import { jsx as m, jsxs as F, Fragment as zt } from "react/jsx-runtime";
import { c as z, a as ne, b as ce } from "./utils-B9z9WPG8.js";
import * as x from "react";
import We, { useId as _t, useState as ot, useEffect as kt, createContext as mo, use as gn, useRef as ft, createElement as C1, useLayoutEffect as Io, Children as ql, isValidElement as Zl, useContext as um, cloneElement as zc, useCallback as In, useMemo as hl, Fragment as X3 } from "react";
import * as an from "react-dom";
import { createPortal as Q3 } from "react-dom";
function J3({ defaultTagName: t, props: e, render: n, state: o = {}, stateAttributesMapping: r }) {
  let i = Bc(e4(o, r), e);
  if (!n) return x.createElement(t, i);
  if (typeof n == "function") return n(i, o);
  if (!x.isValidElement(n)) return null;
  let s = n.props, l = { ...Bc(i, s), ref: ns(i.ref, s.ref) };
  return x.cloneElement(n, l);
}
function Bc(...t) {
  let e = {};
  for (let n of t) {
    if (!n) continue;
    let o = n;
    for (let r of Object.keys(o)) {
      let i = o[r];
      if (i === void 0) continue;
      let s = e[r];
      r === "className" ? e[r] = [s, i].filter(Boolean).join(" ") : r === "style" ? e[r] = { ...s, ...i } : r === "ref" ? e[r] = ns(s, i) : n4(r) && typeof s == "function" && typeof i == "function" ? e[r] = t4(i, s) : e[r] = i;
    }
  }
  return e;
}
function e4(t, e) {
  let n = {};
  for (let o of Object.keys(t)) {
    let r = t[o], i = e?.[o]?.(r);
    if (i) {
      Object.assign(n, i);
      continue;
    }
    if (o === "slot") {
      n["data-slot"] = r;
      continue;
    }
    let s = `data-${String(o).replace(/[A-Z]/g, (l) => `-${l.toLowerCase()}`)}`;
    typeof r == "boolean" ? n[s] = r ? "" : void 0 : r != null && (n[s] = String(r));
  }
  return n;
}
function t4(t, e) {
  return function(n) {
    t(n), n.defaultPrevented || e(n);
  };
}
function n4(t) {
  return /^on[A-Z]/.test(t);
}
function ns(...t) {
  let e = t.filter(Boolean);
  if (e.length !== 0) return (n) => {
    for (let o of e) typeof o == "function" ? o(n) : o && (o.current = n);
  };
}
var o4 = 8, r4 = 64, i4 = 0, Nl = 0.5, s4 = 180, l4 = /* @__PURE__ */ new Set(["ArrowDown", "ArrowUp", "End", "Home", "PageDown", "PageUp", " "]), dm = { start: !1, end: !1 }, a4 = [], kl = { currentAnchorId: null, visibleMessageIds: a4 };
function c4({ content: t, scrollEdgeThreshold: e, spacer: n, viewport: o }) {
  if (!o || !t) return dm;
  let r = wu({ content: t, spacer: n, viewport: o });
  return { start: o.scrollTop > e, end: r - o.scrollTop - o.clientHeight > e };
}
function u4({ content: t, scrollMargin: e, scrollPreviousItemPeek: n, spacer: o, viewport: r, visibleMessageIds: i }) {
  if (!t || !r) return kl;
  let s = r.getBoundingClientRect(), l = s.top + e + n, a = typeof IntersectionObserver > "u", c = [], u = null;
  for (let d of Bi(t, o)) {
    let f = d.dataset.messageId;
    if (!f) continue;
    let p = d.dataset.scrollAnchor === "true", g = p || a ? d.getBoundingClientRect() : null;
    (a && g ? g.bottom > l && g.top < s.bottom : i.has(f)) && c.push(f), p && g && g.top <= l + Nl && (u = f);
  }
  return c.length === 0 && u === null ? kl : { currentAnchorId: u, visibleMessageIds: c };
}
function Bi(t, e) {
  return Array.from(t.children).filter((n) => n instanceof HTMLElement && n !== e);
}
function d4(t, e) {
  for (let n = e; n < t.length; n++) {
    let o = t[n];
    if (o?.dataset.scrollAnchor === "true") return o;
  }
  return null;
}
function f4(t, e) {
  for (let n of t) if (n.dataset.scrollAnchor === "true" && !e.has(n)) return n;
  return null;
}
function p4(t, e) {
  let n = 0;
  for (let o = e; o < t.length; o++) if (t[o]?.dataset.scrollAnchor === "true" && (n += 1, n > 1)) return !0;
  return !1;
}
function g4(t) {
  for (let e = t.length - 1; e >= 0; e--) {
    let n = t[e];
    if (n?.dataset.scrollAnchor === "true") return n;
  }
  return null;
}
function m4({ content: t, spacer: e, viewport: n }) {
  let o = n.getBoundingClientRect();
  for (let r of Bi(t, e)) {
    if (!r.dataset.messageId) continue;
    let i = r.getBoundingClientRect();
    if (i.bottom > o.top && i.top < o.bottom) return r;
  }
  return null;
}
function h4({ align: t, element: e, scrollMargin: n, spacer: o, viewport: r }) {
  let i = fm(e, r), s = e.getBoundingClientRect().height, l = y4(o);
  if (t === "center") {
    let a = Math.max(0, r.clientHeight - l.start - l.end);
    return i - l.start - (a - s) / 2 - n;
  }
  if (t === "end") return i - r.clientHeight + s + l.end + n;
  if (t === "nearest") {
    let a = i + s, c = r.scrollTop + l.start, u = r.scrollTop + r.clientHeight - l.end;
    return i >= c && a <= u ? r.scrollTop : i < c ? i - l.start - n : a - r.clientHeight + l.end + n;
  }
  return i - l.start - n;
}
function fm(t, e) {
  let n = t.getBoundingClientRect(), o = e.getBoundingClientRect();
  return n.top - o.top + e.scrollTop;
}
function bl(t, e) {
  return t.getBoundingClientRect().top - e.getBoundingClientRect().top;
}
function b4({ content: t, scrollTop: e, spacer: n, viewport: o }) {
  let r = wu({ content: t, spacer: n, viewport: o });
  return e + o.clientHeight - r;
}
function wu({ content: t, spacer: e, viewport: n }) {
  let o = Bi(t, e), r = pm(t), i = n.getBoundingClientRect(), s = n.scrollTop, l = r.start + r.end;
  for (let a of o) {
    let c = a.getBoundingClientRect();
    l = Math.max(l, c.bottom - i.top + s + r.end);
  }
  return l;
}
function v4(t) {
  return Math.max(0, t.scrollHeight - t.clientHeight);
}
function pm(t) {
  let e = window.getComputedStyle(t);
  return { end: Wc(e.paddingBlockEnd || e.paddingBottom), start: Wc(e.paddingBlockStart || e.paddingTop) };
}
function y4(t) {
  let e = t?.parentElement;
  return e ? pm(e) : { end: 0, start: 0 };
}
function x4(t) {
  if (!t) return 0;
  let e = window.getComputedStyle(t), n = e.rowGap === "normal" ? e.gap : e.rowGap;
  return Wc(n);
}
function Wc(t) {
  if (!t) return 0;
  let e = Number.parseFloat(t);
  return Number.isFinite(e) ? e : 0;
}
function C4({ refs: t, commitScrollState: e, scheduleStateCommit: n, scheduleVisibilitySync: o }) {
  let { streamingTurnRef: r, autoScrollRef: i, autoscrollingRef: s, autoscrollingTimeoutRef: l, contentRef: a, defaultScrollPositionAppliedRef: c, itemCountRef: u, messageElementsRef: d, modeRef: f, pendingScrollToMessageRef: p, prependRestoreRef: g, scrollMarginRef: h, scrollPreviousItemPeekRef: b, spacerGapRef: v, spacerHeightRef: C, spacerRef: y, viewportRef: w } = t, R = x.useCallback((M) => {
    l.current !== null && (window.clearTimeout(l.current), l.current = null), s.current !== M && (s.current = M, e()), M && (l.current = window.setTimeout(() => {
      l.current = null, s.current = !1, e();
    }, s4));
  }, [e]), S = x.useCallback((M) => {
    let D = y.current;
    if (!D) return;
    let O = Math.max(0, Math.ceil(M));
    C.current !== O && (C.current = O, D.hidden = O === 0, D.style.height = `${O}px`, D.style.marginTop = O > 0 ? `${-v.current}px` : "");
  }, []), E = x.useCallback((M, { behavior: D = "auto", autoscrolling: O = !1 } = {}) => {
    let V = w.current;
    if (!V) return;
    let _ = Math.max(0, M);
    if (Math.abs(V.scrollTop - _) <= Nl) {
      V.scrollTop = _, e();
      return;
    }
    O && R(!0), V.scrollTo({ top: _, behavior: D }), n();
  }, [e, n, R]), N = x.useCallback(({ behavior: M = "auto" } = {}) => w.current ? (S(0), r.current = null, f.current = "free-scrolling", E(0, { behavior: M }), o(), !0) : !1, [o, E, S]), T = x.useCallback(({ behavior: M = "auto" } = {}) => {
    let D = w.current;
    return D ? (S(0), r.current = null, f.current = i.current ? "following-bottom" : "free-scrolling", E(v4(D), { autoscrolling: !0, behavior: M }), o(), !0) : !1;
  }, [o, E, S]), P = x.useCallback((M, { align: D = "start", behavior: O = "auto", scrollMargin: V = h.current } = {}, { keepPreviousPeek: _ = !1 } = {}) => {
    let A = a.current, L = w.current;
    if (!A || !L || !A.contains(M)) return !1;
    let B = h4({ align: D, element: M, scrollMargin: _ ? V + b.current : V, spacer: y.current, viewport: L }), G = b4({ content: A, scrollTop: B, spacer: y.current, viewport: L });
    return S(G), g.current = { element: M, viewportTop: bl(M, L) }, f.current = _ ? "anchored-to-message" : "settling-jump", r.current = _ ? M : null, E(B, { behavior: O }), o(), !0;
  }, [o, E, S]), I = x.useCallback(() => {
    let M = r.current;
    return !M || !M.isConnected || f.current !== "anchored-to-message" ? !1 : P(M, { align: "start" }, { keepPreviousPeek: !0 });
  }, [P]), k = x.useCallback((M, D) => {
    let O = d.current.get(M);
    return O ? (c.current = !0, P(O, D) ? (p.current = null, !0) : (p.current = { messageId: M, options: D }, !0)) : u.current === 0 ? (p.current = { messageId: M, options: D }, c.current = !0, !0) : !1;
  }, [P]);
  return { flushPendingScrollToMessage: x.useCallback(() => {
    let M = p.current;
    if (!M) return !1;
    let D = d.current.get(M.messageId);
    return !D || !P(D, M.options) ? !1 : (p.current = null, c.current = !0, !0);
  }, [P]), reanchorToAnchoredMessage: I, scrollToElement: P, scrollToEnd: T, scrollToMessage: k, scrollToStart: N };
}
function gm(t, e) {
  let n = t, o = /* @__PURE__ */ new Set();
  return { getSnapshot: () => n, hasListeners: () => o.size > 0, setSnapshot: (r) => {
    e(n, r) || (n = r, o.forEach((i) => i()));
  }, subscribe: (r, i, s) => {
    let l = o.size === 0;
    return o.add(r), l && i?.(), () => {
      o.delete(r), o.size === 0 && s?.();
    };
  } };
}
function w4(t, e) {
  return gm(t, e);
}
function S4() {
  return gm(kl, E4);
}
function R4(t, e) {
  return t.start === e.start && t.end === e.end;
}
function E4(t, e) {
  return t.currentAnchorId !== e.currentAnchorId || t.visibleMessageIds.length !== e.visibleMessageIds.length ? !1 : t.visibleMessageIds.every((n, o) => n === e.visibleMessageIds[o]);
}
function N4({ autoScroll: t, scrollEdgeThreshold: e, scrollMargin: n, scrollPreviousItemPeek: o }) {
  let r = x.useRef(t), i = x.useRef(!1), s = x.useRef(null), l = x.useRef(!1), a = x.useRef(e), c = x.useRef(0), u = x.useRef(null), d = x.useRef(0), f = x.useRef(t ? "following-bottom" : "free-scrolling"), p = x.useRef(/* @__PURE__ */ new Map()), g = x.useRef(null), h = x.useRef(null), b = x.useRef(null), v = x.useRef(o), C = x.useRef(!0), y = x.useRef(null), w = x.useRef(n), R = x.useRef(null), S = x.useRef(0), E = x.useRef(0), N = x.useRef(null), T = x.useRef(null), P = x.useRef(null), I = x.useRef(null), k = x.useRef(null), M = x.useRef(null), D = x.useRef(null), O = x.useRef(null), V = x.useRef(/* @__PURE__ */ new Set()), _ = x.useRef(/* @__PURE__ */ new WeakSet());
  return P.current === null && (P.current = w4(dm, R4)), O.current === null && (O.current = S4()), r.current = t, a.current = e, w.current = n, v.current = o, { autoScrollRef: r, autoscrollingRef: i, autoscrollingTimeoutRef: I, streamingTurnRef: b, contentRef: s, defaultScrollPositionAppliedRef: l, firstItemRef: u, itemCountRef: c, lastScrollTopRef: d, messageElementsRef: p, modeRef: f, pendingScrollFrameRef: R, pendingScrollToMessageRef: g, prependRestoreRef: h, preserveScrollOnPrependRef: C, rootRef: y, scrollEdgeThresholdRef: a, scrollMarginRef: w, scrollPreviousItemPeekRef: v, spacerGapRef: S, spacerHeightRef: E, spacerRef: N, stateFrameRef: T, stateStore: P.current, viewportRef: k, visibilityFrameRef: M, visibilityObserverRef: D, visibilityStore: O.current, visibleMessageIdsRef: V, handledScrollAnchorsRef: _ };
}
function w1(t, e) {
  return x.useCallback((n) => {
    t.current = n, n && e();
  }, [t, e]);
}
function k4({ autoScroll: t = !1, defaultScrollPosition: e = "end", scrollEdgeThreshold: n = o4, scrollPreviousItemPeek: o = r4, scrollMargin: r = i4 }) {
  let i = N4({ autoScroll: t, scrollEdgeThreshold: n, scrollMargin: r, scrollPreviousItemPeek: o }), { streamingTurnRef: s, autoScrollRef: l, autoscrollingRef: a, autoscrollingTimeoutRef: c, contentRef: u, defaultScrollPositionAppliedRef: d, firstItemRef: f, itemCountRef: p, lastScrollTopRef: g, messageElementsRef: h, modeRef: b, pendingScrollFrameRef: v, pendingScrollToMessageRef: C, prependRestoreRef: y, preserveScrollOnPrependRef: w, rootRef: R, scrollEdgeThresholdRef: S, scrollMarginRef: E, scrollPreviousItemPeekRef: N, spacerGapRef: T, spacerHeightRef: P, spacerRef: I, stateFrameRef: k, stateStore: M, viewportRef: D, visibilityFrameRef: O, visibilityObserverRef: V, visibilityStore: _, visibleMessageIdsRef: A, handledScrollAnchorsRef: L } = i, B = x.useRef(e);
  B.current !== e && (B.current = e, d.current = !1);
  let G = x.useCallback((be) => {
    let ve = R.current, me = D.current, Ee = [be.start && "start", be.end && "end"].filter(Boolean).join(" "), Pe = a.current;
    for (let Me of [ve, me]) Me && (Ee ? Me.setAttribute("data-scrollable", Ee) : Me.removeAttribute("data-scrollable"), Me.toggleAttribute("data-autoscrolling", Pe));
  }, []), U = x.useCallback((be) => {
    let ve = D.current?.scrollTop ?? 0, me = ve < g.current - Nl;
    g.current = ve, l.current && !be.end && b.current !== "settling-jump" && b.current !== "anchored-to-message" ? b.current = "following-bottom" : b.current === "following-bottom" && be.end && me && !a.current && (b.current = "free-scrolling");
  }, []), Y = x.useCallback(() => {
    let be = c4({ content: u.current, scrollEdgeThreshold: S.current, spacer: I.current, viewport: D.current });
    U(be);
    let ve = b.current === "following-bottom" ? { ...be, end: !1 } : be;
    G(ve), M.setSnapshot(ve);
  }, [U, M, G]), K = x.useCallback(() => {
    k.current === null && (k.current = window.requestAnimationFrame(() => {
      k.current = null, Y();
    }));
  }, [Y]), j = x.useCallback(() => {
    _.hasListeners() && O.current === null && (O.current = window.requestAnimationFrame(() => {
      O.current = null, _.hasListeners() && _.setSnapshot(u4({ content: u.current, scrollMargin: E.current, scrollPreviousItemPeek: N.current, spacer: I.current, viewport: D.current, visibleMessageIds: A.current }));
    }));
  }, [_]), { flushPendingScrollToMessage: Z, reanchorToAnchoredMessage: te, scrollToElement: W, scrollToEnd: X, scrollToMessage: ee, scrollToStart: le } = C4({ refs: i, commitScrollState: Y, scheduleStateCommit: K, scheduleVisibilitySync: j }), J = x.useCallback(() => {
    let be = y.current, ve = D.current;
    if (!be || !ve || !be.element.isConnected) return !1;
    let me = bl(be.element, ve) - be.viewportTop;
    return Math.abs(me) <= Nl ? !1 : (ve.scrollTop += me, be.viewportTop = bl(be.element, ve), K(), j(), !0);
  }, [K, j]), ie = x.useCallback(() => {
    let be = u.current, ve = D.current;
    if (!be || !ve) {
      y.current = null;
      return;
    }
    let me = m4({ content: be, spacer: I.current, viewport: ve });
    y.current = me ? { element: me, viewportTop: bl(me, ve) } : null;
  }, []), pe = x.useCallback(() => {
    v.current === null && (v.current = window.requestAnimationFrame(() => {
      v.current = null, Z() && ie();
    }));
  }, [ie, Z]), oe = x.useCallback(() => {
    if (!e || d.current || p.current === 0) return !1;
    let be = !1;
    if (e === "last-anchor") {
      let ve = u.current, me = D.current, Ee = ve && me ? g4(Bi(ve, I.current)) : null;
      if (!ve || !me || !Ee) be = X({ behavior: "auto" });
      else {
        let Pe = fm(Ee, me);
        be = wu({ content: ve, spacer: I.current, viewport: me }) - Pe <= me.clientHeight ? X({ behavior: "auto" }) : W(Ee, { align: "start" }, { keepPreviousPeek: !0 });
      }
    } else be = e === "end" ? X({ behavior: "auto" }) : le({ behavior: "auto" });
    return be ? (d.current = !0, !0) : !1;
  }, [e, W, X, le]), re = x.useCallback(() => {
    let be = u.current;
    if (!be) return;
    let ve = Bi(be, I.current), me = p.current, Ee = f.current;
    p.current = ve.length, f.current = ve[0] ?? null, (() => {
      if (Z()) return;
      if (me === 0) {
        if (oe() || ve.length > 0 && l.current && X({ behavior: "auto" })) return;
        Y(), j();
        return;
      }
      let Pe = Ee ? ve.indexOf(Ee) : -1;
      if (w.current && Pe > 0) {
        J();
        return;
      }
      if (ve.length > me) {
        let Me = d4(ve, me);
        if (Me) {
          if (l.current && b.current === "following-bottom" && p4(ve, me)) {
            X({ behavior: "auto" });
            return;
          }
          W(Me, { align: "start" }, { keepPreviousPeek: !0 }), L.current.add(Me);
          return;
        }
      }
      if (ve.length === me) {
        let Me = f4(ve, L.current);
        if (Me) {
          W(Me, { align: "start" }, { keepPreviousPeek: !0 }), L.current.add(Me);
          return;
        }
      }
      b.current === "following-bottom" && l.current ? X({ behavior: "auto" }) : (Y(), j());
    })(), ie();
  }, [oe, ie, Y, Z, J, j, W, X]), de = x.useCallback(() => {
    if (b.current === "following-bottom" && l.current) {
      X({ behavior: "auto" });
      return;
    }
    let be = P.current;
    if (te()) {
      l.current && be > 0 && P.current === 0 && X({ behavior: "auto" });
      return;
    }
    K(), j();
  }, [te, K, j, X]), xe = x.useCallback(() => {
    let be = D.current;
    if (!(!be || !_.hasListeners())) {
      if (typeof IntersectionObserver > "u") {
        j();
        return;
      }
      V.current || (V.current = new IntersectionObserver((ve) => {
        for (let me of ve) {
          let Ee = me.target.dataset.messageId;
          Ee && (me.isIntersecting ? A.current.add(Ee) : A.current.delete(Ee));
        }
        j();
      }, { root: be, rootMargin: `${-(E.current + N.current)}px 0px 0px 0px`, threshold: [0, 0.01, 0.5, 1] })), h.current.forEach((ve) => {
        V.current?.observe(ve);
      }), j();
    }
  }, [j, _]), se = x.useCallback(() => {
    O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), V.current?.disconnect(), V.current = null, A.current.clear(), _.setSnapshot(kl);
  }, [_]), fe = x.useCallback((be, ve, me) => {
    if (ve) {
      h.current.set(be, ve), V.current?.observe(ve), j(), C.current?.messageId === be && pe();
      return;
    }
    me && h.current.get(be) === me && (h.current.delete(be), A.current.delete(be), V.current?.unobserve(me), j());
  }, [pe, j]), $ = x.useCallback(() => {
    (b.current === "following-bottom" || b.current === "anchored-to-message" || b.current === "settling-jump") && (s.current = null, b.current = "free-scrolling");
  }, []), Q = x.useCallback(() => G(M.getSnapshot()), [M, G]), H = w1(R, Q), q = w1(D, Q), ae = x.useCallback((be) => {
    u.current = be;
  }, []), ge = x.useCallback((be) => {
    I.current = be, T.current = x4(be?.parentElement ?? null);
  }, []), ue = x.useCallback(() => {
    Y(), j(), ie();
  }, [ie, Y, j]), Re = x.useMemo(() => ({ handleContentChange: re, handleResize: de, observeVisibility: xe, preserveScrollOnPrependRef: w, scrollToEnd: X, scrollToMessage: ee, scrollToStart: le, setContentElement: ae, setRootElement: H, setSpacerElement: ge, setViewportElement: q, stateStore: M, syncAfterScroll: ue, unobserveVisibility: se, userScrollIntent: $, viewportRef: D, visibilityStore: _ }), [re, de, xe, X, ee, le, ae, H, ge, q, M, ue, se, $, _]);
  return x.useLayoutEffect(() => {
    oe();
  }, [oe]), x.useEffect(() => () => {
    k.current !== null && (window.cancelAnimationFrame(k.current), k.current = null), O.current !== null && (window.cancelAnimationFrame(O.current), O.current = null), c.current !== null && (window.clearTimeout(c.current), c.current = null), v.current !== null && (window.cancelAnimationFrame(v.current), v.current = null), V.current?.disconnect(), V.current = null;
  }, []), x.useLayoutEffect(() => {
    if (t && b.current === "following-bottom" && p.current > 0) {
      X({ behavior: "auto" });
      return;
    }
    Y();
  }, [t, Y, X]), { context: Re, registerMessage: fe };
}
function M4(t) {
  let e = x.useRef(t);
  return e.current = t, e;
}
var mm = x.createContext(null), hm = x.createContext(null);
function os() {
  let t = x.useContext(mm);
  if (!t) throw new Error("useMessageScroller must be used within a MessageScroller.");
  return t;
}
function I4() {
  let t = x.useContext(hm);
  if (!t) throw new Error("MessageScrollerItem must be used within a MessageScroller.");
  return t;
}
function Su() {
  let { scrollToEnd: t, scrollToMessage: e, scrollToStart: n } = os();
  return x.useMemo(() => ({ scrollToEnd: t, scrollToMessage: e, scrollToStart: n }), [t, e, n]);
}
function P4({ autoScroll: t = !1, children: e, defaultScrollPosition: n = "end", scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i }) {
  let { context: s, registerMessage: l } = k4({ autoScroll: t, defaultScrollPosition: n, scrollEdgeThreshold: o, scrollPreviousItemPeek: r, scrollMargin: i });
  return m(mm.Provider, { value: s, children: m(hm.Provider, { value: l, children: e }) });
}
function T4({ children: t, ...e }) {
  let { setRootElement: n } = os();
  return m("div", { ref: n, ...e, children: t });
}
function O4({ "aria-label": t, children: e, onKeyDown: n, onScroll: o, onTouchMove: r, onWheel: i, preserveScrollOnPrepend: s = !0, ref: l, role: a, tabIndex: c, ...u }) {
  let { handleResize: d, preserveScrollOnPrependRef: f, setViewportElement: p, syncAfterScroll: g, userScrollIntent: h, viewportRef: b } = os();
  f.current = s;
  let v = x.useCallback((S) => {
    p(S), ns(l)?.(S);
  }, [l, p]);
  function C(S) {
    g(), o?.(S);
  }
  function y(S) {
    h(), i?.(S);
  }
  function w(S) {
    h(), r?.(S);
  }
  function R(S) {
    l4.has(S.key) && h(), n?.(S);
  }
  return x.useEffect(() => {
    let S = b.current;
    if (!S || typeof ResizeObserver > "u") return;
    let E = 0, N = new ResizeObserver(() => {
      window.cancelAnimationFrame(E), E = window.requestAnimationFrame(d);
    });
    return N.observe(S), () => {
      window.cancelAnimationFrame(E), N.disconnect();
    };
  }, [d, b]), m("div", { ref: v, role: a ?? "region", "aria-label": t ?? "Messages", tabIndex: c ?? 0, onKeyDown: R, onScroll: C, onTouchMove: w, onWheel: y, ...u, children: e });
}
function D4({ "aria-relevant": t, children: e, ref: n, role: o, spacerClassName: r, ...i }) {
  let { handleContentChange: s, handleResize: l, setContentElement: a, setSpacerElement: c } = os(), u = x.useRef(null), d = x.useCallback((f) => {
    u.current = f, a(f), ns(n)?.(f);
  }, [n, a]);
  return x.useLayoutEffect(() => {
    let f = u.current;
    if (!f || (s(), typeof MutationObserver > "u")) return;
    let p = new MutationObserver(() => {
      s();
    });
    return p.observe(f, { childList: !0 }), () => p.disconnect();
  }, [s]), x.useEffect(() => {
    let f = u.current;
    if (!f || typeof ResizeObserver > "u") return;
    let p = 0, g = new ResizeObserver(() => {
      window.cancelAnimationFrame(p), p = window.requestAnimationFrame(l);
    });
    return g.observe(f), () => {
      window.cancelAnimationFrame(p), g.disconnect();
    };
  }, [l]), F("div", { ref: d, role: o ?? "log", "aria-relevant": t ?? "additions", ...i, children: [e, m("div", { ref: c, "aria-hidden": "true", "data-message-scroller-spacer": "", hidden: !0, className: r })] });
}
function V4({ messageId: t, ref: e, scrollAnchor: n = !1, ...o }) {
  let r = I4(), i = x.useRef(null), s = x.useCallback((l) => {
    let a = i.current;
    i.current = l, t && r(t, l, a), ns(e)?.(l);
  }, [t, e, r]);
  return m("div", { ref: s, "data-message-id": t, "data-scroll-anchor": n ? "true" : "false", ...o });
}
function _4({ behavior: t = "smooth", children: e, direction: n = "end", onClick: o, render: r, tabIndex: i, type: s = "button", ...l }) {
  let { scrollToEnd: a, scrollToStart: c, stateStore: u } = os(), d = M4(o), f = x.useCallback((b) => u.subscribe(b), [u]), p = x.useCallback(() => {
    let b = u.getSnapshot();
    return n === "start" ? b.start : b.end;
  }, [n, u]), g = x.useSyncExternalStore(f, p, p), h = x.useCallback((b) => {
    g && (d.current?.(b), b.defaultPrevented || (b.currentTarget.blur(), n === "start" ? c({ behavior: t }) : a({ behavior: t })));
  }, [t, n, g, d, a, c]);
  return J3({ defaultTagName: "button", props: Bc({ type: s, inert: !g, tabIndex: g ? i : -1, children: e ?? F("span", { children: ["Scroll to ", n] }), onClick: h }, l), render: r, state: { active: g, direction: n }, stateAttributesMapping: { active: (b) => ({ "data-active": b ? "true" : "false" }) } });
}
var Ur = { Provider: P4, Root: T4, Viewport: O4, Content: D4, Item: V4, Button: _4 };
const bm = {
  xs: "var(--icon-xs)",
  sm: "var(--icon-sm)",
  md: "var(--icon-md)",
  lg: "var(--icon-lg)",
  xl: "var(--icon-xl)",
  xxl: "var(--icon-xxl)"
};
function Ru(t) {
  const e = z.c(18);
  let n, o;
  e[0] !== t ? ({
    size: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "md" : o, i = _t();
  let s;
  if (e[3] !== i) {
    let v;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /:/g, e[5] = v) : v = e[5], s = i.replace(v, ""), e[3] = i, e[4] = s;
  } else
    s = e[4];
  const a = `ai-sparkles-gradient-${s}`, c = bm[r];
  let u, d, f;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), d = /* @__PURE__ */ m("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), f = /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), e[6] = u, e[7] = d, e[8] = f) : (u = e[6], d = e[7], f = e[8]);
  let p;
  e[9] !== a ? (p = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ F("linearGradient", { id: a, x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
    u,
    d,
    f
  ] }) }), e[9] = a, e[10] = p) : p = e[10];
  const g = `url(#${a})`;
  let h;
  e[11] !== g ? (h = /* @__PURE__ */ m("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: g }), e[11] = g, e[12] = h) : h = e[12];
  let b;
  return e[13] !== c || e[14] !== n || e[15] !== p || e[16] !== h ? (b = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", width: c, height: c, "aria-hidden": "true", focusable: "false", ...n, children: [
    p,
    h
  ] }), e[13] = c, e[14] = n, e[15] = p, e[16] = h, e[17] = b) : b = e[17], b;
}
function A4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 12.52 7 12.938 7.418 12.938 7.9375 V 12.3125 C 12.938 12.832 12.52 13.25 12 13.25 C 11.48 13.25 11.062 12.832 11.062 12.3125 V 7.9375 C 11.062 7.418 11.48 7 12 7 Z M 10.75 15.75 C 10.75 15.4185 10.882 15.1005 11.116 14.8661 C 11.351 14.6317 11.668 14.5 12 14.5 C 12.332 14.5 12.649 14.6317 12.884 14.8661 C 13.118 15.1005 13.25 15.4185 13.25 15.75 C 13.25 16.0815 13.118 16.3995 12.884 16.6339 C 12.649 16.8683 12.332 17 12 17 C 11.668 17 11.351 16.8683 11.116 16.6339 C 10.882 16.3995 10.75 16.0815 10.75 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function L4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 4.32 6.96 C 4.32 6.561 4.641 6.24 5.04 6.24 C 5.439 6.24 5.76 6.561 5.76 6.96 V 17.04 C 5.76 17.439 5.439 17.76 5.04 17.76 C 4.641 17.76 4.32 17.439 4.32 17.04 V 6.96 Z M 8.37 12.51 C 8.088 12.228 8.088 11.772 8.37 11.493 L 12.45 7.41 C 12.732 7.128 13.188 7.128 13.467 7.41 C 13.746 7.692 13.749 8.148 13.467 8.427 L 10.617 11.277 H 18.96 C 19.359 11.277 19.68 11.598 19.68 11.997 C 19.68 12.396 19.359 12.717 18.96 12.717 H 10.617 L 13.467 15.567 C 13.749 15.849 13.749 16.305 13.467 16.584 C 13.185 16.863 12.729 16.866 12.45 16.584 L 8.37 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function F4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 2.275 10.8332 C 1.908 11.2004 1.908 11.7942 2.275 12.1575 L 8.837 18.7246 C 9.204 19.0918 9.798 19.0918 10.161 18.7246 C 10.525 18.3574 10.528 17.7636 10.161 17.4002 L 5.201 12.4349 H 21.063 C 21.582 12.4349 22 12.0169 22 11.4973 C 22 10.9777 21.582 10.5597 21.063 10.5597 H 5.201 L 10.165 5.5983 C 10.532 5.2311 10.532 4.6373 10.165 4.274 C 9.798 3.9106 9.204 3.9067 8.841 4.274 L 2.275 10.8332 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function $4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 5.76 6.96 C 5.76 6.561 5.439 6.24 5.04 6.24 C 4.641 6.24 4.32 6.561 4.32 6.96 V 17.04 C 4.32 17.439 4.641 17.76 5.04 17.76 C 5.439 17.76 5.76 17.439 5.76 17.04 V 6.96 Z M 19.47 12.51 C 19.752 12.228 19.752 11.772 19.47 11.493 L 15.39 7.41 C 15.108 7.128 14.652 7.128 14.373 7.41 C 14.094 7.692 14.091 8.148 14.373 8.427 L 17.223 11.277 H 8.88 C 8.481 11.277 8.16 11.598 8.16 11.997 C 8.16 12.396 8.481 12.717 8.88 12.717 H 17.223 L 14.373 15.567 C 14.091 15.849 14.091 16.305 14.373 16.584 C 14.655 16.863 15.111 16.866 15.39 16.584 L 19.47 12.51 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function H4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 19 4 C 19.554 4 20 4.4459 20 5.0001 V 15.0014 C 20 15.5557 19.554 16.0016 19 16.0016 C 18.446 16.0016 18 15.5557 18 15.0014 V 7.4129 L 5.706 19.7062 C 5.314 20.0979 4.68 20.0979 4.293 19.7062 C 3.905 19.3145 3.901 18.6852 4.289 18.2935 L 16.583 6.0003 H 8.994 C 8.439 6.0003 7.993 5.5544 7.993 5.0001 C 7.993 4.4459 8.439 4 8.994 4 H 18.996 H 19 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function z4(t) {
  const e = z.c(13), n = _t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m("path", { d: "M 11.414 4.0871 C 11.582 3.9894 11.784 3.9894 11.953 4.0871 L 17.339 7.1983 L 11.683 10.4646 L 6.027 7.1983 L 11.414 4.0871 Z M 5.218 8.6006 L 10.874 11.8669 V 18.3995 L 5.488 15.2882 C 5.319 15.1905 5.218 15.0152 5.218 14.8197 V 8.5972 V 8.6006 Z M 12.492 18.3995 V 11.8669 L 18.148 8.6006 V 14.8231 C 18.148 15.0152 18.047 15.1938 17.879 15.2916 L 12.492 18.3995 Z M 12.762 2.6882 C 12.094 2.304 11.272 2.304 10.605 2.6882 L 4.679 6.1062 C 4.011 6.4905 3.6 7.2051 3.6 7.9736 V 14.8163 C 3.6 15.5882 4.011 16.2995 4.679 16.6837 L 10.605 20.1118 C 11.272 20.4961 12.094 20.4961 12.762 20.1118 L 18.691 16.6905 C 19.359 16.3062 19.77 15.5916 19.77 14.8231 V 7.9804 C 19.77 7.2085 19.359 6.4972 18.691 6.1129 L 12.762 2.6849 V 2.6882 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ m("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function B4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 6 4.8 C 6 4.1362 6.536 3.6 7.2 3.6 H 8.4 C 9.064 3.6 9.6 4.1362 9.6 4.8 V 5.4 H 6 V 4.8 Z M 4.635 8.325 C 4.815 7.3275 5.685 6.6 6.701 6.6 H 9.9 C 10.399 6.6 10.8 7.0012 10.8 7.5 V 8.4 H 13.2 V 7.5 C 13.2 7.0012 13.601 6.6 14.1 6.6 H 17.299 C 18.315 6.6 19.185 7.3275 19.365 8.325 L 19.552 9.3487 C 19.687 10.095 19.957 10.8112 20.347 11.4637 L 20.445 11.6287 C 21.199 12.8887 21.6 14.3287 21.6 15.795 V 18.3 C 21.6 19.4587 20.659 20.4 19.5 20.4 H 15.3 C 14.141 20.4 13.2 19.4587 13.2 18.3 V 13.2 H 10.8 V 18.3 C 10.8 19.4587 9.859 20.4 8.7 20.4 H 4.5 C 3.341 20.4 2.4 19.4587 2.4 18.3 V 15.795 C 2.4 14.325 2.797 12.885 3.555 11.625 L 3.652 11.46 C 4.042 10.8075 4.312 10.0912 4.447 9.345 L 4.635 8.3212 V 8.325 Z M 6.701 8.4 C 6.555 8.4 6.431 8.505 6.405 8.6475 L 6.217 9.6712 C 6.045 10.6312 5.7 11.55 5.197 12.39 L 5.1 12.555 C 4.511 13.5337 4.2 14.6512 4.2 15.795 V 18.3 C 4.2 18.465 4.335 18.6 4.5 18.6 H 8.7 C 8.865 18.6 9 18.465 9 18.3 V 8.4 H 6.701 Z M 17.299 8.4 H 15 V 18.3 C 15 18.465 15.135 18.6 15.3 18.6 H 19.5 C 19.665 18.6 19.8 18.465 19.8 18.3 V 15.795 C 19.8 14.655 19.489 13.5337 18.904 12.555 L 18.806 12.39 C 18.304 11.5537 17.959 10.6312 17.782 9.6712 L 17.595 8.6475 C 17.569 8.505 17.445 8.4 17.299 8.4 Z M 15.6 3.6 H 16.8 C 17.464 3.6 18 4.1362 18 4.8 V 5.4 H 14.4 V 4.8 C 14.4 4.1362 14.936 3.6 15.6 3.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function W4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 20.66 17 C 21.512 15.5312 22 13.8203 22 12 C 22 6.4766 17.523 2 12 2 V 3.875 C 16.488 3.875 20.125 7.5117 20.125 12 C 20.125 13.4805 19.73 14.8672 19.039 16.0625 L 20.664 17 H 20.66 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function U4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 7.357 2 C 7.951 2 8.429 2.4681 8.429 3.05 V 4.8 H 15.571 V 3.05 C 15.571 2.4681 16.049 2 16.643 2 C 17.237 2 17.714 2.4681 17.714 3.05 V 4.8 H 19.143 C 20.719 4.8 22 6.0556 22 7.6 V 20.2 C 22 21.7444 20.719 23 19.143 23 H 4.857 C 3.281 23 2 21.7444 2 20.2 V 7.6 C 2 6.0556 3.281 4.8 4.857 4.8 H 6.286 V 3.05 C 6.286 2.4681 6.763 2 7.357 2 Z M 7.357 6.9 H 4.857 C 4.464 6.9 4.143 7.215 4.143 7.6 V 9.7 H 19.857 V 7.6 C 19.857 7.215 19.536 6.9 19.143 6.9 H 7.357 Z M 4.143 11.8 V 20.2 C 4.143 20.585 4.464 20.9 4.857 20.9 H 19.143 C 19.536 20.9 19.857 20.585 19.857 20.2 V 11.8 H 4.143 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function G4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M1.82142 0.910712V0H0V16.9999H19.4285V15.1785H1.82142V0.910712ZM17.9486 5.19865L18.5937 4.55356L17.3073 3.26718L16.6622 3.91227L12.1466 8.42788C9.756 6.03726 8.54172 4.82298 8.50377 4.78503L7.85868 5.43012L3.91227 9.37653L3.26718 10.0216L4.55356 11.308L5.19865 10.6629L8.49998 7.36159L11.4977 10.3593L12.1428 11.0044L12.7879 10.3593L17.9486 5.19865Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 20 17", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Y4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 8.17 16.6234 L 3.194 11.648 L 1.5 13.3303 L 8.17 20 L 22.487 5.6823 L 20.805 4 L 8.17 16.6234 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function j4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M7.45739 5.45213C7.75425 5.03285 7.6527 4.4597 7.22692 4.16736C6.80115 3.87502 6.21914 3.97503 5.92227 4.39431L4.37153 6.56764L3.60201 5.80601C3.23484 5.44828 2.6411 5.44828 2.27392 5.80601C1.90674 6.16375 1.91065 6.75228 2.27392 7.11386L3.83638 8.6525C4.03169 8.84483 4.30512 8.94485 4.58246 8.91792C4.8598 8.89099 5.10979 8.75252 5.26994 8.52941L7.45739 5.45213ZM7.45739 11.6067C7.75425 11.1874 7.6527 10.6143 7.22692 10.3219C6.80115 10.0296 6.21914 10.1296 5.92227 10.5489L4.37153 12.7222L3.60201 11.9606C3.23484 11.599 2.6411 11.599 2.27783 11.9606C1.91455 12.3222 1.91065 12.9069 2.27392 13.2684L3.83638 14.8071C4.03169 14.9994 4.30512 15.0994 4.58246 15.0725C4.8598 15.0456 5.10979 14.9071 5.26994 14.684L7.45739 11.6067ZM9.50031 6.45994C9.50031 6.97154 9.91826 7.38312 10.4378 7.38312H21.0625C21.582 7.38312 22 6.97154 22 6.45994C22 5.94834 21.582 5.53675 21.0625 5.53675H10.4378C9.91826 5.53675 9.50031 5.94834 9.50031 6.45994ZM9.50031 12.6145C9.50031 13.1261 9.91826 13.5377 10.4378 13.5377H21.0625C21.582 13.5377 22 13.1261 22 12.6145C22 12.1029 21.582 11.6913 21.0625 11.6913H10.4378C9.91826 11.6913 9.50031 12.1029 9.50031 12.6145ZM8.25034 18.7691C8.25034 19.2807 8.6683 19.6923 9.18781 19.6923H21.0625C21.582 19.6923 22 19.2807 22 18.7691C22 18.2575 21.582 17.8459 21.0625 17.8459H9.18781C8.6683 17.8459 8.25034 18.2575 8.25034 18.7691ZM5.7504 18.7691C5.7504 18.4426 5.61871 18.1295 5.38429 17.8987C5.14988 17.6679 4.83194 17.5382 4.50043 17.5382C4.16892 17.5382 3.85098 17.6679 3.61657 17.8987C3.38215 18.1295 3.25046 18.4426 3.25046 18.7691C3.25046 19.0955 3.38215 19.4086 3.61657 19.6395C3.85098 19.8703 4.16892 20 4.50043 20C4.83194 20 5.14988 19.8703 5.38429 19.6395C5.61871 19.4086 5.7504 19.0955 5.7504 18.7691Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function K4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 11.505 16.5898 C 11.787 16.8718 12.243 16.8718 12.522 16.5898 L 18.522 10.5898 C 18.804 10.3078 18.804 9.8518 18.522 9.5728 C 18.24 9.2938 17.784 9.2908 17.505 9.5728 L 12.015 15.0628 L 6.525 9.5728 C 6.243 9.2908 5.787 9.2908 5.508 9.5728 C 5.229 9.8548 5.226 10.3108 5.508 10.5898 L 11.508 16.5898 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function q4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 7.313 11.778 C 6.896 12.1768 6.896 12.8216 7.313 13.2162 L 16.184 21.7009 C 16.601 22.0997 17.275 22.0997 17.687 21.7009 C 18.1 21.3021 18.104 20.6573 17.687 20.2627 L 9.57 12.4992 L 17.687 4.7357 C 18.104 4.3369 18.104 3.692 17.687 3.2975 C 17.27 2.903 16.596 2.8987 16.184 3.2975 L 7.313 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Z4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 17.687 11.778 C 18.104 12.1768 18.104 12.8216 17.687 13.2162 L 8.816 21.7009 C 8.399 22.0997 7.725 22.0997 7.313 21.7009 C 6.9 21.3021 6.896 20.6573 7.313 20.2627 L 15.43 12.4992 L 7.313 4.7357 C 6.896 4.3369 6.896 3.692 7.313 3.2975 C 7.73 2.903 8.404 2.8987 8.816 3.2975 L 17.687 11.7822 V 11.778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function X4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 11.505 7.41 C 11.787 7.128 12.243 7.128 12.522 7.41 L 18.522 13.41 C 18.804 13.692 18.804 14.148 18.522 14.427 C 18.24 14.706 17.784 14.709 17.505 14.427 L 12.015 8.937 L 6.525 14.427 C 6.243 14.709 5.787 14.709 5.508 14.427 C 5.229 14.145 5.226 13.689 5.508 13.41 L 11.508 7.41 H 11.505 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function Q4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 12 21.6 C 6.697 21.6 2.4 17.3025 2.4 12 C 2.4 6.6975 6.697 2.4 12 2.4 C 17.302 2.4 21.6 6.6975 21.6 12 C 21.6 17.3025 17.302 21.6 12 21.6 Z M 12 4.2 C 7.691 4.2 4.2 7.6913 4.2 12 C 4.2 16.3088 7.691 19.8 12 19.8 C 16.309 19.8 19.8 16.3088 19.8 12 C 19.8 7.6913 16.309 4.2 12 4.2 Z M 14.651 8.7713 C 14.944 8.37 15.506 8.28 15.907 8.5725 C 16.309 8.865 16.399 9.4275 16.106 9.8288 L 11.527 16.1288 C 11.374 16.3425 11.134 16.4775 10.871 16.4963 C 10.609 16.515 10.35 16.4213 10.166 16.2375 L 8.07 14.1413 C 7.717 13.7888 7.717 13.2188 8.07 12.87 C 8.422 12.5213 8.992 12.5175 9.341 12.87 L 10.691 14.22 L 14.651 8.775 V 8.7713 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function J4(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 12 3.875 C 14.155 3.875 16.222 4.731 17.745 6.2548 C 19.269 7.7785 20.125 9.8451 20.125 12 C 20.125 14.1549 19.269 16.2215 17.745 17.7452 C 16.222 19.269 14.155 20.125 12 20.125 C 9.845 20.125 7.778 19.269 6.255 17.7452 C 4.731 16.2215 3.875 14.1549 3.875 12 C 3.875 9.8451 4.731 7.7785 6.255 6.2548 C 7.778 4.731 9.845 3.875 12 3.875 Z M 12 22 C 14.652 22 17.196 20.9464 19.071 19.0711 C 20.946 17.1957 22 14.6522 22 12 C 22 9.3478 20.946 6.8043 19.071 4.9289 C 17.196 3.0536 14.652 2 12 2 C 9.348 2 6.804 3.0536 4.929 4.9289 C 3.054 6.8043 2 9.3478 2 12 C 2 14.6522 3.054 17.1957 4.929 19.0711 C 6.804 20.9464 9.348 22 12 22 Z M 12 7 C 11.48 7 11.062 7.418 11.062 7.9375 V 12.3125 C 11.062 12.832 11.48 13.25 12 13.25 C 12.52 13.25 12.938 12.832 12.938 12.3125 V 7.9375 C 12.938 7.418 12.52 7 12 7 Z M 13.25 15.75 C 13.25 15.4185 13.118 15.1005 12.884 14.8661 C 12.649 14.6317 12.332 14.5 12 14.5 C 11.668 14.5 11.351 14.6317 11.116 14.8661 C 10.882 15.1005 10.75 15.4185 10.75 15.75 C 10.75 16.0815 10.882 16.3995 11.116 16.6339 C 11.351 16.8683 11.668 17 12 17 C 12.332 17 12.649 16.8683 12.884 16.6339 C 13.118 16.3995 13.25 16.0815 13.25 15.75 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function e5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 10.9 6.5 H 13.1 V 8.7 H 10.9 V 6.5 Z M 10.9 10.9 H 13.1 V 17.5 H 10.9 V 10.9 Z M 12 1 C 5.928 1 1 5.928 1 12 C 1 18.072 5.928 23 12 23 C 18.072 23 23 18.072 23 12 C 23 5.928 18.072 1 12 1 Z M 12 20.8 C 7.149 20.8 3.2 16.851 3.2 12 C 3.2 7.149 7.149 3.2 12 3.2 C 16.851 3.2 20.8 7.149 20.8 12 C 20.8 16.851 16.851 20.8 12 20.8 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function t5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 19.672 11.75 C 19.672 13.851 18.837 15.866 17.352 17.3516 C 15.866 18.8373 13.851 19.6719 11.75 19.6719 C 9.649 19.6719 7.634 18.8373 6.148 17.3516 C 4.663 15.866 3.828 13.851 3.828 11.75 C 3.828 9.649 4.663 7.634 6.148 6.1484 C 7.634 4.6627 9.649 3.8281 11.75 3.8281 C 13.851 3.8281 15.866 4.6627 17.352 6.1484 C 18.837 7.634 19.672 9.649 19.672 11.75 Z M 2 11.75 C 2 14.3359 3.027 16.8158 4.856 18.6443 C 6.684 20.4728 9.164 21.5 11.75 21.5 C 14.336 21.5 16.816 20.4728 18.644 18.6443 C 20.473 16.8158 21.5 14.3359 21.5 11.75 C 21.5 9.1641 20.473 6.6842 18.644 4.8557 C 16.816 3.0272 14.336 2 11.75 2 C 9.164 2 6.684 3.0272 4.856 4.8557 C 3.027 6.6842 2 9.1641 2 11.75 Z M 10.836 6.5703 V 8.7298 L 10.074 7.5872 C 9.792 7.1683 9.225 7.054 8.806 7.332 C 8.387 7.6101 8.273 8.1813 8.551 8.6003 L 10.988 12.2565 C 11.213 12.5917 11.628 12.7402 12.013 12.626 C 12.397 12.5117 12.66 12.1537 12.66 11.75 V 6.5703 C 12.66 6.0638 12.253 5.6562 11.746 5.6562 C 11.24 5.6562 10.832 6.0638 10.832 6.5703 H 10.836 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function n5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M9 5.31034C9.47739 5.31034 9.93523 5.1069 10.2728 4.74476C10.6104 4.38262 10.8 3.89145 10.8 3.37931C10.8 2.86717 10.6104 2.376 10.2728 2.01386C9.93523 1.65172 9.47739 1.44828 9 1.44828C8.52261 1.44828 8.06477 1.65172 7.72721 2.01386C7.38964 2.376 7.2 2.86717 7.2 3.37931C7.2 3.89145 7.38964 4.38262 7.72721 4.74476C8.06477 5.1069 8.52261 5.31034 9 5.31034ZM9 0C9.83543 0 10.6366 0.356033 11.2274 0.989777C11.8181 1.62352 12.15 2.48306 12.15 3.37931C12.15 4.27556 11.8181 5.1351 11.2274 5.76884C10.6366 6.40259 9.83543 6.75862 9 6.75862C8.16457 6.75862 7.36335 6.40259 6.77261 5.76884C6.18187 5.1351 5.85 4.27556 5.85 3.37931C5.85 2.48306 6.18187 1.62352 6.77261 0.989777C7.36335 0.356033 8.16457 0 9 0ZM8.325 9.65517C6.71062 9.65517 5.4 11.0612 5.4 12.7931V13.2759C5.4 13.6772 5.09906 14 4.725 14C4.35094 14 4.05 13.6772 4.05 13.2759V12.7931C4.05 10.2616 5.96531 8.2069 8.325 8.2069H9.675C12.0347 8.2069 13.95 10.2616 13.95 12.7931V13.2759C13.95 13.6772 13.6491 14 13.275 14C12.9009 14 12.6 13.6772 12.6 13.2759V12.7931C12.6 11.0612 11.2894 9.65517 9.675 9.65517H8.325ZM12.1331 6.8431C12.4622 6.50216 12.7406 6.1069 12.96 5.67241C13.1259 5.75086 13.3087 5.7931 13.5 5.7931C14.2453 5.7931 14.85 5.1444 14.85 4.34483C14.85 3.54526 14.2453 2.89655 13.5 2.89655H13.4775C13.4325 2.39569 13.3144 1.91897 13.1372 1.47543C13.2553 1.45733 13.3791 1.44828 13.5 1.44828C14.9906 1.44828 16.2 2.74569 16.2 4.34483C16.2 5.94397 14.9906 7.24138 13.5 7.24138C13.0022 7.24138 12.5353 7.09655 12.1331 6.8431ZM4.5 1.44828C4.62375 1.44828 4.74469 1.45733 4.86281 1.47543C4.68562 1.91897 4.5675 2.39871 4.5225 2.89655H4.5C3.75469 2.89655 3.15 3.54526 3.15 4.34483C3.15 5.1444 3.75469 5.7931 4.5 5.7931C4.69125 5.7931 4.87406 5.75086 5.04 5.67241C5.25937 6.1069 5.53781 6.50216 5.86688 6.8431C5.4675 7.09655 5.00062 7.24138 4.5 7.24138C3.00937 7.24138 1.8 5.94397 1.8 4.34483C1.8 2.74569 3.00937 1.44828 4.5 1.44828ZM4.19906 8.68966C3.77437 9.18147 3.42563 9.74569 3.1725 10.3672C2.10375 10.8349 1.35 11.9603 1.35 13.2759C1.35 13.6772 1.04906 14 0.675 14C0.300937 14 0 13.6772 0 13.2759C0 10.7685 1.87313 8.7319 4.19906 8.68966ZM14.8275 10.3672C14.5744 9.74569 14.2228 9.17845 13.8009 8.68966C16.1269 8.7319 18 10.7685 18 13.2759C18 13.6772 17.6991 14 17.325 14C16.9509 14 16.65 13.6772 16.65 13.2759C16.65 11.9603 15.8962 10.8349 14.8275 10.3672Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 18 14", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function o5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M11.875 3.875H7.5C7.15625 3.875 6.875 4.15625 6.875 4.5V19.5C6.875 19.8438 7.15625 20.125 7.5 20.125H17.5C17.8438 20.125 18.125 19.8438 18.125 19.5V10.125H14.6875C13.1328 10.125 11.875 8.86719 11.875 7.3125V3.875ZM17.3477 8.25L13.75 4.65234V7.3125C13.75 7.83203 14.168 8.25 14.6875 8.25H17.3477ZM5 4.5C5 3.12109 6.12109 2 7.5 2H12.7148C13.3789 2 14.0156 2.26172 14.4844 2.73047L19.2695 7.51953C19.7383 7.98828 20 8.625 20 9.28906V19.5C20 20.8789 18.8789 22 17.5 22H7.5C6.12109 22 5 20.8789 5 19.5V4.5Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function r5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M17.366 12.0832C16.2569 12.0832 15.3571 11.15 15.3571 9.99987C15.3571 8.84971 16.2569 7.91656 17.366 7.91656C18.4751 7.91656 19.3749 8.84971 19.3749 9.99987C19.3749 11.15 18.4751 12.0832 17.366 12.0832ZM10 7.91656C11.1091 7.91656 12.0089 8.84971 12.0089 9.99987C12.0089 11.15 11.1091 12.0832 10 12.0832C8.89092 12.0832 7.99109 11.15 7.99109 9.99987C7.99109 8.84971 8.89092 7.91656 10 7.91656ZM2.634 12.0832C1.52492 12.0832 0.625095 11.15 0.625095 9.99987C0.625095 8.84971 1.52492 7.91656 2.634 7.91656C3.74309 7.91656 4.64291 8.84971 4.64291 9.99987C4.64291 11.15 3.74309 12.0832 2.634 12.0832Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function i5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M12.0833 2.634C12.0833 3.74309 11.1502 4.64291 10 4.64291C8.84984 4.64291 7.91669 3.74309 7.91669 2.634C7.91669 1.52492 8.84984 0.625095 10 0.625095C11.1502 0.625095 12.0833 1.52492 12.0833 2.634ZM7.91669 10C7.91669 8.89092 8.84984 7.99109 10 7.99109C11.1502 7.99109 12.0833 8.89092 12.0833 10C12.0833 11.1091 11.1502 12.0089 10 12.0089C8.84984 12.0089 7.91669 11.1091 7.91669 10ZM12.0833 17.366C12.0833 18.4751 11.1502 19.3749 10 19.3749C8.84984 19.3749 7.91669 18.4751 7.91669 17.366C7.91669 16.2569 8.84984 15.3571 10 15.3571C11.1502 15.3571 12.0833 16.2569 12.0833 17.366Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function s5(t) {
  const e = z.c(13), n = _t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 14.3999 C 11.682 14.3999 11.376 14.5263 11.151 14.7514 C 10.926 14.9764 10.8 15.2816 10.8 15.5999 C 10.8 15.9182 10.926 16.2234 11.151 16.4484 C 11.376 16.6735 11.682 16.7999 12 16.7999 C 12.318 16.7999 12.623 16.6735 12.848 16.4484 C 13.073 16.2234 13.2 15.9182 13.2 15.5999 C 13.2 15.2816 13.073 14.9764 12.848 14.7514 C 12.623 14.5263 12.318 14.3999 12 14.3999 Z M 12 7.1999 C 11.317 7.1999 10.774 7.7812 10.822 8.4637 L 11.1 12.3637 C 11.134 12.8362 11.527 13.1999 11.996 13.1999 C 12.469 13.1999 12.859 12.8362 12.892 12.3637 L 13.17 8.4637 C 13.219 7.7812 12.679 7.1999 11.992 7.1999 H 12 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ m("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function l5(t) {
  const e = z.c(13), n = _t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m("path", { d: "M 12 21.5999 C 9.454 21.5999 7.012 20.5885 5.212 18.7881 C 3.411 16.9878 2.4 14.546 2.4 11.9999 C 2.4 9.4538 3.411 7.012 5.212 5.2117 C 7.012 3.4113 9.454 2.3999 12 2.3999 C 14.546 2.3999 16.988 3.4113 18.788 5.2117 C 20.588 7.012 21.6 9.4538 21.6 11.9999 C 21.6 14.546 20.588 16.9878 18.788 18.7881 C 16.988 20.5885 14.546 21.5999 12 21.5999 Z M 12 4.1999 C 9.931 4.1999 7.947 5.0217 6.484 6.4845 C 5.022 7.9473 4.2 9.9312 4.2 11.9999 C 4.2 14.0686 5.022 16.0526 6.484 17.5153 C 7.947 18.9781 9.931 19.7999 12 19.7999 C 14.069 19.7999 16.053 18.9781 17.515 17.5153 C 18.978 16.0526 19.8 14.0686 19.8 11.9999 C 19.8 9.9312 18.978 7.9473 17.515 6.4845 C 16.053 5.0217 14.069 4.1999 12 4.1999 Z M 12 16.7999 C 11.682 16.7999 11.376 16.6735 11.151 16.4484 C 10.926 16.2234 10.8 15.9182 10.8 15.5999 C 10.8 15.2816 10.926 14.9764 11.151 14.7514 C 11.376 14.5263 11.682 14.3999 12 14.3999 C 12.318 14.3999 12.623 14.5263 12.848 14.7514 C 13.073 14.9764 13.2 15.2816 13.2 15.5999 C 13.2 15.9182 13.073 16.2234 12.848 16.4484 C 12.623 16.6735 12.318 16.7999 12 16.7999 Z M 12 7.1999 C 12.682 7.1999 13.226 7.7812 13.177 8.4637 L 12.9 12.3637 C 12.866 12.8362 12.472 13.1999 12.004 13.1999 C 11.531 13.1999 11.141 12.8362 11.107 12.3637 L 10.83 8.4637 C 10.774 7.7812 11.317 7.1999 12 7.1999 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ m("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function a5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 11.998 5.3214 C 9.508 5.3214 7.461 6.4446 5.891 7.8904 C 4.421 9.2489 3.405 10.8616 2.886 12 C 3.405 13.1384 4.421 14.7511 5.888 16.1096 C 7.461 17.5554 9.508 18.6786 11.998 18.6786 C 14.488 18.6786 16.535 17.5554 18.105 16.1096 C 19.575 14.7511 20.591 13.1384 21.11 12 C 20.591 10.8616 19.575 9.2489 18.109 7.8904 C 16.535 6.4446 14.488 5.3214 11.998 5.3214 Z M 4.642 6.5585 C 6.441 4.8964 8.912 3.5 11.998 3.5 C 15.084 3.5 17.555 4.8964 19.354 6.5585 C 21.141 8.2092 22.336 10.1786 22.905 11.5333 C 23.032 11.833 23.032 12.167 22.905 12.4667 C 22.336 13.8214 21.141 15.7946 19.354 17.4415 C 17.555 19.1036 15.084 20.5 11.998 20.5 C 8.912 20.5 6.441 19.1036 4.642 17.4415 C 2.855 15.7946 1.66 13.8214 1.095 12.4667 C 0.968 12.167 0.968 11.833 1.095 11.5333 C 1.66 10.1786 2.855 8.2054 4.642 6.5585 Z M 11.998 15.0357 C 13.686 15.0357 15.053 13.6772 15.053 12 C 15.053 10.3228 13.686 8.9643 11.998 8.9643 C 11.971 8.9643 11.948 8.9643 11.922 8.9643 C 11.971 9.1578 11.998 9.3627 11.998 9.5714 C 11.998 10.9109 10.902 12 9.554 12 C 9.344 12 9.138 11.9734 8.943 11.9241 C 8.943 11.9507 8.943 11.9734 8.943 12 C 8.943 13.6772 10.31 15.0357 11.998 15.0357 Z M 11.998 7.1429 C 13.295 7.1429 14.538 7.6546 15.455 8.5655 C 16.372 9.4764 16.887 10.7118 16.887 12 C 16.887 13.2882 16.372 14.5236 15.455 15.4345 C 14.538 16.3454 13.295 16.8571 11.998 16.8571 C 10.702 16.8571 9.458 16.3454 8.541 15.4345 C 7.625 14.5236 7.11 13.2882 7.11 12 C 7.11 10.7118 7.625 9.4764 8.541 8.5655 C 9.458 7.6546 10.702 7.1429 11.998 7.1429 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function c5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M3.88889 2.25C3.88889 1.00898 4.88542 0 6.11111 0H13.8889C15.1146 0 16.1111 1.00898 16.1111 2.25V6.75H17.7778C19.0035 6.75 20 7.75898 20 9V15.75C20 16.991 19.0035 18 17.7778 18H2.22222C0.996528 18 0 16.991 0 15.75V5.625C0 4.38398 0.996528 3.375 2.22222 3.375H3.88889V2.25ZM6.11111 1.6875C5.80556 1.6875 5.55556 1.94062 5.55556 2.25V4.21875C5.55556 4.68633 5.18403 5.0625 4.72222 5.0625H2.22222C1.91667 5.0625 1.66667 5.31563 1.66667 5.625V15.75C1.66667 16.0594 1.91667 16.3125 2.22222 16.3125H8.33333V13.5C8.33333 12.8777 8.82986 12.375 9.44444 12.375H10.5556C11.1701 12.375 11.6667 12.8777 11.6667 13.5V16.3125H17.7778C18.0833 16.3125 18.3333 16.0594 18.3333 15.75V9C18.3333 8.69063 18.0833 8.4375 17.7778 8.4375H15.2778C14.816 8.4375 14.4444 8.06133 14.4444 7.59375V2.25C14.4444 1.94062 14.1944 1.6875 13.8889 1.6875H6.11111ZM10.5556 3.9375C10.5556 3.62812 10.8056 3.375 11.1111 3.375H12.2222C12.5278 3.375 12.7778 3.62812 12.7778 3.9375V5.0625C12.7778 5.37187 12.5278 5.625 12.2222 5.625H11.1111C10.8056 5.625 10.5556 5.37187 10.5556 5.0625V3.9375ZM7.77778 3.375H8.88889C9.19444 3.375 9.44444 3.62812 9.44444 3.9375V5.0625C9.44444 5.37187 9.19444 5.625 8.88889 5.625H7.77778C7.47222 5.625 7.22222 5.37187 7.22222 5.0625V3.9375C7.22222 3.62812 7.47222 3.375 7.77778 3.375ZM10.5556 7.3125C10.5556 7.00313 10.8056 6.75 11.1111 6.75H12.2222C12.5278 6.75 12.7778 7.00313 12.7778 7.3125V8.4375C12.7778 8.74687 12.5278 9 12.2222 9H11.1111C10.8056 9 10.5556 8.74687 10.5556 8.4375V7.3125ZM7.77778 6.75H8.88889C9.19444 6.75 9.44444 7.00313 9.44444 7.3125V8.4375C9.44444 8.74687 9.19444 9 8.88889 9H7.77778C7.47222 9 7.22222 8.74687 7.22222 8.4375V7.3125C7.22222 7.00313 7.47222 6.75 7.77778 6.75ZM3.33333 7.3125C3.33333 7.00313 3.58333 6.75 3.88889 6.75H5C5.30556 6.75 5.55556 7.00313 5.55556 7.3125V8.4375C5.55556 8.74687 5.30556 9 5 9H3.88889C3.58333 9 3.33333 8.74687 3.33333 8.4375V7.3125ZM3.88889 10.125H5C5.30556 10.125 5.55556 10.3781 5.55556 10.6875V11.8125C5.55556 12.1219 5.30556 12.375 5 12.375H3.88889C3.58333 12.375 3.33333 12.1219 3.33333 11.8125V10.6875C3.33333 10.3781 3.58333 10.125 3.88889 10.125ZM15 10.125H16.1111C16.4167 10.125 16.6667 10.3781 16.6667 10.6875V11.8125C16.6667 12.1219 16.4167 12.375 16.1111 12.375H15C14.6944 12.375 14.4444 12.1219 14.4444 11.8125V10.6875C14.4444 10.3781 14.6944 10.125 15 10.125Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 20 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function u5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 4.32 7.131 C 4.32 6.639 4.719 6.24 5.211 6.24 H 18.792 C 19.284 6.24 19.683 6.639 19.683 7.131 C 19.683 7.368 19.59 7.593 19.422 7.761 L 14.4 12.777 V 18.789 C 14.4 19.281 14.001 19.68 13.509 19.68 C 13.272 19.68 13.047 19.587 12.879 19.419 L 9.81 16.35 C 9.675 16.215 9.6 16.032 9.6 15.84 V 12.777 L 4.581 7.758 C 4.413 7.593 4.32 7.365 4.32 7.131 Z M 6.537 7.68 L 10.83 11.97 C 10.965 12.105 11.04 12.288 11.04 12.48 V 15.543 L 12.96 17.463 V 12.48 C 12.96 12.288 13.035 12.105 13.17 11.97 L 17.46 7.68 H 6.537 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function d5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M6.87493 0.937491C6.87493 0.417965 6.45697 0 5.93744 0C5.41791 0 4.99995 0.417965 4.99995 0.937491V2.49997C3.62106 2.49997 2.49997 3.62106 2.49997 4.99995H0.937491C0.417965 4.99995 0 5.41791 0 5.93744C0 6.45697 0.417965 6.87493 0.937491 6.87493H2.49997V9.06241H0.937491C0.417965 9.06241 0 9.48037 0 9.9999C0 10.5194 0.417965 10.9374 0.937491 10.9374H2.49997V13.1249H0.937491C0.417965 13.1249 0 13.5428 0 14.0624C0 14.5819 0.417965 14.9998 0.937491 14.9998H2.49997C2.49997 16.3787 3.62106 17.4998 4.99995 17.4998V19.0623C4.99995 19.5818 5.41791 19.9998 5.93744 19.9998C6.45697 19.9998 6.87493 19.5818 6.87493 19.0623V17.4998H9.06241V19.0623C9.06241 19.5818 9.48037 19.9998 9.9999 19.9998C10.5194 19.9998 10.9374 19.5818 10.9374 19.0623V17.4998H13.1249V19.0623C13.1249 19.5818 13.5428 19.9998 14.0624 19.9998C14.5819 19.9998 14.9998 19.5818 14.9998 19.0623V17.4998C16.3787 17.4998 17.4998 16.3787 17.4998 14.9998H19.0623C19.5818 14.9998 19.9998 14.5819 19.9998 14.0624C19.9998 13.5428 19.5818 13.1249 19.0623 13.1249H17.4998V10.9374H19.0623C19.5818 10.9374 19.9998 10.5194 19.9998 9.9999C19.9998 9.48037 19.5818 9.06241 19.0623 9.06241H17.4998V6.87493H19.0623C19.5818 6.87493 19.9998 6.45697 19.9998 5.93744C19.9998 5.41791 19.5818 4.99995 19.0623 4.99995H17.4998C17.4998 3.62106 16.3787 2.49997 14.9998 2.49997V0.937491C14.9998 0.417965 14.5819 0 14.0624 0C13.5428 0 13.1249 0.417965 13.1249 0.937491V2.49997H10.9374V0.937491C10.9374 0.417965 10.5194 0 9.9999 0C9.48037 0 9.06241 0.417965 9.06241 0.937491V2.49997H6.87493V0.937491ZM15.6248 4.99995V14.9998C15.6248 15.3436 15.3436 15.6248 14.9998 15.6248H4.99995C4.6562 15.6248 4.37496 15.3436 4.37496 14.9998V4.99995C4.37496 4.6562 4.6562 4.37496 4.99995 4.37496H14.9998C15.3436 4.37496 15.6248 4.6562 15.6248 4.99995ZM7.49992 6.24994C6.80852 6.24994 6.24994 6.80852 6.24994 7.49992V12.4999C6.24994 13.1913 6.80852 13.7499 7.49992 13.7499H12.4999C13.1913 13.7499 13.7499 13.1913 13.7499 12.4999V7.49992C13.7499 6.80852 13.1913 6.24994 12.4999 6.24994H7.49992ZM8.12492 8.12492H11.8749V11.8749H8.12492V8.12492Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function f5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 11.378 2.2403 C 11.734 1.9199 12.273 1.9199 12.628 2.2403 L 21.688 10.3661 C 22.075 10.7098 22.106 11.3036 21.759 11.6904 C 21.411 12.0772 20.821 12.1084 20.435 11.7607 L 20.122 11.4794 V 19.4998 C 20.122 20.8788 19.001 22 17.623 22 H 6.376 C 4.997 22 3.876 20.8788 3.876 19.4998 V 11.4794 L 3.564 11.7607 C 3.177 12.1045 2.588 12.0732 2.24 11.6904 C 1.893 11.3075 1.928 10.7137 2.31 10.3661 L 11.378 2.2403 Z M 12.003 4.1975 L 5.755 9.8035 V 19.5037 C 5.755 19.8474 6.036 20.1287 6.38 20.1287 H 8.254 V 16.0658 C 8.254 14.511 9.512 13.2531 11.066 13.2531 H 12.94 C 14.495 13.2531 15.752 14.511 15.752 16.0658 V 20.1287 H 17.627 C 17.97 20.1287 18.252 19.8474 18.252 19.5037 V 9.8035 L 12.003 4.2014 V 4.1975 Z M 10.129 20.1287 H 13.878 V 16.0658 C 13.878 15.5462 13.46 15.1282 12.94 15.1282 H 11.066 C 10.547 15.1282 10.129 15.5462 10.129 16.0658 V 20.1287 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function p5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 19.5 5.375 C 19.844 5.375 20.125 5.6562 20.125 6 V 18.4922 L 19.93 18.2383 L 14.617 11.3633 C 14.441 11.1328 14.164 11 13.875 11 C 13.586 11 13.312 11.1328 13.133 11.3633 L 9.891 15.5586 L 8.699 13.8906 C 8.523 13.6445 8.242 13.5 7.938 13.5 C 7.633 13.5 7.352 13.6445 7.176 13.8945 L 4.051 18.2695 L 3.875 18.5117 V 18.5 V 6 C 3.875 5.6562 4.156 5.375 4.5 5.375 H 19.5 Z M 4.5 3.5 C 3.121 3.5 2 4.6211 2 6 V 18.5 C 2 19.8789 3.121 21 4.5 21 H 19.5 C 20.879 21 22 19.8789 22 18.5 V 6 C 22 4.6211 20.879 3.5 19.5 3.5 H 4.5 Z M 7.625 11 C 7.871 11 8.115 10.9515 8.343 10.8573 C 8.57 10.763 8.777 10.6249 8.951 10.4508 C 9.125 10.2767 9.263 10.07 9.357 9.8425 C 9.452 9.615 9.5 9.3712 9.5 9.125 C 9.5 8.8788 9.452 8.635 9.357 8.4075 C 9.263 8.18 9.125 7.9733 8.951 7.7992 C 8.777 7.6251 8.57 7.487 8.343 7.3927 C 8.115 7.2985 7.871 7.25 7.625 7.25 C 7.379 7.25 7.135 7.2985 6.907 7.3927 C 6.68 7.487 6.473 7.6251 6.299 7.7992 C 6.125 7.9733 5.987 8.18 5.893 8.4075 C 5.798 8.635 5.75 8.8788 5.75 9.125 C 5.75 9.3712 5.798 9.615 5.893 9.8425 C 5.987 10.07 6.125 10.2767 6.299 10.4508 C 6.473 10.6249 6.68 10.763 6.907 10.8573 C 7.135 10.9515 7.379 11 7.625 11 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function g5(t) {
  const e = z.c(13), n = _t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.3999)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m("path", { d: "M 9.12 5.5198 C 9.519 5.5198 9.84 5.8408 9.84 6.2398 C 9.84 6.6388 9.519 6.9598 9.12 6.9598 C 8.721 6.9598 8.4 6.6388 8.4 6.2398 C 8.4 5.8408 8.721 5.5198 9.12 5.5198 Z M 9.12 8.1598 C 9.153 8.1598 9.186 8.1598 9.219 8.1568 L 10.026 9.8848 C 9.087 10.5358 8.415 11.5468 8.22 12.7198 H 6.102 C 5.817 12.0148 5.127 11.5198 4.323 11.5198 C 3.264 11.5198 2.403 12.3808 2.403 13.4398 C 2.403 14.4988 3.264 15.3598 4.323 15.3598 C 5.13 15.3598 5.82 14.8648 6.102 14.1598 H 8.22 C 8.562 16.2028 10.341 17.7598 12.48 17.7598 C 13.794 17.7598 14.97 17.1748 15.762 16.2478 L 17.784 17.4598 C 17.769 17.5558 17.76 17.6578 17.76 17.7568 C 17.76 18.8158 18.621 19.6768 19.68 19.6768 C 20.739 19.6768 21.6 18.8158 21.6 17.7568 C 21.6 16.6978 20.739 15.8368 19.68 15.8368 C 19.245 15.8368 18.846 15.9808 18.525 16.2238 L 16.506 15.0118 C 16.698 14.5228 16.803 13.9918 16.803 13.4368 C 16.803 12.7408 16.638 12.0808 16.344 11.4988 L 18.672 9.7918 C 18.966 9.9748 19.311 10.0798 19.683 10.0798 C 20.742 10.0798 21.603 9.2188 21.603 8.1598 C 21.603 7.1008 20.742 6.2398 19.683 6.2398 C 18.624 6.2398 17.763 7.1008 17.763 8.1598 C 17.763 8.3218 17.784 8.4808 17.82 8.6308 L 15.492 10.3378 C 14.715 9.5818 13.653 9.1168 12.483 9.1168 C 12.084 9.1168 11.7 9.1708 11.334 9.2728 L 10.527 7.5478 C 10.845 7.2058 11.04 6.7468 11.04 6.2398 C 11.04 5.1808 10.179 4.3198 9.12 4.3198 C 8.061 4.3198 7.2 5.1808 7.2 6.2398 C 7.2 7.2988 8.061 8.1598 9.12 8.1598 Z M 19.68 7.4398 C 20.079 7.4398 20.4 7.7608 20.4 8.1598 C 20.4 8.5588 20.079 8.8798 19.68 8.8798 C 19.281 8.8798 18.96 8.5588 18.96 8.1598 C 18.96 7.7608 19.281 7.4398 19.68 7.4398 Z M 18.96 17.7598 C 18.96 17.3608 19.281 17.0398 19.68 17.0398 C 20.079 17.0398 20.4 17.3608 20.4 17.7598 C 20.4 18.1588 20.079 18.4798 19.68 18.4798 C 19.281 18.4798 18.96 18.1588 18.96 17.7598 Z M 4.32 12.7198 C 4.719 12.7198 5.04 13.0408 5.04 13.4398 C 5.04 13.8388 4.719 14.1598 4.32 14.1598 C 3.921 14.1598 3.6 13.8388 3.6 13.4398 C 3.6 13.0408 3.921 12.7198 4.32 12.7198 Z M 12.48 10.5598 C 14.07 10.5598 15.36 11.8498 15.36 13.4398 C 15.36 15.0298 14.07 16.3198 12.48 16.3198 C 10.89 16.3198 9.6 15.0298 9.6 13.4398 C 9.6 11.8498 10.89 10.5598 12.48 10.5598 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ m("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function m5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M0.91935 0C0.409877 0 0 0.409877 0 0.91935V2.75805C0 3.26752 0.409877 3.6774 0.91935 3.6774H2.75805C3.26752 3.6774 3.6774 3.26752 3.6774 2.75805V0.91935C3.6774 0.409877 3.26752 0 2.75805 0H0.91935ZM6.43545 0.91935C5.92598 0.91935 5.5161 1.32923 5.5161 1.8387C5.5161 2.34817 5.92598 2.75805 6.43545 2.75805H18.0806C18.59 2.75805 18.9999 2.34817 18.9999 1.8387C18.9999 1.32923 18.59 0.91935 18.0806 0.91935H6.43545ZM6.43545 7.04835C5.92598 7.04835 5.5161 7.45823 5.5161 7.9677C5.5161 8.47717 5.92598 8.88705 6.43545 8.88705H18.0806C18.59 8.88705 18.9999 8.47717 18.9999 7.9677C18.9999 7.45823 18.59 7.04835 18.0806 7.04835H6.43545ZM6.43545 13.1774C5.92598 13.1774 5.5161 13.5872 5.5161 14.0967C5.5161 14.6062 5.92598 15.0161 6.43545 15.0161H18.0806C18.59 15.0161 18.9999 14.6062 18.9999 14.0967C18.9999 13.5872 18.59 13.1774 18.0806 13.1774H6.43545ZM0 7.04835V8.88705C0 9.39652 0.409877 9.8064 0.91935 9.8064H2.75805C3.26752 9.8064 3.6774 9.39652 3.6774 8.88705V7.04835C3.6774 6.53888 3.26752 6.129 2.75805 6.129H0.91935C0.409877 6.129 0 6.53888 0 7.04835ZM0.91935 12.258C0.409877 12.258 0 12.6679 0 13.1774V15.0161C0 15.5255 0.409877 15.9354 0.91935 15.9354H2.75805C3.26752 15.9354 3.6774 15.5255 3.6774 15.0161V13.1774C3.6774 12.6679 3.26752 12.258 2.75805 12.258H0.91935Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 19 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function h5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 6.6 9.4725 C 6.6 10.5263 6.941 11.76 7.56 13.0913 C 8.171 14.4075 9 15.72 9.859 16.8975 C 10.62 17.9475 11.389 18.8663 12.004 19.5638 C 12.619 18.8663 13.384 17.9475 14.149 16.8975 C 15.007 15.72 15.836 14.4075 16.447 13.0913 C 17.062 11.76 17.407 10.5263 17.407 9.4725 C 17.407 6.5925 15.019 4.2 12.007 4.2 C 8.996 4.2 6.6 6.5888 6.6 9.4725 Z M 19.2 9.4725 C 19.2 13.6425 15.289 18.5775 13.234 20.8875 C 12.851 21.3188 12.532 21.6563 12.315 21.8813 C 12.116 22.0875 12 22.2 12 22.2 C 12 22.2 11.887 22.0875 11.685 21.8813 C 11.467 21.6563 11.149 21.315 10.766 20.8875 C 8.711 18.5775 4.8 13.6425 4.8 9.4725 C 4.8 5.565 8.025 2.4 12 2.4 C 15.975 2.4 19.2 5.565 19.2 9.4725 Z M 13.2 9.6 C 13.2 9.2818 13.073 8.9765 12.848 8.7515 C 12.623 8.5265 12.318 8.4 12 8.4 C 11.682 8.4 11.376 8.5265 11.151 8.7515 C 10.926 8.9765 10.8 9.2818 10.8 9.6 C 10.8 9.9183 10.926 10.2235 11.151 10.4486 C 11.376 10.6736 11.682 10.8 12 10.8 C 12.318 10.8 12.623 10.6736 12.848 10.4486 C 13.073 10.2235 13.2 9.9183 13.2 9.6 Z M 9 9.6 C 9 8.8044 9.316 8.0413 9.878 7.4787 C 10.441 6.9161 11.204 6.6 12 6.6 C 12.795 6.6 13.559 6.9161 14.121 7.4787 C 14.684 8.0413 15 8.8044 15 9.6 C 15 10.3957 14.684 11.1587 14.121 11.7213 C 13.559 12.284 12.795 12.6 12 12.6 C 11.204 12.6 10.441 12.284 9.878 11.7213 C 9.316 11.1587 9 10.3957 9 9.6 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function b5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 9.378 8.5091 C 9.378 5.1346 12.113 2.4 15.487 2.4 C 16.473 2.4 17.407 2.6328 18.233 3.0509 C 18.484 3.1782 18.658 3.4146 18.702 3.6909 C 18.745 3.9673 18.654 4.2473 18.458 4.4473 L 15.778 7.1273 V 8.2218 H 16.873 L 19.553 5.5418 C 19.749 5.3455 20.033 5.2546 20.309 5.2982 C 20.585 5.3418 20.825 5.5164 20.949 5.7673 C 21.364 6.5928 21.6 7.5273 21.6 8.5128 C 21.6 11.8873 18.865 14.6218 15.491 14.6218 C 14.887 14.6218 14.302 14.5346 13.749 14.3709 L 7.364 20.7491 C 6.229 21.8837 4.385 21.8837 3.251 20.7491 C 2.116 19.6146 2.116 17.7709 3.251 16.6364 L 9.629 10.2509 C 9.465 9.6982 9.378 9.1128 9.378 8.5091 Z M 15.487 4.1455 C 13.076 4.1455 11.124 6.0982 11.124 8.5091 C 11.124 9.0909 11.236 9.6473 11.444 10.1528 C 11.574 10.4764 11.502 10.8509 11.251 11.0982 L 4.48 17.8691 C 4.025 18.3237 4.025 19.0618 4.48 19.5164 C 4.934 19.9709 5.673 19.9709 6.127 19.5164 L 12.898 12.7455 C 13.145 12.4982 13.52 12.4218 13.844 12.5528 C 14.349 12.76 14.905 12.8728 15.487 12.8728 C 17.898 12.8728 19.851 10.92 19.851 8.5091 C 19.851 8.2582 19.829 8.0109 19.789 7.7709 L 17.851 9.7091 C 17.687 9.8728 17.465 9.9637 17.233 9.9637 H 14.905 C 14.422 9.9637 14.033 9.5746 14.033 9.0909 V 6.7637 C 14.033 6.5309 14.124 6.3091 14.287 6.1455 L 16.225 4.2073 C 15.985 4.1673 15.738 4.1455 15.487 4.1455 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function v5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 5.28 6.96 C 5.28 6.561 5.601 6.24 6 6.24 H 18 C 18.399 6.24 18.72 6.561 18.72 6.96 C 18.72 7.359 18.399 7.68 18 7.68 H 6 C 5.601 7.68 5.28 7.359 5.28 6.96 Z M 5.28 12 C 5.28 11.601 5.601 11.28 6 11.28 H 18 C 18.399 11.28 18.72 11.601 18.72 12 C 18.72 12.399 18.399 12.72 18 12.72 H 6 C 5.601 12.72 5.28 12.399 5.28 12 Z M 18.72 17.04 C 18.72 17.439 18.399 17.76 18 17.76 H 6 C 5.601 17.76 5.28 17.439 5.28 17.04 C 5.28 16.641 5.601 16.32 6 16.32 H 18 C 18.399 16.32 18.72 16.641 18.72 17.04 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function y5(t) {
  const e = z.c(13), n = _t();
  let o;
  if (e[0] !== n) {
    let f;
    e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (f = /:/g, e[2] = f) : f = e[2], o = n.replace(f, ""), e[0] = n, e[1] = o;
  } else
    o = e[1];
  const i = `icon-${o}-0`;
  let s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m("rect", { width: "19.2", height: "19.2", fill: "white", transform: "translate(2.4 2.4)" }), e[3] = s) : s = e[3];
  let l;
  e[4] !== i ? (l = /* @__PURE__ */ m("defs", { children: /* @__PURE__ */ m("clipPath", { id: i, children: s }) }), e[4] = i, e[5] = l) : l = e[5];
  const a = `url(#${i})`;
  let c;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m("path", { d: "M 15.12 5.76 C 15.12 6.024 14.904 6.24 14.64 6.24 H 12.48 V 8.16 H 15.84 C 16.899 8.16 17.76 9.021 17.76 10.08 V 10.581 C 17.445 10.554 17.115 10.554 16.8 10.581 V 10.08 C 16.8 9.549 16.371 9.12 15.84 9.12 H 8.16 C 7.629 9.12 7.2 9.549 7.2 10.08 V 13.92 C 7.2 14.451 7.629 14.88 8.16 14.88 H 9.12 C 9.27 14.88 9.414 14.952 9.504 15.072 L 10.512 16.416 C 10.692 16.659 10.977 16.8 11.28 16.8 H 11.541 C 11.568 17.13 11.622 17.448 11.703 17.76 H 11.283 C 10.68 17.76 10.11 17.475 9.747 16.992 L 8.88 15.84 H 8.16 C 7.101 15.84 6.24 14.979 6.24 13.92 V 12.48 H 5.28 V 14.88 C 5.28 15.144 5.064 15.36 4.8 15.36 C 4.536 15.36 4.32 15.144 4.32 14.88 V 9.12 C 4.32 8.856 4.536 8.64 4.8 8.64 C 5.064 8.64 5.28 8.856 5.28 9.12 V 11.52 H 6.24 V 10.08 C 6.24 9.021 7.101 8.16 8.16 8.16 H 11.52 V 6.24 H 9.36 C 9.096 6.24 8.88 6.024 8.88 5.76 C 8.88 5.496 9.096 5.28 9.36 5.28 H 14.64 C 14.904 5.28 15.12 5.496 15.12 5.76 Z M 18.72 10.74 V 9.6 C 18.72 9.336 18.936 9.12 19.2 9.12 C 19.464 9.12 19.68 9.336 19.68 9.6 V 11.082 C 19.374 10.941 19.053 10.827 18.72 10.74 Z M 14.4 11.04 C 14.523 11.04 14.634 11.085 14.718 11.16 C 14.265 11.385 13.845 11.67 13.47 12 H 9.6 C 9.336 12 9.12 11.784 9.12 11.52 C 9.12 11.256 9.336 11.04 9.6 11.04 H 14.4 Z M 20.64 16.32 C 20.64 14.463 19.137 12.96 17.28 12.96 C 15.423 12.96 13.92 14.463 13.92 16.32 C 13.92 18.177 15.423 19.68 17.28 19.68 C 19.137 19.68 20.64 18.177 20.64 16.32 Z M 12.96 16.32 C 12.96 13.935 14.895 12 17.28 12 C 19.665 12 21.6 13.935 21.6 16.32 C 21.6 18.705 19.665 20.64 17.28 20.64 C 14.895 20.64 12.96 18.705 12.96 16.32 Z M 17.28 17.64 C 17.61 17.64 17.88 17.91 17.88 18.24 C 17.88 18.57 17.61 18.84 17.28 18.84 C 16.95 18.84 16.68 18.57 16.68 18.24 C 16.68 17.91 16.95 17.64 17.28 17.64 Z M 17.28 13.92 C 17.544 13.92 17.76 14.136 17.76 14.4 V 16.32 C 17.76 16.584 17.544 16.8 17.28 16.8 C 17.016 16.8 16.8 16.584 16.8 16.32 V 14.4 C 16.8 14.136 17.016 13.92 17.28 13.92 Z", fill: "currentColor" }), e[6] = c) : c = e[6];
  let u;
  e[7] !== a ? (u = /* @__PURE__ */ m("g", { clipPath: a, children: c }), e[7] = a, e[8] = u) : u = e[8];
  let d;
  return e[9] !== t || e[10] !== l || e[11] !== u ? (d = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    l,
    u
  ] }), e[9] = t, e[10] = l, e[11] = u, e[12] = d) : d = e[12], d;
}
function x5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 12 4.3199 C 11.601 4.3199 11.28 4.6409 11.28 5.0399 V 5.3309 C 8.838 5.6789 6.96 7.7819 6.96 10.3199 V 10.7549 C 6.96 11.8859 6.66 12.9959 6.09 13.9739 L 5.433 15.0959 C 5.334 15.2699 5.28 15.4649 5.28 15.6659 C 5.28 16.2929 5.787 16.7999 6.414 16.7999 H 17.586 C 18.213 16.7999 18.72 16.2929 18.72 15.6659 C 18.72 15.4649 18.666 15.2669 18.567 15.0959 L 17.91 13.9709 C 17.34 12.9929 17.04 11.8829 17.04 10.7519 V 10.3169 C 17.04 7.7789 15.162 5.6759 12.72 5.3279 V 5.0369 C 12.72 4.6379 12.399 4.3169 12 4.3169 V 4.3199 Z M 17.052 15.3599 H 6.945 L 7.332 14.6969 C 8.031 13.4999 8.4 12.1379 8.4 10.7549 V 10.3199 C 8.4 8.3309 10.011 6.7199 12 6.7199 C 13.989 6.7199 15.6 8.3309 15.6 10.3199 V 10.7549 C 15.6 12.1409 15.969 13.4999 16.665 14.6969 L 17.052 15.3599 Z M 9.963 18.2399 C 10.26 19.0799 11.061 19.6799 12 19.6799 C 12.939 19.6799 13.74 19.0799 14.037 18.2399 H 9.963 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function C5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 9.6 1 C 8.936 1 8.4 1.5462 8.4 2.2222 C 8.4 2.6729 8.64 3.0701 9 3.2802 V 7.9285 C 7.208 8.9865 6 10.9573 6 13.2222 V 19.6389 C 6 21.4951 7.478 23 9.3 23 H 14.7 C 16.523 23 18 21.4951 18 19.6389 V 13.2222 C 18 10.9573 16.793 8.9865 15 7.9285 V 3.2802 C 15.36 3.0701 15.6 2.6729 15.6 2.2222 C 15.6 1.5462 15.064 1 14.4 1 H 9.6 Z M 10.8 3.4444 H 13.2 V 8.4861 C 13.2 8.8451 13.406 9.1736 13.729 9.3226 C 15.188 9.9948 16.2 11.4882 16.2 13.2222 V 19.6389 C 16.2 20.483 15.529 21.1667 14.7 21.1667 H 9.3 C 8.471 21.1667 7.8 20.483 7.8 19.6389 V 13.2222 C 7.8 11.4882 8.812 9.9948 10.271 9.3226 C 10.594 9.1736 10.8 8.849 10.8 8.4861 V 3.4444 Z M 14.4 15.6667 C 14.4 14.8569 13.316 13.2031 12.604 12.2062 C 12.3 11.7823 11.696 11.7823 11.393 12.2062 C 10.68 13.2031 9.596 14.8569 9.596 15.6667 C 9.596 16.8736 10.673 18.1111 11.996 18.1111 C 13.32 18.1111 14.396 16.8736 14.396 15.6667 H 14.4 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function w5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 13.212 2.7115 C 13.212 2.0401 12.671 1.5 12 1.5 C 11.329 1.5 10.788 2.0401 10.788 2.7115 V 10.7885 H 2.712 C 2.04 10.7885 1.5 11.3286 1.5 12 C 1.5 12.6714 2.04 13.2115 2.712 13.2115 H 10.788 V 21.2885 C 10.788 21.9599 11.329 22.5 12 22.5 C 12.671 22.5 13.212 21.9599 13.212 21.2885 V 13.2115 H 21.288 C 21.96 13.2115 22.5 12.6714 22.5 12 C 22.5 11.3286 21.96 10.7885 21.288 10.7885 H 13.212 V 2.7115 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function S5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M7.19979 5.27982V4.31982H5.27979V19.6798H7.19979V15.0718L9.08079 14.5078C10.3378 14.1298 11.6938 14.2468 12.8668 14.8348C14.1478 15.4768 15.6418 15.5548 16.9828 15.0508L18.7198 14.3998V4.79982L17.0218 5.64882C15.6748 6.32382 14.0878 6.32382 12.7378 5.64882C11.6458 5.10282 10.3888 4.99482 9.22178 5.34582L7.19979 5.95182V5.27982Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function R5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 16.199 10.2018 C 16.199 6.8871 13.514 4.2024 10.199 4.2024 C 6.884 4.2024 4.2 6.8871 4.2 10.2018 C 4.2 13.5165 6.884 16.2012 10.199 16.2012 C 13.514 16.2012 16.199 13.5165 16.199 10.2018 Z M 15.04 16.3175 C 13.713 17.3711 12.029 18.0011 10.199 18.0011 C 5.891 18.0011 2.4 14.5102 2.4 10.2018 C 2.4 5.8935 5.891 2.4026 10.199 2.4026 C 14.507 2.4026 17.998 5.8935 17.998 10.2018 C 17.998 12.0316 17.368 13.7152 16.315 15.0426 L 21.336 20.0634 C 21.688 20.4158 21.688 20.9858 21.336 21.3345 C 20.983 21.6832 20.413 21.687 20.064 21.3345 L 15.04 16.3175 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function E5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 10.485 7.1008 L 10.896 5.2798 H 13.104 L 13.515 7.1008 C 13.566 7.3228 13.719 7.5088 13.929 7.6018 C 14.253 7.7458 14.559 7.9228 14.841 8.1298 C 15.024 8.2648 15.264 8.3068 15.483 8.2378 L 17.268 7.6828 L 18.372 9.5968 L 16.998 10.8658 C 16.83 11.0218 16.746 11.2468 16.77 11.4718 C 16.809 11.8168 16.809 12.1828 16.77 12.5278 C 16.746 12.7558 16.83 12.9808 16.998 13.1338 L 18.372 14.4028 L 17.268 16.3168 L 15.483 15.7618 C 15.264 15.6928 15.027 15.7348 14.841 15.8698 C 14.559 16.0768 14.253 16.2568 13.929 16.3978 C 13.719 16.4908 13.566 16.6768 13.515 16.8988 L 13.104 18.7198 H 10.896 L 10.485 16.8988 C 10.434 16.6768 10.281 16.4908 10.071 16.3978 C 9.747 16.2538 9.441 16.0768 9.159 15.8698 C 8.976 15.7348 8.736 15.6928 8.517 15.7618 L 6.732 16.3168 L 5.628 14.4028 L 7.002 13.1338 C 7.17 12.9778 7.254 12.7528 7.23 12.5278 C 7.191 12.1828 7.191 11.8168 7.23 11.4718 C 7.254 11.2438 7.17 11.0188 7.002 10.8658 L 5.628 9.5968 L 6.732 7.6828 L 8.517 8.2378 C 8.736 8.3068 8.973 8.2648 9.159 8.1298 C 9.441 7.9228 9.747 7.7428 10.071 7.6018 C 10.281 7.5088 10.434 7.3228 10.485 7.1008 Z M 10.704 3.8398 C 10.143 3.8398 9.657 4.2298 9.534 4.7758 L 9.156 6.4438 C 8.967 6.5398 8.787 6.6448 8.61 6.7588 L 6.978 6.2518 C 6.441 6.0838 5.862 6.3118 5.583 6.7978 L 4.287 9.0418 C 4.008 9.5278 4.101 10.1428 4.512 10.5238 L 5.769 11.6848 C 5.76 11.8918 5.76 12.1048 5.769 12.3148 L 4.512 13.4758 C 4.101 13.8568 4.005 14.4718 4.287 14.9578 L 5.583 17.2018 C 5.862 17.6878 6.444 17.9128 6.978 17.7478 L 8.613 17.2408 C 8.79 17.3548 8.97 17.4598 9.159 17.5558 L 9.537 19.2238 C 9.66 19.7698 10.146 20.1598 10.707 20.1598 H 13.299 C 13.86 20.1598 14.346 19.7698 14.469 19.2238 L 14.847 17.5558 C 15.036 17.4598 15.216 17.3548 15.393 17.2408 L 17.028 17.7478 C 17.565 17.9158 18.144 17.6878 18.423 17.2018 L 19.719 14.9578 C 19.998 14.4718 19.905 13.8568 19.494 13.4758 L 18.237 12.3148 C 18.246 12.1078 18.246 11.8948 18.237 11.6848 L 19.494 10.5238 C 19.905 10.1428 19.998 9.5278 19.719 9.0418 L 18.42 6.7978 C 18.138 6.3118 17.559 6.0868 17.025 6.2518 L 15.39 6.7588 C 15.213 6.6448 15.033 6.5398 14.844 6.4438 L 14.469 4.7758 C 14.343 4.2298 13.857 3.8398 13.296 3.8398 H 10.704 Z M 13.44 11.9998 C 13.44 12.7948 12.795 13.4398 12 13.4398 C 11.205 13.4398 10.56 12.7948 10.56 11.9998 C 10.56 11.2048 11.205 10.5598 12 10.5598 C 12.795 10.5598 13.44 11.2048 13.44 11.9998 Z M 12 9.1198 C 10.41 9.1198 9.12 10.4098 9.12 11.9998 C 9.12 13.5898 10.41 14.8798 12 14.8798 C 13.59 14.8798 14.88 13.5898 14.88 11.9998 C 14.88 10.4098 13.59 9.1198 12 9.1198 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function N5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 13.539 7.8393 C 13.187 8.1918 12.617 8.1918 12.268 7.8393 C 11.919 7.4868 11.916 6.9168 12.268 6.5681 L 16.164 2.6643 C 16.517 2.3118 17.087 2.3118 17.436 2.6643 L 21.336 6.5643 C 21.688 6.9168 21.688 7.4868 21.336 7.8356 C 20.983 8.1843 20.413 8.1881 20.064 7.8356 L 17.702 5.4731 V 20.7018 C 17.702 21.2006 17.301 21.6018 16.802 21.6018 C 16.303 21.6018 15.902 21.2006 15.902 20.7018 V 5.4731 L 13.539 7.8356 V 7.8393 Z M 3.939 16.1643 L 6.302 18.5268 V 3.2981 C 6.302 2.7993 6.703 2.3981 7.202 2.3981 C 7.701 2.3981 8.102 2.7993 8.102 3.2981 V 18.5268 L 10.464 16.1643 C 10.817 15.8118 11.387 15.8118 11.736 16.1643 C 12.084 16.5168 12.088 17.0868 11.736 17.4356 L 7.836 21.3356 C 7.483 21.6881 6.913 21.6881 6.564 21.3356 L 2.664 17.4393 C 2.312 17.0868 2.312 16.5168 2.664 16.1681 C 3.017 15.8193 3.587 15.8156 3.936 16.1681 L 3.939 16.1643 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function k5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 16.024 4.395 C 15.855 4.4587 15.743 4.62 15.743 4.8 C 15.743 4.98 15.855 5.1412 16.024 5.205 L 18.143 6 L 18.938 8.1187 C 19.002 8.2875 19.163 8.4 19.343 8.4 C 19.523 8.4 19.684 8.2875 19.748 8.1187 L 20.543 6 L 22.662 5.205 C 22.83 5.1412 22.943 4.98 22.943 4.8 C 22.943 4.62 22.83 4.4587 22.662 4.395 L 20.543 3.6 L 19.748 1.4812 C 19.684 1.3125 19.523 1.2 19.343 1.2 C 19.163 1.2 19.002 1.3125 18.938 1.4812 L 18.143 3.6 L 16.024 4.395 Z M 7.639 10.2187 L 8.543 8.265 L 9.447 10.2187 C 9.627 10.6087 9.938 10.92 10.328 11.1 L 12.282 12.0037 L 10.328 12.9075 C 9.938 13.0875 9.627 13.3987 9.447 13.7887 L 8.543 15.7425 L 7.639 13.7887 C 7.459 13.3987 7.148 13.0875 6.758 12.9075 L 4.804 12 L 6.762 11.0962 C 7.152 10.9162 7.463 10.605 7.643 10.215 L 7.639 10.2187 Z M 7.553 6.1162 L 6.008 9.465 L 2.659 11.01 L 2.637 11.0212 C 2.49 11.0887 2.175 11.235 1.692 11.4562 C 1.478 11.5537 1.343 11.7675 1.343 12 C 1.343 12.2325 1.478 12.4462 1.692 12.5437 C 2.175 12.765 2.487 12.9112 2.637 12.9787 L 2.659 12.99 L 6.008 14.535 L 7.553 17.8837 L 7.564 17.9062 C 7.632 18.0525 7.778 18.3675 7.999 18.8512 C 8.097 19.065 8.31 19.2 8.543 19.2 C 8.775 19.2 8.989 19.065 9.087 18.8512 C 9.627 17.685 9.653 17.625 11.078 14.5387 L 14.427 12.9937 L 14.449 12.9825 C 14.595 12.915 14.91 12.7687 15.394 12.5475 C 15.608 12.45 15.743 12.2362 15.743 12.0037 C 15.743 11.7712 15.608 11.5575 15.394 11.46 C 14.228 10.92 14.168 10.8937 11.082 9.4687 L 9.537 6.12 L 9.525 6.0975 C 9.458 5.9512 9.312 5.6362 9.09 5.1525 C 8.993 4.9387 8.779 4.8037 8.547 4.8037 C 8.314 4.8037 8.1 4.9387 8.003 5.1525 C 7.485 6.27 7.572 6.09 7.557 6.12 L 7.553 6.1162 Z M 16.943 18 L 14.824 18.795 C 14.655 18.8587 14.543 19.02 14.543 19.2 C 14.543 19.38 14.655 19.5412 14.824 19.605 L 16.943 20.4 L 17.738 22.5187 C 17.802 22.6875 17.963 22.8 18.143 22.8 C 18.323 22.8 18.484 22.6875 18.548 22.5187 L 19.343 20.4 L 21.462 19.605 C 21.63 19.5412 21.743 19.38 21.743 19.2 C 21.743 19.02 21.63 18.8587 21.462 18.795 L 19.343 18 L 18.548 15.8812 C 18.484 15.7125 18.323 15.6 18.143 15.6 C 17.963 15.6 17.802 15.7125 17.738 15.8812 L 16.943 18 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function M5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 12.781 3.4736 C 12.632 3.1844 12.33 3 12.003 3 C 11.676 3 11.374 3.1844 11.225 3.4736 L 8.55 8.6862 L 2.737 9.6044 C 2.414 9.655 2.145 9.8828 2.043 10.1936 C 1.941 10.5045 2.025 10.8443 2.254 11.0757 L 6.412 15.2147 L 5.496 20.9949 C 5.445 21.3167 5.58 21.642 5.845 21.8336 C 6.111 22.0252 6.46 22.0541 6.754 21.9059 L 12.003 19.2526 L 17.249 21.9059 C 17.54 22.0541 17.892 22.0252 18.158 21.8336 C 18.423 21.642 18.558 21.3203 18.507 20.9949 L 17.587 15.2147 L 21.746 11.0757 C 21.978 10.8443 22.058 10.5045 21.957 10.1936 C 21.855 9.8828 21.589 9.655 21.262 9.6044 L 15.453 8.6862 L 12.781 3.4736 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function I5(t) {
  const e = z.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.199 11.3999 C 19.531 11.3998 19.799 11.6684 19.799 11.9997 L 19.8 15.9268 C 19.8 16.0859 19.737 16.2385 19.624 16.3511 C 19.512 16.4637 19.359 16.5269 19.2 16.5269 L 15.272 16.5268 C 14.941 16.5268 14.672 16.2581 14.672 15.9268 C 14.672 15.5954 14.941 15.3268 15.272 15.3268 L 18.6 15.3269 L 18.599 12 C 18.599 11.6686 18.868 11.4 19.199 11.3999 Z", fill: "currentColor" }), o = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 4.375 7.6474 C 4.61 7.4131 4.99 7.4131 5.224 7.6474 L 9.709 12.1324 L 12.557 9.2843 C 12.791 9.05 13.171 9.05 13.405 9.2843 L 19.624 15.502 C 19.858 15.7363 19.858 16.1162 19.624 16.3505 C 19.39 16.5848 19.01 16.5849 18.775 16.3506 L 12.981 10.5571 L 10.133 13.4052 C 9.899 13.6395 9.519 13.6395 9.285 13.4052 L 4.375 8.4959 C 4.141 8.2616 4.141 7.8817 4.375 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function P5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M19.1454 10.5575C19.4514 10.2514 19.4514 9.75637 19.1454 9.45351L14.7188 5.02131C14.4128 4.71519 13.9181 4.71519 13.6154 5.02131C13.3127 5.32743 13.3094 5.82243 13.6154 6.12529L16.7075 9.21903H1.40627C0.973369 9.21903 0.625095 9.56749 0.625095 10.0006C0.625095 10.4337 0.973369 10.7822 1.40627 10.7822H16.7075L13.6154 13.8759C13.3094 14.1821 13.3094 14.677 13.6154 14.9799C13.9213 15.2828 14.4161 15.286 14.7188 14.9799L19.1454 10.5575Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function T5(t) {
  const e = z.c(4);
  let n, o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 14.673 8.0727 C 14.673 7.7413 14.941 7.4727 15.273 7.4727 H 19.2 C 19.531 7.4727 19.8 7.7413 19.8 8.0726 V 11.9996 C 19.8 12.3309 19.531 12.5996 19.2 12.5996 C 18.868 12.5996 18.6 12.3309 18.6 11.9996 V 8.6727 H 15.273 C 14.941 8.6727 14.673 8.404 14.673 8.0727 Z", fill: "currentColor" }), o = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M 19.624 7.6474 C 19.858 7.8817 19.858 8.2616 19.624 8.4959 L 13.405 14.7144 C 13.293 14.8269 13.14 14.8901 12.981 14.8901 C 12.822 14.8901 12.669 14.8268 12.557 14.7144 L 9.709 11.8656 L 5.224 16.3505 C 4.99 16.5848 4.61 16.5848 4.375 16.3505 C 4.141 16.1162 4.141 15.7363 4.375 15.502 L 9.285 10.5928 C 9.397 10.4803 9.55 10.417 9.709 10.4171 C 9.868 10.4171 10.021 10.4803 10.133 10.5928 L 12.981 13.4416 L 18.775 7.6474 C 19.01 7.4131 19.39 7.4131 19.624 7.6474 Z", fill: "currentColor" }), e[0] = n, e[1] = o) : (n = e[0], o = e[1]);
  let r;
  return e[2] !== t ? (r = /* @__PURE__ */ F("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: [
    n,
    o
  ] }), e[2] = t, e[3] = r) : r = e[3], r;
}
function O5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 12.72 14.1599 C 12.72 14.5589 12.399 14.8799 12 14.8799 C 11.601 14.8799 11.28 14.5589 11.28 14.1599 V 6.7769 L 9.39 8.6669 C 9.108 8.9489 8.652 8.9489 8.373 8.6669 C 8.094 8.3849 8.091 7.9289 8.373 7.6499 L 11.49 4.5299 C 11.772 4.2479 12.228 4.2479 12.507 4.5299 L 15.63 7.6499 C 15.912 7.9319 15.912 8.3879 15.63 8.6669 C 15.348 8.9459 14.892 8.9489 14.613 8.6669 L 12.723 6.7769 V 14.1599 H 12.72 Z M 9.84 13.9199 H 7.2 C 6.936 13.9199 6.72 14.1359 6.72 14.3999 V 16.7999 C 6.72 17.0639 6.936 17.2799 7.2 17.2799 H 16.8 C 17.064 17.2799 17.28 17.0639 17.28 16.7999 V 14.3999 C 17.28 14.1359 17.064 13.9199 16.8 13.9199 H 14.16 V 12.4799 H 16.8 C 17.859 12.4799 18.72 13.3409 18.72 14.3999 V 16.7999 C 18.72 17.8589 17.859 18.7199 16.8 18.7199 H 7.2 C 6.141 18.7199 5.28 17.8589 5.28 16.7999 V 14.3999 C 5.28 13.3409 6.141 12.4799 7.2 12.4799 H 9.84 V 13.9199 Z M 14.88 15.5999 C 14.88 15.2009 15.201 14.8799 15.6 14.8799 C 15.999 14.8799 16.32 15.2009 16.32 15.5999 C 16.32 15.9989 15.999 16.3199 15.6 16.3199 C 15.201 16.3199 14.88 15.9989 14.88 15.5999 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function D5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M5.78571 5C5.78571 4.1712 6.12436 3.37634 6.72716 2.79029C7.32995 2.20424 8.14752 1.875 9 1.875C9.85248 1.875 10.67 2.20424 11.2728 2.79029C11.8756 3.37634 12.2143 4.1712 12.2143 5C12.2143 5.8288 11.8756 6.62366 11.2728 7.20971C10.67 7.79576 9.85248 8.125 9 8.125C8.14752 8.125 7.32995 7.79576 6.72716 7.20971C6.12436 6.62366 5.78571 5.8288 5.78571 5ZM14.1429 5C14.1429 3.67392 13.601 2.40215 12.6365 1.46447C11.6721 0.526784 10.364 0 9 0C7.63603 0 6.32792 0.526784 5.36345 1.46447C4.39898 2.40215 3.85714 3.67392 3.85714 5C3.85714 6.32608 4.39898 7.59785 5.36345 8.53553C6.32792 9.47322 7.63603 10 9 10C10.364 10 11.6721 9.47322 12.6365 8.53553C13.601 7.59785 14.1429 6.32608 14.1429 5ZM1.92857 18.75C1.92857 15.9883 4.2308 13.75 7.07143 13.75H10.9286C13.7692 13.75 16.0714 15.9883 16.0714 18.75V19.0625C16.0714 19.582 16.5013 20 17.0357 20C17.5701 20 18 19.582 18 19.0625V18.75C18 14.9531 14.8339 11.875 10.9286 11.875H7.07143C3.16607 11.875 0 14.9531 0 18.75V19.0625C0 19.582 0.429911 20 0.964286 20C1.49866 20 1.92857 19.582 1.92857 19.0625V18.75Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function V5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 11.103 3.2971 C 15.44 3.2971 19.037 6.4723 19.697 10.6231 C 19.353 10.7931 19.047 11.0446 18.806 11.3778 L 18.167 12.2515 C 18.17 12.1665 18.174 12.0849 18.174 11.9999 C 18.174 8.0938 15.009 4.9289 11.103 4.9289 C 7.197 4.9289 4.032 8.0938 4.032 11.9999 C 4.032 15.9059 7.197 19.0709 11.103 19.0709 C 12.33 19.0709 13.482 18.7581 14.485 18.2108 L 15.542 19.3055 C 15.58 19.3428 15.621 19.3802 15.661 19.4142 C 14.336 20.2301 12.775 20.7027 11.103 20.7027 C 6.296 20.7027 2.4 16.8068 2.4 11.9999 C 2.4 7.193 6.296 3.2971 11.103 3.2971 Z M 20.125 12.3364 C 20.39 11.9727 20.9 11.8911 21.264 12.1563 C 21.628 12.4214 21.709 12.9314 21.444 13.2951 L 17.963 18.0816 C 17.82 18.2754 17.599 18.4012 17.361 18.4148 C 17.123 18.4284 16.885 18.34 16.719 18.1666 L 15.141 16.5348 C 14.829 16.2119 14.835 15.6952 15.162 15.3824 C 15.488 15.0697 16.001 15.0799 16.314 15.4028 L 17.215 16.3343 L 20.125 12.333 V 12.3364 Z M 11.103 16.3513 C 10.501 16.3513 10.015 15.8651 10.015 15.2634 C 10.015 14.6617 10.501 14.1756 11.103 14.1756 C 11.704 14.1756 12.191 14.6617 12.191 15.2634 C 12.191 15.8651 11.704 16.3513 11.103 16.3513 Z M 11.103 7.6485 C 11.721 7.6485 12.214 8.1754 12.17 8.7941 L 11.919 12.3296 C 11.888 12.758 11.531 13.0877 11.106 13.0877 C 10.678 13.0877 10.324 12.758 10.294 12.3296 L 10.042 8.7941 C 9.998 8.1754 10.487 7.6485 11.109 7.6485 H 11.103 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function _5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 2 5.2222 C 2 3.9965 2.997 3 4.222 3 H 13.111 C 14.337 3 15.333 3.9965 15.333 5.2222 V 9.8958 C 12.767 10.6215 10.889 12.9792 10.889 15.7778 C 10.889 17.8299 11.899 19.6424 13.448 20.7535 C 13.337 20.7708 13.226 20.7778 13.111 20.7778 H 4.222 C 2.997 20.7778 2 19.7812 2 18.5556 V 5.2222 Z M 4.222 8 C 4.222 8.3056 4.472 8.5556 4.778 8.5556 H 12.556 C 12.861 8.5556 13.111 8.3056 13.111 8 C 13.111 7.6944 12.861 7.4444 12.556 7.4444 H 4.778 C 4.472 7.4444 4.222 7.6944 4.222 8 Z M 4.778 10.7778 C 4.472 10.7778 4.222 11.0278 4.222 11.3333 C 4.222 11.6389 4.472 11.8889 4.778 11.8889 H 10.333 C 10.639 11.8889 10.889 11.6389 10.889 11.3333 C 10.889 11.0278 10.639 10.7778 10.333 10.7778 H 4.778 Z M 4.778 14.1111 C 4.472 14.1111 4.222 14.3611 4.222 14.6667 C 4.222 14.9722 4.472 15.2222 4.778 15.2222 H 8.111 C 8.417 15.2222 8.667 14.9722 8.667 14.6667 C 8.667 14.3611 8.417 14.1111 8.111 14.1111 H 4.778 Z M 17 10.7778 C 18.326 10.7778 19.598 11.3046 20.536 12.2422 C 21.473 13.1799 22 14.4517 22 15.7778 C 22 17.1039 21.473 18.3756 20.536 19.3133 C 19.598 20.251 18.326 20.7778 17 20.7778 C 15.674 20.7778 14.402 20.251 13.464 19.3133 C 12.527 18.3756 12 17.1039 12 15.7778 C 12 14.4517 12.527 13.1799 13.464 12.2422 C 14.402 11.3046 15.674 10.7778 17 10.7778 Z M 17 14.1111 C 17.221 14.1111 17.433 14.0233 17.589 13.867 C 17.746 13.7108 17.833 13.4988 17.833 13.2778 C 17.833 13.0568 17.746 12.8448 17.589 12.6885 C 17.433 12.5322 17.221 12.4444 17 12.4444 C 16.779 12.4444 16.567 12.5322 16.411 12.6885 C 16.254 12.8448 16.167 13.0568 16.167 13.2778 C 16.167 13.4988 16.254 13.7108 16.411 13.867 C 16.567 14.0233 16.779 14.1111 17 14.1111 Z M 15.889 15.7778 C 15.889 16.0833 16.139 16.3333 16.444 16.3333 V 18 C 16.139 18 15.889 18.25 15.889 18.5556 C 15.889 18.8611 16.139 19.1111 16.444 19.1111 H 17 H 17.556 C 17.861 19.1111 18.111 18.8611 18.111 18.5556 C 18.111 18.25 17.861 18 17.556 18 V 15.7778 C 17.556 15.4722 17.306 15.2222 17 15.2222 H 16.444 C 16.139 15.2222 15.889 15.4722 15.889 15.7778 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
function A5(t) {
  const e = z.c(3);
  let n;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M 6.465 7.47 C 6.183 7.188 6.183 6.732 6.465 6.453 C 6.747 6.174 7.203 6.171 7.482 6.453 L 12.012 10.983 L 16.542 6.453 C 16.824 6.171 17.28 6.171 17.559 6.453 C 17.838 6.735 17.841 7.191 17.559 7.47 L 13.029 12 L 17.559 16.53 C 17.841 16.812 17.841 17.268 17.559 17.547 C 17.277 17.826 16.821 17.829 16.542 17.547 L 12.012 13.017 L 7.482 17.547 C 7.2 17.829 6.744 17.829 6.465 17.547 C 6.186 17.265 6.183 16.809 6.465 16.53 L 10.995 12 L 6.465 7.47 Z", fill: "currentColor" }), e[0] = n) : n = e[0];
  let o;
  return e[1] !== t ? (o = /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", ...t, children: n }), e[1] = t, e[2] = o) : o = e[2], o;
}
const vm = {
  alerts: A4,
  "arrow-left-shrink-sidebar": L4,
  "arrow-left": F4,
  "arrow-right-expand-sidebar": $4,
  "arrow-up-right": H4,
  asset: z4,
  binoculars: B4,
  "button-load-spinner": W4,
  calendar: U4,
  "chart-line": G4,
  "check-mark": Y4,
  checklist: j4,
  "chevron-down": K4,
  "chevron-left": q4,
  "chevron-right": Z4,
  "chevron-up": X4,
  "circle-check": Q4,
  "circle-exclamation": J4,
  "circle-info": e5,
  "clock-seven": t5,
  customers: n5,
  document: o5,
  "ellipsis-dots-horiz": r5,
  "ellipsis-dots": i5,
  "error-solid": s5,
  error: l5,
  "eye-watching": a5,
  facilities: c5,
  filter: u5,
  hardware: d5,
  home: f5,
  "image-regular": p5,
  integrations: g5,
  list: m5,
  "location-pin-solid": h5,
  maintenance: b5,
  "menu-hamburger": v5,
  "monitoring-point": y5,
  "notification-bell": x5,
  "oil-analysis-bottle": C5,
  "plus-regular": w5,
  priority: S5,
  search: R5,
  "settings-cog": E5,
  sort: N5,
  sparkles: k5,
  "star-recommended": M5,
  "trend-down": I5,
  "trend-no-change": P5,
  "trend-up": T5,
  upload: O5,
  user: D5,
  warning: V5,
  workorder: _5,
  "x-close": A5
}, L5 = {
  "add-photo": () => import("./add-photo-UE3i3aw7.js"),
  "add-plus": () => import("./add-plus-oFj-MK_p.js"),
  "advanced-readings": () => import("./advanced-readings-DE7-Y7MC.js"),
  "ai-filled": () => import("./ai-filled-1J1gMDKF.js"),
  ai: () => import("./ai-CruGGRMf.js"),
  "alert-exclamation": () => import("./alert-exclamation-C9YLD8Y5.js"),
  "alerts-outline": () => import("./alerts-outline-u0BE6BKG.js"),
  "angles-up-down-solid": () => import("./angles-up-down-solid-abyxkTyM.js"),
  api: () => import("./api-Cq21Vyn5.js"),
  "arrow-drop-down": () => import("./arrow-drop-down-CvUuwgsF.js"),
  "arrow-right-regular": () => import("./arrow-right-regular-ClIL3B0L.js"),
  "arrow-right": () => import("./arrow-right-BB9ZosBM.js"),
  "art-service": () => import("./art-service-D9k-QhdX.js"),
  "assign-link": () => import("./assign-link-Cz8DBNIP.js"),
  "barcode-scan-regular": () => import("./barcode-scan-regular-CRMPw43a.js"),
  "bars-filter-regular": () => import("./bars-filter-regular-rA10KAwS.js"),
  "bookmark-regular": () => import("./bookmark-regular-ErqXaTnq.js"),
  "bookmark-solid": () => import("./bookmark-solid-XxMmOSH8.js"),
  "calendar-solid": () => import("./calendar-solid-BKuAZoMG.js"),
  "camera-regular": () => import("./camera-regular-DCn5NMis.js"),
  "check-circle": () => import("./check-circle-pcTXVe3m.js"),
  "circle-check-regular": () => import("./circle-check-regular-D1RKE1A3.js"),
  "circle-minus-solid": () => import("./circle-minus-solid-DKh4s7Vy.js"),
  "circle-navigation": () => import("./circle-navigation-BggCTKte.js"),
  "circle-play-solid": () => import("./circle-play-solid-5RxV5EWv.js"),
  "circle-plus-regular": () => import("./circle-plus-regular-zl6C5_zW.js"),
  "circle-question": () => import("./circle-question-BInzI22Q.js"),
  "circle-stop-regular": () => import("./circle-stop-regular-C_JIeCcl.js"),
  "circle-xmark-solid": () => import("./circle-xmark-solid--KBWCnKI.js"),
  "cloud-slash-regular": () => import("./cloud-slash-regular-DoTIr8Oz.js"),
  collect: () => import("./collect-Co2HYlGr.js"),
  "collection-taken": () => import("./collection-taken-eCVooTdW.js"),
  "command-search": () => import("./command-search-C2xsNRgD.js"),
  component: () => import("./component-BbcQUwAb.js"),
  "configure-slider": () => import("./configure-slider-bFpbIHj4.js"),
  "copy-regular": () => import("./copy-regular-BuvekPFc.js"),
  "cost-savings-dollar": () => import("./cost-savings-dollar-WugkrpTl.js"),
  "developing-stage": () => import("./developing-stage-CBpNw3F8.js"),
  "document-upload": () => import("./document-upload-BGJdqBn4.js"),
  "dollar-sign": () => import("./dollar-sign-DrSDp3MT.js"),
  dot: () => import("./dot-Bsti8OLe.js"),
  download: () => import("./download-CnMNSBLT.js"),
  drag: () => import("./drag-BZplXPTC.js"),
  "early-stage": () => import("./early-stage-DN8bJpyi.js"),
  "edit-pen": () => import("./edit-pen-CxBiIwxm.js"),
  "email-envelope": () => import("./email-envelope-DiLoHzY9.js"),
  "expand-regular": () => import("./expand-regular-C05q6RBY.js"),
  expand: () => import("./expand-Ar2qxbi8.js"),
  "eye-slash-regular": () => import("./eye-slash-regular-BL-pt4ts.js"),
  "flash-auto": () => import("./flash-auto-COJnXXcG.js"),
  "flash-off": () => import("./flash-off-DxAJx4CC.js"),
  "flash-on": () => import("./flash-on-D41TNyqb.js"),
  "gauge-max-solid-full": () => import("./gauge-max-solid-full-DVsU73t4.js"),
  grid: () => import("./grid-BnvfXTkX.js"),
  "grip-drag": () => import("./grip-drag-T3n9XLV-.js"),
  hazardous: () => import("./hazardous-DMmCTvnj.js"),
  "hwe-sensor-triangle": () => import("./hwe-sensor-triangle-DoamELQq.js"),
  "invoke-reading-bolt-regular": () => import("./invoke-reading-bolt-regular-Cp5QGlzd.js"),
  "invoke-reading-bolt-solid": () => import("./invoke-reading-bolt-solid-B9yq2sii.js"),
  line: () => import("./line-bZnGeTu-.js"),
  "logout-exit": () => import("./logout-exit-CJdNt9zY.js"),
  marketplace: () => import("./marketplace-DjGN6iKj.js"),
  "mature-stage": () => import("./mature-stage-Dvx2oWNp.js"),
  message: () => import("./message-CnKMpyxz.js"),
  "microphone-solid": () => import("./microphone-solid-BN1BAqyC.js"),
  minus: () => import("./minus-Ck_rUujj.js"),
  "new-message": () => import("./new-message-COl6FN29.js"),
  "new-nxt-step": () => import("./new-nxt-step-DdKIQhHf.js"),
  "note-regular": () => import("./note-regular-DtG3iBud.js"),
  "paper-plane-top": () => import("./paper-plane-top-UvtbOAeS.js"),
  partners: () => import("./partners-qveXf0qH.js"),
  phone: () => import("./phone-bdISCoGZ.js"),
  "qr-code-scan": () => import("./qr-code-scan-0YI-iWcO.js"),
  "quarterly-collection": () => import("./quarterly-collection-CxUmYmn_.js"),
  "report-error-square-regular": () => import("./report-error-square-regular-BVmNOQPD.js"),
  rotate: () => import("./rotate-BZY99ywR.js"),
  save: () => import("./save-BMS6Tjxq.js"),
  send: () => import("./send-iYh4V9VL.js"),
  service: () => import("./service-D19lNwJd.js"),
  "settings-cog-solid": () => import("./settings-cog-solid-DzBAvMJm.js"),
  share: () => import("./share-DR74k9ao.js"),
  "signal-connection": () => import("./signal-connection-D2TXKNXS.js"),
  signal: () => import("./signal-ClsGNY50.js"),
  "sort-lines": () => import("./sort-lines-BqsmDERv.js"),
  "stacked-images-regular": () => import("./stacked-images-regular-C7r2AhI2.js"),
  sync: () => import("./sync-DCq2I0rc.js"),
  tag: () => import("./tag-C-1U0rZc.js"),
  "temperature-high-regular-full": () => import("./temperature-high-regular-full-CGdfPnlm.js"),
  "thumbs-down": () => import("./thumbs-down-CFpQbdTQ.js"),
  "thumbs-up": () => import("./thumbs-up-BA7gZye6.js"),
  "trash-delete-bin": () => import("./trash-delete-bin-BRaP7obb.js"),
  "triangle-exclamation-solid": () => import("./triangle-exclamation-solid-BlUal_cM.js"),
  ultrasound: () => import("./ultrasound-CVhj4j7D.js"),
  "up-down": () => import("./up-down-BgbgwQHo.js"),
  vero: () => import("./vero-BgxkNmbD.js"),
  vibration: () => import("./vibration-B66xjocq.js"),
  watching: () => import("./watching-C6VbFi_c.js"),
  "wifi-exclamation-sharp-solid": () => import("./wifi-exclamation-sharp-solid-B2lRByzu.js"),
  wifi: () => import("./wifi-8GgIkdeE.js"),
  "zoom-in": () => import("./zoom-in-B26X0B3W.js"),
  "zoom-out": () => import("./zoom-out-5iqiIT_e.js")
}, F5 = {
  neutral: "text-icon-main",
  secondary: "text-icon-secondary",
  brand: "text-primary",
  warning: "text-accessibility-warning",
  negative: "text-negative",
  positive: "text-positive",
  informative: "text-informative",
  inherit: "text-current"
}, Ml = /* @__PURE__ */ new Map(), Hs = /* @__PURE__ */ new Map();
function Wa(t) {
  return t in vm;
}
function $5(t) {
  const e = Ml.get(t);
  if (e)
    return Promise.resolve(e);
  const n = Hs.get(t);
  if (n)
    return n;
  const o = L5[t], r = o().then((i) => (Ml.set(t, i.default), Hs.delete(t), i.default)).catch((i) => {
    throw Hs.delete(t), i;
  });
  return Hs.set(t, r), r;
}
function Ke(t) {
  const e = z.c(31);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    name: r,
    size: l,
    tone: a,
    style: s,
    "aria-label": o,
    "aria-hidden": n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "md" : l, u = a === void 0 ? "neutral" : a, d = !o, f = bm[c];
  let p;
  e[8] !== r ? (p = () => {
    if (Wa(r))
      return;
    const T = Ml.get(r);
    return T ? {
      name: r,
      Component: T
    } : void 0;
  }, e[8] = r, e[9] = p) : p = e[9];
  const [g, h] = ot(p), b = F5[u];
  let v;
  e[10] !== f || e[11] !== s ? (v = {
    width: f,
    height: f,
    flexShrink: 0,
    ...s
  }, e[10] = f, e[11] = s, e[12] = v) : v = e[12];
  const C = n ?? (d ? !0 : void 0), y = d ? void 0 : "img";
  let w;
  e[13] !== o || e[14] !== i || e[15] !== b || e[16] !== v || e[17] !== C || e[18] !== y ? (w = {
    className: b,
    style: v,
    "aria-hidden": C,
    "aria-label": o,
    role: y,
    ...i
  }, e[13] = o, e[14] = i, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : w = e[19];
  const R = w;
  let S, E;
  if (e[20] !== r ? (E = () => {
    if (Wa(r)) {
      h(void 0);
      return;
    }
    let T = !0;
    const P = r, I = Ml.get(P);
    if (I) {
      h({
        name: P,
        Component: I
      });
      return;
    }
    return h(void 0), $5(P).then((k) => {
      T && h({
        name: P,
        Component: k
      });
    }).catch(() => {
      T && h(void 0);
    }), () => {
      T = !1;
    };
  }, S = [r], e[20] = r, e[21] = S, e[22] = E) : (S = e[21], E = e[22]), kt(E, S), Wa(r)) {
    const T = vm[r];
    let P;
    return e[23] !== T || e[24] !== R ? (P = /* @__PURE__ */ m(T, { ...R }), e[23] = T, e[24] = R, e[25] = P) : P = e[25], P;
  }
  if (g?.name === r) {
    const T = g.Component;
    let P;
    return e[26] !== T || e[27] !== R ? (P = /* @__PURE__ */ m(T, { ...R }), e[26] = T, e[27] = R, e[28] = P) : P = e[28], P;
  }
  let N;
  return e[29] !== R ? (N = /* @__PURE__ */ m("svg", { ...R }), e[29] = R, e[30] = N) : N = e[30], N;
}
const H5 = ce(["inline-flex", "items-center", "justify-center", "max-w-full", "gap-(--spacing-4)", "h-(--spacing-24)", "rounded-(--radius-sm)", "overflow-hidden", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(--font-weight-medium)", "whitespace-nowrap"], {
  variants: {
    tone: {
      positive: ["bg-chip-positive-container", "text-chip-positive-label"],
      neutral: ["bg-chip-neutral-container", "text-chip-neutral-label"],
      negative: ["bg-chip-negative-container", "text-chip-negative-label"],
      warning: ["bg-chip-warning-container", "text-chip-warning-label"],
      informative: ["bg-chip-informative-container", "text-chip-informative-label"],
      brand: ["bg-chip-brand-container", "text-chip-brand-label"]
    },
    iconOnly: {
      true: ["px-(--spacing-4)", "py-(--spacing-4)"],
      false: ["px-(--spacing-6)", "py-(--spacing-4)"]
    }
  },
  defaultVariants: {
    tone: "neutral",
    iconOnly: !1
  }
}), z5 = {
  informative: "text-chip-informative-label-icon",
  positive: "text-chip-positive-label-icon",
  warning: "text-chip-warning-label-icon",
  negative: "text-chip-negative-label-icon"
};
function ym(t) {
  const e = z.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: l,
    icon: o,
    label: r,
    children: n,
    truncate: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !0 : s, c = o !== void 0 && r === void 0;
  let u;
  e[7] !== c || e[8] !== l ? (u = H5({
    tone: l,
    iconOnly: c
  }), e[7] = c, e[8] = l, e[9] = u) : u = e[9];
  let d;
  e[10] !== o || e[11] !== l ? (d = o && /* @__PURE__ */ m("span", { className: ne("inline-flex shrink-0 items-center", z5[l]), children: /* @__PURE__ */ m(Ke, { name: o, size: "xs", tone: "inherit" }) }), e[10] = o, e[11] = l, e[12] = d) : d = e[12];
  let f;
  e[13] !== r || e[14] !== a ? (f = r !== void 0 && /* @__PURE__ */ m("span", { className: a ? "min-w-0 flex-1 truncate" : void 0, children: String(r) }), e[13] = r, e[14] = a, e[15] = f) : f = e[15];
  let p;
  return e[16] !== n || e[17] !== i || e[18] !== u || e[19] !== d || e[20] !== f ? (p = /* @__PURE__ */ F("span", { className: u, ...i, children: [
    d,
    f,
    n
  ] }), e[16] = n, e[17] = i, e[18] = u, e[19] = d, e[20] = f, e[21] = p) : p = e[21], p;
}
function Kn(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(ym, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function B5(t) {
  const e = z.c(15);
  let n, o, r, i;
  e[0] !== t ? ({
    label: n,
    onClose: o,
    removeAriaLabel: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = i ?? `Remove ${n}`;
  let l;
  e[5] !== o ? (l = (d) => {
    d.stopPropagation(), o();
  }, e[5] = o, e[6] = l) : l = e[6];
  let a;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" }), e[7] = a) : a = e[7];
  let c;
  e[8] !== s || e[9] !== l ? (c = /* @__PURE__ */ m("button", { type: "button", "aria-label": s, className: "inline-flex shrink-0 cursor-pointer items-center text-icon-main rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", onClick: l, children: a }), e[8] = s, e[9] = l, e[10] = c) : c = e[10];
  let u;
  return e[11] !== n || e[12] !== r || e[13] !== c ? (u = /* @__PURE__ */ m(ym, { tone: "neutral", label: n, ...r, children: c }), e[11] = n, e[12] = r, e[13] = c, e[14] = u) : u = e[14], u;
}
const xm = mo({
  activeId: void 0,
  orientation: "vertical",
  onActiveChange: void 0,
  startScrollLock: void 0,
  scrollRef: void 0
}), S1 = ce([
  // Layout
  "relative",
  "inline-flex",
  "items-center",
  "gap-(--spacing-4)",
  "px-(--spacing-6)",
  "rounded-(--radius-sm)",
  // Typography
  "font-(family-name:--font-family-label)",
  "text-(length:--font-size-label-large)",
  "leading-(--font-line-height-16)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "select-none",
  "outline-none",
  "cursor-pointer",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Default text color
  "text-informative",
  // Hover
  "hover:bg-surface-hover",
  // Pressed
  "active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-button-focus-ring"
], {
  variants: {
    orientation: {
      // Vertical: fixed 26px height, no extra vertical padding
      vertical: ["h-[26px]"],
      // Horizontal: fixed 26px height, no extra vertical padding
      horizontal: ["h-[26px]"]
    },
    selected: {
      true: [],
      false: []
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none", "cursor-default"]
    }
  },
  compoundVariants: [{
    orientation: "horizontal",
    selected: !0,
    className: "font-semibold"
  }]
}), W5 = ["flex", "items-center", "gap-(--spacing-16)", "h-[26px]", "w-full"].join(" "), R1 = ce(["shrink-0", "transition-colors", "duration-200", "ease-in-out"], {
  variants: {
    orientation: {
      vertical: ["shrink-0", "w-(--spacing-2)", "h-(--spacing-24)", "rounded-tr-(--radius-sm)", "rounded-br-(--radius-sm)"],
      horizontal: ["absolute", "bottom-0", "left-[14px]", "right-[14px]", "h-(--spacing-2)", "rounded-tl-(--radius-sm)", "rounded-tr-(--radius-sm)"]
    },
    selected: {
      true: "bg-informative",
      false: "bg-surface-container-highest"
    }
  }
});
function U5(t) {
  const e = z.c(59), {
    targetId: n,
    icon: o,
    chip: r,
    disabled: i,
    children: s
  } = t, l = i === void 0 ? !1 : i, {
    activeId: a,
    orientation: c,
    onActiveChange: u,
    startScrollLock: d,
    scrollRef: f
  } = gn(xm), p = a === n, g = !l && p;
  let h;
  e[0] !== l || e[1] !== u || e[2] !== f || e[3] !== d || e[4] !== n ? (h = function(I) {
    if (l) {
      I.preventDefault();
      return;
    }
    if (I.button !== 0 || I.metaKey || I.ctrlKey || I.shiftKey || I.altKey)
      return;
    I.preventDefault();
    const k = document.getElementById(n);
    if (k) {
      const M = window.matchMedia("(prefers-reduced-motion: reduce)").matches, D = M ? "instant" : "smooth", O = f?.current;
      M || d?.(), O ? O.scrollTo({
        top: k.offsetTop - O.offsetTop,
        behavior: D
      }) : k.scrollIntoView({
        behavior: D
      });
    }
    window.history.pushState(null, "", `#${n}`), u?.(n);
  }, e[0] = l, e[1] = u, e[2] = f, e[3] = d, e[4] = n, e[5] = h) : h = e[5];
  const b = h;
  if (c === "vertical") {
    const P = g || l && p;
    let I;
    e[6] !== c || e[7] !== P ? (I = R1({
      orientation: c,
      selected: P
    }), e[6] = c, e[7] = P, e[8] = I) : I = e[8];
    const k = l && p ? "opacity-50" : "";
    let M;
    e[9] !== I || e[10] !== k ? (M = [I, k].filter(Boolean), e[9] = I, e[10] = k, e[11] = M) : M = e[11];
    const D = M.join(" ");
    let O;
    e[12] !== D ? (O = /* @__PURE__ */ m("span", { "aria-hidden": !0, className: D }), e[12] = D, e[13] = O) : O = e[13];
    const V = `#${n}`, _ = g ? "true" : void 0, A = l ? "true" : void 0, L = l ? -1 : void 0;
    let B;
    e[14] !== l || e[15] !== g || e[16] !== c ? (B = S1({
      selected: g,
      disabled: l,
      orientation: c
    }), e[14] = l, e[15] = g, e[16] = c, e[17] = B) : B = e[17];
    let G;
    e[18] !== o ? (G = o && /* @__PURE__ */ m(Ke, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[18] = o, e[19] = G) : G = e[19];
    let U;
    e[20] !== r ? (U = r && /* @__PURE__ */ m(Kn, { ...r }), e[20] = r, e[21] = U) : U = e[21];
    let Y;
    e[22] !== s || e[23] !== b || e[24] !== _ || e[25] !== A || e[26] !== L || e[27] !== B || e[28] !== G || e[29] !== U || e[30] !== V ? (Y = /* @__PURE__ */ F("a", { href: V, onClick: b, "aria-current": _, "aria-disabled": A, tabIndex: L, className: B, children: [
      G,
      s,
      U
    ] }), e[22] = s, e[23] = b, e[24] = _, e[25] = A, e[26] = L, e[27] = B, e[28] = G, e[29] = U, e[30] = V, e[31] = Y) : Y = e[31];
    let K;
    return e[32] !== Y || e[33] !== O ? (K = /* @__PURE__ */ F("div", { className: W5, children: [
      O,
      Y
    ] }), e[32] = Y, e[33] = O, e[34] = K) : K = e[34], K;
  }
  const v = `#${n}`, C = g ? "true" : void 0, y = l ? "true" : void 0, w = l ? -1 : void 0;
  let R;
  e[35] !== l || e[36] !== g || e[37] !== c ? (R = S1({
    selected: g,
    disabled: l,
    orientation: c
  }), e[35] = l, e[36] = g, e[37] = c, e[38] = R) : R = e[38];
  let S;
  e[39] !== o ? (S = o && /* @__PURE__ */ m(Ke, { name: o, size: "xs", tone: "inherit", "aria-hidden": !0 }), e[39] = o, e[40] = S) : S = e[40];
  let E;
  e[41] !== r ? (E = r && /* @__PURE__ */ m(Kn, { ...r }), e[41] = r, e[42] = E) : E = e[42];
  let N;
  e[43] !== l || e[44] !== p || e[45] !== g || e[46] !== c ? (N = (g || l && p) && /* @__PURE__ */ m("span", { "aria-hidden": !0, className: [R1({
    orientation: c,
    selected: !0
  }), l && p ? "opacity-50" : ""].filter(Boolean).join(" ") }), e[43] = l, e[44] = p, e[45] = g, e[46] = c, e[47] = N) : N = e[47];
  let T;
  return e[48] !== s || e[49] !== b || e[50] !== N || e[51] !== v || e[52] !== C || e[53] !== y || e[54] !== w || e[55] !== R || e[56] !== S || e[57] !== E ? (T = /* @__PURE__ */ F("a", { href: v, onClick: b, "aria-current": C, "aria-disabled": y, tabIndex: w, className: R, children: [
    S,
    s,
    E,
    N
  ] }), e[48] = s, e[49] = b, e[50] = N, e[51] = v, e[52] = C, e[53] = y, e[54] = w, e[55] = R, e[56] = S, e[57] = E, e[58] = T) : T = e[58], T;
}
function G5(t) {
  const e = z.c(12), {
    orientation: n,
    activeId: o,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s,
    children: l
  } = t, a = n === void 0 ? "vertical" : n;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== a || e[3] !== s || e[4] !== i ? (c = {
    activeId: o,
    orientation: a,
    onActiveChange: r,
    startScrollLock: i,
    scrollRef: s
  }, e[0] = o, e[1] = r, e[2] = a, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const u = a === "vertical" ? "flex flex-col items-start gap-(--spacing-8)" : "flex flex-row flex-wrap gap-(--spacing-8)";
  let d;
  e[6] !== l || e[7] !== u ? (d = /* @__PURE__ */ m("nav", { "aria-label": "On this page", className: u, children: l }), e[6] = l, e[7] = u, e[8] = d) : d = e[8];
  let f;
  return e[9] !== c || e[10] !== d ? (f = /* @__PURE__ */ m(xm, { value: c, children: d }), e[9] = c, e[10] = d, e[11] = f) : f = e[11], f;
}
const E1 = 800;
function Y5(t) {
  const e = ft(null), n = ft(!1), o = ft(null), r = ft(null), [i, s] = ot(t[0]), l = t.join(","), a = ft(() => {
  });
  kt(() => {
    const u = e.current, d = l.split(",");
    function f() {
      o.current !== null && (s(o.current), o.current = null), n.current = !1, r.current !== null && (clearTimeout(r.current), r.current = null);
    }
    a.current = f;
    const p = new IntersectionObserver((h) => {
      for (const b of h)
        b.isIntersecting && (n.current ? (o.current = b.target.id, r.current !== null && clearTimeout(r.current), r.current = setTimeout(f, E1)) : s(b.target.id));
    }, {
      root: u,
      rootMargin: "0px 0px -80% 0px",
      threshold: 0
    });
    for (const h of d) {
      const b = document.getElementById(h);
      b && p.observe(b);
    }
    const g = u ?? document;
    return g.addEventListener("scrollend", f), () => {
      p.disconnect(), g.removeEventListener("scrollend", f), r.current !== null && clearTimeout(r.current);
    };
  }, [l]);
  const c = ft(() => {
    n.current = !0, r.current !== null && clearTimeout(r.current), r.current = setTimeout(() => a.current(), E1);
  }).current;
  return {
    scrollRef: e,
    activeId: i,
    onActiveChange: s,
    startScrollLock: c
  };
}
function j5(t, e) {
  return function(o, ...r) {
    const i = new URL(t);
    return i.searchParams.set("code", o.toString()), r.forEach((s) => i.searchParams.append("args[]", s)), `${e} error #${o}; visit ${i} for the full message.`;
  };
}
const rt = j5("https://base-ui.com/production-error", "Base UI"), N1 = {};
function Tt(t, e) {
  const n = x.useRef(N1);
  return n.current === N1 && (n.current = t(e)), n;
}
function fn(t, e, n, o) {
  const r = Tt(Cm).current;
  return q5(r, t, e, n, o) && wm(r, [t, e, n, o]), r.callback;
}
function K5(t) {
  const e = Tt(Cm).current;
  return Z5(e, t) && wm(e, t), e.callback;
}
function Cm() {
  return {
    callback: null,
    cleanup: null,
    refs: []
  };
}
function q5(t, e, n, o, r) {
  return t.refs[0] !== e || t.refs[1] !== n || t.refs[2] !== o || t.refs[3] !== r;
}
function Z5(t, e) {
  return t.refs.length !== e.length || t.refs.some((n, o) => n !== e[o]);
}
function wm(t, e) {
  if (t.refs = e, e.every((n) => n == null)) {
    t.callback = null;
    return;
  }
  t.callback = (n) => {
    if (t.cleanup && (t.cleanup(), t.cleanup = null), n != null) {
      const o = Array(e.length).fill(null);
      for (let r = 0; r < e.length; r += 1) {
        const i = e[r];
        if (i != null)
          switch (typeof i) {
            case "function": {
              const s = i(n);
              typeof s == "function" && (o[r] = s);
              break;
            }
            case "object": {
              i.current = n;
              break;
            }
          }
      }
      t.cleanup = () => {
        for (let r = 0; r < e.length; r += 1) {
          const i = e[r];
          if (i != null)
            switch (typeof i) {
              case "function": {
                const s = o[r];
                typeof s == "function" ? s() : i(null);
                break;
              }
              case "object": {
                i.current = null;
                break;
              }
            }
        }
      };
    }
  };
}
const X5 = parseInt(x.version, 10);
function Eu(t) {
  return X5 >= t;
}
function k1(t) {
  if (!/* @__PURE__ */ x.isValidElement(t))
    return null;
  const e = t, n = e.props;
  return (Eu(19) ? n?.ref : e.ref) ?? null;
}
function Uc(t, e) {
  if (t && !e)
    return t;
  if (!t && e)
    return e;
  if (t || e)
    return {
      ...t,
      ...e
    };
}
let Gc;
process.env.NODE_ENV !== "production" && (Gc = /* @__PURE__ */ new Set());
function Xl(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    Gc.has(e) || (Gc.add(e), console.warn(`Base UI: ${e}`));
  }
}
function xt() {
}
const On = Object.freeze([]), St = Object.freeze({});
function Q5(t, e) {
  const n = {};
  for (const o in t) {
    const r = t[o];
    if (e?.hasOwnProperty(o)) {
      const i = e[o](r);
      i != null && Object.assign(n, i);
      continue;
    }
    r === !0 ? n[`data-${o.toLowerCase()}`] = "" : r && (n[`data-${o.toLowerCase()}`] = r.toString());
  }
  return n;
}
function J5(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function ev(t, e) {
  return typeof t == "function" ? t(e) : t;
}
const Nu = {};
function en(t, e, n, o, r) {
  if (!n && !o && !r && !t)
    return Il(e);
  let i = Il(t);
  return e && (i = Oi(i, e)), n && (i = Oi(i, n)), o && (i = Oi(i, o)), r && (i = Oi(i, r)), i;
}
function tv(t) {
  if (t.length === 0)
    return Nu;
  if (t.length === 1)
    return Il(t[0]);
  let e = Il(t[0]);
  for (let n = 1; n < t.length; n += 1)
    e = Oi(e, t[n]);
  return e;
}
function Il(t) {
  return ku(t) ? {
    ...Rm(t, Nu)
  } : nv(t);
}
function Oi(t, e) {
  return ku(e) ? Rm(e, t) : ov(t, e);
}
function nv(t) {
  const e = {
    ...t
  };
  for (const n in e) {
    const o = e[n];
    Sm(n, o) && (e[n] = Em(o));
  }
  return e;
}
function ov(t, e) {
  if (!e)
    return t;
  for (const n in e) {
    const o = e[n];
    switch (n) {
      case "style": {
        t[n] = Uc(t.style, o);
        break;
      }
      case "className": {
        t[n] = Nm(t.className, o);
        break;
      }
      default:
        Sm(n, o) ? t[n] = rv(t[n], o) : t[n] = o;
    }
  }
  return t;
}
function Sm(t, e) {
  const n = t.charCodeAt(0), o = t.charCodeAt(1), r = t.charCodeAt(2);
  return n === 111 && o === 110 && r >= 65 && r <= 90 && (typeof e == "function" || typeof e > "u");
}
function ku(t) {
  return typeof t == "function";
}
function Rm(t, e) {
  return ku(t) ? t(e) : t ?? Nu;
}
function rv(t, e) {
  return e ? t ? (...n) => {
    const o = n[0];
    if (km(o)) {
      const i = o;
      Pl(i);
      const s = e(...n);
      return i.baseUIHandlerPrevented || t?.(...n), s;
    }
    const r = e(...n);
    return t?.(...n), r;
  } : Em(e) : t;
}
function Em(t) {
  return t && ((...e) => {
    const n = e[0];
    return km(n) && Pl(n), t(...e);
  });
}
function Pl(t) {
  return t.preventBaseUIHandler = () => {
    t.baseUIHandlerPrevented = !0;
  }, t;
}
function Nm(t, e) {
  return e ? t ? e + " " + t : e : t;
}
function km(t) {
  return t != null && typeof t == "object" && "nativeEvent" in t;
}
function $e(t, e, n = {}) {
  const o = e.render, r = iv(e, n);
  if (n.enabled === !1)
    return null;
  const i = n.state ?? St;
  return uv(t, o, r, i);
}
function iv(t, e = {}) {
  const {
    className: n,
    style: o,
    render: r
  } = t, {
    state: i = St,
    ref: s,
    props: l,
    stateAttributesMapping: a,
    enabled: c = !0
  } = e, u = c ? J5(n, i) : void 0, d = c ? ev(o, i) : void 0, f = c ? Q5(i, a) : St, p = c && l ? sv(l) : void 0, g = c ? Uc(f, p) ?? {} : St;
  return typeof document < "u" && (c ? Array.isArray(s) ? g.ref = K5([g.ref, k1(r), ...s]) : g.ref = fn(g.ref, k1(r), s) : fn(null, null)), c ? (u !== void 0 && (g.className = Nm(g.className, u)), d !== void 0 && (g.style = Uc(g.style, d)), g) : St;
}
function sv(t) {
  return Array.isArray(t) ? tv(t) : en(void 0, t);
}
const lv = /* @__PURE__ */ Symbol.for("react.lazy"), av = /^[A-Z][A-Za-z0-9$]*$/, cv = /[a-z]/;
function uv(t, e, n, o) {
  if (e) {
    if (typeof e == "function")
      return process.env.NODE_ENV !== "production" && dv(e), e(n, o);
    const r = en(n, e.props);
    r.ref = n.ref;
    let i = e;
    if (i?.$$typeof === lv && (i = x.Children.toArray(e)[0]), process.env.NODE_ENV !== "production" && !/* @__PURE__ */ x.isValidElement(i))
      throw new Error(["Base UI: The `render` prop was provided an invalid React element as `React.isValidElement(render)` is `false`.", "A valid React element must be provided to the `render` prop because it is cloned with props to replace the default element.", "https://base-ui.com/r/invalid-render-prop"].join(`
`));
    return /* @__PURE__ */ x.cloneElement(i, r);
  }
  if (t && typeof t == "string")
    return fv(t, n);
  throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: Render element or function are not defined." : rt(8));
}
function dv(t) {
  const e = t.name;
  e.length !== 0 && av.test(e) && cv.test(e) && Xl(`The \`render\` prop received a function named \`${e}\` that starts with an uppercase letter.`, "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function fv(t, e) {
  return t === "button" ? /* @__PURE__ */ C1("button", {
    type: "button",
    ...e,
    key: e.key
  }) : t === "img" ? /* @__PURE__ */ C1("img", {
    alt: "",
    ...e,
    key: e.key
  }) : /* @__PURE__ */ x.createElement(t, e);
}
const Mu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Mu.displayName = "AvatarRootContext");
function Mm() {
  const t = x.useContext(Mu);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: AvatarRootContext is missing. Avatar parts must be placed within <Avatar.Root>." : rt(13));
  return t;
}
const Iu = {
  imageLoadingStatus: () => null
}, Yc = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, [l, a] = x.useState("idle"), c = {
    imageLoadingStatus: l
  }, u = x.useMemo(() => ({
    imageLoadingStatus: l,
    setImageLoadingStatus: a
  }), [l, a]), d = $e("span", e, {
    state: c,
    ref: n,
    props: s,
    stateAttributesMapping: Iu
  });
  return /* @__PURE__ */ m(Mu.Provider, {
    value: u,
    children: d
  });
});
process.env.NODE_ENV !== "production" && (Yc.displayName = "AvatarRoot");
const Ua = x[`useInsertionEffect${Math.random().toFixed(1)}`.slice(0, -3)], pv = (
  // React 17 doesn't have useInsertionEffect.
  Ua && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
  Ua !== x.useLayoutEffect ? Ua : (t) => t()
);
function Se(t) {
  const e = Tt(gv).current;
  return e.next = t, pv(e.effect), e.trampoline;
}
function gv() {
  const t = {
    next: void 0,
    callback: mv,
    trampoline: (...e) => t.callback?.(...e),
    effect: () => {
      t.callback = t.next;
    }
  };
  return t;
}
function mv() {
  if (process.env.NODE_ENV !== "production")
    throw (
      /* minify-error-disabled */
      new Error("Base UI: Cannot call an event handler while rendering.")
    );
}
const hv = () => {
}, ke = typeof document < "u" ? x.useLayoutEffect : hv, bv = [];
function Jr(t) {
  x.useEffect(t, bv);
}
const zs = null;
let M1 = globalThis.requestAnimationFrame;
class vv {
  /* This implementation uses an array as a backing data-structure for frame callbacks.
   * It allows `O(1)` callback cancelling by inserting a `null` in the array, though it
   * never calls the native `cancelAnimationFrame` if there are no frames left. This can
   * be much more efficient if there is a call pattern that alterns as
   * "request-cancel-request-cancel-…".
   * But in the case of "request-request-…-cancel-cancel-…", it leaves the final animation
   * frame to run anyway. We turn that frame into a `O(1)` no-op via `callbacksCount`. */
  callbacks = [];
  callbacksCount = 0;
  nextId = 1;
  startId = 1;
  isScheduled = !1;
  tick = (e) => {
    this.isScheduled = !1;
    const n = this.callbacks, o = this.callbacksCount;
    if (this.callbacks = [], this.callbacksCount = 0, this.startId = this.nextId, o > 0)
      for (let r = 0; r < n.length; r += 1)
        n[r]?.(e);
  };
  request(e) {
    const n = this.nextId;
    this.nextId += 1, this.callbacks.push(e), this.callbacksCount += 1;
    const o = process.env.NODE_ENV !== "production" && M1 !== requestAnimationFrame && (M1 = requestAnimationFrame, !0);
    return (!this.isScheduled || o) && (requestAnimationFrame(this.tick), this.isScheduled = !0), n;
  }
  cancel(e) {
    const n = e - this.startId;
    n < 0 || n >= this.callbacks.length || (this.callbacks[n] = null, this.callbacksCount -= 1);
  }
}
const Bs = new vv();
class At {
  static create() {
    return new At();
  }
  static request(e) {
    return Bs.request(e);
  }
  static cancel(e) {
    return Bs.cancel(e);
  }
  currentId = zs;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  request(e) {
    this.cancel(), this.currentId = Bs.request(() => {
      this.currentId = zs, e();
    });
  }
  cancel = () => {
    this.currentId !== zs && (Bs.cancel(this.currentId), this.currentId = zs);
  };
  disposeEffect = () => this.cancel;
}
function ei() {
  const t = Tt(At.create).current;
  return Jr(t.disposeEffect), t;
}
function yo(t) {
  return t == null ? t : "current" in t ? t.current : t;
}
let qn = /* @__PURE__ */ (function(t) {
  return t.startingStyle = "data-starting-style", t.endingStyle = "data-ending-style", t;
})({});
const yv = {
  [qn.startingStyle]: ""
}, xv = {
  [qn.endingStyle]: ""
}, Bt = {
  transitionStatus(t) {
    return t === "starting" ? yv : t === "ending" ? xv : null;
  }
};
function Ql(t, e = !1, n = !0) {
  const o = ei();
  return Se((r, i = null) => {
    o.cancel();
    const s = yo(t);
    if (s == null)
      return;
    const l = s, a = () => {
      an.flushSync(r);
    };
    if (typeof l.getAnimations != "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
      r();
      return;
    }
    function c() {
      Promise.all(l.getAnimations().map((u) => u.finished)).then(() => {
        i?.aborted || a();
      }).catch(() => {
        if (n) {
          i?.aborted || a();
          return;
        }
        const u = l.getAnimations();
        !i?.aborted && u.length > 0 && u.some((d) => d.pending || d.playState !== "finished") && c();
      });
    }
    if (e) {
      const u = qn.startingStyle;
      if (!l.hasAttribute(u)) {
        o.request(c);
        return;
      }
      const d = new MutationObserver(() => {
        l.hasAttribute(u) || (d.disconnect(), c());
      });
      d.observe(l, {
        attributes: !0,
        attributeFilter: [u]
      }), i?.addEventListener("abort", () => d.disconnect(), {
        once: !0
      });
      return;
    }
    o.request(c);
  });
}
function jt(t) {
  const {
    enabled: e = !0,
    open: n,
    ref: o,
    onComplete: r
  } = t, i = Se(r), s = Ql(o, n, !1);
  x.useEffect(() => {
    if (!e)
      return;
    const l = new AbortController();
    return s(i, l.signal), () => {
      l.abort();
    };
  }, [e, n, i, s]);
}
function Xn(t, e = !1, n = !1) {
  const [o, r] = x.useState(t && e ? "idle" : void 0), [i, s] = x.useState(t);
  return t && !i && (s(!0), r("starting")), !t && i && o !== "ending" && !n && r("ending"), !t && !i && o === "ending" && r(void 0), ke(() => {
    if (!t && i && o !== "ending" && n) {
      const l = At.request(() => {
        r("ending");
      });
      return () => {
        At.cancel(l);
      };
    }
  }, [t, i, o, n]), ke(() => {
    if (!t || e)
      return;
    const l = At.request(() => {
      r(void 0);
    });
    return () => {
      At.cancel(l);
    };
  }, [e, t]), ke(() => {
    if (!t || !e)
      return;
    t && i && o !== "idle" && r("starting");
    const l = At.request(() => {
      r("idle");
    });
    return () => {
      At.cancel(l);
    };
  }, [e, t, i, o]), {
    mounted: i,
    setMounted: s,
    transitionStatus: o
  };
}
function Cv(t, {
  referrerPolicy: e,
  crossOrigin: n
}) {
  const [o, r] = x.useState("idle");
  return ke(() => {
    if (!t)
      return r("error"), xt;
    let i = !0;
    const s = new window.Image(), l = (a) => () => {
      i && r(a);
    };
    return r("loading"), s.onload = l("loaded"), s.onerror = l("error"), e && (s.referrerPolicy = e), s.crossOrigin = n ?? null, s.src = t, s.complete && r(s.naturalWidth > 0 ? "loaded" : "error"), () => {
      i = !1;
    };
  }, [t, n, e]), o;
}
const wv = {
  ...Iu,
  ...Bt
}, Im = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    onLoadingStatusChange: i,
    referrerPolicy: s,
    crossOrigin: l,
    style: a,
    ...c
  } = e, u = Mm(), d = Cv(e.src, {
    referrerPolicy: s,
    crossOrigin: l
  }), f = d === "loaded", {
    mounted: p,
    transitionStatus: g,
    setMounted: h
  } = Xn(f), b = x.useRef(null), v = Se((w) => {
    i?.(w), u.setImageLoadingStatus(w);
  });
  ke(() => {
    d !== "idle" && v(d);
  }, [d, v]);
  const C = {
    imageLoadingStatus: d,
    transitionStatus: g
  };
  jt({
    open: f,
    ref: b,
    onComplete() {
      f || h(!1);
    }
  });
  const y = $e("img", e, {
    state: C,
    ref: [n, b],
    props: c,
    stateAttributesMapping: wv,
    enabled: p
  });
  return p ? y : null;
});
process.env.NODE_ENV !== "production" && (Im.displayName = "AvatarImage");
const Si = 0;
class xn {
  static create() {
    return new xn();
  }
  currentId = Si;
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(e, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = Si, n();
    }, e);
  }
  isStarted() {
    return this.currentId !== Si;
  }
  clear = () => {
    this.currentId !== Si && (clearTimeout(this.currentId), this.currentId = Si);
  };
  disposeEffect = () => this.clear;
}
function Vt() {
  const t = Tt(xn.create).current;
  return Jr(t.disposeEffect), t;
}
const Pm = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    delay: i,
    style: s,
    ...l
  } = e, {
    imageLoadingStatus: a
  } = Mm(), [c, u] = x.useState(i === void 0), d = Vt();
  return x.useEffect(() => (i !== void 0 && d.start(i, () => u(!0)), d.clear), [d, i]), $e("span", e, {
    state: {
      imageLoadingStatus: a
    },
    ref: n,
    props: l,
    stateAttributesMapping: Iu,
    enabled: a !== "loaded" && c
  });
});
process.env.NODE_ENV !== "production" && (Pm.displayName = "AvatarFallback");
const I1 = ce(["inline-flex", "shrink-0", "items-center", "justify-center", "overflow-hidden", "rounded-full", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "select-none"], {
  variants: {
    size: {
      md: ["size-(--spacing-40)", "text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"],
      xs: ["size-(--spacing-20)", "text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)"]
    },
    variant: {
      internal: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      external: ["bg-surface-container-highest", "text-surface-on-surface"],
      ai: ["bg-ai-avatar-background"]
    }
  }
});
function Gr(t) {
  const e = z.c(44);
  let n, o, r, i;
  e[0] !== t ? ({
    size: r,
    variant: i,
    "aria-label": n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "md" : r;
  if (i === "ai") {
    const S = s === "xs", E = S ? void 0 : "img", N = S ? void 0 : n ?? "AI", T = S || void 0;
    let P;
    e[5] !== s || e[6] !== i ? (P = I1({
      size: s,
      variant: i
    }), e[5] = s, e[6] = i, e[7] = P) : P = e[7];
    const I = s === "xs" ? "xs" : "sm", k = s === "xs" ? "size-[12px]" : void 0;
    let M;
    e[8] !== I || e[9] !== k ? (M = /* @__PURE__ */ m(Ru, { size: I, className: k }), e[8] = I, e[9] = k, e[10] = M) : M = e[10];
    let D;
    return e[11] !== o || e[12] !== E || e[13] !== N || e[14] !== T || e[15] !== P || e[16] !== M ? (D = /* @__PURE__ */ m(Yc, { ...o, "data-slot": "avatar", "data-variant": "ai", role: E, "aria-label": N, "aria-hidden": T, className: P, children: M }), e[11] = o, e[12] = E, e[13] = N, e[14] = T, e[15] = P, e[16] = M, e[17] = D) : D = e[17], D;
  }
  const l = o;
  let a, c, u;
  e[18] !== l ? ({
    initials: a,
    src: u,
    ...c
  } = l, e[18] = l, e[19] = a, e[20] = c, e[21] = u) : (a = e[19], c = e[20], u = e[21]);
  const d = s === "xs", f = !u && !d ? n : void 0, p = u && !d ? n : void 0, g = f ? "img" : void 0, h = d || void 0;
  let b;
  e[22] !== s || e[23] !== i ? (b = I1({
    size: s,
    variant: i
  }), e[22] = s, e[23] = i, e[24] = b) : b = e[24];
  let v;
  e[25] !== n || e[26] !== d || e[27] !== u ? (v = u ? /* @__PURE__ */ m(Im, { "data-slot": "avatar-image", src: u, alt: d ? "" : n ?? "", className: "h-full w-full object-cover" }) : null, e[25] = n, e[26] = d, e[27] = u, e[28] = v) : v = e[28];
  const C = p ? "img" : void 0;
  let y;
  e[29] !== a ? (y = /* @__PURE__ */ m("span", { "aria-hidden": "true", children: a }), e[29] = a, e[30] = y) : y = e[30];
  let w;
  e[31] !== p || e[32] !== C || e[33] !== y ? (w = /* @__PURE__ */ m(Pm, { "data-slot": "avatar-fallback", role: C, "aria-label": p, children: y }), e[31] = p, e[32] = C, e[33] = y, e[34] = w) : w = e[34];
  let R;
  return e[35] !== f || e[36] !== c || e[37] !== g || e[38] !== h || e[39] !== b || e[40] !== v || e[41] !== w || e[42] !== i ? (R = /* @__PURE__ */ F(Yc, { ...c, "data-slot": "avatar", "data-variant": i, role: g, "aria-label": f, "aria-hidden": h, className: b, children: [
    v,
    w
  ] }), e[35] = f, e[36] = c, e[37] = g, e[38] = h, e[39] = b, e[40] = v, e[41] = w, e[42] = i, e[43] = R) : R = e[43], R;
}
function Jl() {
  return typeof window < "u";
}
function cn(t) {
  return Pu(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function wt(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function ho(t) {
  var e;
  return (e = (Pu(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function Pu(t) {
  return Jl() ? t instanceof Node || t instanceof wt(t).Node : !1;
}
function pt(t) {
  return Jl() ? t instanceof Element || t instanceof wt(t).Element : !1;
}
function Ct(t) {
  return Jl() ? t instanceof HTMLElement || t instanceof wt(t).HTMLElement : !1;
}
function Yr(t) {
  return !Jl() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof wt(t).ShadowRoot;
}
function Qo(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = pn(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && r !== "inline" && r !== "contents";
}
function Sv(t) {
  return /^(table|td|th)$/.test(cn(t));
}
function ea(t) {
  try {
    if (t.matches(":popover-open"))
      return !0;
  } catch {
  }
  try {
    return t.matches(":modal");
  } catch {
    return !1;
  }
}
const Rv = /transform|translate|scale|rotate|perspective|filter/, Ev = /paint|layout|strict|content/, or = (t) => !!t && t !== "none";
let Ga;
function Tu(t) {
  const e = pt(t) ? pn(t) : t;
  return or(e.transform) || or(e.translate) || or(e.scale) || or(e.rotate) || or(e.perspective) || !ta() && (or(e.backdropFilter) || or(e.filter)) || Rv.test(e.willChange || "") || Ev.test(e.contain || "");
}
function Nv(t) {
  let e = po(t);
  for (; Ct(e) && !ao(e); ) {
    if (Tu(e))
      return e;
    if (ea(e))
      return null;
    e = po(e);
  }
  return null;
}
function ta() {
  return Ga == null && (Ga = typeof CSS < "u" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none")), Ga;
}
function ao(t) {
  return /^(html|body|#document)$/.test(cn(t));
}
function pn(t) {
  return wt(t).getComputedStyle(t);
}
function na(t) {
  return pt(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function po(t) {
  if (cn(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Yr(t) && t.host || // Fallback.
    ho(t)
  );
  return Yr(e) ? e.host : e;
}
function Tm(t) {
  const e = po(t);
  return ao(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Ct(e) && Qo(e) ? e : Tm(e);
}
function Wi(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = Tm(t), i = r === ((o = t.ownerDocument) == null ? void 0 : o.body), s = wt(r);
  if (i) {
    const l = jc(s);
    return e.concat(s, s.visualViewport || [], Qo(r) ? r : [], l && n ? Wi(l) : []);
  } else
    return e.concat(r, Wi(r, [], n));
}
function jc(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
let Kc;
process.env.NODE_ENV !== "production" && (Kc = /* @__PURE__ */ new Set());
function jo(...t) {
  if (process.env.NODE_ENV !== "production") {
    const e = t.join(" ");
    Kc.has(e) || (Kc.add(e), console.error(`Base UI: ${e}`));
  }
}
const pr = {
  ...x
}, Ou = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ou.displayName = "CompositeRootContext");
function Du(t = !1) {
  const e = x.useContext(Ou);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CompositeRootContext is missing. Composite parts must be placed within <Composite.Root>." : rt(16));
  return e;
}
function kv(t) {
  const {
    focusableWhenDisabled: e,
    disabled: n,
    composite: o = !1,
    tabIndex: r = 0,
    isNativeButton: i
  } = t, s = o && e !== !1, l = o && e === !1;
  return {
    props: x.useMemo(() => {
      const c = {
        // allow Tabbing away from focusableWhenDisabled elements
        onKeyDown(u) {
          n && e && u.key !== "Tab" && u.preventDefault();
        }
      };
      return o || (c.tabIndex = r, !i && n && (c.tabIndex = e ? r : -1)), (i && (e || s) || !i && n) && (c["aria-disabled"] = n), i && (!e || l) && (c.disabled = n), c;
    }, [o, n, e, s, l, i, r])
  };
}
function Wt(t = {}) {
  const {
    disabled: e = !1,
    focusableWhenDisabled: n,
    tabIndex: o = 0,
    native: r = !0,
    composite: i
  } = t, s = x.useRef(null), l = Du(!0), a = i ?? l !== void 0, {
    props: c
  } = kv({
    focusableWhenDisabled: n,
    disabled: e,
    composite: a,
    tabIndex: o,
    isNativeButton: r
  });
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!s.current)
      return;
    const p = Ws(s.current);
    if (r) {
      if (!p) {
        const g = pr.captureOwnerStack?.() || "";
        jo(`A component that acts as a button expected a native <button> because the \`nativeButton\` prop is true. Rendering a non-<button> removes native button semantics, which can impact forms and accessibility. Use a real <button> in the \`render\` prop, or set \`nativeButton\` to \`false\`.${g}`);
      }
    } else if (p) {
      const g = pr.captureOwnerStack?.() || "";
      jo(`A component that acts as a button expected a non-<button> because the \`nativeButton\` prop is false. Rendering a <button> keeps native behavior while Base UI applies non-native attributes and handlers, which can add unintended extra attributes (such as \`role\` or \`aria-disabled\`). Use a non-<button> in the \`render\` prop, or set \`nativeButton\` to \`true\`.${g}`);
    }
  }, [r]);
  const u = x.useCallback(() => {
    const p = s.current;
    Ws(p) && a && e && c.disabled === void 0 && p.disabled && (p.disabled = !1);
  }, [e, c.disabled, a]);
  ke(u, [u]);
  const d = x.useCallback((p = {}) => {
    const {
      onClick: g,
      onMouseDown: h,
      onKeyUp: b,
      onKeyDown: v,
      onPointerDown: C,
      ...y
    } = p;
    return en({
      type: r ? "button" : void 0,
      onClick(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        g?.(R);
      },
      onMouseDown(R) {
        e || h?.(R);
      },
      onKeyDown(R) {
        if (e || (Pl(R), v?.(R), R.baseUIHandlerPrevented))
          return;
        const S = R.target === R.currentTarget, E = R.currentTarget, N = Ws(E), T = !r && Mv(E), P = S && (r ? N : !T), I = R.key === "Enter", k = R.key === " ", M = E.getAttribute("role"), D = M?.startsWith("menuitem") || M === "option" || M === "gridcell";
        if (S && a && k) {
          if (R.defaultPrevented && D)
            return;
          R.preventDefault(), T || r && N ? (E.click(), R.preventBaseUIHandler()) : P && (g?.(R), R.preventBaseUIHandler());
          return;
        }
        P && (!r && (k || I) && R.preventDefault(), !r && I && g?.(R));
      },
      onKeyUp(R) {
        if (!e) {
          if (Pl(R), b?.(R), R.target === R.currentTarget && r && a && Ws(R.currentTarget) && R.key === " ") {
            R.preventDefault();
            return;
          }
          R.baseUIHandlerPrevented || R.target === R.currentTarget && !r && !a && R.key === " " && g?.(R);
        }
      },
      onPointerDown(R) {
        if (e) {
          R.preventDefault();
          return;
        }
        C?.(R);
      }
    }, r ? void 0 : {
      role: "button"
    }, c, y);
  }, [e, c, a, r]), f = Se((p) => {
    s.current = p, u();
  });
  return {
    getButtonProps: d,
    buttonRef: f
  };
}
function Ws(t) {
  return Ct(t) && t.tagName === "BUTTON";
}
function Mv(t) {
  return !!(t?.tagName === "A" && t?.href);
}
const Qn = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    focusableWhenDisabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    getButtonProps: u,
    buttonRef: d
  } = Wt({
    disabled: i,
    focusableWhenDisabled: s,
    native: l
  });
  return $e("button", e, {
    state: {
      disabled: i
    },
    ref: [n, d],
    props: [c, u]
  });
});
process.env.NODE_ENV !== "production" && (Qn.displayName = "Button");
function Vu(t) {
  const e = z.c(2), {
    size: n
  } = t, o = n === void 0 ? "sm" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ m("span", { className: "aw-spinner inline-flex", "aria-hidden": "true", children: /* @__PURE__ */ m(Ke, { name: "button-load-spinner", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
const Iv = ce(["inline-flex", "items-center", "justify-center", "whitespace-nowrap", "shrink-0", "rounded-(--radius-sm)", "px-(--spacing-12)", "border", "border-solid", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-[background,color,box-shadow]", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "conversation-ui": ["bg-button-primary-conversation-ui-background", "text-button-primary-conversation-ui-text", "border-button-primary-conversation-ui-background", "hover:bg-button-primary-conversation-ui-background", "hover:border-button-primary-conversation-ui-background", "active:bg-button-primary-conversation-ui-background", "active:border-button-primary-conversation-ui-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-outline": ["aw-ai-button--outline", "bg-surface", "border-transparent", "text-text-default", "hover:bg-button-outline-hover-background", "active:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      "ai-ghost": ["border-transparent", "bg-transparent", "text-text-default", "hover:bg-surface-hover", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["h-(--spacing-32)", "gap-(--spacing-8)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"],
      md: ["h-(--spacing-40)", "gap-(--spacing-8)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"],
      lg: ["h-[44px]", "gap-(--spacing-8)", "px-(--spacing-16)", "text-(length:--font-size-body-large)", "leading-(--font-line-height-24)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "sm",
    class: ["text-(length:--font-size-body-large)", "leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "md",
    class: ["leading-(--font-line-height-20)"]
  }, {
    variant: ["ai-outline", "ai-ghost"],
    size: "lg",
    class: ["px-(--spacing-12)", "leading-(--font-line-height-20)"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function Pv() {
  const t = z.c(44), e = _t();
  let n;
  if (t[0] !== e) {
    let G;
    t[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = /:/g, t[2] = G) : G = t[2], n = e.replace(G, ""), t[0] = e, t[1] = n;
  } else
    n = t[1];
  const o = n, r = `ai-button-gradient-${o}`, i = `ai-button-shimmer-${o}`, s = `ai-button-glow-${o}`;
  let l, a, c;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ m("stop", { offset: "13%", stopColor: "hsl(var(--primary-primary-container))" }), a = /* @__PURE__ */ m("stop", { offset: "44%", stopColor: "hsl(var(--primary-primary))" }), c = /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))" }), t[3] = l, t[4] = a, t[5] = c) : (l = t[3], a = t[4], c = t[5]);
  let u;
  t[6] !== r ? (u = /* @__PURE__ */ F("linearGradient", { id: r, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    l,
    a,
    c
  ] }), t[6] = r, t[7] = u) : u = t[7];
  let d, f, p, g, h, b;
  t[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ m("stop", { offset: "0%", stopColor: "hsl(var(--primary-primary))", stopOpacity: "0" }), g = /* @__PURE__ */ m("stop", { offset: "30%", stopColor: "hsl(var(--primary-primary-container))", stopOpacity: "0" }), h = /* @__PURE__ */ m("stop", { offset: "46%", stopColor: "hsl(var(--gradients-ai-gradient-01))", stopOpacity: "0.9" }), b = /* @__PURE__ */ m("stop", { offset: "70%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), d = /* @__PURE__ */ m("stop", { offset: "100%", stopColor: "hsl(var(--tertiary-tertiary))", stopOpacity: "0" }), f = /* @__PURE__ */ m("animateTransform", { attributeName: "gradientTransform", type: "rotate", from: "-12 .5 .5", to: "348 .5 .5", dur: "3.25s", repeatCount: "indefinite" }), t[8] = d, t[9] = f, t[10] = p, t[11] = g, t[12] = h, t[13] = b) : (d = t[8], f = t[9], p = t[10], g = t[11], h = t[12], b = t[13]);
  let v;
  t[14] !== i ? (v = /* @__PURE__ */ F("linearGradient", { id: i, x1: "0", y1: "0", x2: "1", y2: "0", gradientTransform: "rotate(-12 .5 .5)", children: [
    p,
    g,
    h,
    b,
    d,
    f
  ] }), t[14] = i, t[15] = v) : v = t[15];
  let C, y, w, R;
  t[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ m("feGaussianBlur", { in: "SourceGraphic", stdDeviation: "0.8", result: "haloBlur" }), y = /* @__PURE__ */ m("feFlood", { floodColor: "hsl(var(--gradients-ai-gradient-01))", floodOpacity: "0.4", result: "haloColor" }), w = /* @__PURE__ */ m("feComposite", { in: "haloColor", in2: "haloBlur", operator: "in", result: "halo" }), R = /* @__PURE__ */ m("feMerge", { children: /* @__PURE__ */ m("feMergeNode", { in: "halo" }) }), t[16] = C, t[17] = y, t[18] = w, t[19] = R) : (C = t[16], y = t[17], w = t[18], R = t[19]);
  let S;
  t[20] !== s ? (S = /* @__PURE__ */ F("filter", { id: s, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", filterUnits: "userSpaceOnUse", children: [
    C,
    y,
    w,
    R
  ] }), t[20] = s, t[21] = S) : S = t[21];
  const E = `${s}-outside`;
  let N, T;
  t[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ m("rect", { x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", fill: "white" }), T = /* @__PURE__ */ m("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "black" }), t[22] = N, t[23] = T) : (N = t[22], T = t[23]);
  let P;
  t[24] !== E ? (P = /* @__PURE__ */ F("mask", { id: E, x: "-2", y: "-2", width: "calc(100% + 4px)", height: "calc(100% + 4px)", maskUnits: "userSpaceOnUse", children: [
    N,
    T
  ] }), t[24] = E, t[25] = P) : P = t[25];
  let I;
  t[26] !== v || t[27] !== S || t[28] !== P || t[29] !== u ? (I = /* @__PURE__ */ F("defs", { children: [
    u,
    v,
    S,
    P
  ] }), t[26] = v, t[27] = S, t[28] = P, t[29] = u, t[30] = I) : I = t[30];
  const k = `url(#${s}-outside)`, M = `url(#${s})`;
  let D;
  t[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = /* @__PURE__ */ m("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: "hsl(var(--gradients-ai-gradient-01))", strokeWidth: "4" }), t[31] = D) : D = t[31];
  let O;
  t[32] !== k || t[33] !== M ? (O = /* @__PURE__ */ m("g", { mask: k, filter: M, children: D }), t[32] = k, t[33] = M, t[34] = O) : O = t[34];
  const V = `url(#${r})`;
  let _;
  t[35] !== V ? (_ = /* @__PURE__ */ m("rect", { className: "aw-ai-button__border", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: V, strokeWidth: "1" }), t[35] = V, t[36] = _) : _ = t[36];
  const A = `url(#${i})`;
  let L;
  t[37] !== A ? (L = /* @__PURE__ */ m("rect", { className: "aw-ai-button__border aw-ai-button__highlight", x: "0.5", y: "0.5", width: "calc(100% - 1px)", height: "calc(100% - 1px)", fill: "none", stroke: A, strokeWidth: "1.5" }), t[37] = A, t[38] = L) : L = t[38];
  let B;
  return t[39] !== I || t[40] !== O || t[41] !== _ || t[42] !== L ? (B = /* @__PURE__ */ F("svg", { className: "pointer-events-none absolute inset-0 z-0 size-full overflow-visible", "aria-hidden": "true", focusable: "false", children: [
    I,
    O,
    _,
    L
  ] }), t[39] = I, t[40] = O, t[41] = _, t[42] = L, t[43] = B) : B = t[43], B;
}
function _u(t) {
  const e = z.c(42);
  let n, o, r, i, s, l, a, c, u, d;
  e[0] !== t ? ({
    children: n,
    variant: d,
    intent: r,
    size: l,
    icon: o,
    loading: a,
    loadingText: i,
    fullWidth: c,
    disabled: u,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10]);
  const f = a === void 0 ? !1 : a, p = c === void 0 ? !1 : c, g = u === void 0 ? !1 : u, h = g || f, b = d === "ai-outline" || d === "ai-ghost", v = d === "ai-outline", y = f ? `${i ?? (b ? "Thinking" : "Loading")}...` : n;
  let w;
  e[11] !== o || e[12] !== b || e[13] !== f ? (w = f ? /* @__PURE__ */ m(Vu, { size: "sm" }) : b ? /* @__PURE__ */ m("span", { className: "inline-flex size-(--icon-sm) shrink-0 overflow-hidden", "aria-hidden": "true", children: /* @__PURE__ */ m(Ru, { className: "block size-(--icon-sm) shrink-0", size: "sm" }) }) : o ? /* @__PURE__ */ m(Ke, { name: o, size: "sm", tone: "inherit" }) : null, e[11] = o, e[12] = b, e[13] = f, e[14] = w) : w = e[14];
  let R;
  e[15] !== y || e[16] !== w ? (R = /* @__PURE__ */ F(zt, { children: [
    y,
    w
  ] }), e[15] = y, e[16] = w, e[17] = R) : R = e[17];
  const S = R;
  let E;
  e[18] !== g || e[19] !== p || e[20] !== r || e[21] !== h || e[22] !== f || e[23] !== l || e[24] !== d ? (E = ne(Iv({
    variant: d,
    intent: r,
    size: l
  }), p && "w-full", h && "opacity-40 pointer-events-none", g && "cursor-not-allowed", f && !g && "cursor-default"), e[18] = g, e[19] = p, e[20] = r, e[21] = h, e[22] = f, e[23] = l, e[24] = d, e[25] = E) : E = e[25];
  const N = h || void 0, T = f || void 0, P = h ? -1 : void 0;
  let I;
  e[26] !== v ? (I = v ? /* @__PURE__ */ m(Pv, {}) : null, e[26] = v, e[27] = I) : I = e[27];
  let k;
  e[28] !== S || e[29] !== b ? (k = b ? /* @__PURE__ */ m("span", { className: "relative z-10 inline-flex items-center gap-(--spacing-8)", children: S }) : S, e[28] = S, e[29] = b, e[30] = k) : k = e[30];
  let M;
  return e[31] !== h || e[32] !== s || e[33] !== l || e[34] !== P || e[35] !== I || e[36] !== k || e[37] !== E || e[38] !== N || e[39] !== T || e[40] !== d ? (M = /* @__PURE__ */ F(Qn, { "data-slot": "button", "data-variant": d, "data-size": l, className: E, disabled: h, "aria-disabled": N, "aria-busy": T, tabIndex: P, ...s, children: [
    I,
    k
  ] }), e[31] = h, e[32] = s, e[33] = l, e[34] = P, e[35] = I, e[36] = k, e[37] = E, e[38] = N, e[39] = T, e[40] = d, e[41] = M) : M = e[41], M;
}
function _n(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(_u, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function P1(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(_u, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Tv(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(_u, { ...t, variant: "conversation-ui" }), e[0] = t, e[1] = n) : n = e[1], n;
}
const Au = mo({
  align: "start"
}), Ov = ce(["flex", "w-full", "min-w-0", "gap-(--spacing-8)"], {
  variants: {
    align: {
      start: "justify-start",
      end: "justify-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), Dv = ce(["flex", "min-w-0", "w-full", "max-w-[520px]", "flex-col", "gap-(--spacing-4)"], {
  variants: {
    align: {
      start: "items-start",
      end: "items-end"
    }
  },
  defaultVariants: {
    align: "start"
  }
}), Vv = ce(["flex", "items-center", "gap-(--spacing-6)", "px-(--spacing-2)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default"]), _v = ce(["flex", "items-center", "min-w-0", "w-full", "gap-(--spacing-8)"]), Av = ce(["flex", "w-full", "flex-col", "gap-(--spacing-8)"]), Lv = ce(["max-w-full", "break-words", "whitespace-pre-wrap", "rounded-(--radius-sm)", "p-(--spacing-16)", "shadow-elevation-1", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      inbound: ["w-fit", "bg-surface-container", "text-text-default"],
      outbound: ["w-fit", "bg-surface-container", "text-text-default"],
      system: ["w-full", "bg-surface-container", "text-text-default"],
      informative: ["w-full", "bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "inbound"
  }
}), Fv = ce(["flex", "w-full", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "px-(--spacing-16)", "py-(--spacing-8)", "text-center", "font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"], {
  variants: {
    tone: {
      default: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      informative: ["border-informative-container", "bg-informative-container", "text-informative-on-container"],
      positive: ["border-positive-on-container", "bg-positive-container", "text-positive-on-container"],
      warning: ["border-warning-on-container", "bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["border-negative-on-container", "bg-negative-container", "text-negative-on-container"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
});
function qc(t) {
  const e = z.c(18);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    direction: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = o === "outbound" ? "end" : "start";
  let s;
  e[4] !== o || e[5] !== i ? (s = {
    align: i,
    direction: o
  }, e[4] = o, e[5] = i, e[6] = s) : s = e[6];
  let l;
  e[7] !== i ? (l = ne(Ov({
    align: i
  })), e[7] = i, e[8] = l) : l = e[8];
  let a;
  e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== i || e[13] !== l ? (a = /* @__PURE__ */ m("article", { "data-slot": "chat-message", "data-align": i, "data-direction": o, className: l, ...r, children: n }), e[9] = n, e[10] = o, e[11] = r, e[12] = i, e[13] = l, e[14] = a) : a = e[14];
  let c;
  return e[15] !== s || e[16] !== a ? (c = /* @__PURE__ */ m(Au, { value: s, children: a }), e[15] = s, e[16] = a, e[17] = c) : c = e[17], c;
}
function Om(t) {
  const e = z.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ m("div", { "data-slot": "chat-message-avatar", className: "shrink-0", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Zc(t) {
  const e = z.c(10);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    align: r
  } = gn(Au);
  let i;
  e[3] !== r ? (i = ne(Dv({
    align: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== r || e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ m("div", { "data-slot": "chat-message-content", "data-align": r, className: i, ...o, children: n }), e[5] = r, e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
function Dm(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Vv()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("header", { "data-slot": "chat-message-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function T1(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(_v()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("footer", { "data-slot": "chat-message-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function $v(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Av()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { "data-slot": "chat-message-group", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Xc(t) {
  const e = z.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    tone: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const {
    direction: i
  } = gn(Au), s = r ?? i ?? "inbound";
  let l;
  e[4] !== s ? (l = ne(Lv({
    tone: s
  })), e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== n || e[7] !== o || e[8] !== s || e[9] !== l ? (a = /* @__PURE__ */ m("div", { "data-slot": "chat-bubble", "data-tone": s, className: l, ...o, children: n }), e[6] = n, e[7] = o, e[8] = s, e[9] = l, e[10] = a) : a = e[10], a;
}
function Hv(t) {
  const e = z.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    live: r,
    tone: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "polite" : r, l = i === void 0 ? "default" : i;
  let a;
  e[5] !== l ? (a = ne(Fv({
    tone: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== s || e[9] !== o || e[10] !== a || e[11] !== l ? (c = /* @__PURE__ */ m("output", { "data-slot": "chat-status", "data-tone": l, "aria-live": s, className: a, ...o, children: n }), e[7] = n, e[8] = s, e[9] = o, e[10] = a, e[11] = l, e[12] = c) : c = e[12], c;
}
const zv = ce(["inline-flex", "items-center", "justify-center", "shrink-0", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      primary: ["bg-button-primary-default-background", "text-button-primary-default-text", "border-button-primary-default-background", "hover:bg-button-primary-hover-background", "hover:border-button-primary-hover-background", "active:bg-button-primary-pressed-background", "active:border-button-primary-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"],
      info: ["bg-button-info-default-background", "text-button-info-default-text", "border-button-info-default-background", "hover:bg-button-info-hover-background", "hover:border-button-info-hover-background", "active:bg-button-info-pressed-background", "active:border-button-info-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]
    },
    intent: {
      default: null,
      destructive: null
    },
    size: {
      sm: ["size-(--spacing-32)"],
      md: ["size-(--spacing-40)"]
    }
  },
  compoundVariants: [{
    variant: "primary",
    intent: "destructive",
    class: ["bg-button-primary-destructive-default-background", "text-button-primary-destructive-text", "border-button-primary-destructive-default-background", "hover:bg-button-primary-destructive-hover-background", "hover:border-button-primary-destructive-hover-background", "active:bg-button-primary-destructive-pressed-background", "active:border-button-primary-destructive-pressed-background"]
  }, {
    variant: "ghost",
    intent: "destructive",
    class: ["text-text-destructive"]
  }],
  defaultVariants: {
    variant: "primary",
    intent: "default",
    size: "md"
  }
});
function mt(t) {
  const e = z.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: n,
    variant: a,
    intent: o,
    size: i,
    loading: s,
    disabled: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? !1 : s, u = l === void 0 ? !1 : l, d = u || c;
  let f;
  e[8] !== u || e[9] !== o || e[10] !== d || e[11] !== c || e[12] !== i || e[13] !== a ? (f = ne(zv({
    variant: a,
    intent: o,
    size: i
  }), d && "opacity-40 pointer-events-none", u && "cursor-not-allowed", c && !u && "cursor-default"), e[8] = u, e[9] = o, e[10] = d, e[11] = c, e[12] = i, e[13] = a, e[14] = f) : f = e[14];
  const p = d || void 0, g = c || void 0, h = d ? -1 : void 0;
  let b;
  e[15] !== n || e[16] !== c ? (b = c ? /* @__PURE__ */ m(Vu, { size: "sm" }) : /* @__PURE__ */ m(Ke, { name: n, size: "sm", tone: "inherit" }), e[15] = n, e[16] = c, e[17] = b) : b = e[17];
  let v;
  return e[18] !== d || e[19] !== r || e[20] !== i || e[21] !== f || e[22] !== p || e[23] !== g || e[24] !== h || e[25] !== b || e[26] !== a ? (v = /* @__PURE__ */ m(Qn, { "data-slot": "icon-button", "data-variant": a, "data-size": i, className: f, disabled: d, "aria-disabled": p, "aria-busy": g, tabIndex: h, ...r, children: b }), e[18] = d, e[19] = r, e[20] = i, e[21] = f, e[22] = p, e[23] = g, e[24] = h, e[25] = b, e[26] = a, e[27] = v) : v = e[27], v;
}
const Bv = ce(["aw-chat-scroller", "group", "relative", "flex", "h-full", "min-h-0", "min-w-0", "flex-1", "flex-col"]), Wv = ce(["min-h-0", "min-w-0", "flex-1", "overflow-x-hidden", "overflow-y-auto", "px-(--spacing-12)", "py-(--spacing-12)", "outline-none", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-button-focus-ring"]), Uv = ce(["flex", "flex-col", "min-w-0", "gap-(--spacing-20)"]), Gv = ce(["min-w-0"]), Yv = ce(["absolute", "bottom-(--spacing-16)", "left-1/2", "z-10", "-translate-x-1/2", "hidden", "group-data-[scrollable~='end']:block"]);
function Vm(t) {
  const e = z.c(19);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    children: n,
    autoScroll: l,
    defaultScrollPosition: a,
    scrollEdgeThreshold: r,
    scrollPreviousItemPeek: s,
    scrollMargin: i,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !0 : l, u = a === void 0 ? "end" : a;
  let d;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = ne(Bv()), e[8] = d) : d = e[8];
  let f;
  e[9] !== n || e[10] !== o ? (f = /* @__PURE__ */ m(Ur.Root, { "data-slot": "chat-scroller", className: d, ...o, children: n }), e[9] = n, e[10] = o, e[11] = f) : f = e[11];
  let p;
  return e[12] !== c || e[13] !== u || e[14] !== r || e[15] !== i || e[16] !== s || e[17] !== f ? (p = /* @__PURE__ */ m(Ur.Provider, { autoScroll: c, defaultScrollPosition: u, scrollEdgeThreshold: r, scrollPreviousItemPeek: s, scrollMargin: i, children: f }), e[12] = c, e[13] = u, e[14] = r, e[15] = i, e[16] = s, e[17] = f, e[18] = p) : p = e[18], p;
}
function _m(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Wv()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m(Ur.Viewport, { "data-slot": "chat-scroller-viewport", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Am(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(Uv()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m(Ur.Content, { "data-slot": "chat-scroller-content", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Fi(t) {
  const e = z.c(9);
  let n, o, r;
  e[0] !== t ? ({
    messageId: o,
    children: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(Gv()), e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== r ? (s = /* @__PURE__ */ m(Ur.Item, { "data-slot": "chat-scroller-item", messageId: o, className: i, ...r, children: n }), e[5] = n, e[6] = o, e[7] = r, e[8] = s) : s = e[8], s;
}
function Lm(t) {
  const e = z.c(9);
  let n, o;
  e[0] !== t ? ({
    "aria-label": o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? "Jump to latest message" : o;
  let i;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(Yv()), e[3] = i) : i = e[3];
  let s;
  e[4] !== r ? (s = /* @__PURE__ */ m(mt, { icon: "chevron-down", "aria-label": r, variant: "outline", size: "sm" }), e[4] = r, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== s ? (l = /* @__PURE__ */ m("div", { "data-slot": "chat-scroller-jump-to-latest", className: i, children: /* @__PURE__ */ m(Ur.Button, { direction: "end", render: s, ...n }) }), e[6] = n, e[7] = s, e[8] = l) : l = e[8], l;
}
const jv = {
  default: "border-outline-subtle",
  high: "border-outline opacity-60"
}, Kv = {
  horizontal: {
    "full-width": "",
    inset: "pl-(--spacing-16)",
    "middle-inset": "px-(--spacing-16)"
  },
  vertical: {
    "full-width": "",
    inset: "pt-(--spacing-16)",
    "middle-inset": "py-(--spacing-16)"
  }
}, O1 = ce(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap"]);
function gr(t) {
  const e = z.c(52);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    orientation: i,
    variant: s,
    subheader: r,
    centeredText: n,
    emphasis: l,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "horizontal" : i, c = s === void 0 ? "full-width" : s, u = l === void 0 ? "default" : l, d = a === "vertical", f = jv[u], p = d ? "border-l" : "border-t", g = Kv[a][c];
  if (!d && n) {
    let w;
    e[7] !== f || e[8] !== p ? (w = ne("grow", p, f), e[7] = f, e[8] = p, e[9] = w) : w = e[9];
    let R;
    e[10] !== w ? (R = /* @__PURE__ */ m("hr", { "aria-orientation": "horizontal", className: w }), e[10] = w, e[11] = R) : R = e[11];
    let S;
    e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = ne(O1(), "shrink-0", "text-(length:--font-size-body-small)"), e[12] = S) : S = e[12];
    let E;
    e[13] !== n || e[14] !== S ? (E = /* @__PURE__ */ m("span", { className: S, children: n }), e[13] = n, e[14] = S, e[15] = E) : E = e[15];
    let N;
    e[16] !== f || e[17] !== p ? (N = ne("grow", p, f), e[16] = f, e[17] = p, e[18] = N) : N = e[18];
    let T;
    e[19] !== N ? (T = /* @__PURE__ */ m("hr", { "aria-orientation": "horizontal", className: N }), e[19] = N, e[20] = T) : T = e[20];
    let P;
    return e[21] !== o || e[22] !== R || e[23] !== E || e[24] !== T ? (P = /* @__PURE__ */ F("div", { ...o, className: "flex items-center gap-(--spacing-6)", children: [
      R,
      E,
      T
    ] }), e[21] = o, e[22] = R, e[23] = E, e[24] = T, e[25] = P) : P = e[25], P;
  }
  if (!d && r) {
    let w;
    e[26] !== f || e[27] !== p ? (w = ne("w-full", p, f), e[26] = f, e[27] = p, e[28] = w) : w = e[28];
    let R;
    e[29] !== w ? (R = /* @__PURE__ */ m("hr", { "aria-orientation": "horizontal", className: w }), e[29] = w, e[30] = R) : R = e[30];
    let S;
    e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (S = ne(O1(), "shrink-0", "text-(length:--font-size-body-medium)"), e[31] = S) : S = e[31];
    let E;
    e[32] !== r || e[33] !== S ? (E = /* @__PURE__ */ m("span", { className: S, children: r }), e[32] = r, e[33] = S, e[34] = E) : E = e[34];
    let N;
    return e[35] !== o || e[36] !== R || e[37] !== E ? (N = /* @__PURE__ */ F("div", { ...o, className: "flex flex-col gap-(--spacing-4) px-(--spacing-16)", children: [
      R,
      E
    ] }), e[35] = o, e[36] = R, e[37] = E, e[38] = N) : N = e[38], N;
  }
  const h = d ? "flex-col" : "flex-row";
  let b;
  e[39] !== g || e[40] !== h ? (b = ne("flex", h, g), e[39] = g, e[40] = h, e[41] = b) : b = e[41];
  let v;
  e[42] !== f || e[43] !== p ? (v = ne("grow", p, f), e[42] = f, e[43] = p, e[44] = v) : v = e[44];
  let C;
  e[45] !== a || e[46] !== v ? (C = /* @__PURE__ */ m("hr", { "aria-orientation": a, className: v }), e[45] = a, e[46] = v, e[47] = C) : C = e[47];
  let y;
  return e[48] !== o || e[49] !== b || e[50] !== C ? (y = /* @__PURE__ */ m("div", { ...o, className: b, children: C }), e[48] = o, e[49] = b, e[50] = C, e[51] = y) : y = e[51], y;
}
function qv(t) {
  const e = z.c(7);
  let n, o, r, i, s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (n = /* @__PURE__ */ m("path", { d: "M17.3918 80.2045L20.2608 86.5396H24.3507L14.0566 64.5386H10.2275L0 86.5396H3.86238L6.73141 80.2045H17.3918ZM16.1043 77.3364H7.98557L12.0089 68.333L16.0988 77.3364H16.1043ZM41.9423 75.356C41.5483 71.5949 39.0733 69.8474 34.2564 69.8474C29.4395 69.8474 26.5982 71.728 26.5982 74.8623C26.5982 76.5764 27.586 78.0299 29.1731 78.6567C30.2608 79.0839 31.0877 79.2836 34.2231 79.7773C36.4872 80.1286 37.8283 80.3931 38.2464 80.5706C38.8735 80.8369 39.2342 81.3971 39.2342 82.0573C39.2342 83.5773 37.5194 84.4316 34.4173 84.4316C31.3152 84.4316 29.434 83.3443 29.2009 81.264H25.8657C26.4928 85.2249 29.101 86.9723 34.3785 86.9723C39.6559 86.9723 42.5305 85.125 42.5305 81.7244C42.5305 80.271 41.97 79.1172 40.9489 78.3627C39.9945 77.6693 39.4007 77.5362 34.9778 76.8427C32.2697 76.4156 31.6759 76.3157 31.0155 76.0494C30.2886 75.7832 29.7947 75.1896 29.7947 74.5627C29.7947 73.2425 31.5094 72.3882 34.0844 72.3882C37.02 72.3882 38.4406 73.309 38.7014 75.356H41.9367H41.9423ZM61.5039 75.356C61.1099 71.5949 58.6349 69.8474 53.8124 69.8474C48.99 69.8474 46.1543 71.728 46.1543 74.8623C46.1543 76.5764 47.1421 78.0299 48.7292 78.6567C49.8169 79.0839 50.6437 79.2836 53.7791 79.7773C56.0433 80.1286 57.3844 80.3931 57.8024 80.5706C58.4295 80.8369 58.7902 81.3971 58.7902 82.0573C58.7902 83.5773 57.0755 84.4316 53.9734 84.4316C50.8713 84.4316 48.99 83.3443 48.7569 81.264H45.4218C46.0488 85.2249 48.6571 86.9723 53.9345 86.9723C59.212 86.9723 62.0866 85.125 62.0866 81.7244C62.0866 80.271 61.5261 79.1172 60.505 78.3627C59.5505 77.6693 58.9567 77.5362 54.5339 76.8427C51.8257 76.4156 51.232 76.3157 50.5716 76.0494C49.8446 75.7832 49.3507 75.1896 49.3507 74.5627C49.3507 73.2425 51.0655 72.3882 53.6404 72.3882C56.576 72.3882 57.9967 73.309 58.2575 75.356H61.4928H61.5039ZM83.1521 79.3502C83.1521 77.3364 82.919 76.0827 82.3585 74.7014C81.1043 71.667 77.9689 69.853 74.0732 69.853C68.6959 69.853 64.9667 73.3811 64.9667 78.4959C64.9667 83.6106 68.596 86.9723 74.0067 86.9723C78.3296 86.9723 81.232 85.1583 82.8524 81.4637H79.3896C78.5627 83.4441 76.8479 84.4316 74.3063 84.4316C70.7769 84.4316 68.4018 82.4844 68.0688 79.3502H83.1465H83.1521ZM68.1687 76.8427C68.929 73.9747 71.0377 72.3549 74.0455 72.3549C77.0533 72.3549 79.162 73.9692 79.8835 76.8427H68.1687ZM90.9822 65.759H87.7802V70.2801H85.6659V72.9207H87.7802V82.3901C87.7802 84.4704 87.9467 85.1916 88.6071 85.8184C89.3008 86.5119 90.5549 86.8724 92.1698 86.8724C92.9634 86.8724 93.5572 86.8059 94.778 86.6394V83.9656C94.0178 84.0987 93.6903 84.132 93.03 84.132C91.3818 84.132 90.9822 83.7714 90.9822 82.2847V72.9152H94.778V70.2746H90.9822V65.7535V65.759ZM123.069 86.5396L130.494 64.5386H127.031L121.226 82.6841L115.022 64.5386H111.193L105.022 82.6841L99.3785 64.5386H95.5494L102.941 86.5396H106.87L113.041 68.2664L119.345 86.5396H123.074H123.069ZM135.305 75.6556C135.538 73.248 136.92 72.3549 140.422 72.3549C143.391 72.3549 144.811 73.1482 144.811 74.8956C144.811 75.7221 144.417 76.2159 143.524 76.5099C142.697 76.7762 142.203 76.8427 139.301 77.1367C135.905 77.4973 135.178 77.6637 133.99 78.1907C132.469 78.8842 131.515 80.3986 131.515 82.1516C131.515 85.1527 133.923 87 137.852 87C140.788 87 142.836 86.2067 144.817 84.3262C145.444 86.1402 146.371 86.767 148.38 86.767C149.073 86.767 149.467 86.7005 150.061 86.5008V84.3262C149.795 84.3595 149.534 84.3928 149.334 84.3928C148.246 84.426 147.847 83.8657 147.847 82.2792V75.0565C147.847 73.076 147.386 71.9555 146.265 71.1955C144.911 70.269 142.963 69.8419 140.294 69.8419C136.926 69.8419 134.551 70.7017 133.23 72.3826C132.569 73.2092 132.275 74.0635 132.109 75.65H135.311L135.305 75.6556ZM144.806 79.744C144.806 81.2917 144.573 81.9186 143.651 82.8117C142.497 83.899 140.877 84.4593 138.735 84.4593C136.127 84.4593 134.806 83.5995 134.806 81.9519C134.806 80.4652 135.699 79.9049 138.568 79.6109C141.143 79.3446 143.024 78.984 144.806 78.4237V79.744ZM156.748 65.759H153.546V70.2801H151.432V72.9207H153.546V82.3901C153.546 84.4704 153.713 85.1916 154.373 85.8184C155.067 86.5119 156.321 86.8724 157.936 86.8724C158.729 86.8724 159.323 86.8059 160.544 86.6394V83.9656C159.784 84.0987 159.456 84.132 158.796 84.132C157.148 84.132 156.748 83.7714 156.748 82.2847V72.9152H160.544V70.2746H156.748V65.7535V65.759ZM176.759 80.6372C175.999 83.1779 174.351 84.4316 171.709 84.4316C168.08 84.4316 165.871 82.1571 165.871 78.3627C165.871 74.5683 168.019 72.3604 171.681 72.3604C174.223 72.3604 175.938 73.481 176.665 75.6278H179.767C178.94 71.9998 175.938 69.853 171.615 69.853C166.104 69.853 162.669 73.1537 162.669 78.4959C162.669 83.838 166.038 86.9723 171.615 86.9723C176.038 86.9723 179.04 84.6979 179.895 80.6372H176.759ZM183.862 86.5396H187.064V77.0702C187.064 74.596 189.639 72.549 192.775 72.549C193.962 72.549 194.95 72.8486 195.677 73.4422C196.537 74.1356 196.798 74.7957 196.798 76.41V86.5396H200V76.1826C200 73.775 199.573 72.5213 198.452 71.5339C197.231 70.4466 195.45 69.853 193.402 69.853C190.76 69.853 189.145 70.5464 187.064 72.5879V64.5386H183.862V86.5396Z" }), o = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M66.5202 30.3223L58.0352 45.2171H69.2338C71.0429 45.2171 72.8243 44.7344 74.3892 43.8247C75.9541 42.9149 77.2527 41.6001 78.1406 40.0247L83.6345 30.3223H66.5091H66.5202Z" }), r = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M78.0688 20.1038L89.3841 40.0356C90.2775 41.6111 91.5705 42.9203 93.1354 43.8301C94.7004 44.7398 96.4762 45.2225 98.2908 45.2169H109.501L83.757 0L78.0744 9.97979C77.1976 11.522 76.7314 13.2639 76.7314 15.039C76.7314 16.8142 77.192 18.5561 78.0688 20.0983V20.1038Z" }), i = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M109.5 0L103.818 9.97979C102.941 11.522 102.48 13.2639 102.48 15.039C102.48 16.8142 102.941 18.5561 103.818 20.0983L115.139 40.0301C116.032 41.6056 117.325 42.9092 118.89 43.8245C120.455 44.7343 122.231 45.2169 124.04 45.2169H135.25L109.5 0Z" }), s = /* @__PURE__ */ m("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M135.245 0L129.562 9.97979C128.685 11.522 128.225 13.2694 128.225 15.039C128.225 16.8086 128.685 18.5561 129.562 20.0983L135.245 30.078L143.807 15.0335L135.245 0Z" }), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s) : (n = e[0], o = e[1], r = e[2], i = e[3], s = e[4]);
  let l;
  return e[5] !== t ? (l = /* @__PURE__ */ F("svg", { width: "200", height: "87", viewBox: "0 0 200 87", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    n,
    o,
    r,
    i,
    s
  ] }), e[5] = t, e[6] = l) : l = e[6], l;
}
const D1 = {
  default: "fill-surface-inverse-surface",
  primary: "fill-primary"
}, Zv = {
  default: {
    width: 44,
    height: 23.21
  },
  compact: {
    width: 24.16,
    height: 12.74
  },
  display: {
    width: 90,
    height: 47.47
  },
  stacked: {
    width: 200,
    height: 87
  }
};
function Xv(t) {
  const e = z.c(29);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    size: s,
    style: i,
    tone: l,
    "aria-label": o,
    "aria-hidden": n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "default" : s, c = !o, u = Zv[a], d = l ?? "primary";
  if (a === "stacked") {
    const C = D1[d], y = n ?? (c ? !0 : void 0), w = c ? void 0 : "img";
    let R;
    e[7] !== i ? (R = {
      flexShrink: 0,
      ...i
    }, e[7] = i, e[8] = R) : R = e[8];
    let S;
    return e[9] !== o || e[10] !== r || e[11] !== C || e[12] !== y || e[13] !== w || e[14] !== R ? (S = /* @__PURE__ */ m(qv, { ...r, className: C, "aria-hidden": y, "aria-label": o, role: w, style: R }), e[9] = o, e[10] = r, e[11] = C, e[12] = y, e[13] = w, e[14] = R, e[15] = S) : S = e[15], S;
  }
  const f = n ?? (c ? !0 : void 0), p = c ? void 0 : "img";
  let g;
  e[16] !== i ? (g = {
    flexShrink: 0,
    ...i
  }, e[16] = i, e[17] = g) : g = e[17];
  const h = D1[d];
  let b;
  e[18] !== h ? (b = /* @__PURE__ */ m("path", { d: "M10.3174 20.54C9.85932 21.349 9.19472 22.0221 8.3916 22.4902C7.58855 22.9583 6.67561 23.2051 5.74609 23.2051H0L4.35254 15.5615H13.1367L10.3174 20.54ZM26.4014 23.2051H20.6514C19.7228 23.2052 18.8103 22.9593 18.0078 22.4922C17.2054 22.0251 16.5415 21.3532 16.083 20.5459L10.2764 10.3164C9.8266 9.52465 9.59036 8.62933 9.59082 7.71875C9.59128 6.80816 9.82872 5.91337 10.2793 5.12207L13.1934 0L26.4014 23.2051ZM39.6104 23.2021H33.8613C32.9331 23.2021 32.021 22.9562 31.2188 22.4893C30.4164 22.0221 29.7514 21.3504 29.293 20.543L23.4863 10.3135C23.0366 9.52227 22.7998 8.62785 22.7998 7.71777C22.7998 6.8077 23.0366 5.91328 23.4863 5.12207L26.4014 0L39.6104 23.2021ZM44 7.71973L39.6084 15.4395L36.6934 10.3174C36.243 9.52576 36.0068 8.63047 36.0068 7.71973C36.0068 6.80898 36.243 5.91369 36.6934 5.12207L39.6084 0L44 7.71973Z", className: h }), e[18] = h, e[19] = b) : b = e[19];
  let v;
  return e[20] !== o || e[21] !== u.height || e[22] !== u.width || e[23] !== r || e[24] !== f || e[25] !== p || e[26] !== g || e[27] !== b ? (v = /* @__PURE__ */ m("svg", { ...r, width: u.width, height: u.height, viewBox: "0 0 44 23.21", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": f, "aria-label": o, role: p, style: g, children: b }), e[20] = o, e[21] = u.height, e[22] = u.width, e[23] = r, e[24] = f, e[25] = p, e[26] = g, e[27] = b, e[28] = v) : v = e[28], v;
}
const Lu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Lu.displayName = "MenuPositionerContext");
function rs(t) {
  const e = x.useContext(Lu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuPositionerContext is missing. MenuPositioner parts must be placed within <Menu.Positioner>." : rt(33));
  return e;
}
const Fu = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fu.displayName = "MenuRootContext");
function Jn(t) {
  const e = x.useContext(Fu);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRootContext is missing. Menu parts must be placed within <Menu.Root>." : rt(36));
  return e;
}
let un = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = qn.startingStyle] = "startingStyle", t[t.endingStyle = qn.endingStyle] = "endingStyle", t.anchorHidden = "data-anchor-hidden", t.side = "data-side", t.align = "data-align", t;
})({}), Tl = /* @__PURE__ */ (function(t) {
  return t.popupOpen = "data-popup-open", t.pressed = "data-pressed", t;
})({});
const Qv = {
  [Tl.popupOpen]: ""
}, Jv = {
  [Tl.popupOpen]: "",
  [Tl.pressed]: ""
}, e8 = {
  [un.open]: ""
}, t8 = {
  [un.closed]: ""
}, n8 = {
  [un.anchorHidden]: ""
}, br = {
  open(t) {
    return t ? Qv : null;
  }
}, Ui = {
  open(t) {
    return t ? Jv : null;
  }
}, Nn = {
  open(t) {
    return t ? e8 : t8;
  },
  anchorHidden(t) {
    return t ? n8 : null;
  }
}, Fm = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Fm.displayName = "ContextMenuRootContext");
function oa(t = !0) {
  const e = x.useContext(Fm);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ContextMenuRootContext is missing. ContextMenu parts must be placed within <ContextMenu.Root>." : rt(25));
  return e;
}
const Pt = "none", Zn = "trigger-press", Lt = "trigger-hover", dr = "trigger-focus", is = "outside-press", Wo = "item-press", $m = "close-press", V1 = "clear-press", o8 = "chip-remove-press", _r = "input-change", Ho = "input-clear", Hm = "input-press", Po = "focus-out", vr = "escape-key", r8 = "close-watcher", $r = "list-navigation", i8 = "pointer", zm = "cancel-open", Di = "sibling-open", s8 = "disabled", ss = "imperative-action", Us = "swipe", l8 = "window-resize";
function dn({
  controlled: t,
  default: e,
  name: n,
  state: o = "value"
}) {
  const {
    current: r
  } = x.useRef(t !== void 0), [i, s] = x.useState(e), l = r ? t : i;
  if (process.env.NODE_ENV !== "production") {
    x.useEffect(() => {
      r !== (t !== void 0) && jo([`A component is changing the ${r ? "" : "un"}controlled ${o} state of ${n} to be ${r ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [o, n, t]);
    const {
      current: c
    } = x.useRef(e);
    x.useEffect(() => {
      !r && _1(c) !== _1(e) && jo([`A component is changing the default ${o} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [e]);
  }
  const a = x.useCallback((c) => {
    r || s(c);
  }, []);
  return [l, a];
}
function _1(t) {
  let e = 0;
  const n = /* @__PURE__ */ new WeakMap();
  try {
    return JSON.stringify(t, function(i, s) {
      if (!(i === "_owner" && this != null && typeof this == "object" && "$$typeof" in this)) {
        if (typeof s == "bigint")
          return `__bigint__:${s}`;
        if (s !== null && typeof s == "object") {
          const l = n.get(s);
          if (l !== void 0)
            return `__object__:${l}`;
          n.set(s, e), e += 1;
        }
        return s;
      }
    }) ?? `__top__:${typeof t}`;
  } catch {
    return "__unserializable__";
  }
}
const Bm = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Bm.displayName = "MenuCheckboxItemContext");
const yr = typeof navigator < "u", Ya = a8(), Wm = u8(), $u = c8(), Hu = typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter:none"), zu = (
  // iPads can claim to be MacIntel
  Ya.platform === "MacIntel" && Ya.maxTouchPoints > 1 ? !0 : /iP(hone|ad|od)|iOS/.test(Ya.platform)
), A1 = yr && /firefox/i.test($u), Um = yr && /apple/i.test(navigator.vendor), Gi = yr && /android/i.test(Wm) || /android/i.test($u), Gm = yr && Wm.toLowerCase().startsWith("mac") && !navigator.maxTouchPoints, Ym = $u.includes("jsdom/");
function a8() {
  if (!yr)
    return {
      platform: "",
      maxTouchPoints: -1
    };
  const t = navigator.userAgentData;
  return t?.platform ? {
    platform: t.platform,
    maxTouchPoints: navigator.maxTouchPoints
  } : {
    platform: navigator.platform ?? "",
    maxTouchPoints: navigator.maxTouchPoints ?? -1
  };
}
function c8() {
  if (!yr)
    return "";
  const t = navigator.userAgentData;
  return t && Array.isArray(t.brands) ? t.brands.map(({
    brand: e,
    version: n
  }) => `${e}/${n}`).join(" ") : navigator.userAgent;
}
function u8() {
  if (!yr)
    return "";
  const t = navigator.userAgentData;
  return t?.platform ? t.platform : navigator.platform ?? "";
}
function d8(t) {
  const {
    closeOnClick: e,
    highlighted: n,
    id: o,
    nodeId: r,
    store: i,
    typingRef: s,
    itemRef: l,
    itemMetadata: a
  } = t, {
    events: c
  } = i.useState("floatingTreeRoot"), u = oa(!0), d = u !== void 0;
  return x.useMemo(() => ({
    id: o,
    role: "menuitem",
    tabIndex: n ? 0 : -1,
    onKeyDown(f) {
      f.key === " " && s?.current && f.preventDefault();
    },
    onMouseMove(f) {
      r && c.emit("itemhover", {
        nodeId: r,
        target: f.currentTarget
      });
    },
    onClick(f) {
      e && c.emit("close", {
        domEvent: f,
        reason: Wo
      });
    },
    onMouseUp(f) {
      if (u) {
        const p = u.initialCursorPointRef.current;
        if (u.initialCursorPointRef.current = null, d && p && Math.abs(f.clientX - p.x) <= 1 && Math.abs(f.clientY - p.y) <= 1 || d && !Gm && f.button === 2)
          return;
      }
      l.current && i.context.allowMouseUpTriggerRef.current && (!d || f.button === 2) && (!a || a.type === "regular-item") && l.current.click();
    }
  }), [e, n, o, c, r, i, s, l, u, d, a]);
}
const Bu = {
  type: "regular-item"
};
function ra(t) {
  const {
    closeOnClick: e,
    disabled: n = !1,
    highlighted: o,
    id: r,
    store: i,
    typingRef: s = i.context.typingRef,
    nativeButton: l,
    itemMetadata: a,
    nodeId: c
  } = t, u = x.useRef(null), {
    getButtonProps: d,
    buttonRef: f
  } = Wt({
    disabled: n,
    focusableWhenDisabled: !0,
    native: l,
    composite: !0
  }), p = d8({
    closeOnClick: e,
    highlighted: o,
    id: r,
    nodeId: c,
    store: i,
    typingRef: s,
    itemRef: u,
    itemMetadata: a
  }), g = x.useCallback((b) => en(p, {
    onMouseEnter() {
      a.type === "submenu-trigger" && a.setActive();
    }
  }, b, d), [p, d, a]), h = fn(u, f);
  return x.useMemo(() => ({
    getItemProps: g,
    itemRef: h
  }), [g, h]);
}
const Wu = /* @__PURE__ */ x.createContext({
  register: () => {
  },
  unregister: () => {
  },
  subscribeMapChange: () => () => {
  },
  elementsRef: {
    current: []
  },
  nextIndexRef: {
    current: 0
  }
});
process.env.NODE_ENV !== "production" && (Wu.displayName = "CompositeListContext");
function f8() {
  return x.useContext(Wu);
}
let Uu = /* @__PURE__ */ (function(t) {
  return t[t.None = 0] = "None", t[t.GuessFromOrder = 1] = "GuessFromOrder", t;
})({});
function Oo(t = {}) {
  const {
    label: e,
    metadata: n,
    textRef: o,
    indexGuessBehavior: r,
    index: i
  } = t, {
    register: s,
    unregister: l,
    subscribeMapChange: a,
    elementsRef: c,
    labelsRef: u,
    nextIndexRef: d
  } = f8(), f = x.useRef(-1), [p, g] = x.useState(i ?? (r === Uu.GuessFromOrder ? () => {
    if (f.current === -1) {
      const v = d.current;
      d.current += 1, f.current = v;
    }
    return f.current;
  } : -1)), h = x.useRef(null), b = x.useCallback((v) => {
    if (h.current = v, p !== -1 && v !== null && (c.current[p] = v, u)) {
      const C = e !== void 0;
      u.current[p] = C ? e : o?.current?.textContent ?? v.textContent;
    }
  }, [p, c, u, e, o]);
  return ke(() => {
    if (i != null)
      return;
    const v = h.current;
    if (v)
      return s(v, n), () => {
        l(v);
      };
  }, [i, s, l, n]), ke(() => {
    if (i == null)
      return a((v) => {
        const C = h.current ? v.get(h.current)?.index : null;
        C != null && g(C);
      });
  }, [i, a, g]), x.useMemo(() => ({
    ref: b,
    index: p
  }), [p, b]);
}
let L1 = 0;
function p8(t, e = "mui") {
  const [n, o] = x.useState(t), r = t || n;
  return x.useEffect(() => {
    n == null && (L1 += 1, o(`${e}-${L1}`));
  }, [n, e]), r;
}
const F1 = pr.useId;
function Do(t, e) {
  if (F1 !== void 0) {
    const n = F1();
    return t ?? (e ? `${e}-${n}` : n);
  }
  return p8(t, e);
}
function Mt(t) {
  return Do(t, "base-ui");
}
let $1 = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.highlighted = "data-highlighted", t;
})({});
const Gu = {
  checked(t) {
    return t ? {
      [$1.checked]: ""
    } : {
      [$1.unchecked]: ""
    };
  },
  ...Bt
};
function Ve(t, e, n, o) {
  let r = !1, i = !1;
  const s = o ?? St;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    cancel() {
      r = !0;
    },
    allowPropagation() {
      i = !0;
    },
    get isCanceled() {
      return r;
    },
    get isPropagationAllowed() {
      return i;
    },
    trigger: n,
    ...s
  };
}
function Ri(t, e, n) {
  const o = n ?? St;
  return {
    reason: t,
    event: e ?? new Event("base-ui"),
    ...o
  };
}
const jm = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    checked: u,
    defaultChecked: d,
    onCheckedChange: f,
    style: p,
    ...g
  } = e, h = Oo({
    label: s
  }), b = rs(!0), v = Mt(i), {
    store: C
  } = Jn(), y = C.useState("isActive", h.index), w = C.useState("itemProps"), [R, S] = dn({
    controlled: u,
    default: d ?? !1,
    name: "MenuCheckboxItem",
    state: "checked"
  }), {
    getItemProps: E,
    itemRef: N
  } = ra({
    closeOnClick: c,
    disabled: a,
    highlighted: y,
    id: v,
    store: C,
    nativeButton: l,
    nodeId: b?.context.nodeId,
    itemMetadata: Bu
  }), T = x.useMemo(() => ({
    disabled: a,
    highlighted: y,
    checked: R
  }), [a, y, R]), P = Se((k) => {
    const M = {
      ...Ve(Wo, k.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    f?.(!R, M), !M.isCanceled && S((D) => !D);
  }), I = $e("div", e, {
    state: T,
    stateAttributesMapping: Gu,
    props: [w, {
      role: "menuitemcheckbox",
      "aria-checked": R,
      onClick: P
    }, g, E],
    ref: [N, n, h.ref]
  });
  return /* @__PURE__ */ m(Bm.Provider, {
    value: T,
    children: I
  });
});
process.env.NODE_ENV !== "production" && (jm.displayName = "MenuCheckboxItem");
const Km = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !0,
    style: u,
    ...d
  } = e, f = Oo({
    label: s
  }), p = rs(!0), g = Mt(i), {
    store: h
  } = Jn(), b = h.useState("isActive", f.index), v = h.useState("itemProps"), {
    getItemProps: C,
    itemRef: y
  } = ra({
    closeOnClick: c,
    disabled: a,
    highlighted: b,
    id: g,
    store: h,
    nativeButton: l,
    nodeId: p?.context.nodeId,
    itemMetadata: Bu
  });
  return $e("div", e, {
    state: {
      disabled: a,
      highlighted: b
    },
    props: [v, d, C],
    ref: [y, n, f.ref]
  });
});
process.env.NODE_ENV !== "production" && (Km.displayName = "MenuItem");
function Ft(t) {
  t.preventDefault(), t.stopPropagation();
}
function g8(t) {
  return "nativeEvent" in t;
}
function qm(t) {
  return t.pointerType === "" && t.isTrusted ? !0 : Gi && t.pointerType ? t.type === "click" && t.buttons === 1 : t.detail === 0 && !t.pointerType;
}
function Zm(t) {
  return Ym ? !1 : !Gi && t.width === 0 && t.height === 0 || Gi && t.width === 1 && t.height === 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  t.width < 1 && t.height < 1 && t.pressure === 0 && t.detail === 0 && t.pointerType === "touch";
}
function jr(t, e) {
  const n = ["mouse", "pen"];
  return e || n.push("", void 0), n.includes(t);
}
function Xm(t) {
  const e = t.type;
  return e === "click" || e === "mousedown" || e === "keydown" || e === "keyup";
}
function m8(t, e) {
  return e != null && !jr(e) ? 0 : typeof t == "function" ? t() : t;
}
function Ol(t, e, n) {
  const o = m8(t, n);
  return typeof o == "number" ? o : o?.[e];
}
function H1(t) {
  return typeof t == "function" ? t() : t;
}
function Qm(t, e) {
  return e || t === "click" || t === "mousedown";
}
const Yu = /* @__PURE__ */ x.createContext({
  hasProvider: !1,
  timeoutMs: 0,
  delayRef: {
    current: 0
  },
  initialDelayRef: {
    current: 0
  },
  timeout: new xn(),
  currentIdRef: {
    current: null
  },
  currentContextRef: {
    current: null
  }
});
process.env.NODE_ENV !== "production" && (Yu.displayName = "FloatingDelayGroupContext");
function h8(t) {
  const {
    children: e,
    delay: n,
    timeoutMs: o = 0
  } = t, r = x.useRef(n), i = x.useRef(n), s = x.useRef(null), l = x.useRef(null), a = Vt();
  return /* @__PURE__ */ m(Yu.Provider, {
    value: x.useMemo(() => ({
      hasProvider: !0,
      delayRef: r,
      initialDelayRef: i,
      currentIdRef: s,
      timeoutMs: o,
      currentContextRef: l,
      timeout: a
    }), [o, a]),
    children: e
  });
}
function b8(t, e = {
  open: !1
}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("floatingId"), {
    open: r
  } = e, i = x.useContext(Yu), {
    currentIdRef: s,
    delayRef: l,
    timeoutMs: a,
    initialDelayRef: c,
    currentContextRef: u,
    hasProvider: d,
    timeout: f
  } = i, [p, g] = x.useState(!1);
  return ke(() => {
    function h() {
      g(!1), u.current?.setIsInstantPhase(!1), s.current = null, u.current = null, l.current = c.current;
    }
    if (s.current && !r && s.current === o) {
      if (g(!1), a) {
        const b = o;
        return f.start(a, () => {
          n.select("open") || s.current && s.current !== b || h();
        }), () => {
          f.clear();
        };
      }
      h();
    }
  }, [r, o, s, l, a, c, u, f, n]), ke(() => {
    if (!r)
      return;
    const h = u.current, b = s.current;
    f.clear(), u.current = {
      onOpenChange: n.setOpen,
      setIsInstantPhase: g
    }, s.current = o, l.current = {
      open: 0,
      close: Ol(c.current, "close")
    }, b !== null && b !== o ? (g(!0), h?.setIsInstantPhase(!0), h?.onOpenChange(!1, Ve(Pt))) : (g(!1), h?.setIsInstantPhase(!1));
  }, [r, o, n, s, l, a, c, u, f]), ke(() => () => {
    u.current = null;
  }, [u]), x.useMemo(() => ({
    hasProvider: d,
    delayRef: l,
    isInstantPhase: p
  }), [d, l, p]);
}
function ut(t, e, n, o) {
  return t.addEventListener(e, n, o), () => {
    t.removeEventListener(e, n, o);
  };
}
function Yn(...t) {
  return () => {
    for (let e = 0; e < t.length; e += 1) {
      const n = t[e];
      n && n();
    }
  };
}
function $t(t) {
  const e = Tt(v8, t).current;
  return e.next = t, ke(e.effect), e;
}
function v8(t) {
  const e = {
    current: t,
    next: t,
    effect: () => {
      e.current = e.next;
    }
  };
  return e;
}
function et(t) {
  return t?.ownerDocument || document;
}
const Jm = {
  clipPath: "inset(50%)",
  overflow: "hidden",
  whiteSpace: "nowrap",
  border: 0,
  padding: 0,
  width: 1,
  height: 1,
  margin: -1
}, Jo = {
  ...Jm,
  position: "fixed",
  top: 0,
  left: 0
}, ti = {
  ...Jm,
  position: "absolute"
}, Vn = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const [o, r] = x.useState();
  return ke(() => {
    Um && r("button");
  }, []), /* @__PURE__ */ m("span", {
    ...e,
    ref: n,
    style: Jo,
    "aria-hidden": o ? void 0 : !0,
    ...{
      tabIndex: 0,
      // Role is only for VoiceOver
      role: o
    },
    "data-base-ui-focus-guard": ""
  });
});
process.env.NODE_ENV !== "production" && (Vn.displayName = "FocusGuard");
const Qc = "data-base-ui-focusable", eh = "active", th = "selected", nh = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])", Uo = "ArrowLeft", Go = "ArrowRight", ju = "ArrowUp", ls = "ArrowDown";
function Gt(t) {
  let e = t.activeElement;
  for (; e?.shadowRoot?.activeElement != null; )
    e = e.shadowRoot.activeElement;
  return e;
}
function ze(t, e) {
  if (!t || !e)
    return !1;
  const n = e.getRootNode?.();
  if (t.contains(e))
    return !0;
  if (n && Yr(n)) {
    let o = e;
    for (; o; ) {
      if (t === o)
        return !0;
      o = o.parentNode || o.host;
    }
  }
  return !1;
}
function bt(t) {
  return "composedPath" in t ? t.composedPath()[0] : t.target;
}
function Dl(t, e) {
  if (!pt(t))
    return !1;
  const n = t;
  if (e.hasElement(n))
    return !n.hasAttribute("data-trigger-disabled");
  for (const [, o] of e.entries())
    if (ze(o, n))
      return !o.hasAttribute("data-trigger-disabled");
  return !1;
}
function zn(t, e) {
  if (e == null)
    return !1;
  if ("composedPath" in t)
    return t.composedPath().includes(e);
  const n = t;
  return n.target != null && e.contains(n.target);
}
function y8(t) {
  return t.matches("html,body");
}
function ia(t) {
  return Ct(t) && t.matches(nh);
}
function oh(t) {
  return t?.closest(`button,a[href],[role="button"],select,[tabindex]:not([tabindex="-1"]),${nh}`) != null;
}
function Jc(t) {
  return t ? t.getAttribute("role") === "combobox" && ia(t) : !1;
}
function Vl(t) {
  if (!t || Ym)
    return !0;
  try {
    return t.matches(":focus-visible");
  } catch {
    return !0;
  }
}
function Yi(t) {
  return t ? t.hasAttribute(Qc) ? t : t.querySelector(`[${Qc}]`) || t : null;
}
const x8 = ["top", "right", "bottom", "left"], Kr = Math.min, Sn = Math.max, _l = Math.round, ar = Math.floor, co = (t) => ({
  x: t,
  y: t
}), C8 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function eu(t, e, n) {
  return Sn(t, Kr(e, n));
}
function To(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function yn(t) {
  return t.split("-")[0];
}
function er(t) {
  return t.split("-")[1];
}
function Ku(t) {
  return t === "x" ? "y" : "x";
}
function qu(t) {
  return t === "y" ? "height" : "width";
}
function Dn(t) {
  const e = t[0];
  return e === "t" || e === "b" ? "y" : "x";
}
function Zu(t) {
  return Ku(Dn(t));
}
function w8(t, e, n) {
  n === void 0 && (n = !1);
  const o = er(t), r = Zu(t), i = qu(r);
  let s = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[i] > e.floating[i] && (s = Al(s)), [s, Al(s)];
}
function S8(t) {
  const e = Al(t);
  return [tu(t), e, tu(e)];
}
function tu(t) {
  return t.includes("start") ? t.replace("start", "end") : t.replace("end", "start");
}
const z1 = ["left", "right"], B1 = ["right", "left"], R8 = ["top", "bottom"], E8 = ["bottom", "top"];
function N8(t, e, n) {
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? B1 : z1 : e ? z1 : B1;
    case "left":
    case "right":
      return e ? R8 : E8;
    default:
      return [];
  }
}
function k8(t, e, n, o) {
  const r = er(t);
  let i = N8(yn(t), n === "start", o);
  return r && (i = i.map((s) => s + "-" + r), e && (i = i.concat(i.map(tu)))), i;
}
function Al(t) {
  const e = yn(t);
  return C8[e] + t.slice(e.length);
}
function M8(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function rh(t) {
  return typeof t != "number" ? M8(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ji(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function Gs(t, e, n) {
  return Math.floor(t / e) !== n;
}
function Ki(t, e) {
  return e < 0 || e >= t.length;
}
function vl(t, e) {
  return rn(t.current, {
    disabledIndices: e
  });
}
function nu(t, e) {
  return rn(t.current, {
    decrement: !0,
    startingIndex: t.current.length,
    disabledIndices: e
  });
}
function rn(t, {
  startingIndex: e = -1,
  decrement: n = !1,
  disabledIndices: o,
  amount: r = 1
} = {}) {
  let i = e;
  do
    i += n ? -r : r;
  while (i >= 0 && i <= t.length - 1 && No(t, i, o));
  return i;
}
function ih(t, {
  event: e,
  orientation: n,
  loopFocus: o,
  onLoop: r,
  rtl: i,
  cols: s,
  disabledIndices: l,
  minIndex: a,
  maxIndex: c,
  prevIndex: u,
  stopEvent: d = !1
}) {
  let f = u, p;
  if (e.key === ju ? p = "up" : e.key === ls && (p = "down"), p) {
    const g = [], h = [];
    let b = !1, v = 0;
    {
      let T = null, P = -1;
      t.forEach((I, k) => {
        if (I == null)
          return;
        v += 1;
        const M = I.closest('[role="row"]');
        M && (b = !0), (M !== T || P === -1) && (T = M, P += 1, g[P] = []), g[P].push(k), h[k] = P;
      });
    }
    let C = !1, y = 0;
    if (b)
      for (const T of g) {
        const P = T.length;
        P > y && (y = P), P !== s && (C = !0);
      }
    const w = C && v < t.length, R = y || s, S = (T) => {
      if (!C || u === -1)
        return;
      const P = h[u];
      if (P == null)
        return;
      const I = g[P].indexOf(u), k = T === "up" ? -1 : 1;
      for (let M = P + k, D = 0; D < g.length; D += 1, M += k) {
        if (M < 0 || M >= g.length) {
          if (!o || w)
            return;
          if (M = M < 0 ? g.length - 1 : 0, r) {
            const V = Math.min(I, g[M].length - 1), _ = g[M][V] ?? g[M][0], A = r(e, u, _);
            M = h[A] ?? M;
          }
        }
        const O = g[M];
        for (let V = Math.min(I, O.length - 1); V >= 0; V -= 1) {
          const _ = O[V];
          if (!No(t, _, l))
            return _;
        }
      }
    }, E = (T) => {
      if (!w || u === -1)
        return;
      const P = u % R, I = T === "up" ? -R : R, k = c - c % R, M = ar(c / R) + 1;
      for (let D = u - P + I, O = 0; O < M; O += 1, D += I) {
        if (D < 0 || D > c) {
          if (!o)
            return;
          D = D < 0 ? k : 0;
        }
        const V = Math.min(D + R - 1, c);
        for (let _ = Math.min(D + P, V); _ >= D; _ -= 1)
          if (!No(t, _, l))
            return _;
      }
    };
    d && Ft(e);
    const N = S(p) ?? E(p);
    if (N !== void 0)
      f = N;
    else if (u === -1)
      f = p === "up" ? c : a;
    else if (f = rn(t, {
      startingIndex: u,
      amount: R,
      decrement: p === "up",
      disabledIndices: l
    }), o) {
      if (p === "up" && (u - R < a || f < 0)) {
        const T = u % R, P = c % R, I = c - (P - T);
        P === T ? f = c : f = P > T ? I : I - R, r && (f = r(e, u, f));
      }
      p === "down" && u + R > c && (f = rn(t, {
        startingIndex: u % R - R,
        amount: R,
        disabledIndices: l
      }), r && (f = r(e, u, f)));
    }
    Ki(t, f) && (f = u);
  }
  if (n === "both") {
    const g = ar(u / s);
    e.key === (i ? Uo : Go) && (d && Ft(e), u % s !== s - 1 ? (f = rn(t, {
      startingIndex: u,
      disabledIndices: l
    }), o && Gs(f, s, g) && (f = rn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = rn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))), Gs(f, s, g) && (f = u)), e.key === (i ? Go : Uo) && (d && Ft(e), u % s !== 0 ? (f = rn(t, {
      startingIndex: u,
      decrement: !0,
      disabledIndices: l
    }), o && Gs(f, s, g) && (f = rn(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f)))) : o && (f = rn(t, {
      startingIndex: u + (s - u % s),
      decrement: !0,
      disabledIndices: l
    }), r && (f = r(e, u, f))), Gs(f, s, g) && (f = u));
    const h = ar(c / s) === g;
    Ki(t, f) && (o && h ? (f = e.key === (i ? Go : Uo) ? c : rn(t, {
      startingIndex: u - u % s - 1,
      disabledIndices: l
    }), r && (f = r(e, u, f))) : f = u);
  }
  return f;
}
function sh(t, e, n) {
  const o = [];
  let r = 0;
  return t.forEach(({
    width: i,
    height: s
  }, l) => {
    if (i > e && process.env.NODE_ENV !== "production")
      throw new Error(`[Floating UI]: Invalid grid - item width at index ${l} is greater than grid columns`);
    let a = !1;
    for (n && (r = 0); !a; ) {
      const c = [];
      for (let u = 0; u < i; u += 1)
        for (let d = 0; d < s; d += 1)
          c.push(r + u + d * e);
      r % e + i <= e && c.every((u) => o[u] == null) ? (c.forEach((u) => {
        o[u] = l;
      }), a = !0) : r += 1;
    }
  }), [...o];
}
function lh(t, e, n, o, r) {
  if (t === -1)
    return -1;
  const i = n.indexOf(t), s = e[t];
  switch (r) {
    case "tl":
      return i;
    case "tr":
      return s ? i + s.width - 1 : i;
    case "bl":
      return s ? i + (s.height - 1) * o : i;
    case "br":
      return n.lastIndexOf(t);
    default:
      return -1;
  }
}
function ah(t, e) {
  return e.flatMap((n, o) => t.includes(n) ? [o] : []);
}
function No(t, e, n) {
  if (typeof n == "function" ? n(e) : n?.includes(e) ?? !1)
    return !0;
  const r = t[e];
  return r ? sa(r) ? !n && (r.hasAttribute("disabled") || r.getAttribute("aria-disabled") === "true") : !0 : !1;
}
function I8(t) {
  return t.visibility === "hidden" || t.visibility === "collapse";
}
function sa(t, e = t ? pn(t) : null) {
  return !t || !t.isConnected || !e || I8(e) ? !1 : typeof t.checkVisibility == "function" ? t.checkVisibility() : e.display !== "none" && e.display !== "contents";
}
const P8 = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function T8(t) {
  const e = t.assignedSlot;
  if (e)
    return e;
  if (t.parentElement)
    return t.parentElement;
  const n = t.getRootNode();
  return Yr(n) ? n.host : null;
}
function ou(t) {
  for (const e of Array.from(t.children))
    if (cn(e) === "summary")
      return e;
  return null;
}
function O8(t, e) {
  const n = ou(e);
  return !!n && (t === n || ze(n, t));
}
function ch(t) {
  const e = t ? cn(t) : "";
  return t != null && t.matches(P8) && (e !== "summary" || t.parentElement != null && cn(t.parentElement) === "details" && ou(t.parentElement) === t) && (e !== "details" || ou(t) == null) && (e !== "input" || t.type !== "hidden");
}
function uh(t) {
  if (!ch(t) || !t.isConnected || t.matches(":disabled"))
    return !1;
  for (let e = t; e; e = T8(e)) {
    const n = e !== t, o = cn(e) === "slot";
    if (e.hasAttribute("inert") || n && cn(e) === "details" && !e.open && !O8(t, e) || e.hasAttribute("hidden") || !o && !D8(e, n))
      return !1;
  }
  return !0;
}
function D8(t, e) {
  const n = pn(t);
  return e ? n.display !== "none" : sa(t, n);
}
function dh(t) {
  const e = t.tabIndex;
  if (e < 0) {
    const n = cn(t);
    if (n === "details" || n === "audio" || n === "video" || Ct(t) && t.isContentEditable)
      return 0;
  }
  return e;
}
function ja(t) {
  if (cn(t) !== "input")
    return null;
  const e = t;
  return e.type === "radio" && e.name !== "" ? e : null;
}
function V8(t, e) {
  const n = ja(t);
  if (!n)
    return !0;
  const o = e.find((r) => {
    const i = ja(r);
    return i?.name === n.name && i.form === n.form && i.checked;
  });
  return o ? o === n : e.find((r) => {
    const i = ja(r);
    return i?.name === n.name && i.form === n.form;
  }) === n;
}
function fh(t) {
  if (Ct(t) && cn(t) === "slot") {
    const e = t.assignedElements({
      flatten: !0
    });
    if (e.length > 0)
      return e;
  }
  return Ct(t) && t.shadowRoot ? Array.from(t.shadowRoot.children) : Array.from(t.children);
}
function ph(t, e) {
  fh(t).forEach((n) => {
    ch(n) && e.push(n), ph(n, e);
  });
}
function gh(t, e, n) {
  fh(t).forEach((o) => {
    Ct(o) && o.matches(e) && n.push(o), gh(o, e, n);
  });
}
function Xu(t) {
  return uh(t) && dh(t) >= 0;
}
function mh(t) {
  const e = [];
  return ph(t, e), e.filter(uh);
}
function as(t) {
  const e = mh(t);
  return e.filter((n) => dh(n) >= 0 && V8(n, e));
}
function hh(t, e) {
  const n = as(t), o = n.length;
  if (o === 0)
    return;
  const r = Gt(et(t)), i = n.indexOf(r), s = i === -1 ? e === 1 ? 0 : o - 1 : i + e;
  return n[s];
}
function Qu(t) {
  return hh(et(t).body, 1) || t;
}
function bh(t) {
  return hh(et(t).body, -1) || t;
}
function vh(t, e) {
  if (!t)
    return null;
  const n = as(et(t).body), o = n.length;
  if (o === 0)
    return null;
  const r = n.indexOf(t);
  if (r === -1)
    return null;
  const i = (r + e + o) % o;
  return n[i];
}
function _8(t) {
  return vh(t, 1);
}
function A8(t) {
  return vh(t, -1);
}
function Hr(t, e) {
  const n = e || t.currentTarget, o = t.relatedTarget;
  return !o || !ze(n, o);
}
function L8(t) {
  as(t).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function W1(t) {
  const e = [];
  gh(t, "[data-tabindex]", e), e.forEach((n) => {
    const o = n.dataset.tabindex;
    delete n.dataset.tabindex, o ? n.setAttribute("tabindex", o) : n.removeAttribute("tabindex");
  });
}
function uo(t, e, n = !0) {
  return t.filter((r) => r.parentId === e).flatMap((r) => [...!n || r.context?.open ? [r] : [], ...uo(t, r.id, n)]);
}
function U1(t, e) {
  let n = [], o = t.find((r) => r.id === e)?.parentId;
  for (; o; ) {
    const r = t.find((i) => i.id === o);
    o = r?.parentId, r && (n = n.concat(r));
  }
  return n;
}
function qi(t) {
  return `data-base-ui-${t}`;
}
let Ys = 0;
function yl(t, e = {}) {
  const {
    preventScroll: n = !1,
    cancelPrevious: o = !0,
    sync: r = !1
  } = e;
  o && cancelAnimationFrame(Ys);
  const i = () => t?.focus({
    preventScroll: n
  });
  if (r)
    return i(), xt;
  const s = requestAnimationFrame(i);
  return Ys = s, () => {
    Ys === s && (cancelAnimationFrame(s), Ys = 0);
  };
}
const Ka = {
  inert: /* @__PURE__ */ new WeakMap(),
  "aria-hidden": /* @__PURE__ */ new WeakMap()
}, G1 = "data-base-ui-inert", ru = {
  inert: /* @__PURE__ */ new WeakSet(),
  "aria-hidden": /* @__PURE__ */ new WeakSet()
};
let Ei = /* @__PURE__ */ new WeakMap(), qa = 0;
function F8(t) {
  return ru[t];
}
function yh(t) {
  return t ? Yr(t) ? t.host : yh(t.parentNode) : null;
}
const Za = (t, e) => e.map((n) => {
  if (t.contains(n))
    return n;
  const o = yh(n);
  return t.contains(o) ? o : null;
}).filter((n) => n != null), Y1 = (t) => {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((n) => {
    let o = n;
    for (; o && !e.has(o); )
      e.add(o), o = o.parentNode;
  }), e;
}, j1 = (t, e, n) => {
  const o = [], r = (i) => {
    !i || n.has(i) || Array.from(i.children).forEach((s) => {
      cn(s) !== "script" && (e.has(s) ? r(s) : o.push(s));
    });
  };
  return r(t), o;
};
function $8(t, e, n, o, {
  mark: r = !0,
  markerIgnoreElements: i = []
}) {
  const s = o ? "inert" : n ? "aria-hidden" : null;
  let l = null, a = null;
  const c = Za(e, t), u = r ? Za(e, i) : [], d = new Set(u), f = r ? j1(e, Y1(c), new Set(c)).filter((h) => !d.has(h)) : [], p = [], g = [];
  if (s) {
    const h = Ka[s], b = F8(s);
    a = b, l = h;
    const v = Za(e, Array.from(e.querySelectorAll("[aria-live]"))), C = c.concat(v);
    j1(e, Y1(C), new Set(C)).forEach((w) => {
      const R = w.getAttribute(s), S = R !== null && R !== "false", E = (h.get(w) || 0) + 1;
      h.set(w, E), p.push(w), E === 1 && S && b.add(w), S || w.setAttribute(s, s === "inert" ? "" : "true");
    });
  }
  return r && f.forEach((h) => {
    const b = (Ei.get(h) || 0) + 1;
    Ei.set(h, b), g.push(h), b === 1 && h.setAttribute(G1, "");
  }), qa += 1, () => {
    l && p.forEach((h) => {
      const v = (l.get(h) || 0) - 1;
      l.set(h, v), v || (!a?.has(h) && s && h.removeAttribute(s), a?.delete(h));
    }), r && g.forEach((h) => {
      const b = (Ei.get(h) || 0) - 1;
      Ei.set(h, b), b || h.removeAttribute(G1);
    }), qa -= 1, qa || (Ka.inert = /* @__PURE__ */ new WeakMap(), Ka["aria-hidden"] = /* @__PURE__ */ new WeakMap(), ru.inert = /* @__PURE__ */ new WeakSet(), ru["aria-hidden"] = /* @__PURE__ */ new WeakSet(), Ei = /* @__PURE__ */ new WeakMap());
  };
}
function K1(t, e = {}) {
  const {
    ariaHidden: n = !1,
    inert: o = !1,
    mark: r = !0,
    markerIgnoreElements: i = []
  } = e, s = et(t[0]).body;
  return $8(t, s, n, o, {
    mark: r,
    markerIgnoreElements: i
  });
}
const H8 = 500, xh = 500, z8 = {
  style: {
    transition: "none"
  }
}, Ju = "data-base-ui-click-trigger", B8 = "data-base-ui-swipe-ignore", W8 = "data-swipe-ignore", Ch = `[${B8}]`, U8 = `[${W8}]`, ed = {
  fallbackAxisSide: "none"
}, la = {
  fallbackAxisSide: "end"
}, G8 = {
  clipPath: "inset(50%)",
  position: "fixed",
  top: 0,
  left: 0
}, td = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (td.displayName = "PortalContext");
const wh = () => x.useContext(td), Y8 = qi("portal");
function Sh(t = {}) {
  const {
    ref: e,
    container: n,
    componentProps: o = St,
    elementProps: r
  } = t, i = Do(), l = wh()?.portalNode, [a, c] = x.useState(null), [u, d] = x.useState(null), f = Se((b) => {
    b !== null && d(b);
  }), p = x.useRef(null);
  ke(() => {
    if (n === null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    if (i == null)
      return;
    const b = (n && (Pu(n) ? n : n.current)) ?? l ?? document.body;
    if (b == null) {
      p.current && (p.current = null, d(null), c(null));
      return;
    }
    p.current !== b && (p.current = b, d(null), c(b));
  }, [n, l, i]);
  const g = $e("div", o, {
    ref: [e, f],
    props: [{
      id: i,
      [Y8]: ""
    }, r]
  });
  return {
    portalNode: u,
    portalSubtree: a && g ? /* @__PURE__ */ an.createPortal(g, a) : null
  };
}
const ni = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    renderGuards: l,
    style: a,
    ...c
  } = e, {
    portalNode: u,
    portalSubtree: d
  } = Sh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: c
  }), f = x.useRef(null), p = x.useRef(null), g = x.useRef(null), h = x.useRef(null), [b, v] = x.useState(null), C = x.useRef(!1), y = b?.modal, w = b?.open, R = typeof l == "boolean" ? l : !!b && !b.modal && b.open && !!u;
  x.useEffect(() => {
    if (!u || y)
      return;
    function E(N) {
      u && N.relatedTarget && Hr(N) && (N.type === "focusin" ? C.current && (W1(u), C.current = !1) : (L8(u), C.current = !0));
    }
    return Yn(ut(u, "focusin", E, !0), ut(u, "focusout", E, !0));
  }, [u, y]), x.useEffect(() => {
    !u || w !== !1 || (W1(u), C.current = !1);
  }, [w, u]);
  const S = x.useMemo(() => ({
    beforeOutsideRef: f,
    afterOutsideRef: p,
    beforeInsideRef: g,
    afterInsideRef: h,
    portalNode: u,
    setFocusManagerState: v
  }), [u]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [d, /* @__PURE__ */ F(td.Provider, {
      value: S,
      children: [R && u && /* @__PURE__ */ m(Vn, {
        "data-type": "outside",
        ref: f,
        onFocus: (E) => {
          if (Hr(E, u))
            g.current?.focus();
          else {
            const N = b ? b.domReference : null;
            bh(N)?.focus();
          }
        }
      }), R && u && /* @__PURE__ */ m("span", {
        "aria-owns": u.id,
        style: G8
      }), u && /* @__PURE__ */ an.createPortal(o, u), R && u && /* @__PURE__ */ m(Vn, {
        "data-type": "outside",
        ref: p,
        onFocus: (E) => {
          if (Hr(E, u))
            h.current?.focus();
          else {
            const N = b ? b.domReference : null;
            Qu(N)?.focus(), b?.closeOnFocusOut && b?.onOpenChange(!1, Ve(Po, E.nativeEvent));
          }
        }
      })]
    })]
  });
});
process.env.NODE_ENV !== "production" && (ni.displayName = "FloatingPortal");
function Rh() {
  const t = /* @__PURE__ */ new Map();
  return {
    emit(e, n) {
      t.get(e)?.forEach((o) => o(n));
    },
    on(e, n) {
      t.has(e) || t.set(e, /* @__PURE__ */ new Set()), t.get(e).add(n);
    },
    off(e, n) {
      t.get(e)?.delete(n);
    }
  };
}
class nd {
  nodesRef = {
    current: []
  };
  events = Rh();
  addNode(e) {
    this.nodesRef.current.push(e);
  }
  removeNode(e) {
    const n = this.nodesRef.current.findIndex((o) => o === e);
    n !== -1 && this.nodesRef.current.splice(n, 1);
  }
}
const od = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (od.displayName = "FloatingNodeContext");
const rd = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (rd.displayName = "FloatingTreeContext");
const bo = () => x.useContext(od)?.id || null, tr = (t) => {
  const e = x.useContext(rd);
  return t ?? e;
};
function aa(t) {
  const e = Do(), n = tr(t), o = bo();
  return ke(() => {
    if (!e)
      return;
    const r = {
      id: e,
      parentId: o
    };
    return n?.addNode(r), () => {
      n?.removeNode(r);
    };
  }, [n, e, o]), e;
}
function id(t) {
  const {
    children: e,
    id: n
  } = t, o = bo();
  return /* @__PURE__ */ m(od.Provider, {
    value: x.useMemo(() => ({
      id: n,
      parentId: o
    }), [n, o]),
    children: e
  });
}
function sd(t) {
  const {
    children: e,
    externalTree: n
  } = t, o = Tt(() => n ?? new nd()).current;
  return /* @__PURE__ */ m(rd.Provider, {
    value: o,
    children: e
  });
}
function j8(t, e) {
  const n = wt(bt(t));
  return t instanceof n.KeyboardEvent ? "keyboard" : t instanceof n.FocusEvent ? e || "keyboard" : "pointerType" in t ? t.pointerType || "keyboard" : "touches" in t ? "touch" : t instanceof n.MouseEvent ? e || (t.detail === 0 ? "keyboard" : "mouse") : "";
}
const q1 = 20;
let zo = [];
function ld() {
  zo = zo.filter((t) => t.deref()?.isConnected);
}
function K8(t) {
  ld(), t && cn(t) !== "body" && (zo.push(new WeakRef(t)), zo.length > q1 && (zo = zo.slice(-q1)));
}
function Xa() {
  return ld(), zo[zo.length - 1]?.deref();
}
function q8(t) {
  return t ? Xu(t) ? t : as(t)[0] || t : null;
}
function Z1(t, e) {
  if (t.hasAttribute("tabindex") && !t.hasAttribute("data-tabindex") || !e.current.includes("floating") && !t.getAttribute("role")?.includes("dialog"))
    return;
  const o = mh(t).filter((i) => {
    const s = i.getAttribute("data-tabindex") || "";
    return Xu(i) || i.hasAttribute("data-tabindex") && !s.startsWith("-");
  }), r = t.getAttribute("tabindex");
  e.current.includes("floating") || o.length === 0 ? r !== "0" && t.setAttribute("tabindex", "0") : (r !== "-1" || t.hasAttribute("data-tabindex") && t.getAttribute("data-tabindex") !== "-1") && (t.setAttribute("tabindex", "-1"), t.setAttribute("data-tabindex", "-1"));
}
function oi(t) {
  const {
    context: e,
    children: n,
    disabled: o = !1,
    initialFocus: r = !0,
    returnFocus: i = !0,
    restoreFocus: s = !1,
    modal: l = !0,
    closeOnFocusOut: a = !0,
    openInteractionType: c = "",
    nextFocusableElement: u,
    previousFocusableElement: d,
    beforeContentFocusGuardRef: f,
    externalTree: p,
    getInsideElements: g
  } = t, h = "rootStore" in e ? e.rootStore : e, b = h.useState("open"), v = h.useState("domReferenceElement"), C = h.useState("floatingElement"), {
    events: y,
    dataRef: w
  } = h.context, R = Se(() => w.current.floatingContext?.nodeId), S = r === !1, E = Jc(v) && S, N = x.useRef(["content"]), T = $t(r), P = $t(i), I = $t(c), k = tr(p), M = wh(), D = x.useRef(!1), O = x.useRef(!1), V = x.useRef(!1), _ = x.useRef(null), A = x.useRef(""), L = x.useRef(""), B = x.useRef(null), G = x.useRef(null), U = fn(B, f, M?.beforeInsideRef), Y = fn(G, M?.afterInsideRef), K = Vt(), j = Vt(), Z = ei(), te = M != null, W = Yi(C), X = Se((J = W) => J ? as(J) : []), ee = Se(() => g?.().filter((J) => J != null) ?? []);
  x.useEffect(() => {
    if (o || !l)
      return;
    function J(pe) {
      pe.key === "Tab" && ze(W, Gt(et(W))) && X().length === 0 && !E && Ft(pe);
    }
    const ie = et(W);
    return ut(ie, "keydown", J);
  }, [o, v, W, l, N, E, X]), x.useEffect(() => {
    if (o || !b)
      return;
    const J = et(W);
    function ie() {
      V.current = !1;
    }
    function pe(re) {
      const de = bt(re), xe = ee(), se = ze(C, de) || ze(v, de) || ze(M?.portalNode, de) || xe.some((fe) => fe === de || ze(fe, de));
      V.current = !se, L.current = re.pointerType || "keyboard", de?.closest(`[${Ju}]`) && (O.current = !0);
    }
    function oe() {
      L.current = "keyboard";
    }
    return Yn(ut(J, "pointerdown", pe, !0), ut(J, "pointerup", ie, !0), ut(J, "pointercancel", ie, !0), ut(J, "keydown", oe, !0));
  }, [o, C, v, W, b, M, ee]), x.useEffect(() => {
    if (o || !a)
      return;
    const J = et(W);
    function ie() {
      O.current = !0, j.start(0, () => {
        O.current = !1;
      });
    }
    function pe(xe) {
      const se = bt(xe);
      Xu(se) && (_.current = se);
    }
    function oe(xe) {
      const se = xe.relatedTarget, fe = xe.currentTarget, $ = bt(xe);
      queueMicrotask(() => {
        const Q = R(), H = h.context.triggerElements, q = ee(), ae = se?.hasAttribute(qi("focus-guard")) && [B.current, G.current, M?.beforeInsideRef.current, M?.afterInsideRef.current, M?.beforeOutsideRef.current, M?.afterOutsideRef.current, yo(d), yo(u)].includes(se), ge = !(ze(v, se) || ze(C, se) || ze(se, C) || ze(M?.portalNode, se) || q.some((ue) => ue === se || ze(ue, se)) || se != null && H.hasElement(se) || H.hasMatchingElement((ue) => ze(ue, se)) || ae || k && (uo(k.nodesRef.current, Q).find((ue) => ze(ue.context?.elements.floating, se) || ze(ue.context?.elements.domReference, se)) || U1(k.nodesRef.current, Q).find((ue) => [ue.context?.elements.floating, Yi(ue.context?.elements.floating)].includes(se) || ue.context?.elements.domReference === se)));
        if (fe === v && W && Z1(W, N), s && fe !== v && !sa($) && Gt(J) === J.body) {
          if (Ct(W) && (W.focus(), s === "popup")) {
            Z.request(() => {
              W.focus();
            });
            return;
          }
          const ue = X(), Re = _.current, be = (Re && ue.includes(Re) ? Re : null) || ue[ue.length - 1] || W;
          Ct(be) && be.focus();
        }
        if (w.current.insideReactTree) {
          w.current.insideReactTree = !1;
          return;
        }
        (E || !l) && se && ge && !O.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        // For an "untrapped" typeable combobox (input role=combobox with
        // initialFocus=false), re-opening the popup and tabbing out should still close it even
        // when the previously focused element (e.g. the next tabbable outside the popup) is
        // focused again. Otherwise, the popup remains open on the second Tab sequence:
        // click input -> Tab (closes) -> click input -> Tab.
        // Allow closing when `isUntrappedTypeableCombobox` regardless of the previously focused element.
        (E || se !== Xa()) && (D.current = !0, h.setOpen(!1, Ve(Po, xe)));
      });
    }
    function re() {
      V.current || (w.current.insideReactTree = !0, K.start(0, () => {
        w.current.insideReactTree = !1;
      }));
    }
    const de = Ct(v) ? v : null;
    if (!(!C && !de))
      return Yn(de && ut(de, "focusout", oe), de && ut(de, "pointerdown", ie), C && ut(C, "focusin", pe), C && ut(C, "focusout", oe), C && M && ut(C, "focusout", re, !0));
  }, [o, v, C, W, l, k, M, h, a, s, X, E, R, N, w, K, j, Z, u, d, ee]), x.useEffect(() => {
    if (o || !C || !b)
      return;
    const J = Array.from(M?.portalNode?.querySelectorAll(`[${qi("portal")}]`) || []), pe = (k ? U1(k.nodesRef.current, R()) : []).find((fe) => Jc(fe.context?.elements.domReference || null))?.context?.elements.domReference, re = [...[C, ...J, B.current, G.current, M?.beforeOutsideRef.current, M?.afterOutsideRef.current, ...ee()], pe, yo(d), yo(u), E ? v : null].filter((fe) => fe != null), de = K1(re, {
      ariaHidden: l || E,
      mark: !1
    }), xe = [C, ...J].filter((fe) => fe != null), se = K1(xe);
    return () => {
      se(), de();
    };
  }, [b, o, v, C, l, N, M, E, k, R, u, d, ee]), ke(() => {
    if (!b || o || !Ct(W))
      return;
    const J = et(W), ie = Gt(J);
    queueMicrotask(() => {
      const pe = T.current, oe = typeof pe == "function" ? pe(I.current || "") : pe;
      if (oe === void 0 || oe === !1 || ze(W, ie))
        return;
      let de = null;
      const xe = () => (de == null && (de = X(W)), de[0] || W);
      let se;
      oe === !0 || oe === null ? se = xe() : se = yo(oe), se = se || xe(), yl(se, {
        preventScroll: se === W
      });
    });
  }, [o, b, W, S, X, T, I]), ke(() => {
    if (o || !W)
      return;
    const J = et(W), ie = Gt(J);
    K8(ie);
    function pe(re) {
      if (re.open || (A.current = j8(re.nativeEvent, L.current)), re.reason === Lt && re.nativeEvent.type === "mouseleave" && (D.current = !0), re.reason === is)
        if (re.nested)
          D.current = !1;
        else if (qm(re.nativeEvent) || Zm(re.nativeEvent))
          D.current = !1;
        else {
          let de = !1;
          et(W).createElement("div").focus({
            get preventScroll() {
              return de = !0, !1;
            }
          }), de ? D.current = !1 : D.current = !0;
        }
    }
    y.on("openchange", pe);
    function oe() {
      const re = P.current;
      let de = typeof re == "function" ? re(A.current) : re;
      if (de === void 0 || de === !1)
        return null;
      if (de === null && (de = !0), typeof de == "boolean") {
        const se = v || Xa();
        return se && se.isConnected ? se : null;
      }
      const xe = v || Xa();
      return yo(de) || xe || null;
    }
    return () => {
      y.off("openchange", pe);
      const re = Gt(J), de = ee(), xe = ze(C, re) || de.some(($) => $ === re || ze($, re)) || k && uo(k.nodesRef.current, R(), !1).some(($) => ze($.context?.elements.floating, re)), se = P.current, fe = oe();
      queueMicrotask(() => {
        const $ = q8(fe), Q = typeof se != "boolean";
        se && !D.current && Ct($) && // If the focus moved somewhere else after mount, avoid returning focus
        // since it likely entered a different element which should be
        // respected: https://github.com/floating-ui/floating-ui/issues/2607
        (!(!Q && $ !== re && re !== J.body) || xe) && $.focus({
          preventScroll: !0
        }), D.current = !1;
      });
    };
  }, [o, C, W, P, w, y, k, v, R, ee]), ke(() => {
    if (!Hu || b || !C)
      return;
    const J = Gt(et(C));
    !Ct(J) || !ia(J) || ze(C, J) && J.blur();
  }, [b, C]), ke(() => {
    if (!(o || !M))
      return M.setFocusManagerState({
        modal: l,
        closeOnFocusOut: a,
        open: b,
        onOpenChange: h.setOpen,
        domReference: v
      }), () => {
        M.setFocusManagerState(null);
      };
  }, [o, M, l, b, h, a, v]), ke(() => {
    if (!(o || !W))
      return Z1(W, N), () => {
        queueMicrotask(ld);
      };
  }, [o, W, N]);
  const le = !o && (l ? !E : !0) && (te || l);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [le && /* @__PURE__ */ m(Vn, {
      "data-type": "inside",
      ref: U,
      onFocus: (J) => {
        if (l) {
          const ie = X();
          yl(ie[ie.length - 1]);
        } else M?.portalNode && (D.current = !1, Hr(J, M.portalNode) ? Qu(v)?.focus() : yo(d ?? M.beforeOutsideRef)?.focus());
      }
    }), n, le && /* @__PURE__ */ m(Vn, {
      "data-type": "inside",
      ref: Y,
      onFocus: (J) => {
        l ? yl(X()[0]) : M?.portalNode && (a && (D.current = !0), Hr(J, M.portalNode) ? bh(v)?.focus() : yo(u ?? M.afterOutsideRef)?.focus());
      }
    })]
  });
}
function xr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, {
    enabled: r = !0,
    event: i = "click",
    toggle: s = !0,
    ignoreMouse: l = !1,
    stickIfOpen: a = !0,
    touchOpenDelay: c = 0,
    reason: u = Zn
  } = e, d = x.useRef(void 0), f = ei(), p = Vt(), g = x.useMemo(() => ({
    onPointerDown(h) {
      d.current = h.pointerType;
    },
    onMouseDown(h) {
      const b = d.current, v = h.nativeEvent, C = n.select("open");
      if (h.button !== 0 || i === "click" || jr(b, !0) && l)
        return;
      const y = o.current.openEvent, w = y?.type, R = n.select("domReferenceElement") !== h.currentTarget, S = C && R || !(C && s && (!(y && a) || w === "click" || w === "mousedown")), E = bt(v);
      if (ia(E)) {
        const T = Ve(u, v, E);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, T);
        }) : n.setOpen(S, T);
        return;
      }
      const N = h.currentTarget;
      f.request(() => {
        const T = Ve(u, v, N);
        S && b === "touch" && c > 0 ? p.start(c, () => {
          n.setOpen(!0, T);
        }) : n.setOpen(S, T);
      });
    },
    onClick(h) {
      if (i === "mousedown-only")
        return;
      const b = d.current;
      if (i === "mousedown" && b) {
        d.current = void 0;
        return;
      }
      if (jr(b, !0) && l)
        return;
      const v = n.select("open"), C = o.current.openEvent, y = n.select("domReferenceElement") !== h.currentTarget, w = v && y || !(v && s && (!(C && a) || Xm(C))), R = Ve(u, h.nativeEvent, h.currentTarget);
      w && b === "touch" && c > 0 ? p.start(c, () => {
        n.setOpen(!0, R);
      }) : n.setOpen(w, R);
    },
    onKeyDown() {
      d.current = void 0;
    }
  }), [o, i, l, n, a, s, f, p, c, u]);
  return x.useMemo(() => r ? {
    reference: g
  } : St, [r, g]);
}
function Z8(t, e) {
  let n = null, o = null, r = !1;
  return {
    contextElement: t || void 0,
    getBoundingClientRect() {
      const i = t?.getBoundingClientRect() || {
        width: 0,
        height: 0,
        x: 0,
        y: 0
      }, s = e.axis === "x" || e.axis === "both", l = e.axis === "y" || e.axis === "both", a = ["mouseenter", "mousemove"].includes(e.dataRef.current.openEvent?.type || "") && e.pointerType !== "touch";
      let c = i.width, u = i.height, d = i.x, f = i.y;
      return n == null && e.x && s && (n = i.x - e.x), o == null && e.y && l && (o = i.y - e.y), d -= n || 0, f -= o || 0, c = 0, u = 0, !r || a ? (c = e.axis === "y" ? i.width : 0, u = e.axis === "x" ? i.height : 0, d = s && e.x != null ? e.x : d, f = l && e.y != null ? e.y : f) : r && !a && (u = e.axis === "x" ? i.height : u, c = e.axis === "y" ? i.width : c), r = !0, {
        width: c,
        height: u,
        x: d,
        y: f,
        top: f,
        right: d + c,
        bottom: f + u,
        left: d
      };
    }
  };
}
function X1(t) {
  return t != null && t.clientX != null;
}
function X8(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    enabled: l = !0,
    axis: a = "both"
  } = e, c = x.useRef(!1), u = x.useRef(null), [d, f] = x.useState(), [p, g] = x.useState([]), h = Se((w, R, S) => {
    c.current || s.current.openEvent && !X1(s.current.openEvent) || n.set("positionReference", Z8(S ?? i, {
      x: w,
      y: R,
      axis: a,
      dataRef: s,
      pointerType: d
    }));
  }), b = Se((w) => {
    o ? u.current || g([]) : h(w.clientX, w.clientY, w.currentTarget);
  }), v = jr(d) ? r : o, C = x.useCallback(() => {
    if (!v || !l)
      return;
    const w = wt(r);
    function R(S) {
      const E = bt(S);
      ze(r, E) ? (u.current?.(), u.current = null) : h(S.clientX, S.clientY);
    }
    if (!s.current.openEvent || X1(s.current.openEvent)) {
      const S = () => {
        u.current?.(), u.current = null;
      };
      return u.current = ut(w, "mousemove", R), S;
    }
    n.set("positionReference", i);
  }, [v, l, r, s, i, n, h]);
  x.useEffect(() => C(), [C, p]), x.useEffect(() => {
    l && !r && (c.current = !1);
  }, [l, r]), x.useEffect(() => {
    !l && o && (c.current = !0);
  }, [l, o]);
  const y = x.useMemo(() => {
    function w(R) {
      f(R.pointerType);
    }
    return {
      onPointerDown: w,
      onPointerEnter: w,
      onMouseMove: b,
      onMouseEnter: b
    };
  }, [b]);
  return x.useMemo(() => l ? {
    reference: y,
    trigger: y
  } : {}, [l, y]);
}
const Q8 = {
  intentional: "onClick",
  sloppy: "onPointerDown"
};
function J8() {
  return !1;
}
function e6(t) {
  return {
    escapeKey: typeof t == "boolean" ? t : t?.escapeKey ?? !1,
    outsidePress: typeof t == "boolean" ? t : t?.outsidePress ?? !0
  };
}
function Cr(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), {
    dataRef: i
  } = n.context, {
    enabled: s = !0,
    escapeKey: l = !0,
    outsidePress: a = !0,
    outsidePressEvent: c = "sloppy",
    referencePress: u = J8,
    referencePressEvent: d = "sloppy",
    bubbles: f,
    externalTree: p
  } = e, g = tr(p), h = Se(typeof a == "function" ? a : () => !1), b = typeof a == "function" ? h : a, v = b !== !1, C = Se(() => c), y = x.useRef(!1), w = x.useRef(!1), R = x.useRef(!1), {
    escapeKey: S,
    outsidePress: E
  } = e6(f), N = x.useRef(null), T = Vt(), P = Vt(), I = Se(() => {
    P.clear(), i.current.insideReactTree = !1;
  }), k = x.useRef(!1), M = x.useRef(""), D = Se(u), O = Se((G) => {
    if (!o || !s || !l || G.key !== "Escape" || k.current)
      return;
    const U = i.current.floatingContext?.nodeId, Y = g ? uo(g.nodesRef.current, U) : [];
    if (!S && Y.length > 0) {
      let Z = !0;
      if (Y.forEach((te) => {
        te.context?.open && !te.context.dataRef.current.__escapeKeyBubbles && (Z = !1);
      }), !Z)
        return;
    }
    const K = g8(G) ? G.nativeEvent : G, j = Ve(vr, K);
    n.setOpen(!1, j), !S && !j.isPropagationAllowed && G.stopPropagation();
  }), V = Se(() => {
    i.current.insideReactTree = !0, P.start(0, I);
  });
  x.useEffect(() => {
    if (!o || !s)
      return;
    i.current.__escapeKeyBubbles = S, i.current.__outsidePressBubbles = E;
    const G = new xn(), U = new xn();
    function Y() {
      G.clear(), k.current = !0;
    }
    function K() {
      G.start(
        // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
        // Only apply to WebKit for the test to remain 0ms.
        ta() ? 5 : 0,
        () => {
          k.current = !1;
        }
      );
    }
    function j() {
      R.current = !0, U.start(0, () => {
        R.current = !1;
      });
    }
    function Z() {
      y.current = !1, w.current = !1;
    }
    function te() {
      const H = M.current, q = H === "pen" || !H ? "mouse" : H, ae = C(), ge = typeof ae == "function" ? ae() : ae;
      return typeof ge == "string" ? ge : ge[q];
    }
    function W(H) {
      const q = te();
      return q === "intentional" && H.type !== "click" || q === "sloppy" && H.type === "click";
    }
    function X(H) {
      const q = i.current.floatingContext?.nodeId, ae = g && uo(g.nodesRef.current, q).some((ge) => zn(H, ge.context?.elements.floating));
      return zn(H, n.select("floatingElement")) || zn(H, n.select("domReferenceElement")) || ae;
    }
    function ee(H) {
      if (W(H)) {
        I();
        return;
      }
      if (i.current.insideReactTree) {
        I();
        return;
      }
      const q = bt(H), ae = `[${qi("inert")}]`, ge = pt(q) ? q.getRootNode() : null, ue = Array.from((Yr(ge) ? ge : et(n.select("floatingElement"))).querySelectorAll(ae)), Re = n.context.triggerElements;
      if (q && (Re.hasElement(q) || Re.hasMatchingElement((Ee) => ze(Ee, q))))
        return;
      let be = pt(q) ? q : null;
      for (; be && !ao(be); ) {
        const Ee = po(be);
        if (ao(Ee) || !pt(Ee))
          break;
        be = Ee;
      }
      if (ue.length && pt(q) && !y8(q) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
      !ze(q, n.select("floatingElement")) && // If the target root element contains none of the markers, then the
      // element was injected after the floating element rendered.
      ue.every((Ee) => !ze(be, Ee)))
        return;
      if (Ct(q) && !("touches" in H)) {
        const Ee = ao(q), Pe = pn(q), Me = /auto|scroll/, _e = Ee || Me.test(Pe.overflowX), Ue = Ee || Me.test(Pe.overflowY), Ye = _e && q.clientWidth > 0 && q.scrollWidth > q.clientWidth, He = Ue && q.clientHeight > 0 && q.scrollHeight > q.clientHeight, ye = Pe.direction === "rtl", Oe = He && (ye ? H.offsetX <= q.offsetWidth - q.clientWidth : H.offsetX > q.clientWidth), Ie = Ye && H.offsetY > q.clientHeight;
        if (Oe || Ie)
          return;
      }
      if (X(H))
        return;
      if (te() === "intentional" && R.current) {
        U.clear(), R.current = !1;
        return;
      }
      if (typeof b == "function" && !b(H))
        return;
      const ve = i.current.floatingContext?.nodeId, me = g ? uo(g.nodesRef.current, ve) : [];
      if (me.length > 0) {
        let Ee = !0;
        if (me.forEach((Pe) => {
          Pe.context?.open && !Pe.context.dataRef.current.__outsidePressBubbles && (Ee = !1);
        }), !Ee)
          return;
      }
      n.setOpen(!1, Ve(is, H)), I();
    }
    function le(H) {
      te() !== "sloppy" || H.pointerType === "touch" || !n.select("open") || !s || zn(H, n.select("floatingElement")) || zn(H, n.select("domReferenceElement")) || ee(H);
    }
    function J(H) {
      if (te() !== "sloppy" || !n.select("open") || !s || zn(H, n.select("floatingElement")) || zn(H, n.select("domReferenceElement")))
        return;
      const q = H.touches[0];
      q && (N.current = {
        startTime: Date.now(),
        startX: q.clientX,
        startY: q.clientY,
        dismissOnTouchEnd: !1,
        dismissOnMouseDown: !0
      }, T.start(1e3, () => {
        N.current && (N.current.dismissOnTouchEnd = !1, N.current.dismissOnMouseDown = !1);
      }));
    }
    function ie(H, q) {
      const ae = bt(H);
      if (!ae)
        return;
      const ge = ut(ae, H.type, () => {
        q(H), ge();
      });
    }
    function pe(H) {
      M.current = "touch", ie(H, J);
    }
    function oe(H) {
      T.clear(), H.type === "pointerdown" && (M.current = H.pointerType), !(H.type === "mousedown" && N.current && !N.current.dismissOnMouseDown) && ie(H, (q) => {
        q.type === "pointerdown" ? le(q) : ee(q);
      });
    }
    function re(H) {
      if (!y.current)
        return;
      const q = w.current;
      if (Z(), te() === "intentional") {
        if (H.type === "pointercancel") {
          q && j();
          return;
        }
        if (!X(H)) {
          if (q) {
            j();
            return;
          }
          typeof b == "function" && !b(H) || (U.clear(), R.current = !0, I());
        }
      }
    }
    function de(H) {
      if (te() !== "sloppy" || !N.current || zn(H, n.select("floatingElement")) || zn(H, n.select("domReferenceElement")))
        return;
      const q = H.touches[0];
      if (!q)
        return;
      const ae = Math.abs(q.clientX - N.current.startX), ge = Math.abs(q.clientY - N.current.startY), ue = Math.sqrt(ae * ae + ge * ge);
      ue > 5 && (N.current.dismissOnTouchEnd = !0), ue > 10 && (ee(H), T.clear(), N.current = null);
    }
    function xe(H) {
      ie(H, de);
    }
    function se(H) {
      te() !== "sloppy" || !N.current || zn(H, n.select("floatingElement")) || zn(H, n.select("domReferenceElement")) || (N.current.dismissOnTouchEnd && ee(H), T.clear(), N.current = null);
    }
    function fe(H) {
      ie(H, se);
    }
    const $ = et(r), Q = Yn(l && Yn(ut($, "keydown", O), ut($, "compositionstart", Y), ut($, "compositionend", K)), v && Yn(ut($, "click", oe, !0), ut($, "pointerdown", oe, !0), ut($, "pointerup", re, !0), ut($, "pointercancel", re, !0), ut($, "mousedown", oe, !0), ut($, "mouseup", re, !0), ut($, "touchstart", pe, !0), ut($, "touchmove", xe, !0), ut($, "touchend", fe, !0)));
    return () => {
      Q(), G.clear(), U.clear(), Z(), R.current = !1;
    };
  }, [i, r, l, v, b, o, s, S, E, O, I, C, g, n, T]), x.useEffect(I, [b, I]);
  const _ = x.useMemo(() => ({
    onKeyDown: O,
    [Q8[d]]: (G) => {
      D() && n.setOpen(!1, Ve(Zn, G.nativeEvent));
    },
    ...d !== "intentional" && {
      onClick(G) {
        D() && n.setOpen(!1, Ve(Zn, G.nativeEvent));
      }
    }
  }), [O, n, d, D]), A = Se((G) => {
    if (!o || !s || G.button !== 0)
      return;
    const U = bt(G.nativeEvent);
    ze(n.select("floatingElement"), U) && (y.current || (y.current = !0, w.current = !1));
  }), L = Se((G) => {
    !o || !s || (G.defaultPrevented || G.nativeEvent.defaultPrevented) && y.current && (w.current = !0);
  }), B = x.useMemo(() => ({
    onKeyDown: O,
    // `onMouseDown` may be blocked if `event.preventDefault()` is called in
    // `onPointerDown`, such as with <NumberField.ScrubArea>.
    // See https://github.com/mui/base-ui/pull/3379
    onPointerDown: L,
    onMouseDown: L,
    onClickCapture: V,
    onMouseDownCapture(G) {
      V(), A(G);
    },
    onPointerDownCapture(G) {
      V(), A(G);
    },
    onMouseUpCapture: V,
    onTouchEndCapture: V,
    onTouchMoveCapture: V
  }), [O, V, A, L]);
  return x.useMemo(() => s ? {
    reference: _,
    floating: B,
    trigger: _
  } : {}, [s, _, B]);
}
function Q1(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const i = Dn(e), s = Zu(e), l = qu(s), a = yn(e), c = i === "y", u = o.x + o.width / 2 - r.width / 2, d = o.y + o.height / 2 - r.height / 2, f = o[l] / 2 - r[l] / 2;
  let p;
  switch (a) {
    case "top":
      p = {
        x: u,
        y: o.y - r.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - r.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (er(e)) {
    case "start":
      p[s] -= f * (n && c ? -1 : 1);
      break;
    case "end":
      p[s] += f * (n && c ? -1 : 1);
      break;
  }
  return p;
}
async function t6(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: i,
    rects: s,
    elements: l,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: p = 0
  } = To(e, t), g = rh(p), b = l[f ? d === "floating" ? "reference" : "floating" : d], v = ji(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(b))) == null || n ? b : b.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: a
  })), C = d === "floating" ? {
    x: o,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, y = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), w = await (i.isElement == null ? void 0 : i.isElement(y)) ? await (i.getScale == null ? void 0 : i.getScale(y)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, R = ji(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: y,
    strategy: a
  }) : C);
  return {
    top: (v.top - R.top + g.top) / w.y,
    bottom: (R.bottom - v.bottom + g.bottom) / w.y,
    left: (v.left - R.left + g.left) / w.x,
    right: (R.right - v.right + g.right) / w.x
  };
}
const n6 = 50, o6 = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: i = [],
    platform: s
  } = n, l = s.detectOverflow ? s : {
    ...s,
    detectOverflow: t6
  }, a = await (s.isRTL == null ? void 0 : s.isRTL(e));
  let c = await s.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: u,
    y: d
  } = Q1(c, o, a), f = o, p = 0;
  const g = {};
  for (let h = 0; h < i.length; h++) {
    const b = i[h];
    if (!b)
      continue;
    const {
      name: v,
      fn: C
    } = b, {
      x: y,
      y: w,
      data: R,
      reset: S
    } = await C({
      x: u,
      y: d,
      initialPlacement: o,
      placement: f,
      strategy: r,
      middlewareData: g,
      rects: c,
      platform: l,
      elements: {
        reference: t,
        floating: e
      }
    });
    u = y ?? u, d = w ?? d, g[v] = {
      ...g[v],
      ...R
    }, S && p < n6 && (p++, typeof S == "object" && (S.placement && (f = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = Q1(c, f, a)), h = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: r,
    middlewareData: g
  };
}, r6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: i,
        rects: s,
        initialPlacement: l,
        platform: a,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: h = !0,
        ...b
      } = To(t, e);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const v = yn(r), C = Dn(l), y = yn(l) === l, w = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), R = f || (y || !h ? [Al(l)] : S8(l)), S = g !== "none";
      !f && S && R.push(...k8(l, h, g, w));
      const E = [l, ...R], N = await a.detectOverflow(e, b), T = [];
      let P = ((o = i.flip) == null ? void 0 : o.overflows) || [];
      if (u && T.push(N[v]), d) {
        const D = w8(r, s, w);
        T.push(N[D[0]], N[D[1]]);
      }
      if (P = [...P, {
        placement: r,
        overflows: T
      }], !T.every((D) => D <= 0)) {
        var I, k;
        const D = (((I = i.flip) == null ? void 0 : I.index) || 0) + 1, O = E[D];
        if (O && (!(d === "alignment" ? C !== Dn(O) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        P.every((A) => Dn(A.placement) === C ? A.overflows[0] > 0 : !0)))
          return {
            data: {
              index: D,
              overflows: P
            },
            reset: {
              placement: O
            }
          };
        let V = (k = P.filter((_) => _.overflows[0] <= 0).sort((_, A) => _.overflows[1] - A.overflows[1])[0]) == null ? void 0 : k.placement;
        if (!V)
          switch (p) {
            case "bestFit": {
              var M;
              const _ = (M = P.filter((A) => {
                if (S) {
                  const L = Dn(A.placement);
                  return L === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  L === "y";
                }
                return !0;
              }).map((A) => [A.placement, A.overflows.filter((L) => L > 0).reduce((L, B) => L + B, 0)]).sort((A, L) => A[1] - L[1])[0]) == null ? void 0 : M[0];
              _ && (V = _);
              break;
            }
            case "initialPlacement":
              V = l;
              break;
          }
        if (r !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function J1(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function ep(t) {
  return x8.some((e) => t[e] >= 0);
}
const i6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: n,
        platform: o
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = To(t, e);
      switch (r) {
        case "referenceHidden": {
          const s = await o.detectOverflow(e, {
            ...i,
            elementContext: "reference"
          }), l = J1(s, n.reference);
          return {
            data: {
              referenceHiddenOffsets: l,
              referenceHidden: ep(l)
            }
          };
        }
        case "escaped": {
          const s = await o.detectOverflow(e, {
            ...i,
            altBoundary: !0
          }), l = J1(s, n.floating);
          return {
            data: {
              escapedOffsets: l,
              escaped: ep(l)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Eh = /* @__PURE__ */ new Set(["left", "top"]);
async function s6(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, i = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), s = yn(n), l = er(n), a = Dn(n) === "y", c = Eh.has(s) ? -1 : 1, u = i && a ? -1 : 1, d = To(e, t);
  let {
    mainAxis: f,
    crossAxis: p,
    alignmentAxis: g
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return l && typeof g == "number" && (p = l === "end" ? g * -1 : g), a ? {
    x: p * u,
    y: f * c
  } : {
    x: f * c,
    y: p * u
  };
}
const l6 = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: i,
        placement: s,
        middlewareData: l
      } = e, a = await s6(e, t);
      return s === ((n = l.offset) == null ? void 0 : n.placement) && (o = l.arrow) != null && o.alignmentOffset ? {} : {
        x: r + a.x,
        y: i + a.y,
        data: {
          ...a,
          placement: s
        }
      };
    }
  };
}, a6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        platform: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: l = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: C,
              y
            } = v;
            return {
              x: C,
              y
            };
          }
        },
        ...c
      } = To(t, e), u = {
        x: n,
        y: o
      }, d = await i.detectOverflow(e, c), f = Dn(yn(r)), p = Ku(f);
      let g = u[p], h = u[f];
      if (s) {
        const v = p === "y" ? "top" : "left", C = p === "y" ? "bottom" : "right", y = g + d[v], w = g - d[C];
        g = eu(y, g, w);
      }
      if (l) {
        const v = f === "y" ? "top" : "left", C = f === "y" ? "bottom" : "right", y = h + d[v], w = h - d[C];
        h = eu(y, h, w);
      }
      const b = a.fn({
        ...e,
        [p]: g,
        [f]: h
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - o,
          enabled: {
            [p]: s,
            [f]: l
          }
        }
      };
    }
  };
}, c6 = function(t) {
  return t === void 0 && (t = {}), {
    options: t,
    fn(e) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: i,
        middlewareData: s
      } = e, {
        offset: l = 0,
        mainAxis: a = !0,
        crossAxis: c = !0
      } = To(t, e), u = {
        x: n,
        y: o
      }, d = Dn(r), f = Ku(d);
      let p = u[f], g = u[d];
      const h = To(l, e), b = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (a) {
        const y = f === "y" ? "height" : "width", w = i.reference[f] - i.floating[y] + b.mainAxis, R = i.reference[f] + i.reference[y] - b.mainAxis;
        p < w ? p = w : p > R && (p = R);
      }
      if (c) {
        var v, C;
        const y = f === "y" ? "width" : "height", w = Eh.has(yn(r)), R = i.reference[d] - i.floating[y] + (w && ((v = s.offset) == null ? void 0 : v[d]) || 0) + (w ? 0 : b.crossAxis), S = i.reference[d] + i.reference[y] + (w ? 0 : ((C = s.offset) == null ? void 0 : C[d]) || 0) - (w ? b.crossAxis : 0);
        g < R ? g = R : g > S && (g = S);
      }
      return {
        [f]: p,
        [d]: g
      };
    }
  };
}, u6 = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        rects: i,
        platform: s,
        elements: l
      } = e, {
        apply: a = () => {
        },
        ...c
      } = To(t, e), u = await s.detectOverflow(e, c), d = yn(r), f = er(r), p = Dn(r) === "y", {
        width: g,
        height: h
      } = i.floating;
      let b, v;
      d === "top" || d === "bottom" ? (b = d, v = f === (await (s.isRTL == null ? void 0 : s.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (v = d, b = f === "end" ? "top" : "bottom");
      const C = h - u.top - u.bottom, y = g - u.left - u.right, w = Kr(h - u[b], C), R = Kr(g - u[v], y), S = !e.middlewareData.shift;
      let E = w, N = R;
      if ((n = e.middlewareData.shift) != null && n.enabled.x && (N = y), (o = e.middlewareData.shift) != null && o.enabled.y && (E = C), S && !f) {
        const P = Sn(u.left, 0), I = Sn(u.right, 0), k = Sn(u.top, 0), M = Sn(u.bottom, 0);
        p ? N = g - 2 * (P !== 0 || I !== 0 ? P + I : Sn(u.left, u.right)) : E = h - 2 * (k !== 0 || M !== 0 ? k + M : Sn(u.top, u.bottom));
      }
      await a({
        ...e,
        availableWidth: N,
        availableHeight: E
      });
      const T = await s.getDimensions(l.floating);
      return g !== T.width || h !== T.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Nh(t) {
  const e = pn(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = Ct(t), i = r ? t.offsetWidth : n, s = r ? t.offsetHeight : o, l = _l(n) !== i || _l(o) !== s;
  return l && (n = i, o = s), {
    width: n,
    height: o,
    $: l
  };
}
function ad(t) {
  return pt(t) ? t : t.contextElement;
}
function zr(t) {
  const e = ad(t);
  if (!Ct(e))
    return co(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: i
  } = Nh(e);
  let s = (i ? _l(n.width) : n.width) / o, l = (i ? _l(n.height) : n.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: s,
    y: l
  };
}
const d6 = /* @__PURE__ */ co(0);
function kh(t) {
  const e = wt(t);
  return !ta() || !e.visualViewport ? d6 : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function f6(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== wt(t) ? !1 : e;
}
function mr(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), i = ad(t);
  let s = co(1);
  e && (o ? pt(o) && (s = zr(o)) : s = zr(t));
  const l = f6(i, n, o) ? kh(i) : co(0);
  let a = (r.left + l.x) / s.x, c = (r.top + l.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (i) {
    const f = wt(i), p = o && pt(o) ? wt(o) : o;
    let g = f, h = jc(g);
    for (; h && o && p !== g; ) {
      const b = zr(h), v = h.getBoundingClientRect(), C = pn(h), y = v.left + (h.clientLeft + parseFloat(C.paddingLeft)) * b.x, w = v.top + (h.clientTop + parseFloat(C.paddingTop)) * b.y;
      a *= b.x, c *= b.y, u *= b.x, d *= b.y, a += y, c += w, g = wt(h), h = jc(g);
    }
  }
  return ji({
    width: u,
    height: d,
    x: a,
    y: c
  });
}
function ca(t, e) {
  const n = na(t).scrollLeft;
  return e ? e.left + n : mr(ho(t)).left + n;
}
function Mh(t, e) {
  const n = t.getBoundingClientRect(), o = n.left + e.scrollLeft - ca(t, n), r = n.top + e.scrollTop;
  return {
    x: o,
    y: r
  };
}
function p6(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const i = r === "fixed", s = ho(o), l = e ? ea(e.floating) : !1;
  if (o === s || l && i)
    return n;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = co(1);
  const u = co(0), d = Ct(o);
  if ((d || !d && !i) && ((cn(o) !== "body" || Qo(s)) && (a = na(o)), d)) {
    const p = mr(o);
    c = zr(o), u.x = p.x + o.clientLeft, u.y = p.y + o.clientTop;
  }
  const f = s && !d && !i ? Mh(s, a) : co(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - a.scrollLeft * c.x + u.x + f.x,
    y: n.y * c.y - a.scrollTop * c.y + u.y + f.y
  };
}
function g6(t) {
  return Array.from(t.getClientRects());
}
function m6(t) {
  const e = ho(t), n = na(t), o = t.ownerDocument.body, r = Sn(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), i = Sn(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + ca(t);
  const l = -n.scrollTop;
  return pn(o).direction === "rtl" && (s += Sn(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
const tp = 25;
function h6(t, e) {
  const n = wt(t), o = ho(t), r = n.visualViewport;
  let i = o.clientWidth, s = o.clientHeight, l = 0, a = 0;
  if (r) {
    i = r.width, s = r.height;
    const u = ta();
    (!u || u && e === "fixed") && (l = r.offsetLeft, a = r.offsetTop);
  }
  const c = ca(o);
  if (c <= 0) {
    const u = o.ownerDocument, d = u.body, f = getComputedStyle(d), p = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, g = Math.abs(o.clientWidth - d.clientWidth - p);
    g <= tp && (i -= g);
  } else c <= tp && (i += c);
  return {
    width: i,
    height: s,
    x: l,
    y: a
  };
}
function b6(t, e) {
  const n = mr(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, i = Ct(t) ? zr(t) : co(1), s = t.clientWidth * i.x, l = t.clientHeight * i.y, a = r * i.x, c = o * i.y;
  return {
    width: s,
    height: l,
    x: a,
    y: c
  };
}
function np(t, e, n) {
  let o;
  if (e === "viewport")
    o = h6(t, n);
  else if (e === "document")
    o = m6(ho(t));
  else if (pt(e))
    o = b6(e, n);
  else {
    const r = kh(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return ji(o);
}
function Ih(t, e) {
  const n = po(t);
  return n === e || !pt(n) || ao(n) ? !1 : pn(n).position === "fixed" || Ih(n, e);
}
function v6(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = Wi(t, [], !1).filter((l) => pt(l) && cn(l) !== "body"), r = null;
  const i = pn(t).position === "fixed";
  let s = i ? po(t) : t;
  for (; pt(s) && !ao(s); ) {
    const l = pn(s), a = Tu(s);
    !a && l.position === "fixed" && (r = null), (i ? !a && !r : !a && l.position === "static" && !!r && (r.position === "absolute" || r.position === "fixed") || Qo(s) && !a && Ih(t, s)) ? o = o.filter((u) => u !== s) : r = l, s = po(s);
  }
  return e.set(t, o), o;
}
function y6(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const s = [...n === "clippingAncestors" ? ea(e) ? [] : v6(e, this._c) : [].concat(n), o], l = np(e, s[0], r);
  let a = l.top, c = l.right, u = l.bottom, d = l.left;
  for (let f = 1; f < s.length; f++) {
    const p = np(e, s[f], r);
    a = Sn(p.top, a), c = Kr(p.right, c), u = Kr(p.bottom, u), d = Sn(p.left, d);
  }
  return {
    width: c - d,
    height: u - a,
    x: d,
    y: a
  };
}
function x6(t) {
  const {
    width: e,
    height: n
  } = Nh(t);
  return {
    width: e,
    height: n
  };
}
function C6(t, e, n) {
  const o = Ct(e), r = ho(e), i = n === "fixed", s = mr(t, !0, i, e);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = co(0);
  function c() {
    a.x = ca(r);
  }
  if (o || !o && !i)
    if ((cn(e) !== "body" || Qo(r)) && (l = na(e)), o) {
      const p = mr(e, !0, i, e);
      a.x = p.x + e.clientLeft, a.y = p.y + e.clientTop;
    } else r && c();
  i && !o && r && c();
  const u = r && !o && !i ? Mh(r, l) : co(0), d = s.left + l.scrollLeft - a.x - u.x, f = s.top + l.scrollTop - a.y - u.y;
  return {
    x: d,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Qa(t) {
  return pn(t).position === "static";
}
function op(t, e) {
  if (!Ct(t) || pn(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return ho(t) === n && (n = n.ownerDocument.body), n;
}
function Ph(t, e) {
  const n = wt(t);
  if (ea(t))
    return n;
  if (!Ct(t)) {
    let r = po(t);
    for (; r && !ao(r); ) {
      if (pt(r) && !Qa(r))
        return r;
      r = po(r);
    }
    return n;
  }
  let o = op(t, e);
  for (; o && Sv(o) && Qa(o); )
    o = op(o, e);
  return o && ao(o) && Qa(o) && !Tu(o) ? n : o || Nv(t) || n;
}
const w6 = async function(t) {
  const e = this.getOffsetParent || Ph, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: C6(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function S6(t) {
  return pn(t).direction === "rtl";
}
const Th = {
  convertOffsetParentRelativeRectToViewportRelativeRect: p6,
  getDocumentElement: ho,
  getClippingRect: y6,
  getOffsetParent: Ph,
  getElementRects: w6,
  getClientRects: g6,
  getDimensions: x6,
  getScale: zr,
  isElement: pt,
  isRTL: S6
};
function Oh(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function R6(t, e) {
  let n = null, o;
  const r = ho(t);
  function i() {
    var l;
    clearTimeout(o), (l = n) == null || l.disconnect(), n = null;
  }
  function s(l, a) {
    l === void 0 && (l = !1), a === void 0 && (a = 1), i();
    const c = t.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: p
    } = c;
    if (l || e(), !f || !p)
      return;
    const g = ar(d), h = ar(r.clientWidth - (u + f)), b = ar(r.clientHeight - (d + p)), v = ar(u), y = {
      rootMargin: -g + "px " + -h + "px " + -b + "px " + -v + "px",
      threshold: Sn(0, Kr(1, a)) || 1
    };
    let w = !0;
    function R(S) {
      const E = S[0].intersectionRatio;
      if (E !== a) {
        if (!w)
          return s();
        E ? s(!1, E) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      E === 1 && !Oh(c, t.getBoundingClientRect()) && s(), w = !1;
    }
    try {
      n = new IntersectionObserver(R, {
        ...y,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(R, y);
    }
    n.observe(t);
  }
  return s(!0), i;
}
function rp(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: i = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = o, c = ad(t), u = r || i ? [...c ? Wi(c) : [], ...e ? Wi(e) : []] : [];
  u.forEach((v) => {
    r && v.addEventListener("scroll", n, {
      passive: !0
    }), i && v.addEventListener("resize", n);
  });
  const d = c && l ? R6(c, n) : null;
  let f = -1, p = null;
  s && (p = new ResizeObserver((v) => {
    let [C] = v;
    C && C.target === c && p && e && (p.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(e);
    })), n();
  }), c && !a && p.observe(c), e && p.observe(e));
  let g, h = a ? mr(t) : null;
  a && b();
  function b() {
    const v = mr(t);
    h && !Oh(h, v) && n(), h = v, g = requestAnimationFrame(b);
  }
  return n(), () => {
    var v;
    u.forEach((C) => {
      r && C.removeEventListener("scroll", n), i && C.removeEventListener("resize", n);
    }), d?.(), (v = p) == null || v.disconnect(), p = null, a && cancelAnimationFrame(g);
  };
}
const E6 = l6, N6 = a6, k6 = r6, M6 = u6, I6 = i6, P6 = c6, T6 = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Th,
    ...n
  }, i = {
    ...r.platform,
    _c: o
  };
  return o6(t, e, {
    ...r,
    platform: i
  });
};
var O6 = typeof document < "u", D6 = function() {
}, xl = O6 ? Io : D6;
function Ll(t, e) {
  if (t === e)
    return !0;
  if (typeof t != typeof e)
    return !1;
  if (typeof t == "function" && t.toString() === e.toString())
    return !0;
  let n, o, r;
  if (t && e && typeof t == "object") {
    if (Array.isArray(t)) {
      if (n = t.length, n !== e.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Ll(t[o], e[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(t), n = r.length, n !== Object.keys(e).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(e, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const i = r[o];
      if (!(i === "_owner" && t.$$typeof) && !Ll(t[i], e[i]))
        return !1;
    }
    return !0;
  }
  return t !== t && e !== e;
}
function Dh(t) {
  return typeof window > "u" ? 1 : (t.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ip(t, e) {
  const n = Dh(t);
  return Math.round(e * n) / n;
}
function Ja(t) {
  const e = x.useRef(t);
  return xl(() => {
    e.current = t;
  }), e;
}
function V6(t) {
  t === void 0 && (t = {});
  const {
    placement: e = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: i,
      floating: s
    } = {},
    transform: l = !0,
    whileElementsMounted: a,
    open: c
  } = t, [u, d] = x.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, p] = x.useState(o);
  Ll(f, o) || p(o);
  const [g, h] = x.useState(null), [b, v] = x.useState(null), C = x.useCallback((A) => {
    A !== S.current && (S.current = A, h(A));
  }, []), y = x.useCallback((A) => {
    A !== E.current && (E.current = A, v(A));
  }, []), w = i || g, R = s || b, S = x.useRef(null), E = x.useRef(null), N = x.useRef(u), T = a != null, P = Ja(a), I = Ja(r), k = Ja(c), M = x.useCallback(() => {
    if (!S.current || !E.current)
      return;
    const A = {
      placement: e,
      strategy: n,
      middleware: f
    };
    I.current && (A.platform = I.current), T6(S.current, E.current, A).then((L) => {
      const B = {
        ...L,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: k.current !== !1
      };
      D.current && !Ll(N.current, B) && (N.current = B, an.flushSync(() => {
        d(B);
      }));
    });
  }, [f, e, n, I, k]);
  xl(() => {
    c === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d((A) => ({
      ...A,
      isPositioned: !1
    })));
  }, [c]);
  const D = x.useRef(!1);
  xl(() => (D.current = !0, () => {
    D.current = !1;
  }), []), xl(() => {
    if (w && (S.current = w), R && (E.current = R), w && R) {
      if (P.current)
        return P.current(w, R, M);
      M();
    }
  }, [w, R, M, P, T]);
  const O = x.useMemo(() => ({
    reference: S,
    floating: E,
    setReference: C,
    setFloating: y
  }), [C, y]), V = x.useMemo(() => ({
    reference: w,
    floating: R
  }), [w, R]), _ = x.useMemo(() => {
    const A = {
      position: n,
      left: 0,
      top: 0
    };
    if (!V.floating)
      return A;
    const L = ip(V.floating, u.x), B = ip(V.floating, u.y);
    return l ? {
      ...A,
      transform: "translate(" + L + "px, " + B + "px)",
      ...Dh(V.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: L,
      top: B
    };
  }, [n, l, V.floating, u.x, u.y]);
  return x.useMemo(() => ({
    ...u,
    update: M,
    refs: O,
    elements: V,
    floatingStyles: _
  }), [u, M, O, V, _]);
}
const _6 = (t, e) => {
  const n = E6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, A6 = (t, e) => {
  const n = N6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, L6 = (t, e) => ({
  fn: P6(t).fn,
  options: [t, e]
}), F6 = (t, e) => {
  const n = k6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, $6 = (t, e) => {
  const n = M6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, H6 = (t, e) => {
  const n = I6(t);
  return {
    name: n.name,
    fn: n.fn,
    options: [t, e]
  };
}, he = (t, e, n, o, r, i, ...s) => {
  if (s.length > 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of selectors" : rt(1));
  let l;
  if (t && e)
    l = (a, c, u, d) => {
      const f = t(a, c, u, d);
      return e(f, c, u, d);
    };
  else if (t)
    l = t;
  else
    throw (
      /* minify-error-disabled */
      new Error("Missing arguments")
    );
  return l;
};
var z6 = (t, e, n) => {
  if (e.length === 1 && e[0] === n) {
    let o = !1;
    try {
      const r = {};
      t(r) === r && (o = !0);
    } catch {
    }
    if (o) {
      let r;
      try {
        throw new Error();
      } catch (i) {
        ({ stack: r } = i);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: r }
      );
    }
  }
}, B6 = (t, e, n) => {
  const { memoize: o, memoizeOptions: r } = e, { inputSelectorResults: i, inputSelectorResultsCopy: s } = t, l = o(() => ({}), ...r);
  if (!(l.apply(null, i) === l.apply(null, s))) {
    let c;
    try {
      throw new Error();
    } catch (u) {
      ({ stack: c } = u);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: n,
        firstInputs: i,
        secondInputs: s,
        stack: c
      }
    );
  }
}, W6 = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
}, Fl = /* @__PURE__ */ Symbol("NOT_FOUND");
function U6(t, e = `expected a function, instead received ${typeof t}`) {
  if (typeof t != "function")
    throw new TypeError(e);
}
function G6(t, e = `expected an object, instead received ${typeof t}`) {
  if (typeof t != "object")
    throw new TypeError(e);
}
function Y6(t, e = "expected all items to be functions, instead received the following types: ") {
  if (!t.every((n) => typeof n == "function")) {
    const n = t.map(
      (o) => typeof o == "function" ? `function ${o.name || "unnamed"}()` : typeof o
    ).join(", ");
    throw new TypeError(`${e}[${n}]`);
  }
}
var sp = (t) => Array.isArray(t) ? t : [t];
function j6(t) {
  const e = Array.isArray(t[0]) ? t[0] : t;
  return Y6(
    e,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), e;
}
function lp(t, e) {
  const n = [], { length: o } = t;
  for (let r = 0; r < o; r++)
    n.push(t[r].apply(null, e));
  return n;
}
var K6 = (t, e) => {
  const { identityFunctionCheck: n, inputStabilityCheck: o } = {
    ...W6,
    ...e
  };
  return {
    identityFunctionCheck: {
      shouldRun: n === "always" || n === "once" && t,
      run: z6
    },
    inputStabilityCheck: {
      shouldRun: o === "always" || o === "once" && t,
      run: B6
    }
  };
};
function q6(t) {
  let e;
  return {
    get(n) {
      return e && t(e.key, n) ? e.value : Fl;
    },
    put(n, o) {
      e = { key: n, value: o };
    },
    getEntries() {
      return e ? [e] : [];
    },
    clear() {
      e = void 0;
    }
  };
}
function Z6(t, e) {
  let n = [];
  function o(l) {
    const a = n.findIndex((c) => e(l, c.key));
    if (a > -1) {
      const c = n[a];
      return a > 0 && (n.splice(a, 1), n.unshift(c)), c.value;
    }
    return Fl;
  }
  function r(l, a) {
    o(l) === Fl && (n.unshift({ key: l, value: a }), n.length > t && n.pop());
  }
  function i() {
    return n;
  }
  function s() {
    n = [];
  }
  return { get: o, put: r, getEntries: i, clear: s };
}
var X6 = (t, e) => t === e;
function Q6(t) {
  return function(n, o) {
    if (n === null || o === null || n.length !== o.length)
      return !1;
    const { length: r } = n;
    for (let i = 0; i < r; i++)
      if (!t(n[i], o[i]))
        return !1;
    return !0;
  };
}
function J6(t, e) {
  const n = typeof e == "object" ? e : { equalityCheck: e }, {
    equalityCheck: o = X6,
    maxSize: r = 1,
    resultEqualityCheck: i
  } = n, s = Q6(o);
  let l = 0;
  const a = r <= 1 ? q6(s) : Z6(r, s);
  function c() {
    let u = a.get(arguments);
    if (u === Fl) {
      if (u = t.apply(null, arguments), l++, i) {
        const f = a.getEntries().find(
          (p) => i(p.value, u)
        );
        f && (u = f.value, l !== 0 && l--);
      }
      a.put(arguments, u);
    }
    return u;
  }
  return c.clearCache = () => {
    a.clear(), c.resetResultsCount();
  }, c.resultsCount = () => l, c.resetResultsCount = () => {
    l = 0;
  }, c;
}
var e9 = class {
  constructor(t) {
    this.value = t;
  }
  deref() {
    return this.value;
  }
}, t9 = typeof WeakRef < "u" ? WeakRef : e9, n9 = 0, ap = 1;
function js() {
  return {
    s: n9,
    v: void 0,
    o: null,
    p: null
  };
}
function Vh(t, e = {}) {
  let n = js();
  const { resultEqualityCheck: o } = e;
  let r, i = 0;
  function s() {
    let l = n;
    const { length: a } = arguments;
    for (let d = 0, f = a; d < f; d++) {
      const p = arguments[d];
      if (typeof p == "function" || typeof p == "object" && p !== null) {
        let g = l.o;
        g === null && (l.o = g = /* @__PURE__ */ new WeakMap());
        const h = g.get(p);
        h === void 0 ? (l = js(), g.set(p, l)) : l = h;
      } else {
        let g = l.p;
        g === null && (l.p = g = /* @__PURE__ */ new Map());
        const h = g.get(p);
        h === void 0 ? (l = js(), g.set(p, l)) : l = h;
      }
    }
    const c = l;
    let u;
    if (l.s === ap)
      u = l.v;
    else if (u = t.apply(null, arguments), i++, o) {
      const d = r?.deref?.() ?? r;
      d != null && o(d, u) && (u = d, i !== 0 && i--), r = typeof u == "object" && u !== null || typeof u == "function" ? new t9(u) : u;
    }
    return c.s = ap, c.v = u, u;
  }
  return s.clearCache = () => {
    n = js(), s.resetResultsCount();
  }, s.resultsCount = () => i, s.resetResultsCount = () => {
    i = 0;
  }, s;
}
function _h(t, ...e) {
  const n = typeof t == "function" ? {
    memoize: t,
    memoizeOptions: e
  } : t, o = (...r) => {
    let i = 0, s = 0, l, a = {}, c = r.pop();
    typeof c == "object" && (a = c, c = r.pop()), U6(
      c,
      `createSelector expects an output function after the inputs, but received: [${typeof c}]`
    );
    const u = {
      ...n,
      ...a
    }, {
      memoize: d,
      memoizeOptions: f = [],
      argsMemoize: p = Vh,
      argsMemoizeOptions: g = [],
      devModeChecks: h = {}
    } = u, b = sp(f), v = sp(g), C = j6(r), y = d(function() {
      return i++, c.apply(
        null,
        arguments
      );
    }, ...b);
    let w = !0;
    const R = p(function() {
      s++;
      const E = lp(
        C,
        arguments
      );
      if (l = y.apply(null, E), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: N, inputStabilityCheck: T } = K6(w, h);
        if (N.shouldRun && N.run(
          c,
          E,
          l
        ), T.shouldRun) {
          const P = lp(
            C,
            arguments
          );
          T.run(
            { inputSelectorResults: E, inputSelectorResultsCopy: P },
            { memoize: d, memoizeOptions: b },
            arguments
          );
        }
        w && (w = !1);
      }
      return l;
    }, ...v);
    return Object.assign(R, {
      resultFunc: c,
      memoizedResultFunc: y,
      dependencies: C,
      dependencyRecomputations: () => s,
      resetDependencyRecomputations: () => {
        s = 0;
      },
      lastResult: () => l,
      recomputations: () => i,
      resetRecomputations: () => {
        i = 0;
      },
      memoize: d,
      argsMemoize: p
    });
  };
  return Object.assign(o, {
    withTypes: () => o
  }), o;
}
var o9 = /* @__PURE__ */ _h(Vh), r9 = Object.assign(
  (t, e = o9) => {
    G6(
      t,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof t}`
    );
    const n = Object.keys(t), o = n.map(
      (i) => t[i]
    );
    return e(
      o,
      (...i) => i.reduce((s, l, a) => (s[n[a]] = l, s), {})
    );
  },
  { withTypes: () => r9 }
);
const i9 = _h({
  memoize: J6,
  memoizeOptions: {
    maxSize: 1,
    equalityCheck: Object.is
  }
}), s9 = (...t) => {
  const e = /* @__PURE__ */ new WeakMap();
  let n = 1;
  const o = t[t.length - 1], r = t.length - 1 || 1, i = o.length - r;
  if (i > 3)
    throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : rt(2));
  return (l, a, c, u) => {
    let d = l.__cacheKey__;
    d || (d = {
      id: n
    }, l.__cacheKey__ = d, n += 1);
    let f = e.get(d);
    if (!f) {
      let p = t;
      const g = [void 0, void 0, void 0];
      switch (i) {
        case 0:
          break;
        case 1: {
          p = [...t.slice(0, -1), () => g[0], o];
          break;
        }
        case 2: {
          p = [...t.slice(0, -1), () => g[0], () => g[1], o];
          break;
        }
        case 3: {
          p = [...t.slice(0, -1), () => g[0], () => g[1], () => g[2], o];
          break;
        }
        default:
          throw new Error(process.env.NODE_ENV !== "production" ? "Unsupported number of arguments" : rt(2));
      }
      f = i9(...p), f.selectorArgs = g, e.set(d, f);
    }
    switch (f.selectorArgs[0] = a, f.selectorArgs[1] = c, f.selectorArgs[2] = u, i) {
      case 0:
        return f(l);
      case 1:
        return f(l, a);
      case 2:
        return f(l, a, c);
      case 3:
        return f(l, a, c, u);
      default:
        throw (
          /* minify-error-disabled */
          new Error("unreachable")
        );
    }
  };
};
var Ks = { exports: {} }, ec = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var cp;
function l9() {
  if (cp) return ec;
  cp = 1;
  var t = We;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var n = typeof Object.is == "function" ? Object.is : e, o = t.useState, r = t.useEffect, i = t.useLayoutEffect, s = t.useDebugValue;
  function l(d, f) {
    var p = f(), g = o({ inst: { value: p, getSnapshot: f } }), h = g[0].inst, b = g[1];
    return i(
      function() {
        h.value = p, h.getSnapshot = f, a(h) && b({ inst: h });
      },
      [d, p, f]
    ), r(
      function() {
        return a(h) && b({ inst: h }), d(function() {
          a(h) && b({ inst: h });
        });
      },
      [d]
    ), s(p), p;
  }
  function a(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var p = f();
      return !n(d, p);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : l;
  return ec.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, ec;
}
var tc = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var up;
function a9() {
  return up || (up = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(p, g) {
      return p === g && (p !== 0 || 1 / p === 1 / g) || p !== p && g !== g;
    }
    function e(p, g) {
      u || r.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var h = g();
      if (!d) {
        var b = g();
        i(h, b) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      b = s({
        inst: { value: h, getSnapshot: g }
      });
      var v = b[0].inst, C = b[1];
      return a(
        function() {
          v.value = h, v.getSnapshot = g, n(v) && C({ inst: v });
        },
        [p, h, g]
      ), l(
        function() {
          return n(v) && C({ inst: v }), p(function() {
            n(v) && C({ inst: v });
          });
        },
        [p]
      ), c(h), h;
    }
    function n(p) {
      var g = p.getSnapshot;
      p = p.value;
      try {
        var h = g();
        return !i(p, h);
      } catch {
        return !0;
      }
    }
    function o(p, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = We, i = typeof Object.is == "function" ? Object.is : t, s = r.useState, l = r.useEffect, a = r.useLayoutEffect, c = r.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : e;
    tc.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), tc;
}
var dp;
function cd() {
  return dp || (dp = 1, process.env.NODE_ENV === "production" ? Ks.exports = l9() : Ks.exports = a9()), Ks.exports;
}
var ud = cd(), qs = { exports: {} }, nc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fp;
function c9() {
  if (fp) return nc;
  fp = 1;
  var t = We, e = cd();
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, i = t.useRef, s = t.useEffect, l = t.useMemo, a = t.useDebugValue;
  return nc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
    var g = i(null);
    if (g.current === null) {
      var h = { hasValue: !1, value: null };
      g.current = h;
    } else h = g.current;
    g = l(
      function() {
        function v(S) {
          if (!C) {
            if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
              var E = h.value;
              if (p(E, S))
                return w = E;
            }
            return w = S;
          }
          if (E = w, o(y, S)) return E;
          var N = f(S);
          return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
        }
        var C = !1, y, w, R = d === void 0 ? null : d;
        return [
          function() {
            return v(u());
          },
          R === null ? void 0 : function() {
            return v(R());
          }
        ];
      },
      [u, d, f, p]
    );
    var b = r(c, g[0], g[1]);
    return s(
      function() {
        h.hasValue = !0, h.value = b;
      },
      [b]
    ), a(b), b;
  }, nc;
}
var oc = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pp;
function u9() {
  return pp || (pp = 1, process.env.NODE_ENV !== "production" && (function() {
    function t(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = We, n = cd(), o = typeof Object.is == "function" ? Object.is : t, r = n.useSyncExternalStore, i = e.useRef, s = e.useEffect, l = e.useMemo, a = e.useDebugValue;
    oc.useSyncExternalStoreWithSelector = function(c, u, d, f, p) {
      var g = i(null);
      if (g.current === null) {
        var h = { hasValue: !1, value: null };
        g.current = h;
      } else h = g.current;
      g = l(
        function() {
          function v(S) {
            if (!C) {
              if (C = !0, y = S, S = f(S), p !== void 0 && h.hasValue) {
                var E = h.value;
                if (p(E, S))
                  return w = E;
              }
              return w = S;
            }
            if (E = w, o(y, S))
              return E;
            var N = f(S);
            return p !== void 0 && p(E, N) ? (y = S, E) : (y = S, w = N);
          }
          var C = !1, y, w, R = d === void 0 ? null : d;
          return [
            function() {
              return v(u());
            },
            R === null ? void 0 : function() {
              return v(R());
            }
          ];
        },
        [u, d, f, p]
      );
      var b = r(c, g[0], g[1]);
      return s(
        function() {
          h.hasValue = !0, h.value = b;
        },
        [b]
      ), a(b), b;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), oc;
}
var gp;
function d9() {
  return gp || (gp = 1, process.env.NODE_ENV === "production" ? qs.exports = c9() : qs.exports = u9()), qs.exports;
}
var f9 = d9();
const iu = [];
let su;
function p9() {
  return su;
}
function g9(t) {
  iu.push(t);
}
function dd(t) {
  const e = (n, o) => {
    const r = Tt(m9).current;
    let i;
    try {
      su = r;
      for (const s of iu)
        s.before(r);
      i = t(n, o);
      for (const s of iu)
        s.after(r);
      r.didInitialize = !0;
    } finally {
      su = void 0;
    }
    return i;
  };
  return e.displayName = t.displayName || t.name, e;
}
function Ah(t) {
  return /* @__PURE__ */ x.forwardRef(dd(t));
}
function m9() {
  return {
    didInitialize: !1
  };
}
const h9 = Eu(19), b9 = h9 ? y9 : x9;
function Ce(t, e, n, o, r) {
  return b9(t, e, n, o, r);
}
function v9(t, e, n, o, r) {
  const i = x.useCallback(() => e(t.getSnapshot(), n, o, r), [t, e, n, o, r]);
  return ud.useSyncExternalStore(t.subscribe, i, i);
}
g9({
  before(t) {
    t.syncIndex = 0, t.didInitialize || (t.syncTick = 1, t.syncHooks = [], t.didChangeStore = !0, t.getSnapshot = () => {
      let e = !1;
      for (let n = 0; n < t.syncHooks.length; n += 1) {
        const o = t.syncHooks[n], r = o.selector(o.store.state, o.a1, o.a2, o.a3);
        (o.didChange || !Object.is(o.value, r)) && (e = !0, o.value = r, o.didChange = !1);
      }
      return e && (t.syncTick += 1), t.syncTick;
    });
  },
  after(t) {
    t.syncHooks.length > 0 && (t.didChangeStore && (t.didChangeStore = !1, t.subscribe = (e) => {
      const n = /* @__PURE__ */ new Set();
      for (const r of t.syncHooks)
        n.add(r.store);
      const o = [];
      for (const r of n)
        o.push(r.subscribe(e));
      return () => {
        for (const r of o)
          r();
      };
    }), ud.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getSnapshot));
  }
});
function y9(t, e, n, o, r) {
  const i = p9();
  if (!i)
    return v9(t, e, n, o, r);
  const s = i.syncIndex;
  i.syncIndex += 1;
  let l;
  return i.didInitialize ? (l = i.syncHooks[s], (l.store !== t || l.selector !== e || !Object.is(l.a1, n) || !Object.is(l.a2, o) || !Object.is(l.a3, r)) && (l.store !== t && (i.didChangeStore = !0), l.store = t, l.selector = e, l.a1 = n, l.a2 = o, l.a3 = r, l.didChange = !0)) : (l = {
    store: t,
    selector: e,
    a1: n,
    a2: o,
    a3: r,
    value: e(t.getSnapshot(), n, o, r),
    didChange: !1
  }, i.syncHooks.push(l)), l.value;
}
function x9(t, e, n, o, r) {
  return f9.useSyncExternalStoreWithSelector(t.subscribe, t.getSnapshot, t.getSnapshot, (i) => e(i, n, o, r));
}
class fd {
  /**
   * The current state of the store.
   * This property is updated immediately when the state changes as a result of calling {@link setState}, {@link update}, or {@link set}.
   * To subscribe to state changes, use the {@link useState} method. The value returned by {@link useState} is updated after the component renders (similarly to React's useState).
   * The values can be used directly (to avoid subscribing to the store) in effects or event handlers.
   *
   * Do not modify properties in state directly. Instead, use the provided methods to ensure proper state management and listener notification.
   */
  // Internal state to handle recursive `setState()` calls
  constructor(e) {
    this.state = e, this.listeners = /* @__PURE__ */ new Set(), this.updateTick = 0;
  }
  /**
   * Registers a listener that will be called whenever the store's state changes.
   *
   * @param fn The listener function to be called on state changes.
   * @returns A function to unsubscribe the listener.
   */
  subscribe = (e) => (this.listeners.add(e), () => {
    this.listeners.delete(e);
  });
  /**
   * Returns the current state of the store.
   */
  getSnapshot = () => this.state;
  /**
   * Updates the entire store's state and notifies all registered listeners.
   *
   * @param newState The new state to set for the store.
   */
  setState(e) {
    if (this.state === e)
      return;
    this.state = e, this.updateTick += 1;
    const n = this.updateTick;
    for (const o of this.listeners) {
      if (n !== this.updateTick)
        return;
      o(e);
    }
  }
  /**
   * Merges the provided changes into the current state and notifies listeners if there are changes.
   *
   * @param changes An object containing the changes to apply to the current state.
   */
  update(e) {
    for (const n in e)
      if (!Object.is(this.state[n], e[n])) {
        this.setState({
          ...this.state,
          ...e
        });
        return;
      }
  }
  /**
   * Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
   *
   * @param key The key in the store's state to update.
   * @param value The new value to set for the specified key.
   */
  set(e, n) {
    Object.is(this.state[e], n) || this.setState({
      ...this.state,
      [e]: n
    });
  }
  /**
   * Gives the state a new reference and updates all registered listeners.
   */
  notifyAll() {
    const e = {
      ...this.state
    };
    this.setState(e);
  }
  use(e, n, o, r) {
    return Ce(this, e, n, o, r);
  }
}
class wr extends fd {
  /**
   * Creates a new ReactStore instance.
   *
   * @param state Initial state of the store.
   * @param context Non-reactive context values.
   * @param selectors Optional selectors for use with `useState`.
   */
  constructor(e, n = {}, o) {
    super(e), this.context = n, this.selectors = o;
  }
  /**
   * Non-reactive values such as refs, callbacks, etc.
   */
  /**
   * Synchronizes a single external value into the store.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValue(e, n) {
    x.useDebugValue(e), ke(() => {
      this.state[e] !== n && this.set(e, n);
    }, [e, n]);
  }
  /**
   * Synchronizes a single external value into the store and
   * cleans it up (sets to `undefined`) on unmount.
   *
   * Note that the while the value in `state` is updated immediately, the value returned
   * by `useState` is updated before the next render (similarly to React's `useState`).
   */
  useSyncedValueWithCleanup(e, n) {
    const o = this;
    ke(() => (o.state[e] !== n && o.set(e, n), () => {
      o.set(e, void 0);
    }), [o, e, n]);
  }
  /**
   * Synchronizes multiple external values into the store.
   *
   * Note that the while the values in `state` are updated immediately, the values returned
   * by `useState` are updated before the next render (similarly to React's `useState`).
   */
  useSyncedValues(e) {
    const n = this;
    if (process.env.NODE_ENV !== "production") {
      x.useDebugValue(e, (s) => Object.keys(s));
      const r = x.useRef(Object.keys(e)).current, i = Object.keys(e);
      (r.length !== i.length || r.some((s, l) => s !== i[l])) && console.error("ReactStore.useSyncedValues expects the same prop keys on every render. Keys should be stable.");
    }
    const o = Object.values(e);
    ke(() => {
      n.update(e);
    }, [n, ...o]);
  }
  /**
   * Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
   * is non-undefined, the store's state at `key` is updated to match `controlled`.
   */
  useControlledProp(e, n) {
    x.useDebugValue(e);
    const o = n !== void 0;
    if (ke(() => {
      o && !Object.is(this.state[e], n) && super.setState({
        ...this.state,
        [e]: n
      });
    }, [e, n, o]), process.env.NODE_ENV !== "production") {
      const r = this.controlledValues ??= /* @__PURE__ */ new Map();
      r.has(e) || r.set(e, o);
      const i = r.get(e);
      i !== void 0 && i !== o && console.error(`A component is changing the ${o ? "" : "un"}controlled state of ${e.toString()} to be ${o ? "un" : ""}controlled. Elements should not switch from uncontrolled to controlled (or vice versa).`);
    }
  }
  /** Gets the current value from the store using a selector with the provided key.
   *
   * @param key Key of the selector to use.
   */
  select(e, n, o, r) {
    const i = this.selectors[e];
    return i(this.state, n, o, r);
  }
  /**
   * Returns a value from the store's state using a selector function.
   * Used to subscribe to specific parts of the state.
   * This methods causes a rerender whenever the selected state changes.
   *
   * @param key Key of the selector to use.
   */
  useState(e, n, o, r) {
    return x.useDebugValue(e), Ce(this, this.selectors[e], n, o, r);
  }
  /**
   * Wraps a function with `useStableCallback` to ensure it has a stable reference
   * and assigns it to the context.
   *
   * @param key Key of the event callback. Must be a function in the context.
   * @param fn Function to assign.
   */
  useContextCallback(e, n) {
    x.useDebugValue(e);
    const o = Se(n ?? xt);
    this.context[e] = o;
  }
  /**
   * Returns a stable setter function for a specific key in the store's state.
   * It's commonly used to pass as a ref callback to React elements.
   *
   * @param key Key of the state to set.
   */
  useStateSetter(e) {
    const n = x.useRef(void 0);
    return n.current === void 0 && (n.current = (o) => {
      this.set(e, o);
    }), n.current;
  }
  /**
   * Observes changes derived from the store's selectors and calls the listener when the selected value changes.
   *
   * @param key Key of the selector to observe.
   * @param listener Listener function called when the selector result changes.
   */
  observe(e, n) {
    let o;
    typeof e == "function" ? o = e : o = this.selectors[e];
    let r = o(this.state);
    return n(r, r, this), this.subscribe((i) => {
      const s = o(i);
      if (!Object.is(r, s)) {
        const l = r;
        r = s, n(s, l, this);
      }
    });
  }
}
const C9 = {
  open: he((t) => t.open),
  transitionStatus: he((t) => t.transitionStatus),
  domReferenceElement: he((t) => t.domReferenceElement),
  referenceElement: he((t) => t.positionReference ?? t.referenceElement),
  floatingElement: he((t) => t.floatingElement),
  floatingId: he((t) => t.floatingId)
};
class pd extends wr {
  constructor(e) {
    const {
      syncOnly: n,
      nested: o,
      onOpenChange: r,
      triggerElements: i,
      ...s
    } = e;
    super({
      ...s,
      positionReference: s.referenceElement,
      domReferenceElement: s.referenceElement
    }, {
      onOpenChange: r,
      dataRef: {
        current: {}
      },
      events: Rh(),
      nested: o,
      triggerElements: i
    }, C9), this.syncOnly = n;
  }
  /**
   * Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
   */
  syncOpenEvent = (e, n) => {
    (!e || !this.state.open || // Prevent a pending hover-open from overwriting a click-open event, while allowing
    // click events to upgrade a hover-open.
    n != null && Xm(n)) && (this.context.dataRef.current.openEvent = e ? n : void 0);
  };
  /**
   * Runs the root-owned side effects for an open state change.
   */
  dispatchOpenChange = (e, n) => {
    this.syncOpenEvent(e, n.event);
    const o = {
      open: e,
      reason: n.reason,
      nativeEvent: n.event,
      nested: this.context.nested,
      triggerElement: n.trigger
    };
    this.context.events.emit("openchange", o);
  };
  /**
   * Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
   *
   * @param newOpen The new open state.
   * @param eventDetails Details about the event that triggered the open state change.
   */
  setOpen = (e, n) => {
    if (this.syncOnly) {
      this.context.onOpenChange?.(e, n);
      return;
    }
    this.dispatchOpenChange(e, n), this.context.onOpenChange?.(e, n);
  };
}
function Lh(t, e) {
  const n = x.useRef(null), o = x.useRef(null);
  return x.useCallback((r) => {
    if (t !== void 0) {
      if (n.current !== null) {
        const i = n.current, s = o.current, l = e.context.triggerElements.getById(i);
        s && l === s && e.context.triggerElements.delete(i), n.current = null, o.current = null;
      }
      r !== null && (n.current = t, o.current = r, e.context.triggerElements.add(t, r));
    }
  }, [e, t]);
}
function cs(t, e, n, o) {
  const r = n.useState("isMountedByTrigger", t), i = Lh(t, n), s = Se((l) => {
    if (i(l), !l || !n.select("open"))
      return;
    const a = n.select("activeTriggerId");
    if (a === t) {
      n.update({
        activeTriggerElement: l,
        ...o
      });
      return;
    }
    a == null && n.update({
      activeTriggerId: t,
      activeTriggerElement: l,
      ...o
    });
  });
  return ke(() => {
    r && n.update({
      activeTriggerElement: e.current,
      ...o
    });
  }, [r, n, e, ...Object.values(o)]), {
    registerTrigger: s,
    isMountedByThisTrigger: r
  };
}
function us(t) {
  const e = t.useState("open");
  ke(() => {
    if (e && !t.select("activeTriggerId") && t.context.triggerElements.size === 1) {
      const n = t.context.triggerElements.entries().next();
      if (!n.done) {
        const [o, r] = n.value;
        t.update({
          activeTriggerId: o,
          activeTriggerElement: r
        });
      }
    }
  }, [e, t]);
}
function ds(t, e, n) {
  const {
    mounted: o,
    setMounted: r,
    transitionStatus: i
  } = Xn(t);
  e.useSyncedValues({
    mounted: o,
    transitionStatus: i
  });
  const s = Se(() => {
    r(!1), e.update({
      activeTriggerId: null,
      activeTriggerElement: null,
      mounted: !1
    }), n?.(), e.context.onOpenChangeComplete?.(!1);
  }), l = e.useState("preventUnmountingOnClose");
  return jt({
    enabled: !l,
    open: t,
    ref: e.context.popupRef,
    onComplete() {
      t || s();
    }
  }), {
    forceUnmount: s,
    transitionStatus: i
  };
}
class Sr {
  constructor() {
    this.elementsSet = /* @__PURE__ */ new Set(), this.idMap = /* @__PURE__ */ new Map();
  }
  /**
   * Adds a trigger element with the given ID.
   *
   * Note: The provided element is assumed to not be registered under multiple IDs.
   */
  add(e, n) {
    const o = this.idMap.get(e);
    if (o !== n && (o !== void 0 && this.elementsSet.delete(o), this.elementsSet.add(n), this.idMap.set(e, n), process.env.NODE_ENV !== "production" && this.elementsSet.size !== this.idMap.size))
      throw new Error("Base UI: A trigger element cannot be registered under multiple IDs in PopupTriggerMap.");
  }
  /**
   * Removes the trigger element with the given ID.
   */
  delete(e) {
    const n = this.idMap.get(e);
    n && (this.elementsSet.delete(n), this.idMap.delete(e));
  }
  /**
   * Whether the given element is registered as a trigger.
   */
  hasElement(e) {
    return this.elementsSet.has(e);
  }
  /**
   * Whether there is a registered trigger element matching the given predicate.
   */
  hasMatchingElement(e) {
    for (const n of this.elementsSet)
      if (e(n))
        return !0;
    return !1;
  }
  /**
   * Returns the trigger element associated with the given ID, or undefined if no such element exists.
   */
  getById(e) {
    return this.idMap.get(e);
  }
  /**
   * Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
   */
  entries() {
    return this.idMap.entries();
  }
  /**
   * Returns an iterable of all registered trigger elements.
   */
  elements() {
    return this.elementsSet.values();
  }
  /**
   * Returns the number of registered trigger elements.
   */
  get size() {
    return this.idMap.size;
  }
}
function w9() {
  return new pd({
    open: !1,
    transitionStatus: void 0,
    floatingElement: null,
    referenceElement: null,
    triggerElements: new Sr(),
    floatingId: "",
    syncOnly: !1,
    nested: !1,
    onOpenChange: void 0
  });
}
function fs() {
  return {
    open: !1,
    openProp: void 0,
    mounted: !1,
    transitionStatus: void 0,
    floatingRootContext: w9(),
    preventUnmountingOnClose: !1,
    payload: void 0,
    activeTriggerId: null,
    activeTriggerElement: null,
    triggerIdProp: void 0,
    popupElement: null,
    positionerElement: null,
    activeTriggerProps: St,
    inactiveTriggerProps: St,
    popupProps: St
  };
}
const Zs = he((t) => t.triggerIdProp ?? t.activeTriggerId), ps = {
  open: he((t) => t.openProp ?? t.open),
  mounted: he((t) => t.mounted),
  transitionStatus: he((t) => t.transitionStatus),
  floatingRootContext: he((t) => t.floatingRootContext),
  preventUnmountingOnClose: he((t) => t.preventUnmountingOnClose),
  payload: he((t) => t.payload),
  activeTriggerId: Zs,
  activeTriggerElement: he((t) => t.mounted ? t.activeTriggerElement : null),
  /**
   * Whether the trigger with the given ID was used to open the popup.
   */
  isTriggerActive: he((t, e) => e !== void 0 && Zs(t) === e),
  /**
   * Whether the popup is open and was activated by a trigger with the given ID.
   */
  isOpenedByTrigger: he((t, e) => e !== void 0 && Zs(t) === e && t.open),
  /**
   * Whether the popup is mounted and was activated by a trigger with the given ID.
   */
  isMountedByTrigger: he((t, e) => e !== void 0 && Zs(t) === e && t.mounted),
  triggerProps: he((t, e) => e ? t.activeTriggerProps : t.inactiveTriggerProps),
  popupProps: he((t) => t.popupProps),
  popupElement: he((t) => t.popupElement),
  positionerElement: he((t) => t.positionerElement)
};
function gd(t) {
  const {
    open: e = !1,
    onOpenChange: n,
    elements: o = {}
  } = t, r = Do(), i = bo() != null;
  if (process.env.NODE_ENV !== "production") {
    const l = o.reference;
    l && !pt(l) && console.error("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `context.setPositionReference()`", "instead.");
  }
  const s = Tt(() => new pd({
    open: e,
    transitionStatus: void 0,
    onOpenChange: n,
    referenceElement: o.reference ?? null,
    floatingElement: o.floating ?? null,
    triggerElements: new Sr(),
    floatingId: r,
    syncOnly: !1,
    nested: i
  })).current;
  return ke(() => {
    const l = {
      open: e,
      floatingId: r
    };
    o.reference !== void 0 && (l.referenceElement = o.reference, l.domReferenceElement = pt(o.reference) ? o.reference : null), o.floating !== void 0 && (l.floatingElement = o.floating), s.update(l);
  }, [e, r, o.reference, o.floating, s]), s.context.onOpenChange = n, s.context.nested = i, s;
}
function S9(t = {}) {
  const {
    nodeId: e,
    externalTree: n
  } = t, o = gd(t), r = t.rootContext || o, i = {
    reference: r.useState("referenceElement"),
    floating: r.useState("floatingElement"),
    domReference: r.useState("domReferenceElement")
  }, [s, l] = x.useState(null), a = x.useRef(null), c = tr(n);
  ke(() => {
    i.domReference && (a.current = i.domReference);
  }, [i.domReference]);
  const u = V6({
    ...t,
    elements: {
      ...i,
      ...s && {
        reference: s
      }
    }
  }), d = x.useCallback((N) => {
    const T = pt(N) ? {
      getBoundingClientRect: () => N.getBoundingClientRect(),
      getClientRects: () => N.getClientRects(),
      contextElement: N
    } : N;
    l(T), u.refs.setReference(T);
  }, [u.refs]), [f, p] = x.useState(void 0), [g, h] = x.useState(null);
  r.useSyncedValue("referenceElement", f ?? null);
  const b = pt(f) ? f : null;
  r.useSyncedValue("domReferenceElement", f === void 0 ? i.domReference : b), r.useSyncedValue("floatingElement", g);
  const v = x.useCallback((N) => {
    (pt(N) || N === null) && (a.current = N, p(N)), (pt(u.refs.reference.current) || u.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    N !== null && !pt(N)) && u.refs.setReference(N);
  }, [u.refs, p]), C = x.useCallback((N) => {
    h(N), u.refs.setFloating(N);
  }, [u.refs]), y = x.useMemo(() => ({
    ...u.refs,
    setReference: v,
    setFloating: C,
    setPositionReference: d,
    domReference: a
  }), [u.refs, v, C, d]), w = x.useMemo(() => ({
    ...u.elements,
    domReference: i.domReference
  }), [u.elements, i.domReference]), R = r.useState("open"), S = r.useState("floatingId"), E = x.useMemo(() => ({
    ...u,
    dataRef: r.context.dataRef,
    open: R,
    onOpenChange: r.setOpen,
    events: r.context.events,
    floatingId: S,
    refs: y,
    elements: w,
    nodeId: e,
    rootStore: r
  }), [u, y, w, e, r, R, S]);
  return ke(() => {
    r.context.dataRef.current.floatingContext = E;
    const N = c?.nodesRef.current.find((T) => T.id === e);
    N && (N.context = E);
  }), x.useMemo(() => ({
    ...u,
    context: E,
    refs: y,
    elements: w,
    rootStore: r
  }), [u, y, w, E, r]);
}
function gs(t) {
  const {
    popupStore: e,
    treatPopupAsFloatingElement: n = !1,
    onOpenChange: o
  } = t, r = Do(), i = bo() != null, s = e.useState("open"), l = e.useState("activeTriggerElement"), a = e.useState(n ? "popupElement" : "positionerElement"), c = e.context.triggerElements, u = Tt(() => new pd({
    open: s,
    transitionStatus: void 0,
    referenceElement: l,
    floatingElement: a,
    triggerElements: c,
    onOpenChange: o,
    floatingId: r,
    syncOnly: !0,
    nested: i
  })).current;
  return ke(() => {
    const d = {
      open: s,
      floatingId: r,
      referenceElement: l,
      floatingElement: a
    };
    pt(l) && (d.domReferenceElement = l), u.state.positionReference === u.state.referenceElement && (d.positionReference = l), u.update(d);
  }, [s, r, l, a, u]), u.context.onOpenChange = o, u.context.nested = i, u;
}
const rc = Gm && Um;
function md(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    events: o,
    dataRef: r
  } = n.context, {
    enabled: i = !0,
    delay: s
  } = e, l = x.useRef(!1), a = x.useRef(null), c = Vt(), u = x.useRef(!0);
  x.useEffect(() => {
    const f = n.select("domReferenceElement");
    if (!i)
      return;
    const p = wt(f);
    function g() {
      const v = n.select("domReferenceElement");
      !n.select("open") && Ct(v) && v === Gt(et(v)) && (l.current = !0);
    }
    function h() {
      u.current = !0;
    }
    function b() {
      u.current = !1;
    }
    return Yn(ut(p, "blur", g), rc && ut(p, "keydown", h, !0), rc && ut(p, "pointerdown", b, !0));
  }, [n, i]), x.useEffect(() => {
    if (!i)
      return;
    function f(p) {
      if (p.reason === Zn || p.reason === vr) {
        const g = n.select("domReferenceElement");
        pt(g) && (a.current = g, l.current = !0);
      }
    }
    return o.on("openchange", f), () => {
      o.off("openchange", f);
    };
  }, [o, i, n]);
  const d = x.useMemo(() => ({
    onMouseLeave() {
      l.current = !1, a.current = null;
    },
    onFocus(f) {
      const p = f.currentTarget;
      if (l.current) {
        if (a.current === p)
          return;
        l.current = !1, a.current = null;
      }
      const g = bt(f.nativeEvent);
      if (pt(g)) {
        if (rc && !f.relatedTarget) {
          if (!u.current && !ia(g))
            return;
        } else if (!Vl(g))
          return;
      }
      const h = Dl(f.relatedTarget, n.context.triggerElements), {
        nativeEvent: b,
        currentTarget: v
      } = f, C = typeof s == "function" ? s() : s;
      if (n.select("open") && h || C === 0 || C === void 0) {
        n.setOpen(!0, Ve(dr, b, v));
        return;
      }
      c.start(C, () => {
        l.current || n.setOpen(!0, Ve(dr, b, v));
      });
    },
    onBlur(f) {
      l.current = !1, a.current = null;
      const p = f.relatedTarget, g = f.nativeEvent, h = pt(p) && p.hasAttribute(qi("focus-guard")) && p.getAttribute("data-type") === "outside";
      c.start(0, () => {
        const b = n.select("domReferenceElement"), v = Gt(et(b));
        !p && v === b || ze(r.current.floatingContext?.refs.floating.current, v) || ze(b, v) || h || Dl(p ?? v, n.context.triggerElements) || n.setOpen(!1, Ve(dr, g));
      });
    }
  }), [r, n, c, s]);
  return x.useMemo(() => i ? {
    reference: d,
    trigger: d
  } : {}, [i, d]);
}
class hd {
  constructor() {
    this.pointerType = void 0, this.interactedInside = !1, this.handler = void 0, this.blockMouseMove = !0, this.performedPointerEventsMutation = !1, this.pointerEventsScopeElement = null, this.pointerEventsReferenceElement = null, this.pointerEventsFloatingElement = null, this.restTimeoutPending = !1, this.openChangeTimeout = new xn(), this.restTimeout = new xn(), this.handleCloseOptions = void 0;
  }
  static create() {
    return new hd();
  }
  dispose = () => {
    this.openChangeTimeout.clear(), this.restTimeout.clear();
  };
  disposeEffect = () => this.dispose;
}
const $l = /* @__PURE__ */ new WeakMap();
function Hl(t) {
  if (!t.performedPointerEventsMutation)
    return;
  const e = t.pointerEventsScopeElement;
  e && $l.get(e) === t && (t.pointerEventsScopeElement?.style.removeProperty("pointer-events"), t.pointerEventsReferenceElement?.style.removeProperty("pointer-events"), t.pointerEventsFloatingElement?.style.removeProperty("pointer-events"), $l.delete(e)), t.performedPointerEventsMutation = !1, t.pointerEventsScopeElement = null, t.pointerEventsReferenceElement = null, t.pointerEventsFloatingElement = null;
}
function Fh(t, e) {
  const {
    scopeElement: n,
    referenceElement: o,
    floatingElement: r
  } = e, i = $l.get(n);
  i && i !== t && Hl(i), Hl(t), t.performedPointerEventsMutation = !0, t.pointerEventsScopeElement = n, t.pointerEventsReferenceElement = o, t.pointerEventsFloatingElement = r, $l.set(n, t), n.style.pointerEvents = "none", o.style.pointerEvents = "auto", r.style.pointerEvents = "auto";
}
function $h(t) {
  const e = Tt(hd.create).current, n = t.context.dataRef.current;
  return n.hoverInteractionState || (n.hoverInteractionState = e), Jr(n.hoverInteractionState.disposeEffect), n.hoverInteractionState;
}
function ua(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), {
    dataRef: s
  } = n.context, {
    enabled: l = !0,
    closeDelay: a = 0,
    nodeId: c
  } = e, u = $h(n), d = tr(), f = bo(), p = Se(() => Qm(s.current.openEvent?.type, u.interactedInside)), g = Se(() => {
    const w = s.current.openEvent?.type;
    return w?.includes("mouse") && w !== "mousedown";
  }), h = Se((w) => Dl(w, n.context.triggerElements)), b = x.useCallback((w) => {
    const R = Ol(a, "close", u.pointerType), S = () => {
      n.setOpen(!1, Ve(Lt, w)), d?.events.emit("floating.closed", w);
    };
    R ? u.openChangeTimeout.start(R, S) : (u.openChangeTimeout.clear(), S());
  }, [a, n, u, d]), v = Se(() => {
    Hl(u);
  }), C = Se((w) => {
    const R = bt(w);
    if (!oh(R)) {
      u.interactedInside = !1;
      return;
    }
    u.interactedInside = R?.closest("[aria-haspopup]") != null;
  });
  ke(() => {
    o || (u.pointerType = void 0, u.restTimeoutPending = !1, u.interactedInside = !1, v());
  }, [o, u, v]), x.useEffect(() => v, [v]), ke(() => {
    if (l && o && u.handleCloseOptions?.blockPointerEvents && g() && pt(i) && r) {
      const w = i, R = r, S = et(r), E = d?.nodesRef.current.find((T) => T.id === f)?.context?.elements.floating;
      E && (E.style.pointerEvents = "");
      const N = u.handleCloseOptions?.getScope?.() ?? u.pointerEventsScopeElement ?? E ?? w.closest("[data-rootownerid]") ?? S.body;
      return Fh(u, {
        scopeElement: N,
        referenceElement: w,
        floatingElement: R
      }), () => {
        v();
      };
    }
  }, [l, o, i, r, u, g, d, f, v]);
  const y = Vt();
  x.useEffect(() => {
    if (!l)
      return;
    function w() {
      u.openChangeTimeout.clear(), y.clear(), d?.events.off("floating.closed", S), v();
    }
    function R(N) {
      if (d && f && uo(d.nodesRef.current, f).length > 0) {
        d.events.on("floating.closed", S);
        return;
      }
      if (h(N.relatedTarget))
        return;
      const T = s.current.floatingContext?.nodeId ?? c, P = N.relatedTarget;
      if (!(d && T && pt(P) && uo(d.nodesRef.current, T, !1).some((k) => ze(k.context?.elements.floating, P)))) {
        if (u.handler) {
          u.handler(N);
          return;
        }
        v(), p() || b(N);
      }
    }
    function S(N) {
      !d || !f || uo(d.nodesRef.current, f).length > 0 || y.start(0, () => {
        d.events.off("floating.closed", S), n.setOpen(!1, Ve(Lt, N)), d.events.emit("floating.closed", N);
      });
    }
    const E = r;
    return Yn(E && ut(E, "mouseenter", w), E && ut(E, "mouseleave", R), E && ut(E, "pointerdown", C, !0), () => {
      d?.events.off("floating.closed", S);
    });
  }, [l, r, n, s, c, p, h, b, v, C, u, d, f, y]);
}
const R9 = {
  current: null
};
function ms(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, {
    dataRef: o,
    events: r
  } = n.context, {
    enabled: i = !0,
    delay: s = 0,
    handleClose: l = null,
    mouseOnly: a = !1,
    restMs: c = 0,
    move: u = !0,
    triggerElementRef: d = R9,
    externalTree: f,
    isActiveTrigger: p = !0,
    getHandleCloseContext: g,
    isClosing: h
  } = e, b = tr(f), v = $h(n), C = x.useRef(!1), y = $t(l), w = $t(s), R = $t(c), S = $t(i), E = $t(h);
  p && (v.handleCloseOptions = y.current?.__options);
  const N = Se(() => Qm(o.current.openEvent?.type, v.interactedInside)), T = Se((D) => Dl(D, n.context.triggerElements)), P = Se((D, O, V) => {
    const _ = n.context.triggerElements;
    if (_.hasElement(O))
      return !D || !ze(D, O);
    if (!pt(V))
      return !1;
    const A = V;
    return _.hasMatchingElement((L) => ze(L, A)) && (!D || !ze(D, A));
  }), I = Se((D, O = !0) => {
    const V = Ol(w.current, "close", v.pointerType);
    V ? v.openChangeTimeout.start(V, () => {
      n.setOpen(!1, Ve(Lt, D)), b?.events.emit("floating.closed", D);
    }) : O && (v.openChangeTimeout.clear(), n.setOpen(!1, Ve(Lt, D)), b?.events.emit("floating.closed", D));
  }), k = Se(() => {
    if (!v.handler)
      return;
    et(n.select("domReferenceElement")).removeEventListener("mousemove", v.handler), v.handler = void 0;
  }), M = Se(() => {
    Hl(v);
  });
  return x.useEffect(() => k, [k]), x.useEffect(() => {
    if (!i)
      return;
    function D(O) {
      O.open ? C.current = !1 : (C.current = O.reason === Lt, k(), v.openChangeTimeout.clear(), v.restTimeout.clear(), v.blockMouseMove = !0, v.restTimeoutPending = !1);
    }
    return r.on("openchange", D), () => {
      r.off("openchange", D);
    };
  }, [i, r, v, k]), x.useEffect(() => {
    if (!i)
      return;
    const D = d.current ?? (p ? n.select("domReferenceElement") : null);
    if (!pt(D))
      return;
    function O(_) {
      if (v.openChangeTimeout.clear(), v.blockMouseMove = !1, a && !jr(v.pointerType))
        return;
      const A = H1(R.current), L = Ol(w.current, "open", v.pointerType), B = bt(_), G = _.currentTarget ?? null, U = n.select("domReferenceElement");
      let Y = G;
      if (pt(B) && !n.context.triggerElements.hasElement(B)) {
        for (const J of n.context.triggerElements.elements())
          if (ze(J, B)) {
            Y = J;
            break;
          }
      }
      pt(G) && pt(U) && !n.context.triggerElements.hasElement(G) && ze(G, U) && (Y = U);
      const K = Y == null ? !1 : P(U, Y, B), j = n.select("open"), Z = E.current?.() ?? n.select("transitionStatus") === "ending", te = !j && Z && C.current, W = !K && pt(Y) && pt(U) && ze(U, Y) && te, X = A > 0 && !L, ee = K && (j || te) || W, le = !j || K;
      if (ee) {
        n.setOpen(!0, Ve(Lt, _, Y));
        return;
      }
      X || (L ? v.openChangeTimeout.start(L, () => {
        le && n.setOpen(!0, Ve(Lt, _, Y));
      }) : le && n.setOpen(!0, Ve(Lt, _, Y)));
    }
    function V(_) {
      if (N()) {
        M();
        return;
      }
      k();
      const A = n.select("domReferenceElement"), L = et(A);
      v.restTimeout.clear(), v.restTimeoutPending = !1;
      const B = o.current.floatingContext ?? g?.();
      if (T(_.relatedTarget))
        return;
      if (y.current && B) {
        n.select("open") || v.openChangeTimeout.clear();
        const Y = d.current;
        v.handler = y.current({
          ...B,
          tree: b,
          x: _.clientX,
          y: _.clientY,
          onClose() {
            M(), k(), S.current && !N() && Y === n.select("domReferenceElement") && I(_, !0);
          }
        }), L.addEventListener("mousemove", v.handler), v.handler(_);
        return;
      }
      (v.pointerType !== "touch" || !ze(n.select("floatingElement"), _.relatedTarget)) && I(_);
    }
    return u ? Yn(ut(D, "mousemove", O, {
      once: !0
    }), ut(D, "mouseenter", O), ut(D, "mouseleave", V)) : Yn(ut(D, "mouseenter", O), ut(D, "mouseleave", V));
  }, [k, M, o, w, I, n, i, y, v, p, P, N, T, a, u, R, d, b, S, g, E]), x.useMemo(() => {
    if (!i)
      return;
    function D(O) {
      v.pointerType = O.pointerType;
    }
    return {
      onPointerDown: D,
      onPointerEnter: D,
      onMouseMove(O) {
        const {
          nativeEvent: V
        } = O, _ = O.currentTarget, A = n.select("domReferenceElement"), L = n.select("open"), B = P(A, _, O.target);
        if (a && !jr(v.pointerType))
          return;
        if (L && B && v.handleCloseOptions?.blockPointerEvents) {
          const Y = n.select("floatingElement");
          if (Y) {
            const K = v.handleCloseOptions?.getScope?.() ?? _.ownerDocument.body;
            Fh(v, {
              scopeElement: K,
              referenceElement: _,
              floatingElement: Y
            });
          }
        }
        const G = H1(R.current);
        if (L && !B || G === 0 || !B && v.restTimeoutPending && O.movementX ** 2 + O.movementY ** 2 < 2)
          return;
        v.restTimeout.clear();
        function U() {
          if (v.restTimeoutPending = !1, N())
            return;
          const Y = n.select("open");
          !v.blockMouseMove && (!Y || B) && n.setOpen(!0, Ve(Lt, V, _));
        }
        v.pointerType === "touch" ? an.flushSync(() => {
          U();
        }) : B && L ? U() : (v.restTimeoutPending = !0, v.restTimeout.start(G, U));
      }
    };
  }, [i, v, N, P, a, n, R]);
}
function eo(t = []) {
  const e = t.map((c) => c?.reference), n = t.map((c) => c?.floating), o = t.map((c) => c?.item), r = t.map((c) => c?.trigger), i = x.useCallback(
    (c) => Xs(c, t, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e
  ), s = x.useCallback(
    (c) => Xs(c, t, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    n
  ), l = x.useCallback(
    (c) => Xs(c, t, "item"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    o
  ), a = x.useCallback(
    (c) => Xs(c, t, "trigger"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    r
  );
  return x.useMemo(() => ({
    getReferenceProps: i,
    getFloatingProps: s,
    getItemProps: l,
    getTriggerProps: a
  }), [i, s, l, a]);
}
function Xs(t, e, n) {
  const o = /* @__PURE__ */ new Map(), r = n === "item", i = {};
  n === "floating" && (i.tabIndex = -1, i[Qc] = "");
  for (const s in t)
    r && t && (s === eh || s === th) || (i[s] = t[s]);
  for (let s = 0; s < e.length; s += 1) {
    let l;
    const a = e[s]?.[n];
    typeof a == "function" ? l = t ? a(t) : null : l = a, l && mp(i, l, r, o);
  }
  return mp(i, t, r, o), i;
}
function mp(t, e, n, o) {
  for (const r in e) {
    const i = e[r];
    n && (r === eh || r === th) || (r.startsWith("on") ? (o.has(r) || o.set(r, []), typeof i == "function" && (o.get(r)?.push(i), t[r] = (...s) => o.get(r)?.map((l) => l(...s)).find((l) => l !== void 0))) : t[r] = i);
  }
}
const E9 = "Escape";
function da(t, e, n) {
  switch (t) {
    case "vertical":
      return e;
    case "horizontal":
      return n;
    default:
      return e || n;
  }
}
function Qs(t, e) {
  return da(e, t === ju || t === ls, t === Uo || t === Go);
}
function ic(t, e, n) {
  return da(e, t === ls, n ? t === Uo : t === Go) || t === "Enter" || t === " " || t === "";
}
function N9(t, e, n) {
  return da(e, n ? t === Uo : t === Go, t === ls);
}
function k9(t, e, n, o) {
  const r = n ? t === Go : t === Uo, i = t === ju;
  return e === "both" || e === "horizontal" && o && o > 1 ? t === E9 : da(e, r, i);
}
function bd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingElement"), i = n.useState("domReferenceElement"), s = n.context.dataRef, {
    listRef: l,
    activeIndex: a,
    onNavigate: c = () => {
    },
    enabled: u = !0,
    selectedIndex: d = null,
    allowEscape: f = !1,
    loopFocus: p = !1,
    nested: g = !1,
    rtl: h = !1,
    virtual: b = !1,
    focusItemOnOpen: v = "auto",
    focusItemOnHover: C = !0,
    openOnArrowKeyDown: y = !0,
    disabledIndices: w = void 0,
    orientation: R = "vertical",
    parentOrientation: S,
    cols: E = 1,
    id: N,
    resetOnPointerLeave: T = !0,
    externalTree: P
  } = e;
  process.env.NODE_ENV !== "production" && (f && (p || console.warn("`useListNavigation` looping must be enabled to allow escaping."), b || console.warn("`useListNavigation` must be virtual to allow escaping.")), R === "vertical" && E > 1 && console.warn("In grid list navigation mode (`cols` > 1), the `orientation` should", 'be either "horizontal" or "both".'));
  const I = Yi(r), k = $t(I), M = bo(), D = tr(P);
  ke(() => {
    s.current.orientation = R;
  }, [s, R]);
  const O = Jc(i), V = x.useRef(v), _ = x.useRef(d ?? -1), A = x.useRef(null), L = x.useRef(!0), B = Se(($) => {
    c(_.current === -1 ? null : _.current, $);
  }), G = x.useRef(B), U = x.useRef(!!r), Y = x.useRef(o), K = x.useRef(!1), j = x.useRef(!1), Z = x.useRef(null), te = $t(w), W = $t(o), X = $t(d), ee = $t(T), le = Se(() => {
    function $(ae) {
      b ? D?.events.emit("virtualfocus", ae) : Z.current = yl(ae, {
        sync: K.current,
        preventScroll: !0
      });
    }
    const Q = l.current[_.current], H = j.current;
    Q && $(Q), (K.current ? (ae) => ae() : requestAnimationFrame)(() => {
      const ae = l.current[_.current] || Q;
      if (!ae)
        return;
      Q || $(ae), // eslint-disable-next-line @typescript-eslint/no-use-before-define
      pe && (H || !L.current) && ae.scrollIntoView?.({
        block: "nearest",
        inline: "nearest"
      });
    });
  });
  ke(() => {
    u && (o && r ? (_.current = d ?? -1, V.current && d != null && (j.current = !0, B())) : U.current && (_.current = -1, G.current()));
  }, [u, o, r, d, B]), ke(() => {
    if (u) {
      if (!o) {
        K.current = !1;
        return;
      }
      if (r)
        if (a == null) {
          if (K.current = !1, X.current != null)
            return;
          if (U.current && (_.current = -1, le()), (!Y.current || !U.current) && V.current && (A.current != null || V.current === !0 && A.current == null)) {
            let $ = 0;
            const Q = () => {
              l.current[0] == null ? ($ < 2 && ($ ? requestAnimationFrame : queueMicrotask)(Q), $ += 1) : (_.current = A.current == null || ic(A.current, R, h) || g ? vl(l) : nu(l), A.current = null, B());
            };
            Q();
          }
        } else Ki(l.current, a) || (_.current = a, le(), j.current = !1);
    }
  }, [u, o, r, a, X, g, l, R, h, B, le, te]), ke(() => {
    if (!u || r || !D || b || !U.current)
      return;
    const $ = D.nodesRef.current, Q = $.find((ae) => ae.id === M)?.context?.elements.floating, H = Gt(et(r)), q = $.some((ae) => ae.context && ze(ae.context.elements.floating, H));
    Q && !q && L.current && Q.focus({
      preventScroll: !0
    });
  }, [u, r, D, M, b]), ke(() => {
    G.current = B, Y.current = o, U.current = !!r;
  }), ke(() => {
    o || (A.current = null, V.current = v);
  }, [o, v]);
  const J = a != null, ie = Se(($) => {
    if (!W.current)
      return;
    const Q = l.current.indexOf($.currentTarget);
    Q !== -1 && (_.current !== Q || a !== Q) && (_.current = Q, B($));
  }), pe = x.useMemo(() => ({
    onFocus(Q) {
      K.current = !0, ie(Q);
    },
    onClick: ({
      currentTarget: Q
    }) => Q.focus({
      preventScroll: !0
    }),
    // Safari
    onMouseMove(Q) {
      K.current = !0, j.current = !1, C && ie(Q);
    },
    onPointerLeave(Q) {
      if (!W.current || !L.current || Q.pointerType === "touch")
        return;
      K.current = !0;
      const H = Q.relatedTarget;
      if (!(!C || l.current.includes(H)) && ee.current && (Z.current?.(), Z.current = null, _.current = -1, B(Q), !b)) {
        const q = k.current, ae = Gt(et(q));
        q && ze(q, ae) && q.focus({
          preventScroll: !0
        });
      }
    }
  }), [ie, W, k, C, l, B, ee, b]), oe = x.useCallback(() => S ?? D?.nodesRef.current.find(($) => $.id === M)?.context?.dataRef?.current.orientation, [M, D, S]), re = Se(($) => {
    if (L.current = !1, K.current = !0, $.which === 229 || !W.current && $.currentTarget === k.current)
      return;
    if (g && k9($.key, R, h, E)) {
      Qs($.key, oe()) || Ft($), n.setOpen(!1, Ve($r, $.nativeEvent)), Ct(i) && (b ? D?.events.emit("virtualfocus", i) : i.focus());
      return;
    }
    const Q = _.current, H = vl(l, w), q = nu(l, w);
    if (O || ($.key === "Home" && (Ft($), _.current = H, B($)), $.key === "End" && (Ft($), _.current = q, B($))), E > 1) {
      const ae = Array.from({
        length: l.current.length
      }, () => ({
        width: 1,
        height: 1
      })), ge = sh(ae, E, !1), ue = ge.findIndex((ve) => ve != null && !No(l.current, ve, w)), Re = ge.reduce((ve, me, Ee) => me != null && !No(l.current, me, w) ? Ee : ve, -1), be = ge[ih(ge.map((ve) => ve != null ? l.current[ve] : null), {
        event: $,
        orientation: R,
        loopFocus: p,
        rtl: h,
        cols: E,
        // treat undefined (empty grid spaces) as disabled indices so we
        // don't end up in them
        disabledIndices: ah([...(typeof w != "function" ? w : null) || l.current.map((ve, me) => No(l.current, me, w) ? me : void 0), void 0], ge),
        minIndex: ue,
        maxIndex: Re,
        prevIndex: lh(
          _.current > q ? H : _.current,
          ae,
          ge,
          E,
          // use a corner matching the edge closest to the direction
          // we're moving in so we don't end up in the same item. Prefer
          // top/left over bottom/right.
          // eslint-disable-next-line no-nested-ternary
          $.key === ls ? "bl" : $.key === (h ? Uo : Go) ? "tr" : "tl"
        ),
        stopEvent: !0
      })];
      if (be != null && (_.current = be, B($)), R === "both")
        return;
    }
    if (Qs($.key, R)) {
      if (Ft($), o && !b && Gt($.currentTarget.ownerDocument) === $.currentTarget) {
        _.current = ic($.key, R, h) ? H : q, B($);
        return;
      }
      ic($.key, R, h) ? p ? Q >= q ? f && Q !== l.current.length ? _.current = -1 : (K.current = !1, _.current = H) : _.current = rn(l.current, {
        startingIndex: Q,
        disabledIndices: w
      }) : _.current = Math.min(q, rn(l.current, {
        startingIndex: Q,
        disabledIndices: w
      })) : p ? Q <= H ? f && Q !== -1 ? _.current = l.current.length : (K.current = !1, _.current = q) : _.current = rn(l.current, {
        startingIndex: Q,
        decrement: !0,
        disabledIndices: w
      }) : _.current = Math.max(H, rn(l.current, {
        startingIndex: Q,
        decrement: !0,
        disabledIndices: w
      })), Ki(l.current, _.current) && (_.current = -1), B($);
    }
  }), de = x.useMemo(() => b && o && J && {
    "aria-activedescendant": `${N}-${a}`
  }, [b, o, J, N, a]), xe = x.useMemo(() => ({
    "aria-orientation": R === "both" ? void 0 : R,
    ...O ? {} : de,
    onKeyDown($) {
      if ($.key === "Tab" && $.shiftKey && o && !b) {
        const Q = bt($.nativeEvent);
        if (Q && !ze(k.current, Q))
          return;
        Ft($), n.setOpen(!1, Ve(Po, $.nativeEvent)), Ct(i) && i.focus();
        return;
      }
      re($);
    },
    onPointerMove() {
      L.current = !0;
    }
  }), [de, re, k, R, O, n, o, b, i]), se = x.useMemo(() => {
    function $(H) {
      v === "auto" && qm(H.nativeEvent) && (V.current = !b);
    }
    function Q(H) {
      V.current = v, v === "auto" && Zm(H.nativeEvent) && (V.current = !0);
    }
    return {
      onKeyDown(H) {
        const q = n.select("open");
        L.current = !1;
        const ae = H.key.startsWith("Arrow"), ge = N9(H.key, oe(), h), ue = Qs(H.key, R), Re = (g ? ge : ue) || H.key === "Enter" || H.key.trim() === "";
        if (b && q)
          return re(H);
        if (!(!q && !y && ae)) {
          if (Re) {
            const be = Qs(H.key, oe());
            A.current = g && be ? null : H.key;
          }
          if (g) {
            ge && (Ft(H), q ? (_.current = vl(l, te.current), B(H)) : n.setOpen(!0, Ve($r, H.nativeEvent, H.currentTarget)));
            return;
          }
          ue && (X.current != null && (_.current = X.current), Ft(H), !q && y ? n.setOpen(!0, Ve($r, H.nativeEvent, H.currentTarget)) : re(H), q && B(H));
        }
      },
      onFocus(H) {
        n.select("open") && !b && (_.current = -1, B(H));
      },
      onPointerDown: Q,
      onPointerEnter: Q,
      onMouseDown: $,
      onClick: $
    };
  }, [re, te, v, l, g, B, n, y, R, oe, h, X, b]), fe = x.useMemo(() => ({
    ...de,
    ...se
  }), [de, se]);
  return x.useMemo(() => u ? {
    reference: fe,
    floating: xe,
    item: pe,
    trigger: se
  } : {}, [u, fe, xe, se, pe]);
}
const M9 = /* @__PURE__ */ new Map([["select", "listbox"], ["combobox", "listbox"], ["label", !1]]);
function vd(t, e = {}) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.useState("open"), r = n.useState("floatingId"), i = n.useState("domReferenceElement"), s = n.useState("floatingElement"), {
    role: l = "dialog"
  } = e, a = Do(), c = i?.id || a, u = x.useMemo(() => Yi(s)?.id || r, [s, r]), d = M9.get(l) ?? l, p = bo() != null, g = x.useMemo(() => d === "tooltip" || l === "label" ? St : {
    "aria-haspopup": d === "alertdialog" ? "dialog" : d,
    "aria-expanded": "false",
    ...d === "listbox" && {
      role: "combobox"
    },
    ...d === "menu" && p && {
      role: "menuitem"
    },
    ...l === "select" && {
      "aria-autocomplete": "none"
    },
    ...l === "combobox" && {
      "aria-autocomplete": "list"
    }
  }, [d, p, l]), h = x.useMemo(() => d === "tooltip" || l === "label" ? {
    [`aria-${l === "label" ? "labelledby" : "describedby"}`]: o ? u : void 0
  } : {
    ...g,
    "aria-expanded": o ? "true" : "false",
    "aria-controls": o ? u : void 0,
    ...d === "menu" && {
      id: c
    }
  }, [d, u, o, c, l, g]), b = x.useMemo(() => {
    const C = {
      id: u,
      ...d && {
        role: d
      }
    };
    return d === "tooltip" || l === "label" ? C : {
      ...C,
      ...d === "menu" && {
        "aria-labelledby": c
      }
    };
  }, [d, u, c, l]), v = x.useCallback(({
    active: C,
    selected: y
  }) => {
    const w = {
      role: "option",
      ...C && {
        id: `${u}-fui-option`
      }
    };
    switch (l) {
      case "select":
      case "combobox":
        return {
          ...w,
          "aria-selected": y
        };
    }
    return {};
  }, [u, l]);
  return x.useMemo(() => ({
    reference: h,
    floating: b,
    item: v,
    trigger: g
  }), [h, b, g, v]);
}
function yd(t, e) {
  const n = "rootStore" in t ? t.rootStore : t, o = n.context.dataRef, r = n.useState("open"), {
    listRef: i,
    elementsRef: s,
    activeIndex: l,
    onMatch: a,
    onTypingChange: c,
    enabled: u = !0,
    resetMs: d = 750,
    selectedIndex: f = null
  } = e, p = Vt(), g = x.useRef(""), h = x.useRef(f ?? l ?? -1), b = x.useRef(null);
  ke(() => {
    !r && f !== null || (p.clear(), b.current = null, g.current !== "" && (g.current = ""));
  }, [r, f, p]), ke(() => {
    r && g.current === "" && (h.current = f ?? l ?? -1);
  }, [r, f, l]);
  const v = Se((S) => {
    S ? o.current.typing || (o.current.typing = S, c?.(S)) : o.current.typing && (o.current.typing = S, c?.(S));
  }), C = Se((S) => {
    function E(O) {
      const V = s?.current[O];
      return !V || sa(V);
    }
    function N(O, V, _ = 0) {
      if (O.length === 0)
        return -1;
      const A = (_ % O.length + O.length) % O.length, L = V.toLocaleLowerCase();
      for (let B = 0; B < O.length; B += 1) {
        const G = (A + B) % O.length;
        if (!(!O[G]?.toLocaleLowerCase().startsWith(L) || !E(G)))
          return G;
      }
      return -1;
    }
    const T = i.current;
    if (g.current.length > 0 && S.key === " " && (Ft(S), v(!0)), g.current.length > 0 && g.current[0] !== " " && N(T, g.current) === -1 && S.key !== " " && v(!1), T == null || // Character key.
    S.key.length !== 1 || // Modifier key.
    S.ctrlKey || S.metaKey || S.altKey)
      return;
    r && S.key !== " " && (Ft(S), v(!0));
    const P = g.current === "";
    P && (h.current = f ?? l ?? -1), T.every((O) => O ? O[0]?.toLocaleLowerCase() !== O[1]?.toLocaleLowerCase() : !0) && g.current === S.key && (g.current = "", h.current = b.current), g.current += S.key, p.start(d, () => {
      g.current = "", h.current = b.current, v(!1);
    });
    const M = ((P ? f ?? l ?? -1 : h.current) ?? 0) + 1, D = N(T, g.current, M);
    D !== -1 ? (a?.(D), b.current = D) : S.key !== " " && (g.current = "", v(!1));
  }), y = Se((S) => {
    const E = S.relatedTarget, N = n.select("domReferenceElement"), T = n.select("floatingElement"), P = ze(N, E), I = ze(T, E);
    P || I || (p.clear(), g.current = "", h.current = b.current, v(!1));
  }), w = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]), R = x.useMemo(() => ({
    onKeyDown: C,
    onBlur: y
  }), [C, y]);
  return x.useMemo(() => u ? {
    reference: w,
    floating: R
  } : {}, [u, w, R]);
}
const hp = 0.1, I9 = hp * hp, Nt = 0.5;
function Js(t, e, n, o, r, i) {
  return o >= e != i >= e && t <= (r - n) * (e - o) / (i - o) + n;
}
function el(t, e, n, o, r, i, s, l, a, c) {
  let u = !1;
  return Js(t, e, n, o, r, i) && (u = !u), Js(t, e, r, i, s, l) && (u = !u), Js(t, e, s, l, a, c) && (u = !u), Js(t, e, a, c, n, o) && (u = !u), u;
}
function P9(t, e, n) {
  return t >= n.x && t <= n.x + n.width && e >= n.y && e <= n.y + n.height;
}
function tl(t, e, n, o, r, i) {
  const s = Math.min(n, r), l = Math.max(n, r), a = Math.min(o, i), c = Math.max(o, i);
  return t >= s && t <= l && e >= a && e <= c;
}
function hs(t = {}) {
  const {
    blockPointerEvents: e = !1
  } = t, n = new xn(), o = ({
    x: r,
    y: i,
    placement: s,
    elements: l,
    onClose: a,
    nodeId: c,
    tree: u
  }) => {
    const d = s?.split("-")[0];
    let f = !1, p = null, g = null, h = typeof performance < "u" ? performance.now() : 0;
    function b(C, y) {
      const w = performance.now(), R = w - h;
      if (p === null || g === null || R === 0)
        return p = C, g = y, h = w, !1;
      const S = C - p, E = y - g, N = S * S + E * E, T = R * R * I9;
      return p = C, g = y, h = w, N < T;
    }
    function v() {
      n.clear(), a();
    }
    return function(y) {
      n.clear();
      const w = l.domReference, R = l.floating;
      if (!w || !R || d == null || r == null || i == null)
        return;
      const {
        clientX: S,
        clientY: E
      } = y, N = bt(y), T = y.type === "mouseleave", P = ze(R, N), I = ze(w, N);
      if (P && (f = !0, !T))
        return;
      if (I && (f = !1, !T)) {
        f = !0;
        return;
      }
      if (T && pt(y.relatedTarget) && ze(R, y.relatedTarget))
        return;
      function k() {
        return !!(u && uo(u.nodesRef.current, c).length > 0);
      }
      function M() {
        k() || v();
      }
      if (k())
        return;
      const D = w.getBoundingClientRect(), O = R.getBoundingClientRect(), V = r > O.right - O.width / 2, _ = i > O.bottom - O.height / 2, A = O.width > D.width, L = O.height > D.height, B = (A ? D : O).left, G = (A ? D : O).right, U = (L ? D : O).top, Y = (L ? D : O).bottom;
      if (d === "top" && i >= D.bottom - 1 || d === "bottom" && i <= D.top + 1 || d === "left" && r >= D.right - 1 || d === "right" && r <= D.left + 1) {
        M();
        return;
      }
      let K = !1;
      switch (d) {
        case "top":
          K = tl(S, E, B, D.top + 1, G, O.bottom - 1);
          break;
        case "bottom":
          K = tl(S, E, B, O.top + 1, G, D.bottom - 1);
          break;
        case "left":
          K = tl(S, E, O.right - 1, Y, D.left + 1, U);
          break;
        case "right":
          K = tl(S, E, D.right - 1, Y, O.left + 1, U);
          break;
      }
      if (K)
        return;
      if (f && !P9(S, E, D)) {
        M();
        return;
      }
      if (!T && b(S, E)) {
        M();
        return;
      }
      let j = !1;
      switch (d) {
        case "top": {
          const Z = A ? Nt / 2 : Nt * 4, te = A || V ? r + Z : r - Z, W = A ? r - Z : V ? r + Z : r - Z, X = i + Nt + 1, ee = V || A ? O.bottom - Nt : O.top, le = V ? A ? O.bottom - Nt : O.top : O.bottom - Nt;
          j = el(S, E, te, X, W, X, O.left, ee, O.right, le);
          break;
        }
        case "bottom": {
          const Z = A ? Nt / 2 : Nt * 4, te = A || V ? r + Z : r - Z, W = A ? r - Z : V ? r + Z : r - Z, X = i - Nt, ee = V || A ? O.top + Nt : O.bottom, le = V ? A ? O.top + Nt : O.bottom : O.top + Nt;
          j = el(S, E, te, X, W, X, O.left, ee, O.right, le);
          break;
        }
        case "left": {
          const Z = L ? Nt / 2 : Nt * 4, te = L || _ ? i + Z : i - Z, W = L ? i - Z : _ ? i + Z : i - Z, X = r + Nt + 1, ee = _ || L ? O.right - Nt : O.left, le = _ ? L ? O.right - Nt : O.left : O.right - Nt;
          j = el(S, E, ee, O.top, le, O.bottom, X, te, X, W);
          break;
        }
        case "right": {
          const Z = L ? Nt / 2 : Nt * 4, te = L || _ ? i + Z : i - Z, W = L ? i - Z : _ ? i + Z : i - Z, X = r - Nt, ee = _ || L ? O.left + Nt : O.right, le = _ ? L ? O.left + Nt : O.right : O.left + Nt;
          j = el(S, E, X, te, X, W, ee, O.top, le, O.bottom);
          break;
        }
      }
      j ? f || n.start(40, M) : M();
    };
  };
  return o.__options = {
    ...t,
    blockPointerEvents: e
  }, o;
}
const Hh = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Hh.displayName = "ToolbarRootContext");
function xd(t) {
  return x.useContext(Hh);
}
const Br = "ArrowUp", cr = "ArrowDown", Zi = "ArrowLeft", Wr = "ArrowRight", bs = "Home", vs = "End", zh = /* @__PURE__ */ new Set([Zi, Wr]), T9 = /* @__PURE__ */ new Set([Zi, Wr, bs, vs]), Bh = /* @__PURE__ */ new Set([Br, cr]), O9 = /* @__PURE__ */ new Set([Br, cr, bs, vs]), Wh = /* @__PURE__ */ new Set([...zh, ...Bh]), D9 = /* @__PURE__ */ new Set([...Wh, bs, vs]), ys = /* @__PURE__ */ new Set([Br, cr, Zi, Wr, bs, vs]), Uh = "Shift", V9 = "Control", _9 = "Alt", A9 = "Meta", L9 = /* @__PURE__ */ new Set([Uh, V9, _9, A9]);
function F9(t) {
  return Ct(t) && t.tagName === "INPUT";
}
function bp(t) {
  return !!(F9(t) && t.selectionStart != null || Ct(t) && t.tagName === "TEXTAREA");
}
function vp(t, e, n, o) {
  if (!t || !e || !e.scrollTo)
    return;
  let r = t.scrollLeft, i = t.scrollTop;
  const s = t.clientWidth < t.scrollWidth, l = t.clientHeight < t.scrollHeight;
  if (s && o !== "vertical") {
    const a = yp(t, e, "left"), c = nl(t), u = nl(e);
    n === "ltr" && (a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight ? r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight : a - u.scrollMarginLeft < t.scrollLeft + c.scrollPaddingLeft && (r = a - u.scrollMarginLeft - c.scrollPaddingLeft)), n === "rtl" && (a - u.scrollMarginRight < t.scrollLeft + c.scrollPaddingLeft ? r = a - u.scrollMarginLeft - c.scrollPaddingLeft : a + e.offsetWidth + u.scrollMarginRight > t.scrollLeft + t.clientWidth - c.scrollPaddingRight && (r = a + e.offsetWidth + u.scrollMarginRight - t.clientWidth + c.scrollPaddingRight));
  }
  if (l && o !== "horizontal") {
    const a = yp(t, e, "top"), c = nl(t), u = nl(e);
    a - u.scrollMarginTop < t.scrollTop + c.scrollPaddingTop ? i = a - u.scrollMarginTop - c.scrollPaddingTop : a + e.offsetHeight + u.scrollMarginBottom > t.scrollTop + t.clientHeight - c.scrollPaddingBottom && (i = a + e.offsetHeight + u.scrollMarginBottom - t.clientHeight + c.scrollPaddingBottom);
  }
  t.scrollTo({
    left: r,
    top: i,
    behavior: "auto"
  });
}
function yp(t, e, n) {
  const o = n === "left" ? "offsetLeft" : "offsetTop";
  let r = 0;
  for (; e.offsetParent && (r += e[o], e.offsetParent !== t); )
    e = e.offsetParent;
  return r;
}
function nl(t) {
  const e = getComputedStyle(t);
  return {
    scrollMarginTop: parseFloat(e.scrollMarginTop) || 0,
    scrollMarginRight: parseFloat(e.scrollMarginRight) || 0,
    scrollMarginBottom: parseFloat(e.scrollMarginBottom) || 0,
    scrollMarginLeft: parseFloat(e.scrollMarginLeft) || 0,
    scrollPaddingTop: parseFloat(e.scrollPaddingTop) || 0,
    scrollPaddingRight: parseFloat(e.scrollPaddingRight) || 0,
    scrollPaddingBottom: parseFloat(e.scrollPaddingBottom) || 0,
    scrollPaddingLeft: parseFloat(e.scrollPaddingLeft) || 0
  };
}
function Rr(t) {
  return t === "starting" ? z8 : St;
}
const $9 = {
  ...Nn,
  ...Bt
}, Gh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a
  } = Jn(), {
    side: c,
    align: u
  } = rs(), d = xd() != null, f = a.useState("open"), p = a.useState("transitionStatus"), g = a.useState("popupProps"), h = a.useState("mounted"), b = a.useState("instantType"), v = a.useState("activeTriggerElement"), C = a.useState("parent"), y = a.useState("lastOpenChangeReason"), w = a.useState("rootId"), R = a.useState("floatingRootContext"), S = a.useState("floatingTreeRoot"), E = a.useState("closeDelay"), N = a.useState("activeTriggerElement"), T = C.type === "context-menu";
  jt({
    open: f,
    ref: a.context.popupRef,
    onComplete() {
      f && a.context.onOpenChangeComplete?.(!0);
    }
  }), x.useEffect(() => {
    function V(_) {
      a.setOpen(!1, Ve(_.reason, _.domEvent));
    }
    return S.events.on("close", V), () => {
      S.events.off("close", V);
    };
  }, [S.events, a]);
  const P = a.useState("hoverEnabled"), I = a.useState("disabled");
  ua(R, {
    enabled: P && !I && !T && C.type !== "menubar",
    closeDelay: E
  });
  const k = {
    transitionStatus: p,
    side: c,
    align: u,
    open: f,
    nested: C.type === "menu",
    instant: b
  }, M = x.useCallback((V) => {
    a.set("popupElement", V);
  }, [a]), D = $e("div", e, {
    state: k,
    ref: [n, a.context.popupRef, M],
    stateAttributesMapping: $9,
    props: [g, {
      onKeyDown(V) {
        d && ys.has(V.key) && V.stopPropagation();
      }
    }, Rr(p), l, {
      "data-rootownerid": w
    }]
  });
  let O = C.type === void 0 || T;
  return (v || C.type === "menubar" && y !== is) && (O = !0), /* @__PURE__ */ m(oi, {
    context: R,
    modal: T,
    disabled: !h,
    returnFocus: s === void 0 ? O : s,
    initialFocus: C.type !== "menu",
    restoreFocus: !0,
    externalTree: C.type !== "menubar" ? S : void 0,
    previousFocusableElement: N,
    nextFocusableElement: C.type === void 0 ? a.context.triggerFocusTargetRef : void 0,
    beforeContentFocusGuardRef: C.type === void 0 ? a.context.beforeContentFocusGuardRef : void 0,
    children: D
  });
});
process.env.NODE_ENV !== "production" && (Gh.displayName = "MenuPopup");
const Cd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Cd.displayName = "MenuPortalContext");
function H9() {
  const t = x.useContext(Cd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Portal> is missing." : rt(32));
  return t;
}
const Yh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Jn();
  return i.useState("mounted") || o ? /* @__PURE__ */ m(Cd.Provider, {
    value: o,
    children: /* @__PURE__ */ m(ni, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Yh.displayName = "MenuPortal");
function Er(t) {
  return Eu(19) ? t : t ? "true" : void 0;
}
const jh = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (jh.displayName = "DirectionContext");
function xs() {
  return x.useContext(jh)?.direction ?? "ltr";
}
const z9 = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: i,
      platform: s,
      elements: l,
      middlewareData: a
    } = e, {
      element: c,
      padding: u = 0,
      offsetParent: d = "real"
    } = To(t, e) || {};
    if (c == null)
      return {};
    const f = rh(u), p = {
      x: n,
      y: o
    }, g = Zu(r), h = qu(g), b = await s.getDimensions(c), v = g === "y", C = v ? "top" : "left", y = v ? "bottom" : "right", w = v ? "clientHeight" : "clientWidth", R = i.reference[h] + i.reference[g] - p[g] - i.floating[h], S = p[g] - i.reference[g], E = d === "real" ? await s.getOffsetParent?.(c) : l.floating;
    let N = l.floating[w] || i.floating[h];
    (!N || !await s.isElement?.(E)) && (N = l.floating[w] || i.floating[h]);
    const T = R / 2 - S / 2, P = N / 2 - b[h] / 2 - 1, I = Math.min(f[C], P), k = Math.min(f[y], P), M = I, D = N - b[h] - k, O = N / 2 - b[h] / 2 + T, V = eu(M, O, D), _ = !a.arrow && er(r) != null && O !== V && i.reference[h] / 2 - (O < M ? I : k) - b[h] / 2 < 0, A = _ ? O < M ? O - M : O - D : 0;
    return {
      [g]: p[g] + A,
      data: {
        [g]: V,
        centerOffset: O - V - A,
        ..._ && {
          alignmentOffset: A
        }
      },
      reset: _
    };
  }
}), B9 = (t, e) => ({
  ...z9(t),
  options: [t, e]
}), W9 = {
  name: "hide",
  async fn(t) {
    const {
      width: e,
      height: n,
      x: o,
      y: r
    } = t.rects.reference, i = e === 0 && n === 0 && o === 0 && r === 0;
    return {
      data: {
        referenceHidden: (await H6().fn(t)).data?.referenceHidden || i
      }
    };
  }
}, Cl = {
  sideX: "left",
  sideY: "top"
}, fa = {
  name: "adaptiveOrigin",
  async fn(t) {
    const {
      x: e,
      y: n,
      rects: {
        floating: o
      },
      elements: {
        floating: r
      },
      platform: i,
      strategy: s,
      placement: l
    } = t, a = wt(r), c = a.getComputedStyle(r);
    if (!(c.transitionDuration !== "0s" && c.transitionDuration !== ""))
      return {
        x: e,
        y: n,
        data: Cl
      };
    const d = await i.getOffsetParent?.(r);
    let f = {
      width: 0,
      height: 0
    };
    if (s === "fixed" && a?.visualViewport)
      f = {
        width: a.visualViewport.width,
        height: a.visualViewport.height
      };
    else if (d === a) {
      const C = et(r);
      f = {
        width: C.documentElement.clientWidth,
        height: C.documentElement.clientHeight
      };
    } else await i.isElement?.(d) && (f = await i.getDimensions(d));
    const p = yn(l);
    let g = e, h = n;
    p === "left" && (g = f.width - (e + o.width)), p === "top" && (h = f.height - (n + o.height));
    const b = p === "left" ? "right" : Cl.sideX, v = p === "top" ? "bottom" : Cl.sideY;
    return {
      x: g,
      y: h,
      data: {
        sideX: b,
        sideY: v
      }
    };
  }
};
function Kh(t, e, n) {
  const o = t === "inline-start" || t === "inline-end";
  return {
    top: "top",
    right: o ? n ? "inline-start" : "inline-end" : "right",
    bottom: "bottom",
    left: o ? n ? "inline-end" : "inline-start" : "left"
  }[e];
}
function xp(t, e, n) {
  const {
    rects: o,
    placement: r
  } = t;
  return {
    side: Kh(e, yn(r), n),
    align: er(r) || "center",
    anchor: {
      width: o.reference.width,
      height: o.reference.height
    },
    positioner: {
      width: o.floating.width,
      height: o.floating.height
    }
  };
}
function ri(t) {
  const {
    // Public parameters
    anchor: e,
    positionMethod: n = "absolute",
    side: o = "bottom",
    sideOffset: r = 0,
    align: i = "center",
    alignOffset: s = 0,
    collisionBoundary: l,
    collisionPadding: a = 5,
    sticky: c = !1,
    arrowPadding: u = 5,
    disableAnchorTracking: d = !1,
    // Private parameters
    keepMounted: f = !1,
    floatingRootContext: p,
    mounted: g,
    collisionAvoidance: h,
    shiftCrossAxis: b = !1,
    nodeId: v,
    adaptiveOrigin: C,
    lazyFlip: y = !1,
    externalTree: w
  } = t, [R, S] = x.useState(null);
  !g && R !== null && S(null);
  const E = h.side || "flip", N = h.align || "flip", T = h.fallbackAxisSide || "end", P = typeof e == "function" ? e : void 0, I = Se(P), k = P ? I : e, M = $t(e), D = $t(g), V = xs() === "rtl", _ = R || {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    "inline-end": V ? "left" : "right",
    "inline-start": V ? "right" : "left"
  }[o], A = i === "center" ? _ : `${_}-${i}`;
  let L = a;
  const B = 1, G = o === "bottom" ? B : 0, U = o === "top" ? B : 0, Y = o === "right" ? B : 0, K = o === "left" ? B : 0;
  typeof L == "number" ? L = {
    top: L + G,
    right: L + K,
    bottom: L + U,
    left: L + Y
  } : L && (L = {
    top: (L.top || 0) + G,
    right: (L.right || 0) + K,
    bottom: (L.bottom || 0) + U,
    left: (L.left || 0) + Y
  });
  const j = {
    boundary: l === "clipping-ancestors" ? "clippingAncestors" : l,
    padding: L
  }, Z = x.useRef(null), te = $t(r), W = $t(s), le = [_6((He) => {
    const ye = xp(He, o, V), Oe = typeof te.current == "function" ? te.current(ye) : te.current, Ie = typeof W.current == "function" ? W.current(ye) : W.current;
    return {
      mainAxis: Oe,
      crossAxis: Ie,
      alignmentAxis: Ie
    };
  }, [typeof r != "function" ? r : 0, typeof s != "function" ? s : 0, V, o])], J = N === "none" && E !== "shift", ie = !J && (c || b || E === "shift"), pe = E === "none" ? null : F6({
    ...j,
    // Ensure the popup flips if it's been limited by its --available-height and it resizes.
    // Since the size() padding is smaller than the flip() padding, flip() will take precedence.
    padding: {
      top: L.top + B,
      right: L.right + B,
      bottom: L.bottom + B,
      left: L.left + B
    },
    mainAxis: !b && E === "flip",
    crossAxis: N === "flip" ? "alignment" : !1,
    fallbackAxisSideDirection: T
  }), oe = J ? null : A6((He) => {
    const ye = et(He.elements.floating).documentElement;
    return {
      ...j,
      // Use the Layout Viewport to avoid shifting around when pinch-zooming
      // for context menus.
      rootBoundary: b ? {
        x: 0,
        y: 0,
        width: ye.clientWidth,
        height: ye.clientHeight
      } : void 0,
      mainAxis: N !== "none",
      crossAxis: ie,
      limiter: c || b ? void 0 : L6((Oe) => {
        if (!Z.current)
          return {};
        const {
          width: Ie,
          height: Le
        } = Z.current.getBoundingClientRect(), Be = Dn(yn(Oe.placement)), Te = Be === "y" ? Ie : Le, vt = Be === "y" ? L.left + L.right : L.top + L.bottom;
        return {
          offset: Te / 2 + vt / 2
        };
      })
    };
  }, [j, c, b, L, N]);
  E === "shift" || N === "shift" || i === "center" ? le.push(oe, pe) : le.push(pe, oe), le.push($6({
    ...j,
    apply({
      elements: {
        floating: He
      },
      availableWidth: ye,
      availableHeight: Oe,
      rects: Ie
    }) {
      if (!D.current)
        return;
      const Le = He.style;
      Le.setProperty("--available-width", `${ye}px`), Le.setProperty("--available-height", `${Oe}px`);
      const Be = wt(He).devicePixelRatio || 1, {
        x: Te,
        y: vt,
        width: nt,
        height: we
      } = Ie.reference, Ne = (Math.round((Te + nt) * Be) - Math.round(Te * Be)) / Be, Ae = (Math.round((vt + we) * Be) - Math.round(vt * Be)) / Be;
      Le.setProperty("--anchor-width", `${Ne}px`), Le.setProperty("--anchor-height", `${Ae}px`);
    }
  }), B9(() => ({
    // `transform-origin` calculations rely on an element existing. If the arrow hasn't been set,
    // we'll create a fake element.
    element: Z.current || et(Z.current).createElement("div"),
    padding: u,
    offsetParent: "floating"
  }), [u]), {
    name: "transformOrigin",
    fn(He) {
      const {
        elements: ye,
        middlewareData: Oe,
        placement: Ie,
        rects: Le,
        y: Be
      } = He, Te = yn(Ie), vt = Dn(Te), nt = Z.current, we = Oe.arrow?.x || 0, Ne = Oe.arrow?.y || 0, Ae = nt?.clientWidth || 0, Fe = nt?.clientHeight || 0, Xe = we + Ae / 2, qe = Ne + Fe / 2, it = Math.abs(Oe.shift?.y || 0), Ge = Le.reference.height / 2, Ze = typeof r == "function" ? r(xp(He, o, V)) : r, tt = it > Ze, st = {
        top: `${Xe}px calc(100% + ${Ze}px)`,
        bottom: `${Xe}px ${-Ze}px`,
        left: `calc(100% + ${Ze}px) ${qe}px`,
        right: `${-Ze}px ${qe}px`
      }[Te], gt = `${Xe}px ${Le.reference.y + Ge - Be}px`;
      return ye.floating.style.setProperty("--transform-origin", ie && vt === "y" && tt ? gt : st), {};
    }
  }, W9, C), ke(() => {
    !g && p && p.update({
      referenceElement: null,
      floatingElement: null,
      domReferenceElement: null,
      positionReference: null
    });
  }, [g, p]);
  const re = x.useMemo(() => ({
    elementResize: !d && typeof ResizeObserver < "u",
    layoutShift: !d && typeof IntersectionObserver < "u"
  }), [d]), {
    refs: de,
    elements: xe,
    x: se,
    y: fe,
    middlewareData: $,
    update: Q,
    placement: H,
    context: q,
    isPositioned: ae,
    floatingStyles: ge
  } = S9({
    rootContext: p,
    open: f ? g : void 0,
    placement: A,
    middleware: le,
    strategy: n,
    whileElementsMounted: f ? void 0 : (...He) => rp(...He, re),
    nodeId: v,
    externalTree: w
  }), {
    sideX: ue,
    sideY: Re
  } = $.adaptiveOrigin || Cl, be = ae ? n : "fixed", ve = x.useMemo(() => {
    const He = C ? {
      position: be,
      [ue]: se,
      [Re]: fe
    } : {
      position: be,
      ...ge
    };
    return ae || (He.opacity = 0), He;
  }, [C, be, ue, se, Re, fe, ge, ae]), me = x.useRef(null);
  ke(() => {
    if (!g)
      return;
    const He = M.current, ye = typeof He == "function" ? He() : He, Ie = (Cp(ye) ? ye.current : ye) || null || null;
    Ie !== me.current && (de.setPositionReference(Ie), me.current = Ie);
  }, [g, de, k, M]), x.useEffect(() => {
    if (!g)
      return;
    const He = M.current;
    typeof He != "function" && Cp(He) && He.current !== me.current && (de.setPositionReference(He.current), me.current = He.current);
  }, [g, de, k, M]), x.useEffect(() => {
    if (f && g && xe.domReference && xe.floating)
      return rp(xe.domReference, xe.floating, Q, re);
  }, [f, g, xe, Q, re]);
  const Ee = yn(H), Pe = Kh(o, Ee, V), Me = er(H) || "center", _e = !!$.hide?.referenceHidden;
  ke(() => {
    y && g && ae && S(Ee);
  }, [y, g, ae, Ee]);
  const Ue = x.useMemo(() => ({
    position: "absolute",
    top: $.arrow?.y,
    left: $.arrow?.x
  }), [$.arrow]), Ye = $.arrow?.centerOffset !== 0;
  return x.useMemo(() => ({
    positionerStyles: ve,
    arrowStyles: Ue,
    arrowRef: Z,
    arrowUncentered: Ye,
    side: Pe,
    align: Me,
    physicalSide: Ee,
    anchorHidden: _e,
    refs: de,
    context: q,
    isPositioned: ae,
    update: Q
  }), [ve, Ue, Z, Ye, Pe, Me, Ee, _e, de, q, ae, Q]);
}
function Cp(t) {
  return t != null && "current" in t;
}
function ii(t) {
  const {
    children: e,
    elementsRef: n,
    labelsRef: o,
    onMapChange: r
  } = t, i = Se(r), s = x.useRef(0), l = Tt(G9).current, a = Tt(U9).current, [c, u] = x.useState(0), d = x.useRef(c), f = Se((v, C) => {
    a.set(v, C ?? null), d.current += 1, u(d.current);
  }), p = Se((v) => {
    a.delete(v), d.current += 1, u(d.current);
  }), g = x.useMemo(() => {
    const v = /* @__PURE__ */ new Map();
    return Array.from(a.keys()).filter((y) => y.isConnected).sort(Y9).forEach((y, w) => {
      const R = a.get(y) ?? {};
      v.set(y, {
        ...R,
        index: w
      });
    }), v;
  }, [a, c]);
  ke(() => {
    if (typeof MutationObserver != "function" || g.size === 0)
      return;
    const v = new MutationObserver((C) => {
      const y = /* @__PURE__ */ new Set(), w = (R) => y.has(R) ? y.delete(R) : y.add(R);
      C.forEach((R) => {
        R.removedNodes.forEach(w), R.addedNodes.forEach(w);
      }), y.size === 0 && (d.current += 1, u(d.current));
    });
    return g.forEach((C, y) => {
      y.parentElement && v.observe(y.parentElement, {
        childList: !0
      });
    }), () => {
      v.disconnect();
    };
  }, [g]), ke(() => {
    d.current === c && (n.current.length !== g.size && (n.current.length = g.size), o && o.current.length !== g.size && (o.current.length = g.size), s.current = g.size), i(g);
  }, [i, g, n, o, c]), ke(() => () => {
    n.current = [];
  }, [n]), ke(() => () => {
    o && (o.current = []);
  }, [o]);
  const h = Se((v) => (l.add(v), () => {
    l.delete(v);
  }));
  ke(() => {
    l.forEach((v) => v(g));
  }, [l, g]);
  const b = x.useMemo(() => ({
    register: f,
    unregister: p,
    subscribeMapChange: h,
    elementsRef: n,
    labelsRef: o,
    nextIndexRef: s
  }), [f, p, h, n, o, s]);
  return /* @__PURE__ */ m(Wu.Provider, {
    value: b,
    children: e
  });
}
function U9() {
  return /* @__PURE__ */ new Map();
}
function G9() {
  return /* @__PURE__ */ new Set();
}
function Y9(t, e) {
  const n = t.compareDocumentPosition(e);
  return n & Node.DOCUMENT_POSITION_FOLLOWING || n & Node.DOCUMENT_POSITION_CONTAINED_BY ? -1 : n & Node.DOCUMENT_POSITION_PRECEDING || n & Node.DOCUMENT_POSITION_CONTAINS ? 1 : 0;
}
const si = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    cutout: o,
    ...r
  } = e;
  let i;
  if (o) {
    const s = o.getBoundingClientRect();
    i = `polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,${s.left}px ${s.top}px,${s.left}px ${s.bottom}px,${s.right}px ${s.bottom}px,${s.right}px ${s.top}px,${s.left}px ${s.top}px)`;
  }
  return /* @__PURE__ */ m("div", {
    ref: n,
    role: "presentation",
    "data-base-ui-inert": "",
    ...r,
    style: {
      position: "fixed",
      inset: 0,
      userSelect: "none",
      WebkitUserSelect: "none",
      clipPath: i
    }
  });
});
process.env.NODE_ENV !== "production" && (si.displayName = "InternalBackdrop");
function li(t, e, {
  styles: n,
  transitionStatus: o,
  props: r,
  refs: i,
  hidden: s,
  inert: l = !1
}) {
  const a = {
    ...n
  };
  return l && (a.pointerEvents = "none"), $e("div", t, {
    state: e,
    ref: i,
    props: [{
      role: "presentation",
      hidden: s,
      style: a
    }, Rr(o), r],
    stateAttributesMapping: Nn
  });
}
let wp = {}, Sp = {}, Rp = "";
function j9(t) {
  if (typeof document > "u")
    return !1;
  const e = et(t);
  return wt(e).innerWidth - e.documentElement.clientWidth > 0;
}
function K9(t) {
  if (!(typeof CSS < "u" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document > "u")
    return !1;
  const n = et(t), o = n.documentElement, r = n.body, i = Qo(o) ? o : r, s = i.style.overflowY, l = o.style.scrollbarGutter;
  o.style.scrollbarGutter = "stable", i.style.overflowY = "scroll";
  const a = i.offsetWidth;
  i.style.overflowY = "hidden";
  const c = i.offsetWidth;
  return i.style.overflowY = s, o.style.scrollbarGutter = l, a === c;
}
function q9(t) {
  const e = et(t), n = e.documentElement, o = e.body, r = Qo(n) ? n : o, i = {
    overflowY: r.style.overflowY,
    overflowX: r.style.overflowX
  };
  return Object.assign(r.style, {
    overflowY: "hidden",
    overflowX: "hidden"
  }), () => {
    Object.assign(r.style, i);
  };
}
function Z9(t) {
  const e = et(t), n = e.documentElement, o = e.body, r = wt(n);
  let i = 0, s = 0, l = !1;
  const a = At.create();
  if (Hu && (r.visualViewport?.scale ?? 1) !== 1)
    return () => {
    };
  function c() {
    const p = r.getComputedStyle(n), g = r.getComputedStyle(o), v = (p.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
    i = n.scrollTop, s = n.scrollLeft, wp = {
      scrollbarGutter: n.style.scrollbarGutter,
      overflowY: n.style.overflowY,
      overflowX: n.style.overflowX
    }, Rp = n.style.scrollBehavior, Sp = {
      position: o.style.position,
      height: o.style.height,
      width: o.style.width,
      boxSizing: o.style.boxSizing,
      overflowY: o.style.overflowY,
      overflowX: o.style.overflowX,
      scrollBehavior: o.style.scrollBehavior
    };
    const C = n.scrollHeight > n.clientHeight, y = n.scrollWidth > n.clientWidth, w = p.overflowY === "scroll" || g.overflowY === "scroll", R = p.overflowX === "scroll" || g.overflowX === "scroll", S = Math.max(0, r.innerWidth - o.clientWidth), E = Math.max(0, r.innerHeight - o.clientHeight), N = parseFloat(g.marginTop) + parseFloat(g.marginBottom), T = parseFloat(g.marginLeft) + parseFloat(g.marginRight), P = Qo(n) ? n : o;
    if (l = K9(t), l) {
      n.style.scrollbarGutter = v, P.style.overflowY = "hidden", P.style.overflowX = "hidden";
      return;
    }
    Object.assign(n.style, {
      scrollbarGutter: v,
      overflowY: "hidden",
      overflowX: "hidden"
    }), (C || w) && (n.style.overflowY = "scroll"), (y || R) && (n.style.overflowX = "scroll"), Object.assign(o.style, {
      position: "relative",
      height: N || E ? `calc(100dvh - ${N + E}px)` : "100dvh",
      width: T || S ? `calc(100vw - ${T + S}px)` : "100vw",
      boxSizing: "border-box",
      overflow: "hidden",
      scrollBehavior: "unset"
    }), o.scrollTop = i, o.scrollLeft = s, n.setAttribute("data-base-ui-scroll-locked", ""), n.style.scrollBehavior = "unset";
  }
  function u() {
    Object.assign(n.style, wp), Object.assign(o.style, Sp), l || (n.scrollTop = i, n.scrollLeft = s, n.removeAttribute("data-base-ui-scroll-locked"), n.style.scrollBehavior = Rp);
  }
  function d() {
    u(), a.request(c);
  }
  c();
  const f = ut(r, "resize", d);
  return () => {
    a.cancel(), u(), typeof r.removeEventListener == "function" && f();
  };
}
class X9 {
  lockCount = 0;
  restore = null;
  timeoutLock = xn.create();
  timeoutUnlock = xn.create();
  acquire(e) {
    return this.lockCount += 1, this.lockCount === 1 && this.restore === null && this.timeoutLock.start(0, () => this.lock(e)), this.release;
  }
  release = () => {
    this.lockCount -= 1, this.lockCount === 0 && this.restore && this.timeoutUnlock.start(0, this.unlock);
  };
  unlock = () => {
    this.lockCount === 0 && this.restore && (this.restore?.(), this.restore = null);
  };
  lock(e) {
    if (this.lockCount === 0 || this.restore !== null)
      return;
    const o = et(e).documentElement, r = wt(o).getComputedStyle(o).overflowY;
    if (r === "hidden" || r === "clip") {
      this.restore = xt;
      return;
    }
    const i = zu || !j9(e);
    this.restore = i ? q9(e) : Z9(e);
  }
}
const Q9 = new X9();
function qh(t = !0, e = null) {
  ke(() => {
    if (t)
      return Q9.acquire(e);
  }, [t, e]);
}
const J9 = 20;
function pa(t, e, n, o) {
  const [r, i] = x.useState(!1);
  ke(() => {
    if (!t || !e || n == null) {
      i(!1);
      return;
    }
    const s = et(n).documentElement.clientWidth, l = n.offsetWidth;
    i(s > 0 && l > 0 && l >= s - J9);
  }, [t, e, n]), qh(t && (!e || r), o);
}
const Zh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l,
    align: a,
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = ed,
    style: v,
    ...C
  } = e, {
    store: y
  } = Jn(), w = H9(), R = oa(!0), S = y.useState("parent"), E = y.useState("floatingRootContext"), N = y.useState("floatingTreeRoot"), T = y.useState("mounted"), P = y.useState("open"), I = y.useState("modal"), k = y.useState("openMethod"), M = y.useState("activeTriggerElement"), D = y.useState("transitionStatus"), O = y.useState("positionerElement"), V = y.useState("instantType"), _ = y.useState("hasViewport"), A = y.useState("lastOpenChangeReason"), L = y.useState("floatingNodeId"), B = y.useState("floatingParentNodeId"), G = E.useState("domReferenceElement"), U = x.useRef(null), Y = Ql(O, !1, !1);
  let K = o, j = c, Z = u, te = a, W = b;
  S.type === "context-menu" && (K = o ?? S.context?.anchor, te = te ?? "start", !l && te !== "center" && (Z = e.alignOffset ?? 2, j = e.sideOffset ?? -5));
  let X = l, ee = te;
  S.type === "menu" ? (X = X ?? "inline-end", ee = ee ?? "start", W = e.collisionAvoidance ?? la) : S.type === "menubar" && (X = X ?? "bottom", ee = ee ?? "start");
  const le = S.type === "context-menu", J = ri({
    anchor: K,
    floatingRootContext: E,
    positionMethod: R ? "fixed" : r,
    mounted: T,
    side: X,
    sideOffset: j,
    align: ee,
    alignOffset: Z,
    arrowPadding: le ? 0 : p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    nodeId: L,
    keepMounted: w,
    disableAnchorTracking: h,
    collisionAvoidance: W,
    shiftCrossAxis: le && !("side" in W && W.side === "flip"),
    externalTree: N,
    adaptiveOrigin: _ ? fa : void 0
  });
  x.useEffect(() => {
    function fe($) {
      $.open && ($.parentNodeId === L && y.set("hoverEnabled", !1), $.nodeId !== L && $.parentNodeId === y.select("floatingParentNodeId") && y.setOpen(!1, Ve(Di)));
    }
    return N.events.on("menuopenchange", fe), () => {
      N.events.off("menuopenchange", fe);
    };
  }, [y, N.events, L]), x.useEffect(() => {
    if (y.select("floatingParentNodeId") == null)
      return;
    function fe($) {
      if ($.open || $.nodeId !== y.select("floatingParentNodeId"))
        return;
      const Q = $.reason ?? Di;
      y.setOpen(!1, Ve(Q));
    }
    return N.events.on("menuopenchange", fe), () => {
      N.events.off("menuopenchange", fe);
    };
  }, [N.events, y]);
  const ie = Vt();
  x.useEffect(() => {
    P || ie.clear();
  }, [P, ie]), x.useEffect(() => {
    function fe($) {
      if (!(!P || $.nodeId !== y.select("floatingParentNodeId")))
        if ($.target && M && M !== $.target) {
          const Q = y.select("closeDelay");
          Q > 0 ? ie.isStarted() || ie.start(Q, () => {
            y.setOpen(!1, Ve(Di));
          }) : y.setOpen(!1, Ve(Di));
        } else
          ie.clear();
    }
    return N.events.on("itemhover", fe), () => {
      N.events.off("itemhover", fe);
    };
  }, [N.events, P, M, y, ie]), x.useEffect(() => {
    const fe = {
      open: P,
      nodeId: L,
      parentNodeId: B,
      reason: y.select("lastOpenChangeReason")
    };
    N.events.emit("menuopenchange", fe);
  }, [N.events, P, y, L, B]), ke(() => {
    const fe = G, $ = U.current;
    if (fe && (U.current = fe), $ && fe && fe !== $) {
      y.set("instantType", void 0);
      const Q = new AbortController();
      return Y(() => {
        y.set("instantType", "trigger-change");
      }, Q.signal), () => {
        Q.abort();
      };
    }
  }, [G, Y, y]);
  const pe = {
    open: P,
    side: J.side,
    align: J.align,
    anchorHidden: J.anchorHidden,
    nested: S.type === "menu",
    instant: V
  }, oe = S.type === "menubar" && S.context.modal;
  pa(P && (oe || I && A !== Lt), k === "touch", O, M);
  const de = li(e, pe, {
    styles: J.positionerStyles,
    transitionStatus: D,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !T,
    inert: !P
  }), xe = T && S.type !== "menu" && (S.type !== "menubar" && I && A !== Lt || S.type === "menubar" && S.context.modal);
  let se = null;
  return S.type === "menubar" ? se = S.context.contentElement : S.type === void 0 && (se = M), /* @__PURE__ */ F(Lu.Provider, {
    value: J,
    children: [xe && /* @__PURE__ */ m(si, {
      ref: S.type === "context-menu" || S.type === "nested-context-menu" ? S.context.internalBackdropRef : null,
      inert: Er(!P),
      cutout: se
    }), /* @__PURE__ */ m(id, {
      id: L,
      children: /* @__PURE__ */ m(ii, {
        elementsRef: y.context.itemDomElements,
        labelsRef: y.context.itemLabels,
        children: de
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (Zh.displayName = "MenuPositioner");
const wd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (wd.displayName = "MenuRadioGroupContext");
function e7() {
  const t = x.useContext(wd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioGroupContext is missing. MenuRadioGroup parts must be placed within <Menu.RadioGroup>." : rt(34));
  return t;
}
const Xh = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i,
    defaultValue: s,
    onValueChange: l,
    disabled: a = !1,
    style: c,
    ...u
  } = e, [d, f] = dn({
    controlled: i,
    default: s,
    name: "MenuRadioGroup"
  }), p = Se(l), g = Se((C, y) => {
    p?.(C, y), !y.isCanceled && f(C);
  }), b = $e("div", e, {
    state: {
      disabled: a
    },
    ref: n,
    props: {
      role: "group",
      "aria-disabled": a || void 0,
      ...u
    }
  }), v = x.useMemo(() => ({
    value: d,
    setValue: g,
    disabled: a
  }), [d, g, a]);
  return /* @__PURE__ */ m(wd.Provider, {
    value: v,
    children: b
  });
}));
process.env.NODE_ENV !== "production" && (Xh.displayName = "MenuRadioGroup");
const Sd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sd.displayName = "MenuRadioItemContext");
function t7() {
  const t = x.useContext(Sd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: MenuRadioItemContext is missing. MenuRadioItem parts must be placed within <Menu.RadioItem>." : rt(35));
  return t;
}
const Qh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    label: s,
    nativeButton: l = !1,
    disabled: a = !1,
    closeOnClick: c = !1,
    value: u,
    style: d,
    ...f
  } = e, p = Oo({
    label: s
  }), g = rs(!0), h = Mt(i), {
    store: b
  } = Jn(), v = b.useState("isActive", p.index), C = b.useState("itemProps"), {
    value: y,
    setValue: w,
    disabled: R
  } = e7(), S = R || a, E = y === u, {
    getItemProps: N,
    itemRef: T
  } = ra({
    closeOnClick: c,
    disabled: S,
    highlighted: v,
    id: h,
    store: b,
    nativeButton: l,
    nodeId: g?.context.nodeId,
    itemMetadata: Bu
  }), P = x.useMemo(() => ({
    disabled: S,
    highlighted: v,
    checked: E
  }), [S, v, E]), I = Se((M) => {
    const D = {
      ...Ve(Wo, M.nativeEvent),
      preventUnmountOnClose: () => {
      }
    };
    w(u, D);
  }), k = $e("div", e, {
    state: P,
    stateAttributesMapping: Gu,
    props: [C, {
      role: "menuitemradio",
      "aria-checked": E,
      onClick: I
    }, f, N],
    ref: [T, n, p.ref]
  });
  return /* @__PURE__ */ m(Sd.Provider, {
    value: P,
    children: k
  });
});
process.env.NODE_ENV !== "production" && (Qh.displayName = "MenuRadioItem");
const Jh = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = t7(), c = x.useRef(null), {
    transitionStatus: u,
    setMounted: d
  } = Xn(a.checked);
  jt({
    open: a.checked,
    ref: c,
    onComplete() {
      a.checked || d(!1);
    }
  });
  const f = {
    checked: a.checked,
    disabled: a.disabled,
    highlighted: a.highlighted,
    transitionStatus: u
  };
  return $e("span", e, {
    state: f,
    stateAttributesMapping: Gu,
    ref: [n, c],
    props: {
      "aria-hidden": !0,
      ...l
    },
    enabled: s || a.checked
  });
});
process.env.NODE_ENV !== "production" && (Jh.displayName = "MenuRadioItemIndicator");
function Nr(t) {
  const e = x.useRef(!0);
  e.current && (e.current = !1, t());
}
const e2 = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (e2.displayName = "MenubarContext");
function t2(t) {
  return x.useContext(e2);
}
function n7(t) {
  const e = x.useRef(""), n = x.useCallback((r) => {
    r.defaultPrevented || (e.current = r.pointerType, t(r, r.pointerType));
  }, [t]);
  return {
    onClick: x.useCallback((r) => {
      if (r.detail === 0) {
        t(r, "keyboard");
        return;
      }
      "pointerType" in r ? t(r, r.pointerType) : t(r, e.current), e.current = "";
    }, [t]),
    onPointerDown: n
  };
}
function wo(t, e) {
  const n = x.useRef(t), o = Se(e);
  ke(() => {
    n.current !== t && o(n.current);
  }, [t, o]), ke(() => {
    n.current = t;
  }, [t]);
}
function Cs(t) {
  const [e, n] = x.useState(null), o = Se((s, l) => {
    t || n(l || // On iOS Safari, the hitslop around touch targets means tapping outside an element's
    // bounds does not fire `pointerdown` but does fire `mousedown`. The `interactionType`
    // will be "" in that case.
    (zu ? "touch" : ""));
  });
  wo(t, (s) => {
    s && !t && n(null);
  });
  const {
    onClick: r,
    onPointerDown: i
  } = n7(o);
  return x.useMemo(() => ({
    openMethod: e,
    triggerProps: {
      onClick: r,
      onPointerDown: i
    }
  }), [e, r, i]);
}
const o7 = {
  ...ps,
  disabled: he((t) => t.parent.type === "menubar" && t.parent.context.disabled || t.disabled),
  modal: he((t) => (t.parent.type === void 0 || t.parent.type === "context-menu") && (t.modal ?? !0)),
  openMethod: he((t) => t.openMethod),
  allowMouseEnter: he((t) => t.allowMouseEnter),
  stickIfOpen: he((t) => t.stickIfOpen),
  parent: he((t) => t.parent),
  rootId: he((t) => t.parent.type === "menu" ? t.parent.store.select("rootId") : t.parent.type !== void 0 ? t.parent.context.rootId : t.rootId),
  activeIndex: he((t) => t.activeIndex),
  isActive: he((t, e) => t.activeIndex === e),
  hoverEnabled: he((t) => t.hoverEnabled),
  instantType: he((t) => t.instantType),
  lastOpenChangeReason: he((t) => t.openChangeReason),
  floatingTreeRoot: he((t) => t.parent.type === "menu" ? t.parent.store.select("floatingTreeRoot") : t.floatingTreeRoot),
  floatingNodeId: he((t) => t.floatingNodeId),
  floatingParentNodeId: he((t) => t.floatingParentNodeId),
  itemProps: he((t) => t.itemProps),
  closeDelay: he((t) => t.closeDelay),
  hasViewport: he((t) => t.hasViewport),
  keyboardEventRelay: he((t) => {
    if (t.keyboardEventRelay)
      return t.keyboardEventRelay;
    if (t.parent.type === "menu")
      return t.parent.store.select("keyboardEventRelay");
  })
};
class Rd extends wr {
  constructor(e) {
    super({
      ...r7(),
      ...e
    }, {
      positionerRef: /* @__PURE__ */ x.createRef(),
      popupRef: /* @__PURE__ */ x.createRef(),
      typingRef: {
        current: !1
      },
      itemDomElements: {
        current: []
      },
      itemLabels: {
        current: []
      },
      allowMouseUpTriggerRef: {
        current: !1
      },
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      onOpenChangeComplete: void 0,
      triggerElements: new Sr()
    }, o7), this.unsubscribeParentListener = this.observe("parent", (n) => {
      if (this.unsubscribeParentListener?.(), n.type === "menu") {
        let o = n.store.select("rootId"), r = n.store.select("floatingTreeRoot"), i = n.store.select("keyboardEventRelay");
        this.unsubscribeParentListener = n.store.subscribe(() => {
          const s = n.store.select("rootId"), l = n.store.select("floatingTreeRoot"), a = n.store.select("keyboardEventRelay");
          o === s && r === l && i === a || (o = s, r = l, i = a, this.notifyAll());
        }), this.context.allowMouseUpTriggerRef = n.store.context.allowMouseUpTriggerRef;
        return;
      }
      n.type !== void 0 && (this.context.allowMouseUpTriggerRef = n.context.allowMouseUpTriggerRef), this.unsubscribeParentListener = null;
    });
  }
  setOpen(e, n) {
    this.state.floatingRootContext.context.events.emit("setOpen", {
      open: e,
      eventDetails: n
    });
  }
  static useStore(e, n) {
    const o = Tt(() => new Rd(n)).current;
    return e ?? o;
  }
  unsubscribeParentListener = null;
}
function r7() {
  return {
    ...fs(),
    disabled: !1,
    modal: !0,
    openMethod: null,
    allowMouseEnter: !1,
    stickIfOpen: !0,
    parent: {
      type: void 0
    },
    rootId: void 0,
    activeIndex: null,
    hoverEnabled: !0,
    instantType: void 0,
    openChangeReason: null,
    floatingTreeRoot: new nd(),
    floatingNodeId: void 0,
    floatingParentNodeId: null,
    itemProps: St,
    keyboardEventRelay: void 0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Ed = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ed.displayName = "MenuSubmenuRootContext");
function n2() {
  return x.useContext(Ed);
}
const ai = dd(function(e) {
  const {
    children: n,
    open: o,
    onOpenChange: r,
    onOpenChangeComplete: i,
    defaultOpen: s = !1,
    disabled: l = !1,
    modal: a,
    loopFocus: c = !0,
    orientation: u = "vertical",
    actionsRef: d,
    closeParentOnEsc: f = !1,
    handle: p,
    triggerId: g,
    defaultTriggerId: h = null,
    highlightItemOnHover: b = !0
  } = e, v = oa(!0), C = Jn(!0), y = t2(!0), w = n2(), R = x.useMemo(() => w && C ? {
    type: "menu",
    store: C.store
  } : y ? {
    type: "menubar",
    context: y
  } : v && !C ? {
    type: "context-menu",
    context: v
  } : {
    type: void 0
  }, [v, C, y, w]), S = Rd.useStore(p?.store, {
    open: s,
    openProp: o,
    activeTriggerId: h,
    triggerIdProp: g,
    parent: R
  });
  Nr(() => {
    o === void 0 && S.state.open === !1 && s === !0 && S.update({
      open: !0,
      activeTriggerId: h
    });
  }), S.useControlledProp("openProp", o), S.useControlledProp("triggerIdProp", g), S.useContextCallback("onOpenChangeComplete", i);
  const E = S.useState("floatingTreeRoot"), N = aa(E), T = bo();
  ke(() => {
    v && !C ? S.update({
      parent: {
        type: "context-menu",
        context: v
      },
      floatingNodeId: N,
      floatingParentNodeId: T
    }) : C && S.update({
      floatingNodeId: N,
      floatingParentNodeId: T
    });
  }, [v, C, N, T, S]);
  const P = S.useState("open"), I = S.useState("activeTriggerElement"), k = S.useState("positionerElement"), M = S.useState("hoverEnabled"), D = S.useState("disabled"), O = S.useState("lastOpenChangeReason"), V = S.useState("parent"), _ = S.useState("activeIndex"), A = S.useState("payload"), L = S.useState("floatingParentNodeId"), B = x.useRef(null), G = L != null;
  process.env.NODE_ENV !== "production" && V.type !== void 0 && a !== void 0 && console.warn("Base UI: The `modal` prop is not supported on nested menus. It will be ignored.");
  const {
    openMethod: U,
    triggerProps: Y
  } = Cs(P);
  S.useSyncedValues({
    disabled: l,
    modal: V.type === void 0 ? a : void 0,
    openMethod: U,
    rootId: Do()
  }), us(S);
  const {
    forceUnmount: K
  } = ds(P, S, () => {
    S.update({
      allowMouseEnter: !1,
      stickIfOpen: !0
    });
  }), j = x.useRef(V.type !== "context-menu"), Z = Vt();
  x.useEffect(() => {
    if (P || (B.current = null), V.type === "context-menu") {
      if (!P) {
        Z.clear(), j.current = !1;
        return;
      }
      Z.start(500, () => {
        j.current = !0;
      });
    }
  }, [Z, P, V.type]), ke(() => {
    !P && !M && S.set("hoverEnabled", !0);
  }, [P, M, S]);
  const te = x.useRef(!0), W = Vt(), X = Se((me, Ee) => {
    const Pe = Ee.reason;
    if (P === me && Ee.trigger === I && O === Pe || (Ee.preventUnmountOnClose = () => {
      S.set("preventUnmountingOnClose", !0);
    }, !me && Ee.trigger == null && (Ee.trigger = I ?? void 0), r?.(me, Ee), Ee.isCanceled))
      return;
    S.state.floatingRootContext.dispatchOpenChange(me, Ee);
    const Me = Ee.event;
    if (me === !1 && Me?.type === "click" && Me.pointerType === "touch" && !te.current)
      return;
    if (!me && _ !== null) {
      const ye = S.context.itemDomElements.current[_];
      queueMicrotask(() => {
        ye?.setAttribute("tabindex", "-1");
      });
    }
    me && Pe === dr ? (te.current = !1, W.start(300, () => {
      te.current = !0;
    })) : (te.current = !0, W.clear());
    const _e = (Pe === Zn || Pe === Wo) && Me.detail === 0 && Me?.isTrusted, Ue = !me && (Pe === vr || Pe == null), Ye = {
      open: me,
      openChangeReason: Pe
    };
    B.current = Ee.event ?? null;
    const He = Ee.trigger?.id ?? null;
    (He || me) && (Ye.activeTriggerId = He, Ye.activeTriggerElement = Ee.trigger ?? null), S.update(Ye), V.type === "menubar" && (Pe === dr || Pe === Po || Pe === Lt || Pe === $r || Pe === Di) ? S.set("instantType", "group") : _e || Ue ? S.set("instantType", _e ? "click" : "dismiss") : S.set("instantType", void 0);
  }), ee = x.useCallback(() => {
    S.setOpen(!1, Ve(ss));
  }, [S]);
  x.useImperativeHandle(d, () => ({
    unmount: K,
    close: ee
  }), [K, ee]);
  let le;
  V.type === "context-menu" && (le = V.context), x.useImperativeHandle(le?.positionerRef, () => k, [k]), x.useImperativeHandle(le?.actionsRef, () => ({
    setOpen: X
  }), [X]);
  const J = gs({
    popupStore: S,
    onOpenChange: X
  }), ie = J.context.events;
  x.useEffect(() => {
    const me = ({
      open: Ee,
      eventDetails: Pe
    }) => X(Ee, Pe);
    return ie.on("setOpen", me), () => {
      ie?.off("setOpen", me);
    };
  }, [ie, X]);
  const pe = Cr(J, {
    enabled: !D,
    bubbles: {
      escapeKey: f && V.type === "menu"
    },
    outsidePress() {
      return V.type !== "context-menu" || B.current?.type === "contextmenu" ? !0 : j.current;
    },
    externalTree: G ? E : void 0
  }), oe = vd(J, {
    role: "menu"
  }), re = xs(), de = x.useCallback((me) => {
    S.select("activeIndex") !== me && S.set("activeIndex", me);
  }, [S]), xe = bd(J, {
    enabled: !D,
    listRef: S.context.itemDomElements,
    activeIndex: _,
    nested: V.type !== void 0,
    loopFocus: c,
    orientation: u,
    parentOrientation: V.type === "menubar" ? V.context.orientation : void 0,
    rtl: re === "rtl",
    disabledIndices: On,
    onNavigate: de,
    openOnArrowKeyDown: V.type !== "context-menu",
    externalTree: G ? E : void 0,
    focusItemOnHover: b
  }), se = x.useCallback((me) => {
    S.context.typingRef.current = me;
  }, [S]), fe = yd(J, {
    listRef: S.context.itemLabels,
    elementsRef: S.context.itemDomElements,
    activeIndex: _,
    resetMs: H8,
    onMatch: (me) => {
      P && me !== _ && S.set("activeIndex", me);
    },
    onTypingChange: se
  }), {
    getReferenceProps: $,
    getFloatingProps: Q,
    getItemProps: H,
    getTriggerProps: q
  } = eo([pe, oe, xe, fe]), ae = x.useMemo(() => {
    const me = en($(), {
      onMouseMove() {
        S.set("allowMouseEnter", !0);
      }
    }, Y);
    return delete me.role, me;
  }, [$, S, Y]), ge = x.useMemo(() => {
    const me = q();
    if (!me)
      return me;
    const Ee = en(me, Y);
    return delete Ee.role, delete Ee["aria-controls"], Ee;
  }, [q, Y]), ue = x.useMemo(() => Q({
    onMouseMove() {
      S.set("allowMouseEnter", !0), V.type === "menu" && S.set("hoverEnabled", !1);
    },
    onClick() {
      S.select("hoverEnabled") && S.set("hoverEnabled", !1);
    },
    onKeyDown(me) {
      const Ee = S.select("keyboardEventRelay");
      Ee && !me.isPropagationStopped() && Ee(me);
    }
  }), [Q, V.type, S]), Re = x.useMemo(() => H(), [H]);
  S.useSyncedValues({
    floatingRootContext: J,
    activeTriggerProps: ae,
    inactiveTriggerProps: ge,
    popupProps: ue,
    itemProps: Re
  });
  const be = x.useMemo(() => ({
    store: S,
    parent: R
  }), [S, R]), ve = /* @__PURE__ */ m(Fu.Provider, {
    value: be,
    children: typeof n == "function" ? n({
      payload: A
    }) : n
  });
  return V.type === void 0 || V.type === "context-menu" ? /* @__PURE__ */ m(sd, {
    externalTree: E,
    children: ve
  }) : ve;
});
process.env.NODE_ENV !== "production" && (ai.displayName = "MenuRoot");
function i7(t) {
  const e = Jn().store, n = x.useMemo(() => ({
    parentMenu: e
  }), [e]);
  return /* @__PURE__ */ m(Ed.Provider, {
    value: n,
    children: /* @__PURE__ */ m(ai, {
      ...t
    })
  });
}
function Nd(t) {
  const e = t.getBoundingClientRect();
  if (process.env.NODE_ENV !== "production")
    return e;
  const n = wt(t), o = n.getComputedStyle(t, "::before"), r = n.getComputedStyle(t, "::after");
  if (!(o.content !== "none" || r.content !== "none"))
    return e;
  const s = parseFloat(o.width) || 0, l = parseFloat(o.height) || 0, a = parseFloat(r.width) || 0, c = parseFloat(r.height) || 0, u = Math.max(e.width, s, a), d = Math.max(e.height, l, c), f = u - e.width, p = d - e.height;
  return {
    left: e.left - f / 2,
    right: e.right + f / 2,
    top: e.top - p / 2,
    bottom: e.bottom + p / 2
  };
}
function o2(t = {}) {
  const {
    highlightItemOnHover: e,
    highlightedIndex: n,
    onHighlightedIndexChange: o
  } = Du(), {
    ref: r,
    index: i
  } = Oo(t), s = n === i, l = x.useRef(null), a = fn(r, l);
  return {
    compositeProps: x.useMemo(() => ({
      tabIndex: s ? 0 : -1,
      onFocus() {
        o(i);
      },
      onMouseMove() {
        const u = l.current;
        if (!e || !u)
          return;
        const d = u.hasAttribute("disabled") || u.ariaDisabled === "true";
        !s && !d && u.focus();
      }
    }), [s, o, i, e]),
    compositeRef: a,
    index: i
  };
}
function kd(t) {
  const {
    render: e,
    className: n,
    style: o,
    state: r = St,
    props: i = On,
    refs: s = On,
    metadata: l,
    stateAttributesMapping: a,
    tag: c = "div",
    ...u
  } = t, {
    compositeProps: d,
    compositeRef: f
  } = o2({
    metadata: l
  });
  return $e(c, t, {
    state: r,
    ref: [...s, f],
    props: [d, ...i, u],
    stateAttributesMapping: a
  });
}
function r2(t) {
  if (Ct(t) && t.hasAttribute("data-rootownerid"))
    return t.getAttribute("data-rootownerid") ?? void 0;
  if (!ao(t))
    return r2(po(t));
}
function i2(t, e) {
  const n = x.useRef(null), o = Se((i) => {
    an.flushSync(() => {
      t.setOpen(!1, Ve(Po, i.nativeEvent, i.currentTarget));
    }), A8(n.current)?.focus();
  }), r = Se((i) => {
    const s = t.select("positionerElement");
    if (s && Hr(i, s))
      t.context.beforeContentFocusGuardRef.current?.focus();
    else {
      an.flushSync(() => {
        t.setOpen(!1, Ve(Po, i.nativeEvent, i.currentTarget));
      });
      let l = _8(t.context.triggerFocusTargetRef.current || e.current);
      for (; l !== null && ze(s, l); ) {
        const a = l;
        if (l = Qu(l), l === a)
          break;
      }
      l?.focus();
    }
  });
  return {
    preFocusGuardRef: n,
    handlePreFocusGuardFocus: o,
    handleFocusTargetFocus: r
  };
}
function s7(t) {
  const {
    enabled: e = !0,
    mouseDownAction: n,
    open: o
  } = t, r = x.useRef(!1);
  return x.useMemo(() => e ? {
    onMouseDown: (i) => {
      (n === "open" && !o || n === "close" && o) && (r.current = !0, et(i.currentTarget).addEventListener("click", () => {
        r.current = !1;
      }, {
        once: !0
      }));
    },
    onClick: (i) => {
      r.current && (r.current = !1, i.preventBaseUIHandler());
    }
  } : St, [e, n, o]);
}
const ol = 2, s2 = Ah(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    openOnHover: a,
    delay: c = 100,
    closeDelay: u = 0,
    handle: d,
    payload: f,
    style: p,
    ...g
  } = e, h = Jn(!0), b = d?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.Trigger> must be either used within a <Menu.Root> component or provided with a handle." : rt(85));
  const v = Mt(l), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), S = a7(), E = Du(!0), N = tr(), T = x.useMemo(() => N ?? new nd(), [N]), P = aa(T), I = bo(), {
    registerTrigger: k,
    isMountedByThisTrigger: M
  } = cs(v, R, b, {
    payload: f,
    closeDelay: u,
    parent: S,
    floatingTreeRoot: T,
    floatingNodeId: P,
    floatingParentNodeId: I,
    keyboardEventRelay: E?.relayKeyboardEvent
  }), D = S.type === "menubar", O = b.useState("disabled"), V = i || O || D && S.context.disabled, {
    getButtonProps: _,
    buttonRef: A
  } = Wt({
    disabled: V,
    native: s
  });
  x.useEffect(() => {
    !w && S.type === void 0 && (b.context.allowMouseUpTriggerRef.current = !1);
  }, [b, w, S.type]);
  const L = x.useRef(null), B = Vt(), G = Se((xe) => {
    if (!L.current)
      return;
    B.clear(), b.context.allowMouseUpTriggerRef.current = !1;
    const se = xe.target;
    if (ze(L.current, se) || ze(b.select("positionerElement"), se) || se === L.current || se != null && r2(se) === b.select("rootId"))
      return;
    const fe = Nd(L.current);
    xe.clientX >= fe.left - ol && xe.clientX <= fe.right + ol && xe.clientY >= fe.top - ol && xe.clientY <= fe.bottom + ol || T.events.emit("close", {
      domEvent: xe,
      reason: zm
    });
  });
  x.useEffect(() => {
    w && b.select("lastOpenChangeReason") === Lt && et(L.current).addEventListener("mouseup", G, {
      once: !0
    });
  }, [w, G, b]);
  const U = D && S.context.hasSubmenuOpen, K = ms(y, {
    enabled: (a ?? U) && !V && S.type !== "context-menu" && (!D || U && !M),
    handleClose: hs({
      blockPointerEvents: !D
    }),
    mouseOnly: !0,
    move: !1,
    restMs: S.type === void 0 ? c : void 0,
    delay: {
      close: u
    },
    triggerElementRef: R,
    externalTree: T,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), j = l7(w, b.select("lastOpenChangeReason")), Z = xr(y, {
    enabled: !V && S.type !== "context-menu",
    event: w && D ? "click" : "mousedown",
    toggle: !0,
    ignoreMouse: !1,
    stickIfOpen: S.type === void 0 ? j : !1
  }), te = md(y, {
    enabled: !V && U
  }), W = s7({
    open: w,
    enabled: D,
    mouseDownAction: "open"
  }), X = eo([Z, te]), ee = {
    disabled: V,
    open: w
  }, le = b.useState("triggerProps", M), J = [L, n, A, k, R], ie = [X.getReferenceProps(), K ?? St, le, {
    "aria-haspopup": "menu",
    id: v,
    onMouseDown: (xe) => {
      if (b.select("open"))
        return;
      B.start(200, () => {
        b.context.allowMouseUpTriggerRef.current = !0;
      }), et(xe.currentTarget).addEventListener("mouseup", G, {
        once: !0
      });
    }
  }, D ? {
    role: "menuitem"
  } : {}, W, g, _], {
    preFocusGuardRef: pe,
    handlePreFocusGuardFocus: oe,
    handleFocusTargetFocus: re
  } = i2(b, R), de = $e("button", e, {
    enabled: !D,
    stateAttributesMapping: Ui,
    state: ee,
    ref: J,
    props: ie
  });
  return D ? /* @__PURE__ */ m(kd, {
    tag: "button",
    render: o,
    className: r,
    style: p,
    state: ee,
    refs: J,
    props: ie,
    stateAttributesMapping: Ui
  }) : w ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ m(Vn, {
      ref: pe,
      onFocus: oe
    }, `${v}-pre-focus-guard`), /* @__PURE__ */ m(x.Fragment, {
      children: de
    }, v), /* @__PURE__ */ m(Vn, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: re
    }, `${v}-post-focus-guard`)]
  }) : /* @__PURE__ */ m(x.Fragment, {
    children: de
  }, v);
});
process.env.NODE_ENV !== "production" && (s2.displayName = "MenuTrigger");
function l7(t, e) {
  const n = Vt(), [o, r] = x.useState(!1);
  return ke(() => {
    t && e === "trigger-hover" ? (r(!0), n.start(xh, () => {
      r(!1);
    })) : t || (n.clear(), r(!1));
  }, [t, e, n]), o;
}
function a7() {
  const t = oa(!0), e = Jn(!0), n = t2();
  return x.useMemo(() => n ? {
    type: "menubar",
    context: n
  } : t && !e ? {
    type: "context-menu",
    context: t
  } : {
    type: void 0
  }, [t, e, n]);
}
function c7(t) {
  const [e, n] = x.useState({
    current: t,
    previous: null
  });
  return t !== e.current && n({
    current: t,
    previous: e.current
  }), e.previous;
}
function l2(t) {
  return t == null || t.hasAttribute("disabled") || t.getAttribute("aria-disabled") === "true";
}
const a2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    label: i,
    id: s,
    nativeButton: l = !1,
    openOnHover: a = !0,
    delay: c = 100,
    closeDelay: u = 0,
    disabled: d = !1,
    style: f,
    ...p
  } = e, g = Oo(), h = rs(), {
    store: b
  } = Jn(), v = Mt(s), C = b.useState("open"), y = b.useState("floatingRootContext"), w = b.useState("floatingTreeRoot"), R = Lh(v, b), S = x.useCallback((Z) => {
    const te = R(Z);
    return Z !== null && b.select("open") && b.select("activeTriggerId") == null && b.update({
      activeTriggerId: v,
      activeTriggerElement: Z,
      closeDelay: u
    }), te;
  }, [R, u, b, v]), E = x.useRef(null), N = x.useCallback((Z) => {
    E.current = Z, b.set("activeTriggerElement", Z);
  }, [b]);
  process.env.NODE_ENV !== "production" && ke(() => {
    const Z = E.current;
    if (Z && l2(Z) && !d) {
      const te = pr.captureOwnerStack?.() || "";
      Xl(`A disabled element was detected on <Menu.SubmenuTrigger>. To properly disable the trigger, use the \`disabled\` prop on the component instead of setting it on the rendered element.${te}`);
    }
  });
  const T = n2();
  if (!T?.parentMenu)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Menu.SubmenuTrigger> must be placed in <Menu.SubmenuRoot>." : rt(37));
  b.useSyncedValue("closeDelay", u);
  const P = T.parentMenu, I = P.useState("itemProps"), k = P.useState("isActive", g.index), M = x.useMemo(() => ({
    type: "submenu-trigger",
    setActive() {
      P.set("activeIndex", g.index);
    }
  }), [P, g.index]), D = b.useState("disabled"), O = d || D, {
    getItemProps: V,
    itemRef: _
  } = ra({
    closeOnClick: !1,
    disabled: O,
    highlighted: k,
    id: v,
    store: b,
    typingRef: P.context.typingRef,
    nativeButton: l,
    itemMetadata: M,
    nodeId: h?.context.nodeId
  }), A = b.useState("hoverEnabled"), L = P.useState("allowMouseEnter"), B = ms(y, {
    enabled: A && a && !O,
    handleClose: hs({
      blockPointerEvents: !0
    }),
    mouseOnly: !0,
    move: !0,
    restMs: c,
    delay: L ? {
      open: c,
      close: u
    } : 0,
    triggerElementRef: E,
    externalTree: w,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), G = xr(y, {
    enabled: !O,
    event: "mousedown",
    toggle: !a,
    ignoreMouse: a,
    stickIfOpen: !1
  }), U = eo([G]), Y = b.useState("triggerProps", !0);
  return delete Y.id, $e("div", e, {
    state: {
      disabled: O,
      highlighted: k,
      open: C
    },
    stateAttributesMapping: br,
    props: [U.getReferenceProps(), B, Y, I, {
      tabIndex: C || k ? 0 : -1,
      onBlur() {
        k && P.set("activeIndex", null);
      }
    }, p, V],
    ref: [n, g.ref, _, S, N]
  });
});
process.env.NODE_ENV !== "production" && (a2.displayName = "MenuSubmenuTrigger");
const Md = mo({
  blockingLayerHost: null,
  portalHost: null
});
function qt() {
  return gn(Md).portalHost ?? void 0;
}
function u7() {
  return gn(Md).blockingLayerHost ?? void 0;
}
function d7() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ m("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const f7 = ce(["rounded-(--radius-sm)", "border", "border-solid", "border-menu-default-outline", "bg-menu-default-background", "shadow-elevation-3", "p-(--spacing-4)", "flex", "flex-col", "max-h-[min(20rem,calc(100vh-2rem))]", "overflow-y-auto", "overscroll-contain", "outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out"], {
  variants: {
    size: {
      sm: "w-[180px]",
      md: "w-[296px]",
      lg: "w-[400px]",
      anchor: "w-[var(--anchor-width)]",
      trigger: "w-[max(180px,var(--anchor-width))] max-w-[calc(100vw-var(--spacing-16))]",
      auto: "w-auto min-w-[180px] max-w-[calc(100vw-var(--spacing-16))]"
    }
  },
  defaultVariants: {
    size: "md"
  }
}), p7 = ce(["flex", "h-[36px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[selected]:bg-menu-item-selected", "data-[checked]:bg-menu-item-selected", "[&[data-highlighted]:active]:bg-menu-item-pressed", "[&[data-selected]:active]:bg-menu-item-pressed", "[&[data-checked]:active]:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "data-[disabled]:hover:bg-transparent"], {
  variants: {
    tone: {
      default: "",
      destructive: ["text-menu-text-destructive", "[&_svg]:text-menu-icon-destructive"]
    }
  },
  defaultVariants: {
    tone: "default"
  }
}), g7 = ne("flex", "h-(--spacing-24)", "w-full", "items-center", "rounded-(--radius-sm)", "px-(--spacing-12)", "py-(--spacing-4)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle", "select-none", "data-[disabled]:text-menu-text-disabled-sub");
function ws({
  size: t,
  className: e
}) {
  return ne(f7({
    size: t
  }), e);
}
function Xi(t) {
  const e = z.c(19), {
    children: n,
    leadingIcon: o,
    endSection: r,
    checked: i,
    checkbox: s,
    submenu: l
  } = t;
  let a;
  e[0] !== s || e[1] !== i ? (a = s && /* @__PURE__ */ m(m7, { checked: i }), e[0] = s, e[1] = i, e[2] = a) : a = e[2];
  let c;
  e[3] !== o ? (c = o && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ m(Ke, { name: o, size: "xs", tone: "inherit" }) }), e[3] = o, e[4] = c) : c = e[4];
  let u;
  e[5] !== n ? (u = /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate", children: n }), e[5] = n, e[6] = u) : u = e[6];
  let d;
  e[7] !== s || e[8] !== i ? (d = i && !s && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ m(Ke, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[7] = s, e[8] = i, e[9] = d) : d = e[9];
  let f;
  e[10] !== r || e[11] !== l ? (f = l ? /* @__PURE__ */ m("span", { "aria-hidden": "true", className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ m(Ke, { name: "chevron-right", size: "xs", tone: "inherit" }) }) : r && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[10] = r, e[11] = l, e[12] = f) : f = e[12];
  let p;
  return e[13] !== a || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F(zt, { children: [
    a,
    c,
    u,
    d,
    f
  ] }), e[13] = a, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function m7(t) {
  const e = z.c(7), {
    checked: n
  } = t, o = n ? "" : void 0, r = n ? "" : void 0;
  let i;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne("inline-flex", "h-(--icon-xs)", "w-(--icon-xs)", "items-center", "justify-center", "rounded-(--radius-sm)", "border-[1.5px]", "border-checkbox-outline-default-border", "bg-surface-container-lowest", "text-transparent", "transition-colors", "duration-200", "ease-in-out", "data-[checked]:border-transparent", "data-[checked]:bg-checkbox-filled-default-background", "data-[checked]:text-surface-container-lowest", "[[data-disabled]_&]:border-transparent", "[[data-disabled]_&]:bg-checkbox-filled-disabled-background", "[[data-disabled]_&]:text-surface-container-lowest"), e[0] = i) : i = e[0];
  let s;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = /* @__PURE__ */ m("span", { className: "h-[calc(var(--icon-xs)*0.8)] w-[calc(var(--icon-xs)*0.8)]", children: /* @__PURE__ */ m(d7, {}) }), e[1] = s) : s = e[1];
  let l;
  e[2] !== r ? (l = /* @__PURE__ */ m("span", { "data-checked": r, className: i, children: s }), e[2] = r, e[3] = l) : l = e[3];
  let a;
  return e[4] !== o || e[5] !== l ? (a = /* @__PURE__ */ m("span", { "aria-hidden": "true", "data-checked": o, className: "inline-flex h-(--icon-sm) w-(--icon-sm) shrink-0 items-center justify-center", children: l }), e[4] = o, e[5] = l, e[6] = a) : a = e[6], a;
}
function Ko({
  tone: t,
  className: e
}) {
  return ne(p7({
    tone: t
  }), e);
}
const h7 = 13;
function Id(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(ai, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Yo(t) {
  const e = z.c(2), {
    render: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m(s2, { render: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function kr(t) {
  const e = z.c(29);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    side: l,
    align: a,
    sideOffset: c,
    alignOffset: u,
    size: s,
    className: o,
    positionerClassName: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = l === void 0 ? "bottom" : l, f = a === void 0 ? "start" : a, p = c === void 0 ? 4 : c, g = u === void 0 ? 0 : u, h = qt();
  let b;
  e[10] !== r ? (b = ne("z-[var(--z-layer-popover)]", r), e[10] = r, e[11] = b) : b = e[11];
  let v;
  e[12] !== o || e[13] !== s ? (v = ws({
    size: s,
    className: o
  }), e[12] = o, e[13] = s, e[14] = v) : v = e[14];
  let C;
  e[15] !== n || e[16] !== i || e[17] !== v ? (C = /* @__PURE__ */ m(Gh, { className: v, ...i, children: n }), e[15] = n, e[16] = i, e[17] = v, e[18] = C) : C = e[18];
  let y;
  e[19] !== f || e[20] !== g || e[21] !== d || e[22] !== p || e[23] !== b || e[24] !== C ? (y = /* @__PURE__ */ m(Zh, { side: d, align: f, sideOffset: p, alignOffset: g, className: b, children: C }), e[19] = f, e[20] = g, e[21] = d, e[22] = p, e[23] = b, e[24] = C, e[25] = y) : y = e[25];
  let w;
  return e[26] !== h || e[27] !== y ? (w = /* @__PURE__ */ m(Yh, { container: h, children: y }), e[26] = h, e[27] = y, e[28] = w) : w = e[28], w;
}
function fr(t) {
  const e = z.c(36);
  let n, o, r, i, s, l, a;
  if (e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    submenu: l,
    tone: a,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]), l != null) {
    let f;
    if (e[8] !== s) {
      const {
        closeOnClick: C,
        ...y
      } = s;
      f = y, e[8] = s, e[9] = f;
    } else
      f = e[9];
    let p;
    e[10] !== o || e[11] !== a ? (p = Ko({
      tone: a,
      className: o
    }), e[10] = o, e[11] = a, e[12] = p) : p = e[12];
    let g;
    e[13] !== n || e[14] !== i ? (g = /* @__PURE__ */ m(Xi, { leadingIcon: i, submenu: !0, children: n }), e[13] = n, e[14] = i, e[15] = g) : g = e[15];
    let h;
    e[16] !== p || e[17] !== g || e[18] !== f ? (h = /* @__PURE__ */ m(a2, { className: p, ...f, children: g }), e[16] = p, e[17] = g, e[18] = f, e[19] = h) : h = e[19];
    let b;
    e[20] !== l ? (b = /* @__PURE__ */ m(kr, { side: "right", align: "start", sideOffset: h7, alignOffset: -4, size: "sm", children: l }), e[20] = l, e[21] = b) : b = e[21];
    let v;
    return e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F(i7, { children: [
      h,
      b
    ] }), e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
  }
  let c;
  e[25] !== o || e[26] !== a ? (c = Ko({
    tone: a,
    className: o
  }), e[25] = o, e[26] = a, e[27] = c) : c = e[27];
  let u;
  e[28] !== n || e[29] !== r || e[30] !== i ? (u = /* @__PURE__ */ m(Xi, { leadingIcon: i, endSection: r, children: n }), e[28] = n, e[29] = r, e[30] = i, e[31] = u) : u = e[31];
  let d;
  return e[32] !== s || e[33] !== c || e[34] !== u ? (d = /* @__PURE__ */ m(Km, { className: c, ...s, children: u }), e[32] = s, e[33] = c, e[34] = u, e[35] = d) : d = e[35], d;
}
function Pd(t) {
  const e = z.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ m(Xh, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Td(t) {
  const e = z.c(21);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    leadingIcon: i,
    endSection: r,
    className: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o ? (l = Ko({
    className: o
  }), e[6] = o, e[7] = l) : l = e[7];
  let a;
  e[8] !== i ? (a = i && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ m(Ke, { name: i, size: "xs", tone: "inherit" }) }), e[8] = i, e[9] = a) : a = e[9];
  let c;
  e[10] !== n ? (c = /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate", children: n }), e[10] = n, e[11] = c) : c = e[11];
  let u;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m(Jh, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ m(Ke, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[12] = u) : u = e[12];
  let d;
  e[13] !== r ? (d = r && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 items-center gap-(--spacing-4)", children: r }), e[13] = r, e[14] = d) : d = e[14];
  let f;
  return e[15] !== s || e[16] !== l || e[17] !== a || e[18] !== c || e[19] !== d ? (f = /* @__PURE__ */ F(Qh, { className: l, ...s, children: [
    a,
    c,
    u,
    d
  ] }), e[15] = s, e[16] = l, e[17] = a, e[18] = c, e[19] = d, e[20] = f) : f = e[20], f;
}
function b7(t) {
  const e = z.c(19);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: o,
    leadingIcon: s,
    endSection: i,
    checked: n,
    className: r,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== r ? (a = Ko({
    className: r
  }), e[7] = r, e[8] = a) : a = e[8];
  let c;
  e[9] !== n || e[10] !== o || e[11] !== i || e[12] !== s ? (c = /* @__PURE__ */ m(Xi, { leadingIcon: s, endSection: i, checked: n, checkbox: !0, children: o }), e[9] = n, e[10] = o, e[11] = i, e[12] = s, e[13] = c) : c = e[13];
  let u;
  return e[14] !== n || e[15] !== l || e[16] !== a || e[17] !== c ? (u = /* @__PURE__ */ m(jm, { checked: n, className: a, ...l, children: c }), e[14] = n, e[15] = l, e[16] = a, e[17] = c, e[18] = u) : u = e[18], u;
}
function lu(t) {
  const e = z.c(13);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    disabled: r,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r ? "" : void 0, l = r || void 0;
  let a;
  e[5] !== o ? (a = ne(g7, o), e[5] = o, e[6] = a) : a = e[6];
  let c;
  return e[7] !== n || e[8] !== i || e[9] !== s || e[10] !== l || e[11] !== a ? (c = /* @__PURE__ */ m("div", { role: "presentation", "data-disabled": s, "aria-disabled": l, className: a, ...i, children: n }), e[7] = n, e[8] = i, e[9] = s, e[10] = l, e[11] = a, e[12] = c) : c = e[12], c;
}
const Od = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Od.displayName = "TooltipRootContext");
function Ss(t) {
  const e = x.useContext(Od);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipRootContext is missing. Tooltip parts must be placed within <Tooltip.Root>." : rt(72));
  return e;
}
const v7 = {
  ...ps,
  disabled: he((t) => t.disabled),
  instantType: he((t) => t.instantType),
  isInstantPhase: he((t) => t.isInstantPhase),
  trackCursorAxis: he((t) => t.trackCursorAxis),
  disableHoverablePopup: he((t) => t.disableHoverablePopup),
  lastOpenChangeReason: he((t) => t.openChangeReason),
  closeOnClick: he((t) => t.closeOnClick),
  closeDelay: he((t) => t.closeDelay),
  hasViewport: he((t) => t.hasViewport)
};
class Dd extends wr {
  constructor(e) {
    super({
      ...y7(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Sr()
    }, v7);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Lt, i = e && o === dr, s = !e && (o === Zn || o === vr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e,
        openChangeReason: o
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === Lt && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? an.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = Tt(() => new Dd(n)).current, r = e ?? o, i = gs({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function y7() {
  return {
    ...fs(),
    disabled: !1,
    instantType: void 0,
    isInstantPhase: !1,
    trackCursorAxis: "none",
    disableHoverablePopup: !1,
    openChangeReason: null,
    closeOnClick: !0,
    closeDelay: 0,
    hasViewport: !1
  };
}
const Vd = dd(function(e) {
  const {
    disabled: n = !1,
    defaultOpen: o = !1,
    open: r,
    disableHoverablePopup: i = !1,
    trackCursorAxis: s = "none",
    actionsRef: l,
    onOpenChange: a,
    onOpenChangeComplete: c,
    handle: u,
    triggerId: d,
    defaultTriggerId: f = null,
    children: p
  } = e, g = Dd.useStore(u?.store, {
    open: o,
    openProp: r,
    activeTriggerId: f,
    triggerIdProp: d
  });
  Nr(() => {
    r === void 0 && g.state.open === !1 && o === !0 && g.update({
      open: !0,
      activeTriggerId: f
    });
  }), g.useControlledProp("openProp", r), g.useControlledProp("triggerIdProp", d), g.useContextCallback("onOpenChange", a), g.useContextCallback("onOpenChangeComplete", c);
  const h = g.useState("open"), b = !n && h, v = g.useState("activeTriggerId"), C = g.useState("payload");
  g.useSyncedValues({
    trackCursorAxis: s,
    disableHoverablePopup: i
  }), ke(() => {
    h && n && g.setOpen(!1, Ve(s8));
  }, [h, n, g]), g.useSyncedValue("disabled", n), us(g);
  const {
    forceUnmount: y,
    transitionStatus: w
  } = ds(b, g), R = g.select("floatingRootContext"), S = g.useState("isInstantPhase"), E = g.useState("instantType"), N = g.useState("lastOpenChangeReason"), T = x.useRef(null);
  ke(() => {
    w === "ending" && N === Pt || w !== "ending" && S ? (E !== "delay" && (T.current = E), g.set("instantType", "delay")) : T.current !== null && (g.set("instantType", T.current), T.current = null);
  }, [w, S, N, E, g]), ke(() => {
    b && v == null && g.set("payload", void 0);
  }, [g, v, b]);
  const P = x.useCallback(() => {
    g.setOpen(!1, Ve(ss));
  }, [g]);
  x.useImperativeHandle(l, () => ({
    unmount: y,
    close: P
  }), [y, P]);
  const I = Cr(R, {
    enabled: !n,
    referencePress: () => g.select("closeOnClick")
  }), k = X8(R, {
    enabled: !n && s !== "none",
    axis: s === "none" ? void 0 : s
  }), {
    getReferenceProps: M,
    getFloatingProps: D,
    getTriggerProps: O
  } = eo([I, k]), V = x.useMemo(() => M(), [M]), _ = x.useMemo(() => O(), [O]), A = x.useMemo(() => D(), [D]);
  return g.useSyncedValues({
    activeTriggerProps: V,
    inactiveTriggerProps: _,
    popupProps: A
  }), /* @__PURE__ */ m(Od.Provider, {
    value: g,
    children: typeof p == "function" ? p({
      payload: C
    }) : p
  });
});
process.env.NODE_ENV !== "production" && (Vd.displayName = "TooltipRoot");
const _d = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (_d.displayName = "TooltipProviderContext");
function x7() {
  return x.useContext(_d);
}
let C7 = (function(t) {
  return t[t.popupOpen = Tl.popupOpen] = "popupOpen", t.triggerDisabled = "data-trigger-disabled", t;
})({});
const w7 = 600, Ad = Ah(function(e, n) {
  const {
    className: o,
    render: r,
    handle: i,
    payload: s,
    disabled: l,
    delay: a,
    closeOnClick: c = !0,
    closeDelay: u,
    id: d,
    style: f,
    ...p
  } = e, g = Ss(!0), h = i?.store ?? g;
  if (!h)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Trigger> must be either used within a <Tooltip.Root> component or provided with a handle." : rt(82));
  const b = Mt(d), v = h.useState("isTriggerActive", b), C = h.useState("isOpenedByTrigger", b), y = h.useState("floatingRootContext"), w = x.useRef(null), R = a ?? w7, S = u ?? 0, {
    registerTrigger: E,
    isMountedByThisTrigger: N
  } = cs(b, w, h, {
    payload: s,
    closeOnClick: c,
    closeDelay: S
  }), T = x7(), {
    delayRef: P,
    isInstantPhase: I,
    hasProvider: k
  } = b8(y, {
    open: C
  });
  h.useSyncedValue("isInstantPhase", I);
  const M = h.useState("disabled"), D = l ?? M, O = h.useState("trackCursorAxis"), V = h.useState("disableHoverablePopup"), _ = ms(y, {
    enabled: !D,
    mouseOnly: !0,
    move: !1,
    handleClose: !V && O !== "both" ? hs() : null,
    restMs() {
      const U = T?.delay, Y = typeof P.current == "object" ? P.current.open : void 0;
      let K = R;
      return k && (Y !== 0 ? K = a ?? U ?? R : K = 0), K;
    },
    delay() {
      const U = typeof P.current == "object" ? P.current.close : void 0;
      let Y = S;
      return u == null && k && (Y = U), {
        close: Y
      };
    },
    triggerElementRef: w,
    isActiveTrigger: v,
    isClosing: () => h.select("transitionStatus") === "ending"
  }), A = md(y, {
    enabled: !D
  }).reference, L = {
    open: C
  }, B = h.useState("triggerProps", N);
  return $e("button", e, {
    state: L,
    ref: [n, E, w],
    props: [_, A, B, {
      onPointerDown() {
        h.set("closeOnClick", c);
      },
      id: b,
      [C7.triggerDisabled]: D ? "" : void 0
    }, p],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (Ad.displayName = "TooltipTrigger");
const Ld = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ld.displayName = "TooltipPortalContext");
function S7() {
  const t = x.useContext(Ld);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Tooltip.Portal> is missing." : rt(70));
  return t;
}
const ga = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    children: o,
    container: r,
    className: i,
    render: s,
    style: l,
    ...a
  } = e, {
    portalNode: c,
    portalSubtree: u
  } = Sh({
    container: r,
    ref: n,
    componentProps: e,
    elementProps: a
  });
  return !u && !c ? null : /* @__PURE__ */ F(x.Fragment, {
    children: [u, c && /* @__PURE__ */ an.createPortal(o, c)]
  });
});
process.env.NODE_ENV !== "production" && (ga.displayName = "FloatingPortalLite");
const Fd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return Ss().useState("mounted") || o ? /* @__PURE__ */ m(Ld.Provider, {
    value: o,
    children: /* @__PURE__ */ m(ga, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Fd.displayName = "TooltipPortal");
const $d = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && ($d.displayName = "TooltipPositionerContext");
function c2() {
  const t = x.useContext($d);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TooltipPositionerContext is missing. TooltipPositioner parts must be placed within <Tooltip.Positioner>." : rt(71));
  return t;
}
const Hd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "top",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = la,
    style: v,
    ...C
  } = e, y = Ss(), w = S7(), R = y.useState("open"), S = y.useState("mounted"), E = y.useState("trackCursorAxis"), N = y.useState("disableHoverablePopup"), T = y.useState("floatingRootContext"), P = y.useState("instantType"), I = y.useState("transitionStatus"), k = y.useState("hasViewport"), M = ri({
    anchor: i,
    positionMethod: s,
    floatingRootContext: T,
    mounted: S,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    arrowPadding: p,
    disableAnchorTracking: h,
    keepMounted: w,
    collisionAvoidance: b,
    adaptiveOrigin: k ? fa : void 0
  }), D = x.useMemo(() => ({
    open: R,
    side: M.side,
    align: M.align,
    anchorHidden: M.anchorHidden,
    instant: E !== "none" ? "tracking-cursor" : P
  }), [R, M.side, M.align, M.anchorHidden, E, P]), O = li(e, D, {
    styles: M.positionerStyles,
    transitionStatus: I,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !S,
    inert: !R || E === "both" || N
  });
  return /* @__PURE__ */ m($d.Provider, {
    value: M,
    children: O
  });
});
process.env.NODE_ENV !== "production" && (Hd.displayName = "TooltipPositioner");
const R7 = {
  ...Nn,
  ...Bt
}, zd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Ss(), {
    side: a,
    align: c
  } = c2(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), g = l.useState("floatingRootContext");
  jt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = l.useState("disabled"), b = l.useState("closeDelay");
  return ua(g, {
    enabled: !h,
    closeDelay: b
  }), $e("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Rr(f), s],
    stateAttributesMapping: R7
  });
});
process.env.NODE_ENV !== "production" && (zd.displayName = "TooltipPopup");
const Bd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Ss(), a = l.useState("open"), c = l.useState("instantType"), {
    arrowRef: u,
    side: d,
    align: f,
    arrowUncentered: p,
    arrowStyles: g
  } = c2();
  return $e("div", e, {
    state: {
      open: a,
      side: d,
      align: f,
      uncentered: p,
      instant: c
    },
    ref: [n, u],
    props: [{
      style: g,
      "aria-hidden": !0
    }, s],
    stateAttributesMapping: Nn
  });
});
process.env.NODE_ENV !== "production" && (Bd.displayName = "TooltipArrow");
const u2 = function(e) {
  const {
    delay: n,
    closeDelay: o,
    timeout: r = 400
  } = e, i = x.useMemo(() => ({
    delay: n,
    closeDelay: o
  }), [n, o]), s = x.useMemo(() => ({
    open: n,
    close: o
  }), [n, o]);
  return /* @__PURE__ */ m(_d.Provider, {
    value: i,
    children: /* @__PURE__ */ m(h8, {
      delay: s,
      timeoutMs: r,
      children: e.children
    })
  });
};
process.env.NODE_ENV !== "production" && (u2.displayName = "TooltipProvider");
const d2 = "z-[var(--z-layer-tooltip)]", f2 = 5, p2 = 9, g2 = ne("max-w-[240px]", "rounded-(--radius-sm)", "px-(--spacing-12) py-(--spacing-8)", "bg-surface-inverse-surface", "text-text-inverse", "shadow-elevation-2", "font-(family-name:--font-family-body)", "transition-opacity duration-150 ease-in-out", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0"), m2 = ne("text-(length:--font-size-label-small)", "leading-(--font-line-height-16)"), h2 = ne("text-(length:--font-size-label-xs)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "mt-(--spacing-4)"), b2 = ne("bg-surface-inverse-surface", "[&[data-side=top]]:h-(--spacing-6) [&[data-side=top]]:w-(--spacing-12)", "[&[data-side=bottom]]:h-(--spacing-6) [&[data-side=bottom]]:w-(--spacing-12)", "[&[data-side=left]]:h-(--spacing-12) [&[data-side=left]]:w-(--spacing-6)", "[&[data-side=right]]:h-(--spacing-12) [&[data-side=right]]:w-(--spacing-6)", "[&[data-side=top]]:-bottom-(--spacing-4) [&[data-side=top]]:[clip-path:polygon(50%_100%,0%_0%,100%_0%)]", "[&[data-side=bottom]]:-top-(--spacing-4) [&[data-side=bottom]]:[clip-path:polygon(50%_0%,0%_100%,100%_100%)]", "[&[data-side=left]]:-right-(--spacing-4) [&[data-side=left]]:[clip-path:polygon(100%_50%,0%_0%,0%_100%)]", "[&[data-side=right]]:-left-(--spacing-4) [&[data-side=right]]:[clip-path:polygon(0%_50%,100%_0%,100%_100%)]");
function qo(t) {
  const e = z.c(30), {
    children: n,
    label: o,
    description: r,
    endSection: i,
    side: s,
    align: l,
    disabled: a,
    showArrow: c
  } = t, u = s === void 0 ? "top" : s, d = l === void 0 ? "center" : l, f = a === void 0 ? !1 : a, p = c === void 0 ? !0 : c, g = qt();
  let h;
  e[0] !== n ? (h = /* @__PURE__ */ m(Ad, { render: n }), e[0] = n, e[1] = h) : h = e[1];
  const b = p ? p2 : f2;
  let v;
  e[2] !== p ? (v = p && /* @__PURE__ */ m(Bd, { "data-slot": "tooltip-arrow", className: b2 }), e[2] = p, e[3] = v) : v = e[3];
  const C = r ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let y;
  e[4] !== C ? (y = ne(m2, C), e[4] = C, e[5] = y) : y = e[5];
  let w;
  e[6] !== o || e[7] !== y ? (w = /* @__PURE__ */ m("p", { className: y, children: o }), e[6] = o, e[7] = y, e[8] = w) : w = e[8];
  let R;
  e[9] !== i || e[10] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-8)", children: [
    w,
    i
  ] }), e[9] = i, e[10] = w, e[11] = R) : R = e[11];
  let S;
  e[12] !== r ? (S = r && /* @__PURE__ */ m("p", { className: h2, children: r }), e[12] = r, e[13] = S) : S = e[13];
  let E;
  e[14] !== R || e[15] !== S || e[16] !== v ? (E = /* @__PURE__ */ F(zd, { className: g2, children: [
    v,
    R,
    S
  ] }), e[14] = R, e[15] = S, e[16] = v, e[17] = E) : E = e[17];
  let N;
  e[18] !== d || e[19] !== u || e[20] !== E || e[21] !== b ? (N = /* @__PURE__ */ m(Hd, { side: u, align: d, sideOffset: b, className: d2, children: E }), e[18] = d, e[19] = u, e[20] = E, e[21] = b, e[22] = N) : N = e[22];
  let T;
  e[23] !== g || e[24] !== N ? (T = /* @__PURE__ */ m(Fd, { container: g, children: N }), e[23] = g, e[24] = N, e[25] = T) : T = e[25];
  let P;
  return e[26] !== f || e[27] !== T || e[28] !== h ? (P = /* @__PURE__ */ F(Vd, { disabled: f, children: [
    h,
    T
  ] }), e[26] = f, e[27] = T, e[28] = h, e[29] = P) : P = e[29], P;
}
function Rs() {
  const t = z.c(10), [e, n] = x.useState(!1);
  let o, r;
  t[0] !== e ? (o = () => {
    if (!e)
      return;
    const u = function() {
      n(!1);
    };
    return document.addEventListener("mouseup", u), document.addEventListener("dragend", u), window.addEventListener("blur", u), () => {
      document.removeEventListener("mouseup", u), document.removeEventListener("dragend", u), window.removeEventListener("blur", u);
    };
  }, r = [e], t[0] = e, t[1] = o, t[2] = r) : (o = t[1], r = t[2]), x.useEffect(o, r);
  const i = e ? "" : void 0;
  let s, l;
  t[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = (u) => {
    u.defaultPrevented || u.button !== 0 || n(!0);
  }, l = () => n(!1), t[3] = s, t[4] = l) : (s = t[3], l = t[4]);
  let a;
  t[5] !== i ? (a = {
    "data-mouse-down": i,
    onMouseDown: s,
    onMouseUp: l
  }, t[5] = i, t[6] = a) : a = t[6];
  let c;
  return t[7] !== e || t[8] !== a ? (c = {
    mouseDown: e,
    triggerMouseDownProps: a
  }, t[7] = e, t[8] = a, t[9] = c) : c = t[9], c;
}
function E7(t) {
  const e = z.c(17), {
    align: n,
    disabled: o,
    items: r,
    size: i,
    tooltip: s,
    variant: l,
    ...a
  } = t, c = n === void 0 ? "end" : n, u = o === void 0 ? !1 : o, d = i === void 0 ? "md" : i, f = l === void 0 ? "default" : l, [p, g] = x.useState(!1), {
    triggerMouseDownProps: h
  } = Rs();
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = function(I) {
    g(I);
  }, e[0] = b) : b = e[0];
  const v = b, C = M7({
    disabled: u,
    isOpen: p,
    props: a,
    size: d,
    tooltip: s,
    triggerMouseDownProps: h,
    variant: f
  }), y = f === "combo" && "gap-(--spacing-4)";
  let w;
  e[1] !== y ? (w = ne("inline-flex items-center", y), e[1] = y, e[2] = w) : w = e[2];
  let R;
  e[3] !== w || e[4] !== C ? (R = /* @__PURE__ */ m("div", { className: w, children: C }), e[3] = w, e[4] = C, e[5] = R) : R = e[5];
  const S = R;
  let E;
  e[6] !== r ? (E = r.map(N7), e[6] = r, e[7] = E) : E = e[7];
  let N;
  e[8] !== c || e[9] !== E ? (N = /* @__PURE__ */ m(kr, { align: c, sideOffset: 5, size: "trigger", children: E }), e[8] = c, e[9] = E, e[10] = N) : N = e[10];
  let T;
  return e[11] !== u || e[12] !== v || e[13] !== p || e[14] !== N || e[15] !== S ? (T = /* @__PURE__ */ F(Id, { open: p, onOpenChange: v, disabled: u, modal: !1, children: [
    S,
    N
  ] }), e[11] = u, e[12] = v, e[13] = p, e[14] = N, e[15] = S, e[16] = T) : T = e[16], T;
}
function N7(t) {
  return t.type === "subheader" ? /* @__PURE__ */ m(lu, { disabled: t.disabled, children: t.label }, t.id) : k7(t);
}
function Ep(t) {
  return /* @__PURE__ */ m(fr, { disabled: t.disabled, endSection: t.endSection, leadingIcon: t.leadingIcon, onClick: t.onSelect, tone: t.tone, children: t.label }, t.id);
}
function k7(t) {
  return t.submenuItems ? /* @__PURE__ */ m(fr, { disabled: t.disabled, leadingIcon: t.leadingIcon, tone: t.tone, submenu: t.submenuItems.map(Ep), children: t.label }, t.id) : Ep(t);
}
function M7({
  disabled: t,
  isOpen: e,
  props: n,
  size: o,
  tooltip: r,
  triggerMouseDownProps: i,
  variant: s
}) {
  const l = o === "lg" ? "md" : o, a = o === "lg" ? {
    width: 44,
    height: 44
  } : void 0;
  if (s === "combo") {
    const {
      buttonVariant: p = "outline",
      label: g,
      onPrimaryAction: h
    } = n, b = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(mt, { "aria-label": `${g} menu`, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: l, style: a, variant: p, ...i }) });
    return /* @__PURE__ */ F(zt, { children: [
      /* @__PURE__ */ m(P1, { disabled: t, onClick: h, size: o, variant: p, children: g }),
      r ? /* @__PURE__ */ m(qo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ m("span", { className: "inline-flex", children: b }) }) : b
    ] });
  }
  if (s === "overflow") {
    const {
      "aria-label": p
    } = n, g = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(mt, { "aria-label": p, disabled: t, icon: "ellipsis-dots", size: l, style: a, variant: "outline", ...i }) });
    return r ? /* @__PURE__ */ m(qo, { label: r, side: "top", align: "end", showArrow: !0, children: /* @__PURE__ */ m("span", { className: "inline-flex", children: g }) }) : g;
  }
  const {
    "aria-label": c,
    label: u
  } = n, d = {};
  c && (d["aria-label"] = c);
  const f = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(P1, { ...d, disabled: t, icon: e ? "chevron-up" : "chevron-down", size: o, variant: "outline", ...i, children: u }) });
  return r ? I7(f, r) : f;
}
function I7(t, e) {
  return /* @__PURE__ */ m(qo, { label: e, side: "top", align: "end", showArrow: !0, children: t });
}
const P7 = {
  xs: "size-(--spacing-40)",
  sm: "size-[60px]",
  md: "size-(--spacing-80)",
  lg: "size-[104px]",
  xl: "size-[120px]"
}, T7 = {
  xs: 40,
  sm: 60,
  md: 80,
  lg: 104,
  xl: 120
}, O7 = {
  xs: "6 6",
  sm: "8 6",
  md: "8 6",
  lg: "8 6",
  xl: "8 6"
}, D7 = {
  xs: 4,
  sm: 4,
  md: 0,
  lg: 2,
  xl: 0
};
function v2(t) {
  const e = z.c(19), {
    size: n,
    src: o,
    alt: r,
    selected: i,
    onClick: s,
    "aria-label": l
  } = t, a = n === void 0 ? "md" : n, c = P7[a], u = a === "sm" ? "focus-visible:ring-offset-1" : "focus-visible:ring-offset-2", d = !!s, f = i !== void 0, p = i === !1 && "opacity-50", g = i && "outline-solid outline-2 outline-primary outline-offset-2";
  let h;
  e[0] !== u || e[1] !== d || e[2] !== p || e[3] !== g ? (h = ne("relative inline-flex items-center justify-center shrink-0 overflow-hidden", "rounded-(--radius-sm)", p, g, d && ["cursor-pointer", "focus-visible:outline-none", "focus-visible:ring-2", u, "focus-visible:ring-datavis-blue-30"]), e[0] = u, e[1] = d, e[2] = p, e[3] = g, e[4] = h) : h = e[4];
  const b = h;
  let v;
  e[5] !== r || e[6] !== a || e[7] !== c || e[8] !== o ? (v = o ? /* @__PURE__ */ m("img", { src: o, alt: r, className: ne(c, "object-cover") }) : /* @__PURE__ */ F("div", { "data-slot": "thumbnail-frame", className: ne(c, "relative flex items-center justify-center rounded-(--radius-sm) bg-surface-container-lowest text-icon-main"), children: [
    /* @__PURE__ */ m(V7, { size: a }),
    /* @__PURE__ */ m(Ke, { name: "image-regular", size: a, tone: "inherit" })
  ] }), e[5] = r, e[6] = a, e[7] = c, e[8] = o, e[9] = v) : v = e[9];
  const C = v;
  if (d) {
    const w = f ? i : void 0;
    let R;
    return e[10] !== l || e[11] !== s || e[12] !== b || e[13] !== w || e[14] !== C ? (R = /* @__PURE__ */ m(Qn, { type: "button", className: b, "aria-label": l, "aria-pressed": w, onClick: s, children: C }), e[10] = l, e[11] = s, e[12] = b, e[13] = w, e[14] = C, e[15] = R) : R = e[15], R;
  }
  let y;
  return e[16] !== b || e[17] !== C ? (y = /* @__PURE__ */ m("div", { className: b, children: C }), e[16] = b, e[17] = C, e[18] = y) : y = e[18], y;
}
function V7(t) {
  const e = z.c(12), {
    size: n
  } = t, o = T7[n], r = o - 0.5, i = r - 3.5, s = O7[n], l = D7[n], a = `M 4 ${0.5} H ${i} A ${3.5} ${3.5} 0 0 1 ${r} 4`, c = `M ${r} 4 V ${i} A ${3.5} ${3.5} 0 0 1 ${i} ${r}`, u = `M ${i} ${r} H 4 A ${3.5} ${3.5} 0 0 1 ${0.5} ${i}`, d = `M ${0.5} ${i} V 4 A ${3.5} ${3.5} 0 0 1 4 ${0.5}`;
  let f;
  e[0] !== a || e[1] !== c || e[2] !== u || e[3] !== d ? (f = [a, c, u, d], e[0] = a, e[1] = c, e[2] = u, e[3] = d, e[4] = f) : f = e[4];
  const p = f, g = `0 0 ${o} ${o}`;
  let h;
  e[5] !== s || e[6] !== l || e[7] !== p ? (h = p.map((v) => /* @__PURE__ */ m("path", { "data-slot": "thumbnail-empty-stroke", className: "stroke-outline-subtle", d: v, strokeDasharray: s, strokeDashoffset: l, strokeLinecap: "butt", strokeLinejoin: "miter", strokeWidth: "1" }, v)), e[5] = s, e[6] = l, e[7] = p, e[8] = h) : h = e[8];
  let b;
  return e[9] !== g || e[10] !== h ? (b = /* @__PURE__ */ m("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", viewBox: g, children: h }), e[9] = g, e[10] = h, e[11] = b) : b = e[11], b;
}
const ci = {
  default: "text-text-default",
  subtle: "text-text-subtle",
  subtext: "text-text-subtext",
  disabled: "text-text-disabled",
  inverse: "text-text-inverse",
  inherit: "text-inherit",
  negative: "text-negative",
  positive: "text-positive",
  warning: "text-text-warning",
  informative: "text-text-informative"
}, ui = {
  start: "text-start",
  center: "text-center",
  end: "text-end"
}, _7 = {
  ...ui,
  justify: "text-justify"
}, di = {
  true: "truncate",
  false: ""
}, ko = {
  regular: "font-(number:--font-weight-regular)",
  medium: "font-(number:--font-weight-medium)",
  semibold: "font-(number:--font-weight-semibold)",
  bold: "font-(number:--font-weight-bold)"
}, y2 = {
  true: "italic",
  false: "not-italic"
}, A7 = {
  2: "line-clamp-2",
  3: "line-clamp-3",
  4: "line-clamp-4"
}, L7 = ce(["font-(family-name:--font-family-body)", "text-(length:--font-size-body-small)", "leading-(--line-height-16)", "font-(number:--font-weight-regular)"], {
  variants: {
    tone: ci,
    align: ui,
    truncate: di
  },
  defaultVariants: {
    tone: "default"
  }
});
function hO({
  tone: t,
  align: e,
  truncate: n,
  as: o = "span",
  ...r
}) {
  return x.createElement(o, {
    className: L7({
      tone: t,
      align: e,
      truncate: n
    }),
    ...r
  });
}
const F7 = ce("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-lg)", "leading-(--line-height-64)", "tracking-[-0.25px]"],
      md: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-md)", "leading-(--line-height-52)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-display)", "text-(length:--font-size-display-sm)", "leading-(--line-height-44)", "tracking-normal"]
    },
    tone: ci,
    align: ui,
    truncate: di,
    weight: ko
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), $7 = {
  lg: "h1",
  md: "h1",
  sm: "h2"
};
function bO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? $7[t] : "h1", a = i || l;
  return x.createElement(a, {
    className: F7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const H7 = ce("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-lg)", "leading-(--line-height-40)", "tracking-normal"],
      md: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-md)", "leading-(--line-height-36)", "tracking-normal"],
      sm: ["font-(family-name:--font-family-headline)", "text-(length:--font-size-headline-sm)", "leading-(--line-height-32)", "tracking-normal"]
    },
    tone: ci,
    align: ui,
    truncate: di,
    weight: {
      medium: ko.medium,
      semibold: ko.semibold,
      bold: ko.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), z7 = {
  lg: "h2",
  md: "h3",
  sm: "h4"
};
function vO({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? z7[t] : "h3", a = i || l;
  return x.createElement(a, {
    className: H7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const B7 = ce("font-(family-name:--font-family-label)", {
  variants: {
    size: {
      lg: ["text-(length:--font-size-label-lg)", "leading-(--line-height-20)"],
      md: ["text-(length:--font-size-label-md)", "leading-(--line-height-20)"],
      sm: ["text-(length:--font-size-label-sm)", "leading-(--line-height-16)"],
      xs: ["text-(length:--font-size-label-xs)", "leading-(--line-height-16)"]
    },
    tone: ci,
    align: ui,
    truncate: di,
    weight: ko,
    italic: y2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "semibold",
    italic: !1
  }
});
function fo({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "semibold",
  italic: i = !1,
  as: s = "span",
  ...l
}) {
  return x.createElement(s, {
    className: B7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r,
      italic: i
    }),
    ...l
  });
}
const W7 = ce("", {
  variants: {
    size: {
      lg: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-lg)", "leading-(--line-height-24)", "tracking-[0.5px]"],
      md: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-md)", "leading-(--line-height-20)", "tracking-[0.25px]"],
      sm: ["font-(family-name:--font-family-body)", "text-(length:--font-size-body-sm)", "leading-(--line-height-16)", "tracking-[0.4px]"]
    },
    tone: ci,
    align: _7,
    truncate: di,
    lineClamp: A7,
    weight: ko,
    italic: y2
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "regular",
    italic: !1
  }
});
function ln({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  lineClamp: r,
  weight: i = "regular",
  italic: s = !1,
  as: l = "p",
  ...a
}) {
  return x.createElement(l, {
    className: W7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      lineClamp: r,
      weight: i,
      italic: s
    }),
    ...a
  });
}
const U7 = ce("", {
  variants: {
    size: {
      xl: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xl)", "tracking-normal"],
      lg: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "tracking-[0.15px]"],
      md: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "tracking-[0.15px]"],
      sm: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-sm)", "tracking-[0.1px]"],
      xs: ["font-(family-name:--font-family-title)", "text-(length:--font-size-title-xs)", "leading-(--line-height-16)", "tracking-[0.1px]"]
    },
    tone: ci,
    align: ui,
    truncate: di,
    weight: {
      medium: ko.medium,
      semibold: ko.semibold,
      bold: ko.bold
    }
  },
  defaultVariants: {
    size: "md",
    tone: "default",
    weight: "medium"
  }
}), G7 = {
  xl: "h4",
  lg: "h5",
  md: "h5",
  sm: "h6",
  xs: "h6"
};
function An({
  size: t = "md",
  tone: e,
  align: n,
  truncate: o,
  weight: r = "medium",
  as: i,
  ...s
}) {
  const l = t ? G7[t] : "h5", a = i || l;
  return x.createElement(a, {
    className: U7({
      size: t,
      tone: e,
      align: n,
      truncate: o,
      weight: r
    }),
    ...s
  });
}
const Y7 = ce(["flex", "h-full", "min-h-0", "min-w-0", "w-full", "flex-col", "overflow-hidden", "bg-surface", "pb-(--spacing-20)", "pt-(--spacing-10)"]), j7 = ce(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-16)", "px-(--spacing-10)"]), K7 = ce(["flex", "shrink-0", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-8)", "py-(--spacing-8)"]), q7 = ce(["flex", "min-h-0", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-20)"]), Z7 = ce(["flex", "shrink-0", "items-start", "gap-(--spacing-20)", "px-(--spacing-10)"]), X7 = ce(["flex", "min-w-0", "flex-1", "flex-col", "items-start", "gap-(--spacing-10)"]), Q7 = ce(["flex", "w-full", "flex-wrap", "items-center", "gap-x-(--spacing-6)", "gap-y-(--spacing-2)"]), J7 = ce(["flex", "flex-1", "min-h-0", "min-w-0", "flex-col", "gap-(--spacing-12)", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface-low", "px-(--spacing-4)", "pb-(--spacing-4)"]), ey = ce(["flex", "w-full", "max-w-[580px]", "min-w-0", "self-center", "flex-col"]), ty = ce(["flex", "w-full", "flex-col", "gap-(--spacing-20)", "py-(--spacing-10)"]), ny = ce(["flex", "min-w-0", "flex-col"], {
  variants: {
    informative: {
      true: "gap-(--spacing-12)",
      false: "gap-(--spacing-6)"
    }
  },
  defaultVariants: {
    informative: !1
  }
}), oy = ce(["flex", "h-full", "min-h-0", "w-(--spacing-40)", "shrink-0", "flex-col", "items-center"]), ry = ce(["w-(--spacing-2)", "flex-1", "bg-outline-variant"]);
function iy(t) {
  const e = z.c(24), {
    content: n,
    detail: o,
    actions: r
  } = t, i = "title" in n ? n.title : void 0, s = "body" in n ? n.body : void 0, l = n.type === "observation" || n.type === "next-step" || n.type === "recommended-procedure", a = l ? "informative" : void 0;
  let c;
  e[0] !== l ? (c = ny({
    informative: l
  }), e[0] = l, e[1] = c) : c = e[1];
  let u;
  e[2] !== i ? (u = i ? /* @__PURE__ */ m(An, { size: "md", children: i }) : null, e[2] = i, e[3] = u) : u = e[3];
  let d;
  e[4] !== s || e[5] !== n.steps || e[6] !== n.type ? (d = n.type === "recommended-procedure" ? /* @__PURE__ */ m("ol", { className: "m-0 w-full list-decimal pl-(--spacing-20) text-(length:--font-size-body-medium) leading-(--font-line-height-20)", children: n.steps.map(sy) }) : s ? /* @__PURE__ */ m(ln, { size: "md", children: s }) : null, e[4] = s, e[5] = n.steps, e[6] = n.type, e[7] = d) : d = e[7];
  let f;
  e[8] !== n ? (f = "completion" in n && n.completion ? /* @__PURE__ */ m(ln, { size: "md", weight: "semibold", children: n.completion }) : null, e[8] = n, e[9] = f) : f = e[9];
  let p;
  e[10] !== o ? (p = o ? /* @__PURE__ */ m("div", { children: o }) : null, e[10] = o, e[11] = p) : p = e[11];
  let g;
  e[12] !== r ? (g = r ? /* @__PURE__ */ m("div", { className: "flex w-full items-center", children: r }) : null, e[12] = r, e[13] = g) : g = e[13];
  let h;
  e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p || e[19] !== g ? (h = /* @__PURE__ */ F("div", { className: c, children: [
    u,
    d,
    f,
    p,
    g
  ] }), e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = g, e[20] = h) : h = e[20];
  let b;
  return e[21] !== a || e[22] !== h ? (b = /* @__PURE__ */ m(Xc, { tone: a, children: h }), e[21] = a, e[22] = h, e[23] = b) : b = e[23], b;
}
function sy(t) {
  return /* @__PURE__ */ m("li", { children: t.content }, t.id);
}
function ly(t) {
  const e = z.c(35), {
    alert: n,
    isCurrentUser: o,
    showConnector: r,
    renderAlertDetail: i,
    renderAlertActions: s
  } = t, l = o ? "outbound" : "inbound";
  let a;
  e[0] !== n.author.initials || e[1] !== n.author.name || e[2] !== n.author.type ? (a = /* @__PURE__ */ m(Gr, { variant: n.author.type, initials: n.author.initials, "aria-label": n.author.name }), e[0] = n.author.initials, e[1] = n.author.name, e[2] = n.author.type, e[3] = a) : a = e[3];
  const c = a;
  let u;
  e[4] !== c || e[5] !== o || e[6] !== r ? (u = o ? null : /* @__PURE__ */ m(Om, { children: r ? /* @__PURE__ */ F("div", { className: oy(), children: [
    /* @__PURE__ */ m("div", { className: "-mb-(--spacing-16) flex w-full items-center pb-(--spacing-24)", children: c }),
    /* @__PURE__ */ m("div", { "aria-hidden": "true", "data-slot": "asset-alert-chat-connector-divider", className: ry() })
  ] }) : /* @__PURE__ */ m("div", { className: "pb-(--spacing-24)", children: c }) }), e[4] = c, e[5] = o, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== n.author.name ? (d = /* @__PURE__ */ m(fo, { size: "lg", weight: "medium", children: n.author.name }), e[8] = n.author.name, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.author.type ? (f = n.author.type === "internal" ? /* @__PURE__ */ m(Xv, { size: "compact", "aria-hidden": "true", "data-slot": "asset-alert-chat-author-logo" }) : null, e[10] = n.author.type, e[11] = f) : f = e[11];
  let p;
  e[12] !== n.timestamp ? (p = n.timestamp ? /* @__PURE__ */ F(zt, { children: [
    /* @__PURE__ */ m(fo, { size: "xs", tone: "subtle", weight: "semibold", children: "•" }),
    /* @__PURE__ */ m(fo, { size: "lg", tone: "subtle", weight: "medium", children: n.timestamp })
  ] }) : null, e[12] = n.timestamp, e[13] = p) : p = e[13];
  let g;
  e[14] !== d || e[15] !== f || e[16] !== p ? (g = /* @__PURE__ */ F(Dm, { children: [
    d,
    f,
    p
  ] }), e[14] = d, e[15] = f, e[16] = p, e[17] = g) : g = e[17];
  let h;
  e[18] !== n || e[19] !== i ? (h = i?.(n), e[18] = n, e[19] = i, e[20] = h) : h = e[20];
  let b;
  e[21] !== n || e[22] !== s ? (b = s?.(n), e[21] = n, e[22] = s, e[23] = b) : b = e[23];
  let v;
  e[24] !== n.content || e[25] !== h || e[26] !== b ? (v = /* @__PURE__ */ m($v, { children: /* @__PURE__ */ m(iy, { content: n.content, detail: h, actions: b }) }), e[24] = n.content, e[25] = h, e[26] = b, e[27] = v) : v = e[27];
  let C;
  e[28] !== g || e[29] !== v ? (C = /* @__PURE__ */ F(Zc, { children: [
    g,
    v
  ] }), e[28] = g, e[29] = v, e[30] = C) : C = e[30];
  let y;
  return e[31] !== l || e[32] !== C || e[33] !== u ? (y = /* @__PURE__ */ F(qc, { direction: l, children: [
    u,
    C
  ] }), e[31] = l, e[32] = C, e[33] = u, e[34] = y) : y = e[34], y;
}
function ay(t, e) {
  return t.author.type === "internal" && e?.author.type === "internal" && t.author.id === e.author.id && !e.dateLabel;
}
function cy(t) {
  const e = z.c(4), {
    messageId: n,
    hasAuxiliaryContent: o
  } = t, {
    scrollToEnd: r
  } = Su(), i = ft(n);
  let s, l;
  return e[0] !== n || e[1] !== r ? (s = () => {
    n && i.current !== n && r(), i.current = n;
  }, l = [n, r], e[0] = n, e[1] = r, e[2] = s, e[3] = l) : (s = e[2], l = e[3]), kt(s, l), uy(o), null;
}
function uy(t) {
  const e = z.c(4), {
    scrollToMessage: n
  } = Su();
  let o, r;
  e[0] !== t || e[1] !== n ? (o = () => {
    t && n("asset-alert-chat-auxiliary-content", {
      align: "start"
    });
  }, r = [t, n], e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (o = e[2], r = e[3]), kt(o, r);
}
function yO({
  title: t,
  titleAccessory: e,
  assetSummary: n,
  sections: o,
  alerts: r,
  currentUserId: i,
  activeSectionId: s,
  onSectionChange: l,
  headerMenuItems: a,
  onClose: c,
  renderAlertDetail: u,
  renderAlertActions: d,
  composer: f,
  auxiliaryContent: p
}) {
  const g = _t(), h = `asset-alert-${g}-details`, [b, v] = ot(!1), C = new Set(o.map((k) => k.id)), y = new Map(o.map((k) => [k.id, `asset-alert-${g}-${k.id}`])), w = /* @__PURE__ */ new Set(), R = r.map((k) => {
    const M = k.sectionId, D = M && C.has(M) && !w.has(M) ? y.get(M) : void 0;
    return M && D && w.add(M), {
      alert: k,
      anchorId: D
    };
  }), S = Y5(o.filter((k) => w.has(k.id)).map((k) => y.get(k.id) ?? k.id)), E = ft(S.activeId), N = r.reduce((k, M) => M.author.id === i ? M.id : k, void 0), T = s === void 0 ? S.activeId : w.has(s) ? y.get(s) : void 0;
  function P(k) {
    S.scrollRef.current = k;
  }
  function I(k) {
    E.current = k, S.onActiveChange(k);
    const M = o.find((D) => y.get(D.id) === k);
    M && l?.(M.id);
  }
  return kt(() => {
    if (E.current === S.activeId)
      return;
    E.current = S.activeId;
    const k = o.find((M) => y.get(M.id) === S.activeId);
    k && l?.(k.id);
  }, [S.activeId, l, y, o]), /* @__PURE__ */ m("section", { "aria-label": typeof t == "string" ? t : "Asset alert chat", className: Y7(), "data-slot": "asset-alert-chat", children: /* @__PURE__ */ F("div", { className: j7(), children: [
    /* @__PURE__ */ F("header", { className: K7(), "data-slot": "asset-alert-chat-header", children: [
      /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 flex-wrap items-center gap-(--spacing-8)", children: [
        /* @__PURE__ */ m(An, { as: "h2", size: "lg", truncate: !0, children: t }),
        e
      ] }),
      /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-10)", children: [
        a?.length ? /* @__PURE__ */ m(E7, { label: "View", items: a, size: "sm" }) : null,
        c ? /* @__PURE__ */ m(mt, { icon: "x-close", variant: "ghost", size: "md", "aria-label": "Close asset chat", onClick: c }) : null
      ] })
    ] }),
    /* @__PURE__ */ F("div", { className: q7(), children: [
      n ? /* @__PURE__ */ F("div", { className: Z7(), "data-slot": "asset-alert-chat-summary", children: [
        /* @__PURE__ */ m(v2, { ...n.thumbnail, size: b ? "xl" : "sm" }),
        /* @__PURE__ */ F("div", { className: X7(), children: [
          /* @__PURE__ */ m(An, { as: "h3", size: "sm", truncate: !0, children: n.name }),
          /* @__PURE__ */ m("div", { id: h, hidden: !b, className: "flex w-full flex-col items-start gap-(--spacing-10)", children: b ? /* @__PURE__ */ F(zt, { children: [
            n.metrics.length > 0 ? /* @__PURE__ */ m("div", { className: Q7(), children: n.metrics.map((k, M) => /* @__PURE__ */ F("span", { className: "contents", children: [
              M > 0 ? /* @__PURE__ */ m("span", { className: "inline-flex h-(--spacing-16) w-(--spacing-2) shrink-0 items-stretch self-center", children: /* @__PURE__ */ m(gr, { orientation: "vertical" }) }) : null,
              /* @__PURE__ */ F("span", { className: "inline-flex h-(--spacing-24) min-w-0 items-center gap-(--spacing-4)", children: [
                /* @__PURE__ */ F(ln, { as: "span", size: "md", tone: "subtle", truncate: !0, children: [
                  k.label,
                  ":"
                ] }),
                /* @__PURE__ */ m("span", { children: /* @__PURE__ */ m(ln, { as: "span", size: "md", truncate: !0, children: k.value }) })
              ] })
            ] }, k.id)) }) : null,
            /* @__PURE__ */ m(Kn, { ...n.status })
          ] }) : null }),
          /* @__PURE__ */ m(_n, { variant: "ghost", size: "sm", icon: b ? "chevron-up" : "chevron-down", "aria-controls": h, "aria-expanded": b, onClick: () => v((k) => !k), children: b ? "Hide details" : "View details" })
        ] })
      ] }) : null,
      o.length > 0 ? /* @__PURE__ */ m(G5, { orientation: "horizontal", activeId: T, onActiveChange: I, scrollRef: S.scrollRef, startScrollLock: S.startScrollLock, children: o.map((k) => /* @__PURE__ */ m(U5, { targetId: y.get(k.id) ?? k.id, disabled: !w.has(k.id), children: k.label }, k.id)) }) : null,
      /* @__PURE__ */ F("div", { className: J7(), children: [
        /* @__PURE__ */ F(Vm, { defaultScrollPosition: "end", children: [
          /* @__PURE__ */ F(_m, { ref: P, "aria-label": "Asset alert transcript", children: [
            /* @__PURE__ */ F(Am, { children: [
              R.length === 0 ? /* @__PURE__ */ m("div", { className: "flex min-h-full items-center justify-center text-center", children: /* @__PURE__ */ m(ln, { tone: "subtle", children: "No alerts to display." }) }) : R.map(({
                alert: k,
                anchorId: M
              }, D) => {
                const O = R[D + 1]?.alert, V = /* @__PURE__ */ m(ly, { alert: k, isCurrentUser: k.author.id === i, showConnector: ay(k, O), renderAlertDetail: u, renderAlertActions: d });
                return /* @__PURE__ */ m(Fi, { id: M, messageId: k.id, children: /* @__PURE__ */ m("div", { className: "flex w-full flex-col", children: /* @__PURE__ */ F("div", { className: ey(), "data-slot": "asset-alert-chat-alerts", children: [
                  k.dateLabel ? /* @__PURE__ */ F("div", { className: ty(), children: [
                    /* @__PURE__ */ m(gr, { centeredText: k.dateLabel }),
                    V
                  ] }) : null,
                  k.dateLabel ? null : V
                ] }) }) }, k.id);
              }),
              p ? /* @__PURE__ */ m(Fi, { messageId: "asset-alert-chat-auxiliary-content", "data-slot": "asset-alert-chat-auxiliary-content", children: p }) : null
            ] }),
            /* @__PURE__ */ m(cy, { messageId: N, hasAuxiliaryContent: !!p })
          ] }),
          /* @__PURE__ */ m(Lm, {})
        ] }),
        f ? /* @__PURE__ */ m("div", { className: "px-(--spacing-4)", children: f }) : null
      ] })
    ] })
  ] }) });
}
function Es(t, e) {
  const n = typeof window < "u" && typeof window.matchMedia < "u";
  t = t.replace(/^@media( ?)/m, "");
  const {
    defaultMatches: o = !1,
    matchMedia: r = n ? window.matchMedia : null,
    ssrMatchMedia: i = null,
    noSsr: s = !1
  } = e, l = x.useCallback(() => o, [o]), a = x.useMemo(() => {
    if (s && r)
      return () => r(t).matches;
    if (i !== null) {
      const {
        matches: f
      } = i(t);
      return () => f;
    }
    return l;
  }, [l, t, i, s, r]), [c, u] = x.useMemo(() => {
    if (r === null)
      return [l, () => () => {
      }];
    const f = r(t);
    return [() => f.matches, (p) => ut(f, "change", p)];
  }, [l, r, t]), d = ud.useSyncExternalStore(u, c, a);
  return process.env.NODE_ENV !== "production" && x.useDebugValue({
    query: t,
    match: d
  }), d;
}
const dy = ce(["inline-flex", "rounded-full"], {
  variants: {
    tone: {
      urgent: "bg-error",
      activity: "bg-primary",
      info: "bg-informative"
    },
    variant: {
      dot: "size-(--spacing-6)",
      pill: "items-center justify-center min-w-(--spacing-16) h-(--spacing-16) px-(--spacing-4) py-[3px]"
    }
  },
  defaultVariants: {
    tone: "urgent",
    variant: "dot"
  }
}), fy = ce(["font-(family-name:--font-family-body)", "font-normal", "text-(length:--font-size-body-small)", "leading-[11px]", "text-center"], {
  variants: {
    tone: {
      urgent: "text-error-on-error",
      activity: "text-primary-on-primary",
      info: "text-text-inverse"
    }
  },
  defaultVariants: {
    tone: "urgent"
  }
});
function au(t) {
  const e = z.c(28);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    tone: l,
    count: r,
    visible: a,
    "aria-hidden": n,
    "aria-label": o,
    style: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "urgent" : l, u = a === void 0 ? !0 : a, d = r === void 0;
  let f;
  e[8] !== r || e[9] !== d ? (f = d ? void 0 : String(r).slice(0, 3), e[8] = r, e[9] = d, e[10] = f) : f = e[10];
  const p = f, g = !u || !o || n === !0 || n === "true" ? !0 : void 0, h = d ? "dot" : "pill";
  let b;
  e[11] !== h || e[12] !== c ? (b = dy({
    tone: c,
    variant: h
  }), e[11] = h, e[12] = c, e[13] = b) : b = e[13];
  let v;
  e[14] !== s || e[15] !== u ? (v = u ? s : {
    ...s,
    visibility: "hidden"
  }, e[14] = s, e[15] = u, e[16] = v) : v = e[16];
  let C;
  e[17] !== p || e[18] !== d || e[19] !== c ? (C = !d && /* @__PURE__ */ m("span", { className: fy({
    tone: c
  }), children: p }), e[17] = p, e[18] = d, e[19] = c, e[20] = C) : C = e[20];
  let y;
  return e[21] !== o || e[22] !== g || e[23] !== i || e[24] !== b || e[25] !== v || e[26] !== C ? (y = /* @__PURE__ */ m("span", { ...i, role: "img", "aria-hidden": g, "aria-label": o, className: b, style: v, children: C }), e[21] = o, e[22] = g, e[23] = i, e[24] = b, e[25] = v, e[26] = C, e[27] = y) : y = e[27], y;
}
const Wd = mo("none"), py = ce(["grid", "h-full", "min-h-0", "min-w-0", "w-full", "overflow-hidden", "relative", "rounded-(--radius-md)", "after:pointer-events-none", "after:absolute", "after:inset-0", "after:z-10", "after:rounded-(--radius-md)", "after:border", "after:border-outline-subtle", "after:content-['']", "bg-surface", "shadow-elevation-4", "text-text-default", "max-[599px]:grid-cols-1"], {
  variants: {
    sidebar: {
      none: "grid-cols-[minmax(0,1fr)]",
      expanded: "grid-cols-[240px_minmax(0,1fr)]",
      collapsed: "grid-cols-[64px_minmax(0,1fr)]"
    }
  },
  defaultVariants: {
    sidebar: "none"
  }
}), gy = ce(["min-h-0", "min-w-0", "overflow-hidden", "relative", "after:pointer-events-none", "after:absolute", "after:inset-y-0", "after:right-0", "after:border-r", "after:border-outline-subtle", "after:content-['']", "bg-surface", "max-[599px]:hidden"], {
  variants: {
    sidebar: {
      expanded: "block",
      collapsed: "block",
      none: "hidden"
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), my = ce([], {
  variants: {
    sidebar: {
      expanded: ["flex", "items-center", "justify-between"],
      collapsed: ["relative", "flex", "w-(--spacing-48)", "justify-center"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), hy = ce([], {
  variants: {
    sidebar: {
      expanded: "shrink-0",
      collapsed: ["absolute", "-right-(--spacing-4)", "-top-(--spacing-4)"]
    }
  },
  defaultVariants: {
    sidebar: "expanded"
  }
}), by = ce(["flex", "min-w-0", "min-h-0", "flex-col", "bg-surface"]), vy = ce(["flex", "shrink-0", "items-center", "gap-(--spacing-12)", "border-b", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)"]), yy = ce(["min-h-0", "flex-1", "overflow-hidden"]), xy = ce(["shrink-0", "min-w-0", "bg-surface", "p-(--spacing-16)"]);
function Np(t) {
  const e = z.c(14);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    sidebar: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r ?? "none";
  let s;
  e[4] !== i ? (s = ne(py({
    sidebar: i
  })), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== n || e[7] !== o || e[8] !== i || e[9] !== s ? (l = /* @__PURE__ */ m("section", { "data-slot": "chat-panel", "data-sidebar": i, className: s, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s, e[10] = l) : l = e[10];
  let a;
  return e[11] !== i || e[12] !== l ? (a = /* @__PURE__ */ m(Wd, { value: i, children: l }), e[11] = i, e[12] = l, e[13] = a) : a = e[13], a;
}
function Cy(t) {
  const e = z.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = gn(Wd);
  let i;
  e[3] !== r ? (i = ne(gy({
    sidebar: r
  })), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ m("aside", { "data-slot": "chat-panel-sidebar", className: i, ...o, children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function kp(t) {
  const e = z.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    badge: n,
    children: o,
    sidebar: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = gn(Wd), l = i ?? (s === "collapsed" ? "collapsed" : "expanded");
  let a;
  e[5] !== l ? (a = ne(my({
    sidebar: l
  })), e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] !== n || e[8] !== l ? (c = n && /* @__PURE__ */ m("span", { className: ne(hy({
    sidebar: l
  })), "data-slot": "chat-panel-sidebar-badge", children: /* @__PURE__ */ m(au, { count: n.count, tone: n.tone, "aria-label": n.label }) }), e[7] = n, e[8] = l, e[9] = c) : c = e[9];
  let u;
  return e[10] !== o || e[11] !== r || e[12] !== l || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("header", { "data-slot": "chat-panel-sidebar-header", "data-sidebar": l, className: a, ...r, children: [
    o,
    c
  ] }), e[10] = o, e[11] = r, e[12] = l, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
function Mp(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(by()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { "data-slot": "chat-panel-main", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function xO(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(vy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("header", { "data-slot": "chat-panel-header", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Ip(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(yy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { "data-slot": "chat-panel-body", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function wy(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(xy()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("footer", { "data-slot": "chat-panel-footer", className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function Sy() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ F("output", { className: "inline-flex items-center gap-[5px] rounded-(--radius-xl) bg-surface-container px-[14px] py-(--spacing-10)", "aria-label": "AI is typing", children: [
    /* @__PURE__ */ m("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ m("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" }),
    /* @__PURE__ */ m("span", { className: "block size-(--spacing-8) rounded-full bg-icon-secondary aw-typing-dot" })
  ] }), t[0] = e) : e = t[0], e;
}
const Ry = 4;
function Ni(t) {
  if (!t) return 0;
  const e = t.getBoundingClientRect().width;
  return e > 0 ? e : t.offsetWidth;
}
function Ey(t) {
  const e = Number.parseFloat(getComputedStyle(t).columnGap);
  return Number.isFinite(e) ? e : Ry;
}
function Ny(t, e) {
  return t.reduce((o, r) => o + r, 0) + Math.max(0, t.length - 1) * e;
}
function Pp({
  itemWidths: t,
  reservedStartWidth: e,
  reservedEndWidth: n,
  overflowWidth: o
}) {
  return [...e > 0 ? [e] : [], ...t, ...o && o > 0 ? [o] : [], ...n > 0 ? [n] : []];
}
function Tp(t, e, n, o) {
  if (t.length === 0) return !0;
  if (o <= 1) return Ny(t, n) <= e;
  let r = 1, i = 0;
  for (const s of t) {
    const l = i === 0 ? s : i + n + s;
    if (l <= e || i === 0) {
      i = l;
      continue;
    }
    if (r += 1, i = s, r > o) return !1;
  }
  return !0;
}
function x2({
  items: t,
  maxRows: e = 1,
  minVisibleItems: n = t.length > 0 ? 1 : 0
}) {
  const o = ft(null), r = ft(null), i = ft(null), s = ft(null), l = ft([]), a = ft({}), c = ft(() => {
  }), [u, d] = ot(Number.POSITIVE_INFINITY), f = t.length === 0 ? 0 : Math.max(n, Math.min(u, t.length)), p = t.slice(0, f), g = t.length - p.length;
  return c.current = () => {
    const h = o.current;
    function b(E) {
      d((N) => N === E ? N : E);
    }
    if (!h || t.length <= n) {
      b(t.length);
      return;
    }
    const v = Ni(h), C = Ey(h), y = Ni(i.current), w = Ni(s.current), R = t.map((E, N) => Ni(l.current[N])), S = Pp({
      itemWidths: R,
      reservedStartWidth: y,
      reservedEndWidth: w
    });
    if (Tp(S, v, C, e)) {
      b(t.length);
      return;
    }
    for (let E = t.length - 1; E >= n; E -= 1) {
      const N = t.length - E, T = Ni(a.current[N]), P = Pp({
        itemWidths: R.slice(0, E),
        reservedStartWidth: y,
        reservedEndWidth: w,
        overflowWidth: T
      });
      if (Tp(P, v, C, e)) {
        b(E);
        return;
      }
    }
    b(n);
  }, Io(() => {
    c.current();
  }), Io(() => {
    const h = o.current;
    if (typeof ResizeObserver > "u" || !h) return;
    const b = new ResizeObserver(() => {
      c.current();
    });
    return b.observe(h), r.current && b.observe(r.current), () => b.disconnect();
  }, []), {
    containerRef: o,
    measuringContainerRef: r,
    reservedStartRef: i,
    reservedEndRef: s,
    itemRefs: l,
    overflowRefs: a,
    visibleItems: p,
    overflowCount: g
  };
}
const ky = ce([
  "inline-flex",
  "items-center",
  "justify-center",
  "gap-(--spacing-4)",
  "h-(--spacing-24)",
  "rounded-(--radius-sm)",
  "px-(--spacing-6)",
  "py-(--spacing-4)",
  "border",
  "border-solid",
  "whitespace-nowrap",
  "overflow-hidden",
  "text-ellipsis",
  "font-(family-name:--font-family-body)",
  "font-(number:--font-weight-medium)",
  "text-(length:--font-size-label-medium)",
  "leading-(--font-line-height-16)",
  "cursor-pointer",
  "select-none",
  "transition-colors",
  "duration-200",
  "ease-in-out",
  "outline-none",
  "[&_svg]:pointer-events-none",
  "[&_svg]:shrink-0",
  // Default state
  "bg-tag-default-background",
  "border-tag-default-outline",
  "text-tag-default-text",
  // Hover state
  "hover:bg-tag-hover-background",
  "hover:border-tag-hover-outline",
  // Pressed state
  "active:bg-tag-pressed-background",
  "active:border-tag-pressed-outline",
  // Focus state
  "focus-visible:ring-2",
  "focus-visible:ring-offset-1",
  "focus-visible:ring-offset-tag-default-background",
  "focus-visible:ring-tag-focus-ring"
]), My = {
  neutral: "text-tag-icon-default",
  brand: "text-tag-icon-brand",
  positive: "text-tag-icon-positive",
  warning: "text-tag-icon-warning",
  negative: "text-tag-icon-negative"
};
function cu(t) {
  const e = z.c(20);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    icon: o,
    iconTone: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "neutral" : i, a = s === void 0 ? !1 : s, c = o ? l : void 0;
  let u;
  e[6] !== a ? (u = ne(ky(), a && "opacity-50 pointer-events-none cursor-default"), e[6] = a, e[7] = u) : u = e[7];
  const d = a || void 0, f = a ? -1 : void 0;
  let p;
  e[8] !== o || e[9] !== l ? (p = o && /* @__PURE__ */ m("span", { className: ne("inline-flex items-center", My[l]), children: /* @__PURE__ */ m(Ke, { name: o, size: "xs", tone: "inherit" }) }), e[8] = o, e[9] = l, e[10] = p) : p = e[10];
  let g;
  return e[11] !== n || e[12] !== a || e[13] !== r || e[14] !== c || e[15] !== u || e[16] !== d || e[17] !== f || e[18] !== p ? (g = /* @__PURE__ */ F(Qn, { "data-slot": "tag", "data-icon-tone": c, className: u, disabled: a, "aria-disabled": d, tabIndex: f, ...r, children: [
    p,
    n
  ] }), e[11] = n, e[12] = a, e[13] = r, e[14] = c, e[15] = u, e[16] = d, e[17] = f, e[18] = p, e[19] = g) : g = e[19], g;
}
const Iy = ce(["flex", "min-w-0", "w-full", "flex-col"]), Py = ce(["relative", "flex", "min-w-0", "flex-col", "gap-(--spacing-32)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:not([data-disabled=true]):focus-within]:border-input-active-outline", "[&_[data-slot=icon-button]]:text-icon-main"], {
  variants: {
    hasAlert: {
      true: ["rounded-t-none"],
      false: []
    },
    disabled: {
      true: ["opacity-50", "cursor-not-allowed", "[&_textarea]:cursor-not-allowed", "[&_[data-slot=button]:disabled]:opacity-100", "[&_[data-slot=icon-button]:disabled]:opacity-100"],
      false: []
    }
  },
  defaultVariants: {
    hasAlert: !1,
    disabled: !1
  }
}), Ty = ce(["[&>div]:rounded-b-none"]), Oy = ce(["min-w-0", "w-full", "[field-sizing:content]", "max-h-(--spacing-128)", "outline-none", "bg-transparent", "resize-none", "overflow-y-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder"]), Dy = ce(["flex", "min-w-0", "w-full", "flex-col", "gap-(--spacing-16)"]), Vy = ce(["relative", "flex", "flex-col", "gap-(--spacing-12)"]), _y = ce(["inline-flex", "h-(--spacing-24)", "items-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-label-sm)", "leading-(--font-line-height-16)", "text-text-subtle", "uppercase"]), Ay = ce(["flex", "flex-wrap", "items-center", "gap-(--spacing-8)"]), Ly = ce(["flex", "items-center", "gap-(--spacing-32)"], {
  variants: {
    showUpload: {
      true: "justify-between",
      false: "justify-end"
    }
  },
  defaultVariants: {
    showUpload: !0
  }
});
function Fy(t) {
  const e = z.c(66), {
    value: n,
    onChange: o,
    placeholder: r,
    "aria-label": i,
    disabled: s,
    autoFocus: l,
    onSend: a,
    clearOnSend: c,
    onUpload: u,
    showUpload: d,
    alert: f,
    suggestedUpdates: p
  } = t, g = i === void 0 ? "Message" : i, h = c === void 0 ? !0 : c, b = d === void 0 ? !0 : d;
  let v;
  e[0] !== p ? (v = p === void 0 ? [] : p, e[0] = p, e[1] = v) : v = e[1];
  const C = v, y = ft(null), [w, R] = ot(!1);
  let S;
  e[2] !== n ? (S = n.trim(), e[2] = n, e[3] = S) : S = e[3];
  const E = S.length > 0, N = s || !a || !E;
  let T;
  e[4] !== l ? (T = l ? {
    autoFocus: !0
  } : void 0, e[4] = l, e[5] = T) : T = e[5];
  const P = T;
  let I, k;
  e[6] !== l || e[7] !== s ? (I = () => {
    l && !s && y.current?.focus();
  }, k = [l, s], e[6] = l, e[7] = s, e[8] = I, e[9] = k) : (I = e[8], k = e[9]), kt(I, k);
  let M;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = function(fe) {
    const $ = y.current;
    if (!$)
      return;
    Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, "value")?.set?.call($, fe), $.dispatchEvent(new Event("input", {
      bubbles: !0
    }));
  }, e[10] = M) : M = e[10];
  const D = M;
  let O;
  e[11] !== h || e[12] !== N || e[13] !== a ? (O = function() {
    N || (a?.(), y.current?.focus(), h && D(""));
  }, e[11] = h, e[12] = N, e[13] = a, e[14] = O) : O = e[14];
  const V = O;
  let _;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = function(fe) {
    D(fe.value), y.current?.focus();
  }, e[15] = _) : _ = e[15];
  const A = _;
  let L;
  e[16] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (L = function() {
    R(Hy);
  }, e[16] = L) : L = e[16];
  const B = L;
  let G;
  e[17] !== V || e[18] !== N || e[19] !== a ? (G = function(fe) {
    if (fe.key === "Escape") {
      fe.currentTarget.blur();
      return;
    }
    if (fe.key === "Enter" && !fe.shiftKey && !fe.nativeEvent.isComposing && a) {
      if (fe.preventDefault(), N)
        return;
      V();
    }
  }, e[17] = V, e[18] = N, e[19] = a, e[20] = G) : G = e[20];
  const U = G, Y = !!f;
  let K;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (K = Iy(), e[21] = K) : K = e[21];
  let j;
  e[22] !== f || e[23] !== Y ? (j = Y ? /* @__PURE__ */ m("div", { className: Ty(), children: f }) : null, e[22] = f, e[23] = Y, e[24] = j) : j = e[24];
  const Z = s || void 0;
  let te;
  e[25] !== s || e[26] !== Y ? (te = Py({
    disabled: s,
    hasAlert: Y
  }), e[25] = s, e[26] = Y, e[27] = te) : te = e[27];
  let W;
  e[28] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (W = Dy(), e[28] = W) : W = e[28];
  let X;
  e[29] !== s || e[30] !== C || e[31] !== w ? (X = C.length > 0 && /* @__PURE__ */ m(zy, { disabled: s, suggestedUpdates: C, suggestedUpdatesCollapsed: w, onToggleSuggestedUpdates: B, onSelectSuggestedUpdate: A }), e[29] = s, e[30] = C, e[31] = w, e[32] = X) : X = e[32];
  let ee;
  e[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ee = Oy(), e[33] = ee) : ee = e[33];
  let le;
  e[34] !== g || e[35] !== P || e[36] !== s || e[37] !== U || e[38] !== o || e[39] !== r || e[40] !== n ? (le = /* @__PURE__ */ m("textarea", { ref: y, rows: 1, value: n, onChange: o, onKeyDown: U, placeholder: r, disabled: s, "aria-label": g, ...P, className: ee }), e[34] = g, e[35] = P, e[36] = s, e[37] = U, e[38] = o, e[39] = r, e[40] = n, e[41] = le) : le = e[41];
  let J;
  e[42] !== X || e[43] !== le ? (J = /* @__PURE__ */ F("div", { className: W, children: [
    X,
    le
  ] }), e[42] = X, e[43] = le, e[44] = J) : J = e[44];
  let ie;
  e[45] !== b ? (ie = Ly({
    showUpload: b
  }), e[45] = b, e[46] = ie) : ie = e[46];
  let pe;
  e[47] !== s || e[48] !== u || e[49] !== b ? (pe = b && /* @__PURE__ */ m(mt, { icon: "upload", variant: "ghost", size: "sm", "aria-label": "Upload file", disabled: s, onClick: u }), e[47] = s, e[48] = u, e[49] = b, e[50] = pe) : pe = e[50];
  let oe;
  e[51] !== V || e[52] !== N ? (oe = /* @__PURE__ */ m(_n, { type: "button", variant: "primary", size: "sm", icon: "send", disabled: N, onMouseDown: $y, onClick: V, children: "Send" }), e[51] = V, e[52] = N, e[53] = oe) : oe = e[53];
  let re;
  e[54] !== ie || e[55] !== pe || e[56] !== oe ? (re = /* @__PURE__ */ F("div", { className: ie, children: [
    pe,
    oe
  ] }), e[54] = ie, e[55] = pe, e[56] = oe, e[57] = re) : re = e[57];
  let de;
  e[58] !== Z || e[59] !== te || e[60] !== J || e[61] !== re ? (de = /* @__PURE__ */ F("div", { "data-disabled": Z, className: te, children: [
    J,
    re
  ] }), e[58] = Z, e[59] = te, e[60] = J, e[61] = re, e[62] = de) : de = e[62];
  let xe;
  return e[63] !== j || e[64] !== de ? (xe = /* @__PURE__ */ F("div", { className: K, children: [
    j,
    de
  ] }), e[63] = j, e[64] = de, e[65] = xe) : xe = e[65], xe;
}
function $y(t) {
  return t.preventDefault();
}
function Hy(t) {
  return !t;
}
function zy(t) {
  const e = z.c(39), {
    disabled: n,
    suggestedUpdates: o,
    suggestedUpdatesCollapsed: r,
    onToggleSuggestedUpdates: i,
    onSelectSuggestedUpdate: s
  } = t;
  let l;
  e[0] !== o ? (l = {
    items: o,
    maxRows: 2,
    minVisibleItems: 0
  }, e[0] = o, e[1] = l) : l = e[1];
  const {
    containerRef: a,
    measuringContainerRef: c,
    reservedStartRef: u,
    reservedEndRef: d,
    itemRefs: f,
    visibleItems: p
  } = x2(l);
  let g;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = Vy(), e[2] = g) : g = e[2];
  let h;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = Ay(), e[3] = h) : h = e[3];
  let b;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = _y(), e[4] = b) : b = e[4];
  let v;
  e[5] !== u ? (v = /* @__PURE__ */ m("span", { ref: u, className: b, children: "Suggested Updates" }), e[5] = u, e[6] = v) : v = e[6];
  let C;
  e[7] !== n || e[8] !== s || e[9] !== r || e[10] !== p ? (C = !r && p.map((D) => /* @__PURE__ */ m(cu, { type: "button", disabled: n, onClick: () => s(D), children: D.label }, `${D.label}-${D.value}`)), e[7] = n, e[8] = s, e[9] = r, e[10] = p, e[11] = C) : C = e[11];
  const y = r ? "eye-watching" : "eye-slash-regular", w = r ? "Show suggested updates" : "Hide suggested updates", R = !r, S = r ? "Show" : "Hide";
  let E;
  e[12] !== n || e[13] !== i || e[14] !== S || e[15] !== y || e[16] !== w || e[17] !== R ? (E = /* @__PURE__ */ m(_n, { type: "button", variant: "ghost", size: "sm", icon: y, "aria-label": w, "aria-expanded": R, disabled: n, onClick: i, children: S }), e[12] = n, e[13] = i, e[14] = S, e[15] = y, e[16] = w, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== d || e[20] !== E ? (N = /* @__PURE__ */ m("span", { ref: d, className: "inline-flex", children: E }), e[19] = d, e[20] = E, e[21] = N) : N = e[21];
  let T;
  e[22] !== a || e[23] !== N || e[24] !== v || e[25] !== C ? (T = /* @__PURE__ */ F("div", { ref: a, className: h, children: [
    v,
    C,
    N
  ] }), e[22] = a, e[23] = N, e[24] = v, e[25] = C, e[26] = T) : T = e[26];
  let P;
  if (e[27] !== f || e[28] !== o) {
    let D;
    e[30] !== f ? (D = (O, V) => /* @__PURE__ */ m("span", { ref: (_) => {
      f.current[V] = _;
    }, className: "inline-flex w-max", children: /* @__PURE__ */ m(cu, { type: "button", disabled: !0, children: O.label }) }, `${O.label}-${O.value}`), e[30] = f, e[31] = D) : D = e[31], P = o.map(D), e[27] = f, e[28] = o, e[29] = P;
  } else
    P = e[29];
  let I;
  e[32] !== c || e[33] !== P ? (I = /* @__PURE__ */ m("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ m("div", { ref: c, className: "inline-flex w-max items-center gap-(--spacing-8)", children: P }) }), e[32] = c, e[33] = P, e[34] = I) : I = e[34];
  let k;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ m(gr, {}), e[35] = k) : k = e[35];
  let M;
  return e[36] !== T || e[37] !== I ? (M = /* @__PURE__ */ F("div", { className: g, children: [
    T,
    I,
    k
  ] }), e[36] = T, e[37] = I, e[38] = M) : M = e[38], M;
}
let Op = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const ma = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valid: null,
  valueMissing: !1
}, Ar = {
  valid: null,
  touched: !1,
  dirty: !1,
  filled: !1,
  focused: !1
}, By = {
  disabled: !1,
  ...Ar
}, to = {
  valid(t) {
    return t === null ? null : t ? {
      [Op.valid]: ""
    } : {
      [Op.invalid]: ""
    };
  }
}, Ud = /* @__PURE__ */ x.createContext({
  invalid: void 0,
  name: void 0,
  validityData: {
    state: ma,
    errors: [],
    error: "",
    value: "",
    initialValue: null
  },
  setValidityData: xt,
  disabled: void 0,
  touched: Ar.touched,
  setTouched: xt,
  dirty: Ar.dirty,
  setDirty: xt,
  filled: Ar.filled,
  setFilled: xt,
  focused: Ar.focused,
  setFocused: xt,
  validate: () => null,
  validationMode: "onSubmit",
  validationDebounceTime: 0,
  shouldValidateOnChange: () => !1,
  state: By,
  markedDirtyRef: {
    current: !1
  },
  registerFieldControl: xt,
  validation: {
    getValidationProps: (t = St) => t,
    getInputValidationProps: (t = St) => t,
    inputRef: {
      current: null
    },
    commit: async () => {
    }
  }
});
process.env.NODE_ENV !== "production" && (Ud.displayName = "FieldRootContext");
function tn(t = !0) {
  const e = x.useContext(Ud);
  if (e.setValidityData === xt && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldRootContext is missing. Field parts must be placed within <Field.Root>." : rt(28));
  return e;
}
const C2 = /* @__PURE__ */ x.createContext({
  legendId: void 0,
  setLegendId: () => {
  },
  disabled: void 0
});
process.env.NODE_ENV !== "production" && (C2.displayName = "FieldsetRootContext");
function w2(t = !1) {
  const e = x.useContext(C2);
  if (!e && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: FieldsetRootContext is missing. Fieldset parts must be placed within <Fieldset.Root>." : rt(86));
  return e;
}
const S2 = /* @__PURE__ */ x.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: xt,
  validationMode: "onSubmit",
  submitAttemptedRef: {
    current: !1
  }
});
process.env.NODE_ENV !== "production" && (S2.displayName = "FormContext");
function Vo() {
  return x.useContext(S2);
}
const Gd = /* @__PURE__ */ x.createContext({
  controlId: void 0,
  registerControlId: xt,
  labelId: void 0,
  setLabelId: xt,
  messageIds: [],
  setMessageIds: xt,
  getDescriptionProps: (t) => t
});
process.env.NODE_ENV !== "production" && (Gd.displayName = "LabelableContext");
function mn() {
  return x.useContext(Gd);
}
const R2 = function(e) {
  const n = Mt(), o = e.controlId === void 0 ? n : e.controlId, [r, i] = x.useState(o), [s, l] = x.useState(e.labelId), [a, c] = x.useState([]), u = Tt(() => /* @__PURE__ */ new Map()), {
    messageIds: d
  } = mn(), f = Se((h, b) => {
    const v = u.current;
    if (b === void 0) {
      v.delete(h);
      return;
    }
    v.set(h, b), i((C) => {
      if (v.size === 0)
        return;
      let y;
      for (const w of v.values()) {
        if (C !== void 0 && w === C)
          return C;
        y === void 0 && (y = w);
      }
      return y;
    });
  }), p = x.useCallback((h) => en({
    "aria-describedby": d.concat(a).join(" ") || void 0
  }, h), [d, a]), g = x.useMemo(() => ({
    controlId: r,
    registerControlId: f,
    labelId: s,
    setLabelId: l,
    messageIds: a,
    setMessageIds: c,
    getDescriptionProps: p
  }), [r, f, s, l, a, c, p]);
  return /* @__PURE__ */ m(Gd.Provider, {
    value: g,
    children: e.children
  });
};
process.env.NODE_ENV !== "production" && (R2.displayName = "LabelableProvider");
function Yd(t, e, n, o = !0, r) {
  const [i, s] = x.useState(), l = Mt(r ? `${r}-label` : void 0), a = t ?? e ?? i;
  return ke(() => {
    const c = t || e || !o ? void 0 : Wy(n.current, l);
    i !== c && s(c);
  }), a;
}
function Wy(t, e) {
  const n = Uy(t);
  if (n)
    return !n.id && e && (n.id = e), n.id || void 0;
}
function Uy(t) {
  if (!t)
    return;
  const e = t.parentElement;
  if (e && e.tagName === "LABEL")
    return e;
  const n = t.id;
  if (n) {
    const r = t.nextElementSibling;
    if (r && r.htmlFor === n)
      return r;
  }
  const o = t.labels;
  return o && o[0];
}
function Mr(t = {}) {
  const {
    id: e,
    implicit: n = !1,
    controlRef: o
  } = t, {
    controlId: r,
    registerControlId: i
  } = mn(), s = Mt(e), l = n ? r : void 0, a = Tt(() => /* @__PURE__ */ Symbol("labelable-control")), c = x.useRef(!1), u = x.useRef(e != null), d = Se(() => {
    !c.current || i === xt || (c.current = !1, i(a.current, void 0));
  });
  return ke(() => {
    if (i === xt)
      return;
    let f;
    if (n) {
      const p = o?.current;
      pt(p) && p.closest("label") != null ? f = e ?? null : f = l ?? s;
    } else if (e != null)
      u.current = !0, f = e;
    else if (u.current)
      f = s;
    else {
      d();
      return;
    }
    if (f === void 0) {
      d();
      return;
    }
    c.current = !0, i(a.current, f);
  }, [e, o, l, i, n, s, a, d]), x.useEffect(() => d, [d]), r ?? s;
}
function Gy(t, e) {
  const n = Mt(t);
  return ke(() => (e(n), () => {
    e(void 0);
  }), [n, e]), n;
}
function Yy(t = {}) {
  const {
    id: e,
    fallbackControlId: n,
    native: o = !1,
    setLabelId: r,
    focusControl: i
  } = t, {
    controlId: s,
    setLabelId: l
  } = mn(), a = Se((p) => {
    l(p), r?.(p);
  }), c = Gy(e, a), u = s ?? n;
  function d(p) {
    if (i) {
      i(p, u);
      return;
    }
    if (!u)
      return;
    const g = et(p.currentTarget).getElementById(u);
    Ct(g) && jy(g);
  }
  function f(p) {
    bt(p.nativeEvent)?.closest("button,input,select,textarea") || (!p.defaultPrevented && p.detail > 1 && p.preventDefault(), !o && d(p));
  }
  return o ? {
    id: c,
    htmlFor: u ?? void 0,
    onMouseDown: f
  } : {
    id: c,
    onClick: f,
    onPointerDown(p) {
      p.preventDefault();
    }
  };
}
function jy(t) {
  t.focus({
    // Available from Chrome 144+ (January 2026).
    // Safari and Firefox already support it.
    focusVisible: !0
  });
}
function zl(t, e) {
  return {
    ...t,
    state: {
      ...t.state,
      valid: !e && t.state.valid
    }
  };
}
const wl = Object.keys(ma);
function Ky(t) {
  if (!t || t.valid || !t.valueMissing)
    return !1;
  let e = !1;
  for (const n of wl)
    n !== "valid" && (n === "valueMissing" && (e = t[n]), t[n] && (e = !1));
  return e;
}
function qy(t) {
  const {
    formRef: e,
    clearErrors: n
  } = Vo(), {
    setValidityData: o,
    validate: r,
    validityData: i,
    validationDebounceTime: s,
    invalid: l,
    markedDirtyRef: a,
    state: c,
    name: u,
    shouldValidateOnChange: d
  } = t, {
    controlId: f,
    getDescriptionProps: p
  } = mn(), g = Vt(), h = x.useRef(null), b = Se(async (y, w = !1) => {
    const R = h.current;
    if (!R)
      return;
    if (w) {
      if (c.valid !== !1)
        return;
      const M = R.validity;
      if (!M.valueMissing) {
        const O = {
          value: y,
          state: {
            ...ma,
            valid: !0
          },
          error: "",
          errors: [],
          initialValue: i.initialValue
        };
        if (R.setCustomValidity(""), f) {
          const V = e.current.fields.get(f);
          V && e.current.fields.set(f, {
            ...V,
            ...zl(O, !1)
            // invalid = false
          });
        }
        o(O);
        return;
      }
      const D = wl.reduce((O, V) => (O[V] = M[V], O), {});
      if (!D.valid && !Ky(D))
        return;
    }
    function S(M) {
      const D = wl.reduce((V, _) => (V[_] = M.validity[_], V), {});
      let O = !1;
      for (const V of wl)
        if (V !== "valid") {
          if (V === "valueMissing" && D[V])
            O = !0;
          else if (D[V])
            return D;
        }
      return O && !a.current && (D.valid = !0, D.valueMissing = !1), D;
    }
    g.clear();
    let E = null, N = [];
    const T = S(R);
    let P;
    const I = d();
    if (R.validationMessage && !I)
      P = R.validationMessage, N = [R.validationMessage];
    else {
      const M = Array.from(e.current.fields.values()).reduce((O, V) => (V.name && (O[V.name] = V.getValue()), O), {}), D = r(y, M);
      typeof D == "object" && D !== null && "then" in D ? E = await D : E = D, E !== null ? (T.valid = !1, T.customError = !0, Array.isArray(E) ? (N = E, R.setCustomValidity(E.join(`
`))) : E && (N = [E], R.setCustomValidity(E))) : I && (R.setCustomValidity(""), T.customError = !1, R.validationMessage ? (P = R.validationMessage, N = [R.validationMessage]) : R.validity.valid && !T.valid && (T.valid = !0));
    }
    const k = {
      value: y,
      state: T,
      error: P ?? (Array.isArray(E) ? E[0] : E ?? ""),
      errors: N,
      initialValue: i.initialValue
    };
    if (f) {
      const M = e.current.fields.get(f);
      M && e.current.fields.set(f, {
        ...M,
        // Keep Form-level errors part of overall field validity for submit blocking/focus logic.
        ...zl(k, l)
      });
    }
    o(k);
  }), v = x.useCallback((y = {}) => en(p, c.valid === !1 ? {
    "aria-invalid": !0
  } : St, y), [p, c.valid]), C = x.useCallback((y = {}) => en({
    onChange(w) {
      if (w.nativeEvent.defaultPrevented)
        return;
      if (n(u), !d()) {
        b(w.currentTarget.value, !0);
        return;
      }
      const R = w.currentTarget;
      if (R.value === "") {
        b(R.value);
        return;
      }
      g.clear(), s ? g.start(s, () => {
        b(R.value);
      }) : b(R.value);
    }
  }, v(y)), [v, n, u, g, b, s, d]);
  return x.useMemo(() => ({
    getValidationProps: v,
    getInputValidationProps: C,
    inputRef: h,
    commit: b
  }), [v, C, b]);
}
function Zy(t) {
  const {
    commit: e,
    invalid: n,
    markedDirtyRef: o,
    name: r,
    setValidityData: i,
    validityData: s
  } = t, {
    formRef: l
  } = Vo(), a = x.useRef(null), c = x.useRef(null), u = x.useRef(null), d = Se(() => {
    const b = c.current;
    if (b)
      return b.getValue ? b.getValue() : b.value;
  }), f = Se((b = !0) => {
    const v = c.current;
    if (!v)
      return;
    let C = v.value;
    C === void 0 && (C = d()), o.current = !0, b ? an.flushSync(() => e(C)) : e(C);
  });
  function p() {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: zl(s, n),
      validate: f
    });
  }
  function g(b = c.current?.id) {
    b && l.current.fields.delete(b);
  }
  function h() {
    const b = c.current;
    if (!b)
      return;
    let v = b.value;
    v === void 0 && (v = d()), s.initialValue === null && v !== null && i((C) => ({
      ...C,
      initialValue: v
    }));
  }
  return ke(() => {
    const b = c.current;
    !b || !b.id || l.current.fields.set(b.id, {
      getValue: d,
      name: r,
      controlRef: b.controlRef ?? u,
      validityData: zl(s, n),
      validate: f
    });
  }, [l, d, n, r, f, s]), ke(() => {
    const b = l.current.fields;
    return () => {
      const v = c.current?.id;
      v && b.delete(v);
    };
  }, [l]), Se((b, v) => {
    if (!v) {
      a.current === b && (a.current = null, g(), c.current = null);
      return;
    }
    const C = c.current?.id;
    a.current = b, c.current = v, C && C !== v.id && g(C), h(), p();
  });
}
const E2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    errors: o,
    validationMode: r,
    submitAttemptedRef: i
  } = Vo(), {
    render: s,
    className: l,
    validate: a,
    validationDebounceTime: c = 0,
    validationMode: u = r,
    name: d,
    disabled: f = !1,
    invalid: p,
    dirty: g,
    touched: h,
    actionsRef: b,
    style: v,
    ...C
  } = e, {
    disabled: y
  } = w2(), w = Se(a || (() => null)), R = y || f, [S, E] = x.useState(!1), [N, T] = x.useState(!1), [P, I] = x.useState(!1), [k, M] = x.useState(!1), D = g ?? N, O = h ?? S, V = x.useRef(!1), _ = Se((le) => {
    g === void 0 && (le && (V.current = !0), T(le));
  }), A = Se((le) => {
    h === void 0 && E(le);
  }), L = Se(() => u === "onChange" || u === "onSubmit" && i.current), B = !!d && Object.hasOwn(o, d) && o[d] !== void 0, G = p === !0 || B, [U, Y] = x.useState({
    state: ma,
    error: "",
    errors: [],
    value: null,
    initialValue: null
  }), K = !G && U.state.valid, j = x.useMemo(() => ({
    disabled: R,
    touched: O,
    dirty: D,
    valid: K,
    filled: P,
    focused: k
  }), [R, O, D, K, P, k]), Z = qy({
    setValidityData: Y,
    validate: w,
    validityData: U,
    validationDebounceTime: c,
    invalid: G,
    markedDirtyRef: V,
    state: j,
    name: d,
    shouldValidateOnChange: L
  }), te = x.useCallback(() => {
    V.current = !0, Z.commit(U.value);
  }, [Z, U]), W = Zy({
    commit: Z.commit,
    invalid: G,
    markedDirtyRef: V,
    name: d,
    setValidityData: Y,
    validityData: U
  });
  x.useImperativeHandle(b, () => ({
    validate: te
  }), [te]);
  const X = x.useMemo(() => ({
    invalid: G,
    name: d,
    validityData: U,
    setValidityData: Y,
    disabled: R,
    touched: O,
    setTouched: A,
    dirty: D,
    setDirty: _,
    filled: P,
    setFilled: I,
    focused: k,
    setFocused: M,
    validate: w,
    validationMode: u,
    validationDebounceTime: c,
    shouldValidateOnChange: L,
    state: j,
    markedDirtyRef: V,
    registerFieldControl: W,
    validation: Z
  }), [G, d, U, R, O, A, D, _, P, I, k, M, w, u, c, L, j, W, Z]), ee = $e("div", e, {
    ref: n,
    state: j,
    props: C,
    stateAttributesMapping: to
  });
  return /* @__PURE__ */ m(Ud.Provider, {
    value: X,
    children: ee
  });
});
process.env.NODE_ENV !== "production" && (E2.displayName = "FieldRootInner");
const Ir = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ m(R2, {
    children: /* @__PURE__ */ m(E2, {
      ...e,
      ref: n
    })
  });
});
process.env.NODE_ENV !== "production" && (Ir.displayName = "FieldRoot");
const N2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    nativeLabel: l = !0,
    ...a
  } = e, c = tn(!1), {
    labelId: u
  } = mn(), d = x.useRef(null), f = Yy({
    id: u ?? s,
    native: l
  });
  return process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (!d.current)
      return;
    const g = d.current.tagName === "LABEL";
    if (l) {
      if (!g) {
        const h = pr.captureOwnerStack?.() || "";
        jo(`<Field.Label> expected a <label> element because the \`nativeLabel\` prop is true. Rendering a non-<label> disables native label association, so \`htmlFor\` will not work. Use a real <label> in the \`render\` prop, or set \`nativeLabel\` to \`false\`.${h}`);
      }
    } else if (g) {
      const h = pr.captureOwnerStack?.() || "";
      jo(`<Field.Label> expected a non-<label> element because the \`nativeLabel\` prop is false. Rendering a <label> assumes native label behavior while Base UI treats it as non-native, which can cause unexpected pointer behavior. Use a non-<label> in the \`render\` prop, or set \`nativeLabel\` to \`true\`.${h}`);
    }
  }, [l]), $e("label", e, {
    ref: [n, d],
    state: c.state,
    props: [f, a],
    stateAttributesMapping: to
  });
});
process.env.NODE_ENV !== "production" && (N2.displayName = "FieldLabel");
const Xy = {
  ...to,
  ...Bt
}, Pr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    match: s,
    style: l,
    ...a
  } = e, c = Mt(r), {
    validityData: u,
    state: d,
    name: f
  } = tn(!1), {
    setMessageIds: p
  } = mn(), {
    errors: g
  } = Vo(), h = f ? g[f] : null, b = typeof s == "string";
  let v = !1;
  s === !0 ? v = !0 : b ? v = !!u.state[s] : v = !!h || u.state.valid === !1;
  const {
    mounted: C,
    transitionStatus: y,
    setMounted: w
  } = Xn(v);
  ke(() => {
    if (!(!v || !c))
      return p((O) => O.concat(c)), () => {
        p((O) => O.filter((V) => V !== c));
      };
  }, [v, c, p]);
  const R = x.useRef(null), [S, E] = x.useState(null), [N, T] = x.useState(null), P = u.errors.length > 1 ? /* @__PURE__ */ m("ul", {
    children: u.errors.map((O) => /* @__PURE__ */ m("li", {
      children: O
    }, O))
  }) : u.error, I = b ? P : h || P;
  let k = u.error;
  h != null ? k = Array.isArray(h) ? JSON.stringify(h) : h : u.errors.length > 1 && (k = JSON.stringify(u.errors)), v && k !== N && (T(k), E(I)), jt({
    open: v,
    ref: R,
    onComplete() {
      v || w(!1);
    }
  });
  const M = {
    ...d,
    transitionStatus: y
  }, D = $e("div", e, {
    ref: [n, R],
    state: M,
    props: [{
      id: c,
      children: v ? I : S
    }, a],
    stateAttributesMapping: Xy,
    enabled: C
  });
  return C ? D : null;
});
process.env.NODE_ENV !== "production" && (Pr.displayName = "FieldError");
const fi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    id: r,
    className: i,
    style: s,
    ...l
  } = e, a = Mt(r), c = tn(!1), {
    setMessageIds: u
  } = mn();
  return ke(() => {
    if (a)
      return u((f) => f.concat(a)), () => {
        u((f) => f.filter((p) => p !== a));
      };
  }, [a, u]), $e("p", e, {
    ref: n,
    state: c.state,
    props: [{
      id: a
    }, l],
    stateAttributesMapping: to
  });
});
process.env.NODE_ENV !== "production" && (fi.displayName = "FieldDescription");
function pi(t, e) {
  const {
    enabled: n = !0,
    getValue: o,
    id: r,
    value: i
  } = e, {
    registerFieldControl: s
  } = tn(), l = x.useRef(null);
  l.current || (l.current = /* @__PURE__ */ Symbol()), ke(() => {
    const a = l.current;
    if (!(!a || !n))
      return s(a, {
        controlRef: t,
        getValue: o,
        id: r,
        value: i
      }), () => {
        s(a, void 0);
      };
  }, [t, n, o, r, s, i]);
}
const jd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    name: s,
    value: l,
    disabled: a = !1,
    onValueChange: c,
    defaultValue: u,
    autoFocus: d = !1,
    style: f,
    ...p
  } = e, {
    state: g,
    name: h,
    disabled: b,
    setTouched: v,
    setDirty: C,
    validityData: y,
    setFocused: w,
    setFilled: R,
    validationMode: S,
    validation: E
  } = tn(), N = b || a, T = h ?? s, P = {
    ...g,
    disabled: N
  }, {
    labelId: I
  } = mn(), k = Mr({
    id: i
  });
  ke(() => {
    const L = l != null;
    E.inputRef.current?.value || L && l !== "" ? R(!0) : L && l === "" && R(!1);
  }, [E.inputRef, R, l]);
  const M = x.useRef(null);
  ke(() => {
    d && M.current === Gt(et(M.current)) && w(!0);
  }, [d, w]);
  const [D] = dn({
    controlled: l,
    default: u,
    name: "FieldControl",
    state: "value"
  }), O = l !== void 0, V = O ? D : void 0, _ = Se(() => E.inputRef.current?.value);
  return pi(E.inputRef, {
    id: k,
    value: V,
    getValue: _
  }), $e("input", e, {
    ref: [n, M],
    state: P,
    props: [{
      id: k,
      disabled: N,
      name: T,
      ref: E.inputRef,
      "aria-labelledby": I,
      autoFocus: d,
      ...O ? {
        value: V
      } : {
        defaultValue: u
      },
      onChange(L) {
        const B = L.currentTarget.value;
        c?.(B, Ve(Pt, L.nativeEvent)), C(B !== y.initialValue), R(B !== "");
      },
      onFocus() {
        w(!0);
      },
      onBlur(L) {
        v(!0), w(!1), S === "onBlur" && E.commit(L.currentTarget.value);
      },
      onKeyDown(L) {
        L.currentTarget.tagName === "INPUT" && L.key === "Enter" && (v(!0), E.commit(L.currentTarget.value));
      }
    }, E.getInputValidationProps(), p],
    stateAttributesMapping: to
  });
});
process.env.NODE_ENV !== "production" && (jd.displayName = "FieldControl");
const k2 = /* @__PURE__ */ x.createContext({
  disabled: !1
});
process.env.NODE_ENV !== "production" && (k2.displayName = "FieldItemContext");
function M2() {
  return x.useContext(k2);
}
const I2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (I2.displayName = "CheckboxGroupContext");
function Qy(t = !0) {
  const e = x.useContext(I2);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CheckboxGroupContext is missing. CheckboxGroup parts must be placed within <CheckboxGroup>." : rt(3));
  return e;
}
function Jy(t) {
  const e = z.c(46);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: o,
    description: n,
    icon: i,
    size: s,
    side: l,
    align: a,
    disabled: c,
    showArrow: u,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = i === void 0 ? "circle-info" : i, f = s === void 0 ? "sm" : s, p = l === void 0 ? "top" : l, g = a === void 0 ? "center" : a, h = c === void 0 ? !1 : c, b = u === void 0 ? !0 : u, v = qt(), C = h ? -1 : 0, y = h && "opacity-40 pointer-events-none";
  let w;
  e[10] !== y ? (w = ne("inline-flex items-center justify-center", "cursor-default transition-colors duration-200", "rounded-(--radius-sm)", "text-icon-main", "hover:text-primary", "focus-visible:text-primary", "focus-visible:outline-none focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", y), e[10] = y, e[11] = w) : w = e[11];
  let R;
  e[12] !== d || e[13] !== f ? (R = /* @__PURE__ */ m(Ke, { name: d, size: f, tone: "inherit" }), e[12] = d, e[13] = f, e[14] = R) : R = e[14];
  let S;
  e[15] !== o || e[16] !== r || e[17] !== R || e[18] !== C || e[19] !== w ? (S = /* @__PURE__ */ m(Ad, { render: /* @__PURE__ */ m("span", { role: "img", tabIndex: C, "aria-label": o, ...r, className: w, children: R }) }), e[15] = o, e[16] = r, e[17] = R, e[18] = C, e[19] = w, e[20] = S) : S = e[20];
  const E = b ? p2 : f2;
  let N;
  e[21] !== b ? (N = b && /* @__PURE__ */ m(Bd, { "data-slot": "tooltip-arrow", className: b2 }), e[21] = b, e[22] = N) : N = e[22];
  const T = n ? "font-(number:--font-weight-semibold)" : "font-(number:--font-weight-regular)";
  let P;
  e[23] !== T ? (P = ne(m2, T), e[23] = T, e[24] = P) : P = e[24];
  let I;
  e[25] !== o || e[26] !== P ? (I = /* @__PURE__ */ m("p", { className: P, children: o }), e[25] = o, e[26] = P, e[27] = I) : I = e[27];
  let k;
  e[28] !== n ? (k = n && /* @__PURE__ */ m("p", { className: h2, children: n }), e[28] = n, e[29] = k) : k = e[29];
  let M;
  e[30] !== N || e[31] !== I || e[32] !== k ? (M = /* @__PURE__ */ F(zd, { className: g2, children: [
    N,
    I,
    k
  ] }), e[30] = N, e[31] = I, e[32] = k, e[33] = M) : M = e[33];
  let D;
  e[34] !== g || e[35] !== p || e[36] !== E || e[37] !== M ? (D = /* @__PURE__ */ m(Hd, { side: p, align: g, sideOffset: E, className: d2, children: M }), e[34] = g, e[35] = p, e[36] = E, e[37] = M, e[38] = D) : D = e[38];
  let O;
  e[39] !== v || e[40] !== D ? (O = /* @__PURE__ */ m(Fd, { container: v, children: D }), e[39] = v, e[40] = D, e[41] = O) : O = e[41];
  let V;
  return e[42] !== h || e[43] !== S || e[44] !== O ? (V = /* @__PURE__ */ F(Vd, { disabled: h, children: [
    S,
    O
  ] }), e[42] = h, e[43] = S, e[44] = O, e[45] = V) : V = e[45], V;
}
function gi(t) {
  const e = z.c(11), {
    htmlFor: n,
    label: o,
    required: r,
    tooltip: i
  } = t;
  let s;
  e[0] !== r ? (s = r && /* @__PURE__ */ m("span", { "aria-hidden": "true", className: "text-input-required", children: "*" }), e[0] = r, e[1] = s) : s = e[1];
  let l;
  e[2] !== n || e[3] !== o || e[4] !== s ? (l = /* @__PURE__ */ F(N2, { htmlFor: n, className: "flex items-center gap-(--spacing-2) text-(length:--font-size-body-medium) leading-(--font-line-height-20) font-(number:--font-weight-semibold) text-input-text-default", children: [
    o,
    s
  ] }), e[2] = n, e[3] = o, e[4] = s, e[5] = l) : l = e[5];
  let a;
  e[6] !== i ? (a = i && /* @__PURE__ */ m(Jy, { label: i, size: "xs" }), e[6] = i, e[7] = a) : a = e[7];
  let c;
  return e[8] !== l || e[9] !== a ? (c = /* @__PURE__ */ F("div", { className: "flex items-center justify-between mb-(--spacing-4)", children: [
    l,
    a
  ] }), e[8] = l, e[9] = a, e[10] = c) : c = e[10], c;
}
const ex = ce(["relative", "flex", "w-full", "min-h-[132px]", "overflow-hidden", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "p-(--spacing-16)", "transition-colors", "duration-200", "ease-in-out", "[&:has([readonly])]:bg-input-readonly-background", "[&:not([data-disabled=true]):not(:focus-within):not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not([data-disabled=true]):focus-within:not(:has([readonly]))]:border-input-active-outline"], {
  variants: {
    hasError: {
      true: ["border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    hasError: !1
  }
}), tx = ce(["flex-1", "min-w-0", "w-full", "min-h-[98px]", "border-0", "outline-none", "bg-transparent", "resize-y", "overflow-auto", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-default", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "read-only:cursor-default", "read-only:resize-none"]);
function Dp(t) {
  return typeof t == "string" || typeof t == "number" ? String(t) : Array.isArray(t) ? t.join(",") : "";
}
function CO(t) {
  const e = z.c(86);
  let n, o, r, i, s, l, a, c, u, d, f, p, g, h, b, v, C, y, w;
  e[0] !== t ? ({
    id: a,
    label: c,
    error: l,
    tooltip: y,
    required: v,
    disabled: s,
    readOnly: b,
    maxLength: u,
    value: w,
    defaultValue: i,
    placeholder: g,
    tabIndex: C,
    onChange: d,
    onKeyDown: f,
    onMouseDown: p,
    "aria-describedby": n,
    "aria-label": o,
    "aria-labelledby": r,
    ...h
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = g, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y, e[19] = w) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], g = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18], w = e[19]);
  const R = _t(), S = a ?? R;
  let E;
  e[20] !== i ? (E = () => Dp(i), e[20] = i, e[21] = E) : E = e[21];
  const [N, T] = ot(E), P = w !== void 0, I = !!l, k = u !== void 0 && !I, M = !b || I || k, D = `${S}-footer`;
  let O;
  e[22] !== n || e[23] !== D || e[24] !== I || e[25] !== k ? (O = [n, I || k ? D : void 0].filter(Boolean).join(" ") || void 0, e[22] = n, e[23] = D, e[24] = I, e[25] = k, e[26] = O) : O = e[26];
  const V = O, _ = c || r ? o : o ?? "Text area";
  let A;
  e[27] !== N || e[28] !== P || e[29] !== w ? (A = P ? Dp(w) : N, e[27] = N, e[28] = P, e[29] = w, e[30] = A) : A = e[30];
  const L = A;
  let B;
  e[31] !== P || e[32] !== d ? (B = function(se) {
    P || T(se.currentTarget.value), d?.(se);
  }, e[31] = P, e[32] = d, e[33] = B) : B = e[33];
  const G = B;
  let U;
  e[34] !== f ? (U = function(se) {
    f?.(se), !se.defaultPrevented && se.key === "Escape" && se.currentTarget.blur();
  }, e[34] = f, e[35] = U) : U = e[35];
  const Y = U;
  let K;
  e[36] !== c || e[37] !== v || e[38] !== S || e[39] !== y ? (K = c && /* @__PURE__ */ m(gi, { htmlFor: S, label: c, required: v, tooltip: y }), e[36] = c, e[37] = v, e[38] = S, e[39] = y, e[40] = K) : K = e[40];
  const j = s || void 0;
  let Z;
  e[41] !== s || e[42] !== I ? (Z = ne(ex({
    hasError: I
  }), !I && "[&:has([readonly])]:border-input-readonly-outline", s && "opacity-50 cursor-not-allowed"), e[41] = s, e[42] = I, e[43] = Z) : Z = e[43];
  const te = b ? void 0 : g, W = b ? -1 : C;
  let X;
  e[44] !== p || e[45] !== b ? (X = (xe) => {
    p?.(xe), b && !xe.defaultPrevented && xe.preventDefault();
  }, e[44] = p, e[45] = b, e[46] = X) : X = e[46];
  const ee = v || void 0, le = I || void 0, J = b || void 0;
  let ie;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = tx(), e[47] = ie) : ie = e[47];
  let pe;
  e[48] !== _ || e[49] !== r || e[50] !== i || e[51] !== V || e[52] !== s || e[53] !== G || e[54] !== Y || e[55] !== u || e[56] !== h || e[57] !== b || e[58] !== v || e[59] !== W || e[60] !== X || e[61] !== ee || e[62] !== le || e[63] !== J || e[64] !== te || e[65] !== S || e[66] !== w ? (pe = /* @__PURE__ */ m(jd, { render: /* @__PURE__ */ m("textarea", { ...h, id: S, value: w, defaultValue: i, placeholder: te, required: v, disabled: s, readOnly: b, maxLength: u, tabIndex: W, onChange: G, onKeyDown: Y, onMouseDown: X, "aria-label": _, "aria-labelledby": r, "aria-required": ee, "aria-invalid": le, "aria-readonly": J, "aria-describedby": V, className: ie }) }), e[48] = _, e[49] = r, e[50] = i, e[51] = V, e[52] = s, e[53] = G, e[54] = Y, e[55] = u, e[56] = h, e[57] = b, e[58] = v, e[59] = W, e[60] = X, e[61] = ee, e[62] = le, e[63] = J, e[64] = te, e[65] = S, e[66] = w, e[67] = pe) : pe = e[67];
  let oe;
  e[68] !== pe || e[69] !== j || e[70] !== Z ? (oe = /* @__PURE__ */ m("div", { "data-disabled": j, className: Z, children: pe }), e[68] = pe, e[69] = j, e[70] = Z, e[71] = oe) : oe = e[71];
  let re;
  e[72] !== l || e[73] !== D || e[74] !== I || e[75] !== u || e[76] !== k || e[77] !== M || e[78] !== L ? (re = M && /* @__PURE__ */ F("div", { "data-testid": "textarea-footer", className: "flex justify-between items-center min-h-(--spacing-20) mt-(--spacing-4) gap-(--spacing-8)", children: [
    /* @__PURE__ */ m("div", { className: "flex-1 min-w-0", children: I && /* @__PURE__ */ m(Pr, { id: D, match: !0, className: "truncate text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-error-text", children: l }) }),
    k && /* @__PURE__ */ F("span", { id: D, "aria-live": "polite", className: "shrink-0 text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting whitespace-nowrap", children: [
      L.length,
      "/",
      u
    ] })
  ] }), e[72] = l, e[73] = D, e[74] = I, e[75] = u, e[76] = k, e[77] = M, e[78] = L, e[79] = re) : re = e[79];
  let de;
  return e[80] !== s || e[81] !== I || e[82] !== oe || e[83] !== re || e[84] !== K ? (de = /* @__PURE__ */ F(Ir, { invalid: I, disabled: s, className: "flex flex-col w-full", children: [
    K,
    oe,
    re
  ] }), e[80] = s, e[81] = I, e[82] = oe, e[83] = re, e[84] = K, e[85] = de) : de = e[85], de;
}
function nx({
  onSendMessage: t,
  value: e,
  onChange: n,
  disabled: o,
  autoFocus: r,
  alert: i,
  placeholder: s = "Ask anything...",
  initialValue: l = ""
}) {
  const [a, c] = ot(l), u = e !== void 0, d = e ?? a, f = ft(0), p = ft(d), g = ft(/* @__PURE__ */ new Map());
  p.current = d, kt(() => () => {
    g.current.forEach(({
      controller: w
    }) => {
      w.abort();
    }), g.current.clear();
  }, []);
  function h(w) {
    u || c(w), n?.(w);
  }
  function b(w) {
    const R = w.target.value;
    f.current += 1, h(R);
  }
  function v(w, R) {
    g.current.get(w) === R && g.current.delete(w);
  }
  async function C(w, R, S) {
    try {
      await t(w, S.controller.signal), g.current.get(w) === S && f.current === R && p.current.trim() === w && h("");
    } catch {
    } finally {
      v(w, S);
    }
  }
  function y() {
    const w = d.trim();
    if (!w) {
      h("");
      return;
    }
    if (g.current.has(w)) return;
    const R = {
      controller: new AbortController()
    };
    g.current.set(w, R);
    const S = f.current;
    C(w, S, R);
  }
  return /* @__PURE__ */ m(Fy, { value: d, onChange: b, onSend: y, clearOnSend: !1, disabled: o, autoFocus: r, alert: i, placeholder: s, showUpload: !1 });
}
const P2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  return /* @__PURE__ */ m(jd, {
    ref: n,
    ...e
  });
});
process.env.NODE_ENV !== "production" && (P2.displayName = "Input");
const ox = ce(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "[&:has([readonly])]:bg-input-readonly-background", "[&:has([readonly])]:cursor-default", "[&:not(:has([readonly])):not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:has([readonly])):not(:focus-within)]:hover:border-input-hover-outline", "[&:not(:has([readonly]))]:active:border-input-pressed-outline", "[&:not(:has([readonly]))]:focus-within:border-input-active-outline", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    size: {
      xs: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Vp = ce(["font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-input-text-default"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"],
      md: ["text-(length:--font-size-body-medium)", "leading-(--font-line-height-24)"]
    },
    italic: {
      true: "italic",
      false: "not-italic"
    }
  },
  defaultVariants: {
    size: "md",
    italic: !1
  }
});
function rx(t) {
  const e = z.c(69);
  let n, o, r, i, s, l, a, c, u, d, f, p, g, h, b, v, C, y;
  e[0] !== t ? ({
    size: f,
    italic: p,
    label: i,
    leadingIcon: s,
    trailingIcon: C,
    trailingAction: v,
    unit: y,
    description: n,
    error: r,
    tooltip: b,
    reserveSubtextSpace: g,
    required: d,
    disabled: o,
    readOnly: u,
    placeholder: a,
    tabIndex: h,
    onMouseDown: l,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p, e[13] = g, e[14] = h, e[15] = b, e[16] = v, e[17] = C, e[18] = y) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12], g = e[13], h = e[14], b = e[15], v = e[16], C = e[17], y = e[18]);
  const w = f === void 0 ? "md" : f, R = p === void 0 ? !1 : p, S = g === void 0 ? !0 : g, E = !!r, N = s || v || y ? void 0 : C;
  let T;
  e[19] !== i || e[20] !== d || e[21] !== b ? (T = i && /* @__PURE__ */ m(gi, { label: i, required: d, tooltip: b }), e[19] = i, e[20] = d, e[21] = b, e[22] = T) : T = e[22];
  let P;
  e[23] !== o || e[24] !== E || e[25] !== w ? (P = ne(ox({
    size: w
  }), !E && "[&:has([readonly])]:border-input-readonly-outline", o && "opacity-50", E && ["border-input-error-outline", "[&:not(:has([readonly])):not(:focus-within)]:hover:border-input-error-outline"]), e[23] = o, e[24] = E, e[25] = w, e[26] = P) : P = e[26];
  let I;
  e[27] !== s ? (I = s && /* @__PURE__ */ m(Ke, { name: s, size: "sm", tone: "inherit" }), e[27] = s, e[28] = I) : I = e[28];
  const k = u ? -1 : h, M = u ? void 0 : a, D = u || void 0;
  let O;
  e[29] !== l || e[30] !== u ? (O = (Y) => {
    l?.(Y), u && !Y.defaultPrevented && Y.preventDefault();
  }, e[29] = l, e[30] = u, e[31] = O) : O = e[31];
  const V = d || void 0;
  let _;
  e[32] !== E || e[33] !== R || e[34] !== w ? (_ = ne("flex-1", "min-w-0", "outline-none", Vp({
    size: w,
    italic: R
  }), "placeholder:text-text-subtle", E && "text-input-error-text"), e[32] = E, e[33] = R, e[34] = w, e[35] = _) : _ = e[35];
  let A;
  e[36] !== c || e[37] !== u || e[38] !== d || e[39] !== O || e[40] !== V || e[41] !== _ || e[42] !== k || e[43] !== M || e[44] !== D ? (A = /* @__PURE__ */ m(P2, { ...c, required: d, readOnly: u, tabIndex: k, placeholder: M, "aria-readonly": D, onMouseDown: O, "aria-required": V, className: _ }), e[36] = c, e[37] = u, e[38] = d, e[39] = O, e[40] = V, e[41] = _, e[42] = k, e[43] = M, e[44] = D, e[45] = A) : A = e[45];
  let L;
  e[46] !== o || e[47] !== u || e[48] !== N || e[49] !== w || e[50] !== v || e[51] !== y ? (L = !u && v ? /* @__PURE__ */ m(mt, { ...v, disabled: o || v.disabled, size: "sm", type: "button", variant: "ghost" }) : y ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) shrink-0", children: [
    /* @__PURE__ */ m("span", { "aria-hidden": "true", className: "text-input-default-outline select-none", children: "|" }),
    /* @__PURE__ */ m("span", { className: ne(Vp({
      size: w,
      italic: !1
    }), "text-input-text-supporting whitespace-nowrap"), children: y })
  ] }) : !u && N ? /* @__PURE__ */ m(Ke, { name: N, size: "sm", tone: "inherit" }) : null, e[46] = o, e[47] = u, e[48] = N, e[49] = w, e[50] = v, e[51] = y, e[52] = L) : L = e[52];
  let B;
  e[53] !== A || e[54] !== L || e[55] !== P || e[56] !== I ? (B = /* @__PURE__ */ F("div", { className: P, children: [
    I,
    A,
    L
  ] }), e[53] = A, e[54] = L, e[55] = P, e[56] = I, e[57] = B) : B = e[57];
  let G;
  e[58] !== n || e[59] !== r || e[60] !== E || e[61] !== S ? (G = (S || E || n) && /* @__PURE__ */ m("div", { "data-testid": "input-subtext-row", className: ne("mt-(--spacing-4)", S && "min-h-(--spacing-20)"), children: E ? /* @__PURE__ */ m(Pr, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: r }) : n ? /* @__PURE__ */ m(fi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: n }) : null }), e[58] = n, e[59] = r, e[60] = E, e[61] = S, e[62] = G) : G = e[62];
  let U;
  return e[63] !== o || e[64] !== E || e[65] !== B || e[66] !== G || e[67] !== T ? (U = /* @__PURE__ */ F(Ir, { invalid: E, disabled: o, className: "flex flex-col w-full", children: [
    T,
    B,
    G
  ] }), e[63] = o, e[64] = E, e[65] = B, e[66] = G, e[67] = T, e[68] = U) : U = e[68], U;
}
const T2 = ce(["flex", "flex-col", "items-start", "min-w-0", "gap-(--spacing-10)", "rounded-(--radius-sm)", "px-(--spacing-8)", "py-(--spacing-10)", "w-full"]), ix = ["Wrong answer", "Slow response", "Incomplete", "Other"];
function O2(t, e) {
  const n = z.c(30), {
    rating: o,
    onSubmit: r,
    onRateResponse: i,
    defaultValue: s,
    submittedDuration: l,
    defaultSubmitted: a
  } = t, c = l === void 0 ? 4e3 : l, u = a === void 0 ? !1 : a, [d, f] = ot(o), [p, g] = ot(s), [h, b] = ot(""), [v, C] = ot(!1), [y, w] = ot(u ? "submitted" : "idle"), R = ft(c), S = ft(e);
  let E, N;
  n[0] !== u || n[1] !== s || n[2] !== o || n[3] !== e || n[4] !== c ? (E = () => {
    S.current !== e && (S.current = e, f(o), g(s), b(""), C(!1), w(u ? "submitted" : "idle"), R.current = c);
  }, N = [u, s, o, e, c], n[0] = u, n[1] = s, n[2] = o, n[3] = e, n[4] = c, n[5] = E, n[6] = N) : (E = n[5], N = n[6]), kt(E, N);
  let T, P;
  n[7] !== y ? (T = () => {
    if (y !== "submitted")
      return;
    const A = window.setTimeout(() => {
      w("dismissed");
    }, R.current);
    return () => window.clearTimeout(A);
  }, P = [y], n[7] = y, n[8] = T, n[9] = P) : (T = n[8], P = n[9]), kt(T, P);
  let I;
  n[10] !== i || n[11] !== r || n[12] !== y || n[13] !== c ? (I = function(L) {
    if (!(y !== "idle" || i === void 0 && r === void 0)) {
      if (f(L), i?.(L), L === -1 && r) {
        C(!0);
        return;
      }
      L === 1 && i === void 0 && r?.(L), R.current = c, w("submitted");
    }
  }, n[10] = i, n[11] = r, n[12] = y, n[13] = c, n[14] = I) : I = n[14];
  const k = I;
  let M;
  n[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (M = function(L) {
    L !== "Other" && b(""), g(L);
  }, n[15] = M) : M = n[15];
  const D = M;
  let O;
  n[16] !== h || n[17] !== r || n[18] !== p || n[19] !== d || n[20] !== c ? (O = function() {
    !r || p === void 0 || (R.current = c, r(d, p === "Other" && h.trim() || p), w("submitted"));
  }, n[16] = h, n[17] = r, n[18] = p, n[19] = d, n[20] = c, n[21] = O) : O = n[21];
  const V = O;
  let _;
  return n[22] !== h || n[23] !== v || n[24] !== p || n[25] !== k || n[26] !== d || n[27] !== y || n[28] !== V ? (_ = {
    selectedRating: d,
    reason: p,
    feedbackText: h,
    isReasonsOpen: v,
    status: y,
    selectRating: k,
    selectReason: D,
    setFeedbackText: b,
    submitFeedback: V
  }, n[22] = h, n[23] = v, n[24] = p, n[25] = k, n[26] = d, n[27] = y, n[28] = V, n[29] = _) : _ = n[29], _;
}
function D2(t) {
  const e = z.c(16), {
    feedbackState: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m("legend", { className: "sr-only", children: "Response feedback" }), e[0] = o) : o = e[0];
  const r = n.selectedRating === 1, i = n.status !== "idle";
  let s;
  e[1] !== n ? (s = () => n.selectRating(1), e[1] = n, e[2] = s) : s = e[2];
  let l;
  e[3] !== r || e[4] !== i || e[5] !== s ? (l = /* @__PURE__ */ m(mt, { icon: "thumbs-up", variant: "ghost", size: "sm", "aria-label": "Helpful response", "aria-pressed": r, disabled: i, onClick: s }), e[3] = r, e[4] = i, e[5] = s, e[6] = l) : l = e[6];
  const a = n.selectedRating === -1, c = n.status !== "idle";
  let u;
  e[7] !== n ? (u = () => n.selectRating(-1), e[7] = n, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== c || e[11] !== u ? (d = /* @__PURE__ */ m(mt, { icon: "thumbs-down", variant: "ghost", size: "sm", "aria-label": "Unhelpful response", "aria-pressed": a, disabled: c, onClick: u }), e[9] = a, e[10] = c, e[11] = u, e[12] = d) : d = e[12];
  let f;
  return e[13] !== l || e[14] !== d ? (f = /* @__PURE__ */ F("fieldset", { className: "m-0 flex items-center gap-(--spacing-4) border-0 p-0", children: [
    o,
    l,
    d
  ] }), e[13] = l, e[14] = d, e[15] = f) : f = e[15], f;
}
function sx(t) {
  const e = z.c(4), {
    children: n,
    selected: o,
    onClick: r
  } = t;
  let i;
  return e[0] !== n || e[1] !== r || e[2] !== o ? (i = /* @__PURE__ */ m("span", { "data-slot": "assistant-chat-feedback-reason", className: "contents [&_button[aria-pressed=true]]:bg-tag-pressed-background [&_button[aria-pressed=true]]:border-tag-pressed-outline", children: /* @__PURE__ */ m(cu, { "aria-pressed": o, onClick: r, children: n }) }), e[0] = n, e[1] = r, e[2] = o, e[3] = i) : i = e[3], i;
}
function V2(t) {
  const e = z.c(19), {
    feedbackState: n,
    allowWrittenFeedback: o,
    submitDisabled: r,
    className: i
  } = t, s = r === void 0 ? !1 : r;
  let l;
  e[0] !== i ? (l = ne(T2(), i), e[0] = i, e[1] = l) : l = e[1];
  let a;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ m(fo, { size: "lg", children: "Share Feedback" }), e[2] = a) : a = e[2];
  let c;
  e[3] !== n ? (c = ix.map((g) => /* @__PURE__ */ m(sx, { selected: n.reason === g, onClick: () => n.selectReason(g), children: g }, g)), e[3] = n, e[4] = c) : c = e[4];
  let u;
  e[5] !== c ? (u = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-start gap-(--spacing-10)", children: [
    a,
    /* @__PURE__ */ m("div", { className: "flex w-full flex-wrap gap-(--spacing-4) min-[600px]:w-max", children: c })
  ] }), e[5] = c, e[6] = u) : u = e[6];
  let d;
  e[7] !== o || e[8] !== n ? (d = o && n.reason === "Other" ? /* @__PURE__ */ m("div", { className: "min-w-0 w-full [&_input]:truncate", children: /* @__PURE__ */ m(rx, { size: "sm", label: "Please provide details:", placeholder: "What was not helpful?", reserveSubtextSpace: !1, value: n.feedbackText, onChange: (g) => n.setFeedbackText(g.target.value) }) }) : null, e[7] = o, e[8] = n, e[9] = d) : d = e[9];
  let f;
  e[10] !== n.reason || e[11] !== n.submitFeedback || e[12] !== s ? (f = n.reason !== void 0 ? /* @__PURE__ */ m(_n, { size: "sm", variant: "outline", disabled: s, onClick: n.submitFeedback, children: "Submit" }) : null, e[10] = n.reason, e[11] = n.submitFeedback, e[12] = s, e[13] = f) : f = e[13];
  let p;
  return e[14] !== l || e[15] !== u || e[16] !== d || e[17] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback-details", className: l, children: [
    u,
    d,
    f
  ] }), e[14] = l, e[15] = u, e[16] = d, e[17] = f, e[18] = p) : p = e[18], p;
}
function _2(t) {
  const e = z.c(5), {
    className: n
  } = t;
  let o;
  e[0] !== n ? (o = ne(T2(), n), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ m(ln, { children: "Thanks! We’ve received your feedback." }), e[2] = r) : r = e[2];
  let i;
  return e[3] !== o ? (i = /* @__PURE__ */ m("output", { "data-slot": "assistant-chat-feedback", className: o, "aria-live": "polite", children: r }), e[3] = o, e[4] = i) : i = e[4], i;
}
function wO(t) {
  const e = z.c(13);
  let n, o;
  e[0] !== t ? ({
    allowWrittenFeedback: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = o === void 0 ? !0 : o, i = O2(n);
  if (i.status === "dismissed")
    return null;
  if (i.status === "submitted") {
    let c;
    return e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m(_2, {}), e[3] = c) : c = e[3], c;
  }
  let s;
  e[4] !== i ? (s = /* @__PURE__ */ m(D2, { feedbackState: i }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  e[6] !== r || e[7] !== i || e[8] !== n ? (l = i.isReasonsOpen ? /* @__PURE__ */ m(V2, { feedbackState: i, allowWrittenFeedback: r, submitDisabled: n.onSubmit === void 0 }) : null, e[6] = r, e[7] = i, e[8] = n, e[9] = l) : l = e[9];
  let a;
  return e[10] !== s || e[11] !== l ? (a = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-feedback", className: "contents", children: [
    s,
    l
  ] }), e[10] = s, e[11] = l, e[12] = a) : a = e[12], a;
}
const lx = ce(["flex", "items-center", "justify-between", "gap-(--spacing-12)", "w-full", "px-(--spacing-12)", "max-[599px]:gap-(--spacing-8)", "max-[599px]:px-(--spacing-8)"], {
  variants: {
    minimized: {
      false: ["py-(--spacing-16)", "max-[599px]:py-(--spacing-12)", "bg-ai-panel-header-expanded", "relative", "after:pointer-events-none", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:border-b", "after:border-solid", "after:border-outline-subtle", "after:content-['']", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"],
      true: ["py-(--spacing-8)", "bg-ai-panel-header-minimized", "[background-origin:padding-box,border-box]", "[background-clip:padding-box,border-box]", "border", "border-solid", "border-transparent", "shadow-elevation-7", "rounded-tl-(--radius-md)", "rounded-tr-(--radius-md)"]
    }
  },
  defaultVariants: {
    minimized: !1
  }
});
function sc(t) {
  const e = z.c(50), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    minimized: i,
    onClose: s,
    onMinimize: l,
    onExpand: a,
    onNewConversation: c,
    isNewConversationDisabled: u,
    onOpenHistory: d,
    onBack: f,
    mobileHistoryControlRef: p
  } = t, g = i === void 0 ? !1 : i, h = u === void 0 ? !1 : u;
  let b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    defaultMatches: !1
  }, e[0] = b) : b = e[0];
  const v = Es("(max-width: 599px)", b), C = g && !v;
  let y;
  e[1] !== C ? (y = ne(lx({
    minimized: C
  })), e[1] = C, e[2] = y) : y = e[2];
  const w = C ? "" : void 0;
  let R;
  e[3] !== C || e[4] !== o ? (R = o ?? /* @__PURE__ */ m("div", { className: ne("flex shrink-0 items-center justify-center rounded-(--radius-sm)", C ? "relative size-(--icon-md) overflow-clip" : "size-(--spacing-40) p-(--spacing-4)"), children: /* @__PURE__ */ m(Ru, { size: C ? "md" : "lg" }) }), e[3] = C, e[4] = o, e[5] = R) : R = e[5];
  const S = C ? "sm" : "md";
  let E;
  e[6] !== S || e[7] !== n ? (E = /* @__PURE__ */ m("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ m(An, { as: "h2", size: S, truncate: !0, children: n }) }), e[6] = S, e[7] = n, e[8] = E) : E = e[8];
  let N;
  e[9] !== r ? (N = r ? /* @__PURE__ */ m("span", { className: "shrink-0", children: r }) : null, e[9] = r, e[10] = N) : N = e[10];
  let T;
  e[11] !== E || e[12] !== N ? (T = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
    E,
    N
  ] }), e[11] = E, e[12] = N, e[13] = T) : T = e[13];
  let P;
  e[14] !== T || e[15] !== R ? (P = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-12)", children: [
    R,
    T
  ] }), e[14] = T, e[15] = R, e[16] = P) : P = e[16];
  let I;
  e[17] !== C || e[18] !== p || e[19] !== f ? (I = !C && f && /* @__PURE__ */ m("span", { className: "min-[600px]:hidden", children: /* @__PURE__ */ m(mt, { ref: p, icon: "arrow-left", variant: "ghost", size: "sm", "aria-label": "Back to chat", onClick: f }) }), e[17] = C, e[18] = p, e[19] = f, e[20] = I) : I = e[20];
  let k;
  e[21] !== C || e[22] !== h || e[23] !== c ? (k = !C && c && /* @__PURE__ */ m("span", { className: "min-[600px]:hidden", children: /* @__PURE__ */ m(mt, { icon: "edit-pen", variant: "ghost", size: "sm", "aria-label": "New chat", onClick: c, disabled: h }) }), e[21] = C, e[22] = h, e[23] = c, e[24] = k) : k = e[24];
  let M;
  e[25] !== C || e[26] !== p || e[27] !== f || e[28] !== d ? (M = !C && !f && d && /* @__PURE__ */ m("span", { className: "min-[600px]:hidden", children: /* @__PURE__ */ m(mt, { ref: p, icon: "clock-seven", variant: "ghost", size: "sm", "aria-label": "Open chat history", onClick: d }) }), e[25] = C, e[26] = p, e[27] = f, e[28] = d, e[29] = M) : M = e[29];
  let D;
  e[30] !== C || e[31] !== l ? (D = !C && /* @__PURE__ */ m("span", { className: "max-[599px]:hidden", children: /* @__PURE__ */ m(mt, { icon: "minus", variant: "ghost", size: "sm", "aria-label": "Minimize", onClick: l }) }), e[30] = C, e[31] = l, e[32] = D) : D = e[32];
  let O;
  e[33] !== C || e[34] !== a ? (O = C && /* @__PURE__ */ m("span", { className: "max-[599px]:hidden", children: /* @__PURE__ */ m(mt, { icon: "expand-regular", variant: "ghost", size: "sm", "aria-label": "Expand", onClick: a }) }), e[33] = C, e[34] = a, e[35] = O) : O = e[35];
  let V;
  e[36] !== s ? (V = /* @__PURE__ */ m(mt, { icon: "x-close", variant: "ghost", size: "sm", "aria-label": "Close", onClick: s }), e[36] = s, e[37] = V) : V = e[37];
  let _;
  e[38] !== I || e[39] !== k || e[40] !== M || e[41] !== D || e[42] !== O || e[43] !== V ? (_ = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
    I,
    k,
    M,
    D,
    O,
    V
  ] }), e[38] = I, e[39] = k, e[40] = M, e[41] = D, e[42] = O, e[43] = V, e[44] = _) : _ = e[44];
  let A;
  return e[45] !== P || e[46] !== _ || e[47] !== y || e[48] !== w ? (A = /* @__PURE__ */ F("header", { className: y, "data-slot": "assistant-chat-header", "data-minimized": w, children: [
    P,
    _
  ] }), e[45] = P, e[46] = _, e[47] = y, e[48] = w, e[49] = A) : A = e[49], A;
}
function A2(t) {
  const e = z.c(9), {
    size: n
  } = t, [o] = ot(ax), r = n === "fullPage" ? "size-[100px]" : "size-(--icon-xxl)";
  let i;
  e[0] !== r ? (i = ne("aw-loading-animation shrink-0", r), e[0] = r, e[1] = i) : i = e[1];
  const s = `${o}ms`;
  let l;
  e[2] !== s ? (l = {
    animationDelay: s
  }, e[2] = s, e[3] = l) : l = e[3];
  let a, c;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ m("path", { className: "fill-outline-subtle opacity-40", d: "M4.8 24c0 10.605 8.595 19.2 19.2 19.2 8.085 0 15-4.995 17.835-12.068-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.128-2.123 5.31-7.313 9.06-13.38 9.06-7.95 0-14.4-6.45-14.4-14.4 0-7.95 6.45-14.4 14.4-14.4.698 0 1.388.053 2.063.143-1.313-.188-2.22-1.403-2.033-2.715.188-1.29 1.365-2.198 2.655-2.048a19.262 19.262 0 0 0-2.685-.188C13.395 4.793 4.8 13.388 4.8 23.993V24Z" }), c = /* @__PURE__ */ m("path", { className: "fill-primary-fixed", d: "M24.023 7.027c.187-1.312 1.402-2.22 2.715-2.032C36.045 6.33 43.2 14.325 43.2 24c0 2.513-.488 4.92-1.365 7.133-.495 1.23-1.89 1.83-3.12 1.335-1.23-.495-1.83-1.89-1.335-3.12.66-1.65 1.028-3.45 1.028-5.348 0-7.253-5.363-13.253-12.338-14.258-1.313-.188-2.22-1.403-2.033-2.715h-.015Z" }), e[4] = a, e[5] = c) : (a = e[4], c = e[5]);
  let u;
  return e[6] !== i || e[7] !== l ? (u = /* @__PURE__ */ F("svg", { "aria-hidden": "true", className: i, "data-slot": "loading-animation", fill: "none", style: l, viewBox: "0 0 48 48", children: [
    a,
    c
  ] }), e[6] = i, e[7] = l, e[8] = u) : u = e[8], u;
}
function ax() {
  return -(Date.now() % 1e3);
}
function L2(t) {
  const e = z.c(6), {
    label: n
  } = t, o = n ?? "Loading";
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ m(A2, { size: "blocking" }), e[0] = r) : r = e[0];
  let i;
  e[1] !== n ? (i = n && /* @__PURE__ */ m(fo, { align: "center", size: "xs", children: n }), e[1] = n, e[2] = i) : i = e[2];
  let s;
  return e[3] !== o || e[4] !== i ? (s = /* @__PURE__ */ F("output", { "aria-label": o, className: "flex flex-col items-center gap-(--spacing-8) rounded-(--radius-sm) bg-surface-container-lowest px-(--spacing-24) py-(--spacing-16)", "data-slot": "blocking-action-status", tabIndex: -1, children: [
    r,
    i
  ] }), e[3] = o, e[4] = i, e[5] = s) : s = e[5], s;
}
function SO(t) {
  const e = z.c(16);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    open: r,
    label: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r || void 0, l = r || void 0;
  let a;
  e[5] !== n || e[6] !== s || e[7] !== l ? (a = /* @__PURE__ */ m("div", { "aria-busy": s, inert: l, children: n }), e[5] = n, e[6] = s, e[7] = l, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== r ? (c = r && /* @__PURE__ */ m("div", { className: "absolute inset-0 z-10 flex items-center justify-center bg-surface-scrim", "data-slot": "blocking-action-overlay-scrim", children: /* @__PURE__ */ m(L2, { label: o }) }), e[9] = o, e[10] = r, e[11] = c) : c = e[11];
  let u;
  return e[12] !== i || e[13] !== a || e[14] !== c ? (u = /* @__PURE__ */ F("div", { ...i, className: "relative", "data-slot": "blocking-action-overlay", children: [
    a,
    c
  ] }), e[12] = i, e[13] = a, e[14] = c, e[15] = u) : u = e[15], u;
}
const F2 = ce(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "rounded-(--radius-sm)", "focus-visible:ring-2", "focus-visible:ring-(--color-inline-link-focus-ring)", "focus-visible:ring-offset-(--spacing-4)", "active:bg-(--color-inline-link-pressed-bg)"], {
  variants: {
    size: {
      xs: ["text-(length:--font-size-title-xs)", "leading-(--font-line-height-16)"],
      sm: ["text-(length:--font-size-title-sm)", "leading-(--font-line-height-20)"],
      md: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    },
    variant: {
      contextual: ["text-(--color-inline-link-contextual)", "no-underline", "hover:underline", "underline-offset-4"],
      navigational: ["text-(--color-inline-link-navigational)", "text-start", "underline", "underline-offset-4", "hover:text-(--color-inline-link-navigational-hover)"]
    },
    destructive: {
      true: ["text-(--color-text-destructive)", "hover:text-(--color-text-destructive)"]
    },
    disabled: {
      true: ["opacity-50", "pointer-events-none"]
    }
  },
  defaultVariants: {
    size: "md",
    variant: "contextual"
  }
}), cx = "https://www.assetwatch.com/privacy-policy";
function ux(t) {
  const e = z.c(4), {
    href: n,
    label: o
  } = t;
  let r;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = F2({
    size: "xs",
    variant: "contextual"
  }), e[0] = r) : r = e[0];
  let i;
  return e[1] !== n || e[2] !== o ? (i = /* @__PURE__ */ m("a", { className: r, href: n, target: "_blank", rel: "noopener noreferrer", children: o }), e[1] = n, e[2] = o, e[3] = i) : i = e[3], i;
}
function dx({
  year: t = (/* @__PURE__ */ new Date()).getFullYear(),
  privacyPolicyHref: e = cx,
  privacyPolicyLabel: n = "Privacy Policy"
}) {
  return /* @__PURE__ */ F("footer", { className: "flex h-(--spacing-32) w-full items-center justify-start gap-(--spacing-8)", children: [
    /* @__PURE__ */ F("span", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-xs) leading-(--font-line-height-16) font-(number:--font-weight-regular) text-text-default", children: [
      "© ",
      t,
      " AssetWatch"
    ] }),
    /* @__PURE__ */ m("span", { "aria-hidden": "true", className: "h-(--spacing-16) border-l border-outline-subtle" }),
    /* @__PURE__ */ m(ux, { href: e, label: n })
  ] });
}
function $2() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("output", { "aria-label": "Loading", tabIndex: -1, children: /* @__PURE__ */ m(A2, { size: "fullPage" }) }), t[0] = e) : e = t[0], e;
}
function RO(t) {
  const e = z.c(5);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  let o;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m($2, {}), e[2] = o) : o = e[2];
  let r;
  return e[3] !== n ? (r = /* @__PURE__ */ m("div", { ...n, "aria-busy": "true", className: "flex min-h-dvh items-center justify-center bg-surface-low p-(--spacing-24)", "data-slot": "full-page-loading", children: o }), e[3] = n, e[4] = r) : r = e[4], r;
}
const fx = ce("mx-auto w-full px-(--spacing-16)", {
  variants: {
    size: {
      sm: "max-w-[600px]",
      md: "max-w-[905px]",
      lg: "max-w-[1240px]",
      xl: "max-w-[1440px]",
      full: "max-w-none"
    }
  },
  defaultVariants: {
    size: "lg"
  }
});
function EO(t) {
  const e = z.c(10);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== r ? (i = ne(fx({
    size: r
  })), e[4] = r, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== i ? (s = /* @__PURE__ */ m("div", { className: i, ...o, children: n }), e[6] = n, e[7] = o, e[8] = i, e[9] = s) : s = e[9], s;
}
const H2 = {
  0: "gap-(--spacing-0)",
  2: "gap-(--spacing-2)",
  4: "gap-(--spacing-4)",
  6: "gap-(--spacing-6)",
  8: "gap-(--spacing-8)",
  10: "gap-(--spacing-10)",
  12: "gap-(--spacing-12)",
  16: "gap-(--spacing-16)",
  20: "gap-(--spacing-20)",
  24: "gap-(--spacing-24)",
  32: "gap-(--spacing-32)",
  40: "gap-(--spacing-40)",
  64: "gap-(--spacing-64)",
  80: "gap-(--spacing-80)"
}, z2 = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
  baseline: "items-baseline"
}, px = {
  start: "justify-start",
  center: "justify-center",
  end: "justify-end",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
}, gx = {
  wrap: "flex-wrap",
  nowrap: "flex-nowrap",
  "wrap-reverse": "flex-wrap-reverse"
}, mx = ce("flex flex-row", {
  variants: {
    align: z2,
    justify: px,
    gap: H2,
    wrap: gx
  },
  defaultVariants: {
    gap: 8,
    align: "center"
  }
});
function hr(t) {
  const e = z.c(18);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    gap: r,
    align: n,
    justify: i,
    wrap: a,
    grow: l,
    children: o,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? !1 : l;
  let u;
  e[8] !== n || e[9] !== r || e[10] !== c || e[11] !== i || e[12] !== a ? (u = ne(mx({
    gap: r,
    align: n,
    justify: i,
    wrap: a
  }), c && "[&>*]:flex-1"), e[8] = n, e[9] = r, e[10] = c, e[11] = i, e[12] = a, e[13] = u) : u = e[13];
  let d;
  return e[14] !== o || e[15] !== s || e[16] !== u ? (d = /* @__PURE__ */ m("div", { className: u, ...s, children: o }), e[14] = o, e[15] = s, e[16] = u, e[17] = d) : d = e[17], d;
}
const hx = ce("flex flex-col", {
  variants: {
    align: z2,
    gap: H2,
    fullWidth: {
      true: "w-full",
      false: null
    }
  },
  defaultVariants: {
    gap: 16,
    fullWidth: !1
  }
});
function qr(t) {
  const e = z.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    gap: r,
    align: n,
    fullWidth: s,
    children: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s;
  let a;
  e[6] !== n || e[7] !== l || e[8] !== r ? (a = ne(hx({
    gap: r,
    align: n,
    fullWidth: l
  })), e[6] = n, e[7] = l, e[8] = r, e[9] = a) : a = e[9];
  let c;
  return e[10] !== o || e[11] !== i || e[12] !== a ? (c = /* @__PURE__ */ m("div", { className: a, ...i, children: o }), e[10] = o, e[11] = i, e[12] = a, e[13] = c) : c = e[13], c;
}
const Kd = mo(null);
function qd() {
  return gn(Kd);
}
function NO() {
  const t = gn(Kd);
  if (!t)
    throw new Error("useAppShell must be used within AppShell.");
  return t;
}
function B2(t) {
  const e = z.c(11);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    modifier: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne("inline-flex", "items-center", "justify-center", "gap-(--spacing-4)", "rounded-(--radius-sm)", "border-[0.5px]", "border-solid", "border-menu-hotkey-outline", "bg-menu-hotkey-background", "px-(--spacing-6)", "py-(--spacing-4)", "font-(family-name:--font-family-body)", "text-(length:--font-size-label-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-16)", "tracking-(--font-letter-spacing-default)", "text-surface-on-surface-variant", "whitespace-nowrap", "not-italic", "select-none"), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = o && /* @__PURE__ */ m("span", { children: o }), e[5] = o, e[6] = s) : s = e[6];
  let l;
  return e[7] !== n || e[8] !== r || e[9] !== s ? (l = /* @__PURE__ */ F("kbd", { "data-slot": "kbd", className: i, ...r, children: [
    s,
    n
  ] }), e[7] = n, e[8] = r, e[9] = s, e[10] = l) : l = e[10], l;
}
const bx = ce(["inline-flex", "h-(--spacing-40)", "w-full", "min-w-0", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-left", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "max-[599px]:hidden"]), vx = ce(["inline-flex", "size-(--spacing-40)", "items-center", "justify-between", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-10)", "py-(--spacing-12)", "text-menu-icon-default", "outline-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring"]), yx = {
  left: {
    collapse: "arrow-left-shrink-sidebar",
    expand: "arrow-right-expand-sidebar"
  },
  right: {
    collapse: "arrow-right-expand-sidebar",
    expand: "arrow-left-shrink-sidebar"
  }
};
function uu(t) {
  const e = z.c(34);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    collapsed: n,
    collapseDirection: l,
    onClick: o,
    onToggle: r,
    shortcut: s,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "left" : l, c = n ? "Expand Panel" : "Collapse Panel", u = yx[a][n ? "expand" : "collapse"];
  let d;
  e[7] !== o || e[8] !== r ? (d = function(y) {
    o?.(y), r();
  }, e[7] = o, e[8] = r, e[9] = d) : d = e[9];
  const f = d;
  if (!n) {
    let C;
    e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = bx(), e[10] = C) : C = e[10];
    let y;
    e[11] !== u ? (y = /* @__PURE__ */ m(Ke, { "aria-hidden": !0, name: u, size: "sm", tone: "inherit" }), e[11] = u, e[12] = y) : y = e[12];
    let w;
    e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ m("span", { className: "min-w-0 truncate", children: "Collapse Panel" }), e[13] = w) : w = e[13];
    let R;
    e[14] !== y ? (R = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
      y,
      w
    ] }), e[14] = y, e[15] = R) : R = e[15];
    let S;
    return e[16] !== f || e[17] !== c || e[18] !== i || e[19] !== R ? (S = /* @__PURE__ */ m("button", { ...i, "aria-expanded": !0, "aria-label": c, className: C, onClick: f, type: "button", children: R }), e[16] = f, e[17] = c, e[18] = i, e[19] = R, e[20] = S) : S = e[20], S;
  }
  let p;
  e[21] !== s ? (p = s ? /* @__PURE__ */ m(B2, { "aria-hidden": "true", children: s }) : void 0, e[21] = s, e[22] = p) : p = e[22];
  let g;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = vx(), e[23] = g) : g = e[23];
  let h;
  e[24] !== u ? (h = /* @__PURE__ */ m(Ke, { "aria-hidden": !0, name: u, size: "sm", tone: "inherit" }), e[24] = u, e[25] = h) : h = e[25];
  let b;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== h ? (b = /* @__PURE__ */ m("button", { ...i, "aria-expanded": !1, "aria-label": c, className: g, onClick: f, type: "button", children: h }), e[26] = f, e[27] = c, e[28] = i, e[29] = h, e[30] = b) : b = e[30];
  let v;
  return e[31] !== p || e[32] !== b ? (v = /* @__PURE__ */ m("span", { className: "max-[599px]:hidden", children: /* @__PURE__ */ m(qo, { align: "center", endSection: p, label: "Expand", showArrow: !1, side: "right", children: b }) }), e[31] = p, e[32] = b, e[33] = v) : v = e[33], v;
}
const xx = [
  "grid",
  "h-dvh",
  "min-h-0",
  "overflow-hidden",
  "bg-surface",
  "grid-rows-[auto_minmax(0,1fr)]",
  "transition-[grid-template-columns]",
  "duration-200",
  "ease-in-out",
  "[--app-shell-sidebar-expanded-width:260px]",
  "[--app-shell-sidebar-collapsed-width:72px]",
  "[--app-shell-sidebar-width:var(--app-shell-sidebar-expanded-width)]",
  "data-[sidebar-collapsed]:[--app-shell-sidebar-width:var(--app-shell-sidebar-collapsed-width)]",
  "grid-cols-[var(--app-shell-sidebar-width)_minmax(0,1fr)]",
  "[&>[data-slot=top-bar]]:col-span-2",
  // Keep the header brand region at the expanded width when the sidebar collapses.
  "[&_[data-slot=top-bar-leading]]:w-(--app-shell-sidebar-expanded-width)",
  "max-[599px]:grid-cols-1",
  "max-[599px]:[&>[data-slot=top-bar]]:col-span-1",
  "max-[599px]:[&_[data-slot=top-bar-leading]]:w-auto"
].join(" "), W2 = "[", U2 = "assetwatch:app-shell:sidebar-collapsed";
function Cx() {
  if (typeof window > "u") return !1;
  try {
    return window.localStorage.getItem(U2) === "true";
  } catch {
    return !1;
  }
}
function _p(t) {
  try {
    window.localStorage.setItem(U2, String(t));
  } catch {
  }
}
function wx(t) {
  return t instanceof HTMLElement ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" || t.tagName === "SELECT" || t.isContentEditable : !1;
}
function kO({
  children: t,
  ...e
}) {
  const n = Es("(max-width: 599px)", {
    defaultMatches: !1
  }), [o, r] = ot(Cx), [i, s] = ot(!1), [l, a] = ot([]), c = ft(0), u = l.at(-1), d = qt(), f = u7();
  function p(b) {
    r(b), _p(b);
  }
  function g(b) {
    const v = c.current;
    return c.current += 1, a((C) => [...C, {
      ...b,
      id: v
    }]), () => {
      a((C) => C.filter((y) => y.id !== v));
    };
  }
  kt(() => {
    if (n) return;
    function b(v) {
      if (v.defaultPrevented || v.isComposing || v.metaKey || v.ctrlKey || v.altKey || v.shiftKey || wx(v.target) || v.key !== W2)
        return;
      v.preventDefault();
      const C = !o;
      r(C), _p(C);
    }
    return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
  }, [o, n]), kt(() => {
    if (d)
      return d.inert = !!u, () => {
        d.inert = !1;
      };
  }, [u, d]);
  const h = u ? /* @__PURE__ */ m("div", { className: "fixed inset-0 z-[var(--z-layer-blocking)] flex items-center justify-center bg-surface-scrim", "data-slot": "app-shell-blocking-overlay", children: /* @__PURE__ */ m(L2, { label: u.label }) }) : null;
  return /* @__PURE__ */ m(Kd, { value: {
    desktopSidebarCollapsed: o,
    beginBlockingAction: g,
    isMobile: n,
    mobileNavigationOpen: i,
    setDesktopSidebarCollapsed: p,
    setMobileNavigationOpen: s
  }, children: /* @__PURE__ */ F("div", { className: "relative h-dvh", children: [
    /* @__PURE__ */ m("div", { ...e, "aria-busy": u ? !0 : void 0, className: xx, "data-sidebar-collapsed": o ? "" : void 0, "data-slot": "app-shell", inert: u ? !0 : void 0, children: t }),
    h && (f ? Q3(h, f) : h)
  ] }) });
}
function MO(t) {
  const e = z.c(30);
  let n, o, r, i, s, l, a, c;
  if (e[0] !== t ? ({
    banner: n,
    pageHeader: r,
    pageHeaderTabs: i,
    privacyPolicyLabel: l,
    privacyPolicyHref: s,
    children: o,
    pending: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]), c === void 0 ? !1 : c) {
    let v;
    e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (v = /* @__PURE__ */ m("main", { "aria-busy": "true", className: "flex min-h-0 min-w-0 items-center justify-center overflow-y-auto bg-surface-low p-(--spacing-24)", children: /* @__PURE__ */ m($2, {}) }), e[9] = v) : v = e[9];
    let C;
    return e[10] !== a ? (C = /* @__PURE__ */ m("div", { ...a, className: "grid min-h-0 min-w-0 grid-rows-[minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: v }), e[10] = a, e[11] = C) : C = e[11], C;
  }
  let d;
  e[12] !== n ? (d = n && /* @__PURE__ */ m(qr, { "data-slot": "app-shell-banner", fullWidth: !0, gap: 0, children: n }), e[12] = n, e[13] = d) : d = e[13];
  let f;
  e[14] !== r || e[15] !== i ? (f = r && /* @__PURE__ */ F("header", { className: i ? "flex min-h-0 max-h-[50dvh] flex-col bg-surface" : "max-h-[50dvh] overflow-y-auto border-b border-outline-subtle bg-surface p-(--spacing-24)", "data-slot": "app-shell-page-header", children: [
    i ? /* @__PURE__ */ m("div", { className: "min-h-0 overflow-y-auto px-(--spacing-24) pt-(--spacing-24) pb-(--spacing-20)", children: r }) : r,
    i && /* @__PURE__ */ m("div", { className: "shrink-0", children: i })
  ] }), e[14] = r, e[15] = i, e[16] = f) : f = e[16];
  let p;
  e[17] !== o ? (p = /* @__PURE__ */ m("div", { className: "min-w-0 grow", children: o }), e[17] = o, e[18] = p) : p = e[18];
  let g;
  e[19] !== s || e[20] !== l ? (g = /* @__PURE__ */ m("div", { className: "mt-(--spacing-32) shrink-0", children: /* @__PURE__ */ m(dx, { privacyPolicyHref: s, privacyPolicyLabel: l }) }), e[19] = s, e[20] = l, e[21] = g) : g = e[21];
  let h;
  e[22] !== p || e[23] !== g ? (h = /* @__PURE__ */ F("main", { className: "flex min-h-0 min-w-0 flex-col overflow-y-auto bg-surface-low p-(--spacing-24)", "data-slot": "app-shell-content-body", children: [
    p,
    g
  ] }), e[22] = p, e[23] = g, e[24] = h) : h = e[24];
  let b;
  return e[25] !== a || e[26] !== d || e[27] !== f || e[28] !== h ? (b = /* @__PURE__ */ F("div", { ...a, className: "relative z-0 grid min-h-0 min-w-0 grid-cols-[minmax(0,1fr)] grid-rows-[auto_auto_minmax(0,1fr)] overflow-hidden bg-surface-low", "data-slot": "app-shell-content", children: [
    d,
    f,
    h
  ] }), e[25] = a, e[26] = d, e[27] = f, e[28] = h, e[29] = b) : b = e[29], b;
}
function IO(t) {
  const e = z.c(7);
  let n;
  e[0] !== t ? ({
    ...n
  } = t, e[0] = t, e[1] = n) : n = e[1];
  const o = qd();
  if (!o)
    throw new Error("AppShellMobileNavigationTrigger must be rendered within AppShell.");
  if (!o.isMobile)
    return null;
  let r;
  e[2] !== o ? (r = () => o.setMobileNavigationOpen(!0), e[2] = o, e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== r ? (i = /* @__PURE__ */ m(mt, { ...n, "aria-label": "Open navigation", icon: "menu-hamburger", onClick: r, variant: "ghost" }), e[4] = n, e[5] = r, e[6] = i) : i = e[6], i;
}
function Sx(t) {
  const e = z.c(11);
  let n, o;
  e[0] !== t ? ({
    onClick: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const r = qd();
  if (!r)
    throw new Error("AppShellSidebarToggle must be rendered within AppShell.");
  if (r.isMobile)
    return null;
  const {
    desktopSidebarCollapsed: i,
    setDesktopSidebarCollapsed: s
  } = r;
  let l;
  e[3] !== i || e[4] !== s ? (l = () => s(!i), e[3] = i, e[4] = s, e[5] = l) : l = e[5];
  let a;
  return e[6] !== i || e[7] !== n || e[8] !== o || e[9] !== l ? (a = /* @__PURE__ */ m(uu, { ...o, collapsed: i, onClick: n, onToggle: l, shortcut: W2 }), e[6] = i, e[7] = n, e[8] = o, e[9] = l, e[10] = a) : a = e[10], a;
}
function Rx(t) {
  const {
    open: e,
    defaultOpen: n,
    onOpenChange: o,
    disabled: r
  } = t, i = e !== void 0, [s, l] = dn({
    controlled: e,
    default: n,
    name: "Collapsible",
    state: "open"
  }), {
    mounted: a,
    setMounted: c,
    transitionStatus: u
  } = Xn(s, !0, !0), [d, f] = x.useState(s), [{
    height: p,
    width: g
  }, h] = x.useState({
    height: void 0,
    width: void 0
  }), b = Mt(), [v, C] = x.useState(), y = v ?? b, [w, R] = x.useState(!1), [S, E] = x.useState(!1), N = x.useRef(null), T = x.useRef(null), P = x.useRef(null), I = x.useRef(null), k = Ql(I, !1), M = Se((D) => {
    const O = !s, V = Ve(Zn, D.nativeEvent);
    if (o(O, V), V.isCanceled)
      return;
    const _ = I.current;
    T.current === "css-animation" && _ != null && _.style.removeProperty("animation-name"), !w && !S && (T.current != null && T.current !== "css-animation" && !a && O && c(!0), T.current === "css-animation" && (!d && O && f(!0), !a && O && c(!0))), l(O), T.current === "none" && a && !O && c(!1);
  });
  return ke(() => {
    i && T.current === "none" && !s && c(!1);
  }, [i, s, e, c]), x.useMemo(() => ({
    abortControllerRef: N,
    animationTypeRef: T,
    disabled: r,
    handleTrigger: M,
    height: p,
    mounted: a,
    open: s,
    panelId: y,
    panelRef: I,
    runOnceAnimationsFinish: k,
    setDimensions: h,
    setHiddenUntilFound: R,
    setKeepMounted: E,
    setMounted: c,
    setOpen: l,
    setPanelIdState: C,
    setVisible: f,
    transitionDimensionRef: P,
    transitionStatus: u,
    visible: d,
    width: g
  }), [N, T, r, M, p, a, s, y, I, k, h, R, E, c, l, f, P, u, d, g]);
}
const Zd = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Zd.displayName = "CollapsibleRootContext");
function G2() {
  const t = x.useContext(Zd);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: CollapsibleRootContext is missing. Collapsible parts must be placed within <Collapsible.Root>." : rt(15));
  return t;
}
let $i = (function(t) {
  return t.open = "data-open", t.closed = "data-closed", t[t.startingStyle = qn.startingStyle] = "startingStyle", t[t.endingStyle = qn.endingStyle] = "endingStyle", t;
})({}), Ex = /* @__PURE__ */ (function(t) {
  return t.panelOpen = "data-panel-open", t;
})({});
const Nx = {
  [$i.open]: ""
}, kx = {
  [$i.closed]: ""
}, Mx = {
  open(t) {
    return t ? {
      [Ex.panelOpen]: ""
    } : null;
  }
}, Ix = {
  open(t) {
    return t ? Nx : kx;
  }
}, Y2 = {
  ...Ix,
  ...Bt
}, Xd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    defaultOpen: i = !1,
    disabled: s = !1,
    onOpenChange: l,
    open: a,
    style: c,
    ...u
  } = e, d = Se(l), f = Rx({
    open: a,
    defaultOpen: i,
    onOpenChange: d,
    disabled: s
  }), p = x.useMemo(() => ({
    open: f.open,
    disabled: f.disabled,
    transitionStatus: f.transitionStatus
  }), [f.open, f.disabled, f.transitionStatus]), g = x.useMemo(() => ({
    ...f,
    onOpenChange: d,
    state: p
  }), [f, d, p]), h = $e("div", e, {
    state: p,
    ref: n,
    props: u,
    stateAttributesMapping: Y2
  });
  return /* @__PURE__ */ m(Zd.Provider, {
    value: g,
    children: h
  });
});
process.env.NODE_ENV !== "production" && (Xd.displayName = "CollapsibleRoot");
const Px = {
  ...Mx,
  ...Bt
}, Bl = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    panelId: o,
    open: r,
    handleTrigger: i,
    state: s,
    disabled: l
  } = G2(), {
    className: a,
    disabled: c = l,
    id: u,
    render: d,
    nativeButton: f = !0,
    style: p,
    ...g
  } = e, {
    getButtonProps: h,
    buttonRef: b
  } = Wt({
    disabled: c,
    focusableWhenDisabled: !0,
    native: f
  }), v = x.useMemo(() => ({
    "aria-controls": r ? o : void 0,
    "aria-expanded": r,
    onClick: i
  }), [o, r, i]);
  return $e("button", e, {
    state: s,
    ref: [n, b],
    props: [v, g, h],
    stateAttributesMapping: Px
  });
});
process.env.NODE_ENV !== "production" && (Bl.displayName = "CollapsibleTrigger");
let Tx = /* @__PURE__ */ (function(t) {
  return t.disabled = "data-disabled", t.orientation = "data-orientation", t;
})({});
function Ox(t) {
  const {
    abortControllerRef: e,
    animationTypeRef: n,
    externalRef: o,
    height: r,
    hiddenUntilFound: i,
    keepMounted: s,
    id: l,
    mounted: a,
    onOpenChange: c,
    open: u,
    panelRef: d,
    runOnceAnimationsFinish: f,
    setDimensions: p,
    setMounted: g,
    setOpen: h,
    setVisible: b,
    transitionDimensionRef: v,
    visible: C,
    width: y
  } = t, w = x.useRef(!1), R = x.useRef(null), S = x.useRef(u), E = x.useRef(u), N = ei(), T = x.useMemo(() => n.current === "css-animation" ? !C : !u && !a, [u, a, C, n]), P = Se((k) => {
    if (!k)
      return;
    if (n.current == null || v.current == null) {
      const O = getComputedStyle(k), V = O.animationName !== "none" && O.animationName !== "", _ = O.transitionDuration !== "0s" && O.transitionDuration !== "";
      V && _ ? process.env.NODE_ENV !== "production" && Xl("CSS transitions and CSS animations both detected on Collapsible or Accordion panel.", "Only one of either animation type should be used.") : O.animationName === "none" && O.transitionDuration !== "0s" ? n.current = "css-transition" : O.animationName !== "none" && O.transitionDuration === "0s" ? n.current = "css-animation" : n.current = "none", k.getAttribute(Tx.orientation) === "horizontal" || O.transitionProperty.indexOf("width") > -1 ? v.current = "width" : v.current = "height";
    }
    if (n.current !== "css-transition")
      return;
    (r === void 0 || y === void 0) && (p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), E.current && k.style.setProperty("transition-duration", "0s"));
    let M = -1, D = -1;
    return M = At.request(() => {
      E.current = !1, D = At.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    }), () => {
      At.cancel(M), At.cancel(D);
    };
  }), I = fn(o, d, P);
  return ke(() => {
    if (n.current !== "css-transition")
      return;
    const k = d.current;
    if (!k)
      return;
    let M = -1;
    if (e.current != null && (e.current.abort(), e.current = null), u) {
      const D = {
        "justify-content": k.style.justifyContent,
        "align-items": k.style.alignItems,
        "align-content": k.style.alignContent,
        "justify-items": k.style.justifyItems
      };
      Object.keys(D).forEach((O) => {
        k.style.setProperty(O, "initial", "important");
      }), !E.current && !s && k.setAttribute($i.startingStyle, ""), p({
        height: k.scrollHeight,
        width: k.scrollWidth
      }), M = At.request(() => {
        Object.entries(D).forEach(([O, V]) => {
          V === "" ? k.style.removeProperty(O) : k.style.setProperty(O, V);
        });
      });
    } else {
      if (k.scrollHeight === 0 && k.scrollWidth === 0)
        return;
      p({
        height: k.scrollHeight,
        width: k.scrollWidth
      });
      const D = new AbortController();
      e.current = D;
      const O = D.signal;
      let V = null;
      const _ = $i.endingStyle;
      return V = new MutationObserver((A) => {
        A.some((B) => B.type === "attributes" && B.attributeName === _) && (V?.disconnect(), V = null, f(() => {
          p({
            height: 0,
            width: 0
          }), k.style.removeProperty("content-visibility"), g(!1), e.current === D && (e.current = null);
        }, O));
      }), V.observe(k, {
        attributes: !0,
        attributeFilter: [_]
      }), () => {
        V?.disconnect(), N.cancel(), e.current === D && (D.abort(), e.current = null);
      };
    }
    return () => {
      At.cancel(M);
    };
  }, [e, n, N, i, s, a, u, d, f, p, g]), ke(() => {
    if (n.current !== "css-animation")
      return;
    const k = d.current;
    k && (R.current = k.style.animationName || R.current, k.style.setProperty("animation-name", "none"), p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), !S.current && !w.current && k.style.removeProperty("animation-name"), u ? (e.current != null && (e.current.abort(), e.current = null), g(!0), b(!0)) : (e.current = new AbortController(), f(() => {
      g(!1), b(!1), e.current = null;
    }, e.current.signal)));
  }, [e, n, u, d, f, p, g, b, C]), Jr(() => {
    const k = At.request(() => {
      S.current = !1;
    });
    return () => At.cancel(k);
  }), ke(() => {
    if (!i)
      return;
    const k = d.current;
    if (!k)
      return;
    let M = -1, D = -1;
    return u && w.current && (k.style.transitionDuration = "0s", p({
      height: k.scrollHeight,
      width: k.scrollWidth
    }), M = At.request(() => {
      w.current = !1, D = At.request(() => {
        setTimeout(() => {
          k.style.removeProperty("transition-duration");
        });
      });
    })), () => {
      At.cancel(M), At.cancel(D);
    };
  }, [i, u, d, p]), ke(() => {
    const k = d.current;
    k && i && T && (k.setAttribute("hidden", "until-found"), n.current === "css-transition" && k.setAttribute($i.startingStyle, ""));
  }, [i, T, n, d]), x.useEffect(function() {
    const M = d.current;
    if (!M)
      return;
    function D(O) {
      w.current = !0, h(!0), c(!0, Ve(Pt, O));
    }
    return ut(M, "beforematch", D);
  }, [c, d, h]), x.useMemo(() => ({
    props: {
      hidden: T,
      id: l,
      ref: I
    }
  }), [T, l, I]);
}
let Ap = /* @__PURE__ */ (function(t) {
  return t.collapsiblePanelHeight = "--collapsible-panel-height", t.collapsiblePanelWidth = "--collapsible-panel-width", t;
})({});
const Qd = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    hiddenUntilFound: r,
    keepMounted: i,
    render: s,
    id: l,
    style: a,
    ...c
  } = e;
  process.env.NODE_ENV !== "production" && ke(() => {
    r && i === !1 && Xl("The `keepMounted={false}` prop on a Collapsible will be ignored when using `hiddenUntilFound` since it requires the Panel to remain mounted even when closed.");
  }, [r, i]);
  const {
    abortControllerRef: u,
    animationTypeRef: d,
    height: f,
    mounted: p,
    onOpenChange: g,
    open: h,
    panelId: b,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setHiddenUntilFound: w,
    setKeepMounted: R,
    setMounted: S,
    setPanelIdState: E,
    setOpen: N,
    setVisible: T,
    state: P,
    transitionDimensionRef: I,
    visible: k,
    width: M,
    transitionStatus: D
  } = G2(), O = r ?? !1, V = i ?? !1;
  ke(() => {
    if (l)
      return E(l), () => {
        E(void 0);
      };
  }, [l, E]), ke(() => {
    w(O);
  }, [w, O]), ke(() => {
    R(V);
  }, [R, V]);
  const {
    props: _
  } = Ox({
    abortControllerRef: u,
    animationTypeRef: d,
    externalRef: n,
    height: f,
    hiddenUntilFound: O,
    id: b,
    keepMounted: V,
    mounted: p,
    onOpenChange: g,
    open: h,
    panelRef: v,
    runOnceAnimationsFinish: C,
    setDimensions: y,
    setMounted: S,
    setOpen: N,
    setVisible: T,
    transitionDimensionRef: I,
    visible: k,
    width: M
  });
  jt({
    open: h && D === "idle",
    ref: v,
    onComplete() {
      h && y({
        height: void 0,
        width: void 0
      });
    }
  });
  const A = x.useMemo(() => ({
    ...P,
    transitionStatus: D
  }), [P, D]), L = $e("div", e, {
    state: A,
    ref: [n, v],
    props: [_, {
      style: {
        [Ap.collapsiblePanelHeight]: f === void 0 ? "auto" : `${f}px`,
        [Ap.collapsiblePanelWidth]: M === void 0 ? "auto" : `${M}px`
      }
    }, c],
    stateAttributesMapping: Y2
  });
  return V || O || p ? L : null;
});
process.env.NODE_ENV !== "production" && (Qd.displayName = "CollapsiblePanel");
function Jd(t) {
  return $e(t.defaultTagName ?? "div", t, t);
}
const ef = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ef.displayName = "DialogRootContext");
function hn(t) {
  const e = x.useContext(ef);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DialogRootContext is missing. Dialog parts must be placed within <Dialog.Root>." : rt(27));
  return e;
}
let Qt = /* @__PURE__ */ (function(t) {
  return t.nestedDrawers = "--nested-drawers", t.height = "--drawer-height", t.frontmostHeight = "--drawer-frontmost-height", t.swipeMovementX = "--drawer-swipe-movement-x", t.swipeMovementY = "--drawer-swipe-movement-y", t.snapPointOffset = "--drawer-snap-point-offset", t.swipeStrength = "--drawer-swipe-strength", t;
})({}), So = /* @__PURE__ */ (function(t) {
  return t.swipeProgress = "--drawer-swipe-progress", t;
})({});
const Dx = {
  ...Nn,
  ...Bt
}, j2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = hn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return $e("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: Dx,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        pointerEvents: c ? void 0 : "none",
        userSelect: "none",
        WebkitUserSelect: "none",
        [So.swipeProgress]: "0",
        [Qt.swipeStrength]: "1"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (j2.displayName = "DrawerBackdrop");
const Zr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, {
    store: c
  } = hn(), u = c.useState("open");
  function d(h) {
    u && c.setOpen(!1, Ve($m, h.nativeEvent));
  }
  const {
    getButtonProps: f,
    buttonRef: p
  } = Wt({
    disabled: i,
    native: s
  });
  return $e("button", e, {
    state: {
      disabled: i
    },
    ref: [n, p],
    props: [{
      onClick: d
    }, a, f]
  });
});
process.env.NODE_ENV !== "production" && (Zr.displayName = "DialogClose");
const K2 = Zr, q2 = "data-drawer-content", Z2 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e;
  return hn(), $e("div", e, {
    ref: n,
    props: [{
      [q2]: ""
    }, s]
  });
});
process.env.NODE_ENV !== "production" && (Z2.displayName = "DrawerContent");
const Qi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = hn(), c = Mt(s);
  return a.useSyncedValueWithCleanup("descriptionElementId", c), $e("p", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Qi.displayName = "DialogDescription");
const Vx = Qi, X2 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (X2.displayName = "DrawerProviderContext");
function Q2(t) {
  return x.useContext(X2);
}
let Wn = (function(t) {
  return t[t.open = un.open] = "open", t[t.closed = un.closed] = "closed", t[t.startingStyle = un.startingStyle] = "startingStyle", t[t.endingStyle = un.endingStyle] = "endingStyle", t.expanded = "data-expanded", t.nestedDrawerOpen = "data-nested-drawer-open", t.nestedDrawerSwiping = "data-nested-drawer-swiping", t.swipeDismiss = "data-swipe-dismiss", t.swipeDirection = "data-swipe-direction", t.swiping = "data-swiping", t;
})({});
const tf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (tf.displayName = "DialogPortalContext");
function nf() {
  const t = x.useContext(tf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Portal> is missing." : rt(26));
  return t;
}
const of = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (of.displayName = "DrawerRootContext");
function ha(t) {
  const e = x.useContext(of);
  if (t === !1 && e === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: DrawerRootContext is missing. Drawer parts must be placed within <Drawer.Root>." : rt(90));
  return e;
}
function Ut(t, e = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(e, Math.min(t, n));
}
function Lp(t, e, n) {
  if (!Number.isFinite(e) || e <= 0)
    return null;
  if (typeof t == "number")
    return Number.isFinite(t) ? t <= 1 ? Ut(t, 0, 1) * e : t : null;
  const o = t.trim();
  if (o.endsWith("px")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r : null;
  }
  if (o.endsWith("rem")) {
    const r = Number.parseFloat(o);
    return Number.isFinite(r) ? r * n : null;
  }
  return null;
}
function _x(t, e) {
  let n = null, o = 1 / 0;
  for (const r of e) {
    const i = Math.abs(r.height - t);
    i < o && (o = i, n = r);
  }
  return n;
}
function J2() {
  const {
    store: t
  } = hn(), {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r
  } = ha(), i = t.useState("viewportElement"), [s, l] = x.useState(0), [a, c] = x.useState(16), u = Se(() => {
    const g = et(i).documentElement;
    i && l(i.offsetHeight), i || l(g.clientHeight);
    const h = parseFloat(getComputedStyle(g).fontSize);
    Number.isFinite(h) && c(h);
  });
  ke(() => {
    if (u(), !i || typeof ResizeObserver != "function")
      return;
    const p = new ResizeObserver(u);
    return p.observe(i), () => {
      p.disconnect();
    };
  }, [u, i]);
  const d = x.useMemo(() => {
    if (!e || e.length === 0 || s <= 0 || r <= 0)
      return [];
    const p = Math.min(r, s);
    if (!Number.isFinite(p) || p <= 0)
      return [];
    const g = e.map((v) => {
      const C = Lp(v, s, a);
      if (C === null || !Number.isFinite(C))
        return null;
      const y = Ut(C, 0, p);
      return {
        value: v,
        height: y,
        offset: Math.max(0, r - y)
      };
    }).filter((v) => !!v);
    if (g.length <= 1)
      return g;
    const h = [], b = [];
    for (let v = g.length - 1; v >= 0; v -= 1) {
      const C = g[v];
      b.some((w) => Math.abs(w - C.height) <= 1) || (b.push(C.height), h.push(C));
    }
    return h.reverse(), h;
  }, [r, a, e, s]), f = x.useMemo(() => {
    if (n === void 0)
      return d[0];
    if (n === null)
      return;
    const p = d.find((v) => Object.is(v.value, n));
    if (p)
      return p;
    const g = Math.min(r, s), h = Lp(n, s, a);
    if (h === null || !Number.isFinite(h))
      return;
    const b = Ut(h, 0, g);
    return _x(b, d) ?? void 0;
  }, [n, r, d, a, s]);
  return {
    snapPoints: e,
    activeSnapPoint: n,
    setActiveSnapPoint: o,
    popupHeight: r,
    viewportHeight: s,
    resolvedSnapPoints: d,
    activeSnapPointOffset: f?.offset ?? null
  };
}
const rf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (rf.displayName = "DrawerViewportContext");
function Ax(t) {
  return x.useContext(rf);
}
let Fp = !1;
function Lx() {
  Fp || (typeof CSS < "u" && "registerProperty" in CSS && ([Qt.swipeMovementX, Qt.swipeMovementY, Qt.snapPointOffset].forEach((t) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<length>",
        inherits: !1,
        initialValue: "0px"
      });
    } catch {
    }
  }), [{
    name: So.swipeProgress,
    initialValue: "0"
  }, {
    name: Qt.swipeStrength,
    initialValue: "1"
  }].forEach(({
    name: t,
    initialValue: e
  }) => {
    try {
      CSS.registerProperty({
        name: t,
        syntax: "<number>",
        inherits: !1,
        initialValue: e
      });
    } catch {
    }
  })), Fp = !0);
}
const Fx = {
  ...Nn,
  ...Bt,
  expanded(t) {
    return t ? {
      [Wn.expanded]: ""
    } : null;
  },
  nestedDrawerOpen(t) {
    return t ? {
      [Wn.nestedDrawerOpen]: ""
    } : null;
  },
  nestedDrawerSwiping(t) {
    return t ? {
      [Wn.nestedDrawerSwiping]: ""
    } : null;
  },
  swipeDirection(t) {
    return t ? {
      [Wn.swipeDirection]: t
    } : null;
  },
  swiping(t) {
    return t ? {
      [Wn.swiping]: ""
    } : null;
  }
}, e0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = hn(), {
    swipeDirection: u,
    frontmostHeight: d,
    hasNestedDrawer: f,
    nestedSwiping: p,
    nestedSwipeProgressStore: g,
    onPopupHeightChange: h,
    notifyParentFrontmostHeight: b,
    notifyParentHasNestedDrawer: v
  } = ha(), C = c.useState("descriptionElementId"), y = c.useState("disablePointerDismissal"), w = c.useState("floatingRootContext"), R = c.useState("popupProps"), S = c.useState("modal"), E = c.useState("mounted"), N = c.useState("nested"), T = c.useState("nestedOpenDrawerCount"), P = c.useState("transitionStatus"), I = c.useState("open"), k = c.useState("openMethod"), M = c.useState("titleElementId"), D = c.useState("role"), O = T > 0, V = Ax(), _ = V?.swiping ?? !1, A = V?.swipeStrength ?? null, {
    snapPoints: L,
    activeSnapPoint: B,
    activeSnapPointOffset: G
  } = J2();
  nf();
  const [U, Y] = x.useState(0), K = x.useRef(0);
  process.env.NODE_ENV !== "production" && x.useEffect(() => {
    if (V)
      return;
    const pe = pr.captureOwnerStack?.() || "";
    jo(`<Drawer.Popup> expected to be rendered within <Drawer.Viewport>. Omitting the viewport disables drawer swipe handling and touch scroll locking. Wrap <Drawer.Popup> in <Drawer.Viewport>.${pe}`);
  }, [V]);
  const j = Se(() => {
    const pe = c.context.popupRef.current;
    if (!pe)
      return;
    const oe = pe.offsetHeight;
    if (K.current > 0 && d > K.current && oe > K.current)
      return;
    if (K.current > 0 && f) {
      const xe = K.current;
      Y(xe), h(xe);
      return;
    }
    const de = oe;
    de !== K.current && (K.current = de, Y(de), h(de));
  });
  ke(() => {
    if (!E) {
      K.current = 0, Y(0), h(0);
      return;
    }
    const pe = c.context.popupRef.current;
    if (!pe || (Lx(), j(), typeof ResizeObserver != "function"))
      return;
    const oe = new ResizeObserver(j);
    return oe.observe(pe), () => {
      oe.disconnect();
    };
  }, [j, E, O, h, c.context.popupRef]), ke(() => {
    const pe = c.context.popupRef, oe = () => {
      const de = pe.current;
      if (!de)
        return;
      const xe = g.getSnapshot();
      xe > 0 ? de.style.setProperty(So.swipeProgress, `${xe}`) : de.style.setProperty(So.swipeProgress, "0");
    };
    oe();
    const re = g.subscribe(oe);
    return () => {
      re();
      const de = pe.current;
      de && de.style.setProperty(So.swipeProgress, "0");
    };
  }, [g, c.context.popupRef]), x.useEffect(() => {
    if (I)
      return b?.(d), () => {
        b?.(0);
      };
  }, [d, I, b]), x.useEffect(() => v ? (v(I || P === "ending"), () => {
    v(!1);
  }) : void 0, [v, I, P]), jt({
    open: I,
    ref: c.context.popupRef,
    onComplete() {
      I && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const Z = i === void 0 ? c.context.popupRef : i, te = {
    open: I,
    nested: N,
    transitionStatus: P,
    expanded: B === 1,
    nestedDrawerOpen: O,
    nestedDrawerSwiping: p,
    swipeDirection: u,
    swiping: _
  };
  let W;
  U && !(!f && P !== "ending") && (W = `${U}px`);
  const ee = L && L.length > 0 && (u === "down" || u === "up");
  let le = null;
  ee && G !== null && (le = u === "up" ? -G : G);
  let J = V ? V.getDragStyles() : St;
  if (ee && u === "down") {
    const pe = G ?? 0, oe = Number.parseFloat(String(J[Qt.swipeMovementY] ?? 0)), re = Number.isFinite(oe) ? pe + oe : pe, de = re < 0;
    if (_ && de && Number.isFinite(oe)) {
      const xe = Math.abs(re), fe = -Math.sqrt(xe) - pe;
      J = {
        ...J,
        transform: void 0,
        [Qt.swipeMovementY]: `${fe}px`
      };
    } else
      J = {
        ...J,
        transform: void 0
      };
  }
  const ie = $e("div", e, {
    state: te,
    props: [R, {
      "aria-labelledby": M,
      "aria-describedby": C,
      role: D,
      tabIndex: -1,
      hidden: !E,
      onKeyDown(pe) {
        ys.has(pe.key) && pe.stopPropagation();
      },
      style: {
        ...J,
        [So.swipeProgress]: "0",
        [Qt.nestedDrawers]: T,
        [Qt.height]: W,
        [Qt.snapPointOffset]: typeof le == "number" ? `${le}px` : "0px",
        [Qt.frontmostHeight]: d ? `${d}px` : void 0,
        [Qt.swipeStrength]: typeof A == "number" && Number.isFinite(A) && A > 0 ? `${A}` : "1"
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: Fx
  });
  return /* @__PURE__ */ m(oi, {
    context: w,
    openInteractionType: k,
    disabled: !E,
    closeOnFocusOut: !y,
    initialFocus: Z,
    returnFocus: r,
    modal: S !== !1,
    restoreFocus: "popup",
    children: ie
  });
});
process.env.NODE_ENV !== "production" && (e0.displayName = "DrawerPopup");
const Tr = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = hn(), s = i.useState("mounted"), l = i.useState("modal"), a = i.useState("open");
  return s || o ? /* @__PURE__ */ m(tf.Provider, {
    value: o,
    children: /* @__PURE__ */ F(ni, {
      ref: n,
      ...r,
      children: [s && l === !0 && /* @__PURE__ */ m(si, {
        ref: i.context.internalBackdropRef,
        inert: Er(!a)
      }), e.children]
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Tr.displayName = "DialogPortal");
const $x = Tr, Hx = {
  ...Nn,
  ...Bt
}, Ns = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    forceRender: s = !1,
    ...l
  } = e, {
    store: a
  } = hn(), c = a.useState("open"), u = a.useState("nested"), d = a.useState("mounted"), f = a.useState("transitionStatus");
  return $e("div", e, {
    state: {
      open: c,
      transitionStatus: f
    },
    ref: [a.context.backdropRef, n],
    stateAttributesMapping: Hx,
    props: [{
      role: "presentation",
      hidden: !d,
      style: {
        userSelect: "none",
        WebkitUserSelect: "none"
      }
    }, l],
    enabled: s || !u
  });
});
process.env.NODE_ENV !== "production" && (Ns.displayName = "DialogBackdrop");
let zx = /* @__PURE__ */ (function(t) {
  return t.nestedDialogs = "--nested-dialogs", t;
})({}), Bx = (function(t) {
  return t[t.open = un.open] = "open", t[t.closed = un.closed] = "closed", t[t.startingStyle = un.startingStyle] = "startingStyle", t[t.endingStyle = un.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const Wx = {
  ...Nn,
  ...Bt,
  nestedDialogOpen(t) {
    return t ? {
      [Bx.nestedDialogOpen]: ""
    } : null;
  }
}, mi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    finalFocus: r,
    initialFocus: i,
    render: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = hn(), u = c.useState("descriptionElementId"), d = c.useState("disablePointerDismissal"), f = c.useState("floatingRootContext"), p = c.useState("popupProps"), g = c.useState("modal"), h = c.useState("mounted"), b = c.useState("nested"), v = c.useState("nestedOpenDialogCount"), C = c.useState("open"), y = c.useState("openMethod"), w = c.useState("titleElementId"), R = c.useState("transitionStatus"), S = c.useState("role");
  nf(), jt({
    open: C,
    ref: c.context.popupRef,
    onComplete() {
      C && c.context.onOpenChangeComplete?.(!0);
    }
  });
  function E(k) {
    return k === "touch" ? c.context.popupRef.current : !0;
  }
  const N = i === void 0 ? E : i, T = v > 0, I = $e("div", e, {
    state: {
      open: C,
      nested: b,
      transitionStatus: R,
      nestedDialogOpen: T
    },
    props: [p, {
      "aria-labelledby": w ?? void 0,
      "aria-describedby": u ?? void 0,
      role: S,
      tabIndex: -1,
      hidden: !h,
      onKeyDown(k) {
        ys.has(k.key) && k.stopPropagation();
      },
      style: {
        [zx.nestedDialogs]: v
      }
    }, a],
    ref: [n, c.context.popupRef, c.useStateSetter("popupElement")],
    stateAttributesMapping: Wx
  });
  return /* @__PURE__ */ m(oi, {
    context: f,
    openInteractionType: y,
    disabled: !h,
    closeOnFocusOut: !d,
    initialFocus: N,
    returnFocus: r,
    modal: g !== !1,
    restoreFocus: "popup",
    children: I
  });
});
process.env.NODE_ENV !== "production" && (mi.displayName = "DialogPopup");
function Ux(t) {
  const {
    store: e,
    parentContext: n,
    actionsRef: o,
    isDrawer: r
  } = t, i = e.useState("open"), s = e.useState("disablePointerDismissal"), l = e.useState("modal"), a = e.useState("popupElement"), {
    openMethod: c,
    triggerProps: u
  } = Cs(i);
  us(e);
  const {
    forceUnmount: d
  } = ds(i, e), f = x.useCallback(() => {
    e.setOpen(!1, Ve(ss));
  }, [e]);
  x.useImperativeHandle(o, () => ({
    unmount: d,
    close: f
  }), [d, f]);
  const p = gs({
    popupStore: e,
    onOpenChange: e.setOpen,
    treatPopupAsFloatingElement: !0
  }), [g, h] = x.useState(0), [b, v] = x.useState(0), C = g === 0, y = vd(p), w = Cr(p, {
    outsidePressEvent() {
      return e.context.internalBackdropRef.current || e.context.backdropRef.current ? "intentional" : {
        mouse: l === "trap-focus" ? "sloppy" : "intentional",
        touch: "sloppy"
      };
    },
    outsidePress(I) {
      if (!e.context.outsidePressEnabledRef.current || "button" in I && I.button !== 0 || "touches" in I && I.touches.length !== 1)
        return !1;
      const k = bt(I);
      if (C && !s) {
        const M = k;
        return l && (e.context.internalBackdropRef.current || e.context.backdropRef.current) ? e.context.internalBackdropRef.current === M || e.context.backdropRef.current === M || ze(M, a) && !M?.hasAttribute("data-base-ui-portal") : !0;
      }
      return !1;
    },
    escapeKey: C
  });
  qh(i && l === !0, a);
  const {
    getReferenceProps: R,
    getFloatingProps: S,
    getTriggerProps: E
  } = eo([y, w]);
  e.useContextCallback("onNestedDialogOpen", (I, k) => {
    h(I), v(k);
  }), e.useContextCallback("onNestedDialogClose", () => {
    h(0), v(0);
  }), x.useEffect(() => (n?.onNestedDialogOpen && i && n.onNestedDialogOpen(g + 1, b + (r ? 1 : 0)), n?.onNestedDialogClose && !i && n.onNestedDialogClose(), () => {
    n?.onNestedDialogClose && i && n.onNestedDialogClose();
  }), [r, i, g, b, n]);
  const N = x.useMemo(() => R(u), [R, u]), T = x.useMemo(() => E(u), [E, u]), P = x.useMemo(() => S(), [S]);
  e.useSyncedValues({
    openMethod: c,
    activeTriggerProps: N,
    inactiveTriggerProps: T,
    popupProps: P,
    floatingRootContext: p,
    nestedOpenDialogCount: g,
    nestedOpenDrawerCount: b
  });
}
const Gx = {
  ...ps,
  modal: he((t) => t.modal),
  nested: he((t) => t.nested),
  nestedOpenDialogCount: he((t) => t.nestedOpenDialogCount),
  nestedOpenDrawerCount: he((t) => t.nestedOpenDrawerCount),
  disablePointerDismissal: he((t) => t.disablePointerDismissal),
  openMethod: he((t) => t.openMethod),
  descriptionElementId: he((t) => t.descriptionElementId),
  titleElementId: he((t) => t.titleElementId),
  viewportElement: he((t) => t.viewportElement),
  role: he((t) => t.role)
};
class sf extends wr {
  constructor(e) {
    super(Yx(e), {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      outsidePressEnabledRef: {
        current: !0
      },
      triggerElements: new Sr(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0
    }, Gx);
  }
  setOpen = (e, n) => {
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, !e && n.trigger == null && this.state.activeTriggerId != null && (n.trigger = this.state.activeTriggerElement ?? void 0), this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const o = {
      open: e
    }, r = n.trigger?.id ?? null;
    (r || e) && (o.activeTriggerId = r, o.activeTriggerElement = n.trigger ?? null), this.update(o);
  };
  static useStore(e, n) {
    const o = Tt(() => new sf(n)).current;
    return e ?? o;
  }
}
function Yx(t = {}) {
  return {
    ...fs(),
    modal: !0,
    disablePointerDismissal: !1,
    popupElement: null,
    viewportElement: null,
    descriptionElementId: void 0,
    titleElementId: void 0,
    openMethod: null,
    nested: !1,
    nestedOpenDialogCount: 0,
    nestedOpenDrawerCount: 0,
    role: "dialog",
    ...t
  };
}
const Wl = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (Wl.displayName = "IsDrawerContext");
function hi(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null
  } = t, f = hn(!0), p = x.useContext(Wl), g = !!f, h = sf.useStore(c?.store, {
    open: o,
    openProp: n,
    activeTriggerId: d,
    triggerIdProp: u,
    modal: l,
    disablePointerDismissal: s,
    nested: g
  });
  Nr(() => {
    n === void 0 && h.state.open === !1 && o === !0 && h.update({
      open: !0,
      activeTriggerId: d
    });
  }), h.useControlledProp("openProp", n), h.useControlledProp("triggerIdProp", u), h.useSyncedValues({
    disablePointerDismissal: s,
    nested: g,
    modal: l
  }), h.useContextCallback("onOpenChange", r), h.useContextCallback("onOpenChangeComplete", i);
  const b = h.useState("payload");
  Ux({
    store: h,
    actionsRef: a,
    parentContext: f?.store.context,
    isDrawer: p
  });
  const v = x.useMemo(() => ({
    store: h
  }), [h]);
  return /* @__PURE__ */ m(Wl.Provider, {
    value: !1,
    children: /* @__PURE__ */ m(ef.Provider, {
      value: v,
      children: typeof e == "function" ? e({
        payload: b
      }) : e
    })
  });
}
let $p = (function(t) {
  return t[t.open = un.open] = "open", t[t.closed = un.closed] = "closed", t[t.startingStyle = un.startingStyle] = "startingStyle", t[t.endingStyle = un.endingStyle] = "endingStyle", t.nested = "data-nested", t.nestedDialogOpen = "data-nested-dialog-open", t;
})({});
const jx = {
  ...Nn,
  ...Bt,
  nested(t) {
    return t ? {
      [$p.nested]: ""
    } : null;
  },
  nestedDialogOpen(t) {
    return t ? {
      [$p.nestedDialogOpen]: ""
    } : null;
  }
}, bi = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    style: s,
    ...l
  } = e, a = nf(), {
    store: c
  } = hn(), u = c.useState("open"), d = c.useState("nested"), f = c.useState("transitionStatus"), p = c.useState("nestedOpenDialogCount"), g = c.useState("mounted"), h = p > 0;
  return $e("div", e, {
    enabled: a || g,
    state: {
      open: u,
      nested: d,
      transitionStatus: f,
      nestedDialogOpen: h
    },
    ref: [n, c.useStateSetter("viewportElement")],
    stateAttributesMapping: jx,
    props: [{
      role: "presentation",
      hidden: !g,
      style: {
        pointerEvents: u ? void 0 : "none"
      },
      children: i
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (bi.displayName = "DialogViewport");
const Ji = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    store: a
  } = hn(), c = Mt(s);
  return a.useSyncedValueWithCleanup("titleElementId", c), $e("h2", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Ji.displayName = "DialogTitle");
const t0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = hn(!0), p = c?.store ?? f?.store;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Dialog.Trigger> must be used within <Dialog.Root> or provided with a handle." : rt(79));
  const g = Mt(l), h = p.useState("floatingRootContext"), b = p.useState("isOpenedByTrigger", g), v = x.useRef(null), {
    registerTrigger: C,
    isMountedByThisTrigger: y
  } = cs(g, v, p, {
    payload: a
  }), {
    getButtonProps: w,
    buttonRef: R
  } = Wt({
    disabled: i,
    native: s
  }), S = xr(h, {
    enabled: h != null
  }), E = eo([S]), N = {
    disabled: i,
    open: b
  }, T = p.useState("triggerProps", y);
  return $e("button", e, {
    state: N,
    ref: [R, n, C, v],
    props: [E.getReferenceProps(), T, {
      [Ju]: "",
      id: g
    }, d, w],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (t0.displayName = "DialogTrigger");
var Hp, zp;
function Kx(t) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    disablePointerDismissal: s = !1,
    modal: l = !0,
    actionsRef: a,
    handle: c,
    triggerId: u,
    defaultTriggerId: d = null,
    swipeDirection: f = "down",
    snapToSequentialPoints: p = !1,
    snapPoints: g,
    snapPoint: h,
    defaultSnapPoint: b,
    onSnapPointChange: v
  } = t, C = Se(v), y = ha(!0), w = y?.onNestedSwipeProgressChange, R = y?.onNestedFrontmostHeightChange, S = y?.onNestedSwipingChange, E = y?.onNestedDrawerPresenceChange, [N, T] = x.useState(0), [P, I] = x.useState(0), [k, M] = x.useState(!1), [D, O] = x.useState(!1), [V] = x.useState(qx), _ = b !== void 0 ? b : g?.[0] ?? null, A = h !== void 0, [L, B] = dn({
    controlled: h,
    default: _,
    name: "Drawer",
    state: "snapPoint"
  }), G = x.useRef(!1), U = Se((J, ie) => {
    const pe = ie ?? Ve(Pt);
    C?.(J, pe), !pe.isCanceled && B(J);
  }), Y = x.useMemo(() => A || !g || g.length === 0 ? L : L === null || !g.some((J) => Object.is(J, L)) ? _ : L, [L, A, _, g]), K = Se((J) => {
    T(J), !G.current && J > 0 && I(J);
  }), j = Se((J) => {
    if (J > 0) {
      G.current = !0, I(J);
      return;
    }
    G.current = !1, N > 0 && I(N);
  }), Z = Se((J) => {
    M(J);
  }), te = Se((J) => {
    V.set(J), w?.(J);
  }), W = Se((J) => {
    O(J), S?.(J);
  }), X = Se((J, ie) => {
    r?.(J, ie), !ie.isCanceled && !J && g && g.length > 0 && U(_, Ve(ie.reason, ie.event, ie.trigger));
  }), ee = x.useMemo(() => ({
    swipeDirection: f,
    snapToSequentialPoints: p,
    snapPoints: g,
    activeSnapPoint: Y,
    setActiveSnapPoint: U,
    frontmostHeight: P,
    popupHeight: N,
    hasNestedDrawer: k,
    nestedSwiping: D,
    nestedSwipeProgressStore: V,
    onNestedDrawerPresenceChange: Z,
    onPopupHeightChange: K,
    onNestedFrontmostHeightChange: j,
    onNestedSwipingChange: W,
    onNestedSwipeProgressChange: te,
    notifyParentFrontmostHeight: R,
    notifyParentSwipingChange: S,
    notifyParentSwipeProgressChange: w,
    notifyParentHasNestedDrawer: E
  }), [Y, P, k, D, V, E, w, S, R, Z, j, te, W, K, N, U, g, p, f]), le = typeof e == "function" ? (J) => /* @__PURE__ */ F(x.Fragment, {
    children: [Hp || (Hp = /* @__PURE__ */ m(Bp, {})), e(J)]
  }) : /* @__PURE__ */ F(x.Fragment, {
    children: [zp || (zp = /* @__PURE__ */ m(Bp, {})), e]
  });
  return /* @__PURE__ */ m(of.Provider, {
    value: ee,
    children: /* @__PURE__ */ m(Wl.Provider, {
      value: !0,
      children: /* @__PURE__ */ m(hi, {
        open: n,
        defaultOpen: o,
        onOpenChange: X,
        onOpenChangeComplete: i,
        disablePointerDismissal: s,
        modal: l,
        actionsRef: a,
        handle: c,
        triggerId: u,
        defaultTriggerId: d,
        children: le
      })
    })
  });
}
function qx() {
  let t = 0;
  const e = /* @__PURE__ */ new Set();
  return {
    getSnapshot: () => t,
    set(n) {
      const o = Number.isFinite(n) ? n : 0;
      o !== t && (t = o, e.forEach((r) => {
        r();
      }));
    },
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    }
  };
}
function Bp() {
  const t = Do(), e = Q2(), n = hn(!1), o = n.store.useState("open"), r = n.store.useState("nestedOpenDialogCount"), i = n.store.useState("popupElement"), s = r === 0;
  return x.useEffect(() => {
    if (!(!e || t == null))
      return () => {
        e.removeDrawer(t);
      };
  }, [t, e]), x.useEffect(() => {
    t != null && e?.setDrawerOpen(t, o);
  }, [t, o, e]), x.useEffect(() => {
    if (!o || !s || !Gi)
      return;
    const a = wt(i).CloseWatcher;
    if (!a)
      return;
    function c(f) {
      n.store.select("open") && n.store.setOpen(!1, Ve(r8, f));
    }
    const u = new a(), d = ut(u, "close", c);
    return () => {
      d(), u.destroy();
    };
  }, [n.store, s, o, i]), null;
}
function du(t, e) {
  const n = pn(t);
  if (e === "vertical") {
    const r = n.overflowY;
    return (r === "auto" || r === "scroll") && t.scrollHeight > t.clientHeight;
  }
  const o = n.overflowX;
  return (o === "auto" || o === "scroll") && t.scrollWidth > t.clientWidth;
}
function Zx(t, e, n) {
  let o = t;
  for (; o && o !== e; ) {
    for (const r of n)
      if (du(o, r))
        return !0;
    o = o.parentElement;
  }
  return !1;
}
function Lr(t, e, n = "vertical") {
  let o = Ct(t) ? t : null;
  for (; o && o !== e; ) {
    if (du(o, n))
      return o;
    o = o.parentElement;
  }
  return du(e, n) ? e : null;
}
function Sl(t, e, n) {
  return typeof t?.elementFromPoint == "function" ? t.elementFromPoint(e, n) : null;
}
const Xx = 40, Qx = 10, Jx = 1, eC = 50, Wp = 16, tC = 80, nC = 'button,a,input,select,textarea,label,[role="button"]';
function lc(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function oC(t) {
  const n = wt(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
function rl(t) {
  return Number.isFinite(t) && t > 0 ? t : null;
}
function rC(t) {
  return t % 2 === 1;
}
function ac(t, e, n) {
  const o = t[n];
  if (typeof o == "function")
    try {
      o.call(t, e);
    } catch (r) {
      if (r && typeof r == "object" && "name" in r && r.name === "NotFoundError")
        return;
      throw r;
    }
}
function iC(t) {
  const {
    enabled: e,
    directions: n,
    elementRef: o,
    movementCssVars: r,
    canStart: i,
    ignoreSelectorWhenTouch: s = !0,
    ignoreScrollableAncestors: l = !1,
    swipeThreshold: a,
    onDismiss: c,
    onProgress: u,
    onCancel: d,
    onSwipeStart: f,
    onRelease: p,
    onSwipingChange: g,
    trackDrag: h = !0
  } = t, b = nC, v = n.length === 1 ? n[0] : void 0, C = Math.max(0, typeof a == "number" ? a : Xx), y = n.includes("left"), w = n.includes("right"), R = n.includes("up"), S = n.includes("down"), E = y || w, N = R || S, T = x.useMemo(() => {
    const we = [];
    return N && we.push("vertical"), E && we.push("horizontal"), we;
  }, [E, N]), [P, I] = x.useState(void 0), [k, M] = x.useState(!1), [D, O] = x.useState(!1), [V, _] = x.useState(!1), [A, L] = x.useState({
    x: 0,
    y: 0
  }), [B, G] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [U, Y] = x.useState(null), K = x.useRef({
    x: 0,
    y: 0
  }), j = x.useRef({
    x: 0,
    y: 0
  }), Z = x.useRef(null), te = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), W = x.useRef(void 0), X = x.useRef(0), ee = x.useRef(!1), le = x.useRef({
    x: 0,
    y: 0
  }), J = x.useRef(!1), ie = x.useRef(!1), pe = x.useRef(null), oe = x.useRef(!1), re = x.useRef(!1), de = x.useRef({
    width: 0,
    height: 0
  }), xe = x.useRef(0), se = x.useRef(C), fe = x.useRef(null), $ = x.useRef(null), Q = x.useRef({
    x: 0,
    y: 0
  }), H = x.useRef(null), q = x.useRef(!1), ae = Se((we) => {
    q.current !== we && (q.current = we, M(we), g?.(we));
  });
  function ge(we) {
    if (!we)
      return;
    if (typeof a != "function") {
      se.current = C;
      return;
    }
    const Ne = o.current;
    if (!Ne)
      return;
    const Ae = a({
      element: Ne,
      direction: we
    });
    se.current = Math.max(0, Ae);
  }
  const ue = Se((we, Ne) => {
    const Ae = Number.isFinite(we) ? Ut(we, 0, 1) : 0, Fe = Ae !== xe.current;
    let Xe = !1;
    if (Ne) {
      const qe = H.current;
      Xe = !qe || qe.deltaX !== Ne.deltaX || qe.deltaY !== Ne.deltaY || qe.direction !== Ne.direction;
    }
    !Fe && !Xe || (xe.current = Ae, Ne ? H.current = Ne : Fe && (H.current = null), u?.(Ae, Ne));
  });
  function Re(we, Ne) {
    if (Ne === null)
      return;
    const Ae = $.current;
    if (Ae && Ne > Ae.time) {
      const Fe = Math.max(Ne - Ae.time, Wp);
      Q.current = {
        x: (we.x - Ae.x) / Fe,
        y: (we.y - Ae.y) / Fe
      };
    }
    $.current = {
      x: we.x,
      y: we.y,
      time: Ne
    };
  }
  const be = x.useCallback(() => {
    I(void 0), ae(!1), O(!1), _(!1), L({
      x: 0,
      y: 0
    }), G({
      x: 0,
      y: 0,
      scale: 1
    }), Y(null), ue(0), se.current = C, K.current = {
      x: 0,
      y: 0
    }, j.current = {
      x: 0,
      y: 0
    }, te.current = {
      x: 0,
      y: 0,
      scale: 1
    }, W.current = void 0, X.current = 0, ee.current = !1, le.current = {
      x: 0,
      y: 0
    }, J.current = !1, Z.current = null, ie.current = !1, pe.current = null, oe.current = !1, re.current = !1, de.current = {
      width: 0,
      height: 0
    }, fe.current = null, $.current = null, Q.current = {
      x: 0,
      y: 0
    }, H.current = null;
  }, [ae, C, ue]);
  x.useEffect(() => {
    typeof a != "function" && (se.current = C);
  }, [C, a]);
  function ve(we) {
    if ("touches" in we) {
      const Ne = we.touches[0];
      return Ne ? {
        x: Ne.clientX,
        y: Ne.clientY
      } : null;
    }
    return {
      x: we.clientX,
      y: we.clientY
    };
  }
  function me(we) {
    return "touches" in we ? !0 : we.pointerType === "touch";
  }
  function Ee(we, Ne) {
    const Ae = et(o.current);
    return Sl(Ae, we.x, we.y) ?? bt(Ne);
  }
  function Pe(we, Ne) {
    return E && !N ? Lr(we, Ne, "horizontal") : N && !E ? Lr(we, Ne, "vertical") : Lr(we, Ne, "vertical") ?? Lr(we, Ne, "horizontal");
  }
  function Me(we, Ne, Ae) {
    oe.current = !1;
    const Fe = me(we), Xe = Ee(Ne, we.nativeEvent), it = et(o.current).body, Ge = Fe && it ? Pe(Xe, it) : null, Ze = Ae?.ignoreScrollableTarget ?? !1;
    if (Ge && !Ze || (oe.current = !!(Ge && Ze), (Xe ? Xe.closest(b) : !1) && (!Fe || s)))
      return !1;
    const st = o.current;
    if (l && st && Xe && T.length > 0 && !(Ae?.ignoreScrollableAncestors ?? !1) && Zx(Xe, st, T))
      return !1;
    if (ee.current = !1, W.current = void 0, X.current = 0, K.current = Ne, fe.current = rl(we.timeStamp), le.current = Ne, Z.current = Ne, st) {
      de.current = {
        width: st.offsetWidth,
        height: st.offsetHeight
      }, ge(v);
      const gt = oC(st);
      te.current = gt, j.current = {
        x: gt.x,
        y: gt.y
      }, G(gt), L({
        x: gt.x,
        y: gt.y
      }), Re({
        x: gt.x,
        y: gt.y
      }, fe.current), "touches" in we || ac(st, we.pointerId, "setPointerCapture");
    }
    return f?.(we.nativeEvent), ae(!0), O(!1), Y(null), J.current = !0, ue(0), !0;
  }
  function _e() {
    Ue(), oe.current = !1, Z.current = null;
  }
  function Ue() {
    ie.current = !1, pe.current = null;
  }
  function Ye(we) {
    if (_e(), !q.current)
      return;
    ae(!1), O(!1), Y(null);
    const Ne = h ? B : te.current;
    j.current = {
      x: Ne.x,
      y: Ne.y
    }, L({
      x: Ne.x,
      y: Ne.y
    }), I(void 0), re.current = !1;
    const Ae = o.current;
    Ae && ac(Ae, we.pointerId, "releasePointerCapture"), ue(0, {
      deltaX: 0,
      deltaY: 0,
      direction: void 0
    }), d?.(we.nativeEvent);
  }
  function He(we, Ne) {
    const Ae = (it) => it >= 0 ? it ** 0.5 : -(Math.abs(it) ** 0.5), Fe = (it, Ge, Ze) => !Ge && it < 0 || !Ze && it > 0 ? Ae(it) : it, Xe = E ? Fe(we, y, w) : Ae(we), qe = N ? Fe(Ne, R, S) : Ae(Ne);
    return {
      x: Xe,
      y: qe
    };
  }
  function ye(we, Ne, Ae) {
    const Fe = Math.abs(Ne), Xe = Math.abs(Ae);
    if (N && Ae !== 0 && (!E || Xe >= Fe)) {
      const Ge = Math.max(0, we.scrollHeight - we.clientHeight), Ze = we.scrollTop <= 0, tt = we.scrollTop >= Ge, st = Ae > 0, gt = Ae < 0;
      return st && Ze && S || gt && tt && R;
    }
    if (E && Ne !== 0 && (!N || Fe > Xe)) {
      const Ge = Math.max(0, we.scrollWidth - we.clientWidth), Ze = we.scrollLeft <= 0, tt = we.scrollLeft >= Ge, st = Ne > 0, gt = Ne < 0;
      return st && Ze && w || gt && tt && y;
    }
    return null;
  }
  const Oe = Se((we) => {
    if (!e || we.defaultPrevented || we.nativeEvent.defaultPrevented || !("touches" in we) && we.button !== 0)
      return;
    const Ne = ve(we);
    !Ne || (ie.current = !0, pe.current = Ne, oe.current = !1, re.current = !1, !(i ? i(Ne, {
      nativeEvent: we.nativeEvent,
      direction: v
    }) : !0)) || Me(we, Ne) && Ue();
  });
  function Ie(we, Ne, Ae) {
    if (!e || !q.current)
      return;
    const Fe = bt(we.nativeEvent);
    if (me(we) && !oe.current) {
      const Zt = we.currentTarget;
      if (Pe(Fe, Zt))
        return;
    }
    if ("touches" in we || we.preventDefault(), J.current) {
      K.current = Ne;
      const Zt = rl(we.timeStamp);
      Zt !== null && (fe.current = Zt), J.current = !1;
    }
    const Xe = Ne.x, qe = Ne.y, it = Ae.x, Ge = Ae.y;
    (Ge < 0 && qe > le.current.y || Ge > 0 && qe < le.current.y) && (le.current = {
      x: le.current.x,
      y: qe
    }), (it < 0 && Xe > le.current.x || it > 0 && Xe < le.current.x) && (le.current = {
      x: Xe,
      y: le.current.y
    });
    const Ze = Xe - K.current.x, tt = qe - K.current.y, st = qe - le.current.y, gt = Xe - le.current.x;
    if (!D && Math.sqrt(Ze * Ze + tt * tt) >= Jx && (O(!0), U === null && E && N)) {
      const Fn = Math.abs(Ze), Ci = Math.abs(tt);
      Y(Fn > Ci ? "horizontal" : "vertical");
    }
    let ht;
    if (!W.current)
      U === "vertical" ? tt > 0 ? ht = "down" : tt < 0 && (ht = "up") : U === "horizontal" ? Ze > 0 ? ht = "right" : Ze < 0 && (ht = "left") : Math.abs(Ze) >= Math.abs(tt) ? ht = Ze > 0 ? "right" : "left" : ht = tt > 0 ? "down" : "up", ht && (ht === "left" && y || ht === "right" && w || ht === "up" && R || ht === "down" && S) && (W.current = ht, X.current = lc(ht, Ze, tt), I(ht), ge(ht));
    else {
      const Zt = W.current, Fn = lc(Zt, gt, st);
      Fn > se.current ? (ee.current = !1, I(Zt)) : !(y && w) && !(R && S) && X.current - Fn >= Qx && (ee.current = !0);
    }
    const Ot = He(Ze, tt);
    let ct = te.current.x, Ht = te.current.y;
    U === "horizontal" ? E && (ct += Ot.x) : (U === "vertical" || E && (ct += Ot.x), N && (Ht += Ot.y)), j.current = {
      x: ct,
      y: Ht
    }, h && L({
      x: ct,
      y: Ht
    }), Re({
      x: ct,
      y: Ht
    }, rl(we.timeStamp));
    const no = ct - te.current.x, bn = Ht - te.current.y, Ln = W.current, kn = v ?? W.current;
    if (!kn) {
      ue(0, {
        deltaX: no,
        deltaY: bn,
        direction: Ln
      });
      return;
    }
    const Mn = kn === "left" || kn === "right" ? de.current.width : de.current.height, nn = te.current.scale || 1;
    if (Mn <= 0 || nn <= 0) {
      ue(0, {
        deltaX: no,
        deltaY: bn,
        direction: Ln
      });
      return;
    }
    const oo = lc(kn, ct - te.current.x, Ht - te.current.y);
    if (oo <= 0) {
      ue(0, {
        deltaX: no,
        deltaY: bn,
        direction: Ln
      });
      return;
    }
    ue(oo / (Mn * nn), {
      deltaX: no,
      deltaY: bn,
      direction: Ln
    });
  }
  const Le = Se((we) => {
    const Ne = ve(we);
    if (!Ne)
      return;
    if (!("touches" in we)) {
      const Xe = rC(we.buttons);
      Xe && (re.current = !0);
      const qe = we.buttons === 0 && re.current;
      if (we.buttons !== 0 && !Xe || qe) {
        Ye(we);
        return;
      }
    }
    if (!k && ie.current) {
      if (!me(we) && (we.defaultPrevented || we.nativeEvent.defaultPrevented)) {
        _e();
        return;
      }
      if (i ? i(Ne, {
        nativeEvent: we.nativeEvent,
        direction: v
      }) : !0) {
        const qe = pe.current;
        let it = !1;
        if (me(we)) {
          const Ze = o.current;
          if (qe && Ze) {
            const tt = Ee(Ne, we.nativeEvent), gt = et(Ze).body, ht = gt ? Pe(tt, gt) : null;
            if (ht && (ze(Ze, ht) || ze(ht, Ze))) {
              const Ot = Ne.x - qe.x, ct = Ne.y - qe.y, Ht = ye(ht, Ot, ct);
              if (Ht === !1)
                return;
              Ht === !0 && (it = !0);
            }
          }
        }
        Me(we, Ne, {
          ignoreScrollableTarget: it,
          ignoreScrollableAncestors: it
        }) && (qe && it ? (Ue(), K.current = qe, le.current = qe, Z.current = qe, J.current = !1) : (Ue(), oe.current = !1));
      }
    }
    const Ae = Z.current, Fe = Ae === null ? {
      x: 0,
      y: 0
    } : {
      x: Ne.x - Ae.x,
      y: Ne.y - Ae.y
    };
    Z.current = Ne, Ie(we, Ne, Fe);
  }), Be = Se((we) => {
    if (!e)
      return;
    const Ne = j.current, Ae = te.current, Fe = Ne.x - Ae.x, Xe = Ne.y - Ae.y, qe = {
      deltaX: Fe,
      deltaY: Xe,
      direction: P ?? W.current
    };
    if (!q.current) {
      _e(), ue(0, qe);
      return;
    }
    ae(!1), O(!1), Y(null), _e(), re.current = !1;
    const it = o.current;
    it && ("touches" in we || ac(it, we.pointerId, "releasePointerCapture"));
    const Ge = Fe, Ze = Xe, tt = fe.current, st = rl(we.timeStamp), gt = tt !== null && st !== null && st > tt ? st - tt : 0, ht = gt > 0 ? Math.max(gt, eC) : 0, Ot = ht > 0 ? Ge / ht : 0, ct = ht > 0 ? Ze / ht : 0;
    let Ht = Q.current.x, no = Q.current.y;
    const bn = $.current;
    if (bn && st !== null && st >= bn.time) {
      const oo = st - bn.time;
      if (oo <= tC) {
        const Zt = Math.max(oo, Wp), Fn = Ne.x - bn.x, Ci = Ne.y - bn.y, vn = Fn / Zt, $n = Ci / Zt;
        vn !== 0 && (Ht = vn), $n !== 0 && (no = $n);
      } else
        Ht = 0, no = 0;
    }
    const Ln = p?.({
      event: we.nativeEvent,
      direction: P ?? W.current,
      deltaX: Ge,
      deltaY: Ze,
      velocityX: Ot,
      velocityY: ct,
      releaseVelocityX: Ht,
      releaseVelocityY: no
    }), kn = typeof Ln == "boolean";
    if (ee.current && !kn) {
      j.current = {
        x: Ae.x,
        y: Ae.y
      }, L({
        x: Ae.x,
        y: Ae.y
      }), I(void 0), ue(0, qe);
      return;
    }
    let Mn = !1, nn;
    if (kn)
      Mn = Ln, nn = P ?? W.current ?? v;
    else
      for (const oo of n) {
        switch (oo) {
          case "right":
            Ge > se.current && (Mn = !0, nn = "right");
            break;
          case "left":
            Ge < -se.current && (Mn = !0, nn = "left");
            break;
          case "down":
            Ze > se.current && (Mn = !0, nn = "down");
            break;
          case "up":
            Ze < -se.current && (Mn = !0, nn = "up");
            break;
        }
        if (Mn)
          break;
      }
    Mn && nn ? (I(nn), _(!0), c?.(we.nativeEvent, {
      direction: nn
    })) : (j.current = {
      x: Ae.x,
      y: Ae.y
    }, L({
      x: Ae.x,
      y: Ae.y
    }), I(void 0), ue(0, qe));
  }), Te = x.useCallback(() => {
    const we = h ? A : j.current, Ne = h ? B : te.current;
    if (!k && we.x === Ne.x && we.y === Ne.y && !V)
      return {
        [r.x]: "0px",
        [r.y]: "0px"
      };
    const Ae = we.x - Ne.x, Fe = we.y - Ne.y;
    return {
      transition: k ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: k ? `translateX(${we.x}px) translateY(${we.y}px) scale(${Ne.scale})` : void 0,
      [r.x]: `${Ae}px`,
      [r.y]: `${Fe}px`
    };
  }, [V, A, B, k, r, h]), vt = x.useCallback(() => e ? {
    onPointerDown: Oe,
    onPointerMove: Le,
    onPointerUp: Be,
    onPointerCancel: Be
  } : {}, [e, Be, Le, Oe]), nt = x.useCallback(() => e ? {
    onTouchStart: Oe,
    onTouchMove: Le,
    onTouchEnd: Be,
    onTouchCancel: Be
  } : {}, [e, Be, Le, Oe]);
  return {
    swiping: k,
    swipeDirection: P,
    dragDismissed: V,
    getPointerProps: vt,
    getTouchProps: nt,
    getDragStyles: Te,
    reset: be
  };
}
const sC = Ji, lC = t0, fu = 10, Up = 0.5, Gp = 0.5, aC = 300, Yp = 4, jp = 0.2, cC = 4, cc = 80, Kp = 360, uc = 0.1, qp = 1, uC = `[${q2}]`, n0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    children: s,
    ...l
  } = e, {
    store: a
  } = hn(), {
    swipeDirection: c,
    notifyParentSwipingChange: u,
    notifyParentSwipeProgressChange: d,
    frontmostHeight: f,
    snapToSequentialPoints: p
  } = ha(), h = Q2()?.visualStateStore, b = a.useState("open"), v = a.useState("mounted"), C = a.useState("nested"), y = a.useState("nestedOpenDrawerCount"), w = a.useState("viewportElement"), R = a.useState("popupElement"), S = y > 0, E = c === "left" || c === "right" ? "horizontal" : "vertical", N = E === "vertical", T = N ? "horizontal" : "vertical", {
    snapPoints: P,
    resolvedSnapPoints: I,
    activeSnapPoint: k,
    activeSnapPointOffset: M,
    setActiveSnapPoint: D,
    popupHeight: O
  } = J2(), [V, _] = x.useState(null), A = x.useRef(void 0), L = x.useRef(null), B = ei(), G = x.useRef(!1), U = x.useRef(""), Y = x.useRef(!1), K = x.useRef(!1), j = x.useRef(null), Z = x.useMemo(() => {
    if (!P || P.length < 2 || c !== "down" && c !== "up" || I.length < 2)
      return null;
    const $ = I.map((ge) => ge.offset).filter((ge) => Number.isFinite(ge)).sort((ge, ue) => ge - ue);
    if ($.length < 2)
      return null;
    const Q = $[0], H = $[1], q = $[$.length - 1];
    let ae = H - Q;
    if (!Number.isFinite(ae) || ae <= 0) {
      const ge = q - Q;
      if (!Number.isFinite(ge) || ge <= 0)
        return null;
      ae = ge;
    }
    return {
      minOffset: Q,
      range: ae
    };
  }, [I, P, c]), te = x.useMemo(() => !Z || M === null ? null : Ut((M - Z.minOffset) / Z.range, 0, 1), [M, Z]), W = x.useMemo(() => P && P.length > 0 && (c === "down" || c === "up") ? c === "down" ? ["down", "up"] : ["up", "down"] : [c], [P, c]), X = Se(($) => {
    Zp(a.context.popupRef.current, a.context.backdropRef.current, $);
  }), ee = Se(() => {
    X(!1), a.context.popupRef.current?.removeAttribute(qn.endingStyle), _(null);
  }), le = Se(() => {
    G.current && (G.current = !1, u?.(!1));
  }), J = Se(({
    resolvedProgress: $,
    shouldTrackProgress: Q,
    notifyParent: H
  }) => {
    const q = b && !C && Q, ae = q ? $ : 0, ge = b && Q ? $ : 0;
    H && d && (d(ge), ge <= 0 && le()), h?.set({
      swipeProgress: ae,
      frontmostHeight: ae > 0 ? f : 0
    });
    const ue = a.context.backdropRef.current;
    if (ue) {
      if (!q || ae <= 0) {
        ue.style.setProperty(So.swipeProgress, "0"), ue.style.removeProperty(Qt.height);
        return;
      }
      ue.style.setProperty(So.swipeProgress, `${ae}`), f > 0 ? ue.style.setProperty(Qt.height, `${f}px`) : ue.style.removeProperty(Qt.height);
    }
  });
  function ie({
    direction: $,
    deltaX: Q,
    deltaY: H,
    velocityX: q,
    velocityY: ae,
    releaseVelocityX: ge,
    releaseVelocityY: ue
  }) {
    if (!$)
      return null;
    const Re = a.context.popupRef.current;
    if (!Re)
      return null;
    const be = $ === "left" || $ === "right" ? Re.offsetWidth : Re.offsetHeight;
    if (!Number.isFinite(be) || be <= 0)
      return null;
    const ve = $ === "left" || $ === "right" ? Q : H, me = P && P.length > 0 ? M ?? 0 : 0;
    let Ee = 0;
    $ === "down" ? Ee = me : $ === "up" && (Ee = -me);
    const Pe = Ee + ve, Me = $ === "left" || $ === "up" ? -Pe : Pe, _e = Math.max(0, be - Me);
    if (!Number.isFinite(_e) || _e <= 0)
      return null;
    const Ue = $ === "left" || $ === "right" ? ge : ue, Ye = $ === "left" || $ === "right" ? q : ae, He = Math.abs(Ue) > 0 && Number.isFinite(Ue) ? Ue : Ye, ye = $ === "left" || $ === "up" ? -He : He;
    if (!Number.isFinite(ye) || ye <= jp)
      return null;
    const Oe = Ut(ye, jp, cC), Ie = Ut(_e / Oe, cc, Kp);
    if (!Number.isFinite(Ie))
      return null;
    const Le = (Ie - cc) / (Kp - cc), Be = Ut(uc + Le * (qp - uc), uc, qp);
    return !Number.isFinite(Be) || Be <= 0 ? null : Be;
  }
  function pe($) {
    if (G.current || !$)
      return;
    const Q = $.direction ?? c, H = Q === "left" || Q === "right" ? $.deltaX : $.deltaY;
    !Number.isFinite(H) || Math.abs(H) < fu || (G.current = !0, u?.(!0));
  }
  const oe = iC({
    enabled: v && !S,
    directions: W,
    elementRef: a.context.popupRef,
    ignoreSelectorWhenTouch: !1,
    ignoreScrollableAncestors: !0,
    movementCssVars: {
      x: Qt.swipeMovementX,
      y: Qt.swipeMovementY
    },
    onSwipeStart($) {
      if ("touches" in $ || "pointerType" in $ && $.pointerType === "touch")
        return;
      const Q = a.context.popupRef.current;
      if (!Q)
        return;
      const q = et(Q).getSelection?.();
      if (!q || q.isCollapsed)
        return;
      const ae = pt(q.anchorNode) ? q.anchorNode : q.anchorNode?.parentElement, ge = pt(q.focusNode) ? q.focusNode : q.focusNode?.parentElement;
      !ze(Q, ae) && !ze(Q, ge) || q.removeAllRanges();
    },
    onSwipingChange($) {
      Xp(a.context.backdropRef.current, $), !$ && !d && le();
    },
    swipeThreshold({
      element: $,
      direction: Q
    }) {
      return Qp($, Q);
    },
    canStart($, Q) {
      const H = a.context.popupRef.current;
      if (!H)
        return !1;
      const q = H.ownerDocument, ae = Sl(q, $.x, $.y);
      if (!ae || !ze(H, ae))
        return !1;
      const ge = Q.nativeEvent;
      return !(("touches" in ge || "pointerType" in ge && ge.pointerType === "touch") && eg(q, H) || ge.type === "touchstart" && dc(ae));
    },
    onProgress($, Q) {
      pe(Q);
      const H = Q?.direction ?? oe.swipeDirection, q = H === void 0 || H === c, ae = !!(P && P.length > 0), ue = ae && (c === "down" || c === "up") || !ae || c === "left" || c === "right" || q;
      let Re = $;
      if (Z && O > 0) {
        if (Q && Number.isFinite(Q.deltaY)) {
          const be = M ?? Z.minOffset, ve = Ut(be + Q.deltaY, 0, O);
          Re = Ut((ve - Z.minOffset) / Z.range, 0, 1);
        } else if (te !== null)
          Re = te;
        else if (H === "down" || H === "up") {
          const be = $ * O, ve = M ?? Z.minOffset, me = H === "down" ? ve + be : ve - be;
          Re = Ut((me - Z.minOffset) / Z.range, 0, 1);
        }
      }
      J({
        resolvedProgress: Re,
        shouldTrackProgress: ue,
        notifyParent: !0
      });
    },
    onRelease({
      event: $,
      deltaX: Q,
      deltaY: H,
      direction: q,
      velocityX: ae,
      velocityY: ge,
      releaseVelocityX: ue,
      releaseVelocityY: Re
    }) {
      const be = {
        deltaX: Q,
        deltaY: H,
        velocityX: ae,
        velocityY: ge,
        releaseVelocityX: ue,
        releaseVelocityY: Re
      };
      function ve(nt) {
        const we = a.context.popupRef.current;
        we && (le(), X(!0), we.style.removeProperty("transition"), we.setAttribute(qn.endingStyle, ""), an.flushSync(() => {
          _(ie({
            direction: nt,
            ...be
          }));
        }));
      }
      if (!P || P.length === 0) {
        if (!q) {
          ee();
          return;
        }
        const nt = a.context.popupRef.current;
        if (!nt) {
          ee();
          return;
        }
        const we = Qp(nt, q), Ne = q === "left" || q === "right" ? Q : H;
        if (!Number.isFinite(Ne)) {
          ee();
          return;
        }
        const Ae = q === "left" || q === "up" ? -Ne : Ne;
        if (Ae <= 0)
          return ee(), !1;
        const Fe = q === "left" || q === "right" ? ae : ge;
        if ((q === "left" || q === "up" ? -Fe : Fe) >= Up && Ae > 0)
          return ve(q), !0;
        const qe = Ae > we;
        return qe ? ve(q) : ee(), qe;
      }
      if (c !== "down" && c !== "up") {
        ee();
        return;
      }
      if (!O || I.length === 0) {
        ee();
        return;
      }
      const me = c === "down" ? H : -H;
      if (!Number.isFinite(me)) {
        ee();
        return;
      }
      const Ee = Math.sign(me), Pe = c === "down" ? Re : -Re, Me = c === "down" ? ge : -ge;
      let _e = Number.isFinite(Pe) ? Pe : Me;
      if (Ee !== 0 && Math.abs(me) >= fu && Number.isFinite(_e)) {
        const nt = Math.sign(_e);
        nt !== 0 && nt !== Ee && (_e = Me);
      }
      const Ue = M ?? 0, Ye = Ut(Ue + me, 0, O), He = Number.isFinite(_e) && Math.abs(_e) >= Gp ? Ut(_e, -Yp, Yp) * aC : 0, ye = p ? Ye : Ut(Ye + He, 0, O), Oe = Ve(Us, $), Ie = () => (A.current = k, D?.(null, Oe), ve(c), !0);
      if (p) {
        const nt = [...I].sort((tt, st) => tt.offset - st.offset);
        if (nt.length === 0)
          return ee(), !1;
        let we = 0, Ne = Math.abs(Ue - nt[0].offset);
        for (let tt = 1; tt < nt.length; tt += 1) {
          const st = Math.abs(Ue - nt[tt].offset);
          st < Ne && (Ne = st, we = tt);
        }
        let Ae = nt[0];
        Ne = Math.abs(ye - Ae.offset);
        for (const tt of nt) {
          const st = Math.abs(ye - tt.offset);
          st < Ne && (Ne = st, Ae = tt);
        }
        const Fe = Math.sign(_e), Xe = Ee !== 0 && Fe !== 0 && Fe === Ee && Math.abs(_e) >= Gp;
        let qe = ye;
        if (Xe) {
          const tt = Ut(we + Ee, 0, nt.length - 1);
          if (tt !== we) {
            const st = nt[tt];
            (Ee > 0 ? ye < st.offset : ye > st.offset) && (Ae = st, qe = st.offset);
          } else if (Ee > 0)
            return Ie();
        }
        const Ge = Math.abs(qe - O), Ze = Math.abs(qe - Ae.offset);
        return Ge < Ze ? Ie() : (D?.(Ae.value, Oe), ee(), !1);
      }
      if (_e >= Up && me > 0)
        return Ie();
      let Le = I[0], Be = Math.abs(ye - Le.offset);
      for (const nt of I) {
        const we = Math.abs(ye - nt.offset);
        we < Be && (Be = we, Le = nt);
      }
      return Math.abs(ye - O) < Be ? Ie() : (D?.(Le.value, Oe), ee(), !1);
    },
    onDismiss($) {
      h?.set({
        swipeProgress: 0,
        frontmostHeight: 0
      });
      const Q = a.context.backdropRef.current;
      Q && (Q.style.setProperty(So.swipeProgress, "0"), Q.style.removeProperty(Qt.height));
      const H = Ve(Us, $);
      if (a.setOpen(!1, H), H.isCanceled) {
        const q = A.current;
        q !== void 0 && D?.(q, Ve(Us, $)), A.current = void 0, L.current?.(), ee();
        return;
      }
      if (a.select("open")) {
        const q = $;
        B.request(() => {
          if (a.select("open")) {
            const ae = A.current;
            ae !== void 0 && D?.(ae, Ve(Us, q)), A.current = void 0, ee(), L.current?.();
          } else
            A.current = void 0;
        });
        return;
      }
      A.current = void 0, X(!0);
    }
  }), re = oe.getPointerProps(), de = oe.getTouchProps(), xe = oe.reset;
  L.current = xe, x.useEffect(() => {
    const $ = w ?? R;
    if (!$)
      return;
    const Q = $, H = et(Q), q = wt(H);
    function ae(ge) {
      if (K.current)
        return;
      const ue = j.current, Re = ge.touches[0];
      if (!Re || !ue)
        return;
      const be = N ? Re.clientY - ue.lastY : Re.clientX - ue.lastX;
      if (o0(ge, q)) {
        ue.allowSwipe = !1, rr(ue, Re);
        return;
      }
      if (ge.touches.length === 2) {
        rr(ue, Re);
        return;
      }
      if (eg(H, Q) || !b || !v || S) {
        rr(ue, Re);
        return;
      }
      if (gC(ue, Re, N)) {
        rr(ue, Re);
        return;
      }
      const me = ue.scrollTarget;
      if (!me || me === H.documentElement || me === H.body) {
        ge.cancelable && ge.preventDefault(), rr(ue, Re);
        return;
      }
      if (!mC(me, E)) {
        ge.cancelable && ge.preventDefault(), rr(ue, Re);
        return;
      }
      const Pe = be;
      if (Pe !== 0) {
        const Me = bC(me, E, c, Pe);
        ue.allowSwipe ? ge.cancelable && ge.preventDefault() : ge.cancelable && Me ? (ue.allowSwipe = !0, ge.preventDefault()) : ue.allowSwipe = !1;
      }
      rr(ue, Re);
    }
    return ut(H, "touchmove", ae, {
      passive: !1,
      capture: !0
    });
  }, [v, S, b, R, N, E, c, w]), x.useEffect(() => {
    if (!Z || oe.swiping)
      return;
    J({
      resolvedProgress: !b || C ? 0 : te ?? 0,
      shouldTrackProgress: !0,
      notifyParent: !1
    });
  }, [J, f, C, d, b, te, Z, oe.swiping, a, h]), x.useEffect(() => {
    if (d)
      return b || d(0), () => {
        d(0);
      };
  }, [d, b]), x.useEffect(() => {
    b && (xe(), ee());
  }, [ee, b, xe]), x.useEffect(() => () => {
    h?.set({
      swipeProgress: 0,
      frontmostHeight: 0
    }), Xp(a.context.backdropRef.current, !1), le();
  }, [le, a, h]);
  const se = x.useMemo(() => ({
    swiping: oe.swiping,
    getDragStyles: oe.getDragStyles,
    swipeStrength: V ?? null,
    setSwipeDismissed($) {
      Zp(a.context.popupRef.current, a.context.backdropRef.current, $);
    }
  }), [a, oe.getDragStyles, oe.swiping, V]);
  function fe() {
    K.current = !1, j.current = null, U.current = "", Y.current = !1;
  }
  return /* @__PURE__ */ m(bi, {
    ref: n,
    className: o,
    render: r,
    ...en(l, {
      onPointerDown($) {
        if (U.current = $.pointerType, Y.current = $.pointerType === "pen", !b || !v || S)
          return;
        const Q = et($.currentTarget), H = Sl(Q, $.clientX, $.clientY);
        dc(H) || dC(H) || $.pointerType !== "touch" && re.onPointerDown?.($);
      },
      onPointerMove($) {
        $.pointerType !== "touch" && re.onPointerMove?.($);
      },
      onPointerUp($) {
        U.current === $.pointerType && (U.current = ""), $.pointerType !== "touch" && re.onPointerUp?.($);
      },
      onPointerCancel($) {
        U.current === $.pointerType && (U.current = ""), $.pointerType !== "touch" && re.onPointerCancel?.($);
      },
      onTouchStart($) {
        if (U.current === "pen" && Y.current) {
          Y.current = !1, K.current = !1, j.current = null;
          return;
        }
        if (!b || !v || S) {
          K.current = !1, j.current = null;
          return;
        }
        const H = $.touches[0];
        if (!H)
          return;
        if (tg($)) {
          K.current = !1, j.current = null;
          return;
        }
        const q = et($.currentTarget), ae = Sl(q, H.clientX, H.clientY);
        if (K.current = dc(ae), K.current) {
          j.current = null;
          return;
        }
        const ge = w ?? R, ue = bt($.nativeEvent), Re = pt(ue) ? ue : null;
        if (ge && Re && !ze(ge, Re)) {
          K.current = !0, j.current = null;
          return;
        }
        let be = null, ve = !1;
        ge && Re && (be = Lr(Re, ge, E), ve = Lr(Re, ge, T) != null);
        let me = null;
        be && (me = hC(be, E, c) ? null : !1), j.current = {
          startX: H.clientX,
          startY: H.clientY,
          lastX: H.clientX,
          lastY: H.clientY,
          scrollTarget: be,
          hasCrossAxisScrollableContent: ve,
          allowSwipe: me,
          preserveNativeCrossAxisScroll: !1
        }, de.onTouchStart?.($);
      },
      onTouchMove($) {
        if (K.current || tg($))
          return;
        const Q = j.current;
        Q?.preserveNativeCrossAxisScroll || Q?.allowSwipe === !1 || Q?.scrollTarget != null && !Q.allowSwipe || de.onTouchMove?.($);
      },
      onTouchEnd($) {
        fe(), de.onTouchEnd?.($);
      },
      onTouchCancel($) {
        fe(), de.onTouchCancel?.($);
      },
      // Drawer popups use drawer-specific nested state attributes.
      // Suppress DialogViewport's generic nested dialog attribute.
      "data-nested-dialog-open": void 0
    }),
    children: /* @__PURE__ */ m(rf.Provider, {
      value: se,
      children: s
    })
  });
});
process.env.NODE_ENV !== "production" && (n0.displayName = "DrawerViewport");
function Zp(t, e, n) {
  if (n) {
    t?.setAttribute(Wn.swipeDismiss, ""), e?.setAttribute(Wn.swipeDismiss, "");
    return;
  }
  t?.removeAttribute(Wn.swipeDismiss), e?.removeAttribute(Wn.swipeDismiss);
}
function Xp(t, e) {
  if (t) {
    if (e) {
      t.setAttribute(Wn.swiping, "");
      return;
    }
    t.removeAttribute(Wn.swiping);
  }
}
function dc(t) {
  return !!t?.closest(Ch);
}
function dC(t) {
  return !!t?.closest(uC);
}
function Qp(t, e) {
  const n = e === "left" || e === "right" ? t.offsetWidth : t.offsetHeight;
  return Math.max(n * 0.5, fu);
}
function Jp(t, e) {
  return t instanceof e.HTMLInputElement && t.type === "range";
}
function fC(t) {
  return pt(t) ? t.tagName === "INPUT" || t.tagName === "TEXTAREA" : !1;
}
function pC(t, e) {
  const n = pt(t.anchorNode) ? t.anchorNode : t.anchorNode?.parentElement, o = pt(t.focusNode) ? t.focusNode : t.focusNode?.parentElement;
  return t.containsNode(e, !0) || ze(e, n) || ze(e, o);
}
function eg(t, e) {
  const n = Gt(t);
  if (!!(n && ze(e, n)) && fC(n)) {
    const {
      selectionStart: i,
      selectionEnd: s
    } = n;
    if (i != null && s != null && i < s)
      return !0;
  }
  const r = t.getSelection?.();
  return !r || r.isCollapsed ? !1 : pC(r, e);
}
function o0(t, e) {
  const n = t.composedPath();
  return n ? n.some((o) => Jp(o, e)) : Jp(bt(t), e);
}
function tg(t) {
  return o0(t.nativeEvent, wt(t.currentTarget));
}
function rr(t, e) {
  t.lastX = e.clientX, t.lastY = e.clientY;
}
function gC(t, e, n) {
  if (t.preserveNativeCrossAxisScroll)
    return !0;
  if (t.allowSwipe === !0 || !t.hasCrossAxisScrollableContent)
    return !1;
  const o = n ? e.clientY - t.startY : e.clientX - t.startX, r = n ? e.clientX - t.startX : e.clientY - t.startY, i = Math.abs(o), s = Math.abs(r);
  return s < 6 || s <= i + 2 ? !1 : (t.preserveNativeCrossAxisScroll = !0, !0);
}
function mC(t, e) {
  return e === "vertical" ? t.scrollHeight > t.clientHeight : t.scrollWidth > t.clientWidth;
}
function r0(t, e) {
  if (e === "vertical") {
    const o = Math.max(0, t.scrollHeight - t.clientHeight);
    return {
      offset: t.scrollTop,
      max: o
    };
  }
  const n = Math.max(0, t.scrollWidth - t.clientWidth);
  return {
    offset: t.scrollLeft,
    max: n
  };
}
function hC(t, e, n) {
  const {
    offset: o,
    max: r
  } = r0(t, e), i = i0(n, e);
  return i === null ? !1 : i ? o <= 0 : o >= r;
}
function bC(t, e, n, o) {
  const {
    offset: r,
    max: i
  } = r0(t, e), s = i0(n, e);
  return s === null || !(s ? o > 0 : o < 0) ? !1 : s ? r <= 0 : r >= i;
}
function i0(t, e) {
  return e === "vertical" ? t === "down" ? !0 : t === "up" ? !1 : null : t === "right" ? !0 : t === "left" ? !1 : null;
}
const s0 = mo({
  responsive: !0,
  side: "right",
  isBottomSheet: !1
}), vC = ce(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface-scrim", "transition-opacity", "duration-200", "data-ending-style:opacity-0", "data-starting-style:opacity-0"]), yC = ce(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "flex", "pointer-events-none"], {
  variants: {
    side: {
      left: "justify-start",
      right: "justify-end"
    },
    isBottomSheet: {
      false: null,
      true: "items-end justify-center"
    },
    responsive: {
      false: null,
      true: "max-[904px]:items-end max-[904px]:justify-center"
    }
  }
}), xC = ce(["pointer-events-auto", "flex", "h-dvh", "max-h-dvh", "min-w-0", "flex-col", "overflow-hidden", "border", "border-outline-subtle", "bg-surface", "text-text-default", "shadow-elevation-4", "outline-none", "transition-transform", "duration-200", "ease-out"], {
  variants: {
    size: {
      default: ["[--drawer-size:640px]", "w-[min(100vw,var(--drawer-size))]"],
      small: ["[--drawer-size:560px]", "w-[min(100vw,var(--drawer-size))]"]
    },
    side: {
      left: ["data-ending-style:-translate-x-full", "data-starting-style:-translate-x-full"],
      right: ["data-ending-style:translate-x-full", "data-starting-style:translate-x-full"]
    },
    contentVariant: {
      default: null,
      navigation: "border-0"
    },
    isBottomSheet: {
      false: null,
      true: ["h-auto", "min-h-[230px]", "max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "w-full", "rounded-t-(--radius-sm)", "data-ending-style:translate-x-0", "data-ending-style:translate-y-full", "data-starting-style:translate-x-0", "data-starting-style:translate-y-full"]
    },
    responsive: {
      false: null,
      true: ["max-[904px]:h-auto", "max-[904px]:min-h-[230px]", "max-[904px]:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-[904px]:w-full", "max-[904px]:rounded-t-(--radius-sm)", "max-[904px]:data-ending-style:translate-x-0", "max-[904px]:data-ending-style:translate-y-full", "max-[904px]:data-starting-style:translate-x-0", "max-[904px]:data-starting-style:translate-y-full"]
    }
  },
  defaultVariants: {
    size: "default"
  }
}), CC = ce(["flex", "min-h-0", "flex-1", "flex-col", "overflow-hidden", "bg-surface"], {
  variants: {
    variant: {
      default: ["gap-(--spacing-16)", "pt-(--spacing-10)"],
      navigation: ["gap-0", "pt-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), wC = ce(["flex", "shrink-0", "items-start", "justify-between", "gap-(--spacing-2)", "bg-surface", "mx-(--spacing-10)", "p-(--spacing-8)"]), SC = ce(["flex", "min-w-0", "flex-1", "items-start", "gap-(--spacing-8)"]), RC = ce(["flex", "min-w-0", "flex-1", "flex-col", "gap-(--spacing-4)"]), EC = ce(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), NC = ce(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), kC = ce(["min-h-0", "flex-1", "overflow-y-auto", "px-(--spacing-20)", "max-[904px]:pb-[env(safe-area-inset-bottom)]"]), MC = ce(["flex", "flex-col"], {
  variants: {
    gap: {
      none: "gap-0",
      md: "gap-(--spacing-20)"
    }
  },
  defaultVariants: {
    gap: "md"
  }
}), IC = ce(["flex", "min-h-(--spacing-80)", "shrink-0", "items-center", "justify-end", "gap-(--spacing-10)", "border-t", "border-outline-subtle", "bg-surface", "px-(--spacing-20)", "py-(--spacing-16)", "max-[904px]:pb-[calc(var(--spacing-16)_+_env(safe-area-inset-bottom))]"]);
function PC(t) {
  const e = z.c(19);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r, i, s;
  e[3] !== o ? ({
    side: i,
    responsive: s,
    ...r
  } = o, e[3] = o, e[4] = r, e[5] = i, e[6] = s) : (r = e[4], i = e[5], s = e[6]);
  const l = i === void 0 ? "right" : i, a = s === void 0 ? !0 : s;
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = {
    defaultMatches: !1
  }, e[7] = c) : c = e[7];
  const u = Es("(max-width: 904px)", c), d = a && u;
  let f;
  e[8] !== d || e[9] !== a || e[10] !== l ? (f = {
    responsive: a,
    side: l,
    isBottomSheet: d
  }, e[8] = d, e[9] = a, e[10] = l, e[11] = f) : f = e[11];
  const p = d ? "down" : l === "left" ? "left" : "right";
  let g;
  e[12] !== n || e[13] !== r || e[14] !== p ? (g = /* @__PURE__ */ m(Kx, { modal: !0, swipeDirection: p, ...r, children: n }), e[12] = n, e[13] = r, e[14] = p, e[15] = g) : g = e[15];
  let h;
  return e[16] !== f || e[17] !== g ? (h = /* @__PURE__ */ m(s0, { value: f, children: g }), e[16] = f, e[17] = g, e[18] = h) : h = e[18], h;
}
function PO(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(lC, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function TC(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m(K2, { ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function OC(t) {
  const e = z.c(33);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    size: r,
    contentVariant: i,
    initialFocus: s,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "default" : i, a = s === void 0 ? !0 : s, c = qt(), {
    responsive: u,
    side: d,
    isBottomSheet: f
  } = gn(s0);
  let p;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ m(j2, { className: ne(vC()) }), e[6] = p) : p = e[6];
  let g;
  e[7] !== f || e[8] !== u || e[9] !== d ? (g = ne(yC({
    responsive: u,
    side: d,
    isBottomSheet: f
  })), e[7] = f, e[8] = u, e[9] = d, e[10] = g) : g = e[10];
  let h;
  e[11] !== l || e[12] !== f || e[13] !== u || e[14] !== d || e[15] !== r ? (h = ne(xC({
    responsive: u,
    size: r,
    side: d,
    isBottomSheet: f,
    contentVariant: l
  })), e[11] = l, e[12] = f, e[13] = u, e[14] = d, e[15] = r, e[16] = h) : h = e[16];
  let b;
  e[17] !== l ? (b = ne(CC({
    variant: l
  })), e[17] = l, e[18] = b) : b = e[18];
  let v;
  e[19] !== n || e[20] !== b ? (v = /* @__PURE__ */ m(Z2, { className: b, children: n }), e[19] = n, e[20] = b, e[21] = v) : v = e[21];
  let C;
  e[22] !== a || e[23] !== o || e[24] !== h || e[25] !== v ? (C = /* @__PURE__ */ m(e0, { "aria-modal": "true", initialFocus: a, className: h, ...o, children: v }), e[22] = a, e[23] = o, e[24] = h, e[25] = v, e[26] = C) : C = e[26];
  let y;
  e[27] !== g || e[28] !== C ? (y = /* @__PURE__ */ m(n0, { className: g, children: C }), e[27] = g, e[28] = C, e[29] = y) : y = e[29];
  let w;
  return e[30] !== c || e[31] !== y ? (w = /* @__PURE__ */ F($x, { container: c, children: [
    p,
    y
  ] }), e[30] = c, e[31] = y, e[32] = w) : w = e[32], w;
}
function TO(t) {
  const e = z.c(36);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    title: a,
    subtitle: s,
    leadingIcon: r,
    accessory: n,
    actions: o,
    closeLabel: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "Close drawer" : l;
  let u;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = ne(wC()), e[8] = u) : u = e[8];
  let d;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = ne(SC()), e[9] = d) : d = e[9];
  let f;
  e[10] !== r ? (f = r && /* @__PURE__ */ m("span", { className: "mt-(--spacing-4) inline-flex shrink-0 text-icon-main", children: /* @__PURE__ */ m(Ke, { name: r, size: "sm", tone: "inherit" }) }), e[10] = r, e[11] = f) : f = e[11];
  let p;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ne(RC()), e[12] = p) : p = e[12];
  let g;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = ne(EC()), e[13] = g) : g = e[13];
  let h;
  e[14] !== a ? (h = /* @__PURE__ */ m(sC, { className: g, children: a }), e[14] = a, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-8)", children: [
    h,
    n
  ] }), e[16] = n, e[17] = h, e[18] = b) : b = e[18];
  let v;
  e[19] !== s ? (v = s && /* @__PURE__ */ m(Vx, { className: ne(NC()), children: s }), e[19] = s, e[20] = v) : v = e[20];
  let C;
  e[21] !== b || e[22] !== v ? (C = /* @__PURE__ */ F("div", { className: p, children: [
    b,
    v
  ] }), e[21] = b, e[22] = v, e[23] = C) : C = e[23];
  let y;
  e[24] !== C || e[25] !== f ? (y = /* @__PURE__ */ F("div", { className: d, children: [
    f,
    C
  ] }), e[24] = C, e[25] = f, e[26] = y) : y = e[26];
  let w;
  e[27] !== c ? (w = /* @__PURE__ */ m(K2, { render: /* @__PURE__ */ m(mt, { icon: "x-close", "aria-label": c, variant: "ghost", size: "md" }) }), e[27] = c, e[28] = w) : w = e[28];
  let R;
  e[29] !== o || e[30] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-8)", children: [
    o,
    w
  ] }), e[29] = o, e[30] = w, e[31] = R) : R = e[31];
  let S;
  return e[32] !== i || e[33] !== y || e[34] !== R ? (S = /* @__PURE__ */ F("div", { className: u, ...i, children: [
    y,
    R
  ] }), e[32] = i, e[33] = y, e[34] = R, e[35] = S) : S = e[35], S;
}
function OO(t) {
  const e = z.c(13);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    gap: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = ne(kC()), e[4] = i) : i = e[4];
  let s;
  e[5] !== o ? (s = ne(MC({
    gap: o
  })), e[5] = o, e[6] = s) : s = e[6];
  let l;
  e[7] !== n || e[8] !== s ? (l = /* @__PURE__ */ m("div", { className: s, children: n }), e[7] = n, e[8] = s, e[9] = l) : l = e[9];
  let a;
  return e[10] !== r || e[11] !== l ? (a = /* @__PURE__ */ m("div", { className: i, ...r, children: l }), e[10] = r, e[11] = l, e[12] = a) : a = e[12], a;
}
function DO(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = ne(IC()), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { className: r, ...o, children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
const ks = mo({
  collapsed: !1
});
function l0() {
  return gn(ks);
}
const DC = ce(["flex", "h-full", "min-h-0", "flex-col", "bg-surface", "border-r", "border-outline-subtle", "text-menu-text-default", "transition-[width]", "duration-200", "ease-in-out", "overflow-hidden"], {
  variants: {
    collapsed: {
      false: null,
      true: null
    },
    inAppShell: {
      false: null,
      true: ["relative", "z-10", "w-(--app-shell-sidebar-width)", "data-[hover-expanded]:w-(--app-shell-sidebar-expanded-width)"]
    }
  },
  compoundVariants: [{
    collapsed: !1,
    inAppShell: !1,
    className: "w-[260px]"
  }, {
    collapsed: !0,
    inAppShell: !1,
    className: "w-[72px]"
  }]
}), VC = ce("sticky bottom-0 z-10 mt-auto flex shrink-0 bg-surface", {
  variants: {
    collapsed: {
      false: "w-full",
      true: "w-(--spacing-40) justify-center"
    }
  }
}), lf = ce(["group/sidebar-item", "relative", "inline-flex", "items-center", "border-0", "rounded-[var(--radius-sm)]", "text-left", "no-underline", "outline-none", "select-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "font-[family-name:var(--font-family-label)]", "font-[number:var(--font-weight-medium)]", "text-[length:var(--font-size-label-large)]", "leading-[var(--font-line-height-24)]", "tracking-[var(--font-letter-spacing-default)]", "text-menu-icon-default", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "focus-visible:ring-2", "focus-visible:ring-inset", "focus-visible:ring-menu-focus-ring", "disabled:cursor-not-allowed", "disabled:opacity-50", "disabled:pointer-events-none"], {
  variants: {
    collapsed: {
      false: ["h-(--spacing-40)", "w-full", "min-w-0", "justify-between", "gap-[var(--spacing-8)]", "px-(--spacing-10)", "py-[var(--spacing-12)]"],
      true: ["size-(--spacing-40)", "justify-center", "p-(--spacing-10)"]
    },
    selected: {
      false: "bg-transparent",
      true: ["bg-menu-item-selected", "text-menu-text-default", "hover:bg-menu-item-selected"]
    },
    variant: {
      item: "",
      subItem: ""
    }
  },
  compoundVariants: [{
    selected: !0,
    variant: "item",
    className: ["before:absolute", "before:left-[-16px]", "before:top-1/2", "before:h-(--spacing-24)", "before:w-[2px]", "before:-translate-y-1/2", "before:bg-primary", "before:rounded-r-[2px]", "before:content-['']"]
  }]
}), _C = ce(["overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "opacity-100", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:opacity-0", "transition-[height,opacity]", "duration-200", "ease-out", "motion-reduce:transition-none"]), AC = "flex size-(--icon-sm) shrink-0 items-center justify-center", LC = ["pointer-events-none", "absolute", "left-[-16px]", "top-1/2", "h-(--spacing-24)", "w-[2px]", "-translate-y-1/2", "rounded-r-[2px]", "bg-primary"].join(" ");
function VO(t) {
  const e = z.c(64);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    collapsed: a,
    "aria-label": c,
    children: n,
    onMouseEnter: i,
    onMouseLeave: s,
    mobileHeaderLeading: r,
    mobileHeaderActions: o,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = a === void 0 ? !1 : a, d = c === void 0 ? "Main navigation" : c, f = qd(), [p, g] = ot(!1), h = ft(!1), b = ft(!1), v = f?.desktopSidebarCollapsed ?? u, C = ft(v), y = f?.isMobile ?? !1, w = !y && v && !p;
  let R, S;
  e[9] !== v ? (R = () => {
    v ? !C.current && v && h.current && (b.current = !0, g(!1)) : (g(!1), b.current = !1), C.current = v;
  }, S = [v], e[9] = v, e[10] = R, e[11] = S) : (R = e[10], S = e[11]), kt(R, S);
  let E;
  e[12] !== f || e[13] !== y ? (E = y ? () => f?.setMobileNavigationOpen(!1) : void 0, e[12] = f, e[13] = y, e[14] = E) : E = e[14];
  let N;
  e[15] !== w || e[16] !== E ? (N = {
    collapsed: w,
    closeMobileNavigation: E
  }, e[15] = w, e[16] = E, e[17] = N) : N = e[17];
  const T = w ? "" : void 0, P = p ? "" : void 0, I = !!f;
  let k;
  e[18] !== w || e[19] !== I ? (k = DC({
    collapsed: w,
    inAppShell: I
  }), e[18] = w, e[19] = I, e[20] = k) : k = e[20];
  const M = `${k}${y ? " w-full border-r-0" : ""}`;
  let D;
  e[21] !== i || e[22] !== v ? (D = (X) => {
    i?.(X), h.current = !0, v && !b.current && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget)) && g(!0);
  }, e[21] = i, e[22] = v, e[23] = D) : D = e[23];
  let O;
  e[24] !== s || e[25] !== v ? (O = (X) => {
    s?.(X), h.current = !1;
    const ee = b.current;
    if (b.current = !1, v && (!(X.relatedTarget instanceof Node) || !X.currentTarget.contains(X.relatedTarget))) {
      if (ee) {
        g(!1);
        return;
      }
      g(!1);
    }
  }, e[24] = s, e[25] = v, e[26] = O) : O = e[26];
  let V;
  e[27] !== f || e[28] !== y ? (V = f && !y && /* @__PURE__ */ m("div", { className: "shrink-0 px-(--spacing-16) pt-(--spacing-24)", children: /* @__PURE__ */ m(Sx, {}) }), e[27] = f, e[28] = y, e[29] = V) : V = e[29];
  let _;
  e[30] !== n ? (_ = /* @__PURE__ */ m("div", { className: "min-h-0 flex-1 overflow-y-auto overscroll-contain", "data-slot": "sidebar-navigation", children: /* @__PURE__ */ m("div", { className: "flex min-h-full flex-col gap-(--spacing-8) px-(--spacing-16) py-(--spacing-16)", children: n }) }), e[30] = n, e[31] = _) : _ = e[31];
  let A;
  e[32] !== d || e[33] !== l || e[34] !== M || e[35] !== D || e[36] !== O || e[37] !== V || e[38] !== _ || e[39] !== T || e[40] !== P ? (A = /* @__PURE__ */ F("nav", { ...l, "aria-label": d, "data-collapsed": T, "data-hover-expanded": P, className: M, "data-slot": "sidebar", onMouseEnter: D, onMouseLeave: O, children: [
    V,
    _
  ] }), e[32] = d, e[33] = l, e[34] = M, e[35] = D, e[36] = O, e[37] = V, e[38] = _, e[39] = T, e[40] = P, e[41] = A) : A = e[41];
  let L;
  e[42] !== A || e[43] !== N ? (L = /* @__PURE__ */ m(ks, { value: N, children: A }), e[42] = A, e[43] = N, e[44] = L) : L = e[44];
  const B = L;
  if (!y || !f)
    return B;
  let G;
  e[45] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = {
    width: "75vw"
  }, e[45] = G) : G = e[45];
  let U;
  e[46] !== r ? (U = /* @__PURE__ */ m("div", { className: "min-w-0", children: r }), e[46] = r, e[47] = U) : U = e[47];
  let Y;
  e[48] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Y = /* @__PURE__ */ m(TC, { render: /* @__PURE__ */ m(mt, { "aria-label": "Close navigation", icon: "x-close", variant: "outline" }) }), e[48] = Y) : Y = e[48];
  let K;
  e[49] !== o ? (K = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-12)", children: [
    o,
    Y
  ] }), e[49] = o, e[50] = K) : K = e[50];
  let j;
  e[51] !== U || e[52] !== K ? (j = /* @__PURE__ */ F("div", { className: "flex h-[68px] shrink-0 items-center justify-between gap-(--spacing-12) border-b border-outline-subtle bg-surface px-(--spacing-24)", children: [
    U,
    K
  ] }), e[51] = U, e[52] = K, e[53] = j) : j = e[53];
  let Z;
  e[54] !== B ? (Z = /* @__PURE__ */ m("div", { className: "min-h-0 flex-1", children: B }), e[54] = B, e[55] = Z) : Z = e[55];
  let te;
  e[56] !== d || e[57] !== j || e[58] !== Z ? (te = /* @__PURE__ */ F(OC, { "aria-label": d, contentVariant: "navigation", style: G, children: [
    j,
    Z
  ] }), e[56] = d, e[57] = j, e[58] = Z, e[59] = te) : te = e[59];
  let W;
  return e[60] !== f.mobileNavigationOpen || e[61] !== f.setMobileNavigationOpen || e[62] !== te ? (W = /* @__PURE__ */ m(PC, { open: f.mobileNavigationOpen, onOpenChange: f.setMobileNavigationOpen, responsive: !1, side: "left", children: te }), e[60] = f.mobileNavigationOpen, e[61] = f.setMobileNavigationOpen, e[62] = te, e[63] = W) : W = e[63], W;
}
function _O(t) {
  const e = z.c(9);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  const {
    collapsed: r
  } = gn(ks);
  let i;
  e[3] !== r ? (i = VC({
    collapsed: r
  }), e[3] = r, e[4] = i) : i = e[4];
  let s;
  return e[5] !== n || e[6] !== o || e[7] !== i ? (s = /* @__PURE__ */ m("div", { ...o, className: i, "data-slot": "sidebar-footer", children: n }), e[5] = n, e[6] = o, e[7] = i, e[8] = s) : s = e[8], s;
}
function FC(t) {
  const e = z.c(6), {
    leading: n
  } = t;
  if (!n)
    return null;
  if (n.type === "icon") {
    let i;
    return e[0] !== n.name ? (i = /* @__PURE__ */ m(Ke, { name: n.name, size: "sm", tone: "inherit", "aria-hidden": !0, "data-slot": "sidebar-item-icon" }), e[0] = n.name, e[1] = i) : i = e[1], i;
  }
  const o = n.variant ?? "external";
  let r;
  return e[2] !== n.initials || e[3] !== n.src || e[4] !== o ? (r = /* @__PURE__ */ m(Gr, { initials: n.initials, size: "xs", src: n.src, variant: o }), e[2] = n.initials, e[3] = n.src, e[4] = o, e[5] = r) : r = e[5], r;
}
function af(t) {
  const e = z.c(21), {
    label: n,
    leading: o,
    badge: r,
    selected: i,
    variant: s,
    collapsed: l,
    trailing: a
  } = t, c = i === void 0 ? !1 : i, u = s === void 0 ? "item" : s;
  let d;
  e[0] !== o || e[1] !== c || e[2] !== u ? (d = u === "subItem" ? /* @__PURE__ */ m("span", { "aria-hidden": !0, className: AC, "data-slot": "sidebar-item-dot", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "relative z-[2] size-(--icon-sm)", viewBox: "0 0 20 20", children: [
    /* @__PURE__ */ m("title", { children: "Sub-navigation item indicator" }),
    /* @__PURE__ */ m("circle", { className: c ? "fill-primary-on-container" : "fill-outline-subtle", cx: "10", cy: "10", "data-slot": "sidebar-item-dot-indicator", r: "2" })
  ] }) }) : /* @__PURE__ */ m(FC, { leading: o }), e[0] = o, e[1] = c, e[2] = u, e[3] = d) : d = e[3];
  let f;
  e[4] !== l || e[5] !== n ? (f = !l && /* @__PURE__ */ m("span", { className: "min-w-0 truncate", "data-slot": "sidebar-item-label", title: n, children: n }), e[4] = l, e[5] = n, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-[var(--spacing-8)]", children: [
    d,
    f
  ] }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let g;
  e[10] !== r || e[11] !== l ? (g = !l && r && /* @__PURE__ */ m("span", { className: "ml-auto shrink-0", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ m(au, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[10] = r, e[11] = l, e[12] = g) : g = e[12];
  const h = !l && a;
  let b;
  e[13] !== r || e[14] !== l ? (b = l && r && /* @__PURE__ */ m("span", { className: "absolute right-(--spacing-2) top-(--spacing-2)", "data-slot": "sidebar-item-badge", children: /* @__PURE__ */ m(au, { count: r.count, tone: r.tone, "aria-label": r.label }) }), e[13] = r, e[14] = l, e[15] = b) : b = e[15];
  let v;
  return e[16] !== p || e[17] !== g || e[18] !== h || e[19] !== b ? (v = /* @__PURE__ */ F(zt, { children: [
    p,
    g,
    h,
    b
  ] }), e[16] = p, e[17] = g, e[18] = h, e[19] = b, e[20] = v) : v = e[20], v;
}
function Rl(t) {
  const e = z.c(24), {
    collapsed: n,
    closeMobileNavigation: o
  } = gn(ks);
  let r, i, s, l, a, c, u;
  if (e[0] !== o || e[1] !== n || e[2] !== t) {
    const {
      itemId: h,
      label: b,
      leading: v,
      selected: C,
      badge: y,
      tooltip: w,
      variant: R,
      collapsed: S,
      ...E
    } = t;
    i = b, u = w;
    const N = C === void 0 ? !1 : C, T = R === void 0 ? "item" : R;
    r = S === void 0 ? n : S;
    const P = lf({
      collapsed: r,
      selected: N,
      variant: T
    });
    let I;
    e[10] !== y || e[11] !== r || e[12] !== i || e[13] !== v || e[14] !== N || e[15] !== T ? (I = /* @__PURE__ */ m(af, { label: i, leading: v, badge: y, selected: N, variant: T, collapsed: r }), e[10] = y, e[11] = r, e[12] = i, e[13] = v, e[14] = N, e[15] = T, e[16] = I) : I = e[16];
    const k = I, {
      render: M,
      href: D,
      target: O,
      rel: V,
      onClick: _,
      ...A
    } = E;
    if (D === void 0 && M === void 0)
      throw new Error("SidebarItem requires either an href or render prop.");
    const L = O === "_blank" && !V ? "noopener noreferrer" : V;
    c = Jd, s = "a", l = M, a = en(A, {
      ...D !== void 0 && {
        href: D
      },
      ...O !== void 0 && {
        target: O
      },
      ...L !== void 0 && {
        rel: L
      },
      onClick: (B) => {
        _?.(B), o?.();
      },
      "data-sidebar-item": h,
      "aria-label": i,
      "aria-current": N ? "page" : void 0,
      className: P,
      children: k
    }), e[0] = o, e[1] = n, e[2] = t, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[17] !== s || e[18] !== l || e[19] !== a ? (d = {
    defaultTagName: s,
    render: l,
    props: a
  }, e[17] = s, e[18] = l, e[19] = a, e[20] = d) : d = e[20];
  const f = c(d);
  if (!r || u === !1)
    return f;
  const p = u ?? i;
  let g;
  return e[21] !== f || e[22] !== p ? (g = /* @__PURE__ */ m(qo, { label: p, side: "right", align: "center", children: f }), e[21] = f, e[22] = p, e[23] = g) : g = e[23], g;
}
function $C(t) {
  const e = z.c(34);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    label: i,
    leading: s,
    selected: c,
    badge: n,
    tooltip: u,
    collapsed: o,
    hasSelectedChild: r,
    open: l,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = c === void 0 ? !1 : c, f = d ? "page" : void 0;
  let p;
  e[10] !== o || e[11] !== d ? (p = lf({
    collapsed: o,
    selected: d,
    variant: "item"
  }), e[10] = o, e[11] = d, e[12] = p) : p = e[12];
  let g;
  e[13] !== r ? (g = r && /* @__PURE__ */ m("span", { "aria-hidden": !0, className: LC, "data-slot": "sidebar-group-current-indicator" }), e[13] = r, e[14] = g) : g = e[14];
  const h = l ? "chevron-up" : "chevron-down";
  let b;
  e[15] !== h ? (b = /* @__PURE__ */ m(Ke, { name: h, size: "xs", tone: "secondary", "aria-hidden": !0 }), e[15] = h, e[16] = b) : b = e[16];
  let v;
  e[17] !== n || e[18] !== o || e[19] !== i || e[20] !== s || e[21] !== d || e[22] !== b ? (v = /* @__PURE__ */ m(af, { label: i, leading: s, badge: n, selected: d, collapsed: o, trailing: b }), e[17] = n, e[18] = o, e[19] = i, e[20] = s, e[21] = d, e[22] = b, e[23] = v) : v = e[23];
  let C;
  e[24] !== i || e[25] !== a || e[26] !== f || e[27] !== p || e[28] !== g || e[29] !== v ? (C = /* @__PURE__ */ F("button", { ...a, "aria-label": i, "aria-current": f, className: p, type: "button", children: [
    g,
    v
  ] }), e[24] = i, e[25] = a, e[26] = f, e[27] = p, e[28] = g, e[29] = v, e[30] = C) : C = e[30];
  const y = C;
  if (!o || u === !1)
    return y;
  const w = u ?? i;
  let R;
  return e[31] !== y || e[32] !== w ? (R = /* @__PURE__ */ m(qo, { label: w, side: "right", align: "center", children: y }), e[31] = y, e[32] = w, e[33] = R) : R = e[33], R;
}
function HC(t) {
  const e = z.c(3), {
    children: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m("span", { "aria-hidden": !0, className: "pointer-events-none absolute top-[24px] bottom-[20px] left-(--spacing-10) z-[1] w-(--icon-sm)", "data-slot": "sidebar-group-connector", children: /* @__PURE__ */ F("svg", { "aria-hidden": !0, className: "size-full", preserveAspectRatio: "none", viewBox: "0 0 20 100", children: [
    /* @__PURE__ */ m("title", { children: "Sub-navigation connector" }),
    /* @__PURE__ */ m("line", { className: "stroke-outline-subtle", vectorEffect: "non-scaling-stroke", x1: "10", x2: "10", y1: "0", y2: "100" })
  ] }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("div", { className: "relative flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-group-items", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function zC(t) {
  const e = z.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m("div", { className: "flex flex-col gap-[var(--spacing-4)] pt-[var(--spacing-4)]", "data-slot": "sidebar-static-group-items", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function BC(t) {
  const e = z.c(13), {
    label: n,
    leading: o,
    badge: r,
    tooltip: i,
    collapsed: s
  } = t;
  let l;
  e[0] !== s ? (l = lf({
    collapsed: s,
    selected: !1,
    variant: "item"
  }), e[0] = s, e[1] = l) : l = e[1];
  const a = `${l} !cursor-default hover:bg-transparent active:bg-transparent`;
  let c;
  e[2] !== r || e[3] !== s || e[4] !== n || e[5] !== o ? (c = /* @__PURE__ */ m(af, { label: n, leading: o, badge: r, collapsed: s }), e[2] = r, e[3] = s, e[4] = n, e[5] = o, e[6] = c) : c = e[6];
  let u;
  e[7] !== a || e[8] !== c ? (u = /* @__PURE__ */ m("div", { className: a, children: c }), e[7] = a, e[8] = c, e[9] = u) : u = e[9];
  const d = u;
  if (!s || i === !1)
    return d;
  const f = i ?? n;
  let p;
  return e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ m(qo, { label: f, side: "right", align: "center", children: d }), e[10] = d, e[11] = f, e[12] = p) : p = e[12], p;
}
function ng(t) {
  const e = z.c(35), {
    itemId: n,
    label: o,
    leading: r,
    selected: i,
    hasSelectedChild: s,
    badge: l,
    tooltip: a,
    collapsed: c,
    collapsible: u,
    open: d,
    defaultOpen: f,
    onOpenChange: p,
    children: g
  } = t, h = i === void 0 ? !1 : i, b = s === void 0 ? !1 : s, v = u === void 0 ? !0 : u, C = f === void 0 ? !1 : f, {
    collapsed: y
  } = gn(ks), w = c ?? y, [R, S] = ot(C), E = d !== void 0, N = E ? d : R;
  let T;
  e[0] !== E || e[1] !== p ? (T = function(A) {
    E || S(A), p?.(A);
  }, e[0] = E, e[1] = p, e[2] = T) : T = e[2];
  const P = T;
  let I;
  e[3] !== l || e[4] !== w || e[5] !== b || e[6] !== o || e[7] !== r || e[8] !== N || e[9] !== h || e[10] !== a ? (I = /* @__PURE__ */ m($C, { label: o, leading: r, selected: h, hasSelectedChild: b, badge: l, tooltip: a, collapsed: w, open: N }), e[3] = l, e[4] = w, e[5] = b, e[6] = o, e[7] = r, e[8] = N, e[9] = h, e[10] = a, e[11] = I) : I = e[11];
  const k = I;
  if (!v) {
    let _;
    e[12] !== l || e[13] !== w || e[14] !== o || e[15] !== r || e[16] !== a ? (_ = /* @__PURE__ */ m(BC, { label: o, leading: r, badge: l, tooltip: a, collapsed: w }), e[12] = l, e[13] = w, e[14] = o, e[15] = r, e[16] = a, e[17] = _) : _ = e[17];
    let A;
    e[18] !== g ? (A = /* @__PURE__ */ m(zC, { children: g }), e[18] = g, e[19] = A) : A = e[19];
    let L;
    return e[20] !== n || e[21] !== _ || e[22] !== A ? (L = /* @__PURE__ */ F("div", { "data-sidebar-group": n, children: [
      _,
      A
    ] }), e[20] = n, e[21] = _, e[22] = A, e[23] = L) : L = e[23], L;
  }
  let M;
  e[24] !== k ? (M = /* @__PURE__ */ m(Bl, { render: k }), e[24] = k, e[25] = M) : M = e[25];
  let D;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = _C(), e[26] = D) : D = e[26];
  let O;
  e[27] !== g ? (O = /* @__PURE__ */ m(Qd, { className: D, "data-slot": "sidebar-group-panel", children: /* @__PURE__ */ m(HC, { children: g }) }), e[27] = g, e[28] = O) : O = e[28];
  let V;
  return e[29] !== P || e[30] !== n || e[31] !== N || e[32] !== M || e[33] !== O ? (V = /* @__PURE__ */ F(Xd, { "data-sidebar-group": n, open: N, onOpenChange: P, children: [
    M,
    O
  ] }), e[29] = P, e[30] = n, e[31] = N, e[32] = M, e[33] = O, e[34] = V) : V = e[34], V;
}
const WC = ["flex", "h-(--spacing-64)", "w-full", "items-center", "bg-surface", "border-b", "border-outline-subtle", "max-[599px]:h-[68px]"], UC = ["flex", "h-full", "min-w-0", "shrink-0", "transition-[width]", "duration-200", "ease-in-out", "items-center", "border-r", "border-outline-subtle", "px-(--spacing-16)", "max-[599px]:border-r-0", "max-[599px]:px-(--spacing-24)"], GC = ["hidden", "h-full", "min-w-0", "flex-1", "items-center", "overflow-hidden", "px-(--spacing-24)", "min-[600px]:flex"], YC = ["ml-auto", "flex", "h-full", "shrink-0", "items-center", "gap-(--spacing-12)", "pr-(--spacing-24)", "max-[599px]:gap-(--spacing-20)"];
function AO(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = WC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("header", { ...o, className: r, "data-slot": "top-bar", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function LO(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = UC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { ...o, className: r, "data-slot": "top-bar-leading", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function FO(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = GC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { ...o, className: r, "data-slot": "top-bar-content", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
function $O(t) {
  const e = z.c(7);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = YC.join(" "), e[3] = r) : r = e[3];
  let i;
  return e[4] !== n || e[5] !== o ? (i = /* @__PURE__ */ m("div", { ...o, className: r, "data-slot": "top-bar-actions", children: n }), e[4] = n, e[5] = o, e[6] = i) : i = e[6], i;
}
const jC = ce(["flex", "h-full", "min-h-0", "flex-col", "bg-surface"]), KC = ce(["flex", "w-full", "min-w-0", "flex-col", "gap-(--spacing-4)", "rounded-(--radius-sm)", "px-0", "py-(--spacing-4)", "text-left", "cursor-pointer", "hover:bg-surface-hover", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring"], {
  variants: {
    active: {
      true: "bg-surface-container",
      false: null
    }
  },
  defaultVariants: {
    active: !1
  }
});
function a0(t) {
  const e = z.c(17), {
    conversations: n,
    activeConversationId: o,
    onSelectConversation: r
  } = t;
  let i, s, l, a, c;
  if (e[0] !== o || e[1] !== n || e[2] !== r) {
    const f = n.reduce(qC, {});
    l = "assistant-chat-sidebar-content", a = "flex h-full min-h-0 flex-1 flex-col", e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m("div", { className: "px-(--spacing-12) max-[599px]:px-(--spacing-20)", children: /* @__PURE__ */ m(fo, { size: "lg", children: "Chat History" }) }), e[8] = c) : c = e[8], i = "min-h-0 flex-1 overflow-y-auto px-(--spacing-12) pt-(--spacing-16)", s = n.length === 0 ? /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-center gap-(--spacing-12) px-(--spacing-12) text-center", children: [
      /* @__PURE__ */ m(Ke, { name: "message", size: "md", tone: "secondary", "aria-hidden": !0 }),
      /* @__PURE__ */ m(ln, { tone: "subtle", children: "Your chat history will appear here" })
    ] }) : Object.entries(f).map((p) => {
      const [g, h] = p;
      return /* @__PURE__ */ F("section", { className: "mb-(--spacing-16)", children: [
        /* @__PURE__ */ m("div", { className: "px-(--spacing-8)", children: /* @__PURE__ */ m(fo, { size: "sm", tone: "subtle", children: g }) }),
        /* @__PURE__ */ m("div", { className: "mt-(--spacing-10) flex flex-col gap-(--spacing-4) px-(--spacing-8)", children: h.map((b) => /* @__PURE__ */ F("button", { type: "button", "aria-current": b.id === o ? "page" : void 0, className: KC({
          active: b.id === o
        }), onClick: () => r(b.id), children: [
          /* @__PURE__ */ F("span", { className: "flex items-start justify-between gap-(--spacing-8)", children: [
            /* @__PURE__ */ m("span", { className: "[&>span]:block min-w-0 flex-1 [&>span]:leading-(--font-line-height-20)", children: /* @__PURE__ */ m(An, { as: "span", size: "sm", truncate: !0, children: b.title }) }),
            b.timestamp ? /* @__PURE__ */ m("span", { className: "shrink-0 whitespace-nowrap", children: /* @__PURE__ */ m(ln, { as: "span", size: "sm", tone: "subtle", children: b.timestamp }) }) : null
          ] }),
          b.preview ? /* @__PURE__ */ m(ln, { as: "span", size: "sm", tone: "subtle", truncate: !0, children: b.preview }) : null
        ] }, b.id)) })
      ] }, g);
    }), e[0] = o, e[1] = n, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a, e[7] = c;
  } else
    i = e[3], s = e[4], l = e[5], a = e[6], c = e[7];
  let u;
  e[9] !== i || e[10] !== s ? (u = /* @__PURE__ */ m("div", { className: i, children: s }), e[9] = i, e[10] = s, e[11] = u) : u = e[11];
  let d;
  return e[12] !== l || e[13] !== a || e[14] !== c || e[15] !== u ? (d = /* @__PURE__ */ F("div", { "data-slot": l, className: a, children: [
    c,
    u
  ] }), e[12] = l, e[13] = a, e[14] = c, e[15] = u, e[16] = d) : d = e[16], d;
}
function qC(t, e) {
  const n = e.groupLabel ?? "Conversations", o = t[n] ?? [];
  return o.push(e), t[n] = o, t;
}
function ZC(t) {
  const e = z.c(20), {
    conversations: n,
    activeConversationId: o,
    collapsed: r,
    onNewConversation: i,
    isNewConversationDisabled: s,
    onSelectConversation: l,
    onToggle: a,
    collapseDirection: c,
    badge: u,
    newConversationLabel: d
  } = t, f = r === void 0 ? !1 : r, p = s === void 0 ? !1 : s, g = d === void 0 ? "New chat" : d;
  let h;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = jC(), e[0] = h) : h = e[0];
  let b;
  e[1] !== u || e[2] !== c || e[3] !== f || e[4] !== a ? (b = f ? null : /* @__PURE__ */ m("div", { className: "h-[72px] pb-(--spacing-8) pl-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ m(kp, { badge: u, sidebar: "expanded", children: /* @__PURE__ */ m(uu, { collapsed: !1, collapseDirection: c, onToggle: a }) }) }), e[1] = u, e[2] = c, e[3] = f, e[4] = a, e[5] = b) : b = e[5];
  let v;
  e[6] !== o || e[7] !== u || e[8] !== c || e[9] !== f || e[10] !== n || e[11] !== p || e[12] !== g || e[13] !== i || e[14] !== l || e[15] !== a ? (v = f ? /* @__PURE__ */ m("div", { className: "min-h-0 flex-1 overflow-y-auto px-(--spacing-4) pb-(--spacing-12) pt-(--spacing-24)", children: /* @__PURE__ */ F("div", { className: "flex h-full flex-col items-center justify-between", children: [
    /* @__PURE__ */ m(kp, { badge: u, sidebar: "collapsed", children: /* @__PURE__ */ m(uu, { collapsed: !0, collapseDirection: c, onToggle: a }) }),
    /* @__PURE__ */ m("div", { className: "flex size-(--spacing-48) items-center justify-center", children: /* @__PURE__ */ m(mt, { icon: "edit-pen", variant: "outline", size: "md", "aria-label": g, onClick: i, disabled: p }) })
  ] }) }) : /* @__PURE__ */ F(zt, { children: [
    /* @__PURE__ */ m(a0, { conversations: n, activeConversationId: o, onSelectConversation: l }),
    /* @__PURE__ */ m("div", { className: "mt-auto px-(--spacing-12) pb-(--spacing-24) pt-(--spacing-12)", children: /* @__PURE__ */ m(_n, { variant: "outline", size: "md", icon: "edit-pen", fullWidth: !0, onClick: i, disabled: p, children: g }) })
  ] }), e[6] = o, e[7] = u, e[8] = c, e[9] = f, e[10] = n, e[11] = p, e[12] = g, e[13] = i, e[14] = l, e[15] = a, e[16] = v) : v = e[16];
  let C;
  return e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-sidebar", className: h, children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19], C;
}
const og = ne("relative", "flex", "flex-col", "items-start", "w-full", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"), fc = {
  none: "p-0",
  compact: "p-(--spacing-12)",
  comfortable: "px-(--spacing-20) py-(--spacing-16)"
}, XC = ne("flex", "w-full", "items-stretch", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:rounded-r-none", "[&>[data-slot=card-group-item]:first-child:not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:rounded-none", "[&>[data-slot=card-group-item]:not(:first-child):not(:last-child)>[data-slot=card]]:border-r-0", "[&>[data-slot=card-group-item]:last-child:not(:first-child)>[data-slot=card]]:rounded-l-none"), QC = ne("flex", "min-w-0", "flex-1", "[&>[data-slot=card]]:h-full"), JC = ne("cursor-pointer", "select-none", "outline-none", "transition-colors", "duration-200", "ease-in-out", "text-left", "hover:bg-surface-hover", "active:bg-surface-container-highest", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"), ew = ne("flex", "w-full", "flex-col", "items-start", "overflow-hidden", "rounded-(--radius-sm)"), tw = {
  brand: "bg-primary",
  positive: "bg-positive",
  warning: "bg-accessibility-warning",
  negative: "bg-negative",
  informative: "bg-informative"
};
function nw(t) {
  const e = z.c(4), {
    tone: n
  } = t, o = tw[n];
  let r;
  e[0] !== o ? (r = ne("pointer-events-none absolute -top-px -left-px -right-px z-10 h-(--spacing-8) rounded-tl-(--radius-sm) rounded-tr-(--radius-sm)", o), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r ? (i = /* @__PURE__ */ m("div", { "data-slot": "card-border-fill", className: r }), e[2] = r, e[3] = i) : i = e[3], i;
}
function c0(t) {
  return Zl(t) && t.type === nw;
}
function HO(t) {
  const e = z.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m("div", { "data-slot": "card-image-slot", className: "w-full shrink-0 overflow-hidden", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function zO(t) {
  const e = z.c(8);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ql.map(n, ow), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ m("div", { "data-slot": "card-group", className: XC, ...o, children: r }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function ow(t) {
  return /* @__PURE__ */ m("div", { "data-slot": "card-group-item", className: QC, children: t });
}
function Xr(t) {
  const e = z.c(26);
  let n, o, r, i, s, l, a;
  if (e[0] !== t) {
    a = /* @__PURE__ */ Symbol.for("react.early_return_sentinel");
    e: {
      const {
        children: g,
        fillHeight: h,
        padding: b,
        ...v
      } = t;
      l = v;
      const C = h === void 0 ? !1 : h;
      s = b === void 0 ? "comfortable" : b;
      let y;
      if (e[8] !== g) {
        const S = ql.toArray(g);
        n = S.filter(c0), r = n.length > 0, y = S.filter(rw), e[8] = g, e[9] = n, e[10] = r, e[11] = y;
      } else
        n = e[9], r = e[10], y = e[11];
      const w = y;
      let R;
      if (e[12] !== g || e[13] !== w || e[14] !== r || e[15] !== s ? (R = r ? /* @__PURE__ */ m("div", { "data-slot": "card-content", className: ne(ew, fc[s]), children: w }) : g, e[12] = g, e[13] = w, e[14] = r, e[15] = s, e[16] = R) : R = e[16], o = R, i = C ? "h-full" : null, "onClick" in l && l.onClick !== void 0) {
        const {
          onClick: S,
          disabled: E,
          ...N
        } = l;
        a = /* @__PURE__ */ F(Qn, { "data-slot": "card", className: ne(og, r ? "overflow-visible" : "overflow-hidden", !r && fc[s], i, JC, E && "opacity-50 pointer-events-none"), onClick: S, disabled: E, "aria-disabled": E || void 0, ...N, children: [
          n,
          o
        ] });
        break e;
      }
    }
    e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7];
  if (a !== /* @__PURE__ */ Symbol.for("react.early_return_sentinel"))
    return a;
  const c = r ? "overflow-visible" : "overflow-hidden", u = !r && fc[s];
  let d;
  e[17] !== i || e[18] !== c || e[19] !== u ? (d = ne(og, c, u, i), e[17] = i, e[18] = c, e[19] = u, e[20] = d) : d = e[20];
  const f = l;
  let p;
  return e[21] !== n || e[22] !== o || e[23] !== d || e[24] !== f ? (p = /* @__PURE__ */ F("div", { "data-slot": "card", className: d, ...f, children: [
    n,
    o
  ] }), e[21] = n, e[22] = o, e[23] = d, e[24] = f, e[25] = p) : p = e[25], p;
}
function rw(t) {
  return !c0(t);
}
const iw = ce(["grid", "w-full", "grid-cols-2", "gap-(--spacing-12)"]);
function BO(t) {
  const e = z.c(18), {
    title: n,
    description: o,
    templates: r,
    onSelectTemplate: i
  } = t;
  let s;
  e[0] !== n ? (s = /* @__PURE__ */ m("h2", { className: "text-center font-(family-name:--font-family-headline) text-(length:--font-size-title-xl) font-(number:--font-weight-semibold) leading-(--font-line-height-28) tracking-(--font-letter-spacing-default) text-text-default", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = o ? /* @__PURE__ */ m(ln, { tone: "subtle", children: o }) : null, e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== s || e[5] !== l ? (a = /* @__PURE__ */ F("div", { className: "flex w-full flex-col items-center gap-(--spacing-8) pt-(--spacing-12) text-center", children: [
    s,
    l
  ] }), e[4] = s, e[5] = l, e[6] = a) : a = e[6];
  let c;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = iw(), e[7] = c) : c = e[7];
  let u;
  if (e[8] !== i || e[9] !== r) {
    let p;
    e[11] !== i ? (p = (g) => /* @__PURE__ */ m(Xr, { fillHeight: !0, padding: "none", "aria-label": g.title, onClick: () => i(g), children: /* @__PURE__ */ m("div", { className: "flex h-full w-full flex-col p-(--spacing-16)", children: g.content ?? /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-12)", children: [
      /* @__PURE__ */ F("div", { className: "flex w-full items-start justify-between gap-(--spacing-12)", children: [
        /* @__PURE__ */ m("span", { className: "text-icon-main", children: g.icon ?? /* @__PURE__ */ m(Ke, { name: "sparkles", size: "md" }) }),
        g.action ? /* @__PURE__ */ m("span", { className: "shrink-0", children: g.action }) : null
      ] }),
      /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-col gap-(--spacing-4)", children: [
        /* @__PURE__ */ m(An, { as: "h3", size: "xs", children: g.title }),
        g.description ? /* @__PURE__ */ m(ln, { size: "sm", tone: "subtle", children: g.description }) : null
      ] })
    ] }) }) }, g.id), e[11] = i, e[12] = p) : p = e[12], u = r.map(p), e[8] = i, e[9] = r, e[10] = u;
  } else
    u = e[10];
  let d;
  e[13] !== u ? (d = /* @__PURE__ */ m("div", { className: c, children: u }), e[13] = u, e[14] = d) : d = e[14];
  let f;
  return e[15] !== a || e[16] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "assistant-chat-template-picker", className: "flex w-full max-w-[368px] flex-col items-center gap-(--spacing-20)", children: [
    a,
    d
  ] }), e[15] = a, e[16] = d, e[17] = f) : f = e[17], f;
}
function sw(t) {
  const e = z.c(53), {
    message: n,
    renderMessageContent: o,
    feedback: r,
    feedbackProps: i,
    feedbackResetKey: s
  } = t;
  let l;
  e[0] !== n || e[1] !== o ? (l = o ? o(n) : n.content, e[0] = n, e[1] = o, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== i ? (c = i ?? {}, e[3] = i, e[4] = c) : c = e[4];
  const u = O2(c, s), d = n.role === "assistant" && r === void 0 && i !== void 0;
  let f;
  e[5] !== u || e[6] !== d ? (f = d && u.status === "idle" ? /* @__PURE__ */ m(D2, { feedbackState: u }) : null, e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  const p = f;
  let g;
  e[8] !== r || e[9] !== i || e[10] !== u || e[11] !== d ? (g = d ? u.status === "submitted" ? /* @__PURE__ */ m(_2, {}) : u.status === "idle" && u.isReasonsOpen ? /* @__PURE__ */ m(V2, { feedbackState: u, allowWrittenFeedback: i.allowWrittenFeedback ?? !0, submitDisabled: i.onSubmit === void 0 }) : null : r, e[8] = r, e[9] = i, e[10] = u, e[11] = d, e[12] = g) : g = e[12];
  const h = g, b = n.role === "user";
  if (n.role === "system") {
    const D = typeof a == "string" || typeof a == "number";
    let O;
    e[13] !== a || e[14] !== D || e[15] !== n.statusTone ? (O = D ? /* @__PURE__ */ m(Hv, { tone: n.statusTone ?? "informative", children: a }) : /* @__PURE__ */ m(Xc, { tone: "system", children: a }), e[13] = a, e[14] = D, e[15] = n.statusTone, e[16] = O) : O = e[16];
    let V;
    e[17] !== n.actions ? (V = n.actions ? /* @__PURE__ */ m(T1, { children: n.actions }) : null, e[17] = n.actions, e[18] = V) : V = e[18];
    let _;
    return e[19] !== O || e[20] !== V ? (_ = /* @__PURE__ */ m(qc, { direction: "inbound", children: /* @__PURE__ */ F(Zc, { children: [
      O,
      V
    ] }) }), e[19] = O, e[20] = V, e[21] = _) : _ = e[21], _;
  }
  const v = b ? "outbound" : "inbound";
  let C;
  e[22] !== b || e[23] !== n.avatar ? (C = b ? null : /* @__PURE__ */ m(Om, { children: n.avatar ?? /* @__PURE__ */ m(Gr, { variant: "ai", size: "md" }) }), e[22] = b, e[23] = n.avatar, e[24] = C) : C = e[24];
  const y = n.author ?? (b ? "You" : "Assistant");
  let w;
  e[25] !== y ? (w = /* @__PURE__ */ m(fo, { size: "lg", children: y }), e[25] = y, e[26] = w) : w = e[26];
  let R;
  e[27] !== n.timestamp ? (R = n.timestamp ? /* @__PURE__ */ F(zt, { children: [
    /* @__PURE__ */ m(fo, { size: "xs", tone: "subtle", children: "•" }),
    /* @__PURE__ */ m(fo, { size: "lg", tone: "subtle", children: n.timestamp })
  ] }) : null, e[27] = n.timestamp, e[28] = R) : R = e[28];
  let S;
  e[29] !== w || e[30] !== R ? (S = /* @__PURE__ */ F(Dm, { children: [
    w,
    R
  ] }), e[29] = w, e[30] = R, e[31] = S) : S = e[31];
  let E;
  e[32] !== a ? (E = /* @__PURE__ */ m(Xc, { children: a }), e[32] = a, e[33] = E) : E = e[33];
  let N;
  e[34] !== p || e[35] !== n.actions ? (N = n.actions || p ? /* @__PURE__ */ m(T1, { children: /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-4)", children: [
    n.actions,
    p
  ] }) }) : null, e[34] = p, e[35] = n.actions, e[36] = N) : N = e[36];
  let T;
  e[37] !== S || e[38] !== E || e[39] !== N ? (T = /* @__PURE__ */ F(Zc, { children: [
    S,
    E,
    N
  ] }), e[37] = S, e[38] = E, e[39] = N, e[40] = T) : T = e[40];
  let P;
  e[41] !== b ? (P = b ? null : /* @__PURE__ */ m("div", { "aria-hidden": !0, className: "w-[28px] shrink-0" }), e[41] = b, e[42] = P) : P = e[42];
  let I;
  e[43] !== T || e[44] !== P || e[45] !== v || e[46] !== C ? (I = /* @__PURE__ */ F(qc, { direction: v, children: [
    C,
    T,
    P
  ] }), e[43] = T, e[44] = P, e[45] = v, e[46] = C, e[47] = I) : I = e[47];
  let k;
  e[48] !== h ? (k = h ? /* @__PURE__ */ m("div", { children: h }) : null, e[48] = h, e[49] = k) : k = e[49];
  let M;
  return e[50] !== I || e[51] !== k ? (M = /* @__PURE__ */ F("div", { className: "flex min-w-0 w-full flex-col gap-(--spacing-4)", children: [
    I,
    k
  ] }), e[50] = I, e[51] = k, e[52] = M) : M = e[52], M;
}
function rg(t) {
  const e = z.c(6), {
    messageId: n,
    scrollPosition: o
  } = t, {
    scrollToEnd: r,
    scrollToMessage: i
  } = Su(), s = ft(n);
  let l, a;
  return e[0] !== n || e[1] !== o || e[2] !== r || e[3] !== i ? (l = () => {
    n && s.current !== n && (o === "end" ? r() : i(n, {
      align: "start"
    })), s.current = n;
  }, a = [n, o, r, i], e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = l, e[5] = a) : (l = e[4], a = e[5]), kt(l, a), null;
}
function WO(t) {
  const e = z.c(114), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    conversations: i,
    activeConversationId: s,
    messages: l,
    isResponding: a,
    sidebar: c,
    templatePicker: u,
    feedback: d,
    feedbackRating: f,
    feedbackResetKey: p,
    conversationDate: g,
    minimized: h,
    onClose: b,
    onExpand: v,
    onMinimize: C,
    onSidebarToggle: y,
    sidebarBadge: w,
    collapseDirection: R,
    onNewConversation: S,
    onSelectConversation: E,
    onSendMessage: N,
    renderMessageContent: T,
    onSubmitFeedback: P,
    onRateResponse: I,
    composerProps: k
  } = t;
  let M;
  e[0] !== i ? (M = i === void 0 ? [] : i, e[0] = i, e[1] = M) : M = e[1];
  const D = M, O = a === void 0 ? !1 : a, V = h === void 0 ? !1 : h, _ = _t();
  let A;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = {
    defaultMatches: !1
  }, e[2] = A) : A = e[2];
  const L = Es("(max-width: 599px)", A), B = V && !L, G = l.length === 0, [U, Y] = ot(!1), [K, j] = ot(0);
  let Z;
  e[3] !== k?.initialValue ? (Z = () => k?.initialValue ?? "", e[3] = k?.initialValue, e[4] = Z) : Z = e[4];
  const [te, W] = ot(Z), X = ft(s), ee = ft(null), le = ft(null), J = `${_}-conversation-date`, ie = `${_}-responding`;
  let pe;
  e[5] !== l ? (pe = [...l].reverse().find(cw)?.id, e[5] = l, e[6] = pe) : pe = e[6];
  const oe = pe;
  let re;
  e[7] !== l ? (re = [...l].reverse().find(aw)?.id, e[7] = l, e[8] = re) : re = e[8];
  const de = re, xe = p ?? `${s ?? "conversation"}:${de ?? "response"}`;
  let se, fe;
  e[9] !== L || e[10] !== c ? (fe = () => {
    (!L || !c) && Y(!1);
  }, se = [L, c], e[9] = L, e[10] = c, e[11] = se, e[12] = fe) : (se = e[11], fe = e[12]), kt(fe, se);
  let $, Q;
  e[13] !== s ? ($ = () => {
    X.current !== s && (W(""), X.current = s);
  }, Q = [s], e[13] = s, e[14] = $, e[15] = Q) : ($ = e[14], Q = e[15]), kt($, Q);
  let H;
  e[16] !== L ? (H = () => {
    !L || le.current === null || (ee.current?.focus(), le.current = null);
  }, e[16] = L, e[17] = H) : H = e[17], Io(H);
  let q;
  e[18] !== f || e[19] !== I || e[20] !== P ? (q = P || I ? {
    rating: f,
    onRateResponse: I,
    onSubmit: P
  } : void 0, e[18] = f, e[19] = I, e[20] = P, e[21] = q) : q = e[21];
  const ae = q;
  let ge;
  e[22] !== L || e[23] !== U || e[24] !== S ? (ge = () => {
    L && U && (le.current = "history"), Y(!1), W(""), j(lw), S?.();
  }, e[22] = L, e[23] = U, e[24] = S, e[25] = ge) : ge = e[25];
  const ue = ge;
  let Re;
  e[26] !== L || e[27] !== U || e[28] !== E ? (Re = (Ge) => {
    L && U && (le.current = "history"), Y(!1), E?.(Ge);
  }, e[26] = L, e[27] = U, e[28] = E, e[29] = Re) : Re = e[29];
  const be = Re;
  let ve;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ve = () => {
    le.current = "back", Y(!0);
  }, e[30] = ve) : ve = e[30];
  const me = ve;
  let Ee;
  e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ee = () => {
    le.current = "history", Y(!1);
  }, e[31] = Ee) : Ee = e[31];
  const Pe = Ee;
  let Me;
  e[32] !== s || e[33] !== D || e[34] !== L || e[35] !== G || e[36] !== o || e[37] !== U || e[38] !== b || e[39] !== v || e[40] !== C || e[41] !== be || e[42] !== c || e[43] !== ue || e[44] !== n || e[45] !== r ? (Me = c && L ? /* @__PURE__ */ m("div", { className: "h-full w-full", hidden: !U, children: /* @__PURE__ */ m(Np, { children: /* @__PURE__ */ F(Mp, { children: [
    /* @__PURE__ */ m(sc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: ue, isNewConversationDisabled: G, onBack: Pe, mobileHistoryControlRef: U ? ee : void 0 }),
    /* @__PURE__ */ m(Ip, { children: /* @__PURE__ */ m("div", { className: "flex h-full min-h-0 flex-col pt-(--spacing-16)", children: /* @__PURE__ */ m(a0, { conversations: D, activeConversationId: s, onSelectConversation: be }) }) })
  ] }) }) }) : null, e[32] = s, e[33] = D, e[34] = L, e[35] = G, e[36] = o, e[37] = U, e[38] = b, e[39] = v, e[40] = C, e[41] = be, e[42] = c, e[43] = ue, e[44] = n, e[45] = r, e[46] = Me) : Me = e[46];
  const _e = Me, Ue = B || !!(c && L && U);
  let Ye;
  e[47] !== s || e[48] !== R || e[49] !== D || e[50] !== G || e[51] !== y || e[52] !== be || e[53] !== c || e[54] !== w || e[55] !== ue ? (Ye = c ? /* @__PURE__ */ m(Cy, { children: /* @__PURE__ */ m(ZC, { conversations: D, activeConversationId: s, collapsed: c === "collapsed", onNewConversation: ue, isNewConversationDisabled: G, onSelectConversation: be, onToggle: y, collapseDirection: R, badge: w }) }) : null, e[47] = s, e[48] = R, e[49] = D, e[50] = G, e[51] = y, e[52] = be, e[53] = c, e[54] = w, e[55] = ue, e[56] = Ye) : Ye = e[56];
  const He = c ? ue : void 0, ye = c ? me : void 0, Oe = U ? void 0 : ee;
  let Ie;
  e[57] !== G || e[58] !== o || e[59] !== b || e[60] !== v || e[61] !== C || e[62] !== He || e[63] !== ye || e[64] !== Oe || e[65] !== n || e[66] !== r ? (Ie = /* @__PURE__ */ m(sc, { title: n, leadingAccessory: o, titleAccessory: r, onClose: b, onMinimize: C, onExpand: v, onNewConversation: He, isNewConversationDisabled: G, onOpenHistory: ye, mobileHistoryControlRef: Oe }), e[57] = G, e[58] = o, e[59] = b, e[60] = v, e[61] = C, e[62] = He, e[63] = ye, e[64] = Oe, e[65] = n, e[66] = r, e[67] = Ie) : Ie = e[67];
  let Le;
  e[68] !== ae || e[69] !== xe || e[70] !== g || e[71] !== J || e[72] !== d || e[73] !== O || e[74] !== de || e[75] !== oe || e[76] !== l || e[77] !== T || e[78] !== ie || e[79] !== u ? (Le = /* @__PURE__ */ m(Ip, { children: !O && l.length === 0 && u ? /* @__PURE__ */ F("div", { className: "relative h-full min-h-0", children: [
    /* @__PURE__ */ m("div", { className: "flex h-full min-h-0 flex-col items-center overflow-y-auto px-(--spacing-12) pb-[58px] pt-(--spacing-12)", children: u }),
    /* @__PURE__ */ m("div", { "aria-hidden": !0, className: "pointer-events-none absolute inset-x-0 bottom-0 h-[58px] bg-gradient-to-b from-surface/0 to-surface" })
  ] }) : /* @__PURE__ */ F(Vm, { children: [
    /* @__PURE__ */ F(_m, { "aria-label": "Conversation", children: [
      /* @__PURE__ */ F(Am, { children: [
        g ? /* @__PURE__ */ m(Fi, { messageId: J, children: /* @__PURE__ */ m("div", { className: "py-(--spacing-10)", children: /* @__PURE__ */ m(gr, { centeredText: g, emphasis: "high" }) }) }) : null,
        l.map((Ge) => /* @__PURE__ */ m(Fi, { messageId: Ge.id, children: /* @__PURE__ */ m(sw, { message: Ge, renderMessageContent: T, feedback: Ge.id === de ? d : void 0, feedbackProps: Ge.id === de ? ae : void 0, feedbackResetKey: xe }) }, Ge.id)),
        O ? /* @__PURE__ */ m(Fi, { messageId: ie, children: /* @__PURE__ */ m(Sy, {}) }) : null
      ] }),
      /* @__PURE__ */ m(rg, { messageId: oe, scrollPosition: "end" }),
      /* @__PURE__ */ m(rg, { messageId: de, scrollPosition: "start" })
    ] }),
    /* @__PURE__ */ m(Lm, {})
  ] }) }), e[68] = ae, e[69] = xe, e[70] = g, e[71] = J, e[72] = d, e[73] = O, e[74] = de, e[75] = oe, e[76] = l, e[77] = T, e[78] = ie, e[79] = u, e[80] = Le) : Le = e[80];
  const Be = `${s ?? "conversation"}:${K}`;
  let Te;
  e[81] !== k || e[82] !== te || e[83] !== N || e[84] !== Be ? (Te = /* @__PURE__ */ m(wy, { children: /* @__PURE__ */ m("div", { className: "-mx-(--spacing-4) -mb-(--spacing-4)", children: /* @__PURE__ */ m(nx, { ...k, autoFocus: !0, value: te, onChange: W, onSendMessage: N }, Be) }) }), e[81] = k, e[82] = te, e[83] = N, e[84] = Be, e[85] = Te) : Te = e[85];
  let vt;
  e[86] !== Ie || e[87] !== Le || e[88] !== Te ? (vt = /* @__PURE__ */ F(Mp, { children: [
    Ie,
    Le,
    Te
  ] }), e[86] = Ie, e[87] = Le, e[88] = Te, e[89] = vt) : vt = e[89];
  let nt;
  e[90] !== c || e[91] !== Ye || e[92] !== vt ? (nt = /* @__PURE__ */ F(Np, { sidebar: c, children: [
    Ye,
    vt
  ] }), e[90] = c, e[91] = Ye, e[92] = vt, e[93] = nt) : nt = e[93];
  let we;
  e[94] !== Ue || e[95] !== nt ? (we = /* @__PURE__ */ m("div", { className: "h-full w-full", hidden: Ue, children: nt }), e[94] = Ue, e[95] = nt, e[96] = we) : we = e[96];
  const Ne = we;
  let Ae;
  e[97] !== Ne || e[98] !== _e ? (Ae = /* @__PURE__ */ F(zt, { children: [
    _e,
    Ne
  ] }), e[97] = Ne, e[98] = _e, e[99] = Ae) : Ae = e[99];
  const Fe = Ae;
  let Xe;
  e[100] !== Fe || e[101] !== B ? (Xe = /* @__PURE__ */ m("div", { className: "contents", hidden: B, children: Fe }), e[100] = Fe, e[101] = B, e[102] = Xe) : Xe = e[102];
  let qe;
  e[103] !== B || e[104] !== o || e[105] !== b || e[106] !== v || e[107] !== C || e[108] !== n || e[109] !== r ? (qe = B ? /* @__PURE__ */ m(sc, { title: n, leadingAccessory: o, titleAccessory: r, minimized: !0, onClose: b, onMinimize: C, onExpand: v }) : null, e[103] = B, e[104] = o, e[105] = b, e[106] = v, e[107] = C, e[108] = n, e[109] = r, e[110] = qe) : qe = e[110];
  let it;
  return e[111] !== Xe || e[112] !== qe ? (it = /* @__PURE__ */ F(zt, { children: [
    Xe,
    qe
  ] }), e[111] = Xe, e[112] = qe, e[113] = it) : it = e[113], it;
}
function lw(t) {
  return t + 1;
}
function aw(t) {
  return t.role === "assistant";
}
function cw(t) {
  return t.role === "user";
}
const uw = ce(["fixed", "z-[var(--z-layer-assistant)]", "outline-none", "right-(--spacing-20)", "max-[599px]:right-(--spacing-12)", "max-[599px]:left-auto", "max-[599px]:top-[172px]", "max-[599px]:bottom-auto", "max-[599px]:m-0", "max-[599px]:h-[min(700px,calc(100dvh-188px))]", "max-[599px]:w-[min(350px,calc(100vw-var(--spacing-24)))]"], {
  variants: {
    minimized: {
      true: ["bottom-0", "w-[242px]"],
      false: ["bottom-(--spacing-12)", "h-[min(624px,calc(100dvh-var(--spacing-80)))]"]
    },
    sidebar: {
      expanded: null,
      collapsed: null
    }
  },
  compoundVariants: [{
    minimized: !1,
    sidebar: "expanded",
    class: "w-[634px]"
  }, {
    minimized: !1,
    sidebar: "collapsed",
    class: "w-[456px]"
  }],
  defaultVariants: {
    minimized: !1,
    sidebar: "collapsed"
  }
});
function UO(t) {
  const e = z.c(20), {
    open: n,
    onOpenChange: o,
    "aria-label": r,
    children: i,
    minimized: s,
    sidebar: l
  } = t, a = s === void 0 ? !1 : s, c = l === void 0 ? "collapsed" : l, u = qt(), [d, f] = ot(n);
  let p;
  e[0] !== o ? (p = (R, S) => {
    const E = S?.reason === "outside-press" || S?.reason === "focus-out";
    if (!R && E) {
      S.cancel();
      return;
    }
    o(R);
  }, e[0] = o, e[1] = p) : p = e[1];
  const g = p;
  let h, b;
  e[2] !== n ? (h = () => {
    n && f(!0);
  }, b = [n], e[2] = n, e[3] = h, e[4] = b) : (h = e[3], b = e[4]), kt(h, b);
  let v;
  e[5] !== a || e[6] !== c ? (v = uw({
    minimized: a,
    sidebar: c
  }), e[5] = a, e[6] = c, e[7] = v) : v = e[7];
  let C;
  e[8] !== r || e[9] !== i || e[10] !== v ? (C = /* @__PURE__ */ m(mi, { "data-slot": "assistant-chat-dialog", "aria-label": r, className: v, children: i }), e[8] = r, e[9] = i, e[10] = v, e[11] = C) : C = e[11];
  let y;
  e[12] !== d || e[13] !== u || e[14] !== C ? (y = /* @__PURE__ */ m(Tr, { container: u, keepMounted: d, children: C }), e[12] = d, e[13] = u, e[14] = C, e[15] = y) : y = e[15];
  let w;
  return e[16] !== g || e[17] !== n || e[18] !== y ? (w = /* @__PURE__ */ m(hi, { open: n, onOpenChange: g, modal: !1, disablePointerDismissal: !0, children: y }), e[16] = g, e[17] = n, e[18] = y, e[19] = w) : w = e[19], w;
}
const dw = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
};
function fw(t) {
  const e = z.c(2), {
    count: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m("span", { className: "flex w-[60px] items-center justify-center rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-6) font-(family-name:--font-family-title) font-(number:--font-weight-bold) text-(length:--font-size-headline-xsmall) leading-(--font-line-height-24) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function GO(t) {
  const e = z.c(40);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    count: r,
    actionItemName: n,
    priority: s,
    priorityLabel: l,
    buttonLabel: o,
    onButtonClick: i,
    style: c,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  let u;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    defaultMatches: !1
  }, e[9] = u) : u = e[9];
  const d = Es("(max-width: 599px)", u);
  let f;
  e[10] !== c ? (f = {
    width: "100%",
    ...c
  }, e[10] = c, e[11] = f) : f = e[11];
  const p = f;
  let g;
  e[12] !== r ? (g = /* @__PURE__ */ m(fw, { count: r }), e[12] = r, e[13] = g) : g = e[13];
  let h;
  e[14] !== n ? (h = /* @__PURE__ */ m(An, { size: "md", as: "h3", children: n }), e[14] = n, e[15] = h) : h = e[15];
  const b = dw[s];
  let v;
  e[16] !== l || e[17] !== b ? (v = /* @__PURE__ */ m(Kn, { tone: b, icon: "priority", label: l }), e[16] = l, e[17] = b, e[18] = v) : v = e[18];
  let C;
  e[19] !== g || e[20] !== h || e[21] !== v ? (C = /* @__PURE__ */ F(hr, { gap: 12, align: "center", wrap: "nowrap", children: [
    g,
    h,
    v
  ] }), e[19] = g, e[20] = h, e[21] = v, e[22] = C) : C = e[22];
  let y;
  e[23] !== o || e[24] !== d || e[25] !== i ? (y = !d && /* @__PURE__ */ m(_n, { variant: "outline", size: "sm", onClick: i, children: o }), e[23] = o, e[24] = d, e[25] = i, e[26] = y) : y = e[26];
  let w;
  e[27] !== C || e[28] !== y ? (w = /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ F(hr, { justify: "between", align: "center", wrap: "nowrap", children: [
    C,
    y
  ] }) }), e[27] = C, e[28] = y, e[29] = w) : w = e[29];
  const R = w;
  if (d) {
    const E = `${o} ${n}`;
    let N;
    return e[30] !== p || e[31] !== R || e[32] !== i || e[33] !== a || e[34] !== E ? (N = /* @__PURE__ */ m(Xr, { ...a, "aria-label": E, padding: "compact", style: p, onClick: i, children: R }), e[30] = p, e[31] = R, e[32] = i, e[33] = a, e[34] = E, e[35] = N) : N = e[35], N;
  }
  let S;
  return e[36] !== p || e[37] !== R || e[38] !== a ? (S = /* @__PURE__ */ m(Xr, { ...a, padding: "compact", style: p, children: R }), e[36] = p, e[37] = R, e[38] = a, e[39] = S) : S = e[39], S;
}
const pw = {
  positive: "text-positive",
  negative: "text-negative"
}, gw = "text-text-subtle";
function u0(t) {
  const e = z.c(16), {
    label: n,
    showIcon: o
  } = t, r = o === void 0 ? !0 : o, {
    value: i
  } = t, s = i === void 0, l = !s && (!("tone" in t) || t.tone === void 0), a = s || l;
  let c = gw, u = "trend-no-change", d = "sm";
  !a && t.tone && t.direction && (c = pw[t.tone], u = t.direction === "up" ? "trend-up" : "trend-down", d = "md");
  const f = `inline-flex items-center gap-(--spacing-4) ${c}`;
  let p;
  e[0] !== u || e[1] !== d || e[2] !== s || e[3] !== r ? (p = r ? s ? /* @__PURE__ */ m("span", { className: "inline-block w-(--icon-sm) text-center font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: "--" }) : /* @__PURE__ */ m(Ke, { name: u, size: d, tone: "inherit" }) : null, e[0] = u, e[1] = d, e[2] = s, e[3] = r, e[4] = p) : p = e[4];
  let g;
  e[5] !== i ? (g = i ? /* @__PURE__ */ m("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-semibold) text-(length:--font-size-title-xs) leading-(--font-line-height-20)", children: i }) : null, e[5] = i, e[6] = g) : g = e[6];
  let h;
  e[7] !== f || e[8] !== p || e[9] !== g ? (h = /* @__PURE__ */ F("span", { className: f, children: [
    p,
    g
  ] }), e[7] = f, e[8] = p, e[9] = g, e[10] = h) : h = e[10];
  let b;
  e[11] !== n ? (b = /* @__PURE__ */ m("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtext", children: n }), e[11] = n, e[12] = b) : b = e[12];
  let v;
  return e[13] !== h || e[14] !== b ? (v = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-4)", children: [
    h,
    b
  ] }), e[13] = h, e[14] = b, e[15] = v) : v = e[15], v;
}
const mw = ce(["font-(family-name:--font-family-body)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-title-lg)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "positive"
  }
});
function hw(t) {
  const e = z.c(5), {
    value: n,
    tone: o
  } = t;
  let r;
  e[0] !== o ? (r = mw({
    tone: o
  }), e[0] = o, e[1] = r) : r = e[1];
  let i;
  return e[2] !== r || e[3] !== n ? (i = /* @__PURE__ */ m("span", { className: r, children: n }), e[2] = r, e[3] = n, e[4] = i) : i = e[4], i;
}
function YO(t) {
  const e = z.c(26);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: o,
    value: l,
    tone: i,
    detail: n,
    trend: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  let a;
  e[7] !== n ? (a = n ? /* @__PURE__ */ F("span", { className: "font-(number:--font-weight-semibold) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: [
    " ",
    n
  ] }) : null, e[7] = n, e[8] = a) : a = e[8];
  let c;
  e[9] !== o || e[10] !== a ? (c = /* @__PURE__ */ F(An, { size: "sm", as: "h3", children: [
    o,
    a
  ] }), e[9] = o, e[10] = a, e[11] = c) : c = e[11];
  let u;
  e[12] !== i || e[13] !== l ? (u = /* @__PURE__ */ m(hw, { value: l, tone: i }), e[12] = i, e[13] = l, e[14] = u) : u = e[14];
  let d;
  e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(hr, { justify: "between", align: "center", wrap: "nowrap", children: [
    c,
    u
  ] }), e[15] = c, e[16] = u, e[17] = d) : d = e[17];
  let f;
  e[18] !== s ? (f = s ? /* @__PURE__ */ m(u0, { ...s }) : null, e[18] = s, e[19] = f) : f = e[19];
  let p;
  e[20] !== d || e[21] !== f ? (p = /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ F(qr, { gap: 8, children: [
    d,
    f
  ] }) }), e[20] = d, e[21] = f, e[22] = p) : p = e[22];
  let g;
  return e[23] !== r || e[24] !== p ? (g = /* @__PURE__ */ m(Xr, { ...r, padding: "compact", children: p }), e[23] = r, e[24] = p, e[25] = g) : g = e[25], g;
}
const bw = {
  urgent: "negative",
  high: "warning",
  medium: "informative"
}, vw = ce(["font-(family-name:--font-family-headline)", "font-(number:--font-weight-semibold)", "text-(length:--font-size-headline-large)", "leading-(--font-line-height-40)", "tracking-(--font-letter-spacing-default)"], {
  variants: {
    tone: {
      neutral: "text-text-default",
      positive: "text-positive",
      negative: "text-negative"
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function yw(t) {
  const e = z.c(5), {
    value: n,
    tone: o
  } = t, r = o === void 0 ? "neutral" : o;
  let i;
  e[0] !== r ? (i = vw({
    tone: r
  }), e[0] = r, e[1] = i) : i = e[1];
  let s;
  return e[2] !== i || e[3] !== n ? (s = /* @__PURE__ */ m("span", { className: i, children: n }), e[2] = i, e[3] = n, e[4] = s) : s = e[4], s;
}
function jO(t) {
  const e = z.c(43);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    label: r,
    value: f,
    tone: c,
    trend: d,
    supportingInfo: a,
    actionLabel: n,
    onActionClick: i,
    actionRender: o,
    priority: s,
    fillHeight: u,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "neutral" : c, g = u === void 0 ? !1 : u, h = g ? "flex h-full w-full flex-col justify-center" : "w-full";
  let b;
  e[12] !== r ? (b = /* @__PURE__ */ m(An, { size: "md", as: "h3", truncate: !0, children: r }), e[12] = r, e[13] = b) : b = e[13];
  let v;
  e[14] !== n || e[15] !== o || e[16] !== i || e[17] !== s ? (v = n && (i || o) ? /* @__PURE__ */ m(mt, { render: o, variant: "outline", size: "sm", icon: "arrow-up-right", "aria-label": n, onClick: i }) : s ? /* @__PURE__ */ m(Ke, { name: "priority", size: "sm", tone: bw[s] }) : null, e[14] = n, e[15] = o, e[16] = i, e[17] = s, e[18] = v) : v = e[18];
  let C;
  e[19] !== b || e[20] !== v ? (C = /* @__PURE__ */ m("div", { className: "h-(--spacing-32)", children: /* @__PURE__ */ F(hr, { justify: "between", align: "start", wrap: "nowrap", children: [
    b,
    v
  ] }) }), e[19] = b, e[20] = v, e[21] = C) : C = e[21];
  let y;
  e[22] !== p || e[23] !== f ? (y = /* @__PURE__ */ m(yw, { value: f, tone: p }), e[22] = p, e[23] = f, e[24] = y) : y = e[24];
  let w;
  e[25] !== d ? (w = d ? /* @__PURE__ */ m(u0, { ...d }) : null, e[25] = d, e[26] = w) : w = e[26];
  let R;
  e[27] !== a ? (R = a ? /* @__PURE__ */ m("div", { className: "w-full", children: a }) : null, e[27] = a, e[28] = R) : R = e[28];
  let S;
  e[29] !== y || e[30] !== w || e[31] !== R ? (S = /* @__PURE__ */ F(qr, { gap: 6, children: [
    y,
    w,
    R
  ] }), e[29] = y, e[30] = w, e[31] = R, e[32] = S) : S = e[32];
  let E;
  e[33] !== S || e[34] !== C ? (E = /* @__PURE__ */ F(qr, { gap: 12, children: [
    C,
    S
  ] }), e[33] = S, e[34] = C, e[35] = E) : E = e[35];
  let N;
  e[36] !== E || e[37] !== h ? (N = /* @__PURE__ */ m("div", { className: h, children: E }), e[36] = E, e[37] = h, e[38] = N) : N = e[38];
  let T;
  return e[39] !== g || e[40] !== l || e[41] !== N ? (T = /* @__PURE__ */ m(Xr, { fillHeight: g, ...l, children: N }), e[39] = g, e[40] = l, e[41] = N, e[42] = T) : T = e[42], T;
}
function KO(t) {
  const e = z.c(33);
  let n;
  e[0] !== t.chipLabel || e[1] !== t.mpCount || e[2] !== t.variant ? (n = t.variant === "add" ? /* @__PURE__ */ m(Kn, { tone: "informative", label: t.chipLabel ?? "Recommended" }) : t.mpCount != null ? /* @__PURE__ */ m(Kn, { tone: "neutral", label: t.mpCount === 1 ? "1 MP" : `${t.mpCount} MPs` }) : null, e[0] = t.chipLabel, e[1] = t.mpCount, e[2] = t.variant, e[3] = n) : n = e[3];
  const o = n;
  let r, i, s, l, a, c;
  if (e[4] !== t) {
    const {
      serviceName: w,
      icon: R,
      variant: S,
      chipLabel: E,
      mpCount: N,
      showIcon: T,
      style: P,
      ...I
    } = t;
    s = w, i = R, a = S, c = T, l = P, r = I, e[4] = t, e[5] = r, e[6] = i, e[7] = s, e[8] = l, e[9] = a, e[10] = c;
  } else
    r = e[5], i = e[6], s = e[7], l = e[8], a = e[9], c = e[10];
  const u = a === void 0 ? "default" : a, d = c === void 0 ? !0 : c;
  let f;
  e[11] !== l ? (f = {
    width: "100%",
    ...l
  }, e[11] = l, e[12] = f) : f = e[12];
  let p;
  e[13] !== i ? (p = /* @__PURE__ */ m(Ke, { name: i, size: "sm", tone: "neutral", "aria-hidden": !0 }), e[13] = i, e[14] = p) : p = e[14];
  let g;
  e[15] !== s ? (g = /* @__PURE__ */ m(An, { size: "sm", as: "h3", children: s }), e[15] = s, e[16] = g) : g = e[16];
  let h;
  e[17] !== p || e[18] !== g ? (h = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-start gap-(--spacing-4)", children: [
    p,
    g
  ] }), e[17] = p, e[18] = g, e[19] = h) : h = e[19];
  let b;
  e[20] !== h || e[21] !== o ? (b = /* @__PURE__ */ F(hr, { gap: 8, justify: "between", wrap: "wrap", align: "start", children: [
    h,
    o
  ] }), e[20] = h, e[21] = o, e[22] = b) : b = e[22];
  let v;
  e[23] !== u || e[24] !== d ? (v = u === "add" ? /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-center gap-(--spacing-10) border border-dashed border-outline-subtle bg-surface py-(--spacing-6)", children: [
    d ? /* @__PURE__ */ m(Ke, { name: "marketplace", size: "md", tone: "neutral", "aria-hidden": !0 }) : null,
    /* @__PURE__ */ m("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-24) text-text-default", children: "Add" })
  ] }) : null, e[23] = u, e[24] = d, e[25] = v) : v = e[25];
  let C;
  e[26] !== b || e[27] !== v ? (C = /* @__PURE__ */ m("div", { className: "w-full", children: /* @__PURE__ */ F(qr, { gap: 12, children: [
    b,
    v
  ] }) }), e[26] = b, e[27] = v, e[28] = C) : C = e[28];
  let y;
  return e[29] !== r || e[30] !== f || e[31] !== C ? (y = /* @__PURE__ */ m(Xr, { ...r, padding: "compact", style: f, children: C }), e[29] = r, e[30] = f, e[31] = C, e[32] = y) : y = e[32], y;
}
const xw = ce(["w-full", "flex", "items-start", "justify-between", "gap-(--spacing-24)", "p-(--spacing-12)", "rounded-(--radius-sm)"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
}), Cw = {
  neutral: "circle-info",
  informative: "circle-info",
  positive: "circle-check",
  warning: "warning",
  negative: "warning"
};
function ig(t) {
  const e = z.c(33);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    tone: s,
    title: l,
    subtext: i,
    action: n,
    onDismiss: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? "neutral" : s, c = a === "negative", u = !!(n || o), d = c ? "alert" : "note", f = c ? "assertive" : void 0;
  let p;
  e[7] !== a ? (p = ne(xw({
    tone: a
  })), e[7] = a, e[8] = p) : p = e[8];
  const g = Cw[a];
  let h;
  e[9] !== g ? (h = /* @__PURE__ */ m(Ke, { name: g, size: "md", tone: "inherit" }), e[9] = g, e[10] = h) : h = e[10];
  let b;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = {
    color: "inherit"
  }, e[11] = b) : b = e[11];
  let v;
  e[12] !== l ? (v = /* @__PURE__ */ m(An, { as: "span", size: "sm", style: b, children: l }), e[12] = l, e[13] = v) : v = e[13];
  let C;
  e[14] !== i ? (C = i ? /* @__PURE__ */ m(ln, { as: "span", size: "sm", style: {
    color: "inherit"
  }, children: i }) : null, e[14] = i, e[15] = C) : C = e[15];
  let y;
  e[16] !== v || e[17] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) min-w-0", children: [
    v,
    C
  ] }), e[16] = v, e[17] = C, e[18] = y) : y = e[18];
  let w;
  e[19] !== y || e[20] !== h ? (w = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    h,
    y
  ] }), e[19] = y, e[20] = h, e[21] = w) : w = e[21];
  let R;
  e[22] !== n || e[23] !== u || e[24] !== o ? (R = u ? /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    o ? /* @__PURE__ */ m(mt, { icon: "x-close", "aria-label": "Dismiss alert", variant: "ghost", size: "sm", onClick: o }) : null
  ] }) : null, e[22] = n, e[23] = u, e[24] = o, e[25] = R) : R = e[25];
  let S;
  return e[26] !== r || e[27] !== w || e[28] !== R || e[29] !== d || e[30] !== f || e[31] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...r, children: [
    w,
    R
  ] }), e[26] = r, e[27] = w, e[28] = R, e[29] = d, e[30] = f, e[31] = p, e[32] = S) : S = e[32], S;
}
function ww(t) {
  const e = z.c(14), {
    stableCount: n,
    watchingCount: o,
    maintenanceCount: r
  } = t, i = n + o + r;
  if (i === 0) {
    let p;
    return e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = /* @__PURE__ */ m("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "h-(--spacing-8) w-full rounded-(--radius-none) bg-surface-inverse-surface/20" }), e[0] = p) : p = e[0], p;
  }
  const s = n / i * 100, l = o / i * 100, a = r / i * 100;
  let c;
  e[1] !== n || e[2] !== s ? (c = n > 0 && /* @__PURE__ */ m("div", { "data-testid": "asset-status-bar-stable", className: "h-full rounded-(--radius-none) bg-datavis-crit-green", style: {
    width: `${s}%`
  } }), e[1] = n, e[2] = s, e[3] = c) : c = e[3];
  let u;
  e[4] !== o || e[5] !== l ? (u = o > 0 && /* @__PURE__ */ m("div", { "data-testid": "asset-status-bar-watching", className: "h-full rounded-(--radius-none) bg-datavis-crit-yellow", style: {
    width: `${l}%`
  } }), e[4] = o, e[5] = l, e[6] = u) : u = e[6];
  let d;
  e[7] !== r || e[8] !== a ? (d = r > 0 && /* @__PURE__ */ m("div", { "data-testid": "asset-status-bar-maintenance", className: "h-full rounded-(--radius-none) bg-datavis-crit-red", style: {
    width: `${a}%`
  } }), e[7] = r, e[8] = a, e[9] = d) : d = e[9];
  let f;
  return e[10] !== c || e[11] !== u || e[12] !== d ? (f = /* @__PURE__ */ F("div", { "aria-hidden": "true", "data-testid": "asset-status-bar", className: "flex h-(--spacing-8) w-full gap-(--spacing-6)", children: [
    c,
    u,
    d
  ] }), e[10] = c, e[11] = u, e[12] = d, e[13] = f) : f = e[13], f;
}
const El = 6, Sw = 4;
function Rw(t) {
  return Sw / (2 * Math.PI * t) * 360;
}
function sg(t, e, n, o) {
  const r = (o - 90) * Math.PI / 180;
  return {
    x: t + n * Math.cos(r),
    y: e + n * Math.sin(r)
  };
}
function Ew(t, e, n, o, r) {
  const i = sg(t, e, n, r), s = sg(t, e, n, o), l = r - o > 180 ? 1 : 0;
  return `M ${i.x} ${i.y} A ${n} ${n} 0 ${l} 0 ${s.x} ${s.y}`;
}
const Nw = ["Stable", "Watching", "Maintenance Recommended"], kw = ["stroke-datavis-crit-green", "stroke-datavis-crit-yellow", "stroke-datavis-crit-red"];
function Mw(t) {
  const e = z.c(51), {
    size: n,
    unit: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t, l = n / 2, a = n / 2, c = (n - El) / 2, u = r + i + s, d = u === 0;
  let f;
  e[0] !== d || e[1] !== u ? (f = d ? "--" : u >= 1e4 ? `${Math.round(u / 1e3)}k` : String(u), e[0] = d, e[1] = u, e[2] = f) : f = e[2];
  const p = f, g = n >= 80 ? "var(--font-size-title-xl)" : "var(--font-size-title-sm)", h = n >= 80 ? "var(--font-size-title-sm)" : "var(--font-size-title-xs)", b = a - 4;
  let v;
  e[3] !== p || e[4] !== g || e[5] !== l || e[6] !== b ? (v = /* @__PURE__ */ m("text", { x: l, y: b, textAnchor: "middle", dominantBaseline: "auto", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: g, className: "fill-text-default", "data-testid": "asset-status-donut-count", children: p }), e[3] = p, e[4] = g, e[5] = l, e[6] = b, e[7] = v) : v = e[7];
  const C = a + 4;
  let y;
  e[8] !== l || e[9] !== C || e[10] !== o || e[11] !== h ? (y = /* @__PURE__ */ m("text", { x: l, y: C, textAnchor: "middle", dominantBaseline: "hanging", fontFamily: "var(--font-family-title)", fontWeight: "var(--font-weight-medium)", fontSize: h, className: "fill-text-subtext", "data-testid": "asset-status-donut-unit", children: o }), e[8] = l, e[9] = C, e[10] = o, e[11] = h, e[12] = y) : y = e[12];
  let w;
  e[13] !== v || e[14] !== y ? (w = /* @__PURE__ */ F(zt, { children: [
    v,
    y
  ] }), e[13] = v, e[14] = y, e[15] = w) : w = e[15];
  const R = w;
  if (d) {
    let V;
    e[16] !== l || e[17] !== a || e[18] !== c ? (V = /* @__PURE__ */ m("circle", { cx: l, cy: a, r: c, fill: "none", className: "stroke-surface-inverse-surface/20", strokeWidth: El }), e[16] = l, e[17] = a, e[18] = c, e[19] = V) : V = e[19];
    let _;
    return e[20] !== R || e[21] !== n || e[22] !== V ? (_ = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": "No asset status data available", "data-testid": "asset-status-donut", children: [
      V,
      R
    ] }), e[20] = R, e[21] = n, e[22] = V, e[23] = _) : _ = e[23], _;
  }
  let S;
  e[24] !== s || e[25] !== r || e[26] !== i ? (S = [r, i, s].map(Tw).filter(Pw), e[24] = s, e[25] = r, e[26] = i, e[27] = S) : S = e[27];
  const E = S;
  let N;
  e[28] !== c || e[29] !== E.length ? (N = E.length > 1 ? Rw(c) : 0, e[28] = c, e[29] = E.length, e[30] = N) : N = e[30];
  const T = N, I = 360 - E.length * T;
  let k;
  if (e[31] !== I || e[32] !== l || e[33] !== a || e[34] !== T || e[35] !== c || e[36] !== E || e[37] !== u) {
    k = [];
    let V = 0;
    for (const _ of E) {
      const A = _.count / u * I;
      k.push({
        path: Ew(l, a, c, V, V + A),
        strokeClassName: _.strokeClassName,
        label: `${_.label}: ${_.count}`
      }), V = V + (A + T);
    }
    e[31] = I, e[32] = l, e[33] = a, e[34] = T, e[35] = c, e[36] = E, e[37] = u, e[38] = k;
  } else
    k = e[38];
  const M = `Asset status: ${r} stable, ${i} watching, ${s} maintenance`;
  let D;
  e[39] !== k || e[40] !== l || e[41] !== a || e[42] !== c || e[43] !== E[0] || e[44] !== E.length ? (D = E.length === 1 ? /* @__PURE__ */ m("circle", { cx: l, cy: a, r: c, fill: "none", className: E[0].strokeClassName, strokeWidth: El, "aria-label": `${E[0].label}: ${E[0].count}`, "data-testid": "asset-status-donut-segment" }) : k.map(Iw), e[39] = k, e[40] = l, e[41] = a, e[42] = c, e[43] = E[0], e[44] = E.length, e[45] = D) : D = e[45];
  let O;
  return e[46] !== R || e[47] !== n || e[48] !== D || e[49] !== M ? (O = /* @__PURE__ */ F("svg", { width: n, height: n, role: "img", "aria-label": M, "data-testid": "asset-status-donut", children: [
    D,
    R
  ] }), e[46] = R, e[47] = n, e[48] = D, e[49] = M, e[50] = O) : O = e[50], O;
}
function Iw(t) {
  return /* @__PURE__ */ m("path", { d: t.path, fill: "none", className: t.strokeClassName, strokeWidth: El, "aria-label": t.label, "data-testid": "asset-status-donut-segment" }, t.label);
}
function Pw(t) {
  return t.count > 0;
}
function Tw(t, e) {
  return {
    count: t,
    strokeClassName: kw[e],
    label: Nw[e]
  };
}
const Ow = {
  md: "var(--font-size-title-sm)",
  sm: "var(--font-size-title-xs)"
};
function pc(t) {
  const e = z.c(20), {
    size: n,
    icon: o,
    iconColor: r,
    chipTone: i,
    label: s,
    count: l
  } = t;
  let a;
  e[0] !== o ? (a = /* @__PURE__ */ m(Ke, { name: o, size: "xs", tone: "inherit" }), e[0] = o, e[1] = a) : a = e[1];
  let c;
  e[2] !== r || e[3] !== a ? (c = /* @__PURE__ */ m("span", { className: r, "aria-hidden": "true", children: a }), e[2] = r, e[3] = a, e[4] = c) : c = e[4];
  const u = Ow[n];
  let d;
  e[5] !== u ? (d = {
    fontSize: u
  }, e[5] = u, e[6] = d) : d = e[6];
  let f;
  e[7] !== s || e[8] !== d ? (f = /* @__PURE__ */ m("span", { className: "truncate font-(family-name:--font-family-title) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default", style: d, children: s }), e[7] = s, e[8] = d, e[9] = f) : f = e[9];
  let p;
  e[10] !== c || e[11] !== f ? (p = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6) min-w-0", children: [
    c,
    f
  ] }), e[10] = c, e[11] = f, e[12] = p) : p = e[12];
  const g = n === "md" ? o : void 0;
  let h;
  e[13] !== i || e[14] !== l || e[15] !== g ? (h = /* @__PURE__ */ m(Kn, { tone: i, icon: g, label: l }), e[13] = i, e[14] = l, e[15] = g, e[16] = h) : h = e[16];
  let b;
  return e[17] !== p || e[18] !== h ? (b = /* @__PURE__ */ F("div", { className: "grid w-full grid-cols-[minmax(0,1fr)_max-content] items-center gap-(--spacing-8)", "data-testid": "asset-status-key-row", children: [
    p,
    h
  ] }), e[17] = p, e[18] = h, e[19] = b) : b = e[19], b;
}
function lg(t) {
  const e = z.c(19), {
    labels: n,
    size: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  } = t;
  let l;
  e[0] !== n ? (l = n === void 0 ? {
    stable: "Stable",
    watching: "Watching",
    maintenance: "Maintenance Recommended"
  } : n, e[0] = n, e[1] = l) : l = e[1];
  const a = l, u = `flex w-full min-w-0 flex-col ${o === "md" ? "gap-(--spacing-6)" : "gap-(--spacing-4)"}`;
  let d;
  e[2] !== a.stable || e[3] !== o || e[4] !== r ? (d = /* @__PURE__ */ m(pc, { size: o, icon: "circle-check", iconColor: "text-datavis-crit-green", chipTone: "positive", label: a.stable, count: r }), e[2] = a.stable, e[3] = o, e[4] = r, e[5] = d) : d = e[5];
  let f;
  e[6] !== a.watching || e[7] !== o || e[8] !== i ? (f = /* @__PURE__ */ m(pc, { size: o, icon: "eye-watching", iconColor: "text-datavis-crit-yellow", chipTone: "warning", label: a.watching, count: i }), e[6] = a.watching, e[7] = o, e[8] = i, e[9] = f) : f = e[9];
  let p;
  e[10] !== a.maintenance || e[11] !== s || e[12] !== o ? (p = /* @__PURE__ */ m(pc, { size: o, icon: "maintenance", iconColor: "text-datavis-crit-red", chipTone: "negative", label: a.maintenance, count: s }), e[10] = a.maintenance, e[11] = s, e[12] = o, e[13] = p) : p = e[13];
  let g;
  return e[14] !== u || e[15] !== d || e[16] !== f || e[17] !== p ? (g = /* @__PURE__ */ F("div", { className: u, "data-testid": "asset-status-key", children: [
    d,
    f,
    p
  ] }), e[14] = u, e[15] = d, e[16] = f, e[17] = p, e[18] = g) : g = e[18], g;
}
const Dw = {
  md: 88,
  sm: 80
};
function Vw({
  stableCount: t,
  watchingCount: e,
  maintenanceCount: n
}) {
  const o = [t < 0 ? "stableCount" : null, e < 0 ? "watchingCount" : null, n < 0 ? "maintenanceCount" : null].filter((r) => r !== null);
  if (o.length > 0)
    throw new RangeError(`AssetStatusCard counts cannot be negative: ${o.join(", ")}`);
}
function _w(t) {
  return t.borderBoxSize[0]?.inlineSize ?? t.contentRect.width;
}
function qO(t) {
  const e = z.c(20), {
    variant: n,
    unit: o,
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s,
    labels: l
  } = t;
  Vw({
    stableCount: r,
    watchingCount: i,
    maintenanceCount: s
  });
  const a = ft(null), [c, u] = ot("md"), d = n === "donut", f = r + i + s, p = f === 0, g = d ? "p-(--spacing-12)" : "p-(--spacing-20)";
  let h, b;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = () => {
    const R = a.current;
    if (!R || typeof ResizeObserver > "u")
      return;
    const S = (N) => {
      u(N <= 380 ? "sm" : "md");
    };
    S(R.getBoundingClientRect().width);
    const E = new ResizeObserver((N) => {
      const [T] = N;
      T && S(_w(T));
    });
    return E.observe(R), () => {
      E.disconnect();
    };
  }, b = [], e[0] = h, e[1] = b) : (h = e[0], b = e[1]), kt(h, b);
  const v = `flex h-full w-full min-w-0 flex-col gap-(--spacing-16) rounded-(--radius-sm) border border-outline-subtle bg-surface shadow-elevation-1 ${g}`;
  let C;
  e[2] !== d || e[3] !== p || e[4] !== f || e[5] !== o ? (C = !d && /* @__PURE__ */ F("div", { className: "flex items-baseline gap-(--spacing-6)", "data-testid": "asset-status-card-header", children: [
    /* @__PURE__ */ m("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xl) leading-(--font-line-height-28) text-text-default", children: p ? "--" : f }),
    /* @__PURE__ */ m("span", { className: "font-(family-name:--font-family-title) font-(number:--font-weight-regular) text-(length:--font-size-title-md) leading-(--font-line-height-24) text-text-subtext", children: o })
  ] }), e[2] = d, e[3] = p, e[4] = f, e[5] = o, e[6] = C) : C = e[6];
  let y;
  e[7] !== d || e[8] !== p || e[9] !== l || e[10] !== s || e[11] !== c || e[12] !== r || e[13] !== o || e[14] !== i ? (y = d ? /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ m("div", { className: "shrink-0", children: /* @__PURE__ */ m(Mw, { size: Dw[c], unit: o, stableCount: r, watchingCount: i, maintenanceCount: s }) }),
    p ? /* @__PURE__ */ m(ig, { tone: "neutral", title: "No available asset status data. Check back later." }) : /* @__PURE__ */ m(lg, { labels: l, size: c, stableCount: r, watchingCount: i, maintenanceCount: s })
  ] }) : /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-16)", "data-testid": "asset-status-card-body", children: [
    /* @__PURE__ */ m(ww, { stableCount: r, watchingCount: i, maintenanceCount: s }),
    p ? /* @__PURE__ */ m(ig, { tone: "neutral", title: "No available asset status data. Check back later." }) : /* @__PURE__ */ m(lg, { labels: l, size: c, stableCount: r, watchingCount: i, maintenanceCount: s })
  ] }), e[7] = d, e[8] = p, e[9] = l, e[10] = s, e[11] = c, e[12] = r, e[13] = o, e[14] = i, e[15] = y) : y = e[15];
  let w;
  return e[16] !== v || e[17] !== C || e[18] !== y ? (w = /* @__PURE__ */ F("div", { ref: a, "data-testid": "asset-status-card", className: v, children: [
    C,
    y
  ] }), e[16] = v, e[17] = C, e[18] = y, e[19] = w) : w = e[19], w;
}
const cf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (cf.displayName = "PreviewCardRootContext");
function Ms(t) {
  const e = x.useContext(cf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PreviewCardRootContext is missing. PreviewCard parts must be placed within <PreviewCard.Root>." : rt(50));
  return e;
}
const Aw = 600, d0 = 300, Lw = {
  ...ps,
  instantType: he((t) => t.instantType),
  hasViewport: he((t) => t.hasViewport)
};
class uf extends wr {
  constructor(e) {
    super({
      ...Fw(),
      ...e
    }, {
      popupRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerElements: new Sr(),
      closeDelayRef: {
        current: d0
      }
    }, Lw);
  }
  setOpen = (e, n) => {
    const o = n.reason, r = o === Lt, i = e && o === dr, s = !e && (o === Zn || o === vr);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const l = () => {
      const a = {
        open: e
      };
      i ? a.instantType = "focus" : s ? a.instantType = "dismiss" : o === Lt && (a.instantType = void 0);
      const c = n.trigger?.id ?? null;
      (c || e) && (a.activeTriggerId = c, a.activeTriggerElement = n.trigger ?? null), this.update(a);
    };
    r ? an.flushSync(l) : l();
  };
  static useStore(e, n) {
    const o = Tt(() => new uf(n)).current, r = e ?? o, i = gs({
      popupStore: r,
      onOpenChange: r.setOpen
    });
    return r.state.floatingRootContext = i, r;
  }
}
function Fw() {
  return {
    ...fs(),
    instantType: void 0,
    hasViewport: !1
  };
}
function ag(t) {
  const {
    open: e,
    defaultOpen: n = !1,
    onOpenChange: o,
    onOpenChangeComplete: r,
    actionsRef: i,
    handle: s,
    triggerId: l,
    defaultTriggerId: a = null,
    children: c
  } = t, u = uf.useStore(s?.store, {
    open: n,
    openProp: e,
    activeTriggerId: a,
    triggerIdProp: l
  });
  Nr(() => {
    e === void 0 && u.state.open === !1 && n === !0 && u.update({
      open: !0,
      activeTriggerId: a
    });
  }), u.useControlledProp("openProp", e), u.useControlledProp("triggerIdProp", l), u.useContextCallback("onOpenChange", o), u.useContextCallback("onOpenChangeComplete", r);
  const d = u.useState("open"), f = u.select("floatingRootContext"), p = u.useState("activeTriggerId"), g = u.useState("payload");
  us(u);
  const {
    forceUnmount: h
  } = ds(d, u);
  ke(() => {
    d && p == null && u.set("payload", void 0);
  }, [u, p, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, Ve(ss));
  }, [u]);
  x.useImperativeHandle(i, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = Cr(f), {
    getReferenceProps: C,
    getTriggerProps: y,
    getFloatingProps: w
  } = eo([v]), R = x.useMemo(() => C(), [C]), S = x.useMemo(() => y(), [y]), E = x.useMemo(() => w(), [w]);
  return u.useSyncedValues({
    activeTriggerProps: R,
    inactiveTriggerProps: S,
    popupProps: E
  }), /* @__PURE__ */ m(cf.Provider, {
    value: u,
    children: typeof c == "function" ? c({
      payload: g
    }) : c
  });
}
function $w(t) {
  return Ms(!0) ? /* @__PURE__ */ m(ag, {
    ...t
  }) : /* @__PURE__ */ m(sd, {
    children: /* @__PURE__ */ m(ag, {
      ...t
    })
  });
}
const df = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (df.displayName = "PreviewCardPortalContext");
function Hw() {
  const t = x.useContext(df);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Portal> is missing." : rt(48));
  return t;
}
const f0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e;
  return Ms().useState("mounted") || o ? /* @__PURE__ */ m(df.Provider, {
    value: o,
    children: /* @__PURE__ */ m(ga, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (f0.displayName = "PreviewCardPortal");
const p0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    delay: i,
    closeDelay: s,
    id: l,
    payload: a,
    handle: c,
    style: u,
    ...d
  } = e, f = Ms(!0), p = c?.store ?? f;
  if (!p)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Trigger> must be either used within a <PreviewCard.Root> component or provided with a handle." : rt(89));
  const g = Mt(l), h = p.useState("isTriggerActive", g), b = p.useState("isOpenedByTrigger", g), v = p.useState("floatingRootContext"), C = x.useRef(null), y = i ?? Aw, w = s ?? d0, {
    registerTrigger: R,
    isMountedByThisTrigger: S
  } = cs(g, C, p, {
    payload: a
  });
  ke(() => {
    S && (p.context.closeDelayRef.current = w);
  }, [p, S, w]);
  const E = ms(v, {
    mouseOnly: !0,
    move: !1,
    handleClose: hs(),
    delay: () => ({
      open: y,
      close: w
    }),
    triggerElementRef: C,
    isActiveTrigger: h,
    isClosing: () => p.select("transitionStatus") === "ending"
  }), N = md(v, {
    delay: y
  }), T = {
    open: b
  }, P = p.useState("triggerProps", S);
  return $e("a", e, {
    state: T,
    ref: [n, R, C],
    props: [E, N.reference, P, {
      id: g
    }, d],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (p0.displayName = "PreviewCardTrigger");
const ff = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ff.displayName = "PreviewCardPositionerContext");
function zw() {
  const t = x.useContext(ff);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <PreviewCard.Popup> and <PreviewCard.Arrow> must be used within the <PreviewCard.Positioner> component" : rt(49));
  return t;
}
const g0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = la,
    style: v,
    ...C
  } = e, y = Ms(), w = Hw(), R = aa(), S = y.useState("open"), E = y.useState("mounted"), N = y.useState("floatingRootContext"), T = y.useState("instantType"), P = y.useState("transitionStatus"), I = y.useState("hasViewport"), k = ri({
    anchor: i,
    floatingRootContext: N,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: I ? fa : void 0
  }), M = {
    open: S,
    side: k.side,
    align: k.align,
    anchorHidden: k.anchorHidden,
    instant: T
  }, D = li(e, M, {
    styles: k.positionerStyles,
    transitionStatus: P,
    props: C,
    refs: [n, y.useStateSetter("positionerElement")],
    hidden: !E,
    inert: !S
  });
  return /* @__PURE__ */ m(ff.Provider, {
    value: k,
    children: /* @__PURE__ */ m(id, {
      id: R,
      children: D
    })
  });
});
process.env.NODE_ENV !== "production" && (g0.displayName = "PreviewCardPositioner");
const Bw = {
  ...Nn,
  ...Bt
}, m0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, l = Ms(), {
    side: a,
    align: c
  } = zw(), u = l.useState("open"), d = l.useState("instantType"), f = l.useState("transitionStatus"), p = l.useState("popupProps"), g = l.useState("floatingRootContext");
  jt({
    open: u,
    ref: l.context.popupRef,
    onComplete() {
      u && l.context.onOpenChangeComplete?.(!0);
    }
  });
  const h = Se(() => l.context.closeDelayRef.current);
  return ua(g, {
    closeDelay: h
  }), $e("div", e, {
    state: {
      open: u,
      side: a,
      align: c,
      instant: d,
      transitionStatus: f
    },
    ref: [n, l.context.popupRef, l.useStateSetter("popupElement")],
    props: [p, Rr(f), s],
    stateAttributesMapping: Bw
  });
});
process.env.NODE_ENV !== "production" && (m0.displayName = "PreviewCardPopup");
const Ww = "z-[var(--z-layer-popover)]", Uw = ne("rounded-(--radius-sm)", "border border-solid border-outline-subtle", "bg-surface-container-lowest", "text-text-default", "shadow-elevation-3", "font-(family-name:--font-family-body)", "origin-(--transform-origin)", "transition-[opacity,transform]", "duration-200", "ease-in-out", "will-change-[opacity,transform]", "[&[data-starting-style]]:scale-95", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:scale-95", "[&[data-ending-style]]:opacity-0");
function Gw(t) {
  const e = z.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ m($w, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function Yw(t) {
  const e = z.c(8);
  let n, o, r;
  e[0] !== t ? ({
    render: o,
    delay: r,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? 0 : r;
  let s;
  return e[4] !== i || e[5] !== n || e[6] !== o ? (s = /* @__PURE__ */ m(p0, { render: o, delay: i, ...n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s) : s = e[7], s;
}
function jw(t) {
  const e = z.c(21);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    children: n,
    className: o,
    side: i,
    align: s,
    sideOffset: l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "bottom" : i, c = s === void 0 ? "center" : s, u = l === void 0 ? 8 : l, d = qt();
  let f;
  e[7] !== o ? (f = ne(Uw, o), e[7] = o, e[8] = f) : f = e[8];
  let p;
  e[9] !== n || e[10] !== f ? (p = /* @__PURE__ */ m(m0, { className: f, children: n }), e[9] = n, e[10] = f, e[11] = p) : p = e[11];
  let g;
  e[12] !== c || e[13] !== r || e[14] !== a || e[15] !== u || e[16] !== p ? (g = /* @__PURE__ */ m(g0, { side: a, align: c, sideOffset: u, className: Ww, ...r, children: p }), e[12] = c, e[13] = r, e[14] = a, e[15] = u, e[16] = p, e[17] = g) : g = e[17];
  let h;
  return e[18] !== d || e[19] !== g ? (h = /* @__PURE__ */ m(f0, { container: d, children: g }), e[18] = d, e[19] = g, e[20] = h) : h = e[20], h;
}
const Kw = {
  operational: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  critical: "bg-datavis-crit-red",
  inactive: "bg-surface-container-high"
}, qw = 32, Zw = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Xw = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
function Qw(t) {
  if (t < 1 || t > 12)
    throw new RangeError(`AssetTimeline requires between 1 and 12 consecutive months. Received ${t}.`);
}
function Jw(t) {
  const e = /* @__PURE__ */ new Date(), n = e.getMonth(), o = e.getFullYear();
  return Array.from({
    length: t
  }, (r, i) => {
    const s = t - i - 1, l = new Date(o, n - s, 1), a = l.getMonth(), c = l.getFullYear();
    return {
      shortLabel: Zw[a],
      longLabel: `${Xw[a]} ${c}`,
      key: `${c}-${a}`
    };
  });
}
function h0(t) {
  return t.markerCount ?? t.events?.length ?? 0;
}
function eS(t) {
  const e = t.reduce((o, r) => (o[r.severity] += 1, o), {
    operational: 0,
    warning: 0,
    critical: 0,
    inactive: 0
  }), n = (o, r) => `${o} ${r} ${o === 1 ? "month" : "months"}`;
  return `Asset timeline: ${n(e.operational, "operational")}, ${n(e.warning, "warning")}, ${n(e.critical, "critical")}, ${n(e.inactive, "inactive")}.`;
}
function cg(t, e) {
  const n = h0(t), o = n === 1 ? "1 event" : `${n} events`;
  return n > 0 ? `${e.longLabel}: ${t.severity}, ${o}` : `${e.longLabel}: ${t.severity}, no events`;
}
function tS(t) {
  const e = z.c(3), {
    count: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m("svg", { "aria-hidden": "true", viewBox: "0 0 8 8", className: "size-(--spacing-8) fill-informative group-focus-visible/asset-timeline-marker:fill-primary-on-primary", children: /* @__PURE__ */ m("path", { d: "M4 8C5.06087 8 6.07828 7.57857 6.82843 6.82843C7.57857 6.07828 8 5.06087 8 4C8 2.93913 7.57857 1.92172 6.82843 1.17157C6.07828 0.421427 5.06087 0 4 0C2.93913 0 1.92172 0.421427 1.17157 1.17157C0.421427 1.92172 0 2.93913 0 4C0 5.06087 0.421427 6.07828 1.17157 6.82843C1.92172 7.57857 2.93913 8 4 8ZM4 2.5C4.39782 2.5 4.77936 2.65804 5.06066 2.93934C5.34196 3.22064 5.5 3.60218 5.5 4C5.5 4.39782 5.34196 4.77936 5.06066 5.06066C4.77936 5.34196 4.39782 5.5 4 5.5C3.60218 5.5 3.22064 5.34196 2.93934 5.06066C2.65804 4.77936 2.5 4.39782 2.5 4C2.5 3.60218 2.65804 3.22064 2.93934 2.93934C3.22064 2.65804 3.60218 2.5 4 2.5Z" }) }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-marker", className: "inline-flex h-(--spacing-20) min-w-(--spacing-32) items-center justify-center gap-(--spacing-2) rounded-(--radius-xs) border border-outline-subtle bg-surface-container-lowest px-(--spacing-6) font-(family-name:--font-family-label) font-(number:--font-weight-medium) text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-default group-hover/asset-timeline-marker:bg-surface-container group-focus-visible/asset-timeline-marker:bg-primary group-focus-visible/asset-timeline-marker:text-primary-on-primary", children: [
    o,
    n
  ] }), e[1] = n, e[2] = r) : r = e[2], r;
}
function nS(t) {
  const e = z.c(6), {
    count: n,
    ariaLabel: o,
    onClick: r
  } = t;
  let i;
  e[0] !== n ? (i = /* @__PURE__ */ m(tS, { count: n }), e[0] = n, e[1] = i) : i = e[1];
  let s;
  return e[2] !== o || e[3] !== r || e[4] !== i ? (s = /* @__PURE__ */ m("button", { type: "button", "aria-label": o, "data-testid": "asset-timeline-event-marker", "data-test-id": "asset-timeline-event-marker", className: "group/asset-timeline-marker cursor-pointer rounded-(--radius-xs) border-0 bg-transparent p-0 outline-none", onClick: r, children: i }), e[2] = o, e[3] = r, e[4] = i, e[5] = s) : s = e[5], s;
}
function oS(t) {
  const e = z.c(43), {
    month: n,
    meta: o,
    monthIndex: r,
    renderHoverCard: i,
    onMonthClick: s
  } = t, l = h0(n);
  let a, c;
  e[0] !== o.longLabel || e[1] !== o.shortLabel || e[2] !== n || e[3] !== r || e[4] !== i ? (a = {
    month: n,
    monthIndex: r,
    monthLabel: o.shortLabel,
    monthLongLabel: o.longLabel
  }, c = i?.(a), e[0] = o.longLabel, e[1] = o.shortLabel, e[2] = n, e[3] = r, e[4] = i, e[5] = a, e[6] = c) : (a = e[5], c = e[6]);
  const u = c;
  let d;
  e[7] !== u || e[8] !== o || e[9] !== n ? (d = u ? {} : {
    role: "img",
    "aria-label": cg(n, o)
  }, e[7] = u, e[8] = o, e[9] = n, e[10] = d) : d = e[10];
  const f = Kw[n.severity];
  let p;
  e[11] !== f ? (p = ne("flex h-(--spacing-12) w-full", f), e[11] = f, e[12] = p) : p = e[12];
  let g;
  e[13] !== u || e[14] !== o || e[15] !== n ? (g = u ? /* @__PURE__ */ F(Gw, { children: [
    /* @__PURE__ */ m(Yw, { delay: 0, closeDelay: 0, render: /* @__PURE__ */ m("button", { type: "button", "aria-label": cg(n, o), className: "block h-full w-full cursor-pointer border-0 bg-transparent p-0 text-center outline-none focus-visible:ring-(--spacing-2) focus-visible:ring-button-focus-ring focus-visible:ring-offset-(--focus-ring-offset) focus-visible:ring-offset-surface" }) }),
    /* @__PURE__ */ m(jw, { className: "overflow-hidden", sideOffset: qw, children: u })
  ] }) : null, e[13] = u, e[14] = o, e[15] = n, e[16] = g) : g = e[16];
  let h;
  e[17] !== d || e[18] !== p || e[19] !== g ? (h = /* @__PURE__ */ m("div", { "data-testid": "asset-timeline-fill", "data-test-id": "asset-timeline-fill", ...d, className: p, children: g }), e[17] = d, e[18] = p, e[19] = g, e[20] = h) : h = e[20];
  const b = h;
  let v;
  e[21] !== o.shortLabel ? (v = o.shortLabel.slice(0, 1), e[21] = o.shortLabel, e[22] = v) : v = e[22];
  let C;
  e[23] !== v ? (C = /* @__PURE__ */ m("span", { className: "@min-[48px]/asset-timeline-month:hidden", children: v }), e[23] = v, e[24] = C) : C = e[24];
  let y;
  e[25] !== o.shortLabel ? (y = /* @__PURE__ */ m("span", { className: "hidden @min-[48px]/asset-timeline-month:inline", children: o.shortLabel }), e[25] = o.shortLabel, e[26] = y) : y = e[26];
  let w;
  e[27] !== C || e[28] !== y ? (w = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "pt-(--spacing-4) font-(family-name:--font-family-title) font-(number:--font-weight-medium) text-(length:--font-size-title-xs) leading-(--font-line-height-20) text-text-subtle", children: [
    C,
    y
  ] }), e[27] = C, e[28] = y, e[29] = w) : w = e[29];
  const R = w;
  let S;
  e[30] !== l || e[31] !== o.longLabel || e[32] !== a || e[33] !== s ? (S = l > 0 ? /* @__PURE__ */ m(nS, { count: l, ariaLabel: `${o.longLabel}: ${l} monthly events`, onClick: () => s?.(a) }) : null, e[30] = l, e[31] = o.longLabel, e[32] = a, e[33] = s, e[34] = S) : S = e[34];
  const E = S;
  let N;
  e[35] !== b || e[36] !== R ? (N = /* @__PURE__ */ F(zt, { children: [
    b,
    R
  ] }), e[35] = b, e[36] = R, e[37] = N) : N = e[37];
  const T = N;
  let P;
  e[38] !== E ? (P = E ? /* @__PURE__ */ m("span", { className: "absolute bottom-(--spacing-40)", children: E }) : null, e[38] = E, e[39] = P) : P = e[39];
  let I;
  return e[40] !== P || e[41] !== T ? (I = /* @__PURE__ */ m("div", { "data-testid": "asset-timeline-month", "data-test-id": "asset-timeline-month", className: "@container/asset-timeline-month flex w-full min-w-0 flex-col items-center text-center", children: /* @__PURE__ */ F("span", { "data-slot": "asset-timeline-month-content", className: "relative flex w-full flex-col items-center pt-(--spacing-24)", children: [
    P,
    T
  ] }) }), e[40] = P, e[41] = T, e[42] = I) : I = e[42], I;
}
function ZO(t) {
  const e = z.c(28);
  let n, o, r, i;
  e[0] !== t ? ({
    months: r,
    ariaLabel: n,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]), Qw(r.length);
  const s = "renderHoverCard" in i ? i.renderHoverCard : void 0, l = "onMonthClick" in i ? i.onMonthClick : void 0;
  let a;
  e[5] !== r.length ? (a = Jw(r.length), e[5] = r.length, e[6] = a) : a = e[6];
  const c = a, u = `repeat(${r.length}, minmax(0, 1fr))`;
  let d;
  e[7] !== u ? (d = {
    gridTemplateColumns: u
  }, e[7] = u, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== n || e[10] !== r ? (p = n ?? eS(r), e[9] = n, e[10] = r, e[11] = p) : p = e[11];
  let g;
  e[12] !== o ? (g = ne("grid w-full min-w-0 items-end gap-x-(--spacing-1)", o), e[12] = o, e[13] = g) : g = e[13];
  let h;
  if (e[14] !== c || e[15] !== r || e[16] !== l || e[17] !== s) {
    let v;
    e[19] !== c || e[20] !== l || e[21] !== s ? (v = (C, y) => /* @__PURE__ */ m(oS, { month: C, meta: c[y], monthIndex: y, renderHoverCard: s, onMonthClick: l }, c[y].key), e[19] = c, e[20] = l, e[21] = s, e[22] = v) : v = e[22], h = r.map(v), e[14] = c, e[15] = r, e[16] = l, e[17] = s, e[18] = h;
  } else
    h = e[18];
  let b;
  return e[23] !== f || e[24] !== p || e[25] !== g || e[26] !== h ? (b = /* @__PURE__ */ m("section", { "data-testid": "asset-timeline", "data-test-id": "asset-timeline", "aria-label": p, className: g, style: f, children: h }), e[23] = f, e[24] = p, e[25] = g, e[26] = h, e[27] = b) : b = e[27], b;
}
const rS = ce(["w-[min(calc(100vw_-_(var(--spacing-16)_*_2)),var(--modal-size))]", "max-w-(--modal-size)", "min-w-0", "max-h-[calc(100vh_-_var(--spacing-32))]", "flex flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5", "p-(--spacing-20)", "outline-none", "max-[599px]:min-h-[230px]", "max-[599px]:max-h-[min(680px,calc(100dvh_-_var(--spacing-16)))]", "max-[599px]:w-full", "max-[599px]:max-w-none", "max-[599px]:rounded-b-none", "max-[599px]:pb-[calc(var(--spacing-20)_+_env(safe-area-inset-bottom))]"], {
  variants: {
    size: {
      sm: "[--modal-size:320px]",
      md: "[--modal-size:600px]",
      lg: "[--modal-size:1100px]"
    }
  }
}), iS = ce("shrink-0 mt-(--spacing-20) flex gap-(--spacing-16)", {
  variants: {
    size: {
      sm: ["h-auto", "flex-col-reverse", "items-stretch", "[&>*]:w-full"],
      md: "h-(--spacing-40) items-center justify-end",
      lg: "h-(--spacing-40) items-center justify-end"
    }
  }
}), sS = ce(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-28)", "text-text-default"]), lS = ce(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]);
function ug(t) {
  const e = z.c(37), {
    open: n,
    onOpenChange: o,
    title: r,
    description: i,
    dismissible: s,
    size: l,
    children: a,
    footer: c
  } = t, u = s === void 0 ? !0 : s, d = qt(), f = l ?? "md";
  let p;
  e[0] !== u || e[1] !== o ? (p = (M, D) => {
    if (!u && !M && (D.reason === "escape-key" || D.reason === "outside-press")) {
      D.cancel();
      return;
    }
    o(M);
  }, e[0] = u, e[1] = o, e[2] = p) : p = e[2];
  const g = p, h = !u;
  let b;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ m(Ns, { className: "fixed inset-0 z-[var(--z-layer-dialog)] bg-surface-scrim" }), e[3] = b) : b = e[3];
  let v;
  e[4] !== f ? (v = ne(rS({
    size: f
  })), e[4] = f, e[5] = v) : v = e[5];
  let C;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ne(sS()), e[6] = C) : C = e[6];
  let y;
  e[7] !== r ? (y = /* @__PURE__ */ m(Ji, { className: C, children: r }), e[7] = r, e[8] = y) : y = e[8];
  let w;
  e[9] !== u ? (w = u && /* @__PURE__ */ m(Zr, { render: /* @__PURE__ */ m(mt, { icon: "x-close", "aria-label": "Close", variant: "ghost", size: "sm" }) }), e[9] = u, e[10] = w) : w = e[10];
  let R;
  e[11] !== y || e[12] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
    y,
    w
  ] }), e[11] = y, e[12] = w, e[13] = R) : R = e[13];
  let S;
  e[14] !== i ? (S = i && /* @__PURE__ */ m(Qi, { className: ne(lS()), children: i }), e[14] = i, e[15] = S) : S = e[15];
  let E;
  e[16] !== S || e[17] !== R ? (E = /* @__PURE__ */ F("div", { className: "shrink-0 flex flex-col gap-(--spacing-6)", children: [
    R,
    S
  ] }), e[16] = S, e[17] = R, e[18] = E) : E = e[18];
  let N;
  e[19] !== a ? (N = a && /* @__PURE__ */ m("div", { className: "min-h-0 mt-(--spacing-20) overflow-y-auto", children: a }), e[19] = a, e[20] = N) : N = e[20];
  let T;
  e[21] !== c || e[22] !== f ? (T = c && /* @__PURE__ */ m("div", { className: ne(iS({
    size: f
  })), children: c }), e[21] = c, e[22] = f, e[23] = T) : T = e[23];
  let P;
  e[24] !== E || e[25] !== N || e[26] !== T || e[27] !== v ? (P = /* @__PURE__ */ m(bi, { className: "fixed inset-0 z-[var(--z-layer-dialog)] flex items-center justify-center max-[599px]:items-end", children: /* @__PURE__ */ F(mi, { "aria-modal": "true", className: v, children: [
    E,
    N,
    T
  ] }) }), e[24] = E, e[25] = N, e[26] = T, e[27] = v, e[28] = P) : P = e[28];
  let I;
  e[29] !== d || e[30] !== P ? (I = /* @__PURE__ */ F(Tr, { container: d, children: [
    b,
    P
  ] }), e[29] = d, e[30] = P, e[31] = I) : I = e[31];
  let k;
  return e[32] !== g || e[33] !== n || e[34] !== I || e[35] !== h ? (k = /* @__PURE__ */ m(hi, { open: n, onOpenChange: g, modal: !0, disablePointerDismissal: h, children: I }), e[32] = g, e[33] = n, e[34] = I, e[35] = h, e[36] = k) : k = e[36], k;
}
const Fr = {
  complete: "complete",
  partial: "partial",
  failed: "failed",
  unknown: "unknown"
}, Vi = {
  complete: "Complete",
  partial: "Partial",
  failed: "Failed",
  unknown: "Unknown"
}, aS = {
  loadingReleaseInfo: "Loading release info...",
  copyRecord: "Copy record",
  openSsm: "Open SSM",
  openSsmAriaLabel: "Open SSM parameter",
  recordUnavailable: "Record unavailable",
  copyPrefix: "Copy",
  rows: {
    tag: "Tag",
    status: "Status",
    sha: "SHA",
    requestedRef: "Requested ref",
    deployedAt: "Deployed at",
    ssmParameter: "SSM parameter",
    selected: "Selected",
    deployed: "Deployed",
    failed: "Failed",
    terraform: "Terraform",
    api: "API",
    frontend: "Frontend"
  },
  links: {
    githubTag: "GitHub tag",
    githubCommit: "GitHub commit",
    workflowRun: "Workflow run"
  },
  status: Vi,
  values: {
    unknown: "unknown",
    none: "none",
    notSelected: "not selected",
    deployed: "deployed"
  }
}, XO = {
  [Fr.complete]: {
    label: Vi.complete,
    icon: "circle-check",
    iconTone: "positive"
  },
  [Fr.failed]: {
    label: Vi.failed,
    icon: "circle-exclamation",
    iconTone: "negative"
  },
  [Fr.partial]: {
    label: Vi.partial,
    icon: "warning",
    iconTone: "warning"
  },
  [Fr.unknown]: {
    label: Vi.unknown,
    icon: "circle-info",
    iconTone: "neutral"
  }
};
function dg(t, e = "unknown") {
  return t ? t.slice(0, 12) : e;
}
function cS(t) {
  return t ?? Fr.unknown;
}
function uS(t, e) {
  return e[t];
}
function dS(t, e) {
  if (!e)
    return "";
  const n = encodeURIComponent(encodeURIComponent(e));
  return `https://${t}.console.aws.amazon.com/systems-manager/parameters/${n}/description?region=${t}`;
}
function fS({
  appName: t,
  environment: e,
  recordParameterName: n,
  commitId: o,
  branchName: r,
  releaseTag: i
}) {
  return {
    app: t,
    environment: e,
    parameterName: n,
    status: Fr.unknown,
    sourceSha: o,
    requestedRef: r,
    releaseTag: i,
    selectedParts: [],
    deployedParts: [],
    failedParts: [],
    parts: {
      terraform: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      api: {
        selected: !1,
        result: "unknown",
        deployed: !1
      },
      frontend: {
        selected: !1,
        result: "unknown",
        deployed: !1
      }
    }
  };
}
function gc(t, e) {
  return !t || t.length === 0 ? e : t.join(", ");
}
function pS(t, e) {
  if (!t)
    return e;
  const n = new Date(t);
  return Number.isNaN(n.getTime()) ? t : n.toLocaleString();
}
function mc(t, e) {
  return t ? t.selected ? t.deployed ? e.deployed : t.result ?? e.unknown : e.notSelected : e.unknown;
}
function hc(t) {
  const e = z.c(23);
  let n, o, r, i, s, l, a, c, u;
  if (e[0] !== t) {
    const {
      size: p,
      destructive: g,
      disabled: h,
      children: b,
      ...v
    } = t;
    n = b, s = v;
    const C = p === void 0 ? "md" : p, y = g === void 0 ? !1 : g;
    r = h === void 0 ? !1 : h, i = "onClick" in t && t.onClick !== void 0 && !("href" in t && t.href !== void 0), o = F2({
      size: C,
      variant: i ? "navigational" : "contextual",
      destructive: y,
      disabled: r
    });
    const {
      render: w,
      href: R,
      target: S,
      rel: E,
      ...N
    } = i ? {} : s, T = S === "_blank" && !E ? "noopener noreferrer" : E;
    u = Jd, l = "a", a = w, c = en(N, {
      ...R !== void 0 && {
        href: R
      },
      ...S !== void 0 && {
        target: S
      },
      ...T !== void 0 && {
        rel: T
      },
      ...r && {
        href: void 0,
        tabIndex: -1,
        onClick: gS
      },
      "aria-disabled": r || void 0,
      className: o,
      children: n
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9];
  let d;
  e[10] !== l || e[11] !== a || e[12] !== c ? (d = {
    defaultTagName: l,
    render: a,
    props: c
  }, e[10] = l, e[11] = a, e[12] = c, e[13] = d) : d = e[13];
  const f = u(d);
  if (i) {
    const p = s;
    let g, h;
    e[14] !== p ? ({
      onClick: h,
      ...g
    } = p, e[14] = p, e[15] = g, e[16] = h) : (g = e[15], h = e[16]);
    const b = g, v = r ? void 0 : h, C = r || void 0;
    let y;
    return e[17] !== n || e[18] !== o || e[19] !== b || e[20] !== v || e[21] !== C ? (y = /* @__PURE__ */ m("button", { ...b, type: "button", onClick: v, "aria-disabled": C, className: o, children: n }), e[17] = n, e[18] = o, e[19] = b, e[20] = v, e[21] = C, e[22] = y) : y = e[22], y;
  }
  return f;
}
function gS(t) {
  return t.preventDefault();
}
function mS(t) {
  const e = z.c(13), {
    display: n,
    labels: o
  } = t;
  let r;
  e[0] !== n.githubTagUrl || e[1] !== o ? (r = n.githubTagUrl ? /* @__PURE__ */ m(hc, { href: n.githubTagUrl, target: "_blank", rel: "noreferrer", children: o.links.githubTag }) : null, e[0] = n.githubTagUrl, e[1] = o, e[2] = r) : r = e[2];
  let i;
  e[3] !== n.githubCommitUrl || e[4] !== o ? (i = n.githubCommitUrl ? /* @__PURE__ */ m(hc, { href: n.githubCommitUrl, target: "_blank", rel: "noreferrer", children: o.links.githubCommit }) : null, e[3] = n.githubCommitUrl, e[4] = o, e[5] = i) : i = e[5];
  let s;
  e[6] !== n.record.workflowRunUrl || e[7] !== o ? (s = n.record.workflowRunUrl ? /* @__PURE__ */ m(hc, { href: n.record.workflowRunUrl, target: "_blank", rel: "noreferrer", children: o.links.workflowRun }) : null, e[6] = n.record.workflowRunUrl, e[7] = o, e[8] = s) : s = e[8];
  let l;
  return e[9] !== r || e[10] !== i || e[11] !== s ? (l = /* @__PURE__ */ F("div", { className: "flex flex-wrap gap-(--spacing-12)", children: [
    r,
    i,
    s
  ] }), e[9] = r, e[10] = i, e[11] = s, e[12] = l) : l = e[12], l;
}
function Tn(t) {
  const e = z.c(17), {
    label: n,
    value: o,
    copyValue: r,
    copiedLabel: i,
    copyPrefix: s,
    onCopy: l,
    unknownValue: a,
    noneValue: c
  } = t, u = r ?? o, d = typeof navigator < "u" && !!navigator.clipboard?.writeText, f = !!(u && u !== a && u !== c), p = i === n;
  let g;
  e[0] !== n ? (g = /* @__PURE__ */ m("div", { className: "max-sm:col-span-2", children: /* @__PURE__ */ m(ln, { as: "div", size: "sm", tone: "subtle", children: n }) }), e[0] = n, e[1] = g) : g = e[1];
  const h = o || a;
  let b;
  e[2] !== h ? (b = /* @__PURE__ */ m("code", { className: "min-w-0 truncate rounded-(--radius-sm) bg-surface-container px-(--spacing-8) py-(--spacing-4) font-mono text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: h }), e[2] = h, e[3] = b) : b = e[3];
  const v = p ? "check-mark" : "copy-regular", C = `${s} ${n}`, y = !f || !d;
  let w;
  e[4] !== n || e[5] !== l || e[6] !== u ? (w = () => {
    l(u, n);
  }, e[4] = n, e[5] = l, e[6] = u, e[7] = w) : w = e[7];
  let R;
  e[8] !== v || e[9] !== C || e[10] !== y || e[11] !== w ? (R = /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: v, "aria-label": C, disabled: y, onClick: w }), e[8] = v, e[9] = C, e[10] = y, e[11] = w, e[12] = R) : R = e[12];
  let S;
  return e[13] !== g || e[14] !== b || e[15] !== R ? (S = /* @__PURE__ */ F("div", { className: "grid grid-cols-[128px_minmax(0,1fr)_var(--spacing-32)] items-center gap-(--spacing-8) border-b border-outline-subtle py-(--spacing-8) last:border-b-0 max-sm:grid-cols-[1fr_var(--spacing-32)]", children: [
    g,
    b,
    R
  ] }), e[13] = g, e[14] = b, e[15] = R, e[16] = S) : S = e[16], S;
}
function hS(t) {
  const e = z.c(76), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t, s = r.rows.selected;
  let l;
  e[0] !== n.record.selectedParts || e[1] !== r.values.none ? (l = gc(n.record.selectedParts, r.values.none), e[0] = n.record.selectedParts, e[1] = r.values.none, e[2] = l) : l = e[2];
  let a;
  e[3] !== o || e[4] !== r.copyPrefix || e[5] !== r.rows.selected || e[6] !== r.values.none || e[7] !== r.values.unknown || e[8] !== i || e[9] !== l ? (a = /* @__PURE__ */ m(Tn, { label: s, value: l, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[3] = o, e[4] = r.copyPrefix, e[5] = r.rows.selected, e[6] = r.values.none, e[7] = r.values.unknown, e[8] = i, e[9] = l, e[10] = a) : a = e[10];
  const c = r.rows.deployed;
  let u;
  e[11] !== n.record.deployedParts || e[12] !== r.values.none ? (u = gc(n.record.deployedParts, r.values.none), e[11] = n.record.deployedParts, e[12] = r.values.none, e[13] = u) : u = e[13];
  let d;
  e[14] !== o || e[15] !== r.copyPrefix || e[16] !== r.rows.deployed || e[17] !== r.values.none || e[18] !== r.values.unknown || e[19] !== i || e[20] !== u ? (d = /* @__PURE__ */ m(Tn, { label: c, value: u, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[14] = o, e[15] = r.copyPrefix, e[16] = r.rows.deployed, e[17] = r.values.none, e[18] = r.values.unknown, e[19] = i, e[20] = u, e[21] = d) : d = e[21];
  const f = r.rows.failed;
  let p;
  e[22] !== n.record.failedParts || e[23] !== r.values.none ? (p = gc(n.record.failedParts, r.values.none), e[22] = n.record.failedParts, e[23] = r.values.none, e[24] = p) : p = e[24];
  let g;
  e[25] !== o || e[26] !== r.copyPrefix || e[27] !== r.rows.failed || e[28] !== r.values.none || e[29] !== r.values.unknown || e[30] !== i || e[31] !== p ? (g = /* @__PURE__ */ m(Tn, { label: f, value: p, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[25] = o, e[26] = r.copyPrefix, e[27] = r.rows.failed, e[28] = r.values.none, e[29] = r.values.unknown, e[30] = i, e[31] = p, e[32] = g) : g = e[32];
  const h = r.rows.terraform, b = n.record.parts?.terraform;
  let v;
  e[33] !== r.values || e[34] !== b ? (v = mc(b, r.values), e[33] = r.values, e[34] = b, e[35] = v) : v = e[35];
  const C = n.record.parts?.terraform?.sha;
  let y;
  e[36] !== o || e[37] !== r.copyPrefix || e[38] !== r.rows.terraform || e[39] !== r.values.none || e[40] !== r.values.unknown || e[41] !== i || e[42] !== v || e[43] !== C ? (y = /* @__PURE__ */ m(Tn, { label: h, value: v, copyValue: C, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[36] = o, e[37] = r.copyPrefix, e[38] = r.rows.terraform, e[39] = r.values.none, e[40] = r.values.unknown, e[41] = i, e[42] = v, e[43] = C, e[44] = y) : y = e[44];
  const w = r.rows.api, R = n.record.parts?.api;
  let S;
  e[45] !== r.values || e[46] !== R ? (S = mc(R, r.values), e[45] = r.values, e[46] = R, e[47] = S) : S = e[47];
  const E = n.record.parts?.api?.image ?? n.record.apiImage;
  let N;
  e[48] !== o || e[49] !== r.copyPrefix || e[50] !== r.rows.api || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i || e[54] !== S || e[55] !== E ? (N = /* @__PURE__ */ m(Tn, { label: w, value: S, copyValue: E, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[48] = o, e[49] = r.copyPrefix, e[50] = r.rows.api, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = S, e[55] = E, e[56] = N) : N = e[56];
  const T = r.rows.frontend, P = n.record.parts?.frontend;
  let I;
  e[57] !== r.values || e[58] !== P ? (I = mc(P, r.values), e[57] = r.values, e[58] = P, e[59] = I) : I = e[59];
  const k = n.record.parts?.frontend?.cloudfrontDistributionId ?? n.record.frontendCloudfrontDistributionId;
  let M;
  e[60] !== o || e[61] !== r.copyPrefix || e[62] !== r.rows.frontend || e[63] !== r.values.none || e[64] !== r.values.unknown || e[65] !== i || e[66] !== I || e[67] !== k ? (M = /* @__PURE__ */ m(Tn, { label: T, value: I, copyValue: k, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[60] = o, e[61] = r.copyPrefix, e[62] = r.rows.frontend, e[63] = r.values.none, e[64] = r.values.unknown, e[65] = i, e[66] = I, e[67] = k, e[68] = M) : M = e[68];
  let D;
  return e[69] !== y || e[70] !== N || e[71] !== M || e[72] !== a || e[73] !== d || e[74] !== g ? (D = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    a,
    d,
    g,
    y,
    N,
    M
  ] }), e[69] = y, e[70] = N, e[71] = M, e[72] = a, e[73] = d, e[74] = g, e[75] = D) : D = e[75], D;
}
function bS(t) {
  const e = z.c(62), {
    display: n,
    copiedLabel: o,
    labels: r,
    onCopy: i
  } = t;
  let s;
  e[0] !== o || e[1] !== n.displayTag || e[2] !== r.copyPrefix || e[3] !== r.rows.tag || e[4] !== r.values.none || e[5] !== r.values.unknown || e[6] !== i ? (s = /* @__PURE__ */ m(Tn, { label: r.rows.tag, value: n.displayTag, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[0] = o, e[1] = n.displayTag, e[2] = r.copyPrefix, e[3] = r.rows.tag, e[4] = r.values.none, e[5] = r.values.unknown, e[6] = i, e[7] = s) : s = e[7];
  const l = r.rows.status;
  let a;
  e[8] !== n.status || e[9] !== r.status ? (a = uS(n.status, r.status), e[8] = n.status, e[9] = r.status, e[10] = a) : a = e[10];
  let c;
  e[11] !== o || e[12] !== r.copyPrefix || e[13] !== r.rows.status || e[14] !== r.values.none || e[15] !== r.values.unknown || e[16] !== i || e[17] !== a ? (c = /* @__PURE__ */ m(Tn, { label: l, value: a, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[11] = o, e[12] = r.copyPrefix, e[13] = r.rows.status, e[14] = r.values.none, e[15] = r.values.unknown, e[16] = i, e[17] = a, e[18] = c) : c = e[18];
  let u;
  e[19] !== o || e[20] !== n.shortSha || e[21] !== n.sourceSha || e[22] !== r.copyPrefix || e[23] !== r.rows.sha || e[24] !== r.values.none || e[25] !== r.values.unknown || e[26] !== i ? (u = /* @__PURE__ */ m(Tn, { label: r.rows.sha, value: n.shortSha, copyValue: n.sourceSha, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[19] = o, e[20] = n.shortSha, e[21] = n.sourceSha, e[22] = r.copyPrefix, e[23] = r.rows.sha, e[24] = r.values.none, e[25] = r.values.unknown, e[26] = i, e[27] = u) : u = e[27];
  const d = n.record.requestedRef ?? r.values.unknown;
  let f;
  e[28] !== o || e[29] !== r.copyPrefix || e[30] !== r.rows.requestedRef || e[31] !== r.values.none || e[32] !== r.values.unknown || e[33] !== i || e[34] !== d ? (f = /* @__PURE__ */ m(Tn, { label: r.rows.requestedRef, value: d, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[28] = o, e[29] = r.copyPrefix, e[30] = r.rows.requestedRef, e[31] = r.values.none, e[32] = r.values.unknown, e[33] = i, e[34] = d, e[35] = f) : f = e[35];
  const p = r.rows.deployedAt;
  let g;
  e[36] !== n.record.deployedAt || e[37] !== r.values.unknown ? (g = pS(n.record.deployedAt, r.values.unknown), e[36] = n.record.deployedAt, e[37] = r.values.unknown, e[38] = g) : g = e[38];
  let h;
  e[39] !== o || e[40] !== r.copyPrefix || e[41] !== r.rows.deployedAt || e[42] !== r.values.none || e[43] !== r.values.unknown || e[44] !== i || e[45] !== g ? (h = /* @__PURE__ */ m(Tn, { label: p, value: g, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[39] = o, e[40] = r.copyPrefix, e[41] = r.rows.deployedAt, e[42] = r.values.none, e[43] = r.values.unknown, e[44] = i, e[45] = g, e[46] = h) : h = e[46];
  let b;
  e[47] !== o || e[48] !== n.parameterName || e[49] !== r.copyPrefix || e[50] !== r.rows.ssmParameter || e[51] !== r.values.none || e[52] !== r.values.unknown || e[53] !== i ? (b = /* @__PURE__ */ m(Tn, { label: r.rows.ssmParameter, value: n.parameterName, copiedLabel: o, copyPrefix: r.copyPrefix, onCopy: i, unknownValue: r.values.unknown, noneValue: r.values.none }), e[47] = o, e[48] = n.parameterName, e[49] = r.copyPrefix, e[50] = r.rows.ssmParameter, e[51] = r.values.none, e[52] = r.values.unknown, e[53] = i, e[54] = b) : b = e[54];
  let v;
  return e[55] !== s || e[56] !== h || e[57] !== b || e[58] !== c || e[59] !== u || e[60] !== f ? (v = /* @__PURE__ */ F("div", { className: "rounded-(--radius-sm) border border-outline-subtle bg-surface-container-lowest px-(--spacing-12)", children: [
    s,
    c,
    u,
    f,
    h,
    b
  ] }), e[55] = s, e[56] = h, e[57] = b, e[58] = c, e[59] = u, e[60] = f, e[61] = v) : v = e[61], v;
}
function QO({
  open: t,
  onOpenChange: e,
  appName: n,
  appLabel: o = n,
  labels: r = aS,
  environment: i = "local",
  branchName: s = "local",
  commitId: l = "local",
  releaseTag: a = "",
  recordParameterName: c = `/assetwatch/deployments/${i}/${n}`,
  record: u,
  isRecordLoading: d = !1,
  isRecordUnavailable: f = !1,
  awsRegion: p = "us-east-2",
  repoFullName: g = "AssetWatch1/fullstack.assetwatch",
  modalTitle: h = `${o} Release Info`,
  modalDescription: b = `Current ${o} release information for this environment.`
}) {
  const [v, C] = ot(null), y = typeof navigator < "u" && !!navigator.clipboard?.writeText;
  async function w(V, _) {
    !V || !y || (await navigator.clipboard.writeText(V), C(_), window.setTimeout(() => C(null), 1600));
  }
  if (d)
    return /* @__PURE__ */ m(ug, { open: t, onOpenChange: e, title: h, description: b, children: /* @__PURE__ */ F(hr, { gap: 8, children: [
      /* @__PURE__ */ m(Vu, { size: "sm" }),
      /* @__PURE__ */ m(ln, { size: "sm", tone: "subtle", children: r.loadingReleaseInfo })
    ] }) });
  const R = u ?? fS({
    appName: n,
    environment: i,
    recordParameterName: c,
    commitId: l,
    branchName: s,
    releaseTag: a
  }), S = cS(R.status), E = R.releaseTag || a || `${R.environment ?? "local"}-${dg(R.sourceSha, r.values.unknown)}`, N = R.sourceSha ?? l, T = dg(N, r.values.unknown), P = R.parameterName || c || r.values.unknown, I = dS(p, P), k = JSON.stringify(R, null, 2), M = R.releaseTag ? `https://github.com/${g}/tree/${R.releaseTag}` : "", D = N && N !== "local" ? `https://github.com/${g}/commit/${N}` : "", O = {
    appLabel: o,
    environment: R.environment ?? i,
    status: S,
    displayTag: E,
    sourceSha: N,
    shortSha: T,
    parameterName: P,
    ssmConsoleUrl: I,
    recordJson: k,
    githubTagUrl: M,
    githubCommitUrl: D,
    record: R
  };
  return /* @__PURE__ */ m(ug, { open: t, onOpenChange: e, title: h, description: b, footer: /* @__PURE__ */ F(hr, { gap: 8, children: [
    /* @__PURE__ */ m(_n, { variant: "outline", size: "sm", icon: v === "record" ? "check-mark" : "copy-regular", disabled: !y, onClick: () => {
      w(O.recordJson, "record");
    }, children: r.copyRecord }),
    O.ssmConsoleUrl ? /* @__PURE__ */ m(_n, { variant: "primary", size: "sm", icon: "arrow-up-right", render: /* @__PURE__ */ m("a", { href: O.ssmConsoleUrl, target: "_blank", rel: "noreferrer", "aria-label": r.openSsmAriaLabel, children: r.openSsm }), children: r.openSsm }) : null
  ] }), children: /* @__PURE__ */ F(qr, { gap: 16, children: [
    f ? /* @__PURE__ */ m(ln, { size: "sm", tone: "warning", children: r.recordUnavailable }) : null,
    /* @__PURE__ */ m(bS, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ m(hS, { display: O, copiedLabel: v, labels: r, onCopy: w }),
    /* @__PURE__ */ m(mS, { display: O, labels: r }),
    /* @__PURE__ */ m("pre", { className: "max-h-[220px] overflow-auto rounded-(--radius-sm) border border-outline-subtle bg-surface-container p-(--spacing-12) text-(length:--font-size-body-sm) leading-(--line-height-16) text-text-default", children: O.recordJson })
  ] }) });
}
function vS(t) {
  return t.split(/\s+/).filter(Boolean).slice(0, 2).map((e) => e[0]).join("").toUpperCase();
}
function JO(t) {
  const e = z.c(27), {
    company: n,
    selected: o,
    onSettingsClick: r
  } = t, i = o === void 0 ? !1 : o, {
    collapsed: s,
    closeMobileNavigation: l
  } = l0(), a = n.facilityCount === void 0 ? void 0 : n.facilityCount + (n.facilityCount === 1 ? " facility" : " facilities"), c = `relative flex h-[60px] min-w-0 items-center gap-(--spacing-6) rounded-(--radius-sm) border border-outline-subtle px-(--spacing-10)${i ? " bg-menu-item-selected" : " bg-surface"}${s ? " w-[60px] shrink-0 justify-center" : " w-full"}`, u = n.name;
  let d;
  e[0] !== n.name ? (d = vS(n.name), e[0] = n.name, e[1] = d) : d = e[1];
  let f;
  e[2] !== n.logoUrl || e[3] !== n.name || e[4] !== d ? (f = /* @__PURE__ */ m(Gr, { "aria-label": u, initials: d, src: n.logoUrl, variant: "external" }), e[2] = n.logoUrl, e[3] = n.name, e[4] = d, e[5] = f) : f = e[5];
  let p;
  e[6] !== s || e[7] !== n.name || e[8] !== a || e[9] !== r ? (p = !s && /* @__PURE__ */ F(zt, { children: [
    /* @__PURE__ */ F("span", { className: "min-w-0 flex-1", children: [
      /* @__PURE__ */ m("span", { className: "block truncate text-(length:--font-size-label-large) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-menu-text-default", children: n.name }),
      a && /* @__PURE__ */ m("span", { className: "block text-(length:--font-size-label-small) leading-(--font-line-height-16) text-text-subtle", children: a })
    ] }),
    r && /* @__PURE__ */ m("span", { "aria-hidden": !0, className: "shrink-0", children: /* @__PURE__ */ m(Ke, { name: "settings-cog", size: "sm", tone: "secondary" }) })
  ] }), e[6] = s, e[7] = n.name, e[8] = a, e[9] = r, e[10] = p) : p = e[10];
  let g;
  e[11] !== f || e[12] !== p ? (g = /* @__PURE__ */ F(zt, { children: [
    f,
    p
  ] }), e[11] = f, e[12] = p, e[13] = g) : g = e[13];
  const h = g;
  if (r) {
    const v = `Open ${n.name} settings`, C = i ? "page" : void 0, y = `${c} cursor-pointer text-left outline-none transition-colors duration-200 ease-in-out ${i ? "hover:bg-menu-item-selected" : "hover:bg-menu-item-hover"} focus-visible:ring-2 focus-visible:ring-menu-focus-ring focus-visible:ring-inset`, w = i || void 0;
    let R;
    e[14] !== l || e[15] !== r ? (R = () => {
      r(), l?.();
    }, e[14] = l, e[15] = r, e[16] = R) : R = e[16];
    let S;
    return e[17] !== h || e[18] !== w || e[19] !== R || e[20] !== v || e[21] !== C || e[22] !== y ? (S = /* @__PURE__ */ m("button", { "aria-label": v, "aria-current": C, className: y, "data-slot": "company-navigation", "data-selected": w, onClick: R, type: "button", children: h }), e[17] = h, e[18] = w, e[19] = R, e[20] = v, e[21] = C, e[22] = y, e[23] = S) : S = e[23], S;
  }
  let b;
  return e[24] !== c || e[25] !== h ? (b = /* @__PURE__ */ m("div", { className: c, "data-slot": "company-navigation", children: h }), e[24] = c, e[25] = h, e[26] = b) : b = e[26], b;
}
const pf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (pf.displayName = "ComboboxRootContext");
const gf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (gf.displayName = "ComboboxFloatingContext");
const mf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (mf.displayName = "ComboboxDerivedItemsContext");
const hf = /* @__PURE__ */ x.createContext("");
process.env.NODE_ENV !== "production" && (hf.displayName = "ComboboxInputValueContext");
function Cn() {
  const t = x.useContext(pf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxRootContext is missing. Combobox parts must be placed within <Combobox.Root>." : rt(22));
  return t;
}
function ba() {
  const t = x.useContext(gf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxFloatingContext is missing. Combobox parts must be placed within <Combobox.Root>." : rt(23));
  return t;
}
function _o() {
  const t = x.useContext(mf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxItemsContext is missing. Combobox parts must be placed within <Combobox.Root>." : rt(24));
  return t;
}
function bf() {
  return x.useContext(hf);
}
const b0 = (t, e) => Object.is(t, e);
function go(t, e, n) {
  return t == null || e == null ? Object.is(t, e) : n(t, e);
}
function v0(t, e, n) {
  return !t || t.length === 0 ? !1 : t.some((o) => o === void 0 ? !1 : go(e, o, n));
}
function Mo(t, e, n) {
  return !t || t.length === 0 ? -1 : t.findIndex((o) => o === void 0 ? !1 : go(o, e, n));
}
function y0(t, e, n) {
  return t.filter((o) => !go(e, o, n));
}
function Ul(t) {
  if (t == null)
    return "";
  if (typeof t == "string")
    return t;
  try {
    return JSON.stringify(t);
  } catch {
    return String(t);
  }
}
function vf(t) {
  return t != null && t.length > 0 && typeof t[0] == "object" && t[0] != null && "items" in t[0];
}
function x0(t) {
  if (!Array.isArray(t))
    return t != null && "null" in t;
  const e = t;
  if (vf(e)) {
    for (const n of e)
      for (const o of n.items)
        if (o && o.value == null && o.label != null)
          return !0;
    return !1;
  }
  for (const n of e)
    if (n && n.value == null && n.label != null)
      return !0;
  return !1;
}
function Jt(t, e) {
  if (e && t != null)
    return e(t) ?? "";
  if (t && typeof t == "object") {
    if ("label" in t && t.label != null)
      return String(t.label);
    if ("value" in t)
      return String(t.value);
  }
  return Ul(t);
}
function Un(t, e) {
  return e && t != null ? e(t) ?? "" : t && typeof t == "object" && "value" in t && "label" in t ? Ul(t.value) : Ul(t);
}
function C0(t, e, n) {
  function o() {
    return Jt(t, n);
  }
  if (n && t != null)
    return n(t);
  if (t && typeof t == "object" && "label" in t && t.label != null)
    return t.label;
  if (e && !Array.isArray(e))
    return e[t] ?? o();
  if (Array.isArray(e)) {
    const r = e, i = vf(r) ? r.flatMap((s) => s.items) : r;
    if (t == null || typeof t != "object") {
      const s = i.find((l) => l.value === t);
      return s && s.label != null ? s.label : o();
    }
    if ("value" in t) {
      const s = i.find((l) => l && l.value === t.value);
      if (s && s.label != null)
        return s.label;
    }
  }
  return o();
}
function yS(t, e, n) {
  return t.reduce((o, r, i) => (i > 0 && o.push(", "), o.push(/* @__PURE__ */ m(x.Fragment, {
    children: C0(r, e, n)
  }, i)), o), []);
}
const De = {
  id: he((t) => t.id),
  labelId: he((t) => t.labelId),
  items: he((t) => t.items),
  selectedValue: he((t) => t.selectedValue),
  hasSelectionChips: he((t) => {
    const e = t.selectedValue;
    return Array.isArray(e) && e.length > 0;
  }),
  hasSelectedValue: he((t) => {
    const {
      selectedValue: e,
      selectionMode: n
    } = t;
    return e == null ? !1 : n === "multiple" && Array.isArray(e) ? e.length > 0 : !0;
  }),
  hasNullItemLabel: he((t, e) => e ? x0(t.items) : !1),
  open: he((t) => t.open),
  mounted: he((t) => t.mounted),
  forceMounted: he((t) => t.forceMounted),
  inline: he((t) => t.inline),
  activeIndex: he((t) => t.activeIndex),
  selectedIndex: he((t) => t.selectedIndex),
  isActive: he((t, e) => t.activeIndex === e),
  isSelected: he((t, e) => {
    const n = t.isItemEqualToValue, o = t.selectedValue;
    return Array.isArray(o) ? o.some((r) => go(e, r, n)) : go(e, o, n);
  }),
  transitionStatus: he((t) => t.transitionStatus),
  popupProps: he((t) => t.popupProps),
  inputProps: he((t) => t.inputProps),
  triggerProps: he((t) => t.triggerProps),
  getItemProps: he((t) => t.getItemProps),
  positionerElement: he((t) => t.positionerElement),
  listElement: he((t) => t.listElement),
  triggerElement: he((t) => t.triggerElement),
  inputElement: he((t) => t.inputElement),
  inputGroupElement: he((t) => t.inputGroupElement),
  popupSide: he((t) => t.popupSide),
  openMethod: he((t) => t.openMethod),
  inputInsidePopup: he((t) => t.inputInsidePopup),
  selectionMode: he((t) => t.selectionMode),
  name: he((t) => t.name),
  form: he((t) => t.form),
  disabled: he((t) => t.disabled),
  readOnly: he((t) => t.readOnly),
  required: he((t) => t.required),
  grid: he((t) => t.grid),
  virtualized: he((t) => t.virtualized),
  itemToStringLabel: he((t) => t.itemToStringLabel),
  isItemEqualToValue: he((t) => t.isItemEqualToValue),
  modal: he((t) => t.modal),
  autoHighlight: he((t) => t.autoHighlight),
  submitOnItemClick: he((t) => t.submitOnItemClick)
};
function xS(t, e) {
  return (n, o) => {
    if (n == null)
      return !1;
    const r = Jt(n, e);
    return t.contains(r, o);
  };
}
function CS(t, e, n) {
  return (o, r) => {
    if (o == null)
      return !1;
    if (!r)
      return !0;
    const i = Jt(o, e), s = n != null ? Jt(n, e) : "";
    return s && t.contains(s, r) && s.length === r.length ? !0 : t.contains(i, r);
  };
}
const fg = /* @__PURE__ */ new Map();
function wS(t = {}) {
  const e = {
    usage: "search",
    sensitivity: "base",
    ignorePunctuation: !0,
    ...t
  }, n = `${w0(t.locale)}|${JSON.stringify(e)}`, o = fg.get(n);
  if (o)
    return o;
  const r = new Intl.Collator(t.locale, e), i = {
    contains(s, l, a) {
      if (!l)
        return !0;
      const c = Jt(s, a);
      for (let u = 0; u <= c.length - l.length; u += 1)
        if (r.compare(c.slice(u, u + l.length), l) === 0)
          return !0;
      return !1;
    },
    startsWith(s, l, a) {
      if (!l)
        return !0;
      const c = Jt(s, a);
      return r.compare(c.slice(0, l.length), l) === 0;
    },
    endsWith(s, l, a) {
      if (!l)
        return !0;
      const c = Jt(s, a), u = l.length;
      return c.length >= u && r.compare(c.slice(c.length - u), l) === 0;
    }
  };
  return fg.set(n, i), i;
}
function w0(t) {
  return Array.isArray(t) ? t.map((e) => w0(e)).join(",") : t == null ? "" : String(t);
}
const S0 = wS, R0 = /* @__PURE__ */ Symbol("none"), ir = {
  value: R0,
  index: -1
};
function E0(t) {
  const {
    id: e,
    onOpenChangeComplete: n,
    defaultSelectedValue: o = null,
    selectedValue: r,
    onSelectedValueChange: i,
    defaultInputValue: s,
    inputValue: l,
    open: a,
    defaultOpen: c = !1,
    selectionMode: u = "none",
    onItemHighlighted: d,
    name: f,
    form: p,
    disabled: g = !1,
    readOnly: h = !1,
    required: b = !1,
    inputRef: v,
    grid: C = !1,
    items: y,
    filteredItems: w,
    filter: R,
    openOnInputClick: S = !0,
    autoHighlight: E = !1,
    keepHighlight: N = !1,
    highlightItemOnHover: T = !0,
    loopFocus: P = !0,
    itemToStringLabel: I,
    itemToStringValue: k,
    isItemEqualToValue: M = b0,
    virtualized: D = !1,
    inline: O = !1,
    fillInputOnItemPress: V = !0,
    modal: _ = !1,
    limit: A = -1,
    autoComplete: L = "list",
    formAutoComplete: B,
    locale: G,
    submitOnItemClick: U = !1
  } = t, {
    clearErrors: Y
  } = Vo(), {
    setDirty: K,
    validityData: j,
    shouldValidateOnChange: Z,
    setFilled: te,
    name: W,
    disabled: X,
    setTouched: ee,
    setFocused: le,
    validationMode: J,
    validation: ie
  } = tn(), pe = Mr({
    id: e
  }), oe = S0({
    locale: G
  }), [re, de] = x.useState(!1), [xe, se] = x.useState(null), fe = x.useRef([]), $ = x.useRef([]), Q = x.useRef(null), H = x.useRef(null), q = x.useRef(null), ae = x.useRef(null), ge = x.useRef(null), ue = x.useRef(!0), Re = x.useRef(!1), be = x.useRef(null), ve = x.useRef(null), me = x.useRef(null), Ee = x.useRef(ir), Pe = x.useRef(null), Me = x.useRef([]), _e = x.useRef([]), Ue = X || g, Ye = W ?? f, He = u === "multiple", ye = u === "single", Oe = l !== void 0 || s !== void 0, Ie = y !== void 0, Le = w !== void 0;
  let Be;
  E === "always" ? Be = "always" : Be = E ? "input-change" : !1;
  const [Te, vt] = dn({
    controlled: r,
    default: He ? o ?? On : o,
    name: "Combobox",
    state: "selectedValue"
  }), nt = x.useMemo(() => R === null ? () => !0 : R !== void 0 ? R : ye && !re ? CS(oe, I, Te) : xS(oe, I), [R, ye, Te, re, oe, I]), we = Tt(() => Oe ? s ?? "" : ye ? Jt(Te, I) : "").current, [Ne, Ae] = dn({
    controlled: l,
    default: we,
    name: "Combobox",
    state: "inputValue"
  }), [Fe, Xe] = dn({
    controlled: a,
    default: c,
    name: "Combobox",
    state: "open"
  }), qe = vf(y), it = xe ?? (Ne === "" ? "" : String(Ne).trim()), Ge = ye ? Jt(Te, I) : "", Ze = ye && !re && it !== "" && Ge !== "" && Ge.length === it.length && oe.contains(Ge, it), tt = Ze ? "" : it, st = Ie && Le && Ze, gt = x.useMemo(() => y ? qe ? y.flatMap((je) => je.items) : y : On, [y, qe]), ht = x.useMemo(() => {
    if (w && !st)
      return w;
    if (!y)
      return On;
    if (qe) {
      const Qe = y, yt = [];
      let Et = 0;
      for (const Xt of Qe) {
        if (A > -1 && Et >= A)
          break;
        const Kt = tt === "" ? Xt.items : Xt.items.filter(($s) => nt($s, tt, I));
        if (Kt.length === 0)
          continue;
        const nr = A > -1 ? A - Et : 1 / 0, Lo = Kt.slice(0, nr);
        if (Lo.length > 0) {
          const $s = {
            ...Xt,
            items: Lo
          };
          yt.push($s), Et += Lo.length;
        }
      }
      return yt;
    }
    if (tt === "")
      return A > -1 ? gt.slice(0, A) : (
        // The cast here is done as `flatItems` is readonly.
        // valuesRef.current, a mutable ref, can be set to `flatFilteredItems`, which may
        // reference this exact readonly value, creating a mutation risk.
        // However, <Combobox.Item> can never mutate this value as the mutating effect
        // bails early when `items` is provided, and this is only ever returned
        // when `items` is provided due to the early return at the top of this hook.
        gt
      );
    const je = [];
    for (const Qe of gt) {
      if (A > -1 && je.length >= A)
        break;
      nt(Qe, tt, I) && je.push(Qe);
    }
    return je;
  }, [w, st, y, qe, tt, A, nt, I, gt]), Ot = x.useMemo(() => qe ? ht.flatMap((Qe) => Qe.items) : ht, [ht, qe]), ct = Tt(() => new fd({
    id: pe,
    labelId: void 0,
    selectedValue: Te,
    open: Fe,
    filter: nt,
    query: it,
    items: y,
    selectionMode: u,
    listRef: fe,
    labelsRef: $,
    popupRef: Q,
    emptyRef: ge,
    inputRef: H,
    startDismissRef: q,
    endDismissRef: ae,
    keyboardActiveRef: ue,
    chipsContainerRef: be,
    clearRef: ve,
    valuesRef: Me,
    allValuesRef: _e,
    selectionEventRef: me,
    name: Ye,
    form: p,
    disabled: Ue,
    readOnly: h,
    required: b,
    grid: C,
    isGrouped: qe,
    virtualized: D,
    openOnInputClick: S,
    itemToStringLabel: I,
    isItemEqualToValue: M,
    modal: _,
    autoHighlight: Be,
    submitOnItemClick: U,
    hasInputValue: Oe,
    mounted: !1,
    forceMounted: !1,
    transitionStatus: "idle",
    inline: O,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    inputProps: {},
    triggerProps: {},
    positionerElement: null,
    listElement: null,
    triggerElement: null,
    inputElement: null,
    inputGroupElement: null,
    popupSide: null,
    openMethod: null,
    inputInsidePopup: !0,
    onOpenChangeComplete: n || xt,
    // Placeholder callbacks replaced on first render
    setOpen: xt,
    setInputValue: xt,
    setSelectedValue: xt,
    setIndices: xt,
    onItemHighlighted: xt,
    handleSelection: xt,
    getItemProps: () => St,
    forceMount: xt,
    requestSubmit: xt
  })).current, Ht = u === "none" ? Ne : Te, no = x.useMemo(() => u === "none" ? Ht : Array.isArray(Te) ? Te.map((je) => Un(je, k)) : Un(Te, k), [Ht, k, u, Te]), bn = Se(d), Ln = Se(n), kn = Ce(ct, De.activeIndex), Mn = Ce(ct, De.selectedIndex), nn = Ce(ct, De.positionerElement), oo = Ce(ct, De.listElement), Zt = Ce(ct, De.triggerElement), Fn = Ce(ct, De.inputElement), Ci = Ce(ct, De.inputGroupElement), vn = Ce(ct, De.inline), $n = Ce(ct, De.inputInsidePopup), V3 = $t(Zt), {
    mounted: y1,
    setMounted: _3,
    transitionStatus: Da
  } = Xn(Fe), {
    openMethod: x1,
    triggerProps: Va
  } = Cs(Fe), A3 = Se(() => no);
  pi($n ? V3 : H, {
    id: pe,
    value: Ht,
    getValue: A3
  });
  const As = Se(() => {
    y ? $.current = Ot.map((je) => Jt(je, I)) : ct.set("forceMounted", !0);
  }), L3 = x.useRef(Te);
  ke(() => {
    Te !== L3.current && As();
  }, [As, Te]);
  const Hn = Se((je) => {
    ct.update(je);
    const Qe = je.type || "none";
    if (je.activeIndex !== void 0)
      if (je.activeIndex === null)
        Ee.current !== ir && (Ee.current = ir, bn(void 0, Ri(Qe, void 0, {
          index: -1
        })));
      else {
        const yt = Me.current[je.activeIndex];
        Ee.current = {
          value: yt,
          index: je.activeIndex
        }, bn(yt, Ri(Qe, void 0, {
          index: je.activeIndex
        }));
      }
  }), ro = Se((je, Qe) => {
    if (Re.current = Qe.reason === Ho, t.onInputValueChange?.(je, Qe), !Qe.isCanceled) {
      if (Qe.reason === _r) {
        const yt = Qe.event, Et = yt.inputType;
        if (yt.type === "compositionend" || Et != null && Et !== "" && Et !== "insertReplacementText") {
          const Kt = je.trim() !== "";
          Kt && de(!0), Pe.current = {
            hasQuery: Kt
          }, Kt && Be && ct.state.activeIndex == null && ct.set("activeIndex", 0);
        }
      }
      Ae(je);
    }
  }), wi = Se((je, Qe) => {
    if (Fe !== je && (Qe.reason === "escape-key" && Ie && Ot.length === 0 && !ct.state.emptyRef.current && Qe.allowPropagation(), t.onOpenChange?.(je, Qe), !Qe.isCanceled && (!je && re && (ye ? (vn || se(it), it === "" && de(!1)) : He && (vn || $n ? Hn({
      activeIndex: null
    }) : se(it), ro("", Ve(Ho, Qe.event)))), Xe(je), !je && $n && (Qe.reason === Po || Qe.reason === is) && (ee(!0), le(!1), J === "onBlur")))) {
      const yt = u === "none" ? Ne : Te;
      ie.commit(yt);
    }
  }), Ls = Se((je, Qe) => {
    if (i?.(je, Qe), Qe.isCanceled)
      return;
    vt(je), (u === "none" && Q.current && V || ye && !ct.state.inputInsidePopup) && ro(Jt(je, I), Ve(Qe.reason, Qe.event)), ye && je != null && Qe.reason !== _r && re && !vn && se(it);
  }), F3 = Se((je, Qe) => {
    let yt = Qe;
    if (yt === void 0) {
      if (kn === null)
        return;
      yt = Me.current[kn];
    }
    const Et = bt(je), Xt = me.current ?? je;
    me.current = null;
    const Kt = Ve(Wo, Xt), nr = Et?.closest("a")?.getAttribute("href");
    if (nr) {
      nr.startsWith("#") && wi(!1, Kt);
      return;
    }
    if (He) {
      const Lo = Array.isArray(Te) ? Te : [], Z3 = v0(Lo, yt, ct.state.isItemEqualToValue) ? y0(Lo, yt, ct.state.isItemEqualToValue) : [...Lo, yt];
      if (Ls(Z3, Kt), !(H.current ? H.current.value.trim() !== "" : !1))
        return;
      ct.state.inputInsidePopup ? ro("", Ve(Ho, Kt.event)) : wi(!1, Kt);
    } else
      Ls(yt, Kt), wi(!1, Kt);
  }), _a = Se(() => {
    if (!ct.state.submitOnItemClick)
      return;
    const je = ie.inputRef.current?.form ?? ct.state.inputElement?.form;
    je && typeof je.requestSubmit == "function" && je.requestSubmit();
  }), Aa = Se(() => {
    if (_3(!1), Ln?.(!1), de(!1), se(null), Hn(u === "none" ? {
      activeIndex: null,
      selectedIndex: null
    } : {
      activeIndex: null
    }), He && H.current && H.current.value !== "" && !Re.current && ro("", Ve(Ho)), ye)
      if (ct.state.inputInsidePopup)
        H.current && H.current.value !== "" && ro("", Ve(Ho));
      else {
        const je = Jt(Te, I);
        H.current && H.current.value !== je && ro(je, Ve(je === "" ? Ho : Pt));
      }
  }), $3 = x.useMemo(() => vn && nn ? {
    current: nn.closest('[role="dialog"]')
  } : Q, [vn, nn]);
  jt({
    enabled: !t.actionsRef,
    open: Fe,
    ref: $3,
    onComplete() {
      Fe || Aa();
    }
  }), x.useImperativeHandle(t.actionsRef, () => ({
    unmount: Aa
  }), [Aa]), ke(function() {
    if (Fe || u === "none")
      return;
    const Qe = y ? gt : _e.current;
    if (He) {
      const yt = Array.isArray(Te) ? Te : [], Et = yt[yt.length - 1], Xt = Mo(Qe, Et, M);
      Hn({
        selectedIndex: Xt === -1 ? null : Xt
      });
    } else {
      const yt = Mo(Qe, Te, M);
      Hn({
        selectedIndex: yt === -1 ? null : yt
      });
    }
  }, [Fe, Te, y, u, gt, He, M, Hn]), ke(() => {
    y && (Me.current = Ot, fe.current.length = Ot.length);
  }, [y, Ot]), ke(() => {
    const je = Pe.current;
    if (je && (je.hasQuery ? Be && ct.set("activeIndex", 0) : Be === "always" && ct.set("activeIndex", 0), Pe.current = null), !Fe && !vn)
      return;
    const yt = Ie || Le ? Ot : Me.current, Et = ct.state.activeIndex;
    if (Et == null) {
      if (Be === "always" && yt.length > 0) {
        ct.set("activeIndex", 0);
        return;
      }
      Ee.current !== ir && (Ee.current = ir, ct.state.onItemHighlighted(void 0, Ri(Pt, void 0, {
        index: -1
      })));
      return;
    }
    if (Et >= yt.length) {
      Ee.current !== ir && (Ee.current = ir, ct.state.onItemHighlighted(void 0, Ri(Pt, void 0, {
        index: -1
      }))), ct.set("activeIndex", null);
      return;
    }
    const Xt = yt[Et], Kt = Ee.current.value, nr = Kt !== R0 && go(Xt, Kt, ct.state.isItemEqualToValue);
    (Ee.current.index !== Et || !nr) && (Ee.current = {
      value: Xt,
      index: Et
    }, ct.state.onItemHighlighted(Xt, Ri(Pt, void 0, {
      index: Et
    })));
  }, [kn, Be, Le, Ie, Ot, vn, Fe, ct]), ke(() => {
    if (u === "none") {
      te(String(Ne) !== "");
      return;
    }
    te(He ? Array.isArray(Te) && Te.length > 0 : Te != null);
  }, [te, u, Ne, Te, He]), x.useEffect(() => {
    Ie && Be && Ot.length === 0 && Hn({
      activeIndex: null
    });
  }, [Ie, Be, Ot.length, Hn]), wo(it, () => {
    !Fe || it === "" || it === String(we) || de(!0);
  }), wo(Te, () => {
    if (u !== "none" && (Y(Ye), K(Te !== j.initialValue), Z() ? ie.commit(Te) : ie.commit(Te, !0), ye && !Oe && !$n)) {
      const je = Jt(Te, I);
      Ne !== je && ro(je, Ve(Pt));
    }
  }), wo(Ne, () => {
    u === "none" && (Y(Ye), K(Ne !== j.initialValue), Z() ? ie.commit(Ne) : ie.commit(Ne, !0));
  }), wo(y, () => {
    if (!ye || Oe || $n || re)
      return;
    const je = Jt(Te, I);
    Ne !== je && ro(je, Ve(Pt));
  });
  const Fs = gd({
    open: vn ? !0 : Fe,
    onOpenChange: wi,
    elements: {
      reference: $n ? Zt : Fn,
      floating: nn
    }
  });
  let La, Fa;
  vn || (La = C ? "grid" : "listbox", Fa = Fe ? "true" : "false");
  const H3 = x.useMemo(() => {
    const je = Fn?.tagName === "INPUT", Qe = Fn == null || je, yt = Qe || Fe, Et = Qe ? {
      autoComplete: "off",
      spellCheck: "false",
      autoCorrect: "off",
      autoCapitalize: "none"
    } : {};
    return yt && (Et.role = "combobox", Et["aria-expanded"] = Fa, Et["aria-haspopup"] = La, Et["aria-controls"] = Fe ? oo?.id : void 0, Et["aria-autocomplete"] = L), {
      reference: Et,
      floating: {
        role: "presentation"
      }
    };
  }, [Fn, Fe, Fa, La, oo?.id, L]), z3 = xr(Fs, {
    enabled: !h && !Ue && S,
    event: "mousedown-only",
    toggle: !1,
    // Apply a small delay for touch to let mobile viewport/keyboard positioning settle.
    // This avoids top-bottom flip flickers if the preferred position is "top" when first tapping.
    touchOpenDelay: $n ? 0 : 100,
    reason: Hm
  }), B3 = Cr(Fs, {
    enabled: !h && !Ue && !vn,
    outsidePressEvent: {
      mouse: "sloppy",
      // The visual viewport (affected by the mobile software keyboard) can be
      // somewhat small. The user may want to scroll the screen to see more of
      // the popup.
      touch: "intentional"
    },
    // Without a popup, let the Escape key bubble the event up to other popups' handlers.
    bubbles: vn ? !0 : void 0,
    outsidePress(je) {
      const Qe = bt(je);
      return !ze(Zt, Qe) && !ze(ve.current, Qe) && !ze(be.current, Qe) && !ze(Ci, Qe);
    }
  }), W3 = bd(Fs, {
    enabled: !h && !Ue,
    id: pe,
    listRef: fe,
    activeIndex: kn,
    selectedIndex: Mn,
    virtual: !0,
    loopFocus: P,
    allowEscape: P && !Be,
    focusItemOnOpen: re || u === "none" && !Be ? !1 : "auto",
    focusItemOnHover: T,
    resetOnPointerLeave: !N,
    // `cols` > 1 enables grid navigation.
    // Since <Combobox.Row> infers column sizes (and is required when building a grid),
    // it works correctly even with a value of `2`.
    // Floating UI tests don't require `role="row"` wrappers, so retains the number API.
    cols: C ? 2 : 1,
    orientation: C ? "horizontal" : void 0,
    disabledIndices: On,
    onNavigate(je, Qe) {
      !Qe && !Fe || Da === "ending" || Hn(Qe ? {
        activeIndex: je,
        type: ue.current ? "keyboard" : "pointer"
      } : {
        activeIndex: je
      });
    }
  }), {
    getReferenceProps: $a,
    getFloatingProps: Ha,
    getItemProps: za
  } = eo([H3, z3, B3, W3]);
  Nr(() => {
    ct.update({
      inline: O,
      popupProps: Ha(),
      inputProps: $a(),
      triggerProps: Va,
      getItemProps: za,
      setOpen: wi,
      setInputValue: ro,
      setSelectedValue: Ls,
      setIndices: Hn,
      onItemHighlighted: bn,
      handleSelection: F3,
      forceMount: As,
      requestSubmit: _a
    });
  }), ke(() => {
    ct.update({
      id: pe,
      selectedValue: Te,
      open: Fe,
      mounted: y1,
      transitionStatus: Da,
      items: y,
      inline: O,
      popupProps: Ha(),
      inputProps: $a(),
      triggerProps: Va,
      openMethod: x1,
      getItemProps: za,
      selectionMode: u,
      name: Ye,
      form: p,
      disabled: Ue,
      readOnly: h,
      required: b,
      grid: C,
      isGrouped: qe,
      virtualized: D,
      onOpenChangeComplete: Ln,
      openOnInputClick: S,
      itemToStringLabel: I,
      modal: _,
      autoHighlight: Be,
      isItemEqualToValue: M,
      submitOnItemClick: U,
      hasInputValue: Oe,
      requestSubmit: _a
    });
  }, [ct, pe, Te, Fe, y1, Da, y, Ha, $a, za, x1, Va, u, Ye, Ue, h, b, ie, C, qe, D, Ln, S, I, _, M, U, Oe, O, _a, Be, p]);
  const U3 = fn(v, ie.inputRef), G3 = x.useMemo(() => ({
    query: it,
    hasItems: Ie,
    filteredItems: ht,
    flatFilteredItems: Ot
  }), [it, Ie, ht, Ot]), Y3 = x.useMemo(() => Array.isArray(Ht) ? "" : Un(Ht, k), [Ht, k]), j3 = He && Array.isArray(Te) && Te.length > 0, Ba = He || u === "none" ? void 0 : Ye, K3 = x.useMemo(() => !He || !Array.isArray(Te) || !Ye ? null : Te.map((je) => {
    const Qe = Un(je, k);
    return /* @__PURE__ */ m("input", {
      type: "hidden",
      form: p,
      name: Ye,
      value: Qe
    }, Qe);
  }), [He, Te, p, Ye, k]), q3 = /* @__PURE__ */ F(x.Fragment, {
    children: [t.children, /* @__PURE__ */ m("input", {
      ...ie.getInputValidationProps({
        // Move focus when the hidden input is focused.
        onFocus() {
          if ($n) {
            Zt?.focus();
            return;
          }
          (H.current || Zt)?.focus();
        },
        // Handle browser autofill.
        onChange(je) {
          if (je.nativeEvent.defaultPrevented)
            return;
          const Qe = je.currentTarget.value, yt = Ve(Pt, je.nativeEvent);
          function Et() {
            if (He)
              return;
            if (u === "none") {
              K(Qe !== j.initialValue), ro(Qe, yt), Z() && ie.commit(Qe);
              return;
            }
            const Xt = Me.current.find((Kt) => Un(Kt, k).toLowerCase() === Qe.toLowerCase() || Jt(Kt, I).toLowerCase() === Qe.toLowerCase());
            Xt != null && (K(Xt !== j.initialValue), Ls?.(Xt, yt), Z() && ie.commit(Xt));
          }
          y ? Et() : (As(), queueMicrotask(Et));
        }
      }),
      id: pe && Ba == null ? `${pe}-hidden-input` : void 0,
      form: p,
      name: Ba,
      autoComplete: B,
      disabled: Ue,
      required: b && !j3,
      readOnly: h,
      value: Y3,
      ref: U3,
      style: Ba ? ti : Jo,
      tabIndex: -1,
      "aria-hidden": !0,
      suppressHydrationWarning: !0
    }), K3]
  });
  return /* @__PURE__ */ m(pf.Provider, {
    value: ct,
    children: /* @__PURE__ */ m(gf.Provider, {
      value: Fs,
      children: /* @__PURE__ */ m(mf.Provider, {
        value: G3,
        children: /* @__PURE__ */ m(hf.Provider, {
          value: Ne,
          children: q3
        })
      })
    })
  });
}
function yf(t) {
  const {
    multiple: e = !1,
    defaultValue: n,
    value: o,
    onValueChange: r,
    autoComplete: i,
    ...s
  } = t;
  return /* @__PURE__ */ m(E0, {
    ...s,
    selectionMode: e ? "multiple" : "single",
    selectedValue: o,
    defaultSelectedValue: n,
    onSelectedValueChange: r,
    formAutoComplete: i
  });
}
function xf(t, e) {
  return t ?? e;
}
const Cf = {
  ...Ui,
  ...to,
  popupSide: (t) => t ? {
    "data-popup-side": t
  } : null,
  listEmpty: (t) => t ? {
    "data-list-empty": ""
  } : null
}, wf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (wf.displayName = "ComboboxChipsContext");
function N0() {
  return x.useContext(wf);
}
const Sf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Sf.displayName = "ComboboxPositionerContext");
function Rf(t) {
  const e = x.useContext(Sf);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Popup> and <Combobox.Arrow> must be used within the <Combobox.Positioner> component" : rt(21));
  return e;
}
const Ef = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = Cn(), {
    buttonRef: r,
    getButtonProps: i
  } = Wt({
    native: !1
  }), s = fn(n, r), l = Se((c) => {
    o.state.setOpen(!1, Ve($m, c.nativeEvent, c.currentTarget));
  }), a = i({
    onClick: l
  });
  return /* @__PURE__ */ m("span", {
    ref: s,
    ...a,
    "aria-label": "Dismiss",
    tabIndex: void 0,
    style: ti
  });
});
process.env.NODE_ENV !== "production" && (Ef.displayName = "ComboboxInternalDismissButton");
const Is = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    id: s,
    style: l,
    ...a
  } = e, {
    state: c,
    disabled: u,
    setTouched: d,
    setFocused: f,
    validationMode: p,
    validation: g
  } = tn(), {
    labelId: h
  } = mn(), b = N0(), C = !!Rf(!0), y = Cn(), {
    filteredItems: w
  } = _o(), R = bf(), S = xs(), E = Ce(y, De.required), N = Ce(y, De.disabled), T = Ce(y, De.readOnly), P = Ce(y, De.name), I = Ce(y, De.form), k = Ce(y, De.selectionMode), M = Ce(y, De.autoHighlight), D = Ce(y, De.inputProps), O = Ce(y, De.triggerProps), V = Ce(y, De.open), _ = Ce(y, De.mounted), A = Ce(y, De.selectedValue), L = Ce(y, De.popupSide), B = Ce(y, De.positionerElement), G = Ce(y, De.id), U = Ce(y, De.inline), Y = Ce(y, De.modal), K = !!M, j = _ && B ? L : null, Z = u || N || i, te = w.length === 0, W = C || U, X = !W || Y, ee = Mt(s ?? (W ? void 0 : G)), le = xf(h, void 0), J = C ? Ar : c, [ie, pe] = x.useState(null), oe = x.useRef(!1), re = x.useRef(null), de = x.useRef(!1), xe = Se((H) => {
    const q = C || y.state.inline;
    q && !y.state.hasInputValue && y.state.setInputValue("", Ve(Pt)), y.update({
      inputElement: H,
      inputInsidePopup: q
    });
  }), se = C || !g ? a : g.getValidationProps(a), fe = {
    ...J,
    open: V,
    disabled: Z,
    readOnly: T,
    popupSide: j,
    listEmpty: te
  };
  function $(H) {
    if (!b)
      return;
    let q;
    const {
      highlightedChipIndex: ae
    } = b, ge = b.chipsRef.current.length;
    if (ae !== void 0) {
      if (H.key === "ArrowLeft")
        H.preventDefault(), ae > 0 ? q = ae - 1 : q = void 0;
      else if (H.key === "ArrowRight")
        H.preventDefault(), ae < ge - 1 ? q = ae + 1 : q = void 0;
      else if (H.key === "Backspace" || H.key === "Delete") {
        H.preventDefault();
        const ue = ae >= A.length - 1 ? A.length - 2 : ae;
        q = ue >= 0 ? ue : void 0, y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: "keyboard"
        });
      }
      return q;
    }
    return H.key === "ArrowLeft" && (H.currentTarget.selectionStart ?? 0) === 0 && A.length > 0 ? (H.preventDefault(), q = ge > 0 ? ge - 1 : void 0) : H.key === "Backspace" && H.currentTarget.value === "" && A.length > 0 && (y.state.setIndices({
      activeIndex: null,
      selectedIndex: null,
      type: "keyboard"
    }), H.preventDefault()), q;
  }
  const Q = $e("input", e, {
    state: fe,
    ref: [n, y.state.inputRef, xe],
    props: [D, O, {
      type: "text",
      value: e.value ?? ie ?? R,
      "aria-readonly": T || void 0,
      "aria-required": E || void 0,
      "aria-labelledby": le,
      disabled: Z,
      readOnly: T,
      required: k === "none" ? E : void 0,
      form: I,
      ...k === "none" && P && {
        name: P
      },
      id: ee,
      onFocus() {
        if (f(!0), !U || !de.current)
          return;
        de.current = !1;
        const H = re.current;
        H == null || // `valuesRef` can be sparse, so guard against restoring a removed slot.
        !Object.hasOwn(y.state.valuesRef.current, H) || y.state.setIndices({
          activeIndex: H
        });
      },
      onBlur() {
        d(!0), f(!1);
        const H = y.state.activeIndex;
        if (U && H !== null && M !== "always" && (re.current = H, de.current = !0, y.state.setIndices({
          activeIndex: null
        })), p === "onBlur") {
          const q = k === "none" ? R : A;
          g.commit(q);
        }
      },
      onCompositionStart(H) {
        Gi || (oe.current = !0, pe(H.currentTarget.value));
      },
      onCompositionEnd(H) {
        oe.current = !1;
        const q = H.currentTarget.value;
        pe(null), y.state.setInputValue(q, Ve(_r, H.nativeEvent));
      },
      onChange(H) {
        const q = H.nativeEvent.inputType, ae = !q || q === "insertReplacementText", ge = oe.current || !ae;
        if (oe.current) {
          const ve = H.currentTarget.value;
          pe(ve), ve === "" && !y.state.openOnInputClick && !y.state.inputInsidePopup && y.state.setOpen(!1, Ve(Ho, H.nativeEvent));
          const me = ve.trim(), Ee = K && me !== "";
          !T && !Z && me && ge && (y.state.setOpen(!0, Ve(_r, H.nativeEvent)), K || y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          })), V && y.state.activeIndex !== null && !Ee && y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          });
          return;
        }
        y.state.setInputValue(H.currentTarget.value, Ve(_r, H.nativeEvent));
        const ue = H.currentTarget.value === "", Re = Ve(Ho, H.nativeEvent);
        ue && !y.state.inputInsidePopup && (k === "single" && y.state.setSelectedValue(null, Re), y.state.openOnInputClick || y.state.setOpen(!1, Re));
        const be = H.currentTarget.value.trim();
        !T && !Z && be && ge && (y.state.setOpen(!0, Ve(_r, H.nativeEvent)), K || y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        })), V && y.state.activeIndex !== null && !K && y.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
        });
      },
      onKeyDown(H) {
        if (Z || T || H.ctrlKey || H.shiftKey || H.altKey || H.metaKey)
          return;
        y.state.keyboardActiveRef.current = !0;
        const q = H.currentTarget, ae = q.scrollWidth - q.clientWidth, ge = S === "rtl";
        if (H.key === "Home") {
          Ft(H);
          const be = A1 && ge ? q.value.length : 0;
          q.setSelectionRange(be, be), q.scrollLeft = 0;
          return;
        }
        if (H.key === "End") {
          Ft(H);
          const be = A1 && ge ? 0 : q.value.length;
          q.setSelectionRange(be, be), q.scrollLeft = ge ? -ae : ae;
          return;
        }
        if (!_ && H.key === "Escape") {
          const be = k === "multiple" && Array.isArray(A) ? A.length === 0 : A === null, ve = Ve(vr, H.nativeEvent), me = k === "multiple" ? [] : null;
          y.state.setInputValue("", ve), y.state.setSelectedValue(me, ve), !be && !y.state.inline && !ve.isPropagationAllowed && H.stopPropagation();
          return;
        }
        if (b && H.key === "Backspace" && q.value === "" && b.highlightedChipIndex === void 0 && Array.isArray(A) && A.length > 0) {
          const be = b.chipsRef.current.length, ve = be > 0 ? be - 1 : A.length - 1, me = A.filter((Ee, Pe) => Pe !== ve);
          y.state.setIndices({
            activeIndex: null,
            selectedIndex: null,
            type: y.state.keyboardActiveRef.current ? "keyboard" : "pointer"
          }), y.state.setSelectedValue(me, Ve(Pt, H.nativeEvent));
          return;
        }
        const ue = b?.highlightedChipIndex !== void 0, Re = $(H);
        if (b?.setHighlightedChipIndex(Re), Re !== void 0 ? b?.chipsRef.current[Re]?.focus() : ue && y.state.inputRef.current?.focus(), H.which !== 229 && H.key === "Enter" && V) {
          const be = y.state.activeIndex, ve = H.nativeEvent;
          if (be === null) {
            if (U)
              return;
            y.state.setOpen(!1, Ve(Pt, ve));
            return;
          }
          Ft(H);
          const me = y.state.listRef.current[be];
          me && (y.state.selectionEventRef.current = ve, me.click(), y.state.selectionEventRef.current = null);
        }
      },
      onPointerMove() {
        y.state.keyboardActiveRef.current = !1;
      },
      onPointerDown() {
        y.state.keyboardActiveRef.current = !1;
      }
    }, se],
    stateAttributesMapping: Cf
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [V && X && /* @__PURE__ */ m(Ef, {
      ref: y.state.startDismissRef
    }), Q]
  });
});
process.env.NODE_ENV !== "production" && (Is.displayName = "ComboboxInput");
function k0(t, e, n, o, r) {
  if (t.baseUIHandlerPrevented || o)
    return;
  const i = bt(t.nativeEvent), s = pt(i) ? i : null;
  s !== t.currentTarget && (r?.(s) || oh(s)) || (t.preventDefault(), !n && (e.state.inputRef.current?.focus(), e.state.openOnInputClick && e.state.setOpen(!0, Ve(Hm, t.nativeEvent))));
}
const va = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = tn(), a = Cn(), {
    filteredItems: c
  } = _o(), u = Ce(a, De.open), d = Ce(a, De.mounted), f = Ce(a, De.popupSide), p = Ce(a, De.positionerElement), g = Ce(a, De.disabled), h = Ce(a, De.readOnly), b = Ce(a, De.hasSelectedValue), v = Ce(a, De.selectionMode), C = d && p ? f : null, y = g, w = c.length === 0, S = {
    ...l,
    open: u,
    disabled: y,
    readOnly: h,
    popupSide: C,
    listEmpty: w,
    placeholder: v === "none" ? !1 : !b
  }, E = Se((N) => {
    a.set("inputGroupElement", N);
  });
  return $e("div", e, {
    ref: [n, E],
    props: [{
      role: "group",
      onMouseDown(N) {
        k0(N, a, y, h, (T) => ze(a.state.chipsContainerRef.current, T));
      }
    }, s],
    state: S,
    stateAttributesMapping: Cf
  });
});
process.env.NODE_ENV !== "production" && (va.displayName = "ComboboxInputGroup");
const il = 2, ya = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    nativeButton: i = !0,
    disabled: s = !1,
    id: l,
    style: a,
    ...c
  } = e, {
    state: u,
    disabled: d,
    setTouched: f,
    setFocused: p,
    validationMode: g,
    validation: h
  } = tn(), {
    labelId: b
  } = mn(), v = Cn(), {
    filteredItems: C
  } = _o(), y = Ce(v, De.selectionMode), w = Ce(v, De.disabled), R = Ce(v, De.readOnly), S = Ce(v, De.required), E = Ce(v, De.mounted), N = Ce(v, De.popupSide), T = Ce(v, De.positionerElement), P = Ce(v, De.listElement), I = Ce(v, De.triggerProps), k = Ce(v, De.triggerElement), M = Ce(v, De.inputInsidePopup), D = Ce(v, De.id), O = Ce(v, De.labelId), V = Ce(v, De.open), _ = Ce(v, De.selectedValue), A = Ce(v, De.activeIndex), L = Ce(v, De.selectedIndex), B = Ce(v, De.hasSelectedValue), G = ba(), U = bf(), Y = Vt(), K = d || w || s, j = C.length === 0, Z = E && T ? N : null;
  Mr({
    id: M ? l : void 0
  });
  const te = M ? l ?? D : l, W = xf(b, O), X = x.useRef("");
  function ee(se) {
    X.current = se.pointerType;
  }
  const le = G.useState("domReferenceElement");
  x.useEffect(() => {
    M && k && k !== le && G.set("domReferenceElement", k);
  }, [k, le, G, M]);
  const {
    reference: J
  } = yd(G, {
    enabled: !V && !R && !w && y === "single",
    listRef: v.state.labelsRef,
    activeIndex: A,
    selectedIndex: L,
    onMatch(se) {
      const fe = v.state.valuesRef.current[se];
      fe !== void 0 && v.state.setSelectedValue(fe, Ve("none"));
    }
  }), {
    reference: ie
  } = xr(G, {
    enabled: !R && !w,
    event: "mousedown"
  }), {
    buttonRef: pe,
    getButtonProps: oe
  } = Wt({
    native: i,
    disabled: K
  }), re = {
    ...u,
    open: V,
    disabled: K,
    popupSide: Z,
    listEmpty: j,
    placeholder: y === "none" ? !1 : !B
  }, de = Se((se) => {
    v.set("triggerElement", se);
  });
  return $e("button", e, {
    ref: [n, pe, de],
    state: re,
    props: [I, ie, J, {
      id: te,
      tabIndex: M ? 0 : -1,
      role: M ? "combobox" : void 0,
      "aria-expanded": V ? "true" : "false",
      "aria-haspopup": M ? "dialog" : "listbox",
      "aria-controls": V ? P?.id : void 0,
      "aria-required": M && S || void 0,
      "aria-labelledby": W,
      onPointerDown: ee,
      onPointerEnter: ee,
      onFocus() {
        p(!0), !(K || R) && Y.start(0, v.state.forceMount);
      },
      onBlur(se) {
        if (!ze(T, se.relatedTarget) && (f(!0), p(!1), g === "onBlur")) {
          const fe = y === "none" ? U : _;
          h.commit(fe);
        }
      },
      onMouseDown(se) {
        if (K || R || (M || G.set("domReferenceElement", se.currentTarget), v.state.forceMount(), X.current !== "touch" && (v.state.inputRef.current?.focus(), M || se.preventDefault()), V))
          return;
        const fe = et(se.currentTarget);
        function $(Q) {
          if (!k)
            return;
          const H = bt(Q), q = v.state.positionerElement, ae = v.state.listElement;
          if (ze(k, H) || ze(q, H) || ze(ae, H) || H === k)
            return;
          const ge = Nd(k), ue = Q.clientX >= ge.left - il && Q.clientX <= ge.right + il, Re = Q.clientY >= ge.top - il && Q.clientY <= ge.bottom + il;
          ue && Re || v.state.setOpen(!1, Ve("cancel-open", Q));
        }
        M && fe.addEventListener("mouseup", $, {
          once: !0
        });
      },
      onKeyDown(se) {
        K || R || (se.key === "ArrowDown" || se.key === "ArrowUp") && (Ft(se), v.state.setOpen(!0, Ve($r, se.nativeEvent)), v.state.inputRef.current?.focus());
      }
    }, h ? h.getValidationProps(c) : c, oe],
    stateAttributesMapping: Cf
  });
});
process.env.NODE_ENV !== "production" && (ya.displayName = "ComboboxTrigger");
const Nf = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Nf.displayName = "GroupCollectionContext");
function SS() {
  return x.useContext(Nf);
}
function RS(t) {
  const {
    children: e,
    items: n
  } = t, o = x.useMemo(() => ({
    items: n
  }), [n]);
  return /* @__PURE__ */ m(Nf.Provider, {
    value: o,
    children: e
  });
}
function M0(t) {
  const {
    children: e
  } = t, {
    filteredItems: n
  } = _o(), o = SS(), r = o ? o.items : n;
  return r ? /* @__PURE__ */ m(x.Fragment, {
    children: r.map(e)
  }) : null;
}
const Ps = /* @__PURE__ */ x.forwardRef(function(e, n) {
  var o;
  const {
    render: r,
    className: i,
    style: s,
    children: l,
    ...a
  } = e, c = Cn(), u = ba(), d = !!Rf(!0), {
    filteredItems: f,
    hasItems: p
  } = _o(), g = Ce(c, De.selectionMode), h = Ce(c, De.grid), b = Ce(c, De.popupProps), v = Ce(c, De.virtualized), C = g === "multiple", y = f.length === 0, w = Se((P) => {
    c.set("positionerElement", P);
  }), R = Se((P) => {
    c.set("listElement", P);
  }), S = x.useMemo(() => typeof l == "function" ? o || (o = /* @__PURE__ */ m(M0, {
    children: l
  })) : l, [l]), E = {
    empty: y
  }, N = u.useState("floatingId"), T = $e("div", e, {
    state: E,
    ref: [n, R, d ? null : w],
    props: [b, {
      children: S,
      tabIndex: -1,
      id: N,
      role: h ? "grid" : "listbox",
      "aria-multiselectable": C ? "true" : void 0,
      onKeyDown(P) {
        if (!(c.state.disabled || c.state.readOnly) && P.key === "Enter") {
          const I = c.state.activeIndex;
          if (I == null)
            return;
          Ft(P);
          const k = P.nativeEvent, M = c.state.listRef.current[I];
          M && (c.state.selectionEventRef.current = k, M.click(), c.state.selectionEventRef.current = null);
        }
      },
      onKeyDownCapture() {
        c.state.keyboardActiveRef.current = !0;
      },
      onPointerMoveCapture() {
        c.state.keyboardActiveRef.current = !1;
      }
    }, a]
  });
  return v ? T : /* @__PURE__ */ m(ii, {
    elementsRef: c.state.listRef,
    labelsRef: p ? void 0 : c.state.labelsRef,
    children: T
  });
});
process.env.NODE_ENV !== "production" && (Ps.displayName = "ComboboxList");
const ES = "⁠", NS = 200;
function kS(t) {
  const e = t.ownerDocument.createTreeWalker(t, NodeFilter.SHOW_TEXT);
  let n = null;
  for (; e.nextNode(); ) {
    const o = e.currentNode;
    o.nodeValue !== "" && (n = o);
  }
  return n;
}
function MS() {
  const t = Vt(), e = x.useRef(null);
  return x.useEffect(() => {
    if (zu)
      return;
    const n = e.current;
    if (n == null)
      return;
    const o = kS(n);
    if (o == null)
      return;
    const r = o.nodeValue ?? "", i = `${r}${ES}`;
    return o.nodeValue = i, t.start(NS, () => {
      o.nodeValue === i && (o.nodeValue = r);
    }), () => {
      t.clear(), o.nodeValue === i && (o.nodeValue = r);
    };
  }, [e, t]), e;
}
const kf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (kf.displayName = "ComboboxPortalContext");
function IS() {
  const t = x.useContext(kf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Combobox.Portal> is missing." : rt(20));
  return t;
}
const xa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, i = Cn(), s = Ce(i, De.mounted), l = Ce(i, De.forceMounted);
  return s || o || l ? /* @__PURE__ */ m(kf.Provider, {
    value: o,
    children: /* @__PURE__ */ m(ni, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (xa.displayName = "ComboboxPortal");
const Ca = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = ed,
    style: v,
    ...C
  } = e, y = Cn(), {
    filteredItems: w
  } = _o(), R = ba(), S = IS(), E = Ce(y, De.modal), N = Ce(y, De.open), T = Ce(y, De.mounted), P = Ce(y, De.openMethod), I = Ce(y, De.positionerElement), k = Ce(y, De.triggerElement), M = Ce(y, De.inputElement), D = Ce(y, De.inputGroupElement), O = Ce(y, De.inputInsidePopup), V = Ce(y, De.transitionStatus), _ = w.length === 0, L = ri({
    anchor: i ?? (O ? k : D ?? M),
    floatingRootContext: R,
    positionMethod: s,
    mounted: T,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: h,
    keepMounted: S,
    collisionAvoidance: b,
    lazyFlip: !0
  });
  pa(N && E, P === "touch", I, k);
  const B = {
    open: N,
    side: L.side,
    align: L.align,
    anchorHidden: L.anchorHidden,
    empty: _
  };
  ke(() => {
    y.set("popupSide", L.side);
  }, [y, L.side]);
  const G = Se((Y) => {
    y.set("positionerElement", Y);
  }), U = li(e, B, {
    styles: L.positionerStyles,
    transitionStatus: V,
    props: C,
    refs: [n, G],
    hidden: !T,
    inert: !N
  });
  return /* @__PURE__ */ F(Sf.Provider, {
    value: L,
    children: [T && E && /* @__PURE__ */ m(si, {
      inert: Er(!N),
      cutout: D ?? M ?? k
    }), U]
  });
});
process.env.NODE_ENV !== "production" && (Ca.displayName = "ComboboxPositioner");
const PS = {
  ...Nn,
  ...Bt
}, wa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    initialFocus: s,
    finalFocus: l,
    ...a
  } = e, c = Cn(), u = Rf(), d = ba(), {
    filteredItems: f
  } = _o(), p = Ce(c, De.mounted), g = Ce(c, De.open), h = Ce(c, De.openMethod), b = Ce(c, De.transitionStatus), v = Ce(c, De.inputInsidePopup), C = Ce(c, De.inputElement), y = Ce(c, De.modal), w = f.length === 0;
  jt({
    open: g,
    ref: c.state.popupRef,
    onComplete() {
      g && c.state.onOpenChangeComplete(!0);
    }
  });
  const R = {
    open: g,
    side: u.side,
    align: u.align,
    anchorHidden: u.anchorHidden,
    transitionStatus: b,
    empty: w
  }, S = $e("div", e, {
    state: R,
    ref: [n, c.state.popupRef],
    props: [{
      role: v ? "dialog" : "presentation",
      tabIndex: -1,
      onFocus(I) {
        const k = bt(I.nativeEvent);
        h !== "touch" && (ze(c.state.listElement, k) || k === I.currentTarget) && c.state.inputRef.current?.focus();
      }
    }, Rr(b), a],
    stateAttributesMapping: PS
  }), N = s === void 0 ? v ? (I) => I === "touch" ? c.state.popupRef.current : C : !1 : s;
  let T;
  l != null ? T = l : T = v ? void 0 : !1;
  const P = !v || y;
  return /* @__PURE__ */ m(oi, {
    context: d,
    disabled: !p,
    modal: P,
    openInteractionType: h,
    initialFocus: N,
    returnFocus: T,
    getInsideElements: () => [c.state.startDismissRef.current, c.state.endDismissRef.current],
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [S, P && /* @__PURE__ */ m(Ef, {
        ref: c.state.endDismissRef
      })]
    })
  });
});
process.env.NODE_ENV !== "production" && (wa.displayName = "ComboboxPopup");
const Mf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Mf.displayName = "ComboboxGroupContext");
function TS() {
  const t = x.useContext(Mf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ComboboxGroupContext is missing. ComboboxGroup parts must be placed within <Combobox.Group>." : rt(18));
  return t;
}
const I0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    items: s,
    ...l
  } = e, [a, c] = x.useState(), u = x.useMemo(() => ({
    labelId: a,
    setLabelId: c,
    items: s
  }), [a, c, s]), d = $e("div", e, {
    ref: n,
    props: [{
      role: "group",
      "aria-labelledby": a
    }, l]
  }), f = /* @__PURE__ */ m(Mf.Provider, {
    value: u,
    children: d
  });
  return s ? /* @__PURE__ */ m(RS, {
    items: s,
    children: f
  }) : f;
});
process.env.NODE_ENV !== "production" && (I0.displayName = "ComboboxGroup");
const P0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    ...l
  } = e, {
    setLabelId: a
  } = TS(), c = Mt(s);
  return ke(() => (a(c), () => {
    a(void 0);
  }), [c, a]), $e("div", e, {
    ref: n,
    props: [{
      id: c
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (P0.displayName = "ComboboxGroupLabel");
const T0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (T0.displayName = "ComboboxItemContext");
const If = /* @__PURE__ */ x.createContext(!1);
process.env.NODE_ENV !== "production" && (If.displayName = "ComboboxRowContext");
function OS() {
  return x.useContext(If);
}
const Ts = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    index: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(!1), f = x.useRef(null), p = Oo({
    index: s,
    textRef: f,
    indexGuessBehavior: Uu.GuessFromOrder
  }), g = Cn(), h = OS(), {
    flatFilteredItems: b,
    hasItems: v
  } = _o(), C = Ce(g, De.open), y = Ce(g, De.selectionMode), w = Ce(g, De.readOnly), R = Ce(g, De.virtualized), S = Ce(g, De.isItemEqualToValue), E = y !== "none", N = s ?? (R ? Mo(b, i, S) : p.index), T = p.index !== -1, P = Ce(g, De.id), I = Ce(g, De.isActive, N), k = Ce(g, De.isSelected, i), M = Ce(g, De.getItemProps), D = x.useRef(null), O = P != null && T ? `${P}-${N}` : void 0, V = k && E;
  ke(() => {
    if (!(T && (R || s != null)))
      return;
    const Z = g.state.listRef.current;
    return Z[N] = D.current, () => {
      delete Z[N];
    };
  }, [T, R, N, s, g]), ke(() => {
    if (!T || v)
      return;
    const j = g.state.valuesRef.current;
    return j[N] = i, y !== "none" && g.state.allValuesRef.current.push(i), () => {
      delete j[N];
    };
  }, [T, v, N, i, g, y]), ke(() => {
    if (!C) {
      d.current = !1;
      return;
    }
    if (!T || v)
      return;
    const j = g.state.selectedValue, Z = Array.isArray(j) ? j[j.length - 1] : j;
    go(i, Z, S) && g.set("selectedIndex", N);
  }, [T, v, C, g, N, i, S]);
  const _ = {
    disabled: l,
    selected: V,
    highlighted: I
  }, A = M({
    active: I,
    selected: V
  });
  A.id = void 0, A.onFocus = void 0;
  const {
    getButtonProps: L,
    buttonRef: B
  } = Wt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function G(j) {
    function Z() {
      g.state.handleSelection(j, i);
    }
    g.state.submitOnItemClick ? (an.flushSync(Z), g.state.requestSubmit()) : Z();
  }
  const U = {
    id: O,
    role: h ? "gridcell" : "option",
    "aria-selected": E ? V : void 0,
    // Focusable items steal focus from the input upon mouseup.
    // Warn if the user renders a natively focusable element like `<button>`,
    // as it should be a `<div>` instead.
    tabIndex: void 0,
    onPointerDownCapture(j) {
      d.current = !0, j.preventDefault();
    },
    onMouseDown(j) {
      j.preventDefault();
    },
    onClick(j) {
      l || w || G(j.nativeEvent);
    },
    onMouseUp(j) {
      const Z = d.current;
      d.current = !1, !(l || w || j.button !== 0 || Z || !I) && G(j.nativeEvent);
    }
  }, Y = $e("div", e, {
    ref: [B, n, p.ref, D],
    state: _,
    props: [A, U, u, L]
  }), K = x.useMemo(() => ({
    selected: V,
    textRef: f
  }), [V, f]);
  return /* @__PURE__ */ m(T0.Provider, {
    value: K,
    children: Y
  });
}));
process.env.NODE_ENV !== "production" && (Ts.displayName = "ComboboxItem");
const O0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Cn(), a = Ce(l, De.open), c = Ce(l, De.hasSelectionChips), [u, d] = x.useState(void 0);
  a && u !== void 0 && d(void 0);
  const f = x.useRef([]), p = $e("div", e, {
    ref: [n, l.state.chipsContainerRef],
    // NVDA enters browse mode instead of staying in focus mode when navigating with
    // arrow keys inside a container unless it has a toolbar role.
    props: [c ? {
      role: "toolbar"
    } : St, {
      onMouseDown(h) {
        k0(h, l, l.state.disabled, l.state.readOnly);
      }
    }, s]
  }), g = x.useMemo(() => ({
    highlightedChipIndex: u,
    setHighlightedChipIndex: d,
    chipsRef: f
  }), [u, d, f]);
  return /* @__PURE__ */ m(wf.Provider, {
    value: g,
    children: /* @__PURE__ */ m(ii, {
      elementsRef: f,
      children: p
    })
  });
});
process.env.NODE_ENV !== "production" && (O0.displayName = "ComboboxChips");
const Pf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Pf.displayName = "ComboboxChipContext");
function DS() {
  const t = x.useContext(Pf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "useComboboxChipContext must be used within a ComboboxChip" : rt(17));
  return t;
}
const D0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = Cn(), {
    setHighlightedChipIndex: a,
    chipsRef: c
  } = N0(), u = Ce(l, De.disabled), d = Ce(l, De.readOnly), f = Ce(l, De.selectedValue), {
    ref: p,
    index: g
  } = Oo();
  function h(y) {
    let w = g;
    if (y.key === "ArrowLeft")
      y.preventDefault(), g > 0 ? w = g - 1 : w = void 0;
    else if (y.key === "ArrowRight")
      y.preventDefault(), g < c.current.length - 1 ? w = g + 1 : w = void 0;
    else if (y.key === "Backspace" || y.key === "Delete") {
      const R = g >= f.length - 1 ? f.length - 2 : g;
      w = R >= 0 ? R : void 0, Ft(y), l.state.setIndices({
        activeIndex: null,
        selectedIndex: null,
        type: "keyboard"
      }), l.state.setSelectedValue(f.filter((S, E) => E !== g), Ve(Pt, y.nativeEvent));
    } else y.key === "Enter" || y.key === " " ? (Ft(y), w = void 0) : y.key === "ArrowDown" || y.key === "ArrowUp" ? (Ft(y), l.state.setOpen(!0, Ve($r, y.nativeEvent)), w = void 0) : (
      // Check for printable characters (letters, numbers, symbols)
      y.key.length === 1 && !y.ctrlKey && !y.metaKey && !y.altKey && (w = void 0)
    );
    return w;
  }
  const v = $e("div", e, {
    ref: [n, p],
    state: {
      disabled: u
    },
    props: [{
      tabIndex: -1,
      "aria-disabled": u || void 0,
      "aria-readonly": d || void 0,
      onKeyDown(y) {
        if (u || d)
          return;
        const w = h(y);
        an.flushSync(() => {
          a(w);
        }), w === void 0 ? l.state.inputRef.current?.focus() : c.current[w]?.focus();
      }
    }, s]
  }), C = x.useMemo(() => ({
    index: g
  }), [g]);
  return /* @__PURE__ */ m(Pf.Provider, {
    value: C,
    children: v
  });
});
process.env.NODE_ENV !== "production" && (D0.displayName = "ComboboxChip");
const V0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    style: l,
    ...a
  } = e, c = Cn(), {
    index: u
  } = DS(), d = Ce(c, De.disabled), f = Ce(c, De.readOnly), p = Ce(c, De.selectedValue), g = Ce(c, De.isItemEqualToValue), h = d || i, {
    buttonRef: b,
    getButtonProps: v
  } = Wt({
    native: s,
    disabled: h || f,
    focusableWhenDisabled: !0
  }), C = {
    disabled: h
  };
  function y(S) {
    const E = c.state.activeIndex;
    if (E == null)
      return;
    const N = Mo(c.state.valuesRef.current, S, g);
    N !== -1 && E === N && c.state.setIndices({
      activeIndex: null,
      type: c.state.keyboardActiveRef.current ? "keyboard" : "pointer"
    });
  }
  function w(S) {
    const E = Ve(o8, S.nativeEvent), N = p[u];
    return y(N), c.state.setSelectedValue(p.filter((T, P) => P !== u), E), c.state.inputRef.current?.focus(), E;
  }
  return $e("button", e, {
    ref: [n, b],
    state: C,
    props: [{
      tabIndex: -1,
      onMouseDown(S) {
        S.preventDefault();
      },
      onClick(S) {
        if (h || f)
          return;
        w(S).isPropagationAllowed || S.stopPropagation();
      },
      onKeyDown(S) {
        h || f || (S.key === "Enter" || S.key === " ") && (w(S).isPropagationAllowed || Ft(S));
      }
    }, a, v]
  });
});
process.env.NODE_ENV !== "production" && (V0.displayName = "ComboboxChipRemove");
const _0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, l = $e("div", e, {
    ref: n,
    props: [{
      role: "row"
    }, s]
  });
  return /* @__PURE__ */ m(If.Provider, {
    value: !0,
    children: l
  });
});
process.env.NODE_ENV !== "production" && (_0.displayName = "ComboboxRow");
const Tf = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, {
    filteredItems: a
  } = _o(), c = Cn(), u = MS(), d = a.length === 0 ? s : null;
  return $e("div", e, {
    ref: [n, c.state.emptyRef, u],
    props: [{
      children: d,
      role: "status",
      "aria-live": "polite",
      "aria-atomic": !0
    }, l]
  });
});
process.env.NODE_ENV !== "production" && (Tf.displayName = "ComboboxEmpty");
const VS = {
  ...Bt,
  ...br
}, Of = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    keepMounted: l = !1,
    style: a,
    ...c
  } = e, {
    disabled: u
  } = tn(), d = Cn(), f = Ce(d, De.selectionMode), p = Ce(d, De.disabled), g = Ce(d, De.readOnly), h = Ce(d, De.open), b = Ce(d, De.selectedValue), v = Ce(d, De.hasSelectionChips), C = bf();
  let y = !1;
  f === "none" ? y = C !== "" : f === "single" ? y = b != null : y = v;
  const w = u || p || i, {
    buttonRef: R,
    getButtonProps: S
  } = Wt({
    native: s,
    disabled: w
  }), {
    mounted: E,
    transitionStatus: N,
    setMounted: T
  } = Xn(y), P = {
    disabled: w,
    open: h,
    transitionStatus: N
  };
  jt({
    open: y,
    ref: d.state.clearRef,
    onComplete() {
      y || T(!1);
    }
  });
  const I = $e("button", e, {
    state: P,
    ref: [n, R, d.state.clearRef],
    props: [{
      tabIndex: -1,
      children: "x",
      // Avoid stealing focus from the input.
      onMouseDown(M) {
        M.preventDefault();
      },
      onClick(M) {
        if (w || g)
          return;
        const D = d.state.keyboardActiveRef;
        d.state.setInputValue("", Ve(V1, M.nativeEvent)), f !== "none" ? (d.state.setSelectedValue(Array.isArray(b) ? [] : null, Ve(V1, M.nativeEvent)), d.state.setIndices({
          activeIndex: null,
          selectedIndex: null,
          type: D.current ? "keyboard" : "pointer"
        })) : d.state.setIndices({
          activeIndex: null,
          type: D.current ? "keyboard" : "pointer"
        }), d.state.inputRef.current?.focus();
      }
    }, c, S],
    stateAttributesMapping: VS
  });
  return l || E ? I : null;
});
process.env.NODE_ENV !== "production" && (Of.displayName = "ComboboxClear");
const _S = ce(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "outline-none", "cursor-pointer", "data-[disabled]:cursor-not-allowed", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "data-[readonly]:bg-input-readonly-background", "data-[readonly]:cursor-default", "[&:not([data-readonly]):not([data-popup-open])]:hover:bg-input-hover-background", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-hover-outline", "[&:not([data-readonly])[data-popup-open]]:border-input-active-outline", "[&:not([data-readonly])]:active:border-input-pressed-outline", "[&:not([data-readonly])]:focus-visible:ring-2", "[&:not([data-readonly])]:focus-visible:ring-input-focus-ring", "[&:not([data-readonly])]:focus-visible:ring-offset-1"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
});
function A0(t) {
  const e = z.c(128), {
    id: n,
    options: o,
    value: r,
    onChange: i,
    defaultValue: s,
    placeholder: l,
    size: a,
    label: c,
    tooltip: u,
    required: d,
    description: f,
    error: p,
    disabled: g,
    readOnly: h,
    reserveSubtextSpace: b,
    name: v,
    "data-testid": C,
    renderValue: y,
    renderOption: w,
    popupWidth: R
  } = t, S = a === void 0 ? "md" : a, E = h === void 0 ? !1 : h, N = b === void 0 ? !0 : b, T = R === void 0 ? "anchor" : R, P = qt(), I = !!p, M = N || I || !!f, D = r !== void 0, [O, V] = ot(s ?? null), [_, A] = ot(!1), [L, B] = ot(""), G = _ && !E;
  let U, Y;
  e[0] !== E ? (U = () => {
    E && A(!1);
  }, Y = [E], e[0] = E, e[1] = U, e[2] = Y) : (U = e[1], Y = e[2]), kt(U, Y);
  const K = D ? r : O;
  let j, Z, te, W, X, ee, le, J, ie, pe, oe, re, de, xe, se, fe, $, Q, H, q, ae, ge, ue, Re;
  if (e[3] !== K || e[4] !== g || e[5] !== I || e[6] !== L || e[7] !== D || e[8] !== G || e[9] !== c || e[10] !== v || e[11] !== i || e[12] !== o || e[13] !== l || e[14] !== E || e[15] !== y || e[16] !== d || e[17] !== S || e[18] !== u) {
    let Fe;
    e[43] !== K ? (Fe = (Ge) => Ge.value === K, e[43] = K, e[44] = Fe) : Fe = e[44];
    const Xe = o.find(Fe);
    let qe;
    e[45] !== K || e[46] !== D || e[47] !== i || e[48] !== d ? (qe = function(Ze, tt) {
      const gt = tt.reason === "item-press" && !d && K !== null && Ze?.value === K ? null : Ze?.value ?? null;
      i?.(gt, tt), !D && !tt.isCanceled && V(gt);
    }, e[45] = K, e[46] = D, e[47] = i, e[48] = d, e[49] = qe) : qe = e[49];
    const it = qe;
    te = Ir, Q = I, H = g, q = "flex flex-col w-full", e[50] !== c || e[51] !== d || e[52] !== u ? (ae = c && /* @__PURE__ */ m(gi, { label: c, required: d, tooltip: u }), e[50] = c, e[51] = d, e[52] = u, e[53] = ae) : ae = e[53], Z = yf, Re = Xe ?? null, W = it, X = g, ee = E, le = d, J = v, ie = !1, pe = o, oe = $S, re = FS, de = LS, xe = G, se = G ? L : Xe?.label ?? "", fe = B, e[54] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? ($ = (Ge) => {
      A(Ge), Ge && B("");
    }, e[54] = $) : $ = e[54], j = va, e[55] !== g || e[56] !== I || e[57] !== S ? (ge = ne(_S({
      size: S
    }), "relative", !I && "data-[readonly]:border-input-readonly-outline", g && "opacity-50 cursor-not-allowed", I && ["border-input-error-outline", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-error-outline"]), e[55] = g, e[56] = I, e[57] = S, e[58] = ge) : ge = e[58], ue = !G && /* @__PURE__ */ m("span", { className: ne("pointer-events-none absolute inset-y-0 left-(--spacing-10) flex min-w-0 items-center text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20)", E ? "right-(--spacing-10)" : "right-(--spacing-32)"), children: y ? y(Xe) : Xe ? /* @__PURE__ */ m("span", { className: "truncate", children: Xe.label }) : E ? null : /* @__PURE__ */ m("span", { className: "truncate text-input-text-placeholder", children: l }) }), e[3] = K, e[4] = g, e[5] = I, e[6] = L, e[7] = D, e[8] = G, e[9] = c, e[10] = v, e[11] = i, e[12] = o, e[13] = l, e[14] = E, e[15] = y, e[16] = d, e[17] = S, e[18] = u, e[19] = j, e[20] = Z, e[21] = te, e[22] = W, e[23] = X, e[24] = ee, e[25] = le, e[26] = J, e[27] = ie, e[28] = pe, e[29] = oe, e[30] = re, e[31] = de, e[32] = xe, e[33] = se, e[34] = fe, e[35] = $, e[36] = Q, e[37] = H, e[38] = q, e[39] = ae, e[40] = ge, e[41] = ue, e[42] = Re;
  } else
    j = e[19], Z = e[20], te = e[21], W = e[22], X = e[23], ee = e[24], le = e[25], J = e[26], ie = e[27], pe = e[28], oe = e[29], re = e[30], de = e[31], xe = e[32], se = e[33], fe = e[34], $ = e[35], Q = e[36], H = e[37], q = e[38], ae = e[39], ge = e[40], ue = e[41], Re = e[42];
  const be = c || n ? void 0 : E ? "Select option" : l ?? "Select option", ve = d || void 0, me = E ? -1 : void 0, Ee = !G && "text-transparent caret-transparent";
  let Pe;
  e[59] !== Ee ? (Pe = ne("min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", Ee), e[59] = Ee, e[60] = Pe) : Pe = e[60];
  const Me = G ? "Search" : void 0;
  let _e;
  e[61] !== E ? (_e = (Fe) => {
    E && Fe.preventDefault();
  }, e[61] = E, e[62] = _e) : _e = e[62];
  let Ue;
  e[63] !== C || e[64] !== n || e[65] !== be || e[66] !== ve || e[67] !== me || e[68] !== Pe || e[69] !== Me || e[70] !== _e ? (Ue = /* @__PURE__ */ m(Is, { id: n, "data-testid": C, "aria-label": be, "aria-required": ve, tabIndex: me, className: Pe, placeholder: Me, onFocus: AS, onMouseDown: _e }), e[63] = C, e[64] = n, e[65] = be, e[66] = ve, e[67] = me, e[68] = Pe, e[69] = Me, e[70] = _e, e[71] = Ue) : Ue = e[71];
  let Ye;
  e[72] !== E ? (Ye = !E && /* @__PURE__ */ m(ya, { "aria-label": "Open options", className: "inline-flex shrink-0 text-input-text-default outline-none", children: /* @__PURE__ */ m(Ke, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[72] = E, e[73] = Ye) : Ye = e[73];
  let He;
  e[74] !== j || e[75] !== Ue || e[76] !== Ye || e[77] !== ge || e[78] !== ue ? (He = /* @__PURE__ */ F(j, { className: ge, children: [
    ue,
    Ue,
    Ye
  ] }), e[74] = j, e[75] = Ue, e[76] = Ye, e[77] = ge, e[78] = ue, e[79] = He) : He = e[79];
  const ye = T === "content" ? "w-auto min-w-(--anchor-width) max-w-[calc(100vw-var(--spacing-16))]" : "w-(--anchor-width)";
  let Oe;
  e[80] !== ye ? (Oe = ne("z-[var(--z-layer-popover)]", ye), e[80] = ye, e[81] = Oe) : Oe = e[81];
  let Ie;
  e[82] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Ie = ws({
    size: "auto"
  }), e[82] = Ie) : Ie = e[82];
  let Le;
  e[83] !== K || e[84] !== w ? (Le = /* @__PURE__ */ m(Ps, { className: "flex flex-col outline-none", children: (Fe) => /* @__PURE__ */ F(Ts, { value: Fe, disabled: Fe.disabled, className: Ko({}), children: [
    Fe.icon && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 text-menu-icon-default", children: /* @__PURE__ */ m(Ke, { name: Fe.icon, size: "xs", tone: "inherit" }) }),
    /* @__PURE__ */ m(Xi, { checked: Fe.value === K, children: w ? w(Fe) : Fe.label })
  ] }, Fe.value) }), e[83] = K, e[84] = w, e[85] = Le) : Le = e[85];
  let Be;
  e[86] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Be = /* @__PURE__ */ m(Tf, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[86] = Be) : Be = e[86];
  let Te;
  e[87] !== Le ? (Te = /* @__PURE__ */ F(wa, { className: Ie, children: [
    Le,
    Be
  ] }), e[87] = Le, e[88] = Te) : Te = e[88];
  let vt;
  e[89] !== Oe || e[90] !== Te ? (vt = /* @__PURE__ */ m(Ca, { sideOffset: 4, className: Oe, children: Te }), e[89] = Oe, e[90] = Te, e[91] = vt) : vt = e[91];
  let nt;
  e[92] !== P || e[93] !== vt ? (nt = /* @__PURE__ */ m(xa, { container: P, children: vt }), e[92] = P, e[93] = vt, e[94] = nt) : nt = e[94];
  let we;
  e[95] !== Z || e[96] !== W || e[97] !== X || e[98] !== ee || e[99] !== le || e[100] !== J || e[101] !== ie || e[102] !== pe || e[103] !== oe || e[104] !== re || e[105] !== de || e[106] !== xe || e[107] !== se || e[108] !== fe || e[109] !== $ || e[110] !== He || e[111] !== nt || e[112] !== Re ? (we = /* @__PURE__ */ F(Z, { value: Re, onValueChange: W, disabled: X, readOnly: ee, required: le, name: J, modal: ie, items: pe, isItemEqualToValue: oe, itemToStringLabel: re, itemToStringValue: de, open: xe, inputValue: se, onInputValueChange: fe, onOpenChange: $, children: [
    He,
    nt
  ] }), e[95] = Z, e[96] = W, e[97] = X, e[98] = ee, e[99] = le, e[100] = J, e[101] = ie, e[102] = pe, e[103] = oe, e[104] = re, e[105] = de, e[106] = xe, e[107] = se, e[108] = fe, e[109] = $, e[110] = He, e[111] = nt, e[112] = Re, e[113] = we) : we = e[113];
  let Ne;
  e[114] !== f || e[115] !== p || e[116] !== I || e[117] !== N || e[118] !== M ? (Ne = M && /* @__PURE__ */ m("div", { "data-testid": "select-subtext-row", className: ne("mt-(--spacing-4)", N && "min-h-(--spacing-20)"), children: I ? /* @__PURE__ */ m(Pr, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: p }) : f ? /* @__PURE__ */ m(fi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: f }) : null }), e[114] = f, e[115] = p, e[116] = I, e[117] = N, e[118] = M, e[119] = Ne) : Ne = e[119];
  let Ae;
  return e[120] !== te || e[121] !== Q || e[122] !== H || e[123] !== q || e[124] !== ae || e[125] !== we || e[126] !== Ne ? (Ae = /* @__PURE__ */ F(te, { invalid: Q, disabled: H, className: q, children: [
    ae,
    we,
    Ne
  ] }), e[120] = te, e[121] = Q, e[122] = H, e[123] = q, e[124] = ae, e[125] = we, e[126] = Ne, e[127] = Ae) : Ae = e[127], Ae;
}
function AS(t) {
  return t.currentTarget.select();
}
function LS(t) {
  return t.value;
}
function FS(t) {
  return t.label;
}
function $S(t, e) {
  return t.value === e.value;
}
function pg(t) {
  if (t)
    return {
      ...t,
      tone: t.tone === "neutral" ? "activity" : t.tone
    };
}
function Hi(t) {
  return t.replace(/^\s*(?:\([^)]*\)\s*[-–—]?\s*)+/, "").split(/\s+/).filter(Boolean).slice(0, 2).map((n) => n[0]).join("").toUpperCase();
}
function HS(t) {
  const e = z.c(36), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    collapsed: a
  } = t;
  let c;
  e[0] !== n ? (c = function(p) {
    return n.find((g) => g.id === p);
  }, e[0] = n, e[1] = c) : c = e[1];
  const u = c;
  let d;
  if (e[2] !== s || e[3] !== a || e[4] !== n || e[5] !== l || e[6] !== u || e[7] !== i || e[8] !== r || e[9] !== o) {
    const f = u(o), p = f ? l?.(f) ?? [] : [];
    let g;
    e[11] !== a || e[12] !== n.length ? (g = a ? /* @__PURE__ */ m("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ m("span", { className: "w-full border-t border-outline-subtle" }) }) : /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
      "FACILITIES (",
      n.length,
      ")"
    ] }), e[11] = a, e[12] = n.length, e[13] = g) : g = e[13];
    const h = a ? "flex w-full justify-center" : void 0, b = a ? "w-[60px] shrink-0" : void 0;
    let v;
    e[14] !== n ? (v = n.map(zS), e[14] = n, e[15] = v) : v = e[15];
    let C;
    e[16] !== a || e[17] !== u ? (C = (N) => N ? /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ m(Gr, { initials: Hi(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      !a && /* @__PURE__ */ m("span", { className: "truncate", children: N.label })
    ] }) : null, e[16] = a, e[17] = u, e[18] = C) : C = e[18];
    let y;
    e[19] !== u ? (y = (N) => /* @__PURE__ */ F("span", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
      /* @__PURE__ */ m(Gr, { initials: Hi(N.label), size: "xs", src: u(N.value)?.avatarUrl, variant: "external" }),
      /* @__PURE__ */ m("span", { className: "truncate", children: N.label })
    ] }), e[19] = u, e[20] = y) : y = e[20];
    let w;
    e[21] !== i || e[22] !== r ? (w = (N) => {
      N && (r ?? i)(N);
    }, e[21] = i, e[22] = r, e[23] = w) : w = e[23];
    let R;
    e[24] !== o || e[25] !== v || e[26] !== C || e[27] !== y || e[28] !== w ? (R = /* @__PURE__ */ m(A0, { options: v, required: !0, popupWidth: "content", reserveSubtextSpace: !1, size: "md", value: o, renderValue: C, renderOption: y, onChange: w }), e[24] = o, e[25] = v, e[26] = C, e[27] = y, e[28] = w, e[29] = R) : R = e[29];
    let S;
    e[30] !== R || e[31] !== b ? (S = /* @__PURE__ */ m("div", { className: b, children: R }), e[30] = R, e[31] = b, e[32] = S) : S = e[32];
    let E;
    e[33] !== S || e[34] !== h ? (E = /* @__PURE__ */ m("div", { className: h, children: S }), e[33] = S, e[34] = h, e[35] = E) : E = e[35], d = /* @__PURE__ */ F("section", { "aria-label": `Facilities (${n.length})`, children: [
      g,
      E,
      f && p.length > 0 && /* @__PURE__ */ m("div", { className: "mt-(--spacing-4) flex flex-col gap-(--spacing-4)", children: p.map((N) => /* @__PURE__ */ m(Rl, { itemId: N.id, label: N.label, badge: N.badge, leading: N.icon ? {
        type: "icon",
        name: N.icon
      } : void 0, href: N.render ? void 0 : N.href ?? "#", render: N.render, onClick: (T) => {
        i(f.id), N.onClick?.(T);
      }, selected: f.id === o && N.id === s, variant: "item" }, N.id)) })
    ] }), e[2] = s, e[3] = a, e[4] = n, e[5] = l, e[6] = u, e[7] = i, e[8] = r, e[9] = o, e[10] = d;
  } else
    d = e[10];
  return d;
}
function zS(t) {
  return {
    value: t.id,
    label: t.name
  };
}
function eD(t) {
  const e = z.c(85), {
    facilities: n,
    selectedFacilityId: o,
    onFacilitySelect: r,
    onFacilityChange: i,
    activeItemId: s,
    facilitySubNavItems: l,
    expandedFacilityId: a,
    initialExpandedFacilityId: c,
    onExpandedFacilityChange: u
  } = t, {
    collapsed: d
  } = l0(), [f, p] = ot(c), g = "expandedFacilityId" in t, h = g ? a : f, b = ft(!1), v = ft(o);
  let C;
  e[0] !== g || e[1] !== u ? (C = function(M) {
    g || p(M), u?.(M);
  }, e[0] = g, e[1] = u, e[2] = C) : C = e[2];
  const y = C;
  let w, R;
  if (e[3] !== h || e[4] !== n || e[5] !== g || e[6] !== u || e[7] !== o ? (w = () => {
    if (g || n.length < 2 || n.length > 5)
      return;
    const k = !b.current;
    b.current = !0;
    const M = v.current !== o;
    v.current = o, (k && h === void 0 || M || h !== void 0 && !n.some((D) => D.id === h)) && (g || p(o), u?.(o));
  }, R = [h, n, g, u, o], e[3] = h, e[4] = n, e[5] = g, e[6] = u, e[7] = o, e[8] = w, e[9] = R) : (w = e[8], R = e[9]), kt(w, R), n.length === 0)
    return null;
  if (n.length === 1) {
    const k = n[0];
    let M, D, O, V, _, A, L, B, G;
    if (e[10] !== s || e[11] !== l || e[12] !== k || e[13] !== i || e[14] !== o) {
      const K = l?.(k) ?? [];
      let j;
      e[24] !== k.alertBadge ? (j = pg(k.alertBadge), e[24] = k.alertBadge, e[25] = j) : j = e[25];
      const Z = j;
      D = k.name, M = ng, O = !1, V = k.id, _ = k.name, A = Z;
      let te;
      e[26] !== s ? (te = (ee) => ee.id === s, e[26] = s, e[27] = te) : te = e[27], L = K.some(te);
      let W;
      e[28] !== k.name ? (W = Hi(k.name), e[28] = k.name, e[29] = W) : W = e[29], e[30] !== k.avatarUrl || e[31] !== W ? (B = {
        type: "avatar",
        initials: W,
        src: k.avatarUrl
      }, e[30] = k.avatarUrl, e[31] = W, e[32] = B) : B = e[32];
      let X;
      e[33] !== s || e[34] !== k.id || e[35] !== i || e[36] !== o ? (X = (ee) => /* @__PURE__ */ m(Rl, { itemId: ee.id, label: ee.label, badge: ee.badge, leading: ee.icon ? {
        type: "icon",
        name: ee.icon
      } : void 0, href: ee.render ? void 0 : ee.href ?? "#", render: ee.render, onClick: (le) => {
        i(k.id), ee.onClick?.(le);
      }, selected: k.id === o && ee.id === s, variant: "item" }, ee.id), e[33] = s, e[34] = k.id, e[35] = i, e[36] = o, e[37] = X) : X = e[37], G = K.map(X), e[10] = s, e[11] = l, e[12] = k, e[13] = i, e[14] = o, e[15] = M, e[16] = D, e[17] = O, e[18] = V, e[19] = _, e[20] = A, e[21] = L, e[22] = B, e[23] = G;
    } else
      M = e[15], D = e[16], O = e[17], V = e[18], _ = e[19], A = e[20], L = e[21], B = e[22], G = e[23];
    let U;
    e[38] !== M || e[39] !== O || e[40] !== V || e[41] !== _ || e[42] !== A || e[43] !== L || e[44] !== B || e[45] !== G ? (U = /* @__PURE__ */ m(M, { collapsible: O, itemId: V, label: _, badge: A, hasSelectedChild: L, leading: B, children: G }), e[38] = M, e[39] = O, e[40] = V, e[41] = _, e[42] = A, e[43] = L, e[44] = B, e[45] = G, e[46] = U) : U = e[46];
    let Y;
    return e[47] !== D || e[48] !== U ? (Y = /* @__PURE__ */ m("section", { "aria-label": D, children: U }), e[47] = D, e[48] = U, e[49] = Y) : Y = e[49], Y;
  }
  if (n.length > 5) {
    let k;
    return e[50] !== s || e[51] !== d || e[52] !== n || e[53] !== l || e[54] !== i || e[55] !== r || e[56] !== o ? (k = /* @__PURE__ */ m(HS, { facilities: n, selectedFacilityId: o, onFacilitySelect: r, onFacilityChange: i, activeItemId: s, facilitySubNavItems: l, collapsed: d }), e[50] = s, e[51] = d, e[52] = n, e[53] = l, e[54] = i, e[55] = r, e[56] = o, e[57] = k) : k = e[57], k;
  }
  const S = `Facilities (${n.length})`;
  let E;
  e[58] !== d || e[59] !== n.length ? (E = !d && /* @__PURE__ */ F("span", { className: "flex h-(--spacing-40) items-center whitespace-nowrap px-(--spacing-10) text-(length:--font-size-label-medium) font-(number:--font-weight-medium) text-text-subtle", children: [
    "FACILITIES (",
    n.length,
    ")"
  ] }), e[58] = d, e[59] = n.length, e[60] = E) : E = e[60];
  let N;
  e[61] !== d ? (N = d && /* @__PURE__ */ m("div", { "aria-hidden": !0, className: "flex h-(--spacing-40) items-center", children: /* @__PURE__ */ m("span", { className: "w-full border-t border-outline-subtle" }) }), e[61] = d, e[62] = N) : N = e[62];
  let T;
  if (e[63] !== s || e[64] !== h || e[65] !== n || e[66] !== l || e[67] !== i || e[68] !== o || e[69] !== y) {
    let k;
    e[71] !== s || e[72] !== h || e[73] !== l || e[74] !== i || e[75] !== o || e[76] !== y ? (k = (M) => {
      const D = l?.(M) ?? [], O = pg(M.alertBadge), V = M.id === o && D.some((A) => A.id === s), _ = M.id === h;
      return D.length ? /* @__PURE__ */ m(ng, { itemId: M.id, label: M.name, badge: O, leading: {
        type: "avatar",
        initials: Hi(M.name),
        src: M.avatarUrl
      }, hasSelectedChild: V, open: _, onOpenChange: (A) => {
        const L = A ? M.id : void 0;
        y(L);
      }, children: D.map((A) => /* @__PURE__ */ m(Rl, { itemId: A.id, label: A.label, badge: A.badge, leading: A.icon ? {
        type: "icon",
        name: A.icon
      } : void 0, href: A.render ? void 0 : A.href ?? "#", render: A.render, onClick: (L) => {
        i(M.id), A.onClick?.(L);
      }, selected: M.id === o && A.id === s, variant: "subItem" }, A.id)) }, M.id) : /* @__PURE__ */ m(Rl, { itemId: M.id, label: M.name, leading: {
        type: "avatar",
        initials: Hi(M.name),
        src: M.avatarUrl
      }, href: "#", badge: O, selected: M.id === o, onClick: (A) => {
        A.preventDefault(), i(M.id);
      } }, M.id);
    }, e[71] = s, e[72] = h, e[73] = l, e[74] = i, e[75] = o, e[76] = y, e[77] = k) : k = e[77], T = n.map(k), e[63] = s, e[64] = h, e[65] = n, e[66] = l, e[67] = i, e[68] = o, e[69] = y, e[70] = T;
  } else
    T = e[70];
  let P;
  e[78] !== T ? (P = /* @__PURE__ */ m("div", { className: "flex flex-col gap-(--spacing-4)", children: T }), e[78] = T, e[79] = P) : P = e[79];
  let I;
  return e[80] !== S || e[81] !== E || e[82] !== N || e[83] !== P ? (I = /* @__PURE__ */ F("section", { "aria-label": S, className: "flex flex-col gap-(--spacing-4)", children: [
    E,
    N,
    P
  ] }), e[80] = S, e[81] = E, e[82] = N, e[83] = P, e[84] = I) : I = e[84], I;
}
const L0 = mo(void 0);
function BS(t) {
  return t === "light" || t === "dark" || t === "system";
}
function gg() {
  return typeof window > "u" || !window.matchMedia ? "light" : window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function WS(t, e) {
  if (typeof window > "u")
    return e;
  try {
    const n = localStorage.getItem(t);
    return BS(n) ? n : e;
  } catch {
    return e;
  }
}
function US(t) {
  const e = z.c(21), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, i = o === void 0 ? "light" : o, s = r === void 0 ? "assetwatch-ui-theme" : r;
  let l;
  e[0] !== i || e[1] !== s ? (l = () => WS(s, i), e[0] = i, e[1] = s, e[2] = l) : l = e[2];
  const [a, c] = ot(l), [u, d] = ot(gg), f = a === "system" ? u : a;
  let p, g;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = () => {
    if (!window.matchMedia)
      return;
    const E = window.matchMedia("(prefers-color-scheme: dark)"), N = () => d(gg());
    return E.addEventListener("change", N), () => E.removeEventListener("change", N);
  }, g = [], e[3] = p, e[4] = g) : (p = e[3], g = e[4]), kt(p, g);
  let h, b;
  e[5] !== f ? (h = () => {
    const E = window.document.documentElement;
    E.classList.remove("light", "dark"), E.classList.add(f);
  }, b = [f], e[5] = f, e[6] = h, e[7] = b) : (h = e[6], b = e[7]), kt(h, b);
  let v;
  e[8] !== s ? (v = (E) => {
    localStorage.setItem(s, E), c(E);
  }, e[8] = s, e[9] = v) : v = e[9];
  const C = v;
  let y;
  e[10] !== f || e[11] !== C ? (y = () => {
    C(f === "light" ? "dark" : "light");
  }, e[10] = f, e[11] = C, e[12] = y) : y = e[12];
  const w = y;
  let R;
  e[13] !== f || e[14] !== C || e[15] !== a || e[16] !== w ? (R = {
    theme: a,
    resolvedTheme: f,
    setTheme: C,
    toggleTheme: w
  }, e[13] = f, e[14] = C, e[15] = a, e[16] = w, e[17] = R) : R = e[17];
  let S;
  return e[18] !== n || e[19] !== R ? (S = /* @__PURE__ */ m(L0.Provider, { value: R, children: n }), e[18] = n, e[19] = R, e[20] = S) : S = e[20], S;
}
function GS() {
  const t = um(L0);
  if (t === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return t;
}
const tD = {
  openMenuAriaLabel: "Open account menu",
  engineeringOnly: "Engineering Only",
  appearance: "Theme",
  matchBrowser: "Match Browser",
  light: "Light",
  dark: "Dark",
  currentArtifact: "Current artifact",
  signOut: "Sign out"
}, YS = [{
  value: "system",
  label: "matchBrowser"
}, {
  value: "light",
  label: "light"
}, {
  value: "dark",
  label: "dark"
}];
function nD(t) {
  const e = z.c(19), {
    additionalContent: n,
    labels: o,
    engineeringOnly: r,
    engineeringContent: i,
    onOpenArtifact: s,
    onSignOut: l
  } = t, a = r === void 0 ? !1 : r, {
    theme: c,
    setTheme: u
  } = GS();
  let d;
  e[0] !== o.openMenuAriaLabel ? (d = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(mt, { "aria-label": o.openMenuAriaLabel, icon: "user", size: "md", variant: "outline" }) }), e[0] = o.openMenuAriaLabel, e[1] = d) : d = e[1];
  let f;
  e[2] !== o.signOut || e[3] !== l ? (f = /* @__PURE__ */ m(fr, { "data-testid": "nav-sign-out", leadingIcon: "logout-exit", onClick: l, tone: "destructive", children: o.signOut }), e[2] = o.signOut, e[3] = l, e[4] = f) : f = e[4];
  let p;
  e[5] !== i || e[6] !== a || e[7] !== o || e[8] !== s || e[9] !== u || e[10] !== c ? (p = a ? /* @__PURE__ */ F(zt, { children: [
    /* @__PURE__ */ m(lu, { children: o.engineeringOnly }),
    /* @__PURE__ */ m(fr, { leadingIcon: "settings-cog", submenu: /* @__PURE__ */ F(Pd, { value: c, onValueChange: (b) => u(b), children: [
      /* @__PURE__ */ m(lu, { children: o.appearance }),
      YS.map((b) => {
        const {
          value: v,
          label: C
        } = b;
        return /* @__PURE__ */ m(Td, { value: v, children: o[C] }, v);
      })
    ] }), children: o.appearance }),
    s ? /* @__PURE__ */ m(fr, { leadingIcon: "document", onClick: s, children: o.currentArtifact }) : null,
    i
  ] }) : null, e[5] = i, e[6] = a, e[7] = o, e[8] = s, e[9] = u, e[10] = c, e[11] = p) : p = e[11];
  let g;
  e[12] !== n || e[13] !== f || e[14] !== p ? (g = /* @__PURE__ */ F(kr, { align: "end", size: "sm", children: [
    n,
    f,
    p
  ] }), e[12] = n, e[13] = f, e[14] = p, e[15] = g) : g = e[15];
  let h;
  return e[16] !== d || e[17] !== g ? (h = /* @__PURE__ */ F(Id, { children: [
    d,
    g
  ] }), e[16] = d, e[17] = g, e[18] = h) : h = e[18], h;
}
const jS = ce(["rounded-(--radius-sm)", "border border-outline-subtle", "bg-surface-container-lowest", "flex flex-col"], {
  variants: {
    padding: {
      compact: "py-(--spacing-12) px-(--spacing-6)",
      standard: "p-(--spacing-12)"
    },
    elevated: {
      true: "shadow-elevation-1",
      false: null
    }
  },
  defaultVariants: {
    padding: "standard",
    elevated: !1
  }
}), KS = ce(["w-full", "flex flex-col", "[overflow:clip]", "rounded-(--radius-sm)", "border-[0.5px] border-outline-subtle", "bg-surface-container-low", "text-text-default"], {
  variants: {
    padding: {
      none: "p-0",
      compact: "p-(--spacing-8) gap-(--spacing-8)"
    }
  },
  defaultVariants: {
    padding: "compact"
  }
}), qS = ce(["min-w-0 truncate", "font-(family-name:--font-family-title)", "text-(length:--font-size-title-md)", "font-medium", "leading-(--line-height-24)", "text-text-default"]), ZS = ce(["w-full min-w-0", "flex gap-(--spacing-24) items-start overflow-hidden"]);
function F0(t) {
  const e = z.c(14);
  let n, o, r, i, s;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: i,
    elevated: r,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  let l;
  e[6] !== o || e[7] !== r || e[8] !== i ? (l = ne(jS({
    padding: i,
    elevated: r
  }), o), e[6] = o, e[7] = r, e[8] = i, e[9] = l) : l = e[9];
  let a;
  return e[10] !== n || e[11] !== s || e[12] !== l ? (a = /* @__PURE__ */ m("div", { className: l, ...s, "data-slot": "content-container-root", children: n }), e[10] = n, e[11] = s, e[12] = l, e[13] = a) : a = e[13], a;
}
function $0(t) {
  const e = z.c(12);
  let n, o, r, i;
  e[0] !== t ? ({
    children: n,
    className: o,
    padding: r,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] !== o || e[6] !== r ? (s = ne(KS({
    padding: r
  }), o), e[5] = o, e[6] = r, e[7] = s) : s = e[7];
  let l;
  return e[8] !== n || e[9] !== i || e[10] !== s ? (l = /* @__PURE__ */ m("div", { className: s, ...i, "data-slot": "content-container-body", children: n }), e[8] = n, e[9] = i, e[10] = s, e[11] = l) : l = e[11], l;
}
function H0(t) {
  const e = z.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = ne("w-full", o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ m("div", { className: i, ...r, "data-slot": "content-container-footer", children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
function XS(t) {
  const e = z.c(20), {
    main: n,
    start: o,
    titleAccessory: r,
    actions: i,
    summary: s
  } = t;
  let l;
  e[0] !== o ? (l = o && /* @__PURE__ */ m("div", { "data-slot": "content-container-start-accessory", className: "flex shrink-0 items-center", children: o }), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = r && /* @__PURE__ */ m("div", { "data-slot": "content-container-title-accessory", className: "flex shrink-0 items-center", children: r }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== n || e[5] !== a ? (c = /* @__PURE__ */ F("div", { "data-slot": "content-container-main", className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    a
  ] }), e[4] = n, e[5] = a, e[6] = c) : c = e[6];
  let u;
  e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-left", className: "flex flex-1 gap-(--spacing-8) items-center min-w-0", children: [
    l,
    c
  ] }), e[7] = l, e[8] = c, e[9] = u) : u = e[9];
  let d;
  e[10] !== i ? (d = i && /* @__PURE__ */ m("div", { "data-slot": "content-container-actions", className: "flex shrink-0 gap-(--spacing-8) items-center justify-end", children: i }), e[10] = i, e[11] = d) : d = e[11];
  let f;
  e[12] !== u || e[13] !== d ? (f = /* @__PURE__ */ F("div", { "data-slot": "content-container-header", className: "flex items-center gap-(--spacing-8) w-full", children: [
    u,
    d
  ] }), e[12] = u, e[13] = d, e[14] = f) : f = e[14];
  let p;
  e[15] !== s ? (p = s && /* @__PURE__ */ m("div", { "data-slot": "content-container-summary", className: ZS(), children: s }), e[15] = s, e[16] = p) : p = e[16];
  let g;
  return e[17] !== f || e[18] !== p ? (g = /* @__PURE__ */ F("div", { "data-slot": "content-container-header-wrapper", className: "flex flex-col gap-(--spacing-8) w-full", children: [
    f,
    p
  ] }), e[17] = f, e[18] = p, e[19] = g) : g = e[19], g;
}
function z0(t) {
  const e = z.c(10);
  let n, o, r;
  e[0] !== t ? ({
    children: n,
    className: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] !== o ? (i = ne(qS(), o), e[4] = o, e[5] = i) : i = e[5];
  let s;
  return e[6] !== n || e[7] !== r || e[8] !== i ? (s = /* @__PURE__ */ m("span", { className: i, ...r, children: n }), e[6] = n, e[7] = r, e[8] = i, e[9] = s) : s = e[9], s;
}
const QS = ce(["hover:bg-surface-container-low", "cursor-pointer", "transition-colors duration-200 ease-in-out", "has-[:focus-visible]:[outline-width:var(--spacing-2)]", "has-[:focus-visible]:outline-solid", "has-[:focus-visible]:outline-tertiary-tertiary", "has-[:focus-visible]:[outline-offset:3px]", "data-[disabled]:opacity-50", "data-[disabled]:cursor-default"]), JS = ce(["w-full", "flex items-center gap-(--spacing-8)", "cursor-pointer", "min-h-(--spacing-24)", "text-left", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), eR = ce(["group", "flex size-(--spacing-32) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "cursor-pointer", "focus-visible:outline-none", "disabled:pointer-events-none", "disabled:cursor-default"]), tR = ce(["w-full", "min-w-0", "overflow-hidden", "h-(--collapsible-panel-height)", "[&[data-starting-style]]:h-0", "[&[data-ending-style]]:h-0", "mt-(--spacing-12)", "[&[data-starting-style]]:mt-0", "[&[data-ending-style]]:mt-0", "transition-[height,margin-top] duration-150 ease-in-out", "motion-reduce:transition-none"]), nR = ["[data-accordion-panel-content]", "[data-accordion-ignore-shell-click]", "button", "a", "input", "label", "select", "textarea", "[role='button']", "[role='link']", "[role='menuitem']", "[role='option']", "[role='switch']", "[role='checkbox']", "[role='radio']"].join(",");
function oR(t) {
  return t instanceof Element ? t.closest(nR) === null : !1;
}
function oD(t) {
  const e = z.c(66);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    open: a,
    defaultOpen: r,
    onOpenChange: l,
    title: f,
    startAccessory: u,
    titleAccessory: p,
    actions: n,
    summary: d,
    children: o,
    footer: s,
    disabled: i,
    ...c
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  let g;
  e[13] !== r ? (g = () => r ?? !1, e[13] = r, e[14] = g) : g = e[14];
  const [h, b] = ot(g), v = a !== void 0, C = v ? a : h;
  let y;
  e[15] !== v || e[16] !== l ? (y = function(W) {
    v || b(W), l?.(W);
  }, e[15] = v, e[16] = l, e[17] = y) : y = e[17];
  const w = y;
  let R;
  e[18] !== i || e[19] !== C || e[20] !== w ? (R = function(W) {
    i || !oR(W.target) || w(!C);
  }, e[18] = i, e[19] = C, e[20] = w, e[21] = R) : R = e[21];
  const S = R, E = i ? "" : void 0;
  let N;
  e[22] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = QS(), e[22] = N) : N = e[22];
  let T;
  e[23] !== u ? (T = u && /* @__PURE__ */ m("div", { className: "flex shrink-0 items-center", children: u }), e[23] = u, e[24] = T) : T = e[24];
  let P;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = JS(), e[25] = P) : P = e[25];
  let I;
  e[26] !== f ? (I = /* @__PURE__ */ m("h3", { className: "flex min-w-0 flex-1 m-0", children: /* @__PURE__ */ m(Bl, { className: P, onClick: iR, children: /* @__PURE__ */ m(z0, { className: "flex-1", children: f }) }) }), e[26] = f, e[27] = I) : I = e[27];
  let k;
  e[28] !== p ? (k = p && /* @__PURE__ */ m("div", { className: "flex shrink-0 items-center", children: p }), e[28] = p, e[29] = k) : k = e[29];
  let M;
  e[30] !== I || e[31] !== k ? (M = /* @__PURE__ */ F("div", { className: "flex flex-1 min-w-0 items-center gap-(--spacing-8)", children: [
    I,
    k
  ] }), e[30] = I, e[31] = k, e[32] = M) : M = e[32];
  let D;
  e[33] !== n ? (D = n && /* @__PURE__ */ m("div", { "data-accordion-ignore-shell-click": "", className: "flex shrink-0 items-center", children: n }), e[33] = n, e[34] = D) : D = e[34];
  let O;
  e[35] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (O = eR(), e[35] = O) : O = e[35];
  let V;
  e[36] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ m("span", { className: "flex group-data-[panel-open]:hidden", children: /* @__PURE__ */ m(Ke, { name: "chevron-down", size: "md", tone: "secondary" }) }), e[36] = V) : V = e[36];
  let _;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (_ = /* @__PURE__ */ F(Bl, { "aria-label": "Toggle accordion", "data-slot": "accordion-chevron-trigger", className: O, onClick: rR, children: [
    V,
    /* @__PURE__ */ m("span", { className: "hidden group-data-[panel-open]:flex", children: /* @__PURE__ */ m(Ke, { name: "chevron-up", size: "md", tone: "secondary" }) })
  ] }), e[37] = _) : _ = e[37];
  let A;
  e[38] !== M || e[39] !== D || e[40] !== T ? (A = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8) w-full", children: [
    T,
    M,
    D,
    _
  ] }), e[38] = M, e[39] = D, e[40] = T, e[41] = A) : A = e[41];
  let L;
  e[42] !== d ? (L = d && /* @__PURE__ */ m("div", { className: "w-full min-w-0", children: d }), e[42] = d, e[43] = L) : L = e[43];
  let B;
  e[44] !== A || e[45] !== L ? (B = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8) w-full", children: [
    A,
    L
  ] }), e[44] = A, e[45] = L, e[46] = B) : B = e[46];
  let G;
  e[47] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (G = tR(), e[47] = G) : G = e[47];
  let U;
  e[48] !== o ? (U = /* @__PURE__ */ m($0, { children: o }), e[48] = o, e[49] = U) : U = e[49];
  let Y;
  e[50] !== s ? (Y = s && /* @__PURE__ */ m(H0, { children: s }), e[50] = s, e[51] = Y) : Y = e[51];
  let K;
  e[52] !== U || e[53] !== Y ? (K = /* @__PURE__ */ m(Qd, { className: G, children: /* @__PURE__ */ F("div", { "data-accordion-panel-content": "", className: "flex flex-col gap-(--spacing-4) cursor-default", children: [
    U,
    Y
  ] }) }), e[52] = U, e[53] = Y, e[54] = K) : K = e[54];
  let j;
  e[55] !== S || e[56] !== B || e[57] !== K || e[58] !== E ? (j = /* @__PURE__ */ F(F0, { padding: "standard", "data-disabled": E, className: N, onClick: S, children: [
    B,
    K
  ] }), e[55] = S, e[56] = B, e[57] = K, e[58] = E, e[59] = j) : j = e[59];
  let Z;
  return e[60] !== i || e[61] !== C || e[62] !== c || e[63] !== w || e[64] !== j ? (Z = /* @__PURE__ */ m(Xd, { ...c, open: C, onOpenChange: w, disabled: i, className: "group", children: j }), e[60] = i, e[61] = C, e[62] = c, e[63] = w, e[64] = j, e[65] = Z) : Z = e[65], Z;
}
function rR(t) {
  return t.stopPropagation();
}
function iR(t) {
  return t.stopPropagation();
}
const sR = ce(["flex", "w-full", "items-center", "justify-between", "px-(--spacing-24)", "py-(--spacing-16)", "rounded-(--radius-sm)", "relative", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-px", "after:bg-outline-subtle"], {
  variants: {
    tone: {
      neutral: ["bg-surface-container-low", "text-surface-on-surface"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    }
  },
  defaultVariants: {
    tone: "neutral"
  }
});
function rD(t) {
  const e = z.c(35);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    icon: r,
    tone: l,
    title: a,
    description: o,
    action: n,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = l === void 0 ? "neutral" : l, u = c === "negative", d = u ? "alert" : "status", f = u ? "assertive" : "polite";
  let p;
  e[8] !== c ? (p = ne(sR({
    tone: c
  })), e[8] = c, e[9] = p) : p = e[9];
  let g;
  e[10] !== r ? (g = /* @__PURE__ */ m(Ke, { name: r, size: "md", tone: "inherit" }), e[10] = r, e[11] = g) : g = e[11];
  let h;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (h = {
    color: "inherit"
  }, e[12] = h) : h = e[12];
  let b;
  e[13] !== a ? (b = /* @__PURE__ */ m(An, { as: "span", size: "md", style: h, children: a }), e[13] = a, e[14] = b) : b = e[14];
  let v;
  e[15] !== o ? (v = o ? /* @__PURE__ */ m(ln, { as: "span", size: "md", style: {
    color: "inherit"
  }, children: o }) : null, e[15] = o, e[16] = v) : v = e[16];
  let C;
  e[17] !== b || e[18] !== v ? (C = /* @__PURE__ */ F("div", { className: "min-w-0 flex flex-col gap-(--spacing-8)", children: [
    b,
    v
  ] }), e[17] = b, e[18] = v, e[19] = C) : C = e[19];
  let y;
  e[20] !== g || e[21] !== C ? (y = /* @__PURE__ */ F("div", { className: "flex flex-1 items-start gap-(--spacing-8) min-w-0", children: [
    g,
    C
  ] }), e[20] = g, e[21] = C, e[22] = y) : y = e[22];
  let w;
  e[23] !== i ? (w = /* @__PURE__ */ m(mt, { icon: "x-close", "aria-label": "Dismiss banner", variant: "ghost", size: "sm", onClick: i }), e[23] = i, e[24] = w) : w = e[24];
  let R;
  e[25] !== n || e[26] !== w ? (R = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-start gap-(--spacing-8)", children: [
    n,
    w
  ] }), e[25] = n, e[26] = w, e[27] = R) : R = e[27];
  let S;
  return e[28] !== s || e[29] !== y || e[30] !== R || e[31] !== d || e[32] !== f || e[33] !== p ? (S = /* @__PURE__ */ F("div", { role: d, "aria-live": f, className: p, ...s, children: [
    y,
    R
  ] }), e[28] = s, e[29] = y, e[30] = R, e[31] = d, e[32] = f, e[33] = p, e[34] = S) : S = e[34], S;
}
function iD(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m("nav", { "aria-label": "Breadcrumb", "data-slot": "breadcrumb", className: "w-full min-w-0", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function sD({
  children: t,
  ref: e,
  ...n
}) {
  const o = ft(null), r = ft(null), i = ft(() => {
  }), [s, l] = ot(!1), a = ql.toArray(t), c = a.filter(B0), u = a.filter(cR), d = uR(t), f = c.length > 2 && a.length === c.length + u.length;
  i.current = function() {
    const b = o.current, v = r.current;
    if (!f || !b || !v) {
      l(!1);
      return;
    }
    const C = b.getBoundingClientRect().width, y = v.getBoundingClientRect().width;
    l(C > 0 && y > C);
  };
  function p(h) {
    o.current = h, typeof e == "function" ? e(h) : e && (e.current = h);
  }
  Io(() => {
    i.current();
  }), Io(() => {
    const h = o.current;
    if (!h || typeof ResizeObserver > "u")
      return;
    const b = new ResizeObserver(() => {
      i.current();
    });
    return b.observe(h), () => {
      b.disconnect();
    };
  }, []);
  const g = s && f ? [c[0], mg(u[0], "breadcrumb-overflow-leading-separator"), /* @__PURE__ */ m(dR, { items: c.slice(1, -1) }, "breadcrumb-overflow"), mg(u[0], "breadcrumb-overflow-trailing-separator"), c.at(-1)] : t;
  return /* @__PURE__ */ F(zt, { children: [
    /* @__PURE__ */ m("ol", { ...n, ref: p, "data-slot": "breadcrumb-list", "data-collapsed": s && f ? "" : void 0, className: "flex w-full min-w-0 flex-nowrap items-center gap-(--spacing-8) overflow-hidden p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: g }),
    f && /* @__PURE__ */ m("ol", { ref: r, "aria-hidden": "true", inert: !0, "data-slot": "breadcrumb-list-measurement", className: "pointer-events-none invisible absolute flex w-max flex-nowrap items-center gap-(--spacing-8) p-(--spacing-8) text-(length:--font-size-body-md) leading-(--line-height-20)", children: d })
  ] });
}
function lR(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m("li", { "data-slot": "breadcrumb-item", className: "inline-flex min-w-0 items-center", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function aR(t) {
  const e = z.c(10);
  let n, o, r, i;
  if (e[0] !== t) {
    const {
      render: l,
      ...a
    } = t;
    i = Jd, n = "a", o = l;
    let c;
    e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ["text-breadcrumb-text-inactive", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "no-underline", "block", "min-w-0", "max-w-full", "truncate", "whitespace-nowrap", "cursor-pointer", "transition-[color,text-decoration-color]", "hover:underline", "hover:[text-decoration-skip-ink:none]", "active:text-breadcrumb-text-inactive-pressed", "active:underline", "active:[text-decoration-skip-ink:none]", "active:[text-decoration-style:solid]", "outline-none", "focus-visible:[outline:var(--spacing-2)_solid_var(--color-breadcrumb-focus-ring)]", "focus-visible:outline-offset-[3px]", "rounded-(--radius-sm)"], e[5] = c) : c = e[5], r = en(a, {
      className: c.join(" ")
    }), e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i;
  } else
    n = e[1], o = e[2], r = e[3], i = e[4];
  let s;
  return e[6] !== n || e[7] !== o || e[8] !== r ? (s = {
    defaultTagName: n,
    render: o,
    props: r
  }, e[6] = n, e[7] = o, e[8] = r, e[9] = s) : s = e[9], i(s);
}
function lD(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m("span", { "data-slot": "breadcrumb-page", "aria-current": "page", className: "block min-w-0 max-w-full truncate text-breadcrumb-text-active font-family-body font-semibold", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function B0(t) {
  return Zl(t) && t.type === lR;
}
function cR(t) {
  return Zl(t) && t.type === U0;
}
function W0(t) {
  return Zl(t) && t.type === aR;
}
function mg(t, e) {
  return t ? zc(t, {
    key: e
  }) : /* @__PURE__ */ m(U0, {}, e);
}
function uR(t) {
  return ql.map(t, (e) => !B0(e) || !W0(e.props.children) ? e : zc(e, {
    children: zc(e.props.children, {
      tabIndex: -1
    })
  }));
}
function dR(t) {
  const e = z.c(10), {
    items: n
  } = t, [o, r] = ot(!1), i = n.length, s = `Show ${i} hidden breadcrumb ${i === 1 ? "level" : "levels"}`;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(mt, { "aria-label": s, icon: "ellipsis-dots-horiz", size: "sm", variant: "ghost" }) }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  e[2] !== n ? (a = n.map(fR), e[2] = n, e[3] = a) : a = e[3];
  let c;
  e[4] !== a ? (c = /* @__PURE__ */ m(kr, { align: "start", size: "sm", children: a }), e[4] = a, e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== c ? (u = /* @__PURE__ */ m("li", { "data-slot": "breadcrumb-overflow", className: "inline-flex shrink-0", children: /* @__PURE__ */ F(Id, { modal: !1, open: o, onOpenChange: r, children: [
    l,
    c
  ] }) }), e[6] = o, e[7] = l, e[8] = c, e[9] = u) : u = e[9], u;
}
function fR(t, e) {
  return /* @__PURE__ */ m(pR, { item: t }, t.key ?? e);
}
function pR(t) {
  const e = z.c(4), {
    item: n
  } = t, o = n.props.children;
  if (W0(o)) {
    let i;
    return e[0] !== o ? (i = /* @__PURE__ */ m(fr, { render: o, children: o.props.children }), e[0] = o, e[1] = i) : i = e[1], i;
  }
  let r;
  return e[2] !== o ? (r = /* @__PURE__ */ m(fr, { disabled: !0, children: o }), e[2] = o, e[3] = r) : r = e[3], r;
}
function U0(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m("li", { "data-slot": "breadcrumb-separator", "aria-hidden": "true", className: "text-breadcrumb-separator font-family-label font-medium shrink-0 select-none", ...t, children: "/" }), e[0] = t, e[1] = n) : n = e[1], n;
}
function aD(t) {
  const e = z.c(16), {
    title: n,
    leadingAccessory: o,
    titleAccessory: r,
    actions: i,
    summary: s,
    children: l,
    footer: a
  } = t;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ m("h3", { className: "flex min-w-0 m-0", children: /* @__PURE__ */ m(z0, { children: n }) }), e[0] = n, e[1] = c) : c = e[1];
  let u;
  e[2] !== i || e[3] !== o || e[4] !== s || e[5] !== c || e[6] !== r ? (u = /* @__PURE__ */ m(XS, { main: c, start: o, titleAccessory: r, actions: i, summary: s }), e[2] = i, e[3] = o, e[4] = s, e[5] = c, e[6] = r, e[7] = u) : u = e[7];
  let d;
  e[8] !== l ? (d = /* @__PURE__ */ m($0, { padding: "none", className: "min-h-(--spacing-80)", children: l }), e[8] = l, e[9] = d) : d = e[9];
  let f;
  e[10] !== a ? (f = a && /* @__PURE__ */ m(H0, { "data-card-container-slot": "footer", children: a }), e[10] = a, e[11] = f) : f = e[11];
  let p;
  return e[12] !== u || e[13] !== d || e[14] !== f ? (p = /* @__PURE__ */ m(F0, { elevated: !0, padding: "standard", children: /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-12) w-full", children: [
    u,
    d,
    f
  ] }) }), e[12] = u, e[13] = d, e[14] = f, e[15] = p) : p = e[15], p;
}
const gR = 2, mR = 32, hR = 3;
function bR(t) {
  return !x.isValidElement(t) || t.type !== v2 ? t : x.cloneElement(t, {
    selected: t.props.selected ?? !1
  });
}
function G0(t) {
  return t.clientWidth || t.getBoundingClientRect().width;
}
function vR(t) {
  return Math.max(t.scrollWidth, t.getBoundingClientRect().width);
}
function yR(t) {
  const e = mR * gR;
  return Math.max(0, t - e);
}
function xR(t, e) {
  const n = G0(t), o = Array.from(e.children).filter((i) => i instanceof HTMLElement);
  if (n <= 0 || o.length === 0) return o.length;
  let r = 0;
  for (const i of o) {
    const s = i.offsetWidth || i.getBoundingClientRect().width;
    if (s <= 0) return o.length;
    if (i.offsetLeft + s > n) break;
    r += 1;
  }
  return Math.max(1, r);
}
function cD({
  children: t,
  ...e
}) {
  const n = x.useRef(null), o = x.useRef(null), r = x.useRef(null), i = x.useRef(() => {
  }), [s, l] = x.useState(!1), [a, c] = x.useState(0), [u, d] = x.useState(Number.POSITIVE_INFINITY), f = x.Children.toArray(t), p = f.length, g = p > 0 ? a % p : 0, h = f.map((y, w) => ({
    child: bR(y),
    key: w
  })), b = s ? [...h.slice(g), ...h.slice(0, g)] : h;
  i.current = () => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R) return;
    const S = G0(y), E = vR(R), N = yR(S), T = E > S, P = p >= hR && E > N, I = p > 1 && S > 0 && (T || P);
    l(I), d(I ? xR(w, R) : p), I || c(0);
  }, x.useLayoutEffect(() => {
    i.current();
  }), x.useLayoutEffect(() => {
    const y = n.current, w = o.current, R = r.current;
    if (!y || !w || !R || typeof ResizeObserver > "u")
      return;
    const S = new ResizeObserver(() => {
      i.current();
    });
    return S.observe(y), S.observe(w), S.observe(R), () => S.disconnect();
  }, []);
  const v = () => {
    p !== 0 && c((y) => (y + 1) % p);
  };
  return /* @__PURE__ */ F("div", { ...e, ref: n, "data-slot": "carousel", className: s ? "flex w-full items-center" : "flex w-full items-center gap-(--spacing-10)", children: [
    s && /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: "chevron-left", "aria-label": "Previous Images", onClick: () => {
      p !== 0 && c((y) => (y - 1 + p) % p);
    } }),
    /* @__PURE__ */ m("div", { ref: o, "data-slot": "carousel-viewport", className: s ? "min-w-0 flex-1 overflow-hidden" : "min-w-0 max-w-full overflow-hidden", children: /* @__PURE__ */ m("div", { ref: r, "data-slot": "carousel-track", className: "relative flex w-max items-center gap-(--spacing-10) p-(--spacing-4)", children: b.map(({
      child: y,
      key: w
    }, R) => {
      const S = s && R >= u;
      return /* @__PURE__ */ m("div", { "data-slot": "carousel-item", className: "shrink-0", inert: S ? !0 : void 0, "aria-hidden": S || void 0, children: y }, w);
    }) }) }),
    s && /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: "chevron-right", "aria-label": "Next Images", onClick: v })
  ] });
}
function uD(t) {
  const e = z.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ m(Tv, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
async function CR(t, e) {
  if (navigator.clipboard?.write && typeof ClipboardItem < "u")
    try {
      await navigator.clipboard.write([new ClipboardItem({
        "text/html": new Blob([e], {
          type: "text/html"
        }),
        "text/plain": new Blob([t], {
          type: "text/plain"
        })
      })]);
      return;
    } catch {
    }
  if (!navigator.clipboard?.writeText)
    throw new Error("Clipboard API is unavailable.");
  await navigator.clipboard.writeText(t);
}
function dD({
  content: t,
  onCopy: e,
  onCopyError: n,
  copyLabel: o = "Copy message",
  copiedLabel: r = "Copied message",
  ...i
}) {
  const [s, l] = ot("default"), a = ft(null);
  kt(() => () => {
    a.current !== null && clearTimeout(a.current);
  }, []);
  async function c() {
    try {
      if (t.html)
        await CR(t.text, t.html);
      else {
        if (!navigator.clipboard?.writeText)
          throw new Error("Clipboard API is unavailable.");
        await navigator.clipboard.writeText(t.text);
      }
    } catch (d) {
      l("error"), n?.(d);
      return;
    }
    l("copied"), a.current !== null && clearTimeout(a.current), a.current = setTimeout(() => l("default"), 3e3), e?.();
  }
  const u = s === "copied";
  return /* @__PURE__ */ m(mt, { "data-slot": "chat-copy-button", "data-copy-state": s, icon: u ? "check-mark" : "copy-regular", "aria-label": u ? r : o, variant: "ghost", size: "sm", onClick: c, ...i });
}
let hg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.indeterminate = "data-indeterminate", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
function wR(t) {
  return x.useMemo(() => ({
    checked(e) {
      return t.indeterminate ? {} : e ? {
        [hg.checked]: ""
      } : {
        [hg.unchecked]: ""
      };
    },
    ...to
  }), [t.indeterminate]);
}
const Y0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Y0.displayName = "CheckboxRootContext");
const SR = "data-parent", j0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i = !1,
    "aria-labelledby": s,
    disabled: l = !1,
    form: a,
    id: c,
    indeterminate: u = !1,
    inputRef: d,
    name: f,
    onCheckedChange: p,
    parent: g = !1,
    readOnly: h = !1,
    render: b,
    required: v = !1,
    uncheckedValue: C,
    value: y,
    nativeButton: w = !1,
    style: R,
    ...S
  } = e, {
    clearErrors: E
  } = Vo(), {
    disabled: N,
    name: T,
    setDirty: P,
    setFilled: I,
    setFocused: k,
    setTouched: M,
    state: D,
    validationMode: O,
    validityData: V,
    shouldValidateOnChange: _,
    validation: A
  } = tn(), L = M2(), {
    labelId: B,
    controlId: G,
    registerControlId: U,
    getDescriptionProps: Y
  } = mn(), K = Qy(), j = K?.parent, Z = j && K.allValues, te = N || L.disabled || K?.disabled || l, W = T ?? f, X = y ?? W, ee = Mt(), le = Mt();
  let J = G;
  Z ? J = g ? le : `${j.id}-${X}` : c && (J = c);
  let ie = {};
  Z && (g ? ie = K.parent.getParentProps() : X && (ie = K.parent.getChildProps(X)));
  const pe = Se(p), {
    checked: oe = o,
    indeterminate: re = u,
    onCheckedChange: de,
    ...xe
  } = ie, se = K?.value, fe = K?.setValue, $ = K?.defaultValue, Q = x.useRef(null), H = Tt(() => /* @__PURE__ */ Symbol("checkbox-control")), q = x.useRef(!1), {
    getButtonProps: ae,
    buttonRef: ge
  } = Wt({
    disabled: te,
    native: w
  }), ue = K?.validation ?? A, [Re, be] = dn({
    controlled: X && se && !g ? se.includes(X) : oe,
    default: X && $ && !g ? $.includes(X) : i,
    name: "Checkbox",
    state: "checked"
  });
  ke(() => {
    U !== xt && (q.current = !0, U(H.current, J));
  }, [J, K, U, g, H]), x.useEffect(() => {
    const ye = H.current;
    return () => {
      !q.current || U === xt || (q.current = !1, U(ye, void 0));
    };
  }, [U, H]), pi(Q, {
    enabled: !K,
    id: ee,
    value: Re
  });
  const ve = x.useRef(null), me = fn(d, ve, ue.inputRef), Ee = Yd(s, B, ve, !w, J ?? void 0);
  ke(() => {
    ve.current && (ve.current.indeterminate = re, Re && I(!0));
  }, [Re, re, I]), wo(Re, () => {
    K && !g || (E(W), I(Re), P(Re !== V.initialValue), _() ? ue.commit(Re) : ue.commit(Re, !0));
  });
  const Pe = en(
    {
      checked: Re,
      disabled: te,
      form: a,
      // parent checkboxes unset `name` to be excluded from form submission
      name: g ? void 0 : W,
      // Set `id` to stop Chrome warning about an unassociated input.
      // When using a native button, the `id` is applied to the button instead.
      id: w ? void 0 : J ?? void 0,
      required: v,
      ref: me,
      style: W ? ti : Jo,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      onChange(ye) {
        if (ye.nativeEvent.defaultPrevented)
          return;
        if (h) {
          ye.preventDefault();
          return;
        }
        const Oe = ye.currentTarget.checked, Ie = Ve(Pt, ye.nativeEvent);
        if (de?.(Oe, Ie), pe(Oe, Ie), !Ie.isCanceled && (be(Oe), X && se && fe && !g && !Z)) {
          const Le = Oe ? [...se, X] : se.filter((Be) => Be !== X);
          fe(Le, Ie);
        }
      },
      onFocus() {
        Q.current?.focus();
      }
    },
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    y !== void 0 ? {
      value: (K ? Re && y : y) || ""
    } : St,
    Y,
    K ? ue.getValidationProps : ue.getInputValidationProps
  ), Me = Z ? !!oe : Re, _e = Z && re || u;
  x.useEffect(() => {
    if (!j || !X)
      return;
    const ye = j.disabledStatesRef.current;
    return ye.set(X, te), () => {
      ye.delete(X);
    };
  }, [j, te, X]);
  const Ue = x.useMemo(() => ({
    ...D,
    checked: Me,
    disabled: te,
    readOnly: h,
    required: v,
    indeterminate: _e
  }), [D, Me, te, h, v, _e]), Ye = wR(Ue), He = $e("span", e, {
    state: Ue,
    ref: [ge, Q, n, K?.registerControlRef],
    props: [{
      id: w ? J ?? void 0 : ee,
      role: "checkbox",
      "aria-checked": re ? "mixed" : Re,
      "aria-readonly": h || void 0,
      "aria-required": v || void 0,
      "aria-labelledby": Ee,
      [SR]: g ? "" : void 0,
      onFocus() {
        k(!0);
      },
      onBlur() {
        const ye = ve.current;
        ye && (M(!0), k(!1), O === "onBlur" && ue.commit(K ? se : ye.checked));
      },
      onClick(ye) {
        h || te || (ye.preventDefault(), ve.current?.dispatchEvent(new PointerEvent("click", {
          bubbles: !0,
          shiftKey: ye.shiftKey,
          ctrlKey: ye.ctrlKey,
          altKey: ye.altKey,
          metaKey: ye.metaKey
        })));
      }
    }, Y, ue.getValidationProps, S, xe, ae],
    stateAttributesMapping: Ye
  });
  return /* @__PURE__ */ F(Y0.Provider, {
    value: Ue,
    children: [He, !Re && !K && W && !g && C !== void 0 && /* @__PURE__ */ m("input", {
      type: "hidden",
      form: a,
      name: W,
      value: C
    }), /* @__PURE__ */ m("input", {
      ...Pe,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (j0.displayName = "CheckboxRoot");
const Gl = {
  sm: "rounded-[2px]",
  md: "rounded-(--radius-sm)"
}, bg = {
  sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
  // Snap md to whole pixels to avoid SVG crossfade shimmer from 19.2px subpixel rasterization.
  md: ["w-[20px]", "h-[20px]"]
}, RR = ce([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "group/checkbox",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1px]",
  "focus-visible:ring-checkbox-focus-ring",
  "cursor-[inherit]",
  // touch target — before:inset per size to maintain WCAG 44×44px minimum
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", Gl.sm, "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", Gl.md, "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), ER = ce(["absolute", "left-1/2", "top-1/2", "z-10", "inline-flex", "-translate-x-1/2", "-translate-y-1/2", "items-center", "justify-center", "overflow-hidden", "transition-[background-color]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "group-data-[checked]/checkbox:bg-checkbox-filled-default-background", "group-data-[indeterminate]/checkbox:bg-checkbox-filled-default-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-filled-hover-background", "group-[[data-checked]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-[[data-indeterminate]:not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-filled-pressed-background", "group-data-[error]/checkbox:bg-error", "group-data-[disabled]/checkbox:bg-checkbox-filled-disabled-background"], {
  variants: {
    size: {
      sm: [Gl.sm, ...bg.sm],
      md: [Gl.md, ...bg.md]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), NR = ce(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):hover]/checkbox:bg-checkbox-outline-hover-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), kR = ce(["absolute", "inset-0", "rounded-(--radius-sm)", "opacity-0", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:opacity-100", "group-[:not([data-checked]):not([data-indeterminate]):not([data-error]):not([data-disabled]):active]/checkbox:bg-checkbox-outline-pressed-background", "transition-[background-color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)"],
      md: ["w-(--icon-md)", "h-(--icon-md)"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), MR = ce(["absolute", "inset-0", "h-full", "w-full", "text-checkbox-outline-default-border", "group-[:not([data-error]):not([data-disabled]):hover]/checkbox:text-checkbox-outline-hover-border", "group-[:not([data-error]):not([data-disabled]):active]/checkbox:text-checkbox-outline-pressed-border", "group-data-[error]/checkbox:text-error", "group-data-[disabled]/checkbox:text-checkbox-filled-disabled-background", "group-data-[checked]/checkbox:opacity-0", "group-data-[indeterminate]/checkbox:opacity-0", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), IR = ce(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[checked]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), PR = ce(["absolute", "inset-0", "h-full", "w-full", "opacity-0", "text-primary-on-primary", "group-data-[indeterminate]/checkbox:opacity-100", "group-data-[error]/checkbox:text-surface-container-lowest", "group-data-[disabled]/checkbox:text-surface-container-lowest", "transition-[color,opacity]", "duration-200", "ease-in-out", "motion-reduce:transition-none"]);
function TR(t) {
  const e = z.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m("path", { d: "M13.7143 1.14286C14.3464 1.14286 14.8571 1.65357 14.8571 2.28571V13.7143C14.8571 14.3464 14.3464 14.8571 13.7143 14.8571H2.28571C1.65357 14.8571 1.14286 14.3464 1.14286 13.7143V2.28571C1.14286 1.65357 1.65357 1.14286 2.28571 1.14286H13.7143ZM2.28571 0C1.025 0 0 1.025 0 2.28571V13.7143C0 14.975 1.025 16 2.28571 16H13.7143C14.975 16 16 14.975 16 13.7143V2.28571C16 1.025 14.975 0 13.7143 0H2.28571Z", fill: "currentColor", fillRule: "evenodd", clipRule: "evenodd" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ m("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function OR(t) {
  const e = z.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m("path", { d: "M12.2143 4.06071C11.8321 3.78214 11.2964 3.86786 11.0179 4.25L6.75357 10.1143L4.89286 8.25357C4.55714 7.91786 4.01429 7.91786 3.68214 8.25357C3.35 8.58929 3.34643 9.13214 3.68214 9.46429L6.25357 12.0357C6.43214 12.2143 6.67857 12.3036 6.925 12.2857C7.17143 12.2679 7.40357 12.1393 7.55 11.9357L12.4036 5.25714C12.6821 4.875 12.5964 4.33929 12.2143 4.06071Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ m("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
function DR(t) {
  const e = z.c(3), {
    className: n
  } = t;
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = /* @__PURE__ */ m("path", { d: "M3 7V9H13V7H3Z", fill: "currentColor" }), e[0] = o) : o = e[0];
  let r;
  return e[1] !== n ? (r = /* @__PURE__ */ m("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: n, children: o }), e[1] = n, e[2] = r) : r = e[2], r;
}
const vg = ce(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), VR = ce(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), _R = ce([], {
  variants: {
    size: {
      sm: [],
      md: []
    },
    labelLeft: {
      true: [],
      false: []
    }
  },
  compoundVariants: [{
    labelLeft: !1,
    size: "sm",
    className: "pl-[calc(var(--icon-sm)+var(--spacing-8))]"
  }, {
    labelLeft: !1,
    size: "md",
    className: "pl-[calc(var(--icon-md)+var(--spacing-8))]"
  }],
  defaultVariants: {
    size: "sm",
    labelLeft: !1
  }
});
function AR(t) {
  const e = z.c(69);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    error: r,
    label: s,
    description: n,
    labelLeft: l,
    size: c,
    indeterminate: i,
    disabled: o,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = _t();
  let d;
  e[9] !== n || e[10] !== u || e[11] !== a ? (d = [a["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[9] = n, e[10] = u, e[11] = a, e[12] = d) : d = e[12];
  const f = d, p = o ? "cursor-not-allowed" : "cursor-pointer";
  let g;
  e[13] !== p ? (g = ne("inline-flex flex-col gap-(--spacing-4)", p), e[13] = p, e[14] = g) : g = e[14];
  let h;
  e[15] !== o || e[16] !== u || e[17] !== s || e[18] !== l ? (h = l && s && /* @__PURE__ */ m("span", { id: `${u}-label`, className: ne(vg(), o && "opacity-50"), children: s }), e[15] = o, e[16] = u, e[17] = s, e[18] = l, e[19] = h) : h = e[19];
  const b = s ? void 0 : a["aria-label"], v = s ? `${u}-label` : void 0, C = r || void 0, y = r ? "" : void 0;
  let w;
  e[20] !== c ? (w = ne(RR({
    size: c
  })), e[20] = c, e[21] = w) : w = e[21];
  let R;
  e[22] !== c ? (R = ne(NR({
    size: c
  })), e[22] = c, e[23] = R) : R = e[23];
  let S;
  e[24] !== R ? (S = /* @__PURE__ */ m("span", { className: R }), e[24] = R, e[25] = S) : S = e[25];
  let E;
  e[26] !== c ? (E = ne(kR({
    size: c
  })), e[26] = c, e[27] = E) : E = e[27];
  let N;
  e[28] !== E ? (N = /* @__PURE__ */ m("span", { className: E }), e[28] = E, e[29] = N) : N = e[29];
  let T;
  e[30] !== c ? (T = ne(ER({
    size: c
  })), e[30] = c, e[31] = T) : T = e[31];
  let P;
  e[32] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (P = /* @__PURE__ */ m(TR, { className: ne(MR()) }), e[32] = P) : P = e[32];
  let I;
  e[33] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (I = /* @__PURE__ */ m(OR, { className: ne(IR()) }), e[33] = I) : I = e[33];
  let k;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = /* @__PURE__ */ m(DR, { className: ne(PR()) }), e[34] = k) : k = e[34];
  let M;
  e[35] !== T ? (M = /* @__PURE__ */ F("span", { className: T, children: [
    P,
    I,
    k
  ] }), e[35] = T, e[36] = M) : M = e[36];
  let D;
  e[37] !== f || e[38] !== o || e[39] !== i || e[40] !== a || e[41] !== S || e[42] !== N || e[43] !== M || e[44] !== b || e[45] !== v || e[46] !== C || e[47] !== y || e[48] !== w ? (D = /* @__PURE__ */ F(j0, { ...a, indeterminate: i, disabled: o, "aria-label": b, "aria-labelledby": v, "aria-describedby": f, "aria-invalid": C, "data-error": y, className: w, children: [
    S,
    N,
    M
  ] }), e[37] = f, e[38] = o, e[39] = i, e[40] = a, e[41] = S, e[42] = N, e[43] = M, e[44] = b, e[45] = v, e[46] = C, e[47] = y, e[48] = w, e[49] = D) : D = e[49];
  let O;
  e[50] !== o || e[51] !== u || e[52] !== s || e[53] !== l ? (O = !l && s && /* @__PURE__ */ m("span", { id: `${u}-label`, className: ne(vg(), o && "opacity-50"), children: s }), e[50] = o, e[51] = u, e[52] = s, e[53] = l, e[54] = O) : O = e[54];
  let V;
  e[55] !== D || e[56] !== O || e[57] !== h ? (V = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    h,
    D,
    O
  ] }), e[55] = D, e[56] = O, e[57] = h, e[58] = V) : V = e[58];
  let _;
  e[59] !== n || e[60] !== o || e[61] !== u || e[62] !== l || e[63] !== c ? (_ = n && /* @__PURE__ */ m("span", { id: `${u}-description`, className: ne(VR(), o && "opacity-50", _R({
    size: c,
    labelLeft: l
  })), children: n }), e[59] = n, e[60] = o, e[61] = u, e[62] = l, e[63] = c, e[64] = _) : _ = e[64];
  let A;
  return e[65] !== V || e[66] !== _ || e[67] !== g ? (A = /* @__PURE__ */ F("label", { className: g, children: [
    V,
    _
  ] }), e[65] = V, e[66] = _, e[67] = g, e[68] = A) : A = e[68], A;
}
const Df = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Df.displayName = "PopoverRootContext");
function Os(t) {
  const e = x.useContext(Df);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverRootContext is missing. Popover parts must be placed within <Popover.Root>." : rt(47));
  return e;
}
function LR() {
  return {
    ...fs(),
    disabled: !1,
    modal: !1,
    focusManagerModal: !1,
    instantType: void 0,
    openMethod: null,
    openChangeReason: null,
    titleElementId: void 0,
    descriptionElementId: void 0,
    stickIfOpen: !0,
    nested: !1,
    openOnHover: !1,
    closeDelay: 0,
    hasViewport: !1
  };
}
const FR = {
  ...ps,
  disabled: he((t) => t.disabled),
  instantType: he((t) => t.instantType),
  openMethod: he((t) => t.openMethod),
  openChangeReason: he((t) => t.openChangeReason),
  modal: he((t) => t.modal),
  focusManagerModal: he((t) => t.focusManagerModal),
  stickIfOpen: he((t) => t.stickIfOpen),
  titleElementId: he((t) => t.titleElementId),
  descriptionElementId: he((t) => t.descriptionElementId),
  openOnHover: he((t) => t.openOnHover),
  closeDelay: he((t) => t.closeDelay),
  hasViewport: he((t) => t.hasViewport)
};
class Vf extends wr {
  constructor(e) {
    const n = {
      ...LR(),
      ...e
    };
    n.open && e?.mounted === void 0 && (n.mounted = !0), super(n, {
      popupRef: /* @__PURE__ */ x.createRef(),
      backdropRef: /* @__PURE__ */ x.createRef(),
      internalBackdropRef: /* @__PURE__ */ x.createRef(),
      onOpenChange: void 0,
      onOpenChangeComplete: void 0,
      triggerFocusTargetRef: /* @__PURE__ */ x.createRef(),
      beforeContentFocusGuardRef: /* @__PURE__ */ x.createRef(),
      stickIfOpenTimeout: new xn(),
      triggerElements: new Sr()
    }, FR);
  }
  setOpen = (e, n) => {
    const o = n.reason === Lt, r = n.reason === Zn && n.event.detail === 0, i = !e && (n.reason === vr || n.reason == null);
    if (n.preventUnmountOnClose = () => {
      this.set("preventUnmountingOnClose", !0);
    }, this.context.onOpenChange?.(e, n), n.isCanceled)
      return;
    this.state.floatingRootContext.dispatchOpenChange(e, n);
    const s = () => {
      const l = {
        open: e,
        openChangeReason: n.reason
      }, a = n.trigger?.id ?? null;
      (a || e) && (l.activeTriggerId = a, l.activeTriggerElement = n.trigger ?? null), this.update(l);
    };
    o ? (this.set("stickIfOpen", !0), this.context.stickIfOpenTimeout.start(xh, () => {
      this.set("stickIfOpen", !1);
    }), an.flushSync(s)) : s(), r || i ? this.set("instantType", r ? "click" : "dismiss") : n.reason === Po ? this.set("instantType", "focus") : this.set("instantType", void 0);
  };
  static useStore(e, n) {
    const o = Tt(() => new Vf(n)).current, r = e ?? o;
    return Jr(o.disposeEffect), r;
  }
  disposeEffect = () => this.context.stickIfOpenTimeout.disposeEffect();
}
function yg({
  props: t
}) {
  const {
    children: e,
    open: n,
    defaultOpen: o = !1,
    onOpenChange: r,
    onOpenChangeComplete: i,
    modal: s = !1,
    handle: l,
    triggerId: a,
    defaultTriggerId: c = null
  } = t, u = Vf.useStore(l?.store, {
    modal: s,
    open: o,
    openProp: n,
    activeTriggerId: c,
    triggerIdProp: a
  });
  Nr(() => {
    n === void 0 && u.state.open === !1 && o === !0 && u.update({
      open: !0,
      activeTriggerId: c
    });
  }), u.useControlledProp("openProp", n), u.useControlledProp("triggerIdProp", a);
  const d = u.useState("open"), f = u.useState("payload");
  u.useContextCallback("onOpenChange", r), u.useContextCallback("onOpenChangeComplete", i);
  const {
    openMethod: p,
    triggerProps: g
  } = Cs(d);
  us(u);
  const {
    forceUnmount: h
  } = ds(d, u, () => {
    u.update({
      stickIfOpen: !0,
      openChangeReason: null
    });
  });
  x.useEffect(() => {
    d || u.context.stickIfOpenTimeout.clear();
  }, [u, d]);
  const b = x.useCallback(() => {
    u.setOpen(!1, Ve(ss));
  }, [u]);
  x.useImperativeHandle(t.actionsRef, () => ({
    unmount: h,
    close: b
  }), [h, b]);
  const v = gs({
    popupStore: u,
    onOpenChange: u.setOpen
  }), C = Cr(v, {
    outsidePressEvent: {
      // Ensure `aria-hidden` on outside elements is removed immediately
      // on outside press when trapping focus.
      mouse: s === "trap-focus" ? "sloppy" : "intentional",
      touch: "sloppy"
    }
  }), y = vd(v), {
    getReferenceProps: w,
    getFloatingProps: R,
    getTriggerProps: S
  } = eo([C, y]), E = x.useMemo(() => w(g), [w, g]), N = x.useMemo(() => S(g), [S, g]), T = x.useMemo(() => R(), [R]);
  u.useSyncedValues({
    modal: s,
    openMethod: p,
    activeTriggerProps: E,
    inactiveTriggerProps: N,
    popupProps: T,
    floatingRootContext: v,
    nested: bo() != null
  });
  const P = x.useMemo(() => ({
    store: u
  }), [u]);
  return /* @__PURE__ */ m(Df.Provider, {
    value: P,
    children: typeof e == "function" ? e({
      payload: f
    }) : e
  });
}
function _f(t) {
  return Os(!0) ? /* @__PURE__ */ m(yg, {
    props: t
  }) : /* @__PURE__ */ m(sd, {
    children: /* @__PURE__ */ m(yg, {
      props: t
    })
  });
}
const $R = 300, Sa = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    nativeButton: s = !0,
    handle: l,
    payload: a,
    openOnHover: c = !1,
    delay: u = $R,
    closeDelay: d = 0,
    id: f,
    style: p,
    ...g
  } = e, h = Os(!0), b = l?.store ?? h?.store;
  if (!b)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Trigger> must be either used within a <Popover.Root> component or provided with a handle." : rt(74));
  const v = Mt(f), C = b.useState("isTriggerActive", v), y = b.useState("floatingRootContext"), w = b.useState("isOpenedByTrigger", v), R = x.useRef(null), {
    registerTrigger: S,
    isMountedByThisTrigger: E
  } = cs(v, R, b, {
    payload: a,
    disabled: i,
    openOnHover: c,
    closeDelay: d
  }), N = b.useState("openChangeReason"), T = b.useState("stickIfOpen"), P = b.useState("openMethod"), I = b.useState("focusManagerModal"), k = ms(y, {
    enabled: y != null && c && (P !== "touch" || N !== Zn),
    mouseOnly: !0,
    move: !1,
    handleClose: hs(),
    restMs: u,
    delay: {
      close: d
    },
    triggerElementRef: R,
    isActiveTrigger: C,
    isClosing: () => b.select("transitionStatus") === "ending"
  }), M = xr(y, {
    enabled: y != null,
    stickIfOpen: T
  }), D = eo([M]), O = b.useState("triggerProps", E), V = {
    disabled: i,
    open: w
  }, {
    getButtonProps: _,
    buttonRef: A
  } = Wt({
    disabled: i,
    native: s
  }), L = x.useMemo(() => ({
    open(K) {
      return K && N === Zn ? Ui.open(K) : br.open(K);
    }
  }), [N]), B = $e("button", e, {
    state: V,
    ref: [A, n, S, R],
    props: [D.getReferenceProps(), k, O, {
      [Ju]: "",
      id: v
    }, g, _],
    stateAttributesMapping: L
  }), {
    preFocusGuardRef: G,
    handlePreFocusGuardFocus: U,
    handleFocusTargetFocus: Y
  } = i2(b, R);
  return C && !I ? /* @__PURE__ */ F(x.Fragment, {
    children: [/* @__PURE__ */ m(Vn, {
      ref: G,
      onFocus: U
    }), /* @__PURE__ */ m(x.Fragment, {
      children: B
    }, v), /* @__PURE__ */ m(Vn, {
      ref: b.context.triggerFocusTargetRef,
      onFocus: Y
    })]
  }) : /* @__PURE__ */ m(x.Fragment, {
    children: B
  }, v);
});
process.env.NODE_ENV !== "production" && (Sa.displayName = "PopoverTrigger");
const Af = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Af.displayName = "PopoverPortalContext");
function HR() {
  const t = x.useContext(Af);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: <Popover.Portal> is missing." : rt(45));
  return t;
}
const Ra = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    keepMounted: o = !1,
    ...r
  } = e, {
    store: i
  } = Os();
  return i.useState("mounted") || o ? /* @__PURE__ */ m(Af.Provider, {
    value: o,
    children: /* @__PURE__ */ m(ni, {
      ref: n,
      ...r
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (Ra.displayName = "PopoverPortal");
const Lf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Lf.displayName = "PopoverPositionerContext");
function zR() {
  const t = x.useContext(Lf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: PopoverPositionerContext is missing. PopoverPositioner parts must be placed within <Popover.Positioner>." : rt(46));
  return t;
}
const Ea = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    anchor: i,
    positionMethod: s = "absolute",
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f = 5,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: h = !1,
    collisionAvoidance: b = la,
    style: v,
    ...C
  } = e, {
    store: y
  } = Os(), w = HR(), R = aa(), S = y.useState("floatingRootContext"), E = y.useState("mounted"), N = y.useState("open"), T = y.useState("openChangeReason"), P = y.useState("activeTriggerElement"), I = y.useState("modal"), k = y.useState("openMethod"), M = y.useState("positionerElement"), D = y.useState("instantType"), O = y.useState("transitionStatus"), V = y.useState("hasViewport"), _ = x.useRef(null), A = Ql(M, !1, !1), L = ri({
    anchor: i,
    floatingRootContext: S,
    positionMethod: s,
    mounted: E,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: h,
    keepMounted: w,
    nodeId: R,
    collisionAvoidance: b,
    adaptiveOrigin: V ? fa : void 0
  }), B = S.useState("domReferenceElement");
  ke(() => {
    const K = B, j = _.current;
    if (K && (_.current = K), j && K && K !== j) {
      y.set("instantType", void 0);
      const Z = new AbortController();
      return A(() => {
        y.set("instantType", "trigger-change");
      }, Z.signal), () => {
        Z.abort();
      };
    }
  }, [B, A, y]);
  const G = {
    open: N,
    side: L.side,
    align: L.align,
    anchorHidden: L.anchorHidden,
    instant: D
  };
  pa(N && I === !0 && T !== Lt, k === "touch", M, P);
  const U = x.useCallback((K) => {
    y.set("positionerElement", K);
  }, [y]), Y = li(e, G, {
    styles: L.positionerStyles,
    transitionStatus: O,
    props: C,
    refs: [n, U],
    hidden: !E,
    inert: !N
  });
  return /* @__PURE__ */ F(Lf.Provider, {
    value: L,
    children: [E && I === !0 && T !== Lt && /* @__PURE__ */ m(si, {
      ref: y.context.internalBackdropRef,
      inert: Er(!N),
      cutout: P
    }), /* @__PURE__ */ m(id, {
      id: R,
      children: Y
    })]
  });
});
process.env.NODE_ENV !== "production" && (Ea.displayName = "PopoverPositioner");
const K0 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (K0.displayName = "ClosePartContext");
function BR() {
  const [t, e] = x.useState(0), n = Se(() => (e((r) => r + 1), () => {
    e((r) => Math.max(0, r - 1));
  }));
  return {
    context: x.useMemo(() => ({
      register: n
    }), [n]),
    hasClosePart: t > 0
  };
}
function WR(t) {
  const {
    value: e,
    children: n
  } = t;
  return /* @__PURE__ */ m(K0.Provider, {
    value: e,
    children: n
  });
}
const UR = {
  ...Nn,
  ...Bt
}, Na = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    initialFocus: i,
    finalFocus: s,
    style: l,
    ...a
  } = e, {
    store: c
  } = Os(), u = zR(), d = xd() != null, {
    context: f,
    hasClosePart: p
  } = BR(), g = c.useState("open"), h = c.useState("openMethod"), b = c.useState("instantType"), v = c.useState("transitionStatus"), C = c.useState("popupProps"), y = c.useState("titleElementId"), w = c.useState("descriptionElementId"), R = c.useState("modal"), S = c.useState("mounted"), E = c.useState("openChangeReason"), N = c.useState("activeTriggerElement"), T = c.useState("floatingRootContext");
  jt({
    open: g,
    ref: c.context.popupRef,
    onComplete() {
      g && c.context.onOpenChangeComplete?.(!0);
    }
  });
  const P = c.useState("disabled"), I = c.useState("openOnHover"), k = c.useState("closeDelay");
  ua(T, {
    enabled: I && !P,
    closeDelay: k
  });
  function M(L) {
    return L === "touch" ? c.context.popupRef.current : !0;
  }
  const D = i === void 0 ? M : i, O = {
    open: g,
    side: u.side,
    align: u.align,
    instant: b,
    transitionStatus: v
  }, V = R !== !1 && p;
  c.useSyncedValue("focusManagerModal", V);
  const _ = x.useCallback((L) => {
    c.set("popupElement", L);
  }, [c]), A = $e("div", e, {
    state: O,
    ref: [n, c.context.popupRef, _],
    props: [C, {
      "aria-labelledby": y,
      "aria-describedby": w,
      onKeyDown(L) {
        d && ys.has(L.key) && L.stopPropagation();
      }
    }, Rr(v), a],
    stateAttributesMapping: UR
  });
  return /* @__PURE__ */ m(oi, {
    context: T,
    openInteractionType: h,
    modal: V,
    disabled: !S || E === Lt,
    initialFocus: D,
    returnFocus: s,
    restoreFocus: "popup",
    previousFocusableElement: Ct(N) ? N : void 0,
    nextFocusableElement: c.context.triggerFocusTargetRef,
    beforeContentFocusGuardRef: c.context.beforeContentFocusGuardRef,
    children: /* @__PURE__ */ m(WR, {
      value: f,
      children: A
    })
  });
});
process.env.NODE_ENV !== "production" && (Na.displayName = "PopoverPopup");
const Ff = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && (Ff.displayName = "SelectRootContext");
const $f = /* @__PURE__ */ x.createContext(null);
process.env.NODE_ENV !== "production" && ($f.displayName = "SelectFloatingContext");
function Ao() {
  const t = x.useContext(Ff);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectRootContext is missing. Select parts must be placed within <Select.Root>." : rt(60));
  return t;
}
function q0() {
  const t = x.useContext($f);
  if (t === null)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectFloatingContext is missing. Select parts must be placed within <Select.Root>." : rt(61));
  return t;
}
const dt = {
  id: he((t) => t.id),
  labelId: he((t) => t.labelId),
  modal: he((t) => t.modal),
  multiple: he((t) => t.multiple),
  items: he((t) => t.items),
  itemToStringLabel: he((t) => t.itemToStringLabel),
  itemToStringValue: he((t) => t.itemToStringValue),
  isItemEqualToValue: he((t) => t.isItemEqualToValue),
  value: he((t) => t.value),
  hasSelectedValue: he((t) => {
    const {
      value: e,
      multiple: n,
      itemToStringValue: o
    } = t;
    return e == null ? !1 : n && Array.isArray(e) ? e.length > 0 : Un(e, o) !== "";
  }),
  hasNullItemLabel: he((t, e) => e ? x0(t.items) : !1),
  open: he((t) => t.open),
  mounted: he((t) => t.mounted),
  forceMount: he((t) => t.forceMount),
  transitionStatus: he((t) => t.transitionStatus),
  openMethod: he((t) => t.openMethod),
  activeIndex: he((t) => t.activeIndex),
  selectedIndex: he((t) => t.selectedIndex),
  isActive: he((t, e) => t.activeIndex === e),
  isSelected: he((t, e, n) => {
    const o = t.isItemEqualToValue, r = t.value;
    return t.multiple ? Array.isArray(r) && r.some((i) => go(n, i, o)) : t.selectedIndex === e && t.selectedIndex !== null ? !0 : go(n, r, o);
  }),
  isSelectedByFocus: he((t, e) => t.selectedIndex === e),
  popupProps: he((t) => t.popupProps),
  triggerProps: he((t) => t.triggerProps),
  triggerElement: he((t) => t.triggerElement),
  positionerElement: he((t) => t.positionerElement),
  listElement: he((t) => t.listElement),
  scrollUpArrowVisible: he((t) => t.scrollUpArrowVisible),
  scrollDownArrowVisible: he((t) => t.scrollDownArrowVisible),
  hasScrollArrows: he((t) => t.hasScrollArrows)
}, xo = 1;
function Z0(t, e) {
  return Math.max(0, t - e);
}
function GR(t, e) {
  if (e <= 0)
    return 0;
  const n = Ut(t, 0, e), o = n, r = e - n, i = o <= xo, s = r <= xo;
  return i && s ? o <= r ? 0 : e : i ? 0 : s ? e : n;
}
function YR(t) {
  const {
    id: e,
    value: n,
    defaultValue: o = null,
    onValueChange: r,
    open: i,
    defaultOpen: s = !1,
    onOpenChange: l,
    name: a,
    form: c,
    autoComplete: u,
    disabled: d = !1,
    readOnly: f = !1,
    required: p = !1,
    modal: g = !0,
    actionsRef: h,
    inputRef: b,
    onOpenChangeComplete: v,
    items: C,
    multiple: y = !1,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S = b0,
    highlightItemOnHover: E = !0,
    children: N
  } = t, {
    clearErrors: T
  } = Vo(), {
    setDirty: P,
    setTouched: I,
    setFocused: k,
    shouldValidateOnChange: M,
    validityData: D,
    setFilled: O,
    name: V,
    disabled: _,
    validation: A,
    validationMode: L
  } = tn(), B = Mr({
    id: e
  }), G = _ || d, U = V ?? a, [Y, K] = dn({
    controlled: n,
    default: y ? o ?? On : o,
    name: "Select",
    state: "value"
  }), [j, Z] = dn({
    controlled: i,
    default: s,
    name: "Select",
    state: "open"
  }), te = x.useRef([]), W = x.useRef([]), X = x.useRef(null), ee = x.useRef(null), le = x.useRef(0), J = x.useRef(null), ie = x.useRef([]), pe = x.useRef(!1), oe = x.useRef(!1), re = x.useRef(null), de = x.useRef({
    allowSelectedMouseUp: !1,
    allowUnselectedMouseUp: !1
  }), xe = x.useRef(!1), {
    mounted: se,
    setMounted: fe,
    transitionStatus: $
  } = Xn(j), {
    openMethod: Q,
    triggerProps: H
  } = Cs(j), q = Tt(() => new fd({
    id: B,
    labelId: void 0,
    modal: g,
    multiple: y,
    itemToStringLabel: w,
    itemToStringValue: R,
    isItemEqualToValue: S,
    value: Y,
    open: j,
    mounted: se,
    transitionStatus: $,
    items: C,
    forceMount: !1,
    openMethod: null,
    activeIndex: null,
    selectedIndex: null,
    popupProps: {},
    triggerProps: {},
    triggerElement: null,
    positionerElement: null,
    listElement: null,
    scrollUpArrowVisible: !1,
    scrollDownArrowVisible: !1,
    hasScrollArrows: !1
  })).current, ae = Ce(q, dt.activeIndex), ge = Ce(q, dt.selectedIndex), ue = Ce(q, dt.triggerElement), Re = Ce(q, dt.positionerElement), be = c7(Q), ve = Q ?? be, me = x.useMemo(() => y && Array.isArray(Y) && Y.length === 0 ? "" : Un(Y, R), [y, Y, R]), Ee = x.useMemo(() => y && Array.isArray(Y) ? Y.map((Ge) => Un(Ge, R)) : Un(Y, R), [y, Y, R]), Pe = $t(q.state.triggerElement), Me = Se(() => Ee);
  pi(Pe, {
    id: B,
    value: Y,
    getValue: Me
  });
  const _e = x.useRef(Y);
  ke(() => {
    Y !== _e.current && q.set("forceMount", !0);
  }, [q, Y]), ke(() => {
    O(y ? Array.isArray(Y) && Y.length > 0 : Y != null);
  }, [y, Y, O]), ke(function() {
    if (j)
      return;
    const Ze = ie.current;
    if (y) {
      const st = Array.isArray(Y) ? Y : [];
      if (st.length === 0) {
        q.set("selectedIndex", null);
        return;
      }
      const gt = st[st.length - 1], ht = Mo(Ze, gt, S);
      q.set("selectedIndex", ht === -1 ? null : ht);
      return;
    }
    const tt = Mo(Ze, Y, S);
    q.set("selectedIndex", tt === -1 ? null : tt);
  }, [y, j, Y, ie, S, q]), wo(Y, () => {
    T(U), P(Y !== D.initialValue), M() ? A.commit(Y) : A.commit(Y, !0);
  });
  const Ue = Se((Ge, Ze) => {
    if (l?.(Ge, Ze), !Ze.isCanceled && (Z(Ge), !Ge && (Ze.reason === Po || Ze.reason === is) && (I(!0), k(!1), L === "onBlur" && A.commit(Y)), !Ge && q.state.activeIndex !== null)) {
      const tt = te.current[q.state.activeIndex];
      queueMicrotask(() => {
        tt?.setAttribute("tabindex", "-1");
      });
    }
  }), Ye = Se(() => {
    fe(!1), q.update({
      activeIndex: null,
      openMethod: null
    }), v?.(!1);
  });
  jt({
    enabled: !h,
    open: j,
    ref: X,
    onComplete() {
      j || Ye();
    }
  }), x.useImperativeHandle(h, () => ({
    unmount: Ye
  }), [Ye]);
  const He = Se((Ge, Ze) => {
    r?.(Ge, Ze), !Ze.isCanceled && K(Ge);
  }), ye = Se(() => {
    const Ge = q.state.listElement || X.current;
    if (!Ge)
      return;
    const Ze = Z0(Ge.scrollHeight, Ge.clientHeight), tt = GR(Ge.scrollTop, Ze), st = tt > 0, gt = tt < Ze;
    q.state.scrollUpArrowVisible !== st && q.set("scrollUpArrowVisible", st), q.state.scrollDownArrowVisible !== gt && q.set("scrollDownArrowVisible", gt);
  }), Oe = gd({
    open: j,
    onOpenChange: Ue,
    elements: {
      reference: ue,
      floating: Re
    }
  }), Ie = xr(Oe, {
    enabled: !f && !G,
    event: "mousedown"
  }), Le = Cr(Oe, {
    bubbles: !1
  }), Be = bd(Oe, {
    enabled: !f && !G,
    listRef: te,
    activeIndex: ae,
    selectedIndex: ge,
    disabledIndices: On,
    onNavigate(Ge) {
      Ge === null && !j || q.set("activeIndex", Ge);
    },
    focusItemOnHover: E
  }), Te = yd(Oe, {
    enabled: !f && !G && (j || !y),
    listRef: W,
    activeIndex: ae,
    selectedIndex: ge,
    onMatch(Ge) {
      j ? q.set("activeIndex", Ge) : He(ie.current[Ge], Ve("none"));
    },
    onTypingChange(Ge) {
      pe.current = Ge;
    }
  }), {
    getReferenceProps: vt,
    getFloatingProps: nt,
    getItemProps: we
  } = eo([Ie, Le, Be, Te]), Ne = x.useMemo(() => en(vt(), H, B ? {
    id: B
  } : St), [vt, H, B]);
  Nr(() => {
    q.update({
      popupProps: nt(),
      triggerProps: Ne
    });
  }), ke(() => {
    q.update({
      id: B,
      modal: g,
      multiple: y,
      value: Y,
      open: j,
      mounted: se,
      transitionStatus: $,
      popupProps: nt(),
      triggerProps: Ne,
      items: C,
      itemToStringLabel: w,
      itemToStringValue: R,
      isItemEqualToValue: S,
      openMethod: ve
    });
  }, [q, B, g, y, Y, j, se, $, nt, Ne, C, w, R, S, ve]);
  const Ae = x.useMemo(() => ({
    store: q,
    name: U,
    required: p,
    disabled: G,
    readOnly: f,
    multiple: y,
    highlightItemOnHover: E,
    setValue: He,
    setOpen: Ue,
    listRef: te,
    popupRef: X,
    scrollHandlerRef: ee,
    handleScrollArrowVisibility: ye,
    scrollArrowsMountedCountRef: le,
    getItemProps: we,
    events: Oe.context.events,
    valueRef: J,
    valuesRef: ie,
    labelsRef: W,
    typingRef: pe,
    selectionRef: de,
    selectedItemTextRef: re,
    validation: A,
    onOpenChangeComplete: v,
    keyboardActiveRef: oe,
    alignItemWithTriggerActiveRef: xe,
    initialValueRef: _e
  }), [q, U, p, G, f, y, E, He, Ue, we, Oe.context.events, A, v, ye]), Fe = fn(b, A.inputRef), Xe = y && Array.isArray(Y) && Y.length > 0, qe = y ? void 0 : U, it = x.useMemo(() => !y || !Array.isArray(Y) || !U ? null : Y.map((Ge) => {
    const Ze = Un(Ge, R);
    return /* @__PURE__ */ m("input", {
      type: "hidden",
      form: c,
      name: U,
      value: Ze
    }, Ze);
  }), [y, Y, c, U, R]);
  return /* @__PURE__ */ m(Ff.Provider, {
    value: Ae,
    children: /* @__PURE__ */ F($f.Provider, {
      value: Oe,
      children: [N, /* @__PURE__ */ m("input", {
        ...A.getInputValidationProps({
          onFocus() {
            q.state.triggerElement?.focus({
              // Supported in Chrome from 144 (January 2026)
              focusVisible: !0
            });
          },
          // Handle browser autofill.
          onChange(Ge) {
            if (Ge.nativeEvent.defaultPrevented)
              return;
            const Ze = Ge.currentTarget.value, tt = Ve(Pt, Ge.nativeEvent);
            function st() {
              if (y)
                return;
              const gt = ie.current.find((ht) => Un(ht, R).toLowerCase() === Ze.toLowerCase() || Jt(ht, w).toLowerCase() === Ze.toLowerCase());
              gt != null && (P(gt !== D.initialValue), He(gt, tt), M() && A.commit(gt));
            }
            q.set("forceMount", !0), queueMicrotask(st);
          }
        }),
        id: B && qe == null ? `${B}-hidden-input` : void 0,
        form: c,
        name: qe,
        autoComplete: u,
        value: me,
        disabled: G,
        required: p && !Xe,
        readOnly: f,
        ref: Fe,
        style: U ? ti : Jo,
        tabIndex: -1,
        "aria-hidden": !0,
        suppressHydrationWarning: !0
      }), it]
    })
  });
}
const sl = 2, jR = 400, xg = 200, KR = {
  ...Ui,
  ...to,
  value: () => null
}, X0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    id: i,
    disabled: s = !1,
    nativeButton: l = !0,
    style: a,
    ...c
  } = e, {
    setTouched: u,
    setFocused: d,
    validationMode: f,
    state: p,
    disabled: g
  } = tn(), {
    labelId: h
  } = mn(), {
    store: b,
    setOpen: v,
    selectionRef: C,
    validation: y,
    readOnly: w,
    required: R,
    alignItemWithTriggerActiveRef: S,
    disabled: E,
    keyboardActiveRef: N
  } = Ao(), T = g || E || s, P = Ce(b, dt.open), I = Ce(b, dt.value), k = Ce(b, dt.triggerProps), M = Ce(b, dt.positionerElement), D = Ce(b, dt.listElement), O = Ce(b, dt.id), V = Ce(b, dt.labelId), _ = Ce(b, dt.hasSelectedValue), A = !_ && P, L = Ce(b, dt.hasNullItemLabel, A), B = i ?? O, G = xf(h, V);
  Mr({
    id: B
  });
  const U = $t(M), Y = x.useRef(null), {
    getButtonProps: K,
    buttonRef: j
  } = Wt({
    disabled: T,
    native: l
  }), Z = Se((oe) => {
    b.set("triggerElement", oe);
  }), te = fn(n, Y, j, Z), W = Vt(), X = Vt(), ee = Vt(), le = Vt();
  x.useEffect(() => {
    if (P)
      return !(_ || L) ? ee.start(jR, () => {
        C.current.allowUnselectedMouseUp = !0, C.current.allowSelectedMouseUp = !0;
      }) : le.start(xg, () => {
        C.current.allowUnselectedMouseUp = !0, ee.start(xg, () => {
          C.current.allowSelectedMouseUp = !0;
        });
      }), () => {
        ee.clear(), le.clear();
      };
    C.current = {
      allowSelectedMouseUp: !1,
      allowUnselectedMouseUp: !1
    }, X.clear();
  }, [P, _, L, C, X, ee, le]);
  const J = x.useMemo(() => D?.id ?? Yi(M)?.id, [D, M]), ie = en(k, {
    id: B,
    role: "combobox",
    "aria-expanded": P ? "true" : "false",
    "aria-haspopup": "listbox",
    "aria-controls": P ? J : void 0,
    "aria-labelledby": G,
    "aria-readonly": w || void 0,
    "aria-required": R || void 0,
    tabIndex: T ? -1 : 0,
    ref: te,
    onFocus(oe) {
      d(!0), P && S.current && v(!1, Ve(Pt, oe.nativeEvent)), W.start(0, () => {
        b.set("forceMount", !0);
      });
    },
    onBlur(oe) {
      ze(M, oe.relatedTarget) || (u(!0), d(!1), f === "onBlur" && y.commit(I));
    },
    onPointerMove() {
      N.current = !1;
    },
    onKeyDown() {
      N.current = !0;
    },
    onMouseDown(oe) {
      if (P)
        return;
      const re = et(oe.currentTarget);
      function de(xe) {
        if (!Y.current)
          return;
        const se = xe.target;
        if (ze(Y.current, se) || ze(U.current, se) || se === Y.current)
          return;
        const fe = Nd(Y.current);
        xe.clientX >= fe.left - sl && xe.clientX <= fe.right + sl && xe.clientY >= fe.top - sl && xe.clientY <= fe.bottom + sl || v(!1, Ve(zm, xe));
      }
      X.start(0, () => {
        re.addEventListener("mouseup", de, {
          once: !0
        });
      });
    }
  }, y.getValidationProps, c, K);
  ie.role = "combobox";
  const pe = {
    ...p,
    open: P,
    disabled: T,
    value: I,
    readOnly: w,
    placeholder: !_
  };
  return $e("button", e, {
    ref: [n, Y],
    state: pe,
    stateAttributesMapping: KR,
    props: ie
  });
});
process.env.NODE_ENV !== "production" && (X0.displayName = "SelectTrigger");
const qR = {
  value: () => null
}, Q0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    children: i,
    placeholder: s,
    style: l,
    ...a
  } = e, {
    store: c,
    valueRef: u
  } = Ao(), d = Ce(c, dt.value), f = Ce(c, dt.items), p = Ce(c, dt.itemToStringLabel), g = Ce(c, dt.hasSelectedValue), h = !g && s != null && i == null, b = Ce(c, dt.hasNullItemLabel, h), v = {
    value: d,
    placeholder: !g
  };
  let C = null;
  return typeof i == "function" ? C = i(d) : i != null ? C = i : !g && s != null && !b ? C = s : Array.isArray(d) ? C = yS(d, f, p) : C = C0(d, f, p), $e("span", e, {
    state: v,
    ref: [n, u],
    props: [{
      children: C
    }, a],
    stateAttributesMapping: qR
  });
});
process.env.NODE_ENV !== "production" && (Q0.displayName = "SelectValue");
const J0 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l
  } = Ao(), c = {
    open: Ce(l, dt.open)
  };
  return $e("span", e, {
    state: c,
    ref: n,
    props: [{
      "aria-hidden": !0,
      children: "▼"
    }, s],
    stateAttributesMapping: br
  });
});
process.env.NODE_ENV !== "production" && (J0.displayName = "SelectIcon");
const eb = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (eb.displayName = "SelectPortalContext");
const tb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    store: o
  } = Ao(), r = Ce(o, dt.mounted), i = Ce(o, dt.forceMount);
  return r || i ? /* @__PURE__ */ m(eb.Provider, {
    value: !0,
    children: /* @__PURE__ */ m(ni, {
      ref: n,
      ...e
    })
  }) : null;
});
process.env.NODE_ENV !== "production" && (tb.displayName = "SelectPortal");
const Hf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Hf.displayName = "SelectPositionerContext");
function nb() {
  const t = x.useContext(Hf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectPositionerContext is missing. SelectPositioner parts must be placed within <Select.Positioner>." : rt(59));
  return t;
}
function Yl(t, e) {
  t && Object.assign(t.style, e);
}
const ob = {
  position: "relative",
  maxHeight: "100%",
  overflowX: "hidden",
  overflowY: "auto"
}, ZR = {
  position: "fixed"
}, rb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    anchor: o,
    positionMethod: r = "absolute",
    className: i,
    render: s,
    side: l = "bottom",
    align: a = "center",
    sideOffset: c = 0,
    alignOffset: u = 0,
    collisionBoundary: d = "clipping-ancestors",
    collisionPadding: f,
    arrowPadding: p = 5,
    sticky: g = !1,
    disableAnchorTracking: h,
    alignItemWithTrigger: b = !0,
    collisionAvoidance: v = ed,
    style: C,
    ...y
  } = e, {
    store: w,
    listRef: R,
    labelsRef: S,
    alignItemWithTriggerActiveRef: E,
    selectedItemTextRef: N,
    valuesRef: T,
    initialValueRef: P,
    popupRef: I,
    setValue: k
  } = Ao(), M = q0(), D = Ce(w, dt.open), O = Ce(w, dt.mounted), V = Ce(w, dt.modal), _ = Ce(w, dt.value), A = Ce(w, dt.openMethod), L = Ce(w, dt.positionerElement), B = Ce(w, dt.triggerElement), G = Ce(w, dt.isItemEqualToValue), U = Ce(w, dt.transitionStatus), Y = x.useRef(null), K = x.useRef(null), [j, Z] = x.useState(b), te = O && j && A !== "touch";
  !O && j !== b && Z(b), ke(() => {
    O || (dt.scrollUpArrowVisible(w.state) && w.set("scrollUpArrowVisible", !1), dt.scrollDownArrowVisible(w.state) && w.set("scrollDownArrowVisible", !1));
  }, [w, O]), x.useImperativeHandle(E, () => te), pa((te || V) && D, A === "touch", L, B);
  const W = ri({
    anchor: o,
    floatingRootContext: M,
    positionMethod: r,
    mounted: O,
    side: l,
    sideOffset: c,
    align: a,
    alignOffset: u,
    arrowPadding: p,
    collisionBoundary: d,
    collisionPadding: f,
    sticky: g,
    disableAnchorTracking: h ?? te,
    collisionAvoidance: v,
    keepMounted: !0
  }), X = te ? "none" : W.side, ee = te ? ZR : W.positionerStyles, le = {
    open: D,
    side: X,
    align: W.align,
    anchorHidden: W.anchorHidden
  }, J = Se((de) => {
    w.set("positionerElement", de);
  }), ie = li(e, le, {
    styles: ee,
    transitionStatus: U,
    props: y,
    refs: [n, J],
    hidden: !O,
    inert: !D
  }), pe = x.useRef(0), oe = Se((de) => {
    if (de.size === 0 && pe.current === 0 || T.current.length === 0)
      return;
    const xe = pe.current;
    if (pe.current = de.size, de.size === xe)
      return;
    const se = Ve(Pt);
    if (xe !== 0 && !w.state.multiple && _ !== null && Mo(T.current, _, G) === -1) {
      const $ = P.current, H = $ != null && Mo(T.current, $, G) !== -1 ? $ : null;
      k(H, se), H === null && (w.set("selectedIndex", null), N.current = null);
    }
    if (xe !== 0 && w.state.multiple && Array.isArray(_)) {
      const fe = (Q) => Mo(T.current, Q, G) !== -1, $ = _.filter((Q) => fe(Q));
      ($.length !== _.length || $.some((Q) => !v0(_, Q, G))) && (k($, se), $.length === 0 && (w.set("selectedIndex", null), N.current = null));
    }
    if (D && te) {
      w.update({
        scrollUpArrowVisible: !1,
        scrollDownArrowVisible: !1
      });
      const fe = {
        height: ""
      };
      Yl(L, fe), Yl(I.current, fe);
    }
  }), re = x.useMemo(() => ({
    ...W,
    side: X,
    alignItemWithTriggerActive: te,
    setControlledAlignItemWithTrigger: Z,
    scrollUpArrowRef: Y,
    scrollDownArrowRef: K
  }), [W, X, te, Z]);
  return /* @__PURE__ */ m(ii, {
    elementsRef: R,
    labelsRef: S,
    onMapChange: oe,
    children: /* @__PURE__ */ F(Hf.Provider, {
      value: re,
      children: [O && V && /* @__PURE__ */ m(si, {
        inert: Er(!D),
        cutout: B
      }), ie]
    })
  });
});
process.env.NODE_ENV !== "production" && (rb.displayName = "SelectPositioner");
const ll = "base-ui-disable-scrollbar", jl = {
  className: ll,
  getElement(t) {
    return /* @__PURE__ */ m("style", {
      nonce: t,
      href: ll,
      precedence: "base-ui:low",
      children: `.${ll}{scrollbar-width:none}.${ll}::-webkit-scrollbar{display:none}`
    });
  }
};
process.env.NODE_ENV !== "production" && (jl.getElement.displayName = "styleDisableScrollbar.getElement");
const ib = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (ib.displayName = "CSPContext");
const XR = {
  disableStyleElements: !1
};
function QR() {
  return x.useContext(ib) ?? XR;
}
const JR = {
  ...Nn,
  ...Bt
}, sb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    finalFocus: s,
    ...l
  } = e, {
    store: a,
    popupRef: c,
    onOpenChangeComplete: u,
    setOpen: d,
    valueRef: f,
    selectedItemTextRef: p,
    keyboardActiveRef: g,
    multiple: h,
    handleScrollArrowVisibility: b,
    scrollHandlerRef: v,
    listRef: C,
    highlightItemOnHover: y
  } = Ao(), {
    side: w,
    align: R,
    alignItemWithTriggerActive: S,
    isPositioned: E,
    setControlledAlignItemWithTrigger: N,
    scrollDownArrowRef: T,
    scrollUpArrowRef: P
  } = nb(), I = xd() != null, k = q0(), M = xs(), {
    nonce: D,
    disableStyleElements: O
  } = QR(), V = Ce(a, dt.id), _ = Ce(a, dt.open), A = Ce(a, dt.mounted), L = Ce(a, dt.popupProps), B = Ce(a, dt.transitionStatus), G = Ce(a, dt.triggerElement), U = Ce(a, dt.positionerElement), Y = Ce(a, dt.listElement), K = x.useRef(!1), j = x.useRef(!1), Z = x.useRef({}), te = ei(), W = Se((J) => {
    if (!U || !c.current || !j.current)
      return;
    if (K.current || !S) {
      b();
      return;
    }
    const ie = U.style.top === "0px", pe = U.style.bottom === "0px";
    if (!ie && !pe) {
      b();
      return;
    }
    const oe = wg(U), re = _i(U.getBoundingClientRect().height, "y", oe), de = et(U), xe = getComputedStyle(U), se = parseFloat(xe.marginTop), fe = parseFloat(xe.marginBottom), $ = Cg(getComputedStyle(c.current)), Q = Math.min(de.documentElement.clientHeight - se - fe, $), H = J.scrollTop, q = al(J);
    let ae = 0, ge = null, ue = !1, Re = !1;
    const be = (Pe) => {
      U.style.height = `${Pe}px`;
    }, ve = (Pe, Me) => {
      const _e = Ut(Pe, 0, Q - re);
      _e > 0 && be(re + _e), J.scrollTop = Me, Q - (re + _e) <= xo && (K.current = !0), b();
    }, me = ie ? q - H : H, Ee = Math.min(re + me, Q);
    if (ae = Ee, me <= xo) {
      ve(me, ie ? q : 0);
      return;
    }
    if (Q - Ee > xo)
      ie ? Re = !0 : ge = 0;
    else if (ue = !0, pe && H < q) {
      const Pe = re + me - Q;
      ge = H - (me - Pe);
    }
    if (ae = Math.ceil(ae), ae !== 0 && be(ae), Re || ge != null) {
      const Pe = al(J), Me = Re ? Pe : Ut(ge, 0, Pe);
      Math.abs(J.scrollTop - Me) > xo && (J.scrollTop = Me);
    }
    (ue || ae >= Q - xo) && (K.current = !0), b();
  });
  x.useImperativeHandle(v, () => W, [W]), jt({
    open: _,
    ref: c,
    onComplete() {
      _ && u?.(!0);
    }
  });
  const X = {
    open: _,
    transitionStatus: B,
    side: w,
    align: R
  };
  ke(() => {
    !U || !c.current || Object.keys(Z.current).length || (Z.current = {
      top: U.style.top || "0",
      left: U.style.left || "0",
      right: U.style.right,
      height: U.style.height,
      bottom: U.style.bottom,
      minHeight: U.style.minHeight,
      maxHeight: U.style.maxHeight,
      marginTop: U.style.marginTop,
      marginBottom: U.style.marginBottom
    });
  }, [c, U]), ke(() => {
    _ || S || (j.current = !1, K.current = !1, Yl(U, Z.current));
  }, [_, S, U, c]), ke(() => {
    const J = c.current;
    if (!_ || !G || !U || !J || S && !E || a.state.transitionStatus === "ending")
      return;
    if (!S) {
      j.current = !0, te.request(b), J.style.removeProperty("--transform-origin");
      return;
    }
    const ie = eE(J);
    J.style.removeProperty("--transform-origin");
    try {
      const pe = p.current, oe = f.current, re = getComputedStyle(U), de = getComputedStyle(J), xe = et(G), se = wt(U), fe = wg(G), $ = cl(G.getBoundingClientRect(), fe), Q = cl(U.getBoundingClientRect(), fe), H = $.height, q = Y || J, ae = q.scrollHeight, ge = parseFloat(de.borderBottomWidth), ue = parseFloat(re.marginTop) || 10, Re = parseFloat(re.marginBottom) || 10, be = parseFloat(re.minHeight) || 100, ve = Cg(de), me = 5, Ee = 5, Pe = 20, Me = xe.documentElement.clientHeight - ue - Re, _e = xe.documentElement.clientWidth, Ue = Me - $.bottom + H;
      let Ye, He = M === "rtl" ? $.right - Q.width : $.left, ye = 0;
      if (pe && oe) {
        const Fe = cl(oe.getBoundingClientRect(), fe);
        Ye = cl(pe.getBoundingClientRect(), fe), He = Q.left + (M === "rtl" ? Fe.right - Ye.right : Fe.left - Ye.left);
        const Xe = Fe.top - $.top + Fe.height / 2;
        ye = Ye.top - Q.top + Ye.height / 2 - Xe;
      }
      const Oe = Ue + ye + Re + ge;
      let Ie = Math.min(Me, Oe);
      const Le = Me - ue - Re, Be = Oe - Ie, Te = _e - Ee;
      U.style.left = `${Ut(He, me, Te - Q.width)}px`, U.style.height = `${Ie}px`, U.style.maxHeight = "auto", U.style.marginTop = `${ue}px`, U.style.marginBottom = `${Re}px`, J.style.height = "100%";
      const vt = al(q), nt = Be >= vt - xo;
      nt && (Ie = Math.min(Me, Q.height) - (Be - vt));
      const we = $.top < Pe || $.bottom > Me - Pe || Math.ceil(Ie) + xo < Math.min(ae, be), Ne = (se.visualViewport?.scale ?? 1) !== 1 && Hu;
      if (we || Ne) {
        j.current = !0, Yl(U, Z.current), N(!1);
        return;
      }
      const Ae = Math.max(be, Ie);
      if (nt) {
        const Fe = Math.max(0, Me - Oe);
        U.style.top = Q.height >= Le ? "0" : `${Fe}px`, U.style.height = `${Ie}px`, q.scrollTop = al(q);
      } else
        U.style.bottom = "0", q.scrollTop = Be;
      if (Ye) {
        const Fe = Q.top, Xe = Q.height, qe = Ye.top + Ye.height / 2, it = Xe > 0 ? (qe - Fe) / Xe * 100 : 50, Ge = Ut(it, 0, 100);
        J.style.setProperty("--transform-origin", `50% ${Ge}%`);
      }
      (Ae === Me || Ie >= ve) && (K.current = !0), b(), y && a.state.selectedIndex === null && a.state.activeIndex === null && C.current[0] != null && a.set("activeIndex", 0), j.current = !0;
    } finally {
      ie();
    }
  }, [a, _, U, G, f, p, c, b, S, N, te, T, P, Y, C, y, M, E]), x.useEffect(() => {
    if (!S || !U || !_)
      return;
    const J = wt(U);
    function ie(pe) {
      d(!1, Ve(l8, pe));
    }
    return ut(J, "resize", ie);
  }, [d, S, U, _]);
  const ee = {
    ...Y ? {
      role: "presentation",
      "aria-orientation": void 0
    } : {
      role: "listbox",
      "aria-multiselectable": h || void 0,
      id: `${V}-list`
    },
    onKeyDown(J) {
      g.current = !0, I && ys.has(J.key) && J.stopPropagation();
    },
    onMouseMove() {
      g.current = !1;
    },
    onScroll(J) {
      Y || W(J.currentTarget);
    },
    ...S && {
      style: Y ? {
        height: "100%"
      } : ob
    }
  }, le = $e("div", e, {
    ref: [n, c],
    state: X,
    stateAttributesMapping: JR,
    props: [L, ee, Rr(B), {
      className: !Y && S ? jl.className : void 0
    }, l]
  });
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!O && jl.getElement(D), /* @__PURE__ */ m(oi, {
      context: k,
      modal: !1,
      disabled: !A,
      returnFocus: s,
      restoreFocus: !0,
      children: le
    })]
  });
});
process.env.NODE_ENV !== "production" && (sb.displayName = "SelectPopup");
function Cg(t) {
  const e = t.maxHeight || "";
  return e.endsWith("px") && parseFloat(e) || 1 / 0;
}
function al(t) {
  return Z0(t.scrollHeight, t.clientHeight);
}
function wg(t) {
  return Th.getScale(t);
}
function _i(t, e, n) {
  return t / n[e];
}
function cl(t, e) {
  return ji({
    x: _i(t.x, "x", e),
    y: _i(t.y, "y", e),
    width: _i(t.width, "x", e),
    height: _i(t.height, "y", e)
  });
}
const Sg = [["transform", "none"], ["scale", "1"], ["translate", "0 0"]];
function eE(t) {
  const {
    style: e
  } = t, n = {};
  for (const [o, r] of Sg)
    n[o] = e.getPropertyValue(o), e.setProperty(o, r, "important");
  return () => {
    for (const [o] of Sg) {
      const r = n[o];
      r ? e.setProperty(o, r) : e.removeProperty(o);
    }
  };
}
const lb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    render: r,
    style: i,
    ...s
  } = e, {
    store: l,
    scrollHandlerRef: a
  } = Ao(), {
    alignItemWithTriggerActive: c
  } = nb(), u = Ce(l, dt.hasScrollArrows), d = Ce(l, dt.openMethod), f = Ce(l, dt.multiple), g = {
    id: `${Ce(l, dt.id)}-list`,
    role: "listbox",
    "aria-multiselectable": f || void 0,
    onScroll(b) {
      a.current?.(b.currentTarget);
    },
    ...c && {
      style: ob
    },
    className: u && d !== "touch" ? jl.className : void 0
  }, h = Se((b) => {
    l.set("listElement", b);
  });
  return $e("div", e, {
    ref: [n, h],
    props: [g, s]
  });
});
process.env.NODE_ENV !== "production" && (lb.displayName = "SelectList");
const zf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (zf.displayName = "SelectItemContext");
function Bf() {
  const t = x.useContext(zf);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SelectItemContext is missing. SelectItem parts must be placed within <Select.Item>." : rt(57));
  return t;
}
const ab = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    value: i = null,
    label: s,
    disabled: l = !1,
    nativeButton: a = !1,
    style: c,
    ...u
  } = e, d = x.useRef(null), f = Oo({
    label: s,
    textRef: d,
    indexGuessBehavior: Uu.GuessFromOrder
  }), {
    store: p,
    getItemProps: g,
    setOpen: h,
    setValue: b,
    selectionRef: v,
    typingRef: C,
    valuesRef: y,
    multiple: w,
    selectedItemTextRef: R
  } = Ao(), S = Ce(p, dt.isActive, f.index), E = Ce(p, dt.isSelected, f.index, i), N = Ce(p, dt.isSelectedByFocus, f.index), T = Ce(p, dt.isItemEqualToValue), P = f.index, I = P !== -1, k = x.useRef(null), M = $t(P);
  ke(() => {
    if (!I)
      return;
    const j = y.current;
    return j[P] = i, () => {
      delete j[P];
    };
  }, [I, P, i, y]), ke(() => {
    if (!I)
      return;
    const j = p.state.value;
    let Z = j;
    w && Array.isArray(j) && j.length > 0 && (Z = j[j.length - 1]), Z !== void 0 && go(i, Z, T) && (p.set("selectedIndex", P), d.current && (R.current = d.current));
  }, [I, P, w, T, p, i, R]);
  const D = {
    disabled: l,
    selected: E,
    highlighted: S
  }, O = g({
    active: S,
    selected: E
  });
  O.id = void 0;
  const V = x.useRef(null), _ = x.useRef("mouse"), A = x.useRef(!1), {
    getButtonProps: L,
    buttonRef: B
  } = Wt({
    disabled: l,
    focusableWhenDisabled: !0,
    native: a,
    composite: !0
  });
  function G(j) {
    const Z = p.state.value;
    if (w) {
      const te = Array.isArray(Z) ? Z : [], W = E ? y0(te, i, T) : [...te, i];
      b(W, Ve(Wo, j));
    } else
      b(i, Ve(Wo, j)), h(!1, Ve(Wo, j));
  }
  const U = {
    role: "option",
    "aria-selected": E,
    tabIndex: S ? 0 : -1,
    onTouchStart() {
      v.current = {
        allowSelectedMouseUp: !1,
        allowUnselectedMouseUp: !1
      };
    },
    onKeyDown(j) {
      V.current = j.key, p.set("activeIndex", P), j.key === " " && C.current && j.preventDefault();
    },
    onClick(j) {
      A.current = !1, !(j.type === "keydown" && V.current === null) && (l || j.type === "keydown" && V.current === " " && C.current || _.current !== "touch" && !S || (V.current = null, G(j.nativeEvent)));
    },
    onPointerEnter(j) {
      _.current = j.pointerType;
    },
    onPointerDown(j) {
      _.current = j.pointerType, A.current = !0;
    },
    onMouseUp() {
      if (l)
        return;
      if (A.current) {
        A.current = !1;
        return;
      }
      const j = !v.current.allowSelectedMouseUp && E, Z = !v.current.allowUnselectedMouseUp && !E;
      j || Z || _.current !== "touch" && !S || k.current?.click();
    }
  }, Y = $e("div", e, {
    ref: [B, n, f.ref, k],
    state: D,
    props: [O, U, u, L]
  }), K = x.useMemo(() => ({
    selected: E,
    indexRef: M,
    textRef: d,
    selectedByFocus: N,
    hasRegistered: I
  }), [E, M, d, N, I]);
  return /* @__PURE__ */ m(zf.Provider, {
    value: K,
    children: Y
  });
}));
process.env.NODE_ENV !== "production" && (ab.displayName = "SelectItem");
const cb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const o = e.keepMounted ?? !1, {
    selected: r
  } = Bf();
  return o || r ? /* @__PURE__ */ m(ub, {
    ...e,
    ref: n
  }) : null;
});
process.env.NODE_ENV !== "production" && (cb.displayName = "SelectItemIndicator");
const ub = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef((t, e) => {
  const {
    render: n,
    className: o,
    style: r,
    keepMounted: i,
    ...s
  } = t, {
    selected: l
  } = Bf(), a = x.useRef(null), {
    transitionStatus: c,
    setMounted: u
  } = Xn(l), f = $e("span", t, {
    ref: [e, a],
    state: {
      selected: l,
      transitionStatus: c
    },
    props: [{
      "aria-hidden": !0,
      children: "✔️"
    }, s],
    stateAttributesMapping: Bt
  });
  return jt({
    open: l,
    ref: a,
    onComplete() {
      l || u(!1);
    }
  }), f;
}));
process.env.NODE_ENV !== "production" && (ub.displayName = "Inner");
const db = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    indexRef: o,
    textRef: r,
    selectedByFocus: i,
    hasRegistered: s
  } = Bf(), {
    selectedItemTextRef: l
  } = Ao(), {
    className: a,
    render: c,
    style: u,
    ...d
  } = e, f = x.useCallback((g) => {
    if (!g || !s)
      return;
    const h = l.current === null || !l.current.isConnected;
    (i || h && o.current === 0) && (l.current = g);
  }, [l, o, i, s]);
  return $e("div", e, {
    ref: [f, n, r],
    props: d
  });
}));
process.env.NODE_ENV !== "production" && (db.displayName = "SelectItemText");
function tE(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const nE = {}, Ai = {};
function ur(t, e) {
  try {
    const o = (nE[t] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return o in Ai ? Ai[o] : Rg(o, o.split(":"));
  } catch {
    if (t in Ai) return Ai[t];
    const n = t?.match(oE);
    return n ? Rg(t, n.slice(1)) : NaN;
  }
}
const oE = /([+-]\d\d):?(\d\d)?/;
function Rg(t, e) {
  const n = +(e[0] || 0), o = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return Ai[t] = n * 60 + o > 0 ? n * 60 + o + r : n * 60 - o - r;
}
class lo extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(ur(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), fb(this), pu(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new lo(...n, e) : new lo(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new lo(+this, e);
  }
  getTimezoneOffset() {
    const e = -ur(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), pu(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new lo(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Eg = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Eg.test(t)) return;
  const e = t.replace(Eg, "$1UTC");
  lo.prototype[e] && (t.startsWith("get") ? lo.prototype[t] = function() {
    return this.internal[e]();
  } : (lo.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), rE(this), +this;
  }, lo.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), pu(this), +this;
  }));
});
function pu(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-ur(t.timeZone, t) * 60));
}
function rE(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), fb(t);
}
function fb(t) {
  const e = ur(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), o = /* @__PURE__ */ new Date(+t);
  o.setUTCHours(o.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+o)).getTimezoneOffset(), s = r - i, l = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  s && l && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + s);
  const a = r - n;
  a && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + a);
  const c = /* @__PURE__ */ new Date(+t);
  c.setUTCSeconds(0);
  const u = r > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, d = Math.round(-(ur(t.timeZone, t) * 60)) % 60;
  (d || u) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + d + u));
  const f = ur(t.timeZone, t), p = f > 0 ? Math.floor(f) : Math.ceil(f), h = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - p, b = p !== n, v = h - a;
  if (b && v) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + v);
    const C = ur(t.timeZone, t), y = C > 0 ? Math.floor(C) : Math.ceil(C), w = p - y;
    w && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + w), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + w));
  }
}
class sn extends lo {
  //#region static
  static tz(e, ...n) {
    return n.length ? new sn(...n, e) : new sn(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, o] = this.tzComponents(), r = `${e}${n}:${o}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, o, r] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${o} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, o, r] = this.tzComponents();
    return `${e} GMT${n}${o}${r} (${tE(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: n?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", o = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, o, r];
  }
  //#endregion
  withTimeZone(e) {
    return new sn(+this, e);
  }
  //#region date-fns integration
  [/* @__PURE__ */ Symbol.for("constructDateFrom")](e) {
    return new sn(+new Date(e), this.timeZone);
  }
  //#endregion
}
const pb = 6048e5, iE = 864e5, Ng = /* @__PURE__ */ Symbol.for("constructDateFrom");
function Yt(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Ng in t ? t[Ng](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function It(t, e) {
  return Yt(e || t, t);
}
function gb(t, e, n) {
  const o = It(t, n?.in);
  return isNaN(e) ? Yt(t, NaN) : (e && o.setDate(o.getDate() + e), o);
}
function mb(t, e, n) {
  const o = It(t, n?.in);
  if (isNaN(e)) return Yt(t, NaN);
  if (!e)
    return o;
  const r = o.getDate(), i = Yt(t, o.getTime());
  i.setMonth(o.getMonth() + e + 1, 0);
  const s = i.getDate();
  return r >= s ? i : (o.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), o);
}
let sE = {};
function Ds() {
  return sE;
}
function Qr(t, e) {
  const n = Ds(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = It(t, e?.in), i = r.getDay(), s = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function es(t, e) {
  return Qr(t, { ...e, weekStartsOn: 1 });
}
function hb(t, e) {
  const n = It(t, e?.in), o = n.getFullYear(), r = Yt(n, 0);
  r.setFullYear(o + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = es(r), s = Yt(n, 0);
  s.setFullYear(o, 0, 4), s.setHours(0, 0, 0, 0);
  const l = es(s);
  return n.getTime() >= i.getTime() ? o + 1 : n.getTime() >= l.getTime() ? o : o - 1;
}
function kg(t) {
  const e = It(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function vi(t, ...e) {
  const n = Yt.bind(
    null,
    e.find((o) => typeof o == "object")
  );
  return e.map(n);
}
function ts(t, e) {
  const n = It(t, e?.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Wf(t, e, n) {
  const [o, r] = vi(
    n?.in,
    t,
    e
  ), i = ts(o), s = ts(r), l = +i - kg(i), a = +s - kg(s);
  return Math.round((l - a) / iE);
}
function lE(t, e) {
  const n = hb(t, e), o = Yt(t, 0);
  return o.setFullYear(n, 0, 4), o.setHours(0, 0, 0, 0), es(o);
}
function aE(t, e, n) {
  return gb(t, e * 7, n);
}
function cE(t, e, n) {
  return mb(t, e * 12, n);
}
function uE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Yt.bind(null, r));
    const i = It(r, o);
    (!n || n < i || isNaN(+i)) && (n = i);
  }), Yt(o, n || NaN);
}
function dE(t, e) {
  let n, o = e?.in;
  return t.forEach((r) => {
    !o && typeof r == "object" && (o = Yt.bind(null, r));
    const i = It(r, o);
    (!n || n > i || isNaN(+i)) && (n = i);
  }), Yt(o, n || NaN);
}
function fE(t, e, n) {
  const [o, r] = vi(
    n?.in,
    t,
    e
  );
  return +ts(o) == +ts(r);
}
function bb(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function pE(t) {
  return !(!bb(t) && typeof t != "number" || isNaN(+It(t)));
}
function vb(t, e, n) {
  const [o, r] = vi(
    n?.in,
    t,
    e
  ), i = o.getFullYear() - r.getFullYear(), s = o.getMonth() - r.getMonth();
  return i * 12 + s;
}
function gE(t, e) {
  const n = It(t, e?.in), o = n.getMonth();
  return n.setFullYear(n.getFullYear(), o + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function yb(t, e) {
  const [n, o] = vi(t, e.start, e.end);
  return { start: n, end: o };
}
function mE(t, e) {
  const { start: n, end: o } = yb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Yt(n, s)), s.setMonth(s.getMonth() + l);
  return r ? a.reverse() : a;
}
function hE(t, e) {
  const n = It(t, e?.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function bE(t, e) {
  const n = It(t, e?.in), o = n.getFullYear();
  return n.setFullYear(o + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function xb(t, e) {
  const n = It(t, e?.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function vE(t, e) {
  const { start: n, end: o } = yb(e?.in, t);
  let r = +n > +o;
  const i = r ? +n : +o, s = r ? o : n;
  s.setHours(0, 0, 0, 0), s.setMonth(0, 1);
  let l = 1;
  const a = [];
  for (; +s <= i; )
    a.push(Yt(n, s)), s.setFullYear(s.getFullYear() + l);
  return r ? a.reverse() : a;
}
function Cb(t, e) {
  const n = Ds(), o = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, r = It(t, e?.in), i = r.getDay(), s = (i < o ? -7 : 0) + 6 - (i - o);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function yE(t, e) {
  return Cb(t, { ...e, weekStartsOn: 1 });
}
const xE = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, CE = (t, e, n) => {
  let o;
  const r = xE[t];
  return typeof r == "string" ? o = r : e === 1 ? o = r.one : o = r.other.replace("{{count}}", e.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function bc(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const wE = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, SE = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, RE = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, EE = {
  date: bc({
    formats: wE,
    defaultWidth: "full"
  }),
  time: bc({
    formats: SE,
    defaultWidth: "full"
  }),
  dateTime: bc({
    formats: RE,
    defaultWidth: "full"
  })
}, NE = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, kE = (t, e, n, o) => NE[t];
function ki(t) {
  return (e, n) => {
    const o = n?.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && t.formattingValues) {
      const s = t.defaultFormattingWidth || t.defaultWidth, l = n?.width ? String(n.width) : s;
      r = t.formattingValues[l] || t.formattingValues[s];
    } else {
      const s = t.defaultWidth, l = n?.width ? String(n.width) : t.defaultWidth;
      r = t.values[l] || t.values[s];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const ME = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, IE = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, PE = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, TE = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, OE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, DE = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, VE = (t, e) => {
  const n = Number(t), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, _E = {
  ordinalNumber: VE,
  era: ki({
    values: ME,
    defaultWidth: "wide"
  }),
  quarter: ki({
    values: IE,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: ki({
    values: PE,
    defaultWidth: "wide"
  }),
  day: ki({
    values: TE,
    defaultWidth: "wide"
  }),
  dayPeriod: ki({
    values: OE,
    defaultWidth: "wide",
    formattingValues: DE,
    defaultFormattingWidth: "wide"
  })
};
function Mi(t) {
  return (e, n = {}) => {
    const o = n.width, r = o && t.matchPatterns[o] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const s = i[0], l = o && t.parsePatterns[o] || t.parsePatterns[t.defaultParseWidth], a = Array.isArray(l) ? LE(l, (d) => d.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      AE(l, (d) => d.test(s))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(a) : a, c = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(s.length);
    return { value: c, rest: u };
  };
}
function AE(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function LE(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function FE(t) {
  return (e, n = {}) => {
    const o = e.match(t.matchPattern);
    if (!o) return null;
    const r = o[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let s = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const l = e.slice(r.length);
    return { value: s, rest: l };
  };
}
const $E = /^(\d+)(th|st|nd|rd)?/i, HE = /\d+/i, zE = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, BE = {
  any: [/^b/i, /^(a|c)/i]
}, WE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, UE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, GE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, YE = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, jE = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, KE = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, qE = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, ZE = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, XE = {
  ordinalNumber: FE({
    matchPattern: $E,
    parsePattern: HE,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: Mi({
    matchPatterns: zE,
    defaultMatchWidth: "wide",
    parsePatterns: BE,
    defaultParseWidth: "any"
  }),
  quarter: Mi({
    matchPatterns: WE,
    defaultMatchWidth: "wide",
    parsePatterns: UE,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: Mi({
    matchPatterns: GE,
    defaultMatchWidth: "wide",
    parsePatterns: YE,
    defaultParseWidth: "any"
  }),
  day: Mi({
    matchPatterns: jE,
    defaultMatchWidth: "wide",
    parsePatterns: KE,
    defaultParseWidth: "any"
  }),
  dayPeriod: Mi({
    matchPatterns: qE,
    defaultMatchWidth: "any",
    parsePatterns: ZE,
    defaultParseWidth: "any"
  })
}, Vr = {
  code: "en-US",
  formatDistance: CE,
  formatLong: EE,
  formatRelative: kE,
  localize: _E,
  match: XE,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function QE(t, e) {
  const n = It(t, e?.in);
  return Wf(n, xb(n)) + 1;
}
function Uf(t, e) {
  const n = It(t, e?.in), o = +es(n) - +lE(n);
  return Math.round(o / pb) + 1;
}
function wb(t, e) {
  const n = It(t, e?.in), o = n.getFullYear(), r = Ds(), i = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, s = Yt(e?.in || t, 0);
  s.setFullYear(o + 1, 0, i), s.setHours(0, 0, 0, 0);
  const l = Qr(s, e), a = Yt(e?.in || t, 0);
  a.setFullYear(o, 0, i), a.setHours(0, 0, 0, 0);
  const c = Qr(a, e);
  return +n >= +l ? o + 1 : +n >= +c ? o : o - 1;
}
function JE(t, e) {
  const n = Ds(), o = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, r = wb(t, e), i = Yt(e?.in || t, 0);
  return i.setFullYear(r, 0, o), i.setHours(0, 0, 0, 0), Qr(i, e);
}
function Gf(t, e) {
  const n = It(t, e?.in), o = +Qr(n, e) - +JE(n, e);
  return Math.round(o / pb) + 1;
}
function Rt(t, e) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(e, "0");
  return n + o;
}
const Fo = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), o = n > 0 ? n : 1 - n;
    return Rt(e === "yy" ? o % 100 : o, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : Rt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return Rt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return Rt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return Rt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return Rt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return Rt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, o = t.getMilliseconds(), r = Math.trunc(
      o * Math.pow(10, n - 3)
    );
    return Rt(r, e.length);
  }
}, Or = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Mg = {
  // Era
  G: function(t, e, n) {
    const o = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(o, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(o, { width: "narrow" });
      default:
        return n.era(o, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const o = t.getFullYear(), r = o > 0 ? o : 1 - o;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Fo.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, o) {
    const r = wb(t, o), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const s = i % 100;
      return Rt(s, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : Rt(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = hb(t);
    return Rt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return Rt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(o);
      // 01, 02, 03, 04
      case "QQ":
        return Rt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const o = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(o);
      // 01, 02, 03, 04
      case "qq":
        return Rt(o, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(o, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.quarter(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Fo.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(o, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.month(o, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const o = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(o + 1);
      // 01, 02, ..., 12
      case "LL":
        return Rt(o + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(o + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(o, {
          width: "narrow",
          context: "standalone"
        });
      default:
        return n.month(o, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, o) {
    const r = Gf(t, o);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : Rt(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const o = Uf(t);
    return e === "Io" ? n.ordinalNumber(o, { unit: "week" }) : Rt(o, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Fo.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const o = QE(t);
    return e === "Do" ? n.ordinalNumber(o, { unit: "dayOfYear" }) : Rt(o, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const o = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(i);
      // Padded numerical value
      case "ee":
        return Rt(i, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, o) {
    const r = t.getDay(), i = (r - o.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(i);
      // Padded numerical value
      case "cc":
        return Rt(i, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const o = t.getDay(), r = o === 0 ? 7 : o;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return Rt(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o === 12 ? r = Or.noon : o === 0 ? r = Or.midnight : r = o / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const o = t.getHours();
    let r;
    switch (o >= 17 ? r = Or.evening : o >= 12 ? r = Or.afternoon : o >= 4 ? r = Or.morning : r = Or.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let o = t.getHours() % 12;
      return o === 0 && (o = 12), n.ordinalNumber(o, { unit: "hour" });
    }
    return Fo.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Fo.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const o = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(o, { unit: "hour" }) : Rt(o, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let o = t.getHours();
    return o === 0 && (o = 24), e === "ko" ? n.ordinalNumber(o, { unit: "hour" }) : Rt(o, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Fo.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Fo.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Fo.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const o = t.getTimezoneOffset();
    if (o === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return Pg(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return lr(o);
      // Hours and minutes with `:` delimiter
      default:
        return lr(o, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return Pg(o);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return lr(o);
      // Hours and minutes with `:` delimiter
      default:
        return lr(o, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ig(o, ":");
      default:
        return "GMT" + lr(o, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const o = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ig(o, ":");
      default:
        return "GMT" + lr(o, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const o = Math.trunc(+t / 1e3);
    return Rt(o, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return Rt(+t, e.length);
  }
};
function Ig(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Math.trunc(o / 60), i = o % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + Rt(i, 2);
}
function Pg(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + Rt(Math.abs(t) / 60, 2) : lr(t, e);
}
function lr(t, e = "") {
  const n = t > 0 ? "-" : "+", o = Math.abs(t), r = Rt(Math.trunc(o / 60), 2), i = Rt(o % 60, 2);
  return n + r + e + i;
}
const Tg = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    default:
      return e.date({ width: "full" });
  }
}, Sb = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    default:
      return e.time({ width: "full" });
  }
}, eN = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], o = n[1], r = n[2];
  if (!r)
    return Tg(t, e);
  let i;
  switch (o) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Tg(o, e)).replace("{{time}}", Sb(r, e));
}, tN = {
  p: Sb,
  P: eN
}, nN = /^D+$/, oN = /^Y+$/, rN = ["D", "DD", "YY", "YYYY"];
function iN(t) {
  return nN.test(t);
}
function sN(t) {
  return oN.test(t);
}
function lN(t, e, n) {
  const o = aN(t, e, n);
  if (console.warn(o), rN.includes(t)) throw new RangeError(o);
}
function aN(t, e, n) {
  const o = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${o} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const cN = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, uN = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, dN = /^'([^]*?)'?$/, fN = /''/g, pN = /[a-zA-Z]/;
function Li(t, e, n) {
  const o = Ds(), r = n?.locale ?? o.locale ?? Vr, i = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, s = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? o.weekStartsOn ?? o.locale?.options?.weekStartsOn ?? 0, l = It(t, n?.in);
  if (!pE(l))
    throw new RangeError("Invalid time value");
  let a = e.match(uN).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = tN[d];
      return f(u, r.formatLong);
    }
    return u;
  }).join("").match(cN).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: gN(u) };
    if (Mg[d])
      return { isToken: !0, value: u };
    if (d.match(pN))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  r.localize.preprocessor && (a = r.localize.preprocessor(l, a));
  const c = {
    firstWeekContainsDate: i,
    weekStartsOn: s,
    locale: r
  };
  return a.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!n?.useAdditionalWeekYearTokens && sN(d) || !n?.useAdditionalDayOfYearTokens && iN(d)) && lN(d, e, String(t));
    const f = Mg[d[0]];
    return f(l, d, r.localize, c);
  }).join("");
}
function gN(t) {
  const e = t.match(dN);
  return e ? e[1].replace(fN, "'") : t;
}
function mN(t, e) {
  const n = It(t, e?.in), o = n.getFullYear(), r = n.getMonth(), i = Yt(n, 0);
  return i.setFullYear(o, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function hN(t, e) {
  return It(t, e?.in).getMonth();
}
function bN(t, e) {
  return It(t, e?.in).getFullYear();
}
function vN(t, e) {
  return +It(t) > +It(e);
}
function yN(t, e) {
  return +It(t) < +It(e);
}
function xN(t, e, n) {
  const [o, r] = vi(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear() && o.getMonth() === r.getMonth();
}
function CN(t, e, n) {
  const [o, r] = vi(
    n?.in,
    t,
    e
  );
  return o.getFullYear() === r.getFullYear();
}
function wN(t, e, n) {
  const o = It(t, n?.in), r = o.getFullYear(), i = o.getDate(), s = Yt(t, 0);
  s.setFullYear(r, e, 15), s.setHours(0, 0, 0, 0);
  const l = mN(s);
  return o.setMonth(e, Math.min(i, l)), o;
}
function SN(t, e, n) {
  const o = It(t, n?.in);
  return isNaN(+o) ? Yt(t, NaN) : (o.setFullYear(e), o);
}
const Og = 5, RN = 4;
function EN(t, e) {
  const n = e.startOfMonth(t), o = n.getDay() > 0 ? n.getDay() : 7, r = e.addDays(t, -o + 1), i = e.addDays(r, Og * 7 - 1);
  return e.getMonth(t) === e.getMonth(i) ? Og : RN;
}
function Rb(t, e) {
  const n = e.startOfMonth(t), o = n.getDay();
  return o === 1 ? n : o === 0 ? e.addDays(n, -6) : e.addDays(n, -1 * (o - 1));
}
function NN(t, e) {
  const n = Rb(t, e), o = EN(t, e);
  return e.addDays(n, o * 7 - 1);
}
const Eb = {
  ...Vr,
  labels: {
    labelDayButton: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => Li(s, l, { locale: Vr, ...n });
      let i = r(t, "PPPP");
      return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
    },
    labelMonthDropdown: "Choose the Month",
    labelNext: "Go to the Next Month",
    labelPrevious: "Go to the Previous Month",
    labelWeekNumber: (t) => `Week ${t}`,
    labelYearDropdown: "Choose the Year",
    labelGrid: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => Li(r, i, { locale: Vr, ...e }), o(t, "LLLL yyyy");
    },
    labelGridcell: (t, e, n, o) => {
      let r;
      o && typeof o.format == "function" ? r = o.format.bind(o) : r = (s, l) => Li(s, l, { locale: Vr, ...n });
      let i = r(t, "PPPP");
      return e?.today && (i = `Today, ${i}`), i;
    },
    labelNav: "Navigation bar",
    labelWeekNumberHeader: "Week Number",
    labelWeekday: (t, e, n) => {
      let o;
      return n && typeof n.format == "function" ? o = n.format.bind(n) : o = (r, i) => Li(r, i, { locale: Vr, ...e }), o(t, "cccc");
    }
  }
};
class Rn {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, n) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? sn.tz(this.options.timeZone) : new this.Date(), this.newDate = (o, r, i) => this.overrides?.newDate ? this.overrides.newDate(o, r, i) : this.options.timeZone ? new sn(o, r, i, this.options.timeZone) : new Date(o, r, i), this.addDays = (o, r) => this.overrides?.addDays ? this.overrides.addDays(o, r) : gb(o, r), this.addMonths = (o, r) => this.overrides?.addMonths ? this.overrides.addMonths(o, r) : mb(o, r), this.addWeeks = (o, r) => this.overrides?.addWeeks ? this.overrides.addWeeks(o, r) : aE(o, r), this.addYears = (o, r) => this.overrides?.addYears ? this.overrides.addYears(o, r) : cE(o, r), this.differenceInCalendarDays = (o, r) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(o, r) : Wf(o, r), this.differenceInCalendarMonths = (o, r) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(o, r) : vb(o, r), this.eachMonthOfInterval = (o) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(o) : mE(o), this.eachYearOfInterval = (o) => {
      const r = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(o) : vE(o), i = new Set(r.map((l) => this.getYear(l)));
      if (i.size === r.length)
        return r;
      const s = [];
      return i.forEach((l) => {
        s.push(new Date(l, 0, 1));
      }), s;
    }, this.endOfBroadcastWeek = (o) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(o) : NN(o, this), this.endOfISOWeek = (o) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(o) : yE(o), this.endOfMonth = (o) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(o) : gE(o), this.endOfWeek = (o, r) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(o, r) : Cb(o, this.options), this.endOfYear = (o) => this.overrides?.endOfYear ? this.overrides.endOfYear(o) : bE(o), this.format = (o, r, i) => {
      const s = this.overrides?.format ? this.overrides.format(o, r, this.options) : Li(o, r, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (o) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(o) : Uf(o), this.getMonth = (o, r) => this.overrides?.getMonth ? this.overrides.getMonth(o, this.options) : hN(o, this.options), this.getYear = (o, r) => this.overrides?.getYear ? this.overrides.getYear(o, this.options) : bN(o, this.options), this.getWeek = (o, r) => this.overrides?.getWeek ? this.overrides.getWeek(o, this.options) : Gf(o, this.options), this.isAfter = (o, r) => this.overrides?.isAfter ? this.overrides.isAfter(o, r) : vN(o, r), this.isBefore = (o, r) => this.overrides?.isBefore ? this.overrides.isBefore(o, r) : yN(o, r), this.isDate = (o) => this.overrides?.isDate ? this.overrides.isDate(o) : bb(o), this.isSameDay = (o, r) => this.overrides?.isSameDay ? this.overrides.isSameDay(o, r) : fE(o, r), this.isSameMonth = (o, r) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(o, r) : xN(o, r), this.isSameYear = (o, r) => this.overrides?.isSameYear ? this.overrides.isSameYear(o, r) : CN(o, r), this.max = (o) => this.overrides?.max ? this.overrides.max(o) : uE(o), this.min = (o) => this.overrides?.min ? this.overrides.min(o) : dE(o), this.setMonth = (o, r) => this.overrides?.setMonth ? this.overrides.setMonth(o, r) : wN(o, r), this.setYear = (o, r) => this.overrides?.setYear ? this.overrides.setYear(o, r) : SN(o, r), this.startOfBroadcastWeek = (o, r) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(o, this) : Rb(o, this), this.startOfDay = (o) => this.overrides?.startOfDay ? this.overrides.startOfDay(o) : ts(o), this.startOfISOWeek = (o) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(o) : es(o), this.startOfMonth = (o) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(o) : hE(o), this.startOfWeek = (o, r) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(o, this.options) : Qr(o, this.options), this.startOfYear = (o) => this.overrides?.startOfYear ? this.overrides.startOfYear(o) : xb(o), this.options = { locale: Eb, ...e }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), o = {};
    for (let r = 0; r < 10; r++)
      o[r.toString()] = n.format(r);
    return o;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const n = this.getDigitMap();
    return e.replace(/\d/g, (o) => n[o] || o);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && Rn.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: n, timeZone: o, numerals: r } = this.options, i = n?.code;
    if (i && Rn.yearFirstLocales.has(i))
      try {
        return new Intl.DateTimeFormat(i, {
          month: "long",
          year: "numeric",
          timeZone: o,
          numberingSystem: r
        }).format(e);
      } catch {
      }
    const s = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, s);
  }
}
Rn.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const vo = new Rn();
class Nb {
  constructor(e, n, o = vo) {
    this.date = e, this.displayMonth = n, this.outside = !!(n && !o.isSameMonth(e, n)), this.dateLib = o, this.isoDate = o.format(e, "yyyy-MM-dd"), this.displayMonthId = o.format(n, "yyyy-MM"), this.dateMonthId = o.format(e, "yyyy-MM");
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class kN {
  constructor(e, n) {
    this.date = e, this.weeks = n;
  }
}
class MN {
  constructor(e, n) {
    this.days = n, this.weekNumber = e;
  }
}
function IN(t) {
  return We.createElement("button", { ...t });
}
function PN(t) {
  return We.createElement("span", { ...t });
}
function TN(t) {
  const { size: e = 24, orientation: n = "left", className: o } = t;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    We.createElement(
      "svg",
      { className: o, width: e, height: e, viewBox: "0 0 24 24" },
      n === "up" && We.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && We.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && We.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && We.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function ON(t) {
  const { day: e, modifiers: n, ...o } = t;
  return We.createElement("td", { ...o });
}
function DN(t) {
  const { day: e, modifiers: n, ...o } = t, r = We.useRef(null);
  return We.useEffect(() => {
    n.focused && r.current?.focus();
  }, [n.focused]), We.createElement("button", { ref: r, ...o });
}
var Je;
(function(t) {
  t.Root = "root", t.Chevron = "chevron", t.Day = "day", t.DayButton = "day_button", t.CaptionLabel = "caption_label", t.Dropdowns = "dropdowns", t.Dropdown = "dropdown", t.DropdownRoot = "dropdown_root", t.Footer = "footer", t.MonthGrid = "month_grid", t.MonthCaption = "month_caption", t.MonthsDropdown = "months_dropdown", t.Month = "month", t.Months = "months", t.Nav = "nav", t.NextMonthButton = "button_next", t.PreviousMonthButton = "button_previous", t.Week = "week", t.Weeks = "weeks", t.Weekday = "weekday", t.Weekdays = "weekdays", t.WeekNumber = "week_number", t.WeekNumberHeader = "week_number_header", t.YearsDropdown = "years_dropdown";
})(Je || (Je = {}));
var Dt;
(function(t) {
  t.disabled = "disabled", t.hidden = "hidden", t.outside = "outside", t.focused = "focused", t.today = "today";
})(Dt || (Dt = {}));
var Gn;
(function(t) {
  t.range_end = "range_end", t.range_middle = "range_middle", t.range_start = "range_start", t.selected = "selected";
})(Gn || (Gn = {}));
var wn;
(function(t) {
  t.weeks_before_enter = "weeks_before_enter", t.weeks_before_exit = "weeks_before_exit", t.weeks_after_enter = "weeks_after_enter", t.weeks_after_exit = "weeks_after_exit", t.caption_after_enter = "caption_after_enter", t.caption_after_exit = "caption_after_exit", t.caption_before_enter = "caption_before_enter", t.caption_before_exit = "caption_before_exit";
})(wn || (wn = {}));
function VN(t) {
  const { options: e, className: n, components: o, classNames: r, ...i } = t, s = [r[Je.Dropdown], n].join(" "), l = e?.find(({ value: a }) => a === i.value);
  return We.createElement(
    "span",
    { "data-disabled": i.disabled, className: r[Je.DropdownRoot] },
    We.createElement(o.Select, { className: s, ...i }, e?.map(({ value: a, label: c, disabled: u }) => We.createElement(o.Option, { key: a, value: a, disabled: u }, c))),
    We.createElement(
      "span",
      { className: r[Je.CaptionLabel], "aria-hidden": !0 },
      l?.label,
      We.createElement(o.Chevron, { orientation: "down", size: 18, className: r[Je.Chevron] })
    )
  );
}
function _N(t) {
  return We.createElement("div", { ...t });
}
function AN(t) {
  return We.createElement("div", { ...t });
}
function LN(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return We.createElement("div", { ...o }, t.children);
}
function FN(t) {
  const { calendarMonth: e, displayIndex: n, ...o } = t;
  return We.createElement("div", { ...o });
}
function $N(t) {
  return We.createElement("table", { ...t });
}
function HN(t) {
  return We.createElement("div", { ...t });
}
const kb = mo(void 0);
function yi() {
  const t = um(kb);
  if (t === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return t;
}
function zN(t) {
  const { components: e } = yi();
  return We.createElement(e.Dropdown, { ...t });
}
function BN(t) {
  const { onPreviousClick: e, onNextClick: n, previousMonth: o, nextMonth: r, ...i } = t, { components: s, classNames: l, labels: { labelPrevious: a, labelNext: c } } = yi(), u = In((f) => {
    r && n?.(f);
  }, [r, n]), d = In((f) => {
    o && e?.(f);
  }, [o, e]);
  return We.createElement(
    "nav",
    { ...i },
    We.createElement(
      s.PreviousMonthButton,
      { type: "button", className: l[Je.PreviousMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": a(o), onClick: d },
      We.createElement(s.Chevron, { disabled: o ? void 0 : !0, className: l[Je.Chevron], orientation: "left" })
    ),
    We.createElement(
      s.NextMonthButton,
      { type: "button", className: l[Je.NextMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": c(r), onClick: u },
      We.createElement(s.Chevron, { disabled: r ? void 0 : !0, orientation: "right", className: l[Je.Chevron] })
    )
  );
}
function WN(t) {
  const { components: e } = yi();
  return We.createElement(e.Button, { ...t });
}
function UN(t) {
  return We.createElement("option", { ...t });
}
function GN(t) {
  const { components: e } = yi();
  return We.createElement(e.Button, { ...t });
}
function YN(t) {
  const { rootRef: e, ...n } = t;
  return We.createElement("div", { ...n, ref: e });
}
function jN(t) {
  return We.createElement("select", { ...t });
}
function KN(t) {
  const { week: e, ...n } = t;
  return We.createElement("tr", { ...n });
}
function qN(t) {
  return We.createElement("th", { ...t });
}
function ZN(t) {
  return We.createElement(
    "thead",
    { "aria-hidden": !0 },
    We.createElement("tr", { ...t })
  );
}
function XN(t) {
  const { week: e, ...n } = t;
  return We.createElement("th", { ...n });
}
function QN(t) {
  return We.createElement("th", { ...t });
}
function JN(t) {
  return We.createElement("tbody", { ...t });
}
function ek(t) {
  const { components: e } = yi();
  return We.createElement(e.Dropdown, { ...t });
}
const tk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: IN,
  CaptionLabel: PN,
  Chevron: TN,
  Day: ON,
  DayButton: DN,
  Dropdown: VN,
  DropdownNav: _N,
  Footer: AN,
  Month: LN,
  MonthCaption: FN,
  MonthGrid: $N,
  Months: HN,
  MonthsDropdown: zN,
  Nav: BN,
  NextMonthButton: WN,
  Option: UN,
  PreviousMonthButton: GN,
  Root: YN,
  Select: jN,
  Week: KN,
  WeekNumber: XN,
  WeekNumberHeader: QN,
  Weekday: qN,
  Weekdays: ZN,
  Weeks: JN,
  YearsDropdown: ek
}, Symbol.toStringTag, { value: "Module" }));
function Ro(t, e, n = !1, o = vo) {
  let { from: r, to: i } = t;
  const { differenceInCalendarDays: s, isSameDay: l } = o;
  return r && i ? (s(i, r) < 0 && ([r, i] = [i, r]), s(e, r) >= (n ? 1 : 0) && s(i, e) >= (n ? 1 : 0)) : !n && i ? l(i, e) : !n && r ? l(r, e) : !1;
}
function Yf(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function ka(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function jf(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function Kf(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function Mb(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function Ib(t, e) {
  return Array.isArray(t) && t.every(e.isDate);
}
function Eo(t, e, n = vo) {
  const o = Array.isArray(e) ? e : [e], { isSameDay: r, differenceInCalendarDays: i, isAfter: s } = n;
  return o.some((l) => {
    if (typeof l == "boolean")
      return l;
    if (n.isDate(l))
      return r(t, l);
    if (Ib(l, n))
      return l.some((a) => r(t, a));
    if (ka(l))
      return Ro(l, t, !1, n);
    if (Mb(l))
      return Array.isArray(l.dayOfWeek) ? l.dayOfWeek.includes(t.getDay()) : l.dayOfWeek === t.getDay();
    if (Yf(l)) {
      const a = i(l.before, t), c = i(l.after, t), u = a > 0, d = c < 0;
      return s(l.before, l.after) ? d && u : u || d;
    }
    return jf(l) ? i(t, l.after) > 0 : Kf(l) ? i(l.before, t) > 0 : typeof l == "function" ? l(t) : !1;
  });
}
function nk(t, e, n, o, r) {
  const { disabled: i, hidden: s, modifiers: l, showOutsideDays: a, broadcastCalendar: c, today: u = r.today() } = e, { isSameDay: d, isSameMonth: f, startOfMonth: p, isBefore: g, endOfMonth: h, isAfter: b } = r, v = n && p(n), C = o && h(o), y = {
    [Dt.focused]: [],
    [Dt.outside]: [],
    [Dt.disabled]: [],
    [Dt.hidden]: [],
    [Dt.today]: []
  }, w = {};
  for (const R of t) {
    const { date: S, displayMonth: E } = R, N = !!(E && !f(S, E)), T = !!(v && g(S, v)), P = !!(C && b(S, C)), I = !!(i && Eo(S, i, r)), k = !!(s && Eo(S, s, r)) || T || P || // Broadcast calendar will show outside days as default
    !c && !a && N || c && a === !1 && N, M = d(S, u);
    N && y.outside.push(R), I && y.disabled.push(R), k && y.hidden.push(R), M && y.today.push(R), l && Object.keys(l).forEach((D) => {
      const O = l?.[D];
      O && Eo(S, O, r) && (w[D] ? w[D].push(R) : w[D] = [R]);
    });
  }
  return (R) => {
    const S = {
      [Dt.focused]: !1,
      [Dt.disabled]: !1,
      [Dt.hidden]: !1,
      [Dt.outside]: !1,
      [Dt.today]: !1
    }, E = {};
    for (const N in y) {
      const T = y[N];
      S[N] = T.some((P) => P === R);
    }
    for (const N in w)
      E[N] = w[N].some((T) => T === R);
    return {
      ...S,
      // custom modifiers should override all the previous ones
      ...E
    };
  };
}
function ok(t, e, n = {}) {
  return Object.entries(t).filter(([, r]) => r === !0).reduce((r, [i]) => (n[i] ? r.push(n[i]) : e[Dt[i]] ? r.push(e[Dt[i]]) : e[Gn[i]] && r.push(e[Gn[i]]), r), [e[Je.Day]]);
}
function rk(t) {
  return {
    ...tk,
    ...t
  };
}
function ik(t) {
  const e = {
    "data-mode": t.mode ?? void 0,
    "data-required": "required" in t ? t.required : void 0,
    "data-multiple-months": t.numberOfMonths && t.numberOfMonths > 1 || void 0,
    "data-week-numbers": t.showWeekNumber || void 0,
    "data-broadcast-calendar": t.broadcastCalendar || void 0,
    "data-nav-layout": t.navLayout || void 0
  };
  return Object.entries(t).forEach(([n, o]) => {
    n.startsWith("data-") && (e[n] = o);
  }), e;
}
function sk() {
  const t = {};
  for (const e in Je)
    t[Je[e]] = `rdp-${Je[e]}`;
  for (const e in Dt)
    t[Dt[e]] = `rdp-${Dt[e]}`;
  for (const e in Gn)
    t[Gn[e]] = `rdp-${Gn[e]}`;
  for (const e in wn)
    t[wn[e]] = `rdp-${wn[e]}`;
  return t;
}
function Pb(t, e, n) {
  return (n ?? new Rn(e)).formatMonthYear(t);
}
const lk = Pb;
function ak(t, e, n) {
  return (n ?? new Rn(e)).format(t, "d");
}
function ck(t, e = vo) {
  return e.format(t, "LLLL");
}
function uk(t, e, n) {
  return (n ?? new Rn(e)).format(t, "cccccc");
}
function dk(t, e = vo) {
  return t < 10 ? e.formatNumber(`0${t.toLocaleString()}`) : e.formatNumber(`${t.toLocaleString()}`);
}
function fk() {
  return "";
}
function Tb(t, e = vo) {
  return e.format(t, "yyyy");
}
const pk = Tb, gk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: Pb,
  formatDay: ak,
  formatMonthCaption: lk,
  formatMonthDropdown: ck,
  formatWeekNumber: dk,
  formatWeekNumberHeader: fk,
  formatWeekdayName: uk,
  formatYearCaption: pk,
  formatYearDropdown: Tb
}, Symbol.toStringTag, { value: "Module" }));
function mk(t) {
  return t?.formatMonthCaption && !t.formatCaption && (t.formatCaption = t.formatMonthCaption), t?.formatYearCaption && !t.formatYearDropdown && (t.formatYearDropdown = t.formatYearCaption), {
    ...gk,
    ...t
  };
}
function qf(t, e, n, o) {
  let r = (o ?? new Rn(n)).format(t, "PPPP");
  return e.today && (r = `Today, ${r}`), e.selected && (r = `${r}, selected`), r;
}
const hk = qf;
function Zf(t, e, n) {
  return (n ?? new Rn(e)).formatMonthYear(t);
}
const bk = Zf;
function Ob(t, e, n, o) {
  let r = (o ?? new Rn(n)).format(t, "PPPP");
  return e?.today && (r = `Today, ${r}`), r;
}
function Db(t) {
  return "Choose the Month";
}
function Vb() {
  return "";
}
const vk = "Go to the Next Month";
function _b(t, e) {
  return vk;
}
function Ab(t) {
  return "Go to the Previous Month";
}
function Lb(t, e, n) {
  return (n ?? new Rn(e)).format(t, "cccc");
}
function Fb(t, e) {
  return `Week ${t}`;
}
function $b(t) {
  return "Week Number";
}
function Hb(t) {
  return "Choose the Year";
}
const yk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: bk,
  labelDay: hk,
  labelDayButton: qf,
  labelGrid: Zf,
  labelGridcell: Ob,
  labelMonthDropdown: Db,
  labelNav: Vb,
  labelNext: _b,
  labelPrevious: Ab,
  labelWeekNumber: Fb,
  labelWeekNumberHeader: $b,
  labelWeekday: Lb,
  labelYearDropdown: Hb
}, Symbol.toStringTag, { value: "Module" })), Bn = (t, e, n) => e || (n ? typeof n == "function" ? n : (...o) => n : t);
function xk(t, e) {
  const n = e.locale?.labels ?? {};
  return {
    ...yk,
    ...t ?? {},
    labelDayButton: Bn(qf, t?.labelDayButton, n.labelDayButton),
    labelMonthDropdown: Bn(Db, t?.labelMonthDropdown, n.labelMonthDropdown),
    labelNext: Bn(_b, t?.labelNext, n.labelNext),
    labelPrevious: Bn(Ab, t?.labelPrevious, n.labelPrevious),
    labelWeekNumber: Bn(Fb, t?.labelWeekNumber, n.labelWeekNumber),
    labelYearDropdown: Bn(Hb, t?.labelYearDropdown, n.labelYearDropdown),
    labelGrid: Bn(Zf, t?.labelGrid, n.labelGrid),
    labelGridcell: Bn(Ob, t?.labelGridcell, n.labelGridcell),
    labelNav: Bn(Vb, t?.labelNav, n.labelNav),
    labelWeekNumberHeader: Bn($b, t?.labelWeekNumberHeader, n.labelWeekNumberHeader),
    labelWeekday: Bn(Lb, t?.labelWeekday, n.labelWeekday)
  };
}
function Ck(t, e, n, o, r) {
  const { startOfMonth: i, startOfYear: s, endOfYear: l, eachMonthOfInterval: a, getMonth: c } = r;
  return a({
    start: s(t),
    end: l(t)
  }).map((f) => {
    const p = o.formatMonthDropdown(f, r), g = c(f), h = e && f < i(e) || n && f > i(n) || !1;
    return { value: g, label: p, disabled: h };
  });
}
function wk(t, e = {}, n = {}) {
  let o = { ...e?.[Je.Day] };
  return Object.entries(t).filter(([, r]) => r === !0).forEach(([r]) => {
    o = {
      ...o,
      ...n?.[r]
    };
  }), o;
}
function Sk(t, e, n, o) {
  const r = o ?? t.today(), i = n ? t.startOfBroadcastWeek(r, t) : e ? t.startOfISOWeek(r) : t.startOfWeek(r), s = [];
  for (let l = 0; l < 7; l++) {
    const a = t.addDays(i, l);
    s.push(a);
  }
  return s;
}
function Rk(t, e, n, o, r = !1) {
  if (!t || !e)
    return;
  const { startOfYear: i, endOfYear: s, eachYearOfInterval: l, getYear: a } = o, c = i(t), u = s(e), d = l({ start: c, end: u });
  return r && d.reverse(), d.map((f) => {
    const p = n.formatYearDropdown(f, o);
    return {
      value: a(f),
      label: p,
      disabled: !1
    };
  });
}
function Ek(t, e = {}) {
  const { weekStartsOn: n, locale: o } = e, r = n ?? o?.options?.weekStartsOn ?? 0, i = (l) => {
    const a = typeof l == "number" || typeof l == "string" ? new Date(l) : l;
    return new sn(a.getFullYear(), a.getMonth(), a.getDate(), 12, 0, 0, t);
  }, s = (l) => {
    const a = i(l);
    return new Date(a.getFullYear(), a.getMonth(), a.getDate(), 0, 0, 0, 0);
  };
  return {
    today: () => i(sn.tz(t)),
    newDate: (l, a, c) => new sn(l, a, c, 12, 0, 0, t),
    startOfDay: (l) => i(l),
    startOfWeek: (l, a) => {
      const c = i(l), u = a?.weekStartsOn ?? r, d = (c.getDay() - u + 7) % 7;
      return c.setDate(c.getDate() - d), c;
    },
    startOfISOWeek: (l) => {
      const a = i(l), c = (a.getDay() - 1 + 7) % 7;
      return a.setDate(a.getDate() - c), a;
    },
    startOfMonth: (l) => {
      const a = i(l);
      return a.setDate(1), a;
    },
    startOfYear: (l) => {
      const a = i(l);
      return a.setMonth(0, 1), a;
    },
    endOfWeek: (l, a) => {
      const c = i(l), f = (((a?.weekStartsOn ?? r) + 6) % 7 - c.getDay() + 7) % 7;
      return c.setDate(c.getDate() + f), c;
    },
    endOfISOWeek: (l) => {
      const a = i(l), c = (7 - a.getDay()) % 7;
      return a.setDate(a.getDate() + c), a;
    },
    endOfMonth: (l) => {
      const a = i(l);
      return a.setMonth(a.getMonth() + 1, 0), a;
    },
    endOfYear: (l) => {
      const a = i(l);
      return a.setMonth(11, 31), a;
    },
    eachMonthOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new sn(a.getFullYear(), a.getMonth(), 1, 12, 0, 0, t), f = c.getFullYear() * 12 + c.getMonth();
      for (; d.getFullYear() * 12 + d.getMonth() <= f; )
        u.push(new sn(d, t)), d.setMonth(d.getMonth() + 1, 1);
      return u;
    },
    // Normalize to noon once before arithmetic (avoid DST/midnight edge cases),
    // mutate the same TZDate, and return it.
    addDays: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a), c;
    },
    addWeeks: (l, a) => {
      const c = i(l);
      return c.setDate(c.getDate() + a * 7), c;
    },
    addMonths: (l, a) => {
      const c = i(l);
      return c.setMonth(c.getMonth() + a), c;
    },
    addYears: (l, a) => {
      const c = i(l);
      return c.setFullYear(c.getFullYear() + a), c;
    },
    eachYearOfInterval: (l) => {
      const a = i(l.start), c = i(l.end), u = [], d = new sn(a.getFullYear(), 0, 1, 12, 0, 0, t);
      for (; d.getFullYear() <= c.getFullYear(); )
        u.push(new sn(d, t)), d.setFullYear(d.getFullYear() + 1, 0, 1);
      return u;
    },
    getWeek: (l, a) => {
      const c = s(l);
      return Gf(c, {
        weekStartsOn: a?.weekStartsOn ?? r,
        firstWeekContainsDate: a?.firstWeekContainsDate ?? o?.options?.firstWeekContainsDate ?? 1
      });
    },
    getISOWeek: (l) => {
      const a = s(l);
      return Uf(a);
    },
    differenceInCalendarDays: (l, a) => {
      const c = s(l), u = s(a);
      return Wf(c, u);
    },
    differenceInCalendarMonths: (l, a) => {
      const c = s(l), u = s(a);
      return vb(c, u);
    }
  };
}
const Vs = (t) => t instanceof HTMLElement ? t : null, vc = (t) => [
  ...t.querySelectorAll("[data-animated-month]") ?? []
], Nk = (t) => Vs(t.querySelector("[data-animated-month]")), yc = (t) => Vs(t.querySelector("[data-animated-caption]")), xc = (t) => Vs(t.querySelector("[data-animated-weeks]")), kk = (t) => Vs(t.querySelector("[data-animated-nav]")), Mk = (t) => Vs(t.querySelector("[data-animated-weekdays]"));
function Ik(t, e, { classNames: n, months: o, focused: r, dateLib: i }) {
  const s = ft(null), l = ft(o), a = ft(!1);
  Io(() => {
    const c = l.current;
    if (l.current = o, !e || !t.current || // safety check because the ref can be set to anything by consumers
    !(t.current instanceof HTMLElement) || // validation required for the animation to work as expected
    o.length === 0 || c.length === 0 || o.length !== c.length)
      return;
    const u = i.isSameMonth(o[0].date, c[0].date), d = i.isAfter(o[0].date, c[0].date), f = d ? n[wn.caption_after_enter] : n[wn.caption_before_enter], p = d ? n[wn.weeks_after_enter] : n[wn.weeks_before_enter], g = s.current, h = t.current.cloneNode(!0);
    if (h instanceof HTMLElement ? (vc(h).forEach((y) => {
      if (!(y instanceof HTMLElement))
        return;
      const w = Nk(y);
      w && y.contains(w) && y.removeChild(w);
      const R = yc(y);
      R && R.classList.remove(f);
      const S = xc(y);
      S && S.classList.remove(p);
    }), s.current = h) : s.current = null, a.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    r)
      return;
    const b = g instanceof HTMLElement ? vc(g) : [], v = vc(t.current);
    if (v?.every((C) => C instanceof HTMLElement) && b && b.every((C) => C instanceof HTMLElement)) {
      a.current = !0, t.current.style.isolation = "isolate";
      const C = kk(t.current);
      C && (C.style.zIndex = "1"), v.forEach((y, w) => {
        const R = b[w];
        if (!R)
          return;
        y.style.position = "relative", y.style.overflow = "hidden";
        const S = yc(y);
        S && S.classList.add(f);
        const E = xc(y);
        E && E.classList.add(p);
        const N = () => {
          a.current = !1, t.current && (t.current.style.isolation = ""), C && (C.style.zIndex = ""), S && S.classList.remove(f), E && E.classList.remove(p), y.style.position = "", y.style.overflow = "", y.contains(R) && y.removeChild(R);
        };
        R.style.pointerEvents = "none", R.style.position = "absolute", R.style.overflow = "hidden", R.setAttribute("aria-hidden", "true");
        const T = Mk(R);
        T && (T.style.opacity = "0");
        const P = yc(R);
        P && (P.classList.add(d ? n[wn.caption_before_exit] : n[wn.caption_after_exit]), P.addEventListener("animationend", N));
        const I = xc(R);
        I && I.classList.add(d ? n[wn.weeks_before_exit] : n[wn.weeks_after_exit]), y.insertBefore(R, y.firstChild);
      });
    }
  });
}
function Pk(t, e, n, o) {
  const r = t[0], i = t[t.length - 1], { ISOWeek: s, fixedWeeks: l, broadcastCalendar: a } = n ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: p, endOfMonth: g, endOfWeek: h, isAfter: b, startOfBroadcastWeek: v, startOfISOWeek: C, startOfWeek: y } = o, w = a ? v(r, o) : s ? C(r) : y(r), R = a ? f(i) : s ? p(g(i)) : h(g(i)), S = e && (a ? f(e) : s ? p(e) : h(e)), E = S && b(R, S) ? S : R, N = u(E, w), T = d(i, r) + 1, P = [];
  for (let M = 0; M <= N; M++) {
    const D = c(w, M);
    P.push(D);
  }
  const k = (a ? 35 : 42) * T;
  if (l && P.length < k) {
    const M = k - P.length;
    for (let D = 0; D < M; D++) {
      const O = c(P[P.length - 1], 1);
      P.push(O);
    }
  }
  return P;
}
function Tk(t) {
  const e = [];
  return t.reduce((n, o) => {
    const r = o.weeks.reduce((i, s) => i.concat(s.days.slice()), e.slice());
    return n.concat(r.slice());
  }, e.slice());
}
function Ok(t, e, n, o) {
  const { numberOfMonths: r = 1 } = n, i = [];
  for (let s = 0; s < r; s++) {
    const l = o.addMonths(t, s);
    if (e && l > e)
      break;
    i.push(l);
  }
  return i;
}
function Dg(t, e, n, o) {
  const { month: r, defaultMonth: i, today: s = o.today(), numberOfMonths: l = 1 } = t;
  let a = r || i || s;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = o;
  if (n && c(n, a) < l - 1) {
    const f = -1 * (l - 1);
    a = u(n, f);
  }
  return e && c(a, e) < 0 && (a = e), d(a);
}
function Dk(t, e, n, o) {
  const { addDays: r, endOfBroadcastWeek: i, endOfISOWeek: s, endOfMonth: l, endOfWeek: a, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: p } = o, g = t.reduce((h, b) => {
    const v = n.broadcastCalendar ? d(b, o) : n.ISOWeek ? f(b) : p(b), C = n.broadcastCalendar ? i(b) : n.ISOWeek ? s(l(b)) : a(l(b)), y = e.filter((E) => E >= v && E <= C), w = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && y.length < w) {
      const E = e.filter((N) => {
        const T = w - y.length;
        return N > C && N <= r(C, T);
      });
      y.push(...E);
    }
    const R = y.reduce((E, N) => {
      const T = n.ISOWeek ? c(N) : u(N), P = E.find((k) => k.weekNumber === T), I = new Nb(N, b, o);
      return P ? P.days.push(I) : E.push(new MN(T, [I])), E;
    }, []), S = new kN(b, R);
    return h.push(S), h;
  }, []);
  return n.reverseMonths ? g.reverse() : g;
}
function Vk(t, e) {
  let { startMonth: n, endMonth: o } = t;
  const { startOfYear: r, startOfDay: i, startOfMonth: s, endOfMonth: l, addYears: a, endOfYear: c, newDate: u, today: d } = e, { fromYear: f, toYear: p, fromMonth: g, toMonth: h } = t;
  !n && g && (n = g), !n && f && (n = e.newDate(f, 0, 1)), !o && h && (o = h), !o && p && (o = u(p, 11, 31));
  const b = t.captionLayout === "dropdown" || t.captionLayout === "dropdown-years";
  return n ? n = s(n) : f ? n = u(f, 0, 1) : !n && b && (n = r(a(t.today ?? d(), -100))), o ? o = l(o) : p ? o = u(p, 11, 31) : !o && b && (o = c(t.today ?? d())), [
    n && i(n),
    o && i(o)
  ];
}
function _k(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i = 1 } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i : 1, u = s(t);
  if (!e)
    return l(u, c);
  if (!(a(e, t) < i))
    return l(u, c);
}
function Ak(t, e, n, o) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: r, numberOfMonths: i } = n, { startOfMonth: s, addMonths: l, differenceInCalendarMonths: a } = o, c = r ? i ?? 1 : 1, u = s(t);
  if (!e)
    return l(u, -c);
  if (!(a(u, e) <= 0))
    return l(u, -c);
}
function Lk(t) {
  const e = [];
  return t.reduce((n, o) => n.concat(o.weeks.slice()), e.slice());
}
function Ma(t, e) {
  const [n, o] = ot(t);
  return [e === void 0 ? n : e, o];
}
function Fk(t, e) {
  const [n, o] = Vk(t, e), { startOfMonth: r, endOfMonth: i } = e, s = Dg(t, n, o, e), [l, a] = Ma(
    s,
    // initialMonth is always computed from props.month if provided
    t.month ? s : void 0
  );
  kt(() => {
    const w = Dg(t, n, o, e);
    a(w);
  }, [t.timeZone]);
  const { months: c, weeks: u, days: d, previousMonth: f, nextMonth: p } = hl(() => {
    const w = Ok(l, o, { numberOfMonths: t.numberOfMonths }, e), R = Pk(w, t.endMonth ? i(t.endMonth) : void 0, {
      ISOWeek: t.ISOWeek,
      fixedWeeks: t.fixedWeeks,
      broadcastCalendar: t.broadcastCalendar
    }, e), S = Dk(w, R, {
      broadcastCalendar: t.broadcastCalendar,
      fixedWeeks: t.fixedWeeks,
      ISOWeek: t.ISOWeek,
      reverseMonths: t.reverseMonths
    }, e), E = Lk(S), N = Tk(S), T = Ak(l, n, t, e), P = _k(l, o, t, e);
    return {
      months: S,
      weeks: E,
      days: N,
      previousMonth: T,
      nextMonth: P
    };
  }, [
    e,
    l.getTime(),
    o?.getTime(),
    n?.getTime(),
    t.disableNavigation,
    t.broadcastCalendar,
    t.endMonth?.getTime(),
    t.fixedWeeks,
    t.ISOWeek,
    t.numberOfMonths,
    t.pagedNavigation,
    t.reverseMonths
  ]), { disableNavigation: g, onMonthChange: h } = t, b = (w) => u.some((R) => R.days.some((S) => S.isEqualTo(w))), v = (w) => {
    if (g)
      return;
    let R = r(w);
    n && R < r(n) && (R = r(n)), o && R > r(o) && (R = r(o)), a(R), h?.(R);
  };
  return {
    months: c,
    weeks: u,
    days: d,
    navStart: n,
    navEnd: o,
    previousMonth: f,
    nextMonth: p,
    goToMonth: v,
    goToDay: (w) => {
      b(w) || v(w.date);
    }
  };
}
var so;
(function(t) {
  t[t.Today = 0] = "Today", t[t.Selected = 1] = "Selected", t[t.LastFocused = 2] = "LastFocused", t[t.FocusedModifier = 3] = "FocusedModifier";
})(so || (so = {}));
function Vg(t) {
  return !t[Dt.disabled] && !t[Dt.hidden] && !t[Dt.outside];
}
function $k(t, e, n, o) {
  let r, i = -1;
  for (const s of t) {
    const l = e(s);
    Vg(l) && (l[Dt.focused] && i < so.FocusedModifier ? (r = s, i = so.FocusedModifier) : o?.isEqualTo(s) && i < so.LastFocused ? (r = s, i = so.LastFocused) : n(s.date) && i < so.Selected ? (r = s, i = so.Selected) : l[Dt.today] && i < so.Today && (r = s, i = so.Today));
  }
  return r || (r = t.find((s) => Vg(e(s)))), r;
}
function Hk(t, e, n, o, r, i, s) {
  const { ISOWeek: l, broadcastCalendar: a } = i, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: p, endOfISOWeek: g, endOfWeek: h, max: b, min: v, startOfBroadcastWeek: C, startOfISOWeek: y, startOfWeek: w } = s;
  let S = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (E) => a ? C(E, s) : l ? y(E) : w(E),
    endOfWeek: (E) => a ? p(E) : l ? g(E) : h(E)
  }[t](n, e === "after" ? 1 : -1);
  return e === "before" && o ? S = b([o, S]) : e === "after" && r && (S = v([r, S])), S;
}
function zb(t, e, n, o, r, i, s, l = 0) {
  if (l > 365)
    return;
  const a = Hk(t, e, n.date, o, r, i, s), c = !!(i.disabled && Eo(a, i.disabled, s)), u = !!(i.hidden && Eo(a, i.hidden, s)), d = a, f = new Nb(a, d, s);
  return !c && !u ? f : zb(t, e, f, o, r, i, s, l + 1);
}
function zk(t, e, n, o, r) {
  const { autoFocus: i } = t, [s, l] = ot(), a = $k(e.days, n, o || (() => !1), s), [c, u] = ot(i ? a : void 0);
  return {
    isFocusTarget: (h) => !!a?.isEqualTo(h),
    setFocused: u,
    focused: c,
    blur: () => {
      l(c), u(void 0);
    },
    moveFocus: (h, b) => {
      if (!c)
        return;
      const v = zb(h, b, c, e.navStart, e.navEnd, t, r);
      v && (t.disableNavigation && !e.days.some((y) => y.isEqualTo(v)) || (e.goToDay(v), u(v)));
    }
  };
}
function Bk(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = Ma(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e, c = (p) => l?.some((g) => a(g, p)) ?? !1, { min: u, max: d } = t;
  return {
    selected: l,
    select: (p, g, h) => {
      let b = [...l ?? []];
      if (c(p)) {
        if (l?.length === u || o && l?.length === 1)
          return;
        b = l?.filter((v) => !a(v, p));
      } else
        l?.length === d ? b = [p] : b = [...b, p];
      return r || s(b), r?.(b, p, g, h), b;
    },
    isSelected: c
  };
}
function Wk(t, e, n = 0, o = 0, r = !1, i = vo) {
  const { from: s, to: l } = e || {}, { isSameDay: a, isAfter: c, isBefore: u } = i;
  let d;
  if (!s && !l)
    d = { from: t, to: n > 0 ? void 0 : t };
  else if (s && !l)
    a(s, t) ? n === 0 ? d = { from: s, to: t } : r ? d = { from: s, to: void 0 } : d = void 0 : u(t, s) ? d = { from: t, to: s } : d = { from: s, to: t };
  else if (s && l)
    if (a(s, t) && a(l, t))
      r ? d = { from: s, to: l } : d = void 0;
    else if (a(s, t))
      d = { from: s, to: n > 0 ? void 0 : t };
    else if (a(l, t))
      d = { from: t, to: n > 0 ? void 0 : t };
    else if (u(t, s))
      d = { from: t, to: l };
    else if (c(t, s))
      d = { from: s, to: t };
    else if (c(t, l))
      d = { from: s, to: t };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const f = i.differenceInCalendarDays(d.to, d.from);
    o > 0 && f > o ? d = { from: t, to: void 0 } : n > 1 && f < n && (d = { from: t, to: void 0 });
  }
  return d;
}
function Uk(t, e, n = vo) {
  const o = Array.isArray(e) ? e : [e];
  let r = t.from;
  const i = n.differenceInCalendarDays(t.to, t.from), s = Math.min(i, 6);
  for (let l = 0; l <= s; l++) {
    if (o.includes(r.getDay()))
      return !0;
    r = n.addDays(r, 1);
  }
  return !1;
}
function _g(t, e, n = vo) {
  return Ro(t, e.from, !1, n) || Ro(t, e.to, !1, n) || Ro(e, t.from, !1, n) || Ro(e, t.to, !1, n);
}
function Gk(t, e, n = vo) {
  const o = Array.isArray(e) ? e : [e];
  if (o.filter((l) => typeof l != "function").some((l) => typeof l == "boolean" ? l : n.isDate(l) ? Ro(t, l, !1, n) : Ib(l, n) ? l.some((a) => Ro(t, a, !1, n)) : ka(l) ? l.from && l.to ? _g(t, { from: l.from, to: l.to }, n) : !1 : Mb(l) ? Uk(t, l.dayOfWeek, n) : Yf(l) ? n.isAfter(l.before, l.after) ? _g(t, {
    from: n.addDays(l.after, 1),
    to: n.addDays(l.before, -1)
  }, n) : Eo(t.from, l, n) || Eo(t.to, l, n) : jf(l) || Kf(l) ? Eo(t.from, l, n) || Eo(t.to, l, n) : !1))
    return !0;
  const s = o.filter((l) => typeof l == "function");
  if (s.length) {
    let l = t.from;
    const a = n.differenceInCalendarDays(t.to, t.from);
    for (let c = 0; c <= a; c++) {
      if (s.some((u) => u(l)))
        return !0;
      l = n.addDays(l, 1);
    }
  }
  return !1;
}
function Yk(t, e) {
  const { disabled: n, excludeDisabled: o, resetOnSelect: r, selected: i, required: s, onSelect: l } = t, [a, c] = Ma(i, l ? i : void 0), u = l ? i : a;
  return {
    selected: u,
    select: (p, g, h) => {
      const { min: b, max: v } = t;
      let C;
      if (p) {
        const y = u?.from, w = u?.to, R = !!y && !!w, S = !!y && !!w && e.isSameDay(y, w) && e.isSameDay(p, y);
        r && (R || !u?.from) ? !s && S ? C = void 0 : C = { from: p, to: void 0 } : C = Wk(p, u, b, v, s, e);
      }
      return o && n && C?.from && C.to && Gk({ from: C.from, to: C.to }, n, e) && (C.from = p, C.to = void 0), l || c(C), l?.(C, p, g, h), C;
    },
    isSelected: (p) => u && Ro(u, p, !1, e)
  };
}
function jk(t, e) {
  const { selected: n, required: o, onSelect: r } = t, [i, s] = Ma(n, r ? n : void 0), l = r ? n : i, { isSameDay: a } = e;
  return {
    selected: l,
    select: (d, f, p) => {
      let g = d;
      return !o && l && l && a(d, l) && (g = void 0), r || s(g), r?.(g, d, f, p), g;
    },
    isSelected: (d) => l ? a(l, d) : !1
  };
}
function Kk(t, e) {
  const n = jk(t, e), o = Bk(t, e), r = Yk(t, e);
  switch (t.mode) {
    case "single":
      return n;
    case "multiple":
      return o;
    case "range":
      return r;
    default:
      return;
  }
}
function Pn(t, e) {
  return t instanceof sn && t.timeZone === e ? t : new sn(t, e);
}
function Dr(t, e, n) {
  return Pn(t, e);
}
function Ag(t, e, n) {
  return typeof t == "boolean" || typeof t == "function" ? t : t instanceof Date ? Dr(t, e) : Array.isArray(t) ? t.map((o) => o instanceof Date ? Dr(o, e) : o) : ka(t) ? {
    ...t,
    from: t.from ? Pn(t.from, e) : t.from,
    to: t.to ? Pn(t.to, e) : t.to
  } : Yf(t) ? {
    before: Dr(t.before, e),
    after: Dr(t.after, e)
  } : jf(t) ? {
    after: Dr(t.after, e)
  } : Kf(t) ? {
    before: Dr(t.before, e)
  } : t;
}
function Cc(t, e, n) {
  return t && (Array.isArray(t) ? t.map((o) => Ag(o, e)) : Ag(t, e));
}
function qk(t) {
  let e = t;
  const n = e.timeZone;
  if (n && (e = {
    ...t,
    timeZone: n
  }, e.today && (e.today = Pn(e.today, n)), e.month && (e.month = Pn(e.month, n)), e.defaultMonth && (e.defaultMonth = Pn(e.defaultMonth, n)), e.startMonth && (e.startMonth = Pn(e.startMonth, n)), e.endMonth && (e.endMonth = Pn(e.endMonth, n)), e.mode === "single" && e.selected ? e.selected = Pn(e.selected, n) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((ye) => Pn(ye, n)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? Pn(e.selected.from, n) : e.selected.from,
    to: e.selected.to ? Pn(e.selected.to, n) : e.selected.to
  }), e.disabled !== void 0 && (e.disabled = Cc(e.disabled, n)), e.hidden !== void 0 && (e.hidden = Cc(e.hidden, n)), e.modifiers)) {
    const ye = {};
    Object.keys(e.modifiers).forEach((Oe) => {
      ye[Oe] = Cc(e.modifiers?.[Oe], n);
    }), e.modifiers = ye;
  }
  const { components: o, formatters: r, labels: i, dateLib: s, locale: l, classNames: a } = hl(() => {
    const ye = { ...Eb, ...e.locale }, Oe = e.broadcastCalendar ? 1 : e.weekStartsOn, Ie = e.noonSafe && e.timeZone ? Ek(e.timeZone, {
      weekStartsOn: Oe,
      locale: ye
    }) : void 0, Le = e.dateLib && Ie ? { ...Ie, ...e.dateLib } : e.dateLib ?? Ie, Be = new Rn({
      locale: ye,
      weekStartsOn: Oe,
      firstWeekContainsDate: e.firstWeekContainsDate,
      useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
      useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
      timeZone: e.timeZone,
      numerals: e.numerals
    }, Le);
    return {
      dateLib: Be,
      components: rk(e.components),
      formatters: mk(e.formatters),
      labels: xk(e.labels, Be.options),
      locale: ye,
      classNames: { ...sk(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.noonSafe,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]);
  e.today || (e = { ...e, today: s.today() });
  const { captionLayout: c, mode: u, navLayout: d, numberOfMonths: f = 1, onDayBlur: p, onDayClick: g, onDayFocus: h, onDayKeyDown: b, onDayMouseEnter: v, onDayMouseLeave: C, onNextClick: y, onPrevClick: w, showWeekNumber: R, styles: S } = e, { formatCaption: E, formatDay: N, formatMonthDropdown: T, formatWeekNumber: P, formatWeekNumberHeader: I, formatWeekdayName: k, formatYearDropdown: M } = r, D = Fk(e, s), { days: O, months: V, navStart: _, navEnd: A, previousMonth: L, nextMonth: B, goToMonth: G } = D, U = nk(O, e, _, A, s), { isSelected: Y, select: K, selected: j } = Kk(e, s) ?? {}, { blur: Z, focused: te, isFocusTarget: W, moveFocus: X, setFocused: ee } = zk(e, D, U, Y ?? (() => !1), s), { labelDayButton: le, labelGridcell: J, labelGrid: ie, labelMonthDropdown: pe, labelNav: oe, labelPrevious: re, labelNext: de, labelWeekday: xe, labelWeekNumber: se, labelWeekNumberHeader: fe, labelYearDropdown: $ } = i, Q = hl(() => Sk(s, e.ISOWeek, e.broadcastCalendar, e.today), [s, e.ISOWeek, e.broadcastCalendar, e.today]), H = u !== void 0 || g !== void 0, q = In(() => {
    L && (G(L), w?.(L));
  }, [L, G, w]), ae = In(() => {
    B && (G(B), y?.(B));
  }, [G, B, y]), ge = In((ye, Oe) => (Ie) => {
    Ie.preventDefault(), Ie.stopPropagation(), ee(ye), !Oe.disabled && (K?.(ye.date, Oe, Ie), g?.(ye.date, Oe, Ie));
  }, [K, g, ee]), ue = In((ye, Oe) => (Ie) => {
    ee(ye), h?.(ye.date, Oe, Ie);
  }, [h, ee]), Re = In((ye, Oe) => (Ie) => {
    Z(), p?.(ye.date, Oe, Ie);
  }, [Z, p]), be = In((ye, Oe) => (Ie) => {
    const Le = {
      ArrowLeft: [
        Ie.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        Ie.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [Ie.shiftKey ? "year" : "week", "after"],
      ArrowUp: [Ie.shiftKey ? "year" : "week", "before"],
      PageUp: [Ie.shiftKey ? "year" : "month", "before"],
      PageDown: [Ie.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (Le[Ie.key]) {
      Ie.preventDefault(), Ie.stopPropagation();
      const [Be, Te] = Le[Ie.key];
      X(Be, Te);
    }
    b?.(ye.date, Oe, Ie);
  }, [X, b, e.dir]), ve = In((ye, Oe) => (Ie) => {
    v?.(ye.date, Oe, Ie);
  }, [v]), me = In((ye, Oe) => (Ie) => {
    C?.(ye.date, Oe, Ie);
  }, [C]), Ee = In((ye) => (Oe) => {
    const Ie = Number(Oe.target.value), Le = s.setMonth(s.startOfMonth(ye), Ie);
    G(Le);
  }, [s, G]), Pe = In((ye) => (Oe) => {
    const Ie = Number(Oe.target.value), Le = s.setYear(s.startOfMonth(ye), Ie);
    G(Le);
  }, [s, G]), { className: Me, style: _e } = hl(() => ({
    className: [a[Je.Root], e.className].filter(Boolean).join(" "),
    style: { ...S?.[Je.Root], ...e.style }
  }), [a, e.className, e.style, S]), Ue = ik(e), Ye = ft(null);
  Ik(Ye, !!e.animate, {
    classNames: a,
    months: V,
    focused: te,
    dateLib: s
  });
  const He = {
    dayPickerProps: e,
    selected: j,
    select: K,
    isSelected: Y,
    months: V,
    nextMonth: B,
    previousMonth: L,
    goToMonth: G,
    getModifiers: U,
    components: o,
    classNames: a,
    styles: S,
    labels: i,
    formatters: r
  };
  return We.createElement(
    kb.Provider,
    { value: He },
    We.createElement(
      o.Root,
      { rootRef: e.animate ? Ye : void 0, className: Me, style: _e, dir: e.dir, id: e.id, lang: e.lang ?? l.code, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...Ue },
      We.createElement(
        o.Months,
        { className: a[Je.Months], style: S?.[Je.Months] },
        !e.hideNavigation && !d && We.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[Je.Nav], style: S?.[Je.Nav], "aria-label": oe(), onPreviousClick: q, onNextClick: ae, previousMonth: L, nextMonth: B }),
        V.map((ye, Oe) => We.createElement(
          o.Month,
          {
            "data-animated-month": e.animate ? "true" : void 0,
            className: a[Je.Month],
            style: S?.[Je.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Oe,
            displayIndex: Oe,
            calendarMonth: ye
          },
          d === "around" && !e.hideNavigation && Oe === 0 && We.createElement(
            o.PreviousMonthButton,
            { type: "button", className: a[Je.PreviousMonthButton], tabIndex: L ? void 0 : -1, "aria-disabled": L ? void 0 : !0, "aria-label": re(L), onClick: q, "data-animated-button": e.animate ? "true" : void 0 },
            We.createElement(o.Chevron, { disabled: L ? void 0 : !0, className: a[Je.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
          ),
          We.createElement(o.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: a[Je.MonthCaption], style: S?.[Je.MonthCaption], calendarMonth: ye, displayIndex: Oe }, c?.startsWith("dropdown") ? We.createElement(
            o.DropdownNav,
            { className: a[Je.Dropdowns], style: S?.[Je.Dropdowns] },
            (() => {
              const Ie = c === "dropdown" || c === "dropdown-months" ? We.createElement(o.MonthsDropdown, { key: "month", className: a[Je.MonthsDropdown], "aria-label": pe(), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Ee(ye.date), options: Ck(ye.date, _, A, r, s), style: S?.[Je.Dropdown], value: s.getMonth(ye.date) }) : We.createElement("span", { key: "month" }, T(ye.date, s)), Le = c === "dropdown" || c === "dropdown-years" ? We.createElement(o.YearsDropdown, { key: "year", className: a[Je.YearsDropdown], "aria-label": $(s.options), classNames: a, components: o, disabled: !!e.disableNavigation, onChange: Pe(ye.date), options: Rk(_, A, r, s, !!e.reverseYears), style: S?.[Je.Dropdown], value: s.getYear(ye.date) }) : We.createElement("span", { key: "year" }, M(ye.date, s));
              return s.getMonthYearOrder() === "year-first" ? [Le, Ie] : [Ie, Le];
            })(),
            We.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, E(ye.date, s.options, s))
          ) : We.createElement(o.CaptionLabel, { className: a[Je.CaptionLabel], role: "status", "aria-live": "polite" }, E(ye.date, s.options, s))),
          d === "around" && !e.hideNavigation && Oe === f - 1 && We.createElement(
            o.NextMonthButton,
            { type: "button", className: a[Je.NextMonthButton], tabIndex: B ? void 0 : -1, "aria-disabled": B ? void 0 : !0, "aria-label": de(B), onClick: ae, "data-animated-button": e.animate ? "true" : void 0 },
            We.createElement(o.Chevron, { disabled: B ? void 0 : !0, className: a[Je.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
          ),
          Oe === f - 1 && d === "after" && !e.hideNavigation && We.createElement(o.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[Je.Nav], style: S?.[Je.Nav], "aria-label": oe(), onPreviousClick: q, onNextClick: ae, previousMonth: L, nextMonth: B }),
          We.createElement(
            o.MonthGrid,
            { role: "grid", "aria-multiselectable": u === "multiple" || u === "range", "aria-label": ie(ye.date, s.options, s) || void 0, className: a[Je.MonthGrid], style: S?.[Je.MonthGrid] },
            !e.hideWeekdays && We.createElement(
              o.Weekdays,
              { "data-animated-weekdays": e.animate ? "true" : void 0, className: a[Je.Weekdays], style: S?.[Je.Weekdays] },
              R && We.createElement(o.WeekNumberHeader, { "aria-label": fe(s.options), className: a[Je.WeekNumberHeader], style: S?.[Je.WeekNumberHeader], scope: "col" }, I()),
              Q.map((Ie) => We.createElement(o.Weekday, { "aria-label": xe(Ie, s.options, s), className: a[Je.Weekday], key: String(Ie), style: S?.[Je.Weekday], scope: "col" }, k(Ie, s.options, s)))
            ),
            We.createElement(o.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: a[Je.Weeks], style: S?.[Je.Weeks] }, ye.weeks.map((Ie) => We.createElement(
              o.Week,
              { className: a[Je.Week], key: Ie.weekNumber, style: S?.[Je.Week], week: Ie },
              R && We.createElement(o.WeekNumber, { week: Ie, style: S?.[Je.WeekNumber], "aria-label": se(Ie.weekNumber, {
                locale: l
              }), className: a[Je.WeekNumber], scope: "row", role: "rowheader" }, P(Ie.weekNumber, s)),
              Ie.days.map((Le) => {
                const { date: Be } = Le, Te = U(Le);
                if (Te[Dt.focused] = !Te.hidden && !!te?.isEqualTo(Le), Te[Gn.selected] = Y?.(Be) || Te.selected, ka(j)) {
                  const { from: Ne, to: Ae } = j;
                  Te[Gn.range_start] = !!(Ne && Ae && s.isSameDay(Be, Ne)), Te[Gn.range_end] = !!(Ne && Ae && s.isSameDay(Be, Ae)), Te[Gn.range_middle] = Ro(j, Be, !0, s);
                }
                const vt = wk(Te, S, e.modifiersStyles), nt = ok(Te, a, e.modifiersClassNames), we = !H && !Te.hidden ? J(Be, Te, s.options, s) : void 0;
                return We.createElement(o.Day, { key: `${Le.isoDate}_${Le.displayMonthId}`, day: Le, modifiers: Te, className: nt.join(" "), style: vt, role: "gridcell", "aria-selected": Te.selected || void 0, "aria-label": we, "data-day": Le.isoDate, "data-month": Le.outside ? Le.dateMonthId : void 0, "data-selected": Te.selected || void 0, "data-disabled": Te.disabled || void 0, "data-hidden": Te.hidden || void 0, "data-outside": Le.outside || void 0, "data-focused": Te.focused || void 0, "data-today": Te.today || void 0 }, !Te.hidden && H ? We.createElement(o.DayButton, { className: a[Je.DayButton], style: S?.[Je.DayButton], type: "button", day: Le, modifiers: Te, disabled: !Te.focused && Te.disabled || void 0, "aria-disabled": Te.focused && Te.disabled || void 0, tabIndex: W(Le) ? 0 : -1, "aria-label": le(Be, Te, s.options, s), onClick: ge(Le, Te), onBlur: Re(Le, Te), onFocus: ue(Le, Te), onKeyDown: be(Le, Te), onMouseEnter: ve(Le, Te), onMouseLeave: me(Le, Te) }, N(Be, s.options, s)) : !Te.hidden && N(Le.date, s.options, s));
              })
            )))
          )
        ))
      ),
      e.footer && We.createElement(o.Footer, { className: a[Je.Footer], style: S?.[Je.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function Zk(t) {
  const e = z.c(18), {
    children: n,
    positionerClassName: o,
    popupClassName: r,
    listClassName: i
  } = t, s = qt();
  let l;
  e[0] !== o ? (l = ne("z-[var(--z-layer-popover)]", o), e[0] = o, e[1] = l) : l = e[1];
  let a;
  e[2] !== r ? (a = ws({
    size: "auto",
    className: r
  }), e[2] = r, e[3] = a) : a = e[3];
  let c;
  e[4] !== i ? (c = ne("flex flex-col", i), e[4] = i, e[5] = c) : c = e[5];
  let u;
  e[6] !== n || e[7] !== c ? (u = /* @__PURE__ */ m(lb, { className: c, children: n }), e[6] = n, e[7] = c, e[8] = u) : u = e[8];
  let d;
  e[9] !== a || e[10] !== u ? (d = /* @__PURE__ */ m(sb, { className: a, children: u }), e[9] = a, e[10] = u, e[11] = d) : d = e[11];
  let f;
  e[12] !== l || e[13] !== d ? (f = /* @__PURE__ */ m(rb, { sideOffset: 4, alignItemWithTrigger: !1, className: l, children: d }), e[12] = l, e[13] = d, e[14] = f) : f = e[14];
  let p;
  return e[15] !== s || e[16] !== f ? (p = /* @__PURE__ */ m(tb, { container: s, children: f }), e[15] = s, e[16] = f, e[17] = p) : p = e[17], p;
}
function Xk(t) {
  const e = z.c(11), {
    value: n,
    disabled: o,
    icon: r,
    children: i
  } = t;
  let s;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = Ko({}), e[0] = s) : s = e[0];
  let l;
  e[1] !== r ? (l = r && /* @__PURE__ */ m("span", { className: "shrink-0 text-menu-icon-default inline-flex", children: /* @__PURE__ */ m(Ke, { name: r, size: "xs", tone: "inherit" }) }), e[1] = r, e[2] = l) : l = e[2];
  let a;
  e[3] !== i ? (a = /* @__PURE__ */ m(db, { className: "flex-1 min-w-0", children: i }), e[3] = i, e[4] = a) : a = e[4];
  let c;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m(cb, { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ m(Ke, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[5] = c) : c = e[5];
  let u;
  return e[6] !== o || e[7] !== l || e[8] !== a || e[9] !== n ? (u = /* @__PURE__ */ F(ab, { value: n, disabled: o, className: s, children: [
    l,
    a,
    c
  ] }), e[6] = o, e[7] = l, e[8] = a, e[9] = n, e[10] = u) : u = e[10], u;
}
function Qk(t) {
  const e = z.c(2), {
    size: n
  } = t, o = n === void 0 ? "xs" : n;
  let r;
  return e[0] !== o ? (r = /* @__PURE__ */ m("span", { className: "transition-transform duration-200 [[data-popup-open]_&]:rotate-180 inline-flex", children: /* @__PURE__ */ m(Ke, { name: "chevron-down", size: o, tone: "inherit" }) }), e[0] = o, e[1] = r) : r = e[1], r;
}
function Jk(t) {
  const e = z.c(26), {
    value: n,
    onChange: o,
    options: r,
    disabled: i,
    "aria-label": s
  } = t;
  let l;
  e[0] !== r || e[1] !== n ? (l = r?.find((R) => R.value === Number(n)), e[0] = r, e[1] = n, e[2] = l) : l = e[2];
  const a = l;
  let c;
  e[3] !== o ? (c = function(S) {
    S !== null && o?.({
      target: {
        value: String(S)
      },
      currentTarget: {
        value: String(S)
      }
    });
  }, e[3] = o, e[4] = c) : c = e[4];
  const u = c, d = a?.value ?? null;
  let f;
  e[5] !== r ? (f = r ?? [], e[5] = r, e[6] = f) : f = e[6];
  let p;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = ne("flex items-center gap-(--spacing-2)", "cursor-pointer rounded-(--radius-xs) outline-none", "focus-visible:ring-2 focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "data-[disabled]:cursor-not-allowed data-[disabled]:opacity-50"), e[7] = p) : p = e[7];
  const g = a?.label ?? "";
  let h;
  e[8] !== g ? (h = /* @__PURE__ */ m(Q0, { className: "text-(length:--font-size-title-md) font-(number:--font-weight-medium) leading-(--font-line-height-24) text-text-default select-none", children: g }), e[8] = g, e[9] = h) : h = e[9];
  let b;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (b = /* @__PURE__ */ m(J0, { className: "text-icon-main", children: /* @__PURE__ */ m(Qk, { size: "sm" }) }), e[10] = b) : b = e[10];
  let v;
  e[11] !== s || e[12] !== i || e[13] !== h ? (v = /* @__PURE__ */ F(X0, { disabled: i, "aria-label": s, className: p, children: [
    h,
    b
  ] }), e[11] = s, e[12] = i, e[13] = h, e[14] = v) : v = e[14];
  let C;
  e[15] !== r ? (C = r?.map(eM), e[15] = r, e[16] = C) : C = e[16];
  let y;
  e[17] !== C ? (y = /* @__PURE__ */ m(Zk, { listClassName: "max-h-[368px] overflow-y-auto", children: C }), e[17] = C, e[18] = y) : y = e[18];
  let w;
  return e[19] !== i || e[20] !== u || e[21] !== y || e[22] !== d || e[23] !== f || e[24] !== v ? (w = /* @__PURE__ */ F(YR, { value: d, onValueChange: u, disabled: i, items: f, children: [
    v,
    y
  ] }), e[19] = i, e[20] = u, e[21] = y, e[22] = d, e[23] = f, e[24] = v, e[25] = w) : w = e[25], w;
}
function eM(t) {
  return /* @__PURE__ */ m(Xk, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function tM(t) {
  const e = z.c(18), {
    children: n
  } = t, {
    goToMonth: o,
    nextMonth: r,
    previousMonth: i,
    dayPickerProps: s
  } = yi(), l = s.disabled === !0, a = l || !i;
  let c;
  e[0] !== o || e[1] !== i ? (c = () => i && o(i), e[0] = o, e[1] = i, e[2] = c) : c = e[2];
  let u;
  e[3] !== a || e[4] !== c ? (u = /* @__PURE__ */ m(mt, { icon: "chevron-left", variant: "ghost", size: "md", "aria-label": "Previous month", disabled: a, onClick: c }), e[3] = a, e[4] = c, e[5] = u) : u = e[5];
  let d;
  e[6] !== n ? (d = /* @__PURE__ */ m("div", { className: "flex items-center gap-[26px]", children: n }), e[6] = n, e[7] = d) : d = e[7];
  const f = l || !r;
  let p;
  e[8] !== o || e[9] !== r ? (p = () => r && o(r), e[8] = o, e[9] = r, e[10] = p) : p = e[10];
  let g;
  e[11] !== f || e[12] !== p ? (g = /* @__PURE__ */ m(mt, { icon: "chevron-right", variant: "ghost", size: "md", "aria-label": "Next month", disabled: f, onClick: p }), e[11] = f, e[12] = p, e[13] = g) : g = e[13];
  let h;
  return e[14] !== u || e[15] !== d || e[16] !== g ? (h = /* @__PURE__ */ F("div", { className: "flex items-center justify-between pt-(--spacing-8) px-(--spacing-12)", children: [
    u,
    d,
    g
  ] }), e[14] = u, e[15] = d, e[16] = g, e[17] = h) : h = e[17], h;
}
function nM(t) {
  const e = z.c(12), {
    value: n,
    onValueChange: o,
    disabled: r
  } = t, i = r === void 0 ? !1 : r, s = n ?? void 0, l = n ?? void 0;
  let a;
  e[0] !== o ? (a = (h) => o(h ?? null), e[0] = o, e[1] = a) : a = e[1];
  let c, u;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = new Date(2e3, 0), u = new Date(2099, 11), e[2] = c, e[3] = u) : (c = e[2], u = e[3]);
  let d, f, p;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = {
    formatMonthDropdown: oM
  }, f = {
    root: "w-[328px] bg-surface rounded-(--radius-sm) shadow-elevation-3 flex flex-col gap-(--spacing-4)",
    months: "flex flex-col",
    month: "flex flex-col gap-(--spacing-4)",
    month_caption: "",
    nav: "hidden",
    dropdowns: "flex items-center gap-[26px]",
    dropdown_root: "",
    dropdown: "",
    caption_label: "",
    month_grid: "w-full border-collapse",
    weeks: "flex flex-col gap-(--spacing-8) px-(--spacing-2) pb-(--spacing-16)",
    week: "flex gap-[11px] items-center justify-center",
    weekdays: "flex gap-[11px] items-center justify-center px-(--spacing-2) pt-(--spacing-8) pb-(--spacing-12) border-t border-outline-subtle",
    weekday: "size-(--font-line-height-36) flex items-center justify-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) text-text-subtle",
    day: "size-(--font-line-height-36) flex items-center justify-center rounded-full text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-text-default cursor-pointer transition-colors duration-200 ease-in-out [&:not([data-selected])]:hover:bg-surface-hover [&:not([data-selected])]:active:bg-surface-pressed",
    day_button: "size-full flex items-center justify-center outline-none rounded-full focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring",
    selected: "bg-primary [&>button]:text-primary-on-primary",
    today: "font-(number:--font-weight-semibold)",
    outside: "text-text-subtle",
    disabled: "text-text-disabled pointer-events-none opacity-50",
    hidden: "invisible"
  }, p = {
    MonthCaption: tM,
    Dropdown: Jk
  }, e[4] = d, e[5] = f, e[6] = p) : (d = e[4], f = e[5], p = e[6]);
  let g;
  return e[7] !== i || e[8] !== s || e[9] !== l || e[10] !== a ? (g = /* @__PURE__ */ m(qk, { mode: "single", selected: s, defaultMonth: l, onSelect: a, disabled: i, captionLayout: "dropdown", startMonth: c, endMonth: u, showOutsideDays: !0, formatters: d, classNames: f, components: p }), e[7] = i, e[8] = s, e[9] = l, e[10] = a, e[11] = g) : g = e[11], g;
}
function oM(t) {
  return t.toLocaleString("en-US", {
    month: "short"
  });
}
const rM = /^(\d{2})\/(\d{2})\/(\d{4})$/;
function Lg(t) {
  const e = t.match(rM);
  if (!e) return null;
  const [, n, o, r] = e, i = new Date(Number(r), Number(n) - 1, Number(o));
  return i.getFullYear() !== Number(r) || i.getMonth() !== Number(n) - 1 || i.getDate() !== Number(o) ? null : i;
}
function wc(t) {
  const e = String(t.getMonth() + 1).padStart(2, "0"), n = String(t.getDate()).padStart(2, "0"), o = t.getFullYear();
  return `${e}/${n}/${o}`;
}
const iM = ce(["flex", "items-center", "justify-between", "gap-(--spacing-4)", "w-[176px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function fD(t) {
  const e = z.c(73), {
    value: n,
    onValueChange: o,
    label: r,
    size: i,
    required: s,
    description: l,
    tooltip: a,
    error: c,
    disabled: u
  } = t, d = i === void 0 ? "md" : i, f = u === void 0 ? !1 : u, p = qt(), [g, h] = ot(!1);
  let b;
  e[0] !== n ? (b = n ? wc(n) : "", e[0] = n, e[1] = b) : b = e[1];
  const [v, C] = ot(b), y = ft(null), w = ft(null), R = _t(), S = _t(), E = !!c;
  let N, T;
  e[2] !== n ? (N = () => {
    C((xe) => {
      const se = Lg(xe);
      return (n === null ? xe === "" : se !== null && se.getFullYear() === n.getFullYear() && se.getMonth() === n.getMonth() && se.getDate() === n.getDate()) ? xe : n ? wc(n) : "";
    });
  }, T = [n], e[2] = n, e[3] = N, e[4] = T) : (N = e[3], T = e[4]), kt(N, T);
  let P;
  e[5] !== o ? (P = function(se) {
    const fe = se.target.value;
    C(fe);
    const $ = Lg(fe);
    $ ? o($) : fe === "" && o(null);
  }, e[5] = o, e[6] = P) : P = e[6];
  const I = P;
  let k;
  e[7] !== o ? (k = function(se) {
    o(se), C(se ? wc(se) : ""), h(!1);
  }, e[7] = o, e[8] = k) : k = e[8];
  const M = k;
  let D;
  e[9] !== o ? (D = function() {
    o(null), C(""), h(!1), w.current?.focus();
  }, e[9] = o, e[10] = D) : D = e[10];
  const O = D, V = v, _ = f && "pointer-events-none";
  let A;
  e[11] !== _ ? (A = ne("flex flex-col w-fit", _), e[11] = _, e[12] = A) : A = e[12];
  let L;
  e[13] !== R || e[14] !== r || e[15] !== s || e[16] !== a ? (L = r && /* @__PURE__ */ m(gi, { htmlFor: R, label: r, required: s, tooltip: a }), e[13] = R, e[14] = r, e[15] = s, e[16] = a, e[17] = L) : L = e[17];
  let B;
  e[18] !== f || e[19] !== E || e[20] !== d ? (B = ne(iM({
    size: d,
    hasError: E
  }), f && "opacity-50"), e[18] = f, e[19] = E, e[20] = d, e[21] = B) : B = e[21];
  const G = s || void 0, U = E || void 0, Y = l || c ? S : void 0, K = E && "text-input-error-text";
  let j;
  e[22] !== K ? (j = ne("flex-1 min-w-0 outline-none bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-text-subtle", K), e[22] = K, e[23] = j) : j = e[23];
  let Z;
  e[24] !== f || e[25] !== V || e[26] !== I || e[27] !== R || e[28] !== s || e[29] !== G || e[30] !== U || e[31] !== Y || e[32] !== j ? (Z = /* @__PURE__ */ m("input", { id: R, ref: w, type: "text", value: V, onChange: I, placeholder: "MM/DD/YYYY", disabled: f, required: s, "aria-required": G, "aria-invalid": U, "aria-describedby": Y, className: j }), e[24] = f, e[25] = V, e[26] = I, e[27] = R, e[28] = s, e[29] = G, e[30] = U, e[31] = Y, e[32] = j, e[33] = Z) : Z = e[33];
  let te;
  e[34] !== f || e[35] !== O || e[36] !== n ? (te = n !== null && !f && /* @__PURE__ */ m("button", { type: "button", "aria-label": "Clear date", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", onMouseDown: sM, onClick: O, children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" }) }), e[34] = f, e[35] = O, e[36] = n, e[37] = te) : te = e[37];
  let W;
  e[38] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (W = /* @__PURE__ */ m(Ke, { name: "calendar", size: "xs", tone: "inherit" }), e[38] = W) : W = e[38];
  let X;
  e[39] !== f ? (X = /* @__PURE__ */ m(Sa, { render: /* @__PURE__ */ m("button", { type: "button", "aria-label": "Open calendar", disabled: f, className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-main hover:text-icon-main disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: W }) }), e[39] = f, e[40] = X) : X = e[40];
  let ee;
  e[41] !== te || e[42] !== X ? (ee = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    te,
    X
  ] }), e[41] = te, e[42] = X, e[43] = ee) : ee = e[43];
  let le;
  e[44] !== B || e[45] !== Z || e[46] !== ee ? (le = /* @__PURE__ */ F("div", { ref: y, className: B, children: [
    Z,
    ee
  ] }), e[44] = B, e[45] = Z, e[46] = ee, e[47] = le) : le = e[47];
  let J;
  e[48] !== f || e[49] !== M || e[50] !== n ? (J = /* @__PURE__ */ m(Ea, { anchor: y, side: "bottom", align: "start", sideOffset: 4, children: /* @__PURE__ */ m(Na, { children: /* @__PURE__ */ m(nM, { value: n, onValueChange: M, disabled: f }) }) }), e[48] = f, e[49] = M, e[50] = n, e[51] = J) : J = e[51];
  let ie;
  e[52] !== p || e[53] !== J ? (ie = /* @__PURE__ */ m(Ra, { container: p, children: J }), e[52] = p, e[53] = J, e[54] = ie) : ie = e[54];
  let pe;
  e[55] !== g || e[56] !== le || e[57] !== ie ? (pe = /* @__PURE__ */ F(_f, { open: g, onOpenChange: h, modal: !1, children: [
    le,
    ie
  ] }), e[55] = g, e[56] = le, e[57] = ie, e[58] = pe) : pe = e[58];
  let oe;
  e[59] !== l || e[60] !== S || e[61] !== c || e[62] !== E ? (oe = E ? /* @__PURE__ */ m(Pr, { match: !0, id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: c }) : l ? /* @__PURE__ */ m(fi, { id: S, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: l }) : null, e[59] = l, e[60] = S, e[61] = c, e[62] = E, e[63] = oe) : oe = e[63];
  let re;
  e[64] !== oe ? (re = /* @__PURE__ */ m("div", { "data-testid": "date-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: oe }), e[64] = oe, e[65] = re) : re = e[65];
  let de;
  return e[66] !== f || e[67] !== E || e[68] !== A || e[69] !== L || e[70] !== pe || e[71] !== re ? (de = /* @__PURE__ */ F(Ir, { invalid: E, disabled: f, className: A, children: [
    L,
    pe,
    re
  ] }), e[66] = f, e[67] = E, e[68] = A, e[69] = L, e[70] = pe, e[71] = re, e[72] = de) : de = e[72], de;
}
function sM(t) {
  return t.preventDefault();
}
const ul = 8, Fg = 20, lM = 16, aM = 20;
function Bb(t) {
  return {
    offsetX: t ? t.offsetLeft : lM,
    offsetY: t ? t.offsetTop : aM,
    width: t?.offsetWidth || Fg,
    height: t?.offsetHeight || Fg
  };
}
function cM(t, e) {
  const n = -e.offsetX, o = -e.offsetY, r = window.innerWidth - e.offsetX - e.width, i = window.innerHeight - e.offsetY - e.height;
  return {
    x: Math.max(n, Math.min(t.x, r)),
    y: Math.max(o, Math.min(t.y, i))
  };
}
function uM(t) {
  const e = z.c(24), {
    dragHandleRef: n,
    position: o,
    onPositionChange: r,
    disabled: i
  } = t, s = i === void 0 ? !1 : i, l = x.useRef(!1), [a, c] = x.useState(!1);
  let u;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = {
    pointerX: 0,
    pointerY: 0,
    elementX: 0,
    elementY: 0
  }, e[0] = u) : u = e[0];
  const d = x.useRef(u);
  let f;
  e[1] !== n ? (f = (I) => cM(I, Bb(n.current)), e[1] = n, e[2] = f) : f = e[2];
  const p = f;
  let g;
  e[3] !== s || e[4] !== o ? (g = (I) => {
    s || I.pointerType === "mouse" && I.button !== 0 || (I.currentTarget.setPointerCapture?.(I.pointerId), l.current = !0, c(!0), d.current = {
      pointerX: I.clientX,
      pointerY: I.clientY,
      elementX: o.x,
      elementY: o.y
    });
  }, e[3] = s, e[4] = o, e[5] = g) : g = e[5];
  const h = g;
  let b;
  e[6] !== p || e[7] !== r ? (b = (I) => {
    if (!l.current)
      return;
    const k = I.clientX - d.current.pointerX, M = I.clientY - d.current.pointerY;
    r(p({
      x: d.current.elementX + k,
      y: d.current.elementY + M
    }));
  }, e[6] = p, e[7] = r, e[8] = b) : b = e[8];
  const v = b;
  let C;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = () => l.current ? (l.current = !1, c(!1), !0) : !1, e[9] = C) : C = e[9];
  const y = C;
  let w;
  e[10] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = (I) => {
    y() && I.currentTarget.releasePointerCapture?.(I.pointerId);
  }, e[10] = w) : w = e[10];
  const R = w;
  let S;
  e[11] !== p || e[12] !== s || e[13] !== r || e[14] !== o ? (S = (I) => {
    if (s || I.target !== I.currentTarget)
      return;
    let k = 0, M = 0;
    if (I.key === "ArrowLeft")
      k = -ul;
    else if (I.key === "ArrowRight")
      k = ul;
    else if (I.key === "ArrowUp")
      M = -ul;
    else if (I.key === "ArrowDown")
      M = ul;
    else
      return;
    I.preventDefault(), r(p({
      x: o.x + k,
      y: o.y + M
    }));
  }, e[11] = p, e[12] = s, e[13] = r, e[14] = o, e[15] = S) : S = e[15];
  const E = S;
  let N;
  e[16] !== E || e[17] !== h || e[18] !== v ? (N = {
    onPointerDown: h,
    onPointerMove: v,
    onPointerUp: R,
    onPointerCancel: y,
    onLostPointerCapture: y,
    onKeyDown: E,
    tabIndex: 0,
    "aria-label": "Drag to reposition",
    "data-slot": "dialog-drag-handle"
  }, e[16] = E, e[17] = h, e[18] = v, e[19] = N) : N = e[19];
  const T = N;
  let P;
  return e[20] !== n || e[21] !== a || e[22] !== T ? (P = {
    dragHandleRef: n,
    isDragging: a,
    dragHandleProps: T
  }, e[20] = n, e[21] = a, e[22] = T, e[23] = P) : P = e[23], P;
}
const $g = 550, Hg = 400, dM = 16, fM = ce(["fixed", "inset-0", "z-[var(--z-layer-dialog)]"], {
  variants: {
    expanded: {
      true: ["pointer-events-none", "flex", "items-center", "justify-center", "p-(--spacing-16)"],
      false: "pointer-events-none"
    }
  }
}), pM = ce(["flex", "flex-col", "overflow-hidden", "rounded-(--radius-sm)", "bg-surface-container-lowest", "shadow-elevation-5"], {
  variants: {
    expanded: {
      true: ["pointer-events-auto", "w-[min(1263px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(1136px,calc(100vh_-_var(--spacing-32)))]", "outline-none"],
      false: ["pointer-events-auto", "fixed", "z-[var(--z-layer-dialog)]", "h-[min(400px,100vh)]", "w-[min(550px,100vw)]"]
    }
  }
}), gM = ce(["shrink-0", "bg-surface-container-lowest", "px-(--spacing-24)", "py-(--spacing-16)", "shadow-elevation-1"]), mM = ce(["flex", "shrink-0", "flex-col", "gap-(--spacing-6)", "p-(--spacing-16)"]), zg = ce(["font-(family-name:--font-family-title)", "text-(length:--font-size-title-lg)", "font-(number:--font-weight-bold)", "leading-(--font-line-height-28)", "text-text-default"]), Bg = ce(["text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"]), hM = ce(["mt-(--spacing-4)", "flex", "size-(--spacing-20)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "select-none", "outline-none", "focus-visible:ring-2", "focus-visible:ring-button-focus-ring", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface"]), bM = ce(["min-h-0", "flex-1"], {
  variants: {
    expanded: {
      true: "flex",
      false: ["overflow-y-auto", "p-(--spacing-16)"]
    }
  }
}), vM = ce([], {
  variants: {
    expanded: {
      true: ["min-w-0", "flex-1", "overflow-y-auto", "p-(--spacing-16)"],
      false: "contents"
    }
  }
}), Wg = ce(["flex", "min-h-(--spacing-40)", "shrink-0", "items-center", "gap-(--spacing-16)", "px-(--spacing-16)", "pb-(--spacing-16)"]);
function Wb() {
  return typeof window > "u" ? {
    width: $g,
    height: Hg
  } : {
    width: Math.min($g, window.innerWidth),
    height: Math.min(Hg, window.innerHeight)
  };
}
function dl(t, e = Wb()) {
  return typeof window > "u" ? t : {
    x: Math.max(0, Math.min(t.x, window.innerWidth - e.width)),
    y: Math.max(0, Math.min(t.y, window.innerHeight - e.height))
  };
}
function Ug(t, e) {
  if (typeof window > "u") return t;
  const n = Bb(e);
  return {
    x: Math.max(-n.offsetX, Math.min(t.x, window.innerWidth - n.offsetX - n.width)),
    y: Math.max(-n.offsetY, Math.min(t.y, window.innerHeight - n.offsetY - n.height))
  };
}
function yM(t) {
  if (typeof window > "u") return {
    x: 0,
    y: 0
  };
  const {
    innerWidth: e,
    innerHeight: n
  } = window, o = Wb(), r = Math.min(dM, e, n), i = e - o.width - r, s = n - o.height - r;
  switch (t) {
    case "top-start":
      return dl({
        x: r,
        y: r
      }, o);
    case "top-end":
      return dl({
        x: i,
        y: r
      }, o);
    case "bottom-start":
      return dl({
        x: r,
        y: s
      }, o);
    case "bottom-end":
      return dl({
        x: i,
        y: s
      }, o);
  }
}
function pD({
  open: t,
  onOpenChange: e,
  expanded: n = !1,
  onExpandedChange: o,
  initialPlacement: r = "bottom-end",
  position: i,
  onPositionChange: s,
  heading: l,
  description: a,
  headerAccessory: c,
  expandedAside: u,
  children: d,
  floatingFooter: f,
  expandedFooter: p
}) {
  const g = qt(), h = !!n, b = i !== void 0, [v, C] = x.useState(() => yM(r)), y = i ?? v, w = x.useRef(null), R = (P) => {
    b || C(P), s?.(P);
  }, S = t && !h ? Ug(y, w.current) : y, {
    isDragging: E,
    dragHandleProps: N
  } = uM({
    dragHandleRef: w,
    position: S,
    onPositionChange: R,
    disabled: h
  });
  return x.useEffect(() => {
    if (!t || h || typeof window > "u") return;
    const P = () => {
      const I = Ug({
        x: y.x,
        y: y.y
      }, w.current);
      (I.x !== y.x || I.y !== y.y) && (b || C(I), s?.(I));
    };
    return P(), window.addEventListener("resize", P), () => window.removeEventListener("resize", P);
  }, [y.x, y.y, b, h, s, t]), /* @__PURE__ */ m(hi, { open: t, onOpenChange: (P, I) => {
    const k = I?.reason === "outside-press" || I?.reason === "focus-out";
    if (!h && !P && k) {
      I.cancel();
      return;
    }
    e(P);
  }, modal: h, disablePointerDismissal: !h, children: /* @__PURE__ */ F(Tr, { container: g, children: [
    h && /* @__PURE__ */ m(Ns, { "data-slot": "dialog-scrim", className: "fixed inset-0 z-[var(--z-layer-dialog)] bg-surface-scrim" }),
    /* @__PURE__ */ m(bi, { className: ne(fM({
      expanded: h
    })), children: /* @__PURE__ */ F(mi, { "aria-modal": h ? "true" : void 0, "data-slot": h ? "dialog-expanded" : "dialog", initialFocus: h ? void 0 : () => w.current, className: ne(pM({
      expanded: h
    })), style: h ? void 0 : {
      left: S.x,
      top: S.y
    }, children: [
      h ? /* @__PURE__ */ F("div", { "data-slot": "dialog-expanded-header", className: ne(gM()), children: [
        /* @__PURE__ */ F("div", { className: "flex items-center justify-between", children: [
          /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-16)", children: [
            /* @__PURE__ */ m(Ji, { className: ne(zg(), "whitespace-nowrap"), children: l }),
            c && /* @__PURE__ */ m("div", { className: "flex min-w-0 items-center gap-(--spacing-16)", children: c })
          ] }),
          /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-16)", children: [
            o && /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Collapse", onClick: () => o(!1) }),
            /* @__PURE__ */ m(Zr, { render: /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
          ] })
        ] }),
        a && /* @__PURE__ */ m(Qi, { className: ne(Bg(), "mt-(--spacing-6)"), children: a })
      ] }) : /* @__PURE__ */ m("div", { className: ne(mM()), children: /* @__PURE__ */ F("div", { className: "flex items-start justify-between gap-(--spacing-6)", children: [
        /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-1 gap-(--spacing-8)", children: [
          /* @__PURE__ */ m("button", { type: "button", ref: w, ...N, className: ne(hM(), E ? "cursor-grabbing" : "cursor-grab"), children: /* @__PURE__ */ m(Ke, { name: "drag", size: "sm", tone: "secondary" }) }),
          /* @__PURE__ */ F("div", { className: "min-w-0 flex-1", children: [
            /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-8)", children: [
              /* @__PURE__ */ m(Ji, { className: ne(zg(), "min-w-0"), children: l }),
              c && /* @__PURE__ */ m("span", { className: "shrink-0", children: c })
            ] }),
            a && /* @__PURE__ */ m(Qi, { className: ne(Bg(), "mt-(--spacing-4)"), children: a })
          ] })
        ] }),
        /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-4)", children: [
          o && /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: "expand-regular", "aria-label": "Expand", onClick: () => o(!0) }),
          /* @__PURE__ */ m(Zr, { render: /* @__PURE__ */ m(mt, { variant: "ghost", size: "sm", icon: "x-close", "aria-label": "Close" }) })
        ] })
      ] }) }),
      /* @__PURE__ */ F("div", { className: ne(bM({
        expanded: h
      })), children: [
        h && u && /* @__PURE__ */ F(zt, { children: [
          /* @__PURE__ */ m("div", { className: "min-w-0 basis-1/2 overflow-y-auto p-(--spacing-16)", children: u }),
          /* @__PURE__ */ m(gr, { orientation: "vertical" })
        ] }),
        /* @__PURE__ */ m("div", { className: ne(vM({
          expanded: h
        })), children: d }, "body")
      ] }),
      h ? p && /* @__PURE__ */ m("div", { className: ne(Wg()), children: p }) : f && /* @__PURE__ */ m("div", { className: ne(Wg()), children: f })
    ] }) })
  ] }) });
}
const xM = {
  1: "h1",
  2: "h2",
  3: "h3",
  4: "h4",
  5: "h5",
  6: "h6"
};
function CM() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("svg", { "data-slot": "empty-state-pattern", "aria-hidden": "true", viewBox: "0 0 336 336", fill: "none", className: "pointer-events-none absolute top-1/2 left-1/2 size-[336px] max-w-none -translate-x-1/2 -translate-y-1/2 text-outline-subtle", children: /* @__PURE__ */ F("g", { stroke: "currentColor", children: [
    /* @__PURE__ */ m("circle", { cx: "168", cy: "168", r: "167.5", strokeOpacity: "0" }),
    /* @__PURE__ */ m("circle", { cx: "168", cy: "168", r: "143.5", strokeOpacity: "0.04" }),
    /* @__PURE__ */ m("circle", { cx: "168", cy: "168", r: "119.5", strokeOpacity: "0.24" }),
    /* @__PURE__ */ m("circle", { cx: "168", cy: "168", r: "95.5", strokeOpacity: "0.48" }),
    /* @__PURE__ */ m("circle", { cx: "168", cy: "168", r: "71.5", strokeOpacity: "0.67" }),
    /* @__PURE__ */ m("circle", { cx: "168", cy: "168", r: "47.5", strokeOpacity: "0.88" })
  ] }) }), t[0] = e) : e = t[0], e;
}
function gD(t) {
  const e = z.c(19), {
    icon: n,
    title: o,
    description: r,
    actions: i,
    headingLevel: s
  } = t, a = xM[s === void 0 ? 2 : s];
  let c;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = /* @__PURE__ */ m(CM, {}), e[0] = c) : c = e[0];
  let u;
  e[1] !== n ? (u = /* @__PURE__ */ F("div", { className: "relative flex size-[48px] items-center justify-center", children: [
    c,
    /* @__PURE__ */ m("div", { className: "relative z-10", children: /* @__PURE__ */ m(Ke, { name: n, size: "md", "aria-hidden": !0 }) })
  ] }), e[1] = n, e[2] = u) : u = e[2];
  let d;
  e[3] !== a || e[4] !== o ? (d = /* @__PURE__ */ m(a, { className: "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-24) text-text-default", children: o }), e[3] = a, e[4] = o, e[5] = d) : d = e[5];
  let f;
  e[6] !== r ? (f = r ? /* @__PURE__ */ m("p", { className: "m-0 font-(family-name:--font-family-title) text-(length:--font-size-title-sm) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-subtle", children: r }) : null, e[6] = r, e[7] = f) : f = e[7];
  let p;
  e[8] !== d || e[9] !== f ? (p = /* @__PURE__ */ F("div", { className: "flex w-full flex-col gap-(--spacing-6)", children: [
    d,
    f
  ] }), e[8] = d, e[9] = f, e[10] = p) : p = e[10];
  let g;
  e[11] !== i ? (g = i ? /* @__PURE__ */ m("div", { className: "mt-(--spacing-32) flex flex-wrap justify-center gap-x-(--spacing-10) gap-y-(--spacing-10)", children: i }) : null, e[11] = i, e[12] = g) : g = e[12];
  let h;
  e[13] !== p || e[14] !== g ? (h = /* @__PURE__ */ F("div", { className: "relative mt-(--spacing-20) flex w-full max-w-[500px] flex-col items-center px-(--spacing-32) text-center", children: [
    p,
    g
  ] }), e[13] = p, e[14] = g, e[15] = h) : h = e[15];
  let b;
  return e[16] !== u || e[17] !== h ? (b = /* @__PURE__ */ F("section", { "data-slot": "empty-state", className: "relative mx-auto flex w-full max-w-[856px] flex-col items-center overflow-hidden bg-surface py-(--spacing-128)", children: [
    u,
    h
  ] }), e[16] = u, e[17] = h, e[18] = b) : b = e[18], b;
}
const Xf = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Xf.displayName = "TabsRootContext");
function Qf() {
  const t = x.useContext(Xf);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsRootContext is missing. Tabs parts must be placed within <Tabs.Root>." : rt(64));
  return t;
}
let wM = /* @__PURE__ */ (function(t) {
  return t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t;
})({});
const Jf = {
  tabActivationDirection: (t) => ({
    [wM.activationDirection]: t
  })
}, e1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultValue: r = 0,
    onValueChange: i,
    orientation: s = "horizontal",
    render: l,
    value: a,
    style: c,
    ...u
  } = e, d = Object.hasOwn(e, "defaultValue"), f = x.useRef([]), [p, g] = x.useState(() => /* @__PURE__ */ new Map()), [h, b] = dn({
    controlled: a,
    default: r,
    name: "Tabs",
    state: "value"
  }), v = a !== void 0, [C, y] = x.useState(() => /* @__PURE__ */ new Map()), w = x.useCallback((Y) => {
    if (Y === void 0)
      return null;
    for (const [K, j] of C.entries())
      if (j != null && Y === (j.value ?? j.index))
        return K;
    return null;
  }, [C]), [R, S] = x.useState(() => ({
    previousValue: h,
    tabActivationDirection: "none"
  })), {
    previousValue: E,
    tabActivationDirection: N
  } = R;
  let T = N, P = !1;
  E !== h && (T = Gg(E, h, s, C), P = E != null && h != null && w(h) == null);
  const I = P ? E : h, k = E !== I || N !== T;
  ke(() => {
    k && S({
      previousValue: I,
      tabActivationDirection: T
    });
  }, [I, k, T]);
  const M = Se((Y, K) => {
    const j = Gg(h, Y, s, C);
    K.activationDirection = j, i?.(Y, K), !K.isCanceled && b(Y);
  }), D = Se((Y, K) => {
    g((j) => {
      if (j.get(Y) === K)
        return j;
      const Z = new Map(j);
      return Z.set(Y, K), Z;
    });
  }), O = Se((Y, K) => {
    g((j) => {
      if (!j.has(Y) || j.get(Y) !== K)
        return j;
      const Z = new Map(j);
      return Z.delete(Y), Z;
    });
  }), V = x.useCallback((Y) => p.get(Y), [p]), _ = x.useCallback((Y) => {
    for (const K of C.values())
      if (Y === K?.value)
        return K?.id;
  }, [C]), A = x.useMemo(() => ({
    getTabElementBySelectedValue: w,
    getTabIdByPanelValue: _,
    getTabPanelIdByValue: V,
    onValueChange: M,
    orientation: s,
    registerMountedTabPanel: D,
    setTabMap: y,
    unregisterMountedTabPanel: O,
    tabActivationDirection: T,
    value: h
  }), [w, _, V, M, s, D, y, O, T, h]), L = x.useMemo(() => {
    for (const Y of C.values())
      if (Y != null && Y.value === h)
        return Y;
  }, [C, h]), B = x.useMemo(() => {
    for (const Y of C.values())
      if (Y != null && !Y.disabled)
        return Y.value;
  }, [C]);
  ke(() => {
    if (v || C.size === 0)
      return;
    const Y = L?.disabled, K = L == null && h !== null;
    if (d && Y && h === r || !Y && !K)
      return;
    const Z = B ?? null;
    h !== Z && (b(Z), S((te) => te.tabActivationDirection === "none" ? te : {
      ...te,
      tabActivationDirection: "none"
    }));
  }, [r, B, d, v, L, b, C, h]);
  const U = $e("div", e, {
    state: {
      orientation: s,
      tabActivationDirection: T
    },
    ref: n,
    props: u,
    stateAttributesMapping: Jf
  });
  return /* @__PURE__ */ m(Xf.Provider, {
    value: A,
    children: /* @__PURE__ */ m(ii, {
      elementsRef: f,
      children: U
    })
  });
});
process.env.NODE_ENV !== "production" && (e1.displayName = "TabsRoot");
function Gg(t, e, n, o) {
  if (t == null || e == null)
    return "none";
  let r = null, i = null;
  for (const [a, c] of o.entries()) {
    if (c == null)
      continue;
    const u = c.value ?? c.index;
    if (t === u && (r = a), e === u && (i = a), r != null && i != null)
      break;
  }
  if (r == null || i == null)
    return r !== i && (typeof t == "number" || typeof t == "string") && typeof t == typeof e ? n === "horizontal" ? e > t ? "right" : "left" : e > t ? "down" : "up" : "none";
  const s = r.getBoundingClientRect(), l = i.getBoundingClientRect();
  if (n === "horizontal") {
    if (l.left < s.left)
      return "left";
    if (l.left > s.left)
      return "right";
  } else {
    if (l.top < s.top)
      return "up";
    if (l.top > s.top)
      return "down";
  }
  return "none";
}
const t1 = "data-composite-item-active", n1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (n1.displayName = "TabsListContext");
function SM() {
  const t = x.useContext(n1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: TabsListContext is missing. TabsList parts must be placed within <Tabs.List>." : rt(65));
  return t;
}
const o1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    disabled: r = !1,
    render: i,
    value: s,
    id: l,
    nativeButton: a = !0,
    style: c,
    ...u
  } = e, {
    value: d,
    getTabPanelIdByValue: f,
    orientation: p
  } = Qf(), {
    activateOnFocus: g,
    highlightedTabIndex: h,
    onTabActivation: b,
    registerTabResizeObserverElement: v,
    setHighlightedTabIndex: C,
    tabsListElement: y
  } = SM(), w = Mt(l), R = x.useMemo(() => ({
    disabled: r,
    id: w,
    value: s
  }), [r, w, s]), {
    compositeProps: S,
    compositeRef: E,
    index: N
    // hook is used instead of the CompositeItem component
    // because the index is needed for Tab internals
  } = o2({
    metadata: R
  }), T = s === d, P = x.useRef(!1), I = x.useRef(null);
  x.useEffect(() => {
    const U = I.current;
    if (U)
      return v(U);
  }, [v]), ke(() => {
    if (P.current) {
      P.current = !1;
      return;
    }
    if (!(T && N > -1 && h !== N))
      return;
    const U = y;
    if (U != null) {
      const Y = Gt(et(U));
      if (Y && ze(U, Y))
        return;
    }
    r || C(N);
  }, [T, N, h, C, r, y]);
  const {
    getButtonProps: k,
    buttonRef: M
  } = Wt({
    disabled: r,
    native: a,
    focusableWhenDisabled: !0
  }), D = f(s), O = x.useRef(!1), V = x.useRef(!1);
  function _(U) {
    T || r || b(s, Ve(Pt, U.nativeEvent, void 0, {
      activationDirection: "none"
    }));
  }
  function A(U) {
    T || (N > -1 && !r && C(N), !r && g && (!O.current || // keyboard or touch focus
    O.current && V.current) && b(s, Ve(Pt, U.nativeEvent, void 0, {
      activationDirection: "none"
    })));
  }
  function L(U) {
    if (T || r)
      return;
    O.current = !0;
    function Y() {
      O.current = !1, V.current = !1;
    }
    (!U.button || U.button === 0) && (V.current = !0, et(U.currentTarget).addEventListener("pointerup", Y, {
      once: !0
    }));
  }
  return $e("button", e, {
    state: {
      disabled: r,
      active: T,
      orientation: p
    },
    ref: [n, M, E, I],
    props: [S, {
      role: "tab",
      "aria-controls": D,
      "aria-selected": T,
      id: w,
      onClick: _,
      onFocus: A,
      onPointerDown: L,
      [t1]: T ? "" : void 0,
      onKeyDownCapture() {
        P.current = !0;
      }
    }, u, k]
  });
});
process.env.NODE_ENV !== "production" && (o1.displayName = "TabsTab");
let RM = (function(t) {
  return t.index = "data-index", t.activationDirection = "data-activation-direction", t.orientation = "data-orientation", t.hidden = "data-hidden", t[t.startingStyle = qn.startingStyle] = "startingStyle", t[t.endingStyle = qn.endingStyle] = "endingStyle", t;
})({});
const EM = {
  ...Jf,
  ...Bt
}, Ub = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    value: r,
    render: i,
    keepMounted: s = !1,
    style: l,
    ...a
  } = e, {
    value: c,
    getTabIdByPanelValue: u,
    orientation: d,
    tabActivationDirection: f,
    registerMountedTabPanel: p,
    unregisterMountedTabPanel: g
  } = Qf(), h = Mt(), b = x.useMemo(() => ({
    id: h,
    value: r
  }), [h, r]), {
    ref: v,
    index: C
  } = Oo({
    metadata: b
  }), y = r === c, {
    mounted: w,
    transitionStatus: R,
    setMounted: S
  } = Xn(y), E = !w, N = u(r), T = {
    hidden: E,
    orientation: d,
    tabActivationDirection: f,
    transitionStatus: R
  }, P = x.useRef(null), I = $e("div", e, {
    state: T,
    ref: [n, v, P],
    props: [{
      "aria-labelledby": N,
      hidden: E,
      id: h,
      role: "tabpanel",
      tabIndex: y ? 0 : -1,
      inert: Er(!y),
      [RM.index]: C
    }, a],
    stateAttributesMapping: EM
  });
  return jt({
    open: y,
    ref: P,
    onComplete() {
      y || S(!1);
    }
  }), ke(() => {
    if (!(E && !s) && h != null)
      return p(r, h), () => {
        g(r, h);
      };
  }, [E, s, r, h, p, g]), s || w ? I : null;
});
process.env.NODE_ENV !== "production" && (Ub.displayName = "TabsPanel");
const NM = [];
function kM(t) {
  const {
    itemSizes: e,
    cols: n = 1,
    loopFocus: o = !0,
    onLoop: r,
    dense: i = !1,
    orientation: s = "both",
    direction: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: u,
    enableHomeAndEndKeys: d = !1,
    stopEventPropagation: f = !1,
    disabledIndices: p,
    modifierKeys: g = NM
  } = t, [h, b] = x.useState(0), v = n > 1, C = x.useRef(null), y = fn(C, u), w = x.useRef([]), R = x.useRef(!1), S = a ?? h, E = Se((I, k = !1) => {
    if ((c ?? b)(I), k) {
      const M = w.current[I];
      vp(C.current, M, l, s);
    }
  }), N = Se((I) => {
    if (I.size === 0 || R.current)
      return;
    R.current = !0;
    const k = Array.from(I.keys()), M = k.find((O) => O?.hasAttribute(t1)) ?? null, D = M ? k.indexOf(M) : -1;
    D !== -1 && E(D), vp(C.current, M, l, s);
  }), T = Se((I, k, M) => r ? r?.(I, k, M, w) : M), P = x.useMemo(() => ({
    "aria-orientation": s === "both" ? void 0 : s,
    ref: y,
    onFocus(I) {
      const k = C.current, M = bt(I.nativeEvent);
      !k || M == null || !bp(M) || M.setSelectionRange(0, M.value.length ?? 0);
    },
    onKeyDown(I) {
      const k = d ? D9 : Wh;
      if (!k.has(I.key) || MM(I, g) || !C.current)
        return;
      const D = l === "rtl", O = D ? Zi : Wr, V = {
        horizontal: O,
        vertical: cr,
        both: O
      }[s], _ = D ? Wr : Zi, A = {
        horizontal: _,
        vertical: Br,
        both: _
      }[s], L = bt(I.nativeEvent);
      if (L != null && bp(L) && !l2(L)) {
        const Z = L.selectionStart, te = L.selectionEnd, W = L.value ?? "";
        if (Z == null || I.shiftKey || Z !== te || I.key !== A && Z < W.length || I.key !== V && Z > 0)
          return;
      }
      let B = S;
      const G = vl(w, p), U = nu(w, p);
      if (v) {
        const Z = e || Array.from({
          length: w.current.length
        }, () => ({
          width: 1,
          height: 1
        })), te = sh(Z, n, i), W = te.findIndex((ee) => ee != null && !No(w.current, ee, p)), X = te.reduce((ee, le, J) => le != null && !No(w.current, le, p) ? J : ee, -1);
        B = te[ih(te.map((ee) => ee != null ? w.current[ee] : null), {
          event: I,
          orientation: s,
          loopFocus: o,
          onLoop: T,
          cols: n,
          // treat undefined (empty grid spaces) as disabled indices so we
          // don't end up in them
          disabledIndices: ah([...p || w.current.map((ee, le) => No(w.current, le) ? le : void 0), void 0], te),
          minIndex: W,
          maxIndex: X,
          prevIndex: lh(
            S > U ? G : S,
            Z,
            te,
            n,
            // use a corner matching the edge closest to the direction we're
            // moving in so we don't end up in the same item. Prefer
            // top/left over bottom/right.
            // eslint-disable-next-line no-nested-ternary
            I.key === cr ? "bl" : I.key === Wr ? "tr" : "tl"
          ),
          rtl: D
        })];
      }
      const Y = {
        horizontal: [O],
        vertical: [cr],
        both: [O, cr]
      }[s], K = {
        horizontal: [_],
        vertical: [Br],
        both: [_, Br]
      }[s], j = v ? k : {
        horizontal: d ? T9 : zh,
        vertical: d ? O9 : Bh,
        both: k
      }[s];
      d && (I.key === bs ? B = G : I.key === vs && (B = U)), B === S && (Y.includes(I.key) || K.includes(I.key)) && (o && B === U && Y.includes(I.key) ? (B = G, r && (B = r(I, S, B, w))) : o && B === G && K.includes(I.key) ? (B = U, r && (B = r(I, S, B, w))) : B = rn(w.current, {
        startingIndex: B,
        decrement: K.includes(I.key),
        disabledIndices: p
      })), B !== S && !Ki(w.current, B) && (f && I.stopPropagation(), j.has(I.key) && I.preventDefault(), E(B, !0), queueMicrotask(() => {
        w.current[B]?.focus();
      }));
    }
  }), [n, i, l, p, w, d, S, v, e, o, r, T, y, g, E, s, f]);
  return x.useMemo(() => ({
    props: P,
    highlightedIndex: S,
    onHighlightedIndexChange: E,
    elementsRef: w,
    disabledIndices: p,
    onMapChange: N,
    relayKeyboardEvent: P.onKeyDown
  }), [P, S, E, w, p, N]);
}
function MM(t, e) {
  for (const n of L9.values())
    if (!e.includes(n) && t.getModifierState(n))
      return !0;
  return !1;
}
function Gb(t) {
  const {
    render: e,
    className: n,
    style: o,
    refs: r = On,
    props: i = On,
    state: s = St,
    stateAttributesMapping: l,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    orientation: u,
    dense: d,
    itemSizes: f,
    loopFocus: p,
    onLoop: g,
    cols: h,
    enableHomeAndEndKeys: b,
    onMapChange: v,
    stopEventPropagation: C = !0,
    rootRef: y,
    disabledIndices: w,
    modifierKeys: R,
    highlightItemOnHover: S = !1,
    tag: E = "div",
    ...N
  } = t, T = xs(), {
    props: P,
    highlightedIndex: I,
    onHighlightedIndexChange: k,
    elementsRef: M,
    onMapChange: D,
    relayKeyboardEvent: O
  } = kM({
    itemSizes: f,
    cols: h,
    loopFocus: p,
    onLoop: g,
    dense: d,
    orientation: u,
    highlightedIndex: a,
    onHighlightedIndexChange: c,
    rootRef: y,
    stopEventPropagation: C,
    enableHomeAndEndKeys: b,
    direction: T,
    disabledIndices: w,
    modifierKeys: R
  }), V = $e(E, t, {
    state: s,
    ref: r,
    props: [P, ...i, N],
    stateAttributesMapping: l
  }), _ = x.useMemo(() => ({
    highlightedIndex: I,
    onHighlightedIndexChange: k,
    highlightItemOnHover: S,
    relayKeyboardEvent: O
  }), [I, k, S, O]);
  return /* @__PURE__ */ m(Ou.Provider, {
    value: _,
    children: /* @__PURE__ */ m(ii, {
      elementsRef: M,
      onMapChange: (A) => {
        v?.(A), D(A);
      },
      children: V
    })
  });
}
const r1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    activateOnFocus: o = !1,
    className: r,
    loopFocus: i = !0,
    render: s,
    style: l,
    ...a
  } = e, {
    onValueChange: c,
    orientation: u,
    value: d,
    setTabMap: f,
    tabActivationDirection: p
  } = Qf(), [g, h] = x.useState(0), [b, v] = x.useState(null), C = x.useRef(/* @__PURE__ */ new Set()), y = x.useRef(/* @__PURE__ */ new Set()), w = x.useRef(null), R = Se(() => {
    C.current.forEach((k) => {
      k();
    });
  });
  x.useEffect(() => {
    if (typeof ResizeObserver > "u")
      return;
    const k = new ResizeObserver(() => {
      C.current.size && R();
    });
    return w.current = k, b && k.observe(b), y.current.forEach((M) => {
      k.observe(M);
    }), () => {
      k.disconnect(), w.current = null;
    };
  }, [b, R]);
  const S = Se((k) => (C.current.add(k), () => {
    C.current.delete(k);
  })), E = Se((k) => (y.current.add(k), w.current?.observe(k), () => {
    y.current.delete(k), w.current?.unobserve(k);
  })), N = Se((k, M) => {
    k !== d && c(k, M);
  }), T = {
    orientation: u,
    tabActivationDirection: p
  }, P = {
    "aria-orientation": u === "vertical" ? "vertical" : void 0,
    role: "tablist"
  }, I = x.useMemo(() => ({
    activateOnFocus: o,
    highlightedTabIndex: g,
    registerIndicatorUpdateListener: S,
    registerTabResizeObserverElement: E,
    onTabActivation: N,
    setHighlightedTabIndex: h,
    tabsListElement: b
  }), [o, g, S, E, N, h, b]);
  return /* @__PURE__ */ m(n1.Provider, {
    value: I,
    children: /* @__PURE__ */ m(Gb, {
      render: s,
      className: r,
      style: l,
      state: T,
      refs: [n, v],
      props: [P, a],
      stateAttributesMapping: Jf,
      highlightedIndex: g,
      enableHomeAndEndKeys: !0,
      loopFocus: i,
      orientation: u,
      onHighlightedIndexChange: h,
      onMapChange: f,
      disabledIndices: On
    })
  });
});
process.env.NODE_ENV !== "production" && (r1.displayName = "TabsList");
function IM(t) {
  const e = z.c(8), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t;
  let i;
  e[0] !== o ? (i = o ?? [], e[0] = o, e[1] = i) : i = e[1];
  const [s, l] = ot(i), a = n !== void 0, c = a ? n : s;
  let u;
  e[2] !== a || e[3] !== r ? (u = function(g) {
    a || l(g), r?.(g);
  }, e[2] = a, e[3] = r, e[4] = u) : u = e[4];
  const d = u;
  let f;
  return e[5] !== c || e[6] !== d ? (f = [c, d], e[5] = c, e[6] = d, e[7] = f) : f = e[7], f;
}
function Yb(t) {
  const e = z.c(6), {
    value: n,
    defaultValue: o,
    onChange: r
  } = t, [i, s] = ot(o ?? null), l = n !== void 0, a = l ? n : i;
  let c;
  e[0] !== l || e[1] !== r ? (c = function(p) {
    l || s(p), r?.(p);
  }, e[0] = l, e[1] = r, e[2] = c) : c = e[2];
  const u = c;
  let d;
  return e[3] !== a || e[4] !== u ? (d = [a, u], e[3] = a, e[4] = u, e[5] = d) : d = e[5], d;
}
const PM = ce(["inline-flex", "h-(--spacing-32)", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-button-outline-default-text", "outline-none", "transition-colors", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "hover:border-button-outline-hover-border", "hover:bg-button-outline-hover-background", "active:border-button-outline-pressed-border", "active:bg-button-outline-pressed-background", "data-[mouse-down]:border-button-outline-pressed-border", "data-[mouse-down]:bg-button-outline-pressed-background", "focus-visible:ring-2", "focus-visible:ring-offset-[3px]", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:cursor-not-allowed", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    fullWidth: {
      true: "w-full",
      false: ""
    }
  },
  defaultVariants: {
    fullWidth: !1
  }
});
function Ia(t) {
  const e = z.c(31);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    children: n,
    leadingIcon: r,
    trailingIcon: u,
    showChevron: s,
    open: l,
    mouseDown: a,
    fullWidth: c,
    className: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = s === void 0 ? !1 : s, f = l === void 0 ? !1 : l, p = a === void 0 ? !1 : a, g = c === void 0 ? !1 : c;
  let h;
  e[10] !== o || e[11] !== g ? (h = ne(PM({
    fullWidth: g
  }), o), e[10] = o, e[11] = g, e[12] = h) : h = e[12];
  const b = p ? "" : void 0, v = d ? f : i["aria-expanded"];
  let C;
  e[13] !== r ? (C = r && /* @__PURE__ */ m(Ke, { name: r, size: "xs", tone: "inherit" }), e[13] = r, e[14] = C) : C = e[14];
  let y;
  e[15] !== n ? (y = /* @__PURE__ */ m("span", { className: "min-w-0 truncate", children: n }), e[15] = n, e[16] = y) : y = e[16];
  let w;
  e[17] !== u ? (w = u && /* @__PURE__ */ m(Ke, { name: u, size: "xs", tone: "inherit" }), e[17] = u, e[18] = w) : w = e[18];
  let R;
  e[19] !== f || e[20] !== d ? (R = d && /* @__PURE__ */ m("span", { "data-open": f ? "" : void 0, className: "inline-flex transition-transform duration-200 data-[open]:rotate-180", children: /* @__PURE__ */ m(Ke, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[19] = f, e[20] = d, e[21] = R) : R = e[21];
  let S;
  return e[22] !== i || e[23] !== w || e[24] !== R || e[25] !== h || e[26] !== b || e[27] !== v || e[28] !== C || e[29] !== y ? (S = /* @__PURE__ */ F(Qn, { className: h, ...i, "data-mouse-down": b, "aria-expanded": v, children: [
    C,
    y,
    w,
    R
  ] }), e[22] = i, e[23] = w, e[24] = R, e[25] = h, e[26] = b, e[27] = v, e[28] = C, e[29] = y, e[30] = S) : S = e[30], S;
}
function mD(t) {
  const e = z.c(47), {
    children: n,
    title: o,
    triggerLabel: r,
    align: i,
    open: s,
    defaultOpen: l,
    onOpenChange: a,
    onApply: c,
    applyLabel: u,
    onClearAll: d,
    clearAllLabel: f,
    disabled: p
  } = t, g = o === void 0 ? "Filters" : o, h = i === void 0 ? "start" : i, b = u === void 0 ? "Apply filters" : u, v = f === void 0 ? "Clear All" : f, C = qt(), [y, w] = ot(l ?? !1), {
    mouseDown: R,
    triggerMouseDownProps: S
  } = Rs(), E = s !== void 0, N = E ? s : y;
  let T;
  e[0] !== E || e[1] !== a ? (T = function(te) {
    E || w(te), a?.(te);
  }, e[0] = E, e[1] = a, e[2] = T) : T = e[2];
  const P = T;
  let I;
  e[3] !== P ? (I = function() {
    P(!1);
  }, e[3] = P, e[4] = I) : I = e[4];
  const k = I;
  let M;
  e[5] !== p || e[6] !== R || e[7] !== g || e[8] !== r || e[9] !== S ? (M = /* @__PURE__ */ m(Sa, { render: r !== void 0 ? /* @__PURE__ */ m(Ia, { trailingIcon: "filter", disabled: p, mouseDown: R, ...S, children: r }) : /* @__PURE__ */ m(mt, { variant: "outline", size: "sm", icon: "filter", "aria-label": g, disabled: p, ...S }) }), e[5] = p, e[6] = R, e[7] = g, e[8] = r, e[9] = S, e[10] = M) : M = e[10];
  let D;
  e[11] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = ne("flex", "w-[500px]", "max-w-[calc(100vw-var(--spacing-32))]", "max-h-[544px]", "flex-col", "gap-(--spacing-20)", "overflow-y-auto", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface", "p-(--spacing-20)", "shadow-elevation-3", "outline-none"), e[11] = D) : D = e[11];
  let O;
  e[12] !== g ? (O = /* @__PURE__ */ m("h2", { className: "font-(family-name:--font-family-title) text-(length:--font-size-title-lg) font-(number:--font-weight-bold) leading-(--font-line-height-28) text-text-default", children: g }), e[12] = g, e[13] = O) : O = e[13];
  let V;
  e[14] !== v || e[15] !== d ? (V = d && /* @__PURE__ */ m(_n, { variant: "ghost", size: "sm", onClick: d, children: v }), e[14] = v, e[15] = d, e[16] = V) : V = e[16];
  let _;
  e[17] !== V || e[18] !== O ? (_ = /* @__PURE__ */ F("div", { className: "flex items-center justify-between gap-(--spacing-16)", children: [
    O,
    V
  ] }), e[17] = V, e[18] = O, e[19] = _) : _ = e[19];
  let A;
  e[20] !== n || e[21] !== k ? (A = typeof n == "function" ? n({
    close: k
  }) : n, e[20] = n, e[21] = k, e[22] = A) : A = e[22];
  let L;
  e[23] !== A ? (L = /* @__PURE__ */ m("div", { className: "flex flex-col gap-(--spacing-16)", children: A }), e[23] = A, e[24] = L) : L = e[24];
  let B;
  e[25] !== k || e[26] !== c ? (B = () => {
    c?.(), k();
  }, e[25] = k, e[26] = c, e[27] = B) : B = e[27];
  let G;
  e[28] !== b || e[29] !== B ? (G = /* @__PURE__ */ m("div", { className: "flex justify-end", children: /* @__PURE__ */ m(_n, { size: "sm", onClick: B, children: b }) }), e[28] = b, e[29] = B, e[30] = G) : G = e[30];
  let U;
  e[31] !== _ || e[32] !== L || e[33] !== G || e[34] !== g ? (U = /* @__PURE__ */ F(Na, { role: "dialog", "aria-label": g, className: D, children: [
    _,
    L,
    G
  ] }), e[31] = _, e[32] = L, e[33] = G, e[34] = g, e[35] = U) : U = e[35];
  let Y;
  e[36] !== h || e[37] !== U ? (Y = /* @__PURE__ */ m(Ea, { side: "bottom", align: h, sideOffset: 4, children: U }), e[36] = h, e[37] = U, e[38] = Y) : Y = e[38];
  let K;
  e[39] !== C || e[40] !== Y ? (K = /* @__PURE__ */ m(Ra, { container: C, children: Y }), e[39] = C, e[40] = Y, e[41] = K) : K = e[41];
  let j;
  return e[42] !== N || e[43] !== P || e[44] !== K || e[45] !== M ? (j = /* @__PURE__ */ F(_f, { open: N, onOpenChange: P, modal: !1, children: [
    M,
    K
  ] }), e[42] = N, e[43] = P, e[44] = K, e[45] = M, e[46] = j) : j = e[46], j;
}
function hD(t) {
  const e = z.c(27), {
    label: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = IM(u), [p, g] = ot(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Rs();
  let v;
  e[4] !== d || e[5] !== f ? (v = function(N, T) {
    f(T ? [...d, N] : d.filter((P) => P !== N));
  }, e[4] = d, e[5] = f, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== a || e[8] !== n || e[9] !== h || e[10] !== p || e[11] !== b ? (y = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(Ia, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: n }) }), e[7] = a, e[8] = n, e[9] = h, e[10] = p, e[11] = b, e[12] = y) : y = e[12];
  let w;
  if (e[13] !== C || e[14] !== o || e[15] !== d) {
    let E;
    e[17] !== C || e[18] !== d ? (E = (N) => /* @__PURE__ */ m(b7, { checked: d.includes(N.value), disabled: N.disabled, closeOnClick: !1, onCheckedChange: (T) => {
      C(N.value, T);
    }, children: N.label }, N.value), e[17] = C, e[18] = d, e[19] = E) : E = e[19], w = o.map(E), e[13] = C, e[14] = o, e[15] = d, e[16] = w;
  } else
    w = e[16];
  let R;
  e[20] !== c || e[21] !== w ? (R = /* @__PURE__ */ m(kr, { size: "auto", align: c, children: w }), e[20] = c, e[21] = w, e[22] = R) : R = e[22];
  let S;
  return e[23] !== p || e[24] !== y || e[25] !== R ? (S = /* @__PURE__ */ F(ai, { open: p, onOpenChange: g, children: [
    y,
    R
  ] }), e[23] = p, e[24] = y, e[25] = R, e[26] = S) : S = e[26], S;
}
function bD(t) {
  const e = z.c(29), {
    options: n,
    value: o,
    defaultValue: r,
    onChange: i,
    placeholder: s,
    align: l,
    disabled: a
  } = t, c = s === void 0 ? "Date Range" : s, u = l === void 0 ? "start" : l;
  let d;
  e[0] !== r || e[1] !== i || e[2] !== o ? (d = {
    value: o,
    defaultValue: r,
    onChange: i
  }, e[0] = r, e[1] = i, e[2] = o, e[3] = d) : d = e[3];
  const [f, p] = Yb(d), [g, h] = ot(!1), {
    mouseDown: b,
    triggerMouseDownProps: v
  } = Rs();
  let C;
  e[4] !== n || e[5] !== c || e[6] !== f ? (C = n.find((I) => I.value === f)?.label ?? c, e[4] = n, e[5] = c, e[6] = f, e[7] = C) : C = e[7];
  const y = C;
  let w;
  e[8] !== a || e[9] !== b || e[10] !== g || e[11] !== y || e[12] !== v ? (w = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ m(Ia, { leadingIcon: "calendar", showChevron: !0, open: g, mouseDown: b, disabled: a, ...v, children: y }) }), e[8] = a, e[9] = b, e[10] = g, e[11] = y, e[12] = v, e[13] = w) : w = e[13];
  const R = f ?? "";
  let S;
  e[14] !== p ? (S = (I) => {
    p(I), h(!1);
  }, e[14] = p, e[15] = S) : S = e[15];
  let E;
  e[16] !== n ? (E = n.map(TM), e[16] = n, e[17] = E) : E = e[17];
  let N;
  e[18] !== R || e[19] !== S || e[20] !== E ? (N = /* @__PURE__ */ m(Pd, { value: R, onValueChange: S, children: E }), e[18] = R, e[19] = S, e[20] = E, e[21] = N) : N = e[21];
  let T;
  e[22] !== u || e[23] !== N ? (T = /* @__PURE__ */ m(kr, { size: "trigger", align: u, children: N }), e[22] = u, e[23] = N, e[24] = T) : T = e[24];
  let P;
  return e[25] !== g || e[26] !== T || e[27] !== w ? (P = /* @__PURE__ */ F(ai, { open: g, onOpenChange: h, children: [
    w,
    T
  ] }), e[25] = g, e[26] = T, e[27] = w, e[28] = P) : P = e[28], P;
}
function TM(t) {
  return /* @__PURE__ */ m(Td, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function vD(t) {
  const e = z.c(33), {
    prefix: n,
    options: o,
    value: r,
    defaultValue: i,
    onChange: s,
    align: l,
    disabled: a
  } = t, c = l === void 0 ? "start" : l;
  let u;
  e[0] !== i || e[1] !== s || e[2] !== r ? (u = {
    value: r,
    defaultValue: i,
    onChange: s
  }, e[0] = i, e[1] = s, e[2] = r, e[3] = u) : u = e[3];
  const [d, f] = Yb(u), [p, g] = ot(!1), {
    mouseDown: h,
    triggerMouseDownProps: b
  } = Rs();
  let v;
  e[4] !== o || e[5] !== d ? (v = o.find((k) => k.value === d)?.label ?? "", e[4] = o, e[5] = d, e[6] = v) : v = e[6];
  const C = v;
  let y;
  e[7] !== n ? (y = /* @__PURE__ */ m("span", { className: "text-text-subtle", children: n }), e[7] = n, e[8] = y) : y = e[8];
  let w;
  e[9] !== C ? (w = C && /* @__PURE__ */ F(zt, { children: [
    " ",
    /* @__PURE__ */ m("span", { children: C })
  ] }), e[9] = C, e[10] = w) : w = e[10];
  let R;
  e[11] !== a || e[12] !== h || e[13] !== p || e[14] !== y || e[15] !== w || e[16] !== b ? (R = /* @__PURE__ */ m(Yo, { render: /* @__PURE__ */ F(Ia, { showChevron: !0, open: p, disabled: a, mouseDown: h, ...b, children: [
    y,
    w
  ] }) }), e[11] = a, e[12] = h, e[13] = p, e[14] = y, e[15] = w, e[16] = b, e[17] = R) : R = e[17];
  const S = d ?? "";
  let E;
  e[18] !== f ? (E = (k) => {
    f(k), g(!1);
  }, e[18] = f, e[19] = E) : E = e[19];
  let N;
  e[20] !== o ? (N = o.map(OM), e[20] = o, e[21] = N) : N = e[21];
  let T;
  e[22] !== S || e[23] !== E || e[24] !== N ? (T = /* @__PURE__ */ m(Pd, { value: S, onValueChange: E, children: N }), e[22] = S, e[23] = E, e[24] = N, e[25] = T) : T = e[25];
  let P;
  e[26] !== c || e[27] !== T ? (P = /* @__PURE__ */ m(kr, { size: "trigger", align: c, children: T }), e[26] = c, e[27] = T, e[28] = P) : P = e[28];
  let I;
  return e[29] !== p || e[30] !== P || e[31] !== R ? (I = /* @__PURE__ */ F(ai, { open: p, onOpenChange: g, children: [
    R,
    P
  ] }), e[29] = p, e[30] = P, e[31] = R, e[32] = I) : I = e[32], I;
}
function OM(t) {
  return /* @__PURE__ */ m(Td, { value: t.value, disabled: t.disabled, children: t.label }, t.value);
}
function yD(t) {
  const e = z.c(13), {
    filters: n,
    onRemove: o,
    onClearAll: r,
    label: i
  } = t, s = i === void 0 ? "Filters:" : i;
  if (n.length === 0)
    return null;
  let l;
  e[0] !== s ? (l = /* @__PURE__ */ m("span", { className: "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtle", children: s }), e[0] = s, e[1] = l) : l = e[1];
  let a;
  if (e[2] !== n || e[3] !== o) {
    let d;
    e[5] !== o ? (d = (f) => /* @__PURE__ */ m(B5, { label: f.label, removeAriaLabel: f.removeAriaLabel, onClose: () => o(f.id) }, f.id), e[5] = o, e[6] = d) : d = e[6], a = n.map(d), e[2] = n, e[3] = o, e[4] = a;
  } else
    a = e[4];
  let c;
  e[7] !== r ? (c = /* @__PURE__ */ m(_n, { variant: "ghost", size: "sm", onClick: r, children: "Clear All" }), e[7] = r, e[8] = c) : c = e[8];
  let u;
  return e[9] !== l || e[10] !== a || e[11] !== c ? (u = /* @__PURE__ */ F("div", { "aria-live": "polite", className: "flex flex-wrap items-center gap-(--spacing-8)", children: [
    l,
    a,
    c
  ] }), e[9] = l, e[10] = a, e[11] = c, e[12] = u) : u = e[12], u;
}
function xD(t) {
  const e = z.c(13), {
    items: n,
    value: o,
    defaultValue: r,
    onValueChange: i,
    "aria-label": s
  } = t, l = s === void 0 ? "Filter views" : s;
  let a;
  e[0] !== i ? (a = (p) => i?.(p), e[0] = i, e[1] = a) : a = e[1];
  let c;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (c = ne("inline-flex", "flex-wrap", "max-w-full", "items-center", "gap-[2px]", "rounded-(--radius-sm)", "border", "border-solid", "border-outline-subtle", "bg-surface-container-high", "p-[2px]", "max-[599px]:gap-(--spacing-4)", "max-[599px]:p-(--spacing-4)"), e[2] = c) : c = e[2];
  let u;
  e[3] !== n ? (u = n.map(DM), e[3] = n, e[4] = u) : u = e[4];
  let d;
  e[5] !== l || e[6] !== u ? (d = /* @__PURE__ */ m(r1, { "aria-label": l, className: c, children: u }), e[5] = l, e[6] = u, e[7] = d) : d = e[7];
  let f;
  return e[8] !== r || e[9] !== a || e[10] !== d || e[11] !== o ? (f = /* @__PURE__ */ m(e1, { value: o, defaultValue: r, onValueChange: a, children: d }), e[8] = r, e[9] = a, e[10] = d, e[11] = o, e[12] = f) : f = e[12], f;
}
function DM(t) {
  return /* @__PURE__ */ F(o1, { value: t.value, disabled: t.disabled, "aria-label": t.count === void 0 ? t.label : `${t.label} ${t.count}`, className: ne("relative", "group", "inline-flex", "h-[28px]", "min-w-0", "items-center", "justify-center", "gap-(--spacing-6)", "rounded-(--radius-xs)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "text-text-subtle", "outline-none", "transition-[background-color,box-shadow]", "duration-200", "ease-in-out", "cursor-pointer", "select-none", "focus-visible:[outline:2px_solid_hsl(var(--button-focus-ring))]", "focus-visible:[outline-offset:2px]", "data-[active]:bg-surface-container-lowest", "data-[active]:text-text-default", "data-[active]:shadow-elevation-1", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50", "max-[599px]:before:absolute", "max-[599px]:before:left-0", "max-[599px]:before:top-1/2", "max-[599px]:before:h-[44px]", "max-[599px]:before:min-w-[44px]", "max-[599px]:before:w-full", "max-[599px]:before:-translate-y-1/2", "max-[599px]:before:content-['']"), children: [
    /* @__PURE__ */ m("span", { className: "truncate", children: t.label }),
    t.count !== void 0 && /* @__PURE__ */ m("span", { className: "text-text-disabled group-data-[active]:text-text-subtle", children: t.count })
  ] }, t.value);
}
const Yg = ne("border", "border-outline-subtle", "rounded-(--radius-sm)", "flex", "flex-col");
function CD(t) {
  const e = z.c(24);
  let n, o, r;
  e[0] !== t ? ({
    as: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "form" : r;
  let s, l, a, c;
  if (e[4] !== n) {
    const b = x.Children.toArray(n);
    s = b.find(jb);
    const v = b.filter(VM);
    c = "overflow-hidden p-(--spacing-20)", l = "flex flex-col gap-(--spacing-20) w-full", a = x.Children.map(v, (C, y) => /* @__PURE__ */ F(zt, { children: [
      C,
      y < v.length - 1 && /* @__PURE__ */ m(gr, { variant: "middle-inset" })
    ] })), e[4] = n, e[5] = s, e[6] = l, e[7] = a, e[8] = c;
  } else
    s = e[5], l = e[6], a = e[7], c = e[8];
  let u;
  e[9] !== l || e[10] !== a ? (u = /* @__PURE__ */ m("div", { className: l, children: a }), e[9] = l, e[10] = a, e[11] = u) : u = e[11];
  let d;
  e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ m("div", { className: c, children: u }), e[12] = c, e[13] = u, e[14] = d) : d = e[14];
  let f;
  e[15] !== s || e[16] !== d ? (f = /* @__PURE__ */ F(zt, { children: [
    d,
    s
  ] }), e[15] = s, e[16] = d, e[17] = f) : f = e[17];
  const p = f;
  if (i === "div") {
    const b = o;
    let v;
    return e[18] !== p || e[19] !== b ? (v = /* @__PURE__ */ m("div", { className: Yg, ...b, children: p }), e[18] = p, e[19] = b, e[20] = v) : v = e[20], v;
  }
  const g = o;
  let h;
  return e[21] !== p || e[22] !== g ? (h = /* @__PURE__ */ m("form", { className: Yg, ...g, children: p }), e[21] = p, e[22] = g, e[23] = h) : h = e[23], h;
}
function VM(t) {
  return !jb(t);
}
function jb(t) {
  return x.isValidElement(t) && t.type === FM;
}
const _M = ce(["font-(family-name:--font-family-title)", "font-(number:--font-weight-medium)", "text-text-default", "tracking-(--font-letter-spacing-default)", "shrink-0"], {
  variants: {
    variant: {
      main: ["text-(length:--font-size-title-xl)", "leading-(--font-line-height-28)"],
      subsection: ["text-(length:--font-size-title-md)", "leading-(--font-line-height-24)"]
    }
  }
}), AM = ce(["font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-text-subtext", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]);
function wD(t) {
  const e = z.c(30), {
    variant: n,
    title: o,
    description: r,
    titleAccessory: i,
    actions: s,
    children: l
  } = t, a = n === "main" ? "h2" : "h3", c = x.useId(), u = r != null, d = u ? `${c}-description` : void 0;
  let f;
  e[0] !== o ? (f = /* @__PURE__ */ m("legend", { className: "sr-only", children: o }), e[0] = o, e[1] = f) : f = e[1];
  let p;
  e[2] !== n ? (p = _M({
    variant: n
  }), e[2] = n, e[3] = p) : p = e[3];
  let g;
  e[4] !== a || e[5] !== p || e[6] !== o ? (g = /* @__PURE__ */ m(a, { className: p, children: o }), e[4] = a, e[5] = p, e[6] = o, e[7] = g) : g = e[7];
  const h = i != null && i;
  let b;
  e[8] !== g || e[9] !== h ? (b = /* @__PURE__ */ F("div", { className: "flex items-center gap-(--spacing-6)", children: [
    g,
    h
  ] }), e[8] = g, e[9] = h, e[10] = b) : b = e[10];
  let v;
  e[11] !== r || e[12] !== u || e[13] !== c ? (v = u && /* @__PURE__ */ m("p", { id: `${c}-description`, className: ne(AM(), "mt-(--spacing-6)"), children: r }), e[11] = r, e[12] = u, e[13] = c, e[14] = v) : v = e[14];
  let C;
  e[15] !== b || e[16] !== v ? (C = /* @__PURE__ */ F("div", { className: "flex-1 min-w-0", children: [
    b,
    v
  ] }), e[15] = b, e[16] = v, e[17] = C) : C = e[17];
  let y;
  e[18] !== s ? (y = s != null && /* @__PURE__ */ m("div", { className: "shrink-0", children: s }), e[18] = s, e[19] = y) : y = e[19];
  let w;
  e[20] !== C || e[21] !== y ? (w = /* @__PURE__ */ F("div", { className: "flex items-start gap-(--spacing-12)", children: [
    C,
    y
  ] }), e[20] = C, e[21] = y, e[22] = w) : w = e[22];
  let R;
  e[23] !== l ? (R = l != null && /* @__PURE__ */ m("div", { className: "mt-(--spacing-16) flex flex-col", children: l }), e[23] = l, e[24] = R) : R = e[24];
  let S;
  return e[25] !== d || e[26] !== w || e[27] !== R || e[28] !== f ? (S = /* @__PURE__ */ F("fieldset", { "aria-describedby": d, className: "border-0 p-0 m-0 min-w-0", children: [
    f,
    w,
    R
  ] }), e[25] = d, e[26] = w, e[27] = R, e[28] = f, e[29] = S) : S = e[29], S;
}
const LM = ne("font-(family-name:--font-family-label)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-20)", "text-text-default", "text-(length:--font-size-label-lg)", "tracking-(--font-letter-spacing-default)", "whitespace-nowrap", "shrink-0");
function SD(t) {
  const e = z.c(10), {
    columns: n
  } = t, [o, r] = n, i = n.length === 2 ? "justify-between" : "justify-center";
  let s;
  e[0] !== i ? (s = ne("flex w-[212px] items-start p-0", i), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ m(jg, { column: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r != null && /* @__PURE__ */ m(jg, { column: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  return e[6] !== s || e[7] !== l || e[8] !== a ? (c = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    a
  ] }), e[6] = s, e[7] = l, e[8] = a, e[9] = c) : c = e[9], c;
}
function jg(t) {
  const e = z.c(7), {
    column: n
  } = t;
  let o;
  e[0] !== n.icon ? (o = n.icon != null && /* @__PURE__ */ m(Ke, { name: n.icon, size: "sm", "aria-hidden": !0 }), e[0] = n.icon, e[1] = o) : o = e[1];
  let r;
  e[2] !== n.label ? (r = /* @__PURE__ */ m("span", { className: LM, children: n.label }), e[2] = n.label, e[3] = r) : r = e[3];
  let i;
  return e[4] !== o || e[5] !== r ? (i = /* @__PURE__ */ F("div", { className: "flex flex-1 items-center justify-end gap-(--spacing-8) min-w-0 overflow-hidden", children: [
    o,
    r
  ] }), e[4] = o, e[5] = r, e[6] = i) : i = e[6], i;
}
function FM(t) {
  const e = z.c(18);
  let n, o, r;
  e[0] !== t ? ({
    leading: o,
    actions: n,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  let i;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ m("div", { "aria-hidden": "true", className: "pointer-events-none h-[58px] w-full shrink-0 bg-gradient-to-b from-surface-0 to-surface mb-[-12px]" }), e[4] = i) : i = e[4];
  const s = o != null && n != null ? "sm:justify-between" : n != null ? "sm:justify-end" : "sm:justify-start";
  let l;
  e[5] !== s ? (l = ne("flex flex-col items-stretch gap-(--spacing-16) overflow-hidden border-t border-outline-subtle bg-surface p-(--spacing-16) shrink-0 rounded-b-(--radius-sm) sm:flex-row sm:items-center", s), e[5] = s, e[6] = l) : l = e[6];
  let a;
  e[7] !== o ? (a = o != null && /* @__PURE__ */ m("div", { className: "min-w-0 w-full sm:flex-1", children: o }), e[7] = o, e[8] = a) : a = e[8];
  let c;
  e[9] !== n ? (c = n != null && /* @__PURE__ */ m("div", { className: "flex flex-wrap items-center justify-end gap-(--spacing-16) self-end sm:flex-nowrap sm:self-auto sm:shrink-0", children: n }), e[9] = n, e[10] = c) : c = e[10];
  let u;
  e[11] !== l || e[12] !== a || e[13] !== c ? (u = /* @__PURE__ */ F("div", { className: l, children: [
    a,
    c
  ] }), e[11] = l, e[12] = a, e[13] = c, e[14] = u) : u = e[14];
  let d;
  return e[15] !== r || e[16] !== u ? (d = /* @__PURE__ */ F("footer", { role: "none", className: "sticky bottom-0 flex flex-col", ...r, children: [
    i,
    u
  ] }), e[15] = r, e[16] = u, e[17] = d) : d = e[17], d;
}
const $M = ce(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface-scrim", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-200", "ease-in-out", "motion-reduce:transition-none"]), HM = ce(["pointer-events-none", "fixed", "inset-0", "flex", "flex-col", "gap-(--spacing-10)", "px-(--spacing-24)", "pt-(--spacing-20)", "pb-(--spacing-32)", "outline-none"]), zM = ce(["pointer-events-auto", "max-h-full", "max-w-full", "rounded-(--radius-sm)", "object-contain", "opacity-100", "transition-opacity", "duration-200", "ease-in-out", "starting:opacity-0", "motion-reduce:transition-none"]);
function RD(t) {
  const e = z.c(42), {
    open: n,
    onOpenChange: o,
    images: r,
    index: i,
    onIndexChange: s,
    "aria-label": l
  } = t, a = l === void 0 ? "Image viewer" : l, c = qt(), u = r[i], d = r.length > 0;
  let f;
  e[0] !== d || e[1] !== r.length || e[2] !== i || e[3] !== s ? (f = () => {
    d && s((i - 1 + r.length) % r.length);
  }, e[0] = d, e[1] = r.length, e[2] = i, e[3] = s, e[4] = f) : f = e[4];
  const p = f;
  let g;
  e[5] !== d || e[6] !== r.length || e[7] !== i || e[8] !== s ? (g = () => {
    d && s((i + 1) % r.length);
  }, e[5] = d, e[6] = r.length, e[7] = i, e[8] = s, e[9] = g) : g = e[9];
  const h = g;
  let b;
  e[10] !== h || e[11] !== p ? (b = (O) => {
    O.altKey || O.ctrlKey || O.metaKey || (O.key === "ArrowLeft" && (O.preventDefault(), p()), O.key === "ArrowRight" && (O.preventDefault(), h()));
  }, e[10] = h, e[11] = p, e[12] = b) : b = e[12];
  const v = b;
  let C;
  e[13] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = /* @__PURE__ */ m(Ns, { "data-slot": "lightbox-scrim", className: ne($M()) }), e[13] = C) : C = e[13];
  let y;
  e[14] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = ne(HM()), e[14] = y) : y = e[14];
  let w;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (w = /* @__PURE__ */ m("div", { className: "pointer-events-auto self-end", children: /* @__PURE__ */ m(Zr, { render: /* @__PURE__ */ m(mt, { icon: "x-close", "aria-label": "Close", variant: "outline", size: "md" }) }) }), e[15] = w) : w = e[15];
  const R = !d;
  let S;
  e[16] !== p || e[17] !== R ? (S = /* @__PURE__ */ m("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ m(mt, { icon: "arrow-left", "aria-label": "Previous image", variant: "outline", size: "md", disabled: R, onClick: p }) }), e[16] = p, e[17] = R, e[18] = S) : S = e[18];
  let E;
  e[19] !== u || e[20] !== i ? (E = u && /* @__PURE__ */ m("img", { src: u.src, alt: u.alt, className: ne(zM()) }, `${i}-${u.src}`), e[19] = u, e[20] = i, e[21] = E) : E = e[21];
  let N;
  e[22] !== E ? (N = /* @__PURE__ */ m("div", { "data-slot": "lightbox-image-container", className: "flex min-w-0 flex-1 self-stretch items-center justify-center", children: E }), e[22] = E, e[23] = N) : N = e[23];
  const T = !d;
  let P;
  e[24] !== h || e[25] !== T ? (P = /* @__PURE__ */ m("div", { className: "pointer-events-auto shrink-0", children: /* @__PURE__ */ m(mt, { icon: "arrow-right-regular", "aria-label": "Next image", variant: "outline", size: "md", disabled: T, onClick: h }) }), e[24] = h, e[25] = T, e[26] = P) : P = e[26];
  let I;
  e[27] !== N || e[28] !== P || e[29] !== S ? (I = /* @__PURE__ */ F("div", { className: "flex min-h-0 flex-1 items-center gap-(--spacing-24)", children: [
    S,
    N,
    P
  ] }), e[27] = N, e[28] = P, e[29] = S, e[30] = I) : I = e[30];
  let k;
  e[31] !== a || e[32] !== v || e[33] !== I ? (k = /* @__PURE__ */ m(bi, { className: "pointer-events-none fixed inset-0 z-[var(--z-layer-dialog)]", children: /* @__PURE__ */ F(mi, { "aria-label": a, "aria-modal": "true", "data-slot": "lightbox", className: y, onKeyDown: v, children: [
    w,
    I
  ] }) }), e[31] = a, e[32] = v, e[33] = I, e[34] = k) : k = e[34];
  let M;
  e[35] !== c || e[36] !== k ? (M = /* @__PURE__ */ F(Tr, { container: c, children: [
    C,
    k
  ] }), e[35] = c, e[36] = k, e[37] = M) : M = e[37];
  let D;
  return e[38] !== o || e[39] !== n || e[40] !== M ? (D = /* @__PURE__ */ m(hi, { open: n, onOpenChange: o, modal: !0, children: M }), e[38] = o, e[39] = n, e[40] = M, e[41] = D) : D = e[41], D;
}
const BM = ne("group relative flex  w-full flex-col items-stretch justify-center overflow-hidden", "min-w-0 flex-1", "border-0 border-b border-solid border-b-outline-subtle", "bg-surface", "p-(--spacing-16)", "text-left", "transition-colors duration-200 ease-in-out", "after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:w-(--spacing-4)", "after:bg-primary after:opacity-0 after:transition-opacity after:duration-200 after:ease-in-out after:content-['']", "data-[state=active]:bg-primary/8 data-[state=active]:after:opacity-100", "cursor-pointer", "hover:bg-surface-hover", "active:bg-surface-pressed", "focus-visible:z-10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-button-focus-ring", "disabled:pointer-events-none disabled:opacity-50");
function ED(t) {
  const e = z.c(9);
  let n, o, r;
  e[0] !== t ? ({
    active: r,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? !1 : r, s = i ? "active" : "default";
  let l;
  return e[4] !== i || e[5] !== n || e[6] !== o || e[7] !== s ? (l = /* @__PURE__ */ m(Qn, { type: "button", "data-slot": "list-card", "data-state": s, "aria-pressed": i, className: BM, ...o, children: n }), e[4] = i, e[5] = n, e[6] = o, e[7] = s, e[8] = l) : l = e[8], l;
}
const WM = ce(["flex", "items-center", "gap-(--spacing-4)", "w-full", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "text-input-text-default", "transition-colors", "duration-200", "ease-in-out", "outline-none", "cursor-pointer", "[&_svg]:shrink-0", "data-[readonly]:bg-input-readonly-background", "data-[readonly]:cursor-default", "[&:not([data-readonly]):not([data-popup-open])]:hover:bg-input-hover-background", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-hover-outline", "[&:not([data-readonly])[data-popup-open]]:border-input-active-outline", "[&:not([data-readonly])]:active:border-input-pressed-outline", "[&:not([data-readonly])]:focus-visible:ring-2", "[&:not([data-readonly])]:focus-visible:ring-input-focus-ring", "[&:not([data-readonly])]:focus-visible:ring-offset-1"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "px-(--spacing-10)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "px-(--spacing-10)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), Kg = ["inline-flex", "items-center", "gap-(--spacing-4)", "h-(--spacing-24)", "bg-chip-neutral-container", "text-chip-neutral-label", "rounded-(--radius-sm)", "px-(--spacing-6)", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-medium)", "leading-(--font-line-height-20)", "font-(number:--font-weight-medium)", "whitespace-nowrap", "overflow-hidden", "max-w-full", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"];
function Sc(t, e) {
  return t.find((n) => n.value === e)?.label ?? e;
}
function UM(t, e) {
  return e.flatMap((n) => {
    const o = t.find((r) => r.value === n);
    return o ? [o] : [];
  });
}
function ND(t) {
  const e = z.c(111), {
    options: n,
    value: o,
    onChange: r,
    defaultValue: i,
    placeholder: s,
    size: l,
    label: a,
    tooltip: c,
    required: u,
    description: d,
    error: f,
    disabled: p,
    readOnly: g,
    name: h,
    reserveSubtextSpace: b
  } = t, v = l === void 0 ? "md" : l, C = g === void 0 ? !1 : g, y = b === void 0 ? !0 : b, w = qt(), R = ft(null), S = !!f, N = y || S || !!d, T = o !== void 0;
  let P;
  e[0] !== i ? (P = i ?? [], e[0] = i, e[1] = P) : P = e[1];
  const [I, k] = ot(P), [M, D] = ot(!1), O = M && !C;
  let V, _;
  e[2] !== C ? (V = () => {
    C && D(!1);
  }, _ = [C], e[2] = C, e[3] = V, e[4] = _) : (V = e[3], _ = e[4]), kt(V, _);
  const A = T ? o : I;
  let L;
  e[5] !== A || e[6] !== n ? (L = UM(n, A), e[5] = A, e[6] = n, e[7] = L) : L = e[7];
  const B = L;
  let G;
  e[8] !== A ? (G = {
    items: A
  }, e[8] = A, e[9] = G) : G = e[9];
  const {
    containerRef: U,
    measuringContainerRef: Y,
    itemRefs: K,
    overflowRefs: j,
    visibleItems: Z,
    overflowCount: te
  } = x2(G);
  let W;
  e[10] !== T || e[11] !== r ? (W = function(Oe) {
    const Ie = Oe.map(ZM);
    T || k(Ie), r?.(Ie);
  }, e[10] = T, e[11] = r, e[12] = W) : W = e[12];
  const X = W;
  let ee;
  e[13] !== a || e[14] !== u || e[15] !== c ? (ee = a && /* @__PURE__ */ m(gi, { label: a, required: u, tooltip: c }), e[13] = a, e[14] = u, e[15] = c, e[16] = ee) : ee = e[16];
  let le;
  e[17] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (le = (ye, Oe) => {
    if (!ye && Oe.reason === "item-press") {
      Oe.cancel();
      return;
    }
    D(ye);
  }, e[17] = le) : le = e[17];
  let J;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (J = /* @__PURE__ */ m("div", {}), e[18] = J) : J = e[18];
  let ie;
  e[19] !== p || e[20] !== S || e[21] !== v ? (ie = ne(WM({
    size: v
  }), p ? "opacity-50 cursor-not-allowed" : "cursor-pointer", !S && "data-[readonly]:border-input-readonly-outline", S && ["border-input-error-outline", "[&:not([data-readonly]):not([data-popup-open])]:hover:border-input-error-outline"]), e[19] = p, e[20] = S, e[21] = v, e[22] = ie) : ie = e[22];
  const pe = u || void 0, oe = C ? -1 : void 0;
  let re;
  e[23] !== C ? (re = (ye) => {
    C && ye.preventDefault();
  }, e[23] = C, e[24] = re) : re = e[24];
  let de;
  e[25] !== A.length || e[26] !== p || e[27] !== n || e[28] !== te || e[29] !== C || e[30] !== Z ? (de = A.length > 0 && /* @__PURE__ */ F(zt, { children: [
    Z.map((ye) => C ? /* @__PURE__ */ m(Kn, { label: Sc(n, ye), tone: "neutral" }, ye) : /* @__PURE__ */ F(D0, { className: ne(Kg), children: [
      /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate", children: Sc(n, ye) }),
      !p && /* @__PURE__ */ m(V0, { className: "inline-flex shrink-0 cursor-pointer items-center text-icon-secondary rounded-(--radius-xs) focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-offset-surface focus-visible:ring-button-focus-ring", "aria-label": "Remove", onMouseDown: YM, children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" }) })
    ] }, ye)),
    te > 0 && /* @__PURE__ */ m(Kn, { label: `+${te}`, tone: "neutral" })
  ] }), e[25] = A.length, e[26] = p, e[27] = n, e[28] = te, e[29] = C, e[30] = Z, e[31] = de) : de = e[31];
  const xe = C ? a ?? "Select option" : a ? `Search ${a}` : "Search options", se = C ? -1 : void 0;
  let fe;
  e[32] !== C ? (fe = (ye) => {
    C && ye.preventDefault();
  }, e[32] = C, e[33] = fe) : fe = e[33];
  const $ = !C && A.length === 0 ? s : void 0;
  let Q;
  e[34] !== p || e[35] !== xe || e[36] !== se || e[37] !== fe || e[38] !== $ ? (Q = /* @__PURE__ */ m(Is, { "aria-label": xe, className: "min-w-0 flex-1 bg-transparent outline-none text-left text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-input-text-default placeholder:text-input-text-placeholder", disabled: p, tabIndex: se, onMouseDown: fe, placeholder: $ }), e[34] = p, e[35] = xe, e[36] = se, e[37] = fe, e[38] = $, e[39] = Q) : Q = e[39];
  let H;
  e[40] !== U || e[41] !== de || e[42] !== Q ? (H = /* @__PURE__ */ F(O0, { ref: U, "data-multi-select-chips": "", className: "flex flex-1 min-w-0 items-center gap-(--spacing-4) cursor-[inherit]", children: [
    de,
    Q
  ] }), e[40] = U, e[41] = de, e[42] = Q, e[43] = H) : H = e[43];
  let q;
  e[44] !== p || e[45] !== C ? (q = !p && !C && /* @__PURE__ */ m(Of, { className: "shrink-0 inline-flex items-center text-icon-secondary", "aria-label": "Clear all", onMouseDown: GM, children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" }) }), e[44] = p, e[45] = C, e[46] = q) : q = e[46];
  let ae;
  e[47] !== C ? (ae = !C && /* @__PURE__ */ m("span", { className: "shrink-0 text-input-text-default inline-flex transition-transform duration-200 [[data-popup-open]_&]:rotate-180 pointer-events-none", children: /* @__PURE__ */ m(Ke, { name: "chevron-down", size: "xs", tone: "inherit" }) }), e[47] = C, e[48] = ae) : ae = e[48];
  let ge;
  e[49] !== ie || e[50] !== pe || e[51] !== oe || e[52] !== re || e[53] !== H || e[54] !== q || e[55] !== ae ? (ge = /* @__PURE__ */ F(ya, { ref: R, render: J, nativeButton: !1, className: ie, "aria-required": pe, tabIndex: oe, onMouseDown: re, children: [
    H,
    q,
    ae
  ] }), e[49] = ie, e[50] = pe, e[51] = oe, e[52] = re, e[53] = H, e[54] = q, e[55] = ae, e[56] = ge) : ge = e[56];
  let ue;
  e[57] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ue = ws({
    size: "auto"
  }), e[57] = ue) : ue = e[57];
  let Re;
  e[58] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Re = (ye) => {
    ye.key === "Escape" && D(!1);
  }, e[58] = Re) : Re = e[58];
  let be;
  e[59] !== A ? (be = /* @__PURE__ */ m(Ps, { className: "flex flex-col outline-none", onKeyDownCapture: Re, children: (ye) => {
    const Oe = A.includes(ye.value);
    return /* @__PURE__ */ m(Ts, { value: ye, disabled: ye.disabled, className: Ko({}), children: /* @__PURE__ */ m(Xi, { checked: Oe, checkbox: !0, children: ye.label }) }, ye.value);
  } }), e[59] = A, e[60] = be) : be = e[60];
  let ve;
  e[61] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ve = /* @__PURE__ */ m(Tf, { className: "[&:empty]:p-0 px-(--spacing-10) py-(--spacing-8) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: "No results available" }), e[61] = ve) : ve = e[61];
  let me;
  e[62] !== be ? (me = /* @__PURE__ */ m(Ca, { anchor: R, align: "start", sideOffset: 4, className: "z-[var(--z-layer-popover)] w-(--anchor-width)", children: /* @__PURE__ */ F(wa, { className: ue, children: [
    be,
    ve
  ] }) }), e[62] = be, e[63] = me) : me = e[63];
  let Ee;
  e[64] !== w || e[65] !== me ? (Ee = /* @__PURE__ */ m(xa, { container: w, children: me }), e[64] = w, e[65] = me, e[66] = Ee) : Ee = e[66];
  let Pe;
  if (e[67] !== K || e[68] !== A || e[69] !== p || e[70] !== n || e[71] !== C) {
    let ye;
    e[73] !== K || e[74] !== p || e[75] !== n || e[76] !== C ? (ye = (Oe, Ie) => /* @__PURE__ */ m("span", { ref: (Le) => {
      K.current[Ie] = Le;
    }, "data-label": Sc(n, Oe), "data-multi-select-measure": "chip", "data-multi-select-measure-index": Ie, className: ne(Kg, "max-w-none before:content-[attr(data-label)]"), children: !p && !C && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 items-center text-icon-secondary", children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" }) }) }, `chip-measure-${Oe}`), e[73] = K, e[74] = p, e[75] = n, e[76] = C, e[77] = ye) : ye = e[77], Pe = A.map(ye), e[67] = K, e[68] = A, e[69] = p, e[70] = n, e[71] = C, e[72] = Pe;
  } else
    Pe = e[72];
  let Me;
  if (e[78] !== A || e[79] !== j) {
    let ye;
    e[81] !== j ? (ye = (Oe, Ie) => {
      const Le = Ie + 1;
      return /* @__PURE__ */ m("span", { ref: (Be) => {
        j.current[Le] = Be;
      }, "data-label": `+${Le}`, "data-multi-select-measure": "overflow", "data-multi-select-measure-count": Le, className: "inline-flex items-center justify-center max-w-none gap-(--spacing-4) h-(--spacing-24) rounded-(--radius-sm) overflow-hidden font-(family-name:--font-family-label) text-(length:--font-size-label-medium) leading-(--font-line-height-20) font-(--font-weight-medium) whitespace-nowrap bg-chip-neutral-container text-chip-neutral-label px-(--spacing-6) py-(--spacing-4) before:content-[attr(data-label)]" }, `overflow-measure-${Le}`);
    }, e[81] = j, e[82] = ye) : ye = e[82], Me = A.slice(1).map(ye), e[78] = A, e[79] = j, e[80] = Me;
  } else
    Me = e[80];
  let _e;
  e[83] !== Y || e[84] !== Pe || e[85] !== Me ? (_e = /* @__PURE__ */ m("div", { "aria-hidden": "true", className: "pointer-events-none invisible absolute left-0 top-0 h-0 overflow-hidden", children: /* @__PURE__ */ F("div", { ref: Y, className: "inline-flex w-max items-center gap-(--spacing-4)", children: [
    Pe,
    Me
  ] }) }), e[83] = Y, e[84] = Pe, e[85] = Me, e[86] = _e) : _e = e[86];
  let Ue;
  e[87] !== p || e[88] !== X || e[89] !== O || e[90] !== h || e[91] !== n || e[92] !== C || e[93] !== u || e[94] !== B || e[95] !== ge || e[96] !== Ee || e[97] !== _e ? (Ue = /* @__PURE__ */ F(yf, { multiple: !0, value: B, onValueChange: X, disabled: p, readOnly: C, required: u, name: h, modal: !1, open: O, onOpenChange: le, items: n, isItemEqualToValue: qM, itemToStringLabel: KM, itemToStringValue: jM, children: [
    ge,
    Ee,
    _e
  ] }), e[87] = p, e[88] = X, e[89] = O, e[90] = h, e[91] = n, e[92] = C, e[93] = u, e[94] = B, e[95] = ge, e[96] = Ee, e[97] = _e, e[98] = Ue) : Ue = e[98];
  let Ye;
  e[99] !== d || e[100] !== f || e[101] !== S || e[102] !== y || e[103] !== N ? (Ye = N && /* @__PURE__ */ m("div", { "data-testid": "multi-select-subtext-row", className: ne("mt-(--spacing-4)", y && "min-h-(--spacing-20)"), children: S ? /* @__PURE__ */ m(Pr, { match: !0, className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-error-text", children: f }) : d ? /* @__PURE__ */ m(fi, { className: "text-(length:--font-size-label-small) leading-(--font-line-height-16) text-input-text-supporting", children: d }) : null }), e[99] = d, e[100] = f, e[101] = S, e[102] = y, e[103] = N, e[104] = Ye) : Ye = e[104];
  let He;
  return e[105] !== p || e[106] !== S || e[107] !== ee || e[108] !== Ue || e[109] !== Ye ? (He = /* @__PURE__ */ F(Ir, { invalid: S, disabled: p, className: "relative flex flex-col w-full", children: [
    ee,
    Ue,
    Ye
  ] }), e[105] = p, e[106] = S, e[107] = ee, e[108] = Ue, e[109] = Ye, e[110] = He) : He = e[110], He;
}
function GM(t) {
  return t.stopPropagation();
}
function YM(t) {
  return t.stopPropagation();
}
function jM(t) {
  return t.value;
}
function KM(t) {
  return t.label;
}
function qM(t, e) {
  return t.value === e.value;
}
function ZM(t) {
  return t.value;
}
const XM = [10, 25, 50, 100];
function Zo(t, e) {
  return Number.isFinite(t) && t > 0 ? Math.floor(t) : e;
}
function xi(t, e) {
  const n = Zo(e, 1), o = Zo(t, 1);
  return Math.min(Math.max(o, 1), n);
}
function Kb(t, e) {
  const n = Zo(e, 1), o = xi(t, n);
  return n === 1 ? "none" : o === 1 ? "right" : o === n ? "left" : "both";
}
function QM(t, e) {
  const n = Zo(e, 1), o = xi(t, n);
  return n <= 4 ? Array.from({
    length: n
  }, (r, i) => ({
    type: "page",
    page: i + 1
  })) : o <= 3 ? [{
    type: "page",
    page: 1
  }, {
    type: "page",
    page: 2
  }, {
    type: "page",
    page: 3
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }] : o >= n - 2 ? [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: n - 2
  }, {
    type: "page",
    page: n - 1
  }, {
    type: "page",
    page: n
  }] : [{
    type: "page",
    page: 1
  }, {
    type: "ellipsis",
    key: "start-ellipsis"
  }, {
    type: "page",
    page: o - 1
  }, {
    type: "page",
    page: o
  }, {
    type: "page",
    page: o + 1
  }, {
    type: "ellipsis",
    key: "end-ellipsis"
  }, {
    type: "page",
    page: n
  }];
}
function JM({
  currentPage: t,
  rowsPerPage: e,
  totalItems: n,
  totalPages: o
}) {
  const r = Math.max(0, Math.floor(n));
  if (r === 0)
    return "0 - 0 of 0";
  const i = Zo(e, r), s = xi(t, o), l = (s - 1) * i + 1, a = Math.min(s * i, r);
  return `${l} - ${a} of ${r}`;
}
function eI(t, e) {
  return e ? `Page ${t}, current page` : `Go to page ${t}`;
}
function Kl(t) {
  const e = z.c(11), {
    direction: n,
    disabled: o,
    mobile: r,
    onClick: i
  } = t, s = r === void 0 ? !1 : r, l = n === "previous", a = l ? "Previous page" : "Next page", c = s ? "size-[44px]" : "size-(--spacing-32)", u = o ? "cursor-default text-icon-disabled" : "cursor-pointer text-surface-on-surface hover:bg-surface-hover active:bg-surface-pressed";
  let d;
  e[0] !== c || e[1] !== u ? (d = ne("inline-flex shrink-0 items-center justify-center rounded-(--radius-sm) border-0 bg-transparent p-0 outline-none transition-colors duration-200 ease-in-out", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", c, u), e[0] = c, e[1] = u, e[2] = d) : d = e[2];
  const f = l ? "chevron-left" : "chevron-right";
  let p;
  e[3] !== f ? (p = /* @__PURE__ */ m(Ke, { name: f, size: "xs", tone: "inherit" }), e[3] = f, e[4] = p) : p = e[4];
  let g;
  return e[5] !== o || e[6] !== i || e[7] !== a || e[8] !== d || e[9] !== p ? (g = /* @__PURE__ */ m("button", { type: "button", "aria-label": a, disabled: o, onClick: i, className: d, children: p }), e[5] = o, e[6] = i, e[7] = a, e[8] = d, e[9] = p, e[10] = g) : g = e[10], g;
}
function qg(t) {
  const e = z.c(26), {
    currentPage: n,
    totalPages: o,
    onPageChange: r,
    showPageIndicator: i
  } = t, s = i === void 0 ? !1 : i;
  let l, a, c;
  e[0] !== n || e[1] !== o ? (a = Zo(o, 1), l = xi(n, a), c = Kb(l, a), e[0] = n, e[1] = o, e[2] = l, e[3] = a, e[4] = c) : (l = e[2], a = e[3], c = e[4]);
  const u = c, d = u === "both" || u === "left", f = u === "both" || u === "right", p = !d;
  let g;
  e[5] !== r || e[6] !== l ? (g = () => r(l - 1), e[5] = r, e[6] = l, e[7] = g) : g = e[7];
  let h;
  e[8] !== p || e[9] !== g ? (h = /* @__PURE__ */ m(Kl, { direction: "previous", disabled: p, onClick: g }), e[8] = p, e[9] = g, e[10] = h) : h = e[10];
  let b;
  e[11] !== r || e[12] !== l || e[13] !== a || e[14] !== s ? (b = s && /* @__PURE__ */ m(tI, { currentPage: l, totalPages: a, onPageChange: r }), e[11] = r, e[12] = l, e[13] = a, e[14] = s, e[15] = b) : b = e[15];
  const v = !f;
  let C;
  e[16] !== r || e[17] !== l ? (C = () => r(l + 1), e[16] = r, e[17] = l, e[18] = C) : C = e[18];
  let y;
  e[19] !== v || e[20] !== C ? (y = /* @__PURE__ */ m(Kl, { direction: "next", disabled: v, onClick: C }), e[19] = v, e[20] = C, e[21] = y) : y = e[21];
  let w;
  return e[22] !== h || e[23] !== b || e[24] !== y ? (w = /* @__PURE__ */ F("div", { className: "flex items-center justify-center gap-(--spacing-12)", children: [
    h,
    b,
    y
  ] }), e[22] = h, e[23] = b, e[24] = y, e[25] = w) : w = e[25], w;
}
function tI(t) {
  const e = z.c(9), {
    currentPage: n,
    totalPages: o,
    onPageChange: r
  } = t;
  let i;
  if (e[0] !== n || e[1] !== r || e[2] !== o) {
    let l;
    e[4] !== n || e[5] !== r ? (l = (a) => {
      if (a.type === "ellipsis")
        return /* @__PURE__ */ m(nI, {}, a.key);
      const c = a.page === n;
      return /* @__PURE__ */ m("button", { type: "button", "aria-label": eI(a.page, c), "aria-current": c ? "page" : void 0, onClick: () => r(a.page), className: ne("inline-flex min-w-(--spacing-20) items-center justify-center rounded-(--radius-sm) px-(--spacing-6) py-(--spacing-2)", "font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20)", "outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", c ? "bg-primary text-primary-on-primary" : "cursor-pointer text-text-subtle hover:bg-surface-hover active:bg-surface-pressed"), children: a.page }, a.page);
    }, e[4] = n, e[5] = r, e[6] = l) : l = e[6], i = QM(n, o).map(l), e[0] = n, e[1] = r, e[2] = o, e[3] = i;
  } else
    i = e[3];
  let s;
  return e[7] !== i ? (s = /* @__PURE__ */ m("div", { className: "flex items-center justify-center gap-(--spacing-10)", children: i }), e[7] = i, e[8] = s) : s = e[8], s;
}
function nI() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("span", { className: "select-none whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-default", children: "..." }), t[0] = e) : e = t[0], e;
}
function oI(t) {
  const e = z.c(16), {
    selectId: n,
    rowsPerPage: o,
    rowsPerPageOptions: r,
    disabled: i,
    onRowsPerPageChange: s,
    onPageChange: l
  } = t, a = i === void 0 ? !1 : i;
  let c;
  e[0] !== n ? (c = /* @__PURE__ */ m("label", { htmlFor: n, className: "whitespace-nowrap font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: "Rows per page" }), e[0] = n, e[1] = c) : c = e[1];
  const u = String(o);
  let d;
  e[2] !== r ? (d = r.map(rI), e[2] = r, e[3] = d) : d = e[3];
  let f;
  e[4] !== l || e[5] !== s ? (f = (h) => {
    h != null && (s(Number(h)), l(1));
  }, e[4] = l, e[5] = s, e[6] = f) : f = e[6];
  let p;
  e[7] !== a || e[8] !== n || e[9] !== u || e[10] !== d || e[11] !== f ? (p = /* @__PURE__ */ m("div", { className: "h-(--spacing-32) w-(--spacing-80) shrink-0", children: /* @__PURE__ */ m(A0, { id: n, size: "sm", value: u, disabled: a, reserveSubtextSpace: !1, options: d, onChange: f }) }), e[7] = a, e[8] = n, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : p = e[12];
  let g;
  return e[13] !== c || e[14] !== p ? (g = /* @__PURE__ */ F("div", { className: "flex h-(--spacing-40) w-[188px] shrink-0 items-center justify-between gap-(--spacing-12)", children: [
    c,
    p
  ] }), e[13] = c, e[14] = p, e[15] = g) : g = e[15], g;
}
function rI(t) {
  return {
    value: String(t),
    label: String(t)
  };
}
function iI(t) {
  const e = z.c(22), {
    rangeLabel: n,
    currentPage: o,
    totalPages: r,
    onPageChange: i
  } = t;
  let s, l;
  if (e[0] !== o || e[1] !== r) {
    const y = Zo(r, 1);
    s = xi(o, y), l = Kb(s, y), e[0] = o, e[1] = r, e[2] = s, e[3] = l;
  } else
    s = e[2], l = e[3];
  const a = l, c = a === "both" || a === "left", u = a === "both" || a === "right", d = !c;
  let f;
  e[4] !== i || e[5] !== s ? (f = () => i(s - 1), e[4] = i, e[5] = s, e[6] = f) : f = e[6];
  let p;
  e[7] !== d || e[8] !== f ? (p = /* @__PURE__ */ m(Kl, { direction: "previous", mobile: !0, disabled: d, onClick: f }), e[7] = d, e[8] = f, e[9] = p) : p = e[9];
  let g;
  e[10] !== n ? (g = /* @__PURE__ */ m("span", { className: "min-w-0 truncate px-(--spacing-12) text-center font-(family-name:--font-family-label) text-(length:--font-size-label-medium) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: n }), e[10] = n, e[11] = g) : g = e[11];
  const h = !u;
  let b;
  e[12] !== i || e[13] !== s ? (b = () => i(s + 1), e[12] = i, e[13] = s, e[14] = b) : b = e[14];
  let v;
  e[15] !== h || e[16] !== b ? (v = /* @__PURE__ */ m(Kl, { direction: "next", mobile: !0, disabled: h, onClick: b }), e[15] = h, e[16] = b, e[17] = v) : v = e[17];
  let C;
  return e[18] !== p || e[19] !== g || e[20] !== v ? (C = /* @__PURE__ */ F("div", { className: "flex h-[44px] w-full items-center justify-between px-(--spacing-16) sm:hidden", children: [
    p,
    g,
    v
  ] }), e[18] = p, e[19] = g, e[20] = v, e[21] = C) : C = e[21], C;
}
function sI(t) {
  const e = z.c(28), {
    currentPage: n,
    totalPages: o,
    totalItems: r,
    rowsPerPage: i,
    onPageChange: s
  } = t, l = _t();
  let a, c, u, d;
  e[0] !== n || e[1] !== i || e[2] !== r || e[3] !== o ? (u = Zo(o, 1), c = xi(n, u), a = r <= 0, d = JM({
    currentPage: c,
    rowsPerPage: i,
    totalItems: r,
    totalPages: u
  }), e[0] = n, e[1] = i, e[2] = r, e[3] = o, e[4] = a, e[5] = c, e[6] = u, e[7] = d) : (a = e[4], c = e[5], u = e[6], d = e[7]);
  const f = d;
  let p;
  e[8] !== s || e[9] !== f || e[10] !== c || e[11] !== u ? (p = /* @__PURE__ */ m(iI, { rangeLabel: f, currentPage: c, totalPages: u, onPageChange: s }), e[8] = s, e[9] = f, e[10] = c, e[11] = u, e[12] = p) : p = e[12];
  let g;
  e[13] !== s || e[14] !== t.contextLabel || e[15] !== t.onRowsPerPageChange || e[16] !== t.rowsPerPageOptions || e[17] !== t.variant || e[18] !== f || e[19] !== i || e[20] !== a || e[21] !== l || e[22] !== c || e[23] !== u ? (g = t.variant === "simplified" ? /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) sm:flex", children: [
    /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: t.contextLabel }),
    /* @__PURE__ */ m("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ m(qg, { currentPage: c, totalPages: u, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ m("div", { className: "h-(--spacing-40) flex-1" })
  ] }) : /* @__PURE__ */ F("div", { className: "hidden h-[56px] w-full items-center justify-between px-(--spacing-24) sm:flex", children: [
    /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-large) font-(number:--font-weight-semibold) leading-(--font-line-height-20) text-text-subtext", children: f }),
    /* @__PURE__ */ m("div", { className: "flex flex-1 justify-center", children: /* @__PURE__ */ m(qg, { currentPage: c, totalPages: u, onPageChange: s, showPageIndicator: !0 }) }),
    /* @__PURE__ */ m("div", { className: "flex flex-1 justify-end", children: /* @__PURE__ */ m(oI, { selectId: l, rowsPerPage: i, rowsPerPageOptions: t.rowsPerPageOptions ?? XM, disabled: a, onRowsPerPageChange: t.onRowsPerPageChange, onPageChange: s }) })
  ] }), e[13] = s, e[14] = t.contextLabel, e[15] = t.onRowsPerPageChange, e[16] = t.rowsPerPageOptions, e[17] = t.variant, e[18] = f, e[19] = i, e[20] = a, e[21] = l, e[22] = c, e[23] = u, e[24] = g) : g = e[24];
  let h;
  return e[25] !== p || e[26] !== g ? (h = /* @__PURE__ */ F("nav", { "aria-label": "Table pagination", className: "w-full", children: [
    p,
    g
  ] }), e[25] = p, e[26] = g, e[27] = h) : h = e[27], h;
}
function kD(t) {
  const e = z.c(4), {
    open: n,
    onOpenChange: o,
    children: r
  } = t;
  let i;
  return e[0] !== r || e[1] !== o || e[2] !== n ? (i = /* @__PURE__ */ m(_f, { open: n, onOpenChange: o, modal: !1, children: r }), e[0] = r, e[1] = o, e[2] = n, e[3] = i) : i = e[3], i;
}
function MD(t) {
  const e = z.c(2), {
    render: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m(Sa, { render: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function ID(t) {
  const e = z.c(10), {
    children: n,
    side: o,
    align: r,
    sideOffset: i
  } = t, s = o === void 0 ? "bottom" : o, l = r === void 0 ? "start" : r, a = i === void 0 ? 4 : i, c = qt();
  let u;
  e[0] !== n ? (u = /* @__PURE__ */ m(Na, { children: n }), e[0] = n, e[1] = u) : u = e[1];
  let d;
  e[2] !== l || e[3] !== s || e[4] !== a || e[5] !== u ? (d = /* @__PURE__ */ m(Ea, { side: s, align: l, sideOffset: a, children: u }), e[2] = l, e[3] = s, e[4] = a, e[5] = u, e[6] = d) : d = e[6];
  let f;
  return e[7] !== c || e[8] !== d ? (f = /* @__PURE__ */ m(Ra, { container: c, children: d }), e[7] = c, e[8] = d, e[9] = f) : f = e[9], f;
}
const Zg = /* @__PURE__ */ new Map();
function lI(t, e) {
  const n = JSON.stringify({
    locale: t,
    options: e
  }), o = Zg.get(n);
  if (o)
    return o;
  const r = new Intl.NumberFormat(t, e);
  return Zg.set(n, r), r;
}
function Xg(t, e, n) {
  return t == null ? "" : lI(e, n).format(t);
}
function aI(t, e, n) {
  return t == null ? "" : n ? Xg(t, e, n) : Xg(t / 100, e, {
    style: "percent"
  });
}
const i1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (i1.displayName = "ProgressRootContext");
function qb() {
  const t = x.useContext(i1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ProgressRootContext is missing. Progress parts must be placed within <Progress.Root>." : rt(51));
  return t;
}
let Rc = /* @__PURE__ */ (function(t) {
  return t.complete = "data-complete", t.indeterminate = "data-indeterminate", t.progressing = "data-progressing", t;
})({});
const s1 = {
  status(t) {
    return t === "progressing" ? {
      [Rc.progressing]: ""
    } : t === "complete" ? {
      [Rc.complete]: ""
    } : t === "indeterminate" ? {
      [Rc.indeterminate]: ""
    } : null;
  }
};
function cI(t, e) {
  return e == null ? "indeterminate progress" : t || `${e}%`;
}
const l1 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    format: o,
    getAriaValueText: r = cI,
    locale: i,
    max: s = 100,
    min: l = 0,
    value: a,
    render: c,
    className: u,
    children: d,
    style: f,
    ...p
  } = e, [g, h] = x.useState(), b = $t(o);
  let v = "indeterminate";
  Number.isFinite(a) && (v = a === s ? "complete" : "progressing");
  const C = aI(a, i, b.current), y = x.useMemo(() => ({
    status: v
  }), [v]), w = {
    "aria-labelledby": g,
    "aria-valuemax": s,
    "aria-valuemin": l,
    "aria-valuenow": a ?? void 0,
    "aria-valuetext": r(C, a),
    role: "progressbar",
    children: /* @__PURE__ */ F(x.Fragment, {
      children: [d, /* @__PURE__ */ m("span", {
        role: "presentation",
        style: Jo,
        children: "x"
      })]
    })
  }, R = x.useMemo(() => ({
    formattedValue: C,
    max: s,
    min: l,
    setLabelId: h,
    state: y,
    status: v,
    value: a
  }), [C, s, l, h, y, v, a]), S = $e("div", e, {
    state: y,
    ref: n,
    props: [w, p],
    stateAttributesMapping: s1
  });
  return /* @__PURE__ */ m(i1.Provider, {
    value: R,
    children: S
  });
});
process.env.NODE_ENV !== "production" && (l1.displayName = "ProgressRoot");
const Zb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = qb();
  return $e("div", e, {
    state: l,
    ref: n,
    props: s,
    stateAttributesMapping: s1
  });
});
process.env.NODE_ENV !== "production" && (Zb.displayName = "ProgressTrack");
function uI(t, e, n) {
  return (t - e) * 100 / (n - e);
}
const Xb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    max: l,
    min: a,
    value: c,
    state: u
  } = qb(), d = Number.isFinite(c) && c !== null ? uI(c, a, l) : null, f = x.useCallback(() => d == null ? {} : {
    insetInlineStart: 0,
    height: "inherit",
    width: `${d}%`
  }, [d]);
  return $e("div", e, {
    state: u,
    ref: n,
    props: [{
      style: f()
    }, s],
    stateAttributesMapping: s1
  });
});
process.env.NODE_ENV !== "production" && (Xb.displayName = "ProgressIndicator");
const dI = {
  sm: "2px",
  md: "4px",
  lg: "8px"
}, fI = {
  brand: "bg-primary",
  positive: "bg-datavis-crit-green",
  warning: "bg-datavis-crit-yellow",
  negative: "bg-datavis-crit-red"
};
function PD(t) {
  const e = z.c(22);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    value: l,
    size: i,
    tone: s,
    "aria-label": n,
    "aria-labelledby": o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = i === void 0 ? "md" : i, c = s === void 0 ? "brand" : s;
  let u;
  e[7] !== l ? (u = Number.isFinite(l) ? Math.min(100, Math.max(0, l)) : 0, e[7] = l, e[8] = u) : u = e[8];
  const d = u, f = dI[a];
  let p;
  e[9] !== f ? (p = {
    height: f
  }, e[9] = f, e[10] = p) : p = e[10];
  const g = `absolute ${fI[c]}`;
  let h;
  e[11] !== g ? (h = /* @__PURE__ */ m(Xb, { className: g }), e[11] = g, e[12] = h) : h = e[12];
  let b;
  e[13] !== p || e[14] !== h ? (b = /* @__PURE__ */ m(Zb, { className: "relative w-full overflow-hidden bg-[hsl(var(--surface-inverse-surface)/0.2)]", style: p, children: h }), e[13] = p, e[14] = h, e[15] = b) : b = e[15];
  let v;
  return e[16] !== n || e[17] !== o || e[18] !== d || e[19] !== r || e[20] !== b ? (v = /* @__PURE__ */ m(l1, { ...r, value: d, "aria-label": n, "aria-labelledby": o, children: b }), e[16] = n, e[17] = o, e[18] = d, e[19] = r, e[20] = b, e[21] = v) : v = e[21], v;
}
const pI = {
  sm: {
    diameter: 16,
    stroke: 3
  },
  md: {
    diameter: 36,
    stroke: 5
  },
  lg: {
    diameter: 56,
    stroke: 7
  }
}, gI = {
  brand: "stroke-primary",
  positive: "stroke-datavis-crit-green",
  warning: "stroke-datavis-crit-yellow",
  negative: "stroke-datavis-crit-red"
};
function TD(t) {
  const e = z.c(40);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    value: a,
    size: s,
    tone: l,
    "aria-label": n,
    "aria-labelledby": o,
    style: i,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "md" : s, u = l === void 0 ? "brand" : l;
  let d;
  e[8] !== a ? (d = Number.isFinite(a) ? Math.min(100, Math.max(0, a)) : 0, e[8] = a, e[9] = d) : d = e[9];
  const f = d, {
    diameter: p,
    stroke: g
  } = pI[c], h = (p - g) / 2, b = 2 * Math.PI * h, v = b * (1 - f / 100), C = p / 2;
  let y;
  e[10] !== p ? (y = {
    display: "inline-flex",
    width: p,
    height: p
  }, e[10] = p, e[11] = y) : y = e[11];
  const w = y;
  let R;
  e[12] !== w || e[13] !== i ? (R = typeof i == "function" ? (V) => ({
    ...i(V),
    ...w
  }) : {
    ...i,
    ...w
  }, e[12] = w, e[13] = i, e[14] = R) : R = e[14];
  const S = R, E = `0 0 ${p} ${p}`;
  let N;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = {
    stroke: "hsl(var(--surface-inverse-surface) / 0.2)"
  }, e[15] = N) : N = e[15];
  let T;
  e[16] !== C || e[17] !== h || e[18] !== g ? (T = /* @__PURE__ */ m("circle", { cx: C, cy: C, r: h, strokeWidth: g, strokeLinecap: "butt", style: N }), e[16] = C, e[17] = h, e[18] = g, e[19] = T) : T = e[19];
  const P = `${b} ${b}`, I = gI[u];
  let k;
  e[20] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = {
    transform: "rotate(-90deg)",
    transformOrigin: "50% 50%"
  }, e[20] = k) : k = e[20];
  let M;
  e[21] !== C || e[22] !== v || e[23] !== h || e[24] !== g || e[25] !== I || e[26] !== P ? (M = /* @__PURE__ */ m("circle", { cx: C, cy: C, r: h, strokeWidth: g, strokeLinecap: "butt", strokeDasharray: P, strokeDashoffset: v, className: I, style: k }), e[21] = C, e[22] = v, e[23] = h, e[24] = g, e[25] = I, e[26] = P, e[27] = M) : M = e[27];
  let D;
  e[28] !== p || e[29] !== M || e[30] !== E || e[31] !== T ? (D = /* @__PURE__ */ F("svg", { width: p, height: p, viewBox: E, fill: "none", "aria-hidden": "true", children: [
    T,
    M
  ] }), e[28] = p, e[29] = M, e[30] = E, e[31] = T, e[32] = D) : D = e[32];
  let O;
  return e[33] !== n || e[34] !== o || e[35] !== f || e[36] !== r || e[37] !== S || e[38] !== D ? (O = /* @__PURE__ */ m(l1, { ...r, value: f, "aria-label": n, "aria-labelledby": o, style: S, children: D }), e[33] = n, e[34] = o, e[35] = f, e[36] = r, e[37] = S, e[38] = D, e[39] = O) : O = e[39], O;
}
let Qg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const gu = {
  checked(t) {
    return t ? {
      [Qg.checked]: ""
    } : {
      [Qg.unchecked]: ""
    };
  },
  ...Bt,
  ...to
}, a1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (a1.displayName = "RadioGroupContext");
function mI() {
  return x.useContext(a1);
}
const c1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (c1.displayName = "RadioRootContext");
function hI() {
  const t = x.useContext(c1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: RadioRootContext is missing. Radio parts must be placed within <Radio.Root>." : rt(52));
  return t;
}
const Qb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i = !1,
    readOnly: s = !1,
    required: l = !1,
    "aria-labelledby": a,
    value: c,
    inputRef: u,
    nativeButton: d = !1,
    id: f,
    style: p,
    ...g
  } = e, h = mI(), {
    disabled: b,
    readOnly: v,
    required: C,
    form: y,
    checkedValue: w,
    touched: R = !1,
    validation: S,
    name: E
  } = h ?? {}, N = h?.setCheckedValue ?? xt, T = h?.setTouched ?? xt, P = h?.registerControlRef ?? xt, I = h?.registerInputRef ?? xt, {
    setDirty: k,
    validityData: M,
    setTouched: D,
    setFilled: O,
    state: V,
    disabled: _
  } = tn(), A = M2(), {
    labelId: L,
    getDescriptionProps: B
  } = mn(), G = _ || A.disabled || b || i, U = v || s, Y = C || l, K = y, j = h ? w === c : c === "", Z = x.useMemo(() => Ul(c), [c]), te = x.useRef(null), W = x.useRef(null), X = Se((ae) => {
    ae && P(ae, G);
  }), ee = fn(u, W, I);
  ke(() => {
    W.current?.checked && O(!0);
  }, [O]), ke(() => {
    if (W.current) {
      if (G && j) {
        I(null);
        return;
      }
      te.current && P(te.current, G), I(W.current);
    }
  }, [j, G, P, I]);
  const le = Mt(), J = Mr({
    id: f,
    implicit: !1,
    controlRef: te
  }), ie = d ? void 0 : J, pe = Yd(a, L, W, !d, ie), oe = {
    role: "radio",
    "aria-checked": j,
    "aria-required": Y || void 0,
    "aria-readonly": U || void 0,
    "aria-labelledby": pe,
    [t1]: j ? "" : void 0,
    id: d ? J : le,
    onKeyDown(ae) {
      ae.key === "Enter" && ae.preventDefault();
    },
    onClick(ae) {
      ae.defaultPrevented || G || U || (ae.preventDefault(), W.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: ae.shiftKey,
        ctrlKey: ae.ctrlKey,
        altKey: ae.altKey,
        metaKey: ae.metaKey
      })));
    },
    onFocus(ae) {
      ae.defaultPrevented || G || U || !R || (W.current?.click(), T(!1));
    }
  }, {
    getButtonProps: re,
    buttonRef: de
  } = Wt({
    disabled: G,
    native: d
  }), xe = {
    type: "radio",
    ref: ee,
    form: K,
    id: ie,
    name: E,
    tabIndex: -1,
    style: E ? ti : Jo,
    "aria-hidden": !0,
    ...c !== void 0 ? {
      value: Z
    } : St,
    disabled: G,
    checked: j,
    required: Y,
    readOnly: U,
    onChange(ae) {
      if (ae.nativeEvent.defaultPrevented || G || U || c === void 0)
        return;
      const ge = Ve(Pt, ae.nativeEvent);
      ge.isCanceled || (D(!0), k(c !== M.initialValue), O(!0), N(c, ge));
    },
    onFocus() {
      te.current?.focus();
    }
  }, se = x.useMemo(() => ({
    ...V,
    required: Y,
    disabled: G,
    readOnly: U,
    checked: j
  }), [V, G, U, j, Y]), fe = se, $ = h !== void 0, Q = [n, te, de, X], H = [oe, B, S?.getValidationProps ?? St, g, re], q = $e("span", e, {
    enabled: !$,
    state: se,
    ref: Q,
    props: H,
    stateAttributesMapping: gu
  });
  return /* @__PURE__ */ F(c1.Provider, {
    value: fe,
    children: [$ ? /* @__PURE__ */ m(kd, {
      tag: "span",
      render: o,
      className: r,
      style: p,
      state: se,
      refs: Q,
      props: H,
      stateAttributesMapping: gu
    }) : q, /* @__PURE__ */ m("input", {
      ...xe,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (Qb.displayName = "RadioRoot");
const Jb = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    keepMounted: s = !1,
    ...l
  } = e, a = hI(), c = a.checked, {
    mounted: u,
    transitionStatus: d,
    setMounted: f
  } = Xn(c), p = {
    ...a,
    transitionStatus: d
  }, g = x.useRef(null), h = s || u, b = $e("span", e, {
    ref: [n, g],
    state: p,
    props: l,
    stateAttributesMapping: gu
  });
  return jt({
    open: c,
    ref: g,
    onComplete() {
      c || f(!1);
    }
  }), h ? b : null;
});
process.env.NODE_ENV !== "production" && (Jb.displayName = "RadioIndicator");
const bI = [Uh], e3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    disabled: i,
    readOnly: s,
    required: l,
    onValueChange: a,
    value: c,
    defaultValue: u,
    form: d,
    name: f,
    inputRef: p,
    id: g,
    style: h,
    ...b
  } = e, {
    setTouched: v,
    setFocused: C,
    shouldValidateOnChange: y,
    validationMode: w,
    name: R,
    disabled: S,
    state: E,
    validation: N,
    setDirty: T,
    setFilled: P,
    validityData: I
  } = tn(), {
    labelId: k
  } = mn(), {
    clearErrors: M
  } = Vo(), D = w2(!0), O = S || i, V = R ?? f, _ = Mt(g), [A, L] = dn({
    controlled: c,
    default: u,
    name: "RadioGroup",
    state: "value"
  }), B = Se(a), G = Se((oe, re) => {
    B(oe, re), !re.isCanceled && L(oe);
  }), U = x.useRef(null), Y = x.useRef(null), K = x.useRef(null);
  function j(oe) {
    let re;
    return p && (typeof p == "function" ? re = p(oe) : p.current = oe), Y.current = oe, N.inputRef.current = oe, re;
  }
  const Z = Se((oe, re = !1) => {
    if (oe) {
      if (re) {
        U.current === oe && (U.current = null);
        return;
      }
      U.current == null && (U.current = oe);
    }
  }), te = Se((oe) => {
    if (!oe || oe.disabled)
      return;
    K.current || (K.current = oe);
    const re = Y.current;
    if (oe.checked || re == null || re.disabled)
      return j(oe);
  }), W = Se(() => A ?? null);
  pi(U, {
    id: _,
    value: A,
    getValue: W
  }), wo(A, () => {
    M(V), T(A !== I.initialValue), P(A != null), y() ? N.commit(A) : N.commit(A, !0);
    const oe = K.current;
    A == null && oe && !oe.disabled && j(oe);
  });
  const [X, ee] = x.useState(!1), le = b["aria-labelledby"] ?? k ?? D?.legendId, J = {
    ...E,
    disabled: O ?? !1,
    required: l ?? !1,
    readOnly: s ?? !1
  }, ie = x.useMemo(() => ({
    ...E,
    checkedValue: A,
    disabled: O,
    form: d,
    validation: N,
    name: V,
    onValueChange: B,
    readOnly: s,
    registerControlRef: Z,
    registerInputRef: te,
    required: l,
    setCheckedValue: G,
    setTouched: ee,
    touched: X
  }), [A, O, d, N, E, V, B, s, Z, te, l, G, ee, X]), pe = {
    role: "radiogroup",
    "aria-required": l || void 0,
    "aria-disabled": O || void 0,
    "aria-readonly": s || void 0,
    "aria-labelledby": le,
    onFocus() {
      C(!0);
    },
    onBlur(oe) {
      ze(oe.currentTarget, oe.relatedTarget) || (v(!0), C(!1), w === "onBlur" && N.commit(A));
    },
    onKeyDownCapture(oe) {
      oe.key.startsWith("Arrow") && (v(!0), ee(!0), C(!0));
    }
  };
  return /* @__PURE__ */ m(a1.Provider, {
    value: ie,
    children: /* @__PURE__ */ m(Gb, {
      render: o,
      className: r,
      style: h,
      state: J,
      props: [pe, N.getValidationProps, b],
      refs: [n],
      stateAttributesMapping: to,
      enableHomeAndEndKeys: !1,
      modifierKeys: bI
    })
  });
});
process.env.NODE_ENV !== "production" && (e3.displayName = "RadioGroup");
function vI() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ m("path", { d: "M15 8C15 4.13438 11.8656 1 8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8ZM0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16C3.58125 16 0 12.4187 0 8Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
function yI() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-hidden": "true", focusable: "false", className: "w-full h-full", children: /* @__PURE__ */ m("path", { d: "M8 16C3.58125 16 0 12.4187 0 8C0 3.58125 3.58125 0 8 0C12.4187 0 16 3.58125 16 8C16 12.4187 12.4187 16 8 16ZM8 1.5C4.40937 1.5 1.5 4.40937 1.5 8C1.5 11.5906 4.40937 14.5 8 14.5C11.5906 14.5 14.5 11.5906 14.5 8C14.5 4.40937 11.5906 1.5 8 1.5ZM8 11C6.34375 11 5 9.65625 5 8C5 6.34375 6.34375 5 8 5C9.65625 5 11 6.34375 11 8C11 9.65625 9.65625 11 8 11Z", fill: "currentColor" }) }), t[0] = e) : e = t[0], e;
}
const t3 = mo({}), xI = ce([
  "relative",
  "shrink-0",
  "inline-flex",
  "items-center",
  "justify-center",
  "rounded-full",
  "group",
  // disabled
  "data-[disabled]:pointer-events-none",
  // focus
  "focus-visible:outline-none",
  "focus-visible:ring-[1.5px]",
  "focus-visible:ring-radio-focus-ring",
  "cursor-[inherit]",
  // coarse touch target
  "[@media(pointer:coarse)]:before:content-['']",
  "[@media(pointer:coarse)]:before:absolute"
], {
  variants: {
    size: {
      sm: ["w-(--icon-sm)", "h-(--icon-sm)", "[@media(pointer:coarse)]:before:inset-[-12px]"],
      md: ["w-(--icon-md)", "h-(--icon-md)", "[@media(pointer:coarse)]:before:inset-[-10px]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), CI = ce(["absolute", "inset-0", "rounded-full", "flex", "items-center", "justify-center", "[[data-checked]_&]:hidden", "group-hover:bg-radio-outline-hover-background", "group-active:bg-radio-outline-pressed-background"]), wI = ce(["flex", "items-center", "justify-center", "text-radio-outline-default-border", "group-hover:text-radio-outline-hover-border", "group-active:text-radio-outline-pressed-border", "[[data-disabled]_&]:text-radio-outline-disabled-border", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), SI = ce(["flex", "items-center", "justify-center", "text-radio-filled-default-background", "group-hover:text-radio-filled-hover-background", "group-active:text-radio-filled-pressed-background", "[[data-disabled]_&]:text-radio-filled-disabled-background", "[[data-error]_&]:text-error"], {
  variants: {
    size: {
      sm: ["w-[calc(var(--icon-sm)*0.8)]", "h-[calc(var(--icon-sm)*0.8)]"],
      md: ["w-[calc(var(--icon-md)*0.8)]", "h-[calc(var(--icon-md)*0.8)]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
}), n3 = ce(["text-text-default", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-label-large)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), RI = ce(["text-text-subtext", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), EI = ce(["flex", "flex-col", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), NI = ce([], {
  variants: {
    size: {
      sm: ["pl-[calc(var(--icon-sm)+var(--spacing-8))]"],
      md: ["pl-[calc(var(--icon-md)+var(--spacing-8))]"]
    }
  },
  defaultVariants: {
    size: "sm"
  }
});
function OD(t) {
  const e = z.c(28);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    label: i,
    error: r,
    disabled: o,
    size: l,
    children: n,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = l === void 0 ? "sm" : l, c = _t();
  let u;
  e[7] !== o || e[8] !== r || e[9] !== a ? (u = {
    error: r,
    disabled: o,
    size: a
  }, e[7] = o, e[8] = r, e[9] = a, e[10] = u) : u = e[10];
  let d;
  e[11] !== c || e[12] !== i ? (d = i && /* @__PURE__ */ m("span", { id: `${c}-label`, className: n3(), children: i }), e[11] = c, e[12] = i, e[13] = d) : d = e[13];
  const f = i ? `${c}-label` : s["aria-labelledby"], p = s["aria-label"], g = r || void 0, h = o || void 0;
  let b;
  e[14] !== n || e[15] !== o || e[16] !== s || e[17] !== f || e[18] !== p || e[19] !== g || e[20] !== h ? (b = /* @__PURE__ */ m(e3, { ...s, disabled: o, "aria-labelledby": f, "aria-label": p, "aria-invalid": g, "aria-disabled": h, className: "flex flex-col gap-(--spacing-8)", children: n }), e[14] = n, e[15] = o, e[16] = s, e[17] = f, e[18] = p, e[19] = g, e[20] = h, e[21] = b) : b = e[21];
  let v;
  e[22] !== d || e[23] !== b ? (v = /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-8)", children: [
    d,
    b
  ] }), e[22] = d, e[23] = b, e[24] = v) : v = e[24];
  let C;
  return e[25] !== u || e[26] !== v ? (C = /* @__PURE__ */ m(t3, { value: u, children: v }), e[25] = u, e[26] = v, e[27] = C) : C = e[27], C;
}
function DD(t) {
  const e = z.c(53);
  let n, o, r, i;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const {
    error: s,
    disabled: l,
    size: a
  } = gn(t3), c = l || o, u = _t();
  let d;
  e[5] !== n || e[6] !== u || e[7] !== i ? (d = [i["aria-describedby"], n ? `${u}-description` : void 0].filter(Boolean).join(" ") || void 0, e[5] = n, e[6] = u, e[7] = i, e[8] = d) : d = e[8];
  const f = d;
  let p;
  e[9] !== c ? (p = EI({
    disabled: c
  }), e[9] = c, e[10] = p) : p = e[10];
  const g = r ? void 0 : i["aria-label"], h = r ? `${u}-label` : void 0, b = s ? "" : void 0;
  let v;
  e[11] !== i ? (v = (O) => {
    i.onKeyDown?.(O), !O.defaultPrevented && O.key === " " && (O.preventDefault(), O.currentTarget.click());
  }, e[11] = i, e[12] = v) : v = e[12];
  let C;
  e[13] !== a ? (C = ne(xI({
    size: a
  })), e[13] = a, e[14] = C) : C = e[14];
  let y;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (y = CI(), e[15] = y) : y = e[15];
  let w;
  e[16] !== a ? (w = wI({
    size: a
  }), e[16] = a, e[17] = w) : w = e[17];
  let R;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (R = /* @__PURE__ */ m(vI, {}), e[18] = R) : R = e[18];
  let S;
  e[19] !== w ? (S = /* @__PURE__ */ m("span", { className: y, children: /* @__PURE__ */ m("span", { className: w, children: R }) }), e[19] = w, e[20] = S) : S = e[20];
  let E;
  e[21] !== a ? (E = SI({
    size: a
  }), e[21] = a, e[22] = E) : E = e[22];
  let N;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (N = /* @__PURE__ */ m(yI, {}), e[23] = N) : N = e[23];
  let T;
  e[24] !== E ? (T = /* @__PURE__ */ m(Jb, { className: E, children: N }), e[24] = E, e[25] = T) : T = e[25];
  let P;
  e[26] !== f || e[27] !== c || e[28] !== i || e[29] !== S || e[30] !== T || e[31] !== g || e[32] !== h || e[33] !== b || e[34] !== v || e[35] !== C ? (P = /* @__PURE__ */ F(Qb, { ...i, disabled: c, "aria-label": g, "aria-labelledby": h, "aria-describedby": f, "data-error": b, onKeyDown: v, className: C, children: [
    S,
    T
  ] }), e[26] = f, e[27] = c, e[28] = i, e[29] = S, e[30] = T, e[31] = g, e[32] = h, e[33] = b, e[34] = v, e[35] = C, e[36] = P) : P = e[36];
  let I;
  e[37] !== u || e[38] !== c || e[39] !== r ? (I = r && /* @__PURE__ */ m("span", { id: `${u}-label`, className: ne(n3(), c && "opacity-[0.54]"), children: r }), e[37] = u, e[38] = c, e[39] = r, e[40] = I) : I = e[40];
  let k;
  e[41] !== P || e[42] !== I ? (k = /* @__PURE__ */ F("div", { className: "inline-flex items-center gap-(--spacing-8)", children: [
    P,
    I
  ] }), e[41] = P, e[42] = I, e[43] = k) : k = e[43];
  let M;
  e[44] !== n || e[45] !== u || e[46] !== c || e[47] !== a ? (M = n && /* @__PURE__ */ m("span", { id: `${u}-description`, className: ne(RI(), c && "opacity-[0.54]", NI({
    size: a
  })), children: n }), e[44] = n, e[45] = u, e[46] = c, e[47] = a, e[48] = M) : M = e[48];
  let D;
  return e[49] !== k || e[50] !== M || e[51] !== p ? (D = /* @__PURE__ */ F("label", { className: p, children: [
    k,
    M
  ] }), e[49] = k, e[50] = M, e[51] = p, e[52] = D) : D = e[52], D;
}
const kI = ce(["flex", "w-full", "items-center", "justify-between", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "shadow-elevation-1", "transition-colors", "duration-200", "ease-in-out", "[&:has(input:focus)]:border-input-active-outline", "hover:bg-input-hover-background", "hover:border-input-hover-outline", "active:border-input-pressed-outline", "[&:has(input:disabled)]:cursor-not-allowed", "[&:has(input:disabled)]:opacity-50"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), o3 = ce(["min-w-0", "flex-1", "border-0", "bg-transparent", "p-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-input-text-default", "outline-none", "placeholder:text-input-text-placeholder", "disabled:cursor-not-allowed", "[&::-webkit-search-cancel-button]:appearance-none"]);
function r3(t) {
  const e = z.c(7), {
    children: n,
    size: o,
    trailing: r
  } = t, i = o === void 0 ? "md" : o;
  let s;
  e[0] !== i ? (s = ne(kI({
    size: i
  })), e[0] = i, e[1] = s) : s = e[1];
  let l;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 text-input-text-placeholder", children: /* @__PURE__ */ m(Ke, { name: "search", size: "sm", tone: "inherit" }) }), e[2] = l) : l = e[2];
  let a;
  return e[3] !== n || e[4] !== s || e[5] !== r ? (a = /* @__PURE__ */ F("div", { className: s, children: [
    l,
    n,
    r
  ] }), e[3] = n, e[4] = s, e[5] = r, e[6] = a) : a = e[6], a;
}
function i3(t, e) {
  const n = z.c(10), o = ft(void 0), r = ft(t);
  let i, s;
  n[0] !== t ? (i = () => {
    r.current = t;
  }, s = [t], n[0] = t, n[1] = i, n[2] = s) : (i = n[1], s = n[2]), kt(i, s);
  let l;
  n[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = function() {
    o.current !== void 0 && (window.clearTimeout(o.current), o.current = void 0);
  }, n[3] = l) : l = n[3];
  const a = l;
  let c;
  n[4] !== e ? (c = function(h, b) {
    const v = b === void 0 ? !1 : b;
    if (a(), !!r.current) {
      if (v || e === 0) {
        r.current(h);
        return;
      }
      o.current = window.setTimeout(() => {
        o.current = void 0, r.current?.(h);
      }, e);
    }
  }, n[4] = e, n[5] = c) : c = n[5];
  const u = c;
  let d, f;
  n[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (d = () => () => {
    o.current !== void 0 && window.clearTimeout(o.current);
  }, f = [], n[6] = d, n[7] = f) : (d = n[6], f = n[7]), kt(d, f);
  let p;
  return n[8] !== u ? (p = {
    cancelSearch: a,
    emitSearch: u
  }, n[8] = u, n[9] = p) : p = n[9], p;
}
function VD(t) {
  const e = z.c(33), {
    "aria-label": n,
    value: o,
    defaultValue: r,
    onChange: i,
    onSearch: s,
    placeholder: l,
    clearable: a,
    debounceMs: c,
    size: u,
    disabled: d,
    autoFocus: f
  } = t, p = r === void 0 ? "" : r, g = l === void 0 ? "Search" : l, h = a === void 0 ? !0 : a, b = c === void 0 ? 300 : c, v = u === void 0 ? "md" : u, [C, y] = ot(p), {
    emitSearch: w
  } = i3(s, b), R = o !== void 0, S = R ? o : C;
  let E;
  e[0] !== f ? (E = f ? {
    autoFocus: !0
  } : void 0, e[0] = f, e[1] = E) : E = e[1];
  const N = E;
  let T;
  e[2] !== w || e[3] !== R || e[4] !== i ? (T = function(B) {
    R || y(B), i?.(B), w(B);
  }, e[2] = w, e[3] = R, e[4] = i, e[5] = T) : T = e[5];
  const P = T;
  let I;
  e[6] !== w || e[7] !== R || e[8] !== i ? (I = function() {
    R || y(""), i?.(""), w("", !0);
  }, e[6] = w, e[7] = R, e[8] = i, e[9] = I) : I = e[9];
  const k = I;
  let M;
  e[10] !== k || e[11] !== h || e[12] !== d || e[13] !== S ? (M = h && S.length > 0 ? /* @__PURE__ */ m(mt, { "aria-label": "Clear search", disabled: d, icon: "x-close", onClick: k, size: "sm", type: "button", variant: "ghost" }) : void 0, e[10] = k, e[11] = h, e[12] = d, e[13] = S, e[14] = M) : M = e[14];
  let D;
  e[15] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (D = ne(o3()), e[15] = D) : D = e[15];
  let O;
  e[16] !== P ? (O = (L) => P(L.target.value), e[16] = P, e[17] = O) : O = e[17];
  let V;
  e[18] !== k || e[19] !== S ? (V = (L) => {
    L.key === "Escape" && S.length > 0 && (L.preventDefault(), k());
  }, e[18] = k, e[19] = S, e[20] = V) : V = e[20];
  let _;
  e[21] !== n || e[22] !== N || e[23] !== d || e[24] !== S || e[25] !== g || e[26] !== O || e[27] !== V ? (_ = /* @__PURE__ */ m("input", { "aria-label": n, className: D, disabled: d, onChange: O, onKeyDown: V, placeholder: g, type: "search", value: S, ...N }), e[21] = n, e[22] = N, e[23] = d, e[24] = S, e[25] = g, e[26] = O, e[27] = V, e[28] = _) : _ = e[28];
  let A;
  return e[29] !== v || e[30] !== _ || e[31] !== M ? (A = /* @__PURE__ */ m(r3, { size: v, trailing: M, children: _ }), e[29] = v, e[30] = _, e[31] = M, e[32] = A) : A = e[32], A;
}
function MI(t) {
  const {
    openOnInputClick: e = !1,
    value: n,
    defaultValue: o,
    onValueChange: r,
    mode: i = "list",
    itemToStringValue: s,
    ...l
  } = t, a = i === "inline" || i === "both", c = i === "inline" || i === "none", u = n !== void 0, [d, f] = x.useState(o ?? ""), [p, g] = x.useState("");
  x.useEffect(() => {
    u && g("");
  }, [n, u]);
  let h;
  a && p !== "" ? h = p : u ? h = n ?? "" : h = d;
  const b = Se((S, E) => {
    g(""), u || f(S), r?.(S, E);
  }), v = S0(), C = x.useMemo(() => l.filter !== void 0 ? l.filter : v.contains, [l.filter, v]), y = String(u ? n : d).trim(), w = x.useMemo(() => i !== "both" ? c ? null : C : C === null ? null : (S, E, N) => C(S, y, N), [C, i, y, c]), R = Se((S, E) => {
    t.onItemHighlighted?.(S, E), E.reason !== i8 && (a ? S == null ? g("") : g(Jt(S, s)) : g(""));
  });
  return /* @__PURE__ */ m(E0, {
    ...l,
    itemToStringLabel: s,
    openOnInputClick: e,
    selectionMode: "none",
    fillInputOnItemPress: !0,
    filter: w,
    autoComplete: i,
    inputValue: h,
    defaultInputValue: o,
    onInputValueChange: b,
    onItemHighlighted: R
  });
}
const II = va, PI = Ts, TI = ce(["w-[min(540px,calc(100vw_-_var(--spacing-32)))]", "max-h-[min(640px,calc(100vh_-_var(--spacing-40)))]", "flex", "flex-col", "gap-(--spacing-10)", "outline-none", "[outline:none]", "focus:outline-none", "data-[starting-style]:opacity-0", "data-[starting-style]:scale-95", "data-[ending-style]:opacity-0", "data-[ending-style]:scale-95", "transition-[opacity,transform]", "duration-100", "ease-in-out", "max-[599px]:h-dvh", "max-[599px]:w-screen", "max-[599px]:max-h-none", "max-[599px]:gap-0", "max-[599px]:bg-surface"]), OI = ce(["fixed", "inset-0", "z-[var(--z-layer-dialog)]", "bg-surface/40", "backdrop-blur-search-overlay", "data-[starting-style]:opacity-0", "data-[ending-style]:opacity-0", "transition-opacity", "duration-100", "ease-in-out"]), DI = ce(["min-h-0", "max-h-[min(520px,calc(100vh_-_160px))]", "overflow-y-auto", "overscroll-contain", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none", "rounded-(--radius-sm)", "bg-surface-container-lowest", "py-(--spacing-20)", "px-(--spacing-10)", "shadow-elevation-3", "max-[599px]:max-h-none", "max-[599px]:flex-1", "max-[599px]:rounded-none", "max-[599px]:shadow-none"]), VI = ce(["contents", "max-[599px]:flex", "max-[599px]:h-[68px]", "max-[599px]:shrink-0", "max-[599px]:items-center", "max-[599px]:gap-(--spacing-8)", "max-[599px]:border-b", "max-[599px]:border-outline-subtle", "max-[599px]:px-(--spacing-16)"]), _I = ce(["hidden", "max-[599px]:flex", "max-[599px]:min-h-[44px]", "max-[599px]:items-center"]), AI = ce(["contents", "max-[599px]:flex", "max-[599px]:min-h-[44px]", "max-[599px]:min-w-0", "max-[599px]:flex-1", "max-[599px]:items-center"]), LI = ce(["flex", "flex-col", "gap-(--spacing-16)", "outline-none", "[outline:none]", "focus:outline-none", "focus-visible:outline-none"]), FI = ce(["flex", "flex-col", "gap-(--spacing-4)"]), $I = ce(["relative", "z-10", "flex", "h-(--spacing-24)", "items-center", "justify-between", "gap-(--spacing-8)", "px-(--spacing-10)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-menu-text-subtle"]), HI = ce(["flex", "h-[45px]", "w-full", "items-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "bg-transparent", "py-(--spacing-4)", "pl-(--spacing-10)", "pr-(--spacing-8)", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-24)", "tracking-(--font-letter-spacing-default)", "text-menu-text-default", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-menu-item-hover", "active:bg-menu-item-pressed", "data-[highlighted]:bg-menu-item-hover", "data-[disabled]:pointer-events-none", "data-[disabled]:cursor-default", "data-[disabled]:opacity-50"]), zI = ce(["inline-flex", "h-(--spacing-32)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "border-button-outline-default-border", "bg-button-outline-default-background", "px-(--spacing-12)", "font-(family-name:--font-family-label)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-button-outline-default-text", "outline-none", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), BI = ce(["inline-flex", "size-(--spacing-32)", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border", "border-solid", "border-transparent", "bg-transparent", "text-button-ghost-default-text", "outline-none", "cursor-pointer", "transition-colors", "duration-200", "ease-in-out", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background"]);
function WI(t) {
  return t.map((e) => ({
    value: e.label,
    items: e.items.map((n) => ({
      ...n,
      groupLabel: e.label
    }))
  }));
}
function UI(t) {
  return t.every((e) => e.items.length === 0);
}
function Ec(t, e) {
  return t.find((n) => n.label === e);
}
function Nc(t) {
  return `${t.groupLabel}:${t.id}`;
}
const GI = {
  meta: "⌘",
  ctrl: "Ctrl",
  alt: "Alt",
  shift: "Shift"
};
function _D(t) {
  const e = z.c(76), {
    open: n,
    onOpenChange: o,
    query: r,
    onQueryChange: i,
    onSearch: s,
    debounceMs: l,
    groups: a,
    placeholder: c,
    hotkey: u,
    showDividers: d,
    emptyLabel: f,
    disabled: p,
    "aria-label": g,
    onItemSelect: h,
    onItemRemove: b
  } = t, v = l === void 0 ? 300 : l, C = c === void 0 ? "Search" : c, y = d === void 0 ? !0 : d, w = f === void 0 ? "No results found." : f, R = g === void 0 ? "Search" : g, S = qt(), E = _t(), {
    cancelSearch: N,
    emitSearch: T
  } = i3(s, v), P = a.filter(KI), I = WI(P), k = UI(P), M = !!u && r.length === 0, D = I.at(-1)?.value, [O, V] = ot();
  let _;
  e[0] !== O ? (_ = (Pe) => Nc(Pe) === O, e[0] = O, e[1] = _) : _ = e[1];
  const A = I.flatMap(jI).find(_);
  let L;
  e[2] !== N || e[3] !== a || e[4] !== h ? (L = function(Me, _e) {
    if (Me.target instanceof Element && Me.target.closest("[data-search-remove]"))
      return;
    const Ue = Ec(a, _e.groupLabel);
    !Ue || _e.disabled || (N(), h(_e, Ue));
  }, e[2] = N, e[3] = a, e[4] = h, e[5] = L) : L = e[5];
  const B = L;
  let G;
  e[6] !== T || e[7] !== i ? (G = function(Me) {
    i(Me), T(Me);
  }, e[6] = T, e[7] = i, e[8] = G) : G = e[8];
  const U = G;
  let Y;
  e[9] !== N || e[10] !== o ? (Y = function(Me) {
    Me || N(), o(Me);
  }, e[9] = N, e[10] = o, e[11] = Y) : Y = e[11];
  const K = Y;
  let j;
  e[12] !== a || e[13] !== b ? (j = function(Me) {
    const _e = Ec(a, Me.groupLabel);
    !_e || Me.disabled || b?.(Me, _e);
  }, e[12] = a, e[13] = b, e[14] = j) : j = e[14];
  const Z = j;
  let te;
  e[15] !== V ? (te = function(Me) {
    const _e = Me ? Nc(Me) : void 0;
    V((Ue) => Ue === _e ? Ue : _e);
  }, e[15] = V, e[16] = te) : te = e[16];
  const W = te;
  let X;
  e[17] !== Z ? (X = function(Me, _e) {
    Me.preventDefault(), Me.stopPropagation(), Z(_e);
  }, e[17] = Z, e[18] = X) : X = e[18];
  const ee = X;
  let le;
  e[19] !== Z || e[20] !== A || e[21] !== r ? (le = function(Me) {
    !A?.removable || A.disabled || !(Me.key === "Delete" || Me.key === "Backspace" && r.length === 0) || (Me.preventDefault(), Me.stopPropagation(), Z(A));
  }, e[19] = Z, e[20] = A, e[21] = r, e[22] = le) : le = e[22];
  const J = le;
  let ie;
  e[23] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ie = function(Me) {
    if (!Me.removable)
      return;
    const _e = Me.chip ? `, ${Me.chip}` : "", Ue = Me.removeAriaLabel ? `${Me.removeAriaLabel}. Press Delete.` : "Press Delete to remove.";
    return `${Me.label}${_e}. ${Ue}`;
  }, e[23] = ie) : ie = e[23];
  const pe = ie;
  let oe;
  e[24] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (oe = /* @__PURE__ */ m(Ns, { className: ne(OI()) }), e[24] = oe) : oe = e[24];
  let re;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (re = ne(TI()), e[25] = re) : re = e[25];
  let de, xe;
  e[26] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (de = ne(VI()), xe = ne(_I()), e[26] = de, e[27] = xe) : (de = e[26], xe = e[27]);
  let se;
  e[28] !== K ? (se = /* @__PURE__ */ m("div", { className: xe, children: /* @__PURE__ */ m(mt, { "aria-label": "Back", icon: "chevron-left", variant: "ghost", onClick: () => K(!1) }) }), e[28] = K, e[29] = se) : se = e[29];
  let fe;
  e[30] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (fe = ne(AI()), e[30] = fe) : fe = e[30];
  let $;
  e[31] !== u || e[32] !== M ? ($ = M && u ? /* @__PURE__ */ m(B2, { "aria-hidden": "true", modifier: u.modifier ? GI[u.modifier] : void 0, children: u.key }) : void 0, e[31] = u, e[32] = M, e[33] = $) : $ = e[33];
  let Q;
  e[34] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (Q = ne(o3()), e[34] = Q) : Q = e[34];
  let H;
  e[35] !== p || e[36] !== J || e[37] !== E || e[38] !== C ? (H = /* @__PURE__ */ m(Is, { id: E, placeholder: C, disabled: p, className: Q, onKeyDown: J }), e[35] = p, e[36] = J, e[37] = E, e[38] = C, e[39] = H) : H = e[39];
  let q;
  e[40] !== $ || e[41] !== H ? (q = /* @__PURE__ */ m(II, { children: /* @__PURE__ */ m(r3, { trailing: $, children: H }) }), e[40] = $, e[41] = H, e[42] = q) : q = e[42];
  let ae;
  e[43] !== E || e[44] !== q ? (ae = /* @__PURE__ */ m("label", { className: fe, htmlFor: E, children: q }), e[43] = E, e[44] = q, e[45] = ae) : ae = e[45];
  let ge;
  e[46] !== se || e[47] !== ae ? (ge = /* @__PURE__ */ F("div", { className: de, children: [
    se,
    ae
  ] }), e[46] = se, e[47] = ae, e[48] = ge) : ge = e[48];
  let ue;
  e[49] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (ue = ne(DI()), e[49] = ue) : ue = e[49];
  let Re;
  e[50] !== w || e[51] !== a || e[52] !== B || e[53] !== ee || e[54] !== k || e[55] !== D || e[56] !== y ? (Re = /* @__PURE__ */ m("div", { className: ue, children: k ? /* @__PURE__ */ m("div", { className: "flex h-(--spacing-40) items-center px-(--spacing-10) font-(family-name:--font-family-body) text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-menu-text-subtle", children: w }) : /* @__PURE__ */ m(Ps, { className: ne(LI()), children: (Pe) => {
    const Me = Ec(a, Pe.value);
    return /* @__PURE__ */ F(X3, { children: [
      /* @__PURE__ */ F(I0, { items: Pe.items, className: ne(FI()), children: [
        /* @__PURE__ */ F(P0, { className: ne($I(), Me?.action && "pr-(--spacing-4)"), children: [
          /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 truncate", children: Pe.value }),
          Me?.action && /* @__PURE__ */ F(Qn, { className: ne(zI()), "aria-label": Me.action["aria-label"], onClick: Me.action.onClick, children: [
            Me.action.label,
            /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" })
          ] })
        ] }),
        /* @__PURE__ */ m(M0, { children: (_e) => /* @__PURE__ */ F(PI, { value: _e, disabled: _e.disabled, className: ne(HI()), "aria-label": pe(_e), onClick: (Ue) => B(Ue, _e), children: [
          /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 items-center gap-(--spacing-8)", children: [
            /* @__PURE__ */ F("span", { className: "flex min-w-0 flex-1 flex-col", children: [
              /* @__PURE__ */ m("span", { className: "min-w-0 truncate", children: _e.label }),
              _e.subLabel && /* @__PURE__ */ m("span", { className: "min-w-0 truncate font-(family-name:--font-family-label) text-(length:--font-size-label-xsmall) font-(number:--font-weight-semibold) leading-(--font-line-height-16) text-menu-text-subtle uppercase", children: _e.subLabel })
            ] }),
            _e.chip && /* @__PURE__ */ m(Kn, { label: _e.chip, tone: "neutral" })
          ] }),
          _e.removable && /* @__PURE__ */ m("span", { "aria-hidden": "true", className: ne(BI()), "data-search-remove": "", "data-testid": `search-remove-${_e.id}`, onPointerDown: (Ue) => ee(Ue, _e), children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "sm", tone: "inherit" }) })
        ] }, Nc(_e)) })
      ] }),
      y && Pe.value !== D && /* @__PURE__ */ m(gr, { variant: "middle-inset" })
    ] }, Pe.value);
  } }) }), e[50] = w, e[51] = a, e[52] = B, e[53] = ee, e[54] = k, e[55] = D, e[56] = y, e[57] = Re) : Re = e[57];
  let be;
  e[58] !== I || e[59] !== p || e[60] !== W || e[61] !== U || e[62] !== r || e[63] !== ge || e[64] !== Re ? (be = /* @__PURE__ */ F(MI, { open: !0, inline: !0, mode: "none", items: I, itemToStringValue: YI, value: r, onValueChange: U, onItemHighlighted: W, disabled: p, children: [
    ge,
    Re
  ] }), e[58] = I, e[59] = p, e[60] = W, e[61] = U, e[62] = r, e[63] = ge, e[64] = Re, e[65] = be) : be = e[65];
  let ve;
  e[66] !== R || e[67] !== be ? (ve = /* @__PURE__ */ m(bi, { className: "fixed inset-0 z-[var(--z-layer-dialog)] flex items-start justify-center px-(--spacing-16) pt-[12vh] max-[599px]:items-stretch max-[599px]:p-0", children: /* @__PURE__ */ m(mi, { "aria-label": R, className: re, children: be }) }), e[66] = R, e[67] = be, e[68] = ve) : ve = e[68];
  let me;
  e[69] !== S || e[70] !== ve ? (me = /* @__PURE__ */ F(Tr, { container: S, children: [
    oe,
    ve
  ] }), e[69] = S, e[70] = ve, e[71] = me) : me = e[71];
  let Ee;
  return e[72] !== K || e[73] !== n || e[74] !== me ? (Ee = /* @__PURE__ */ m(hi, { open: n, onOpenChange: K, modal: !0, children: me }), e[72] = K, e[73] = n, e[74] = me, e[75] = Ee) : Ee = e[75], Ee;
}
function YI(t) {
  return t.label;
}
function jI(t) {
  return t.items;
}
function KI(t) {
  return t.items.length > 0;
}
function qI(t) {
  if (!(t instanceof HTMLElement)) return !1;
  const e = t.tagName.toLowerCase();
  return e === "input" || e === "textarea" || e === "select" || t.isContentEditable;
}
function ZI(t, e) {
  if (!e.includes("+"))
    return !t.metaKey && !t.ctrlKey && !t.altKey && !t.shiftKey && t.key.toLowerCase() === e.toLowerCase();
  const [n, o] = e.toLowerCase().split("+");
  return !n || !o ? !1 : !!(n === "mod" ? t.metaKey || t.ctrlKey : n === "meta" ? t.metaKey : n === "ctrl" ? t.ctrlKey : n === "alt" ? t.altKey : n === "shift" && t.shiftKey) && t.key.toLowerCase() === o;
}
function AD(t) {
  const e = z.c(5), {
    key: n,
    enabled: o,
    onOpen: r
  } = t, i = o === void 0 ? !0 : o;
  let s, l;
  e[0] !== i || e[1] !== n || e[2] !== r ? (s = () => {
    if (!i)
      return;
    const a = function(u) {
      qI(u.target) || ZI(u, n) && (u.preventDefault(), r());
    };
    return document.addEventListener("keydown", a), () => document.removeEventListener("keydown", a);
  }, l = [i, n, r], e[0] = i, e[1] = n, e[2] = r, e[3] = s, e[4] = l) : (s = e[3], l = e[4]), kt(s, l);
}
const XI = ce(["aw-skeleton", "relative", "block", "overflow-hidden", "bg-surface-container"], {
  variants: {
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    }
  },
  defaultVariants: {
    radius: "sm"
  }
});
function LD(t) {
  const e = z.c(25);
  let n, o, r, i, s, l, a;
  e[0] !== t ? ({
    radius: s,
    width: a,
    height: o,
    className: n,
    style: i,
    "aria-hidden": l,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7]);
  const c = s === void 0 ? "sm" : s, u = l === void 0 ? !0 : l;
  let d;
  e[8] !== a ? (d = a !== void 0 ? {
    width: a
  } : void 0, e[8] = a, e[9] = d) : d = e[9];
  let f;
  e[10] !== o ? (f = o !== void 0 ? {
    height: o
  } : void 0, e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== i || e[13] !== d || e[14] !== f ? (p = {
    ...i,
    ...d,
    ...f
  }, e[12] = i, e[13] = d, e[14] = f, e[15] = p) : p = e[15];
  const g = p;
  let h;
  e[16] !== n || e[17] !== c ? (h = ne(XI({
    radius: c
  }), n), e[16] = n, e[17] = c, e[18] = h) : h = e[18];
  let b;
  return e[19] !== u || e[20] !== r || e[21] !== c || e[22] !== g || e[23] !== h ? (b = /* @__PURE__ */ m("div", { ...r, "data-slot": "skeleton", "data-radius": c, "aria-hidden": u, className: h, style: g }), e[19] = u, e[20] = r, e[21] = c, e[22] = g, e[23] = h, e[24] = b) : b = e[24], b;
}
const QI = 5, JI = 200;
function eP(t, e, n) {
  const o = [...t], [r] = o.splice(e, 1);
  return o.splice(n, 0, r), o;
}
function Ii(t, e, n) {
  return `${t}, position ${e + 1} of ${n}`;
}
function kc(t, e, n) {
  const o = [...t.tops], r = t.ids.map((l, a) => a), [i] = r.splice(e, 1);
  r.splice(n, 0, i);
  let s = t.tops[0] ?? 0;
  return r.forEach((l, a) => {
    o[l] = s, s += t.heights[l] + (t.gaps[a] ?? 0);
  }), o;
}
function Mc(t, e, n) {
  const r = {
    ArrowUp: (i) => i - 1,
    ArrowDown: (i) => i + 1,
    Home: () => 0,
    End: (i, s) => s
  }[t];
  return r ? Math.max(0, Math.min(n, r(e, n))) : void 0;
}
function tP({
  items: t,
  getItemId: e,
  getItemLabel: n,
  onReorder: o,
  onDragEnd: r
}) {
  const [i, s] = x.useState(null), [l, a] = x.useState(!1), [c, u] = x.useState(""), d = x.useId(), f = x.useRef(/* @__PURE__ */ new Map()), p = x.useRef(null), g = x.useRef(null), h = x.useRef(/* @__PURE__ */ new Map()), b = x.useRef(null), v = x.useRef(null), C = x.useRef(null), y = x.useRef(null), w = x.useRef([]), R = x.useRef({
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  });
  R.current = {
    items: t,
    getItemId: e,
    getItemLabel: n,
    onReorder: o,
    onDragEnd: r
  };
  function S(W, X) {
    X ? f.current.set(W, X) : f.current.delete(W);
  }
  function E(W) {
    const X = h.current.get(W);
    if (X) return X;
    const ee = (le) => S(W, le);
    return h.current.set(W, ee), ee;
  }
  function N(W) {
    const {
      items: X,
      getItemId: ee,
      getItemLabel: le
    } = R.current, J = X.find((ie) => ee(ie) === W);
    return J ? le(J) : "";
  }
  function T(W) {
    v.current = W, s(W);
  }
  function P(W) {
    typeof document > "u" || (document.body.style.cursor = "grabbing", document.body.style.userSelect = "none");
  }
  function I() {
    if (typeof document > "u") return;
    const W = C.current;
    W && (document.body.style.cursor = W.previousBodyCursor, document.body.style.userSelect = W.previousBodyUserSelect);
  }
  function k() {
    p.current?.abort(), p.current = null, g.current?.abort(), g.current = null, y.current && (clearTimeout(y.current), y.current = null), b.current = null, I(), C.current = null, T(null);
  }
  function M() {
    for (const W of w.current)
      cancelAnimationFrame(W);
    w.current = [];
  }
  function D() {
    M();
    const W = requestAnimationFrame(() => {
      const X = requestAnimationFrame(() => {
        w.current = [], a(!1);
      });
      w.current = [X];
    });
    w.current = [W];
  }
  function O(W, X) {
    y.current && (clearTimeout(y.current), y.current = null), p.current?.abort(), p.current = null, b.current = null;
    const ee = v.current;
    if (!ee) {
      k();
      return;
    }
    T({
      ...ee,
      delta: W,
      settling: !0
    }), y.current = setTimeout(() => {
      a(!0), X?.(), k(), D();
    }, JI);
  }
  function V() {
    const W = v.current;
    if (!W) {
      k();
      return;
    }
    if (W.settling) return;
    const X = C.current;
    if (!X) {
      k();
      return;
    }
    g.current?.abort(), g.current = null;
    const le = kc(X, W.fromIndex, W.overIndex)[W.fromIndex] - X.tops[W.fromIndex];
    O(le, () => {
      const {
        items: J,
        getItemId: ie,
        onReorder: pe,
        onDragEnd: oe
      } = R.current;
      if (u(`Dropped ${Ii(N(W.id), W.overIndex, J.length)}`), W.overIndex === W.fromIndex) return;
      const re = J.findIndex((fe) => ie(fe) === W.id), de = X.ids[W.overIndex], xe = J.findIndex((fe) => ie(fe) === de);
      if (re < 0 || xe < 0 || re === xe) return;
      const se = eP(J, re, xe);
      pe(se), oe?.(se);
    });
  }
  function _() {
    const W = v.current;
    if (!W) {
      k();
      return;
    }
    W.settling || (u(`Reordering cancelled. ${Ii(N(W.id), W.fromIndex, R.current.items.length)}`), T({
      ...W,
      delta: 0,
      overIndex: W.fromIndex
    }), O(0));
  }
  function A(W, X, ee = !0) {
    const {
      items: le,
      getItemId: J
    } = R.current, ie = le.findIndex((fe) => J(fe) === W);
    if (ie < 0) return;
    const pe = le.map((fe) => J(fe)), oe = pe.map((fe) => f.current.get(fe)?.getBoundingClientRect()), re = oe.map((fe) => fe ? fe.top + fe.height / 2 : 0), de = oe.map((fe, $) => {
      const Q = oe[$ + 1];
      return fe && Q ? Q.top - (fe.top + fe.height) : 0;
    }), xe = oe.map((fe) => fe?.height ?? 0), se = oe.map((fe) => fe?.top ?? 0);
    C.current = {
      centers: re,
      gaps: de,
      heights: xe,
      ids: pe,
      previousBodyCursor: typeof document > "u" ? "" : document.body.style.cursor,
      previousBodyUserSelect: typeof document > "u" ? "" : document.body.style.userSelect,
      startY: X,
      tops: se
    }, ee && P(), T({
      id: W,
      fromIndex: ie,
      overIndex: ie,
      delta: 0,
      settling: !1
    }), u(`Picked up ${Ii(N(W), ie, le.length)}`);
  }
  function L(W) {
    const ee = f.current.get(W)?.getBoundingClientRect();
    A(W, ee ? ee.top + ee.height / 2 : 0, !1), K(W);
  }
  function B(W) {
    const X = v.current, ee = C.current;
    if (!X || X.settling || !ee) return;
    const le = W - ee.startY, J = ee.centers[X.fromIndex] + le;
    let ie = 0, pe = Number.POSITIVE_INFINITY;
    for (let oe = 0; oe < ee.centers.length; oe++) {
      const re = Math.abs(J - ee.centers[oe]);
      re < pe && (pe = re, ie = oe);
    }
    ie !== X.overIndex && u(Ii(N(X.id), ie, R.current.items.length)), T({
      ...X,
      delta: le,
      overIndex: ie
    });
  }
  function G(W) {
    const X = v.current, ee = C.current;
    if (!X || X.settling || !ee) return;
    W !== X.overIndex && u(Ii(N(X.id), W, R.current.items.length));
    const le = kc(ee, X.fromIndex, W);
    T({
      ...X,
      delta: le[X.fromIndex] - ee.tops[X.fromIndex],
      overIndex: W
    });
  }
  function U(W, X) {
    if (W.pointerType === "mouse" && W.button !== 0 || v.current || b.current) return;
    W.currentTarget.setPointerCapture?.(W.pointerId), b.current = {
      id: X,
      x: W.clientX,
      y: W.clientY
    };
    const ee = new AbortController();
    p.current = ee;
    const {
      signal: le
    } = ee;
    window.addEventListener("pointermove", (J) => {
      const ie = b.current;
      if (ie && !v.current) {
        if (Math.hypot(J.clientX - ie.x, J.clientY - ie.y) < QI)
          return;
        A(ie.id, ie.y);
      }
      v.current && (J.preventDefault(), B(J.clientY));
    }, {
      signal: le
    }), window.addEventListener("pointerup", V, {
      signal: le
    }), window.addEventListener("pointercancel", _, {
      signal: le
    }), window.addEventListener("blur", _, {
      signal: le
    }), document.addEventListener("visibilitychange", () => {
      document.visibilityState === "hidden" && _();
    }, {
      signal: le
    }), window.addEventListener("keydown", (J) => {
      J.key === "Escape" && (J.preventDefault(), _());
    }, {
      signal: le
    });
  }
  function Y(W, X) {
    const ee = v.current;
    if (ee?.id !== X) return;
    if (W.key === "Tab") {
      _();
      return;
    }
    if (W.key === " " || W.key === "Enter") {
      W.preventDefault(), V();
      return;
    }
    if (W.key === "Escape") {
      W.preventDefault(), _();
      return;
    }
    const le = Mc(W.key, ee.overIndex, R.current.items.length - 1);
    le !== void 0 && (W.preventDefault(), G(le));
  }
  function K(W) {
    if (g.current?.abort(), typeof document > "u") return;
    const X = new AbortController();
    g.current = X;
    const {
      signal: ee
    } = X;
    document.addEventListener("keydown", (le) => Y(le, W), {
      signal: ee
    }), document.addEventListener("focusin", (le) => {
      if (v.current?.id !== W) return;
      const ie = le.target, pe = f.current.get(W)?.querySelector('[data-slot="sortable-handle"]');
      ie instanceof Node && pe?.contains(ie) || _();
    }, {
      signal: ee
    });
  }
  function j(W, X) {
    const ee = v.current;
    if (W.key === " " || W.key === "Enter") {
      if (W.preventDefault(), W.stopPropagation(), ee?.id === X) {
        V();
        return;
      }
      ee || L(X);
      return;
    }
    if (W.key === "Escape" && ee?.id === X) {
      W.preventDefault(), W.stopPropagation(), _();
      return;
    }
    const {
      items: le
    } = R.current, J = le.length - 1;
    if (ee?.id === X) {
      const ie = Mc(W.key, ee.overIndex, J);
      if (ie === void 0) return;
      W.preventDefault(), W.stopPropagation(), G(ie);
      return;
    }
    Mc(W.key, 0, J) !== void 0 && (W.preventDefault(), W.stopPropagation());
  }
  function Z(W, X) {
    return {
      "aria-label": `Reorder ${X}`,
      "aria-describedby": d,
      "aria-pressed": i?.id === W,
      "data-slot": "sortable-handle",
      role: "button",
      tabIndex: 0,
      onPointerDown: (ee) => U(ee, W),
      onKeyDown: (ee) => j(ee, W),
      onClick: (ee) => ee.stopPropagation()
    };
  }
  function te(W, X) {
    if (!i) return;
    if (W === i.id) return `translateY(${i.delta}px)`;
    const ee = C.current;
    if (!ee) return;
    const {
      fromIndex: le,
      overIndex: J
    } = i, pe = kc(ee, le, J)[X] - ee.tops[X];
    return pe === 0 ? void 0 : `translateY(${pe}px)`;
  }
  return x.useEffect(() => () => {
    p.current?.abort(), p.current = null, y.current && (clearTimeout(y.current), y.current = null), g.current?.abort(), g.current = null;
    for (const X of w.current)
      cancelAnimationFrame(X);
    w.current = [], b.current = null;
    const W = C.current;
    typeof document < "u" && W && (document.body.style.cursor = W.previousBodyCursor, document.body.style.userSelect = W.previousBodyUserSelect), C.current = null;
  }, []), {
    draggingId: i?.id ?? null,
    settling: i?.settling ?? !1,
    committing: l,
    getRowRef: E,
    getHandleProps: Z,
    getItemTransform: te,
    announcement: c,
    instructionsId: d
  };
}
const nP = ce(["relative", "transition-transform duration-200 ease-out", "motion-reduce:transition-none"]), oP = ce(["flex size-(--spacing-20) shrink-0 items-center justify-center", "rounded-(--radius-sm)", "text-text-subtext", "cursor-grab touch-none", "active:cursor-grabbing", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"]), rP = ce(["flex w-full items-stretch", "data-[dragging]:shadow-elevation-1"]);
function FD(t) {
  const e = z.c(8);
  let n, o;
  e[0] !== t ? ({
    className: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  e[3] !== n ? (r = ne(rP(), n), e[3] = n, e[4] = r) : r = e[4];
  let i;
  return e[5] !== o || e[6] !== r ? (i = /* @__PURE__ */ m("div", { "data-slot": "sortable-list-item", className: r, ...o }), e[5] = o, e[6] = r, e[7] = i) : i = e[7], i;
}
function iP(t) {
  const e = z.c(7);
  let n, o;
  if (e[0] !== t ? ({
    visible: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]), !(o === void 0 ? !0 : o))
    return null;
  let i, s;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = oP(), s = /* @__PURE__ */ m(Ke, { name: "grip-drag", size: "md", tone: "secondary", "aria-hidden": !0 }), e[3] = i, e[4] = s) : (i = e[3], s = e[4]);
  let l;
  return e[5] !== n ? (l = /* @__PURE__ */ m("div", { className: "flex w-(--spacing-40) shrink-0 items-center justify-center", children: /* @__PURE__ */ m("button", { ...n, type: "button", className: i, children: s }) }), e[5] = n, e[6] = l) : l = e[6], l;
}
function sP(t) {
  const e = z.c(36), {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s,
    className: l,
    children: a
  } = t;
  let c;
  e[0] !== o || e[1] !== r || e[2] !== n || e[3] !== s || e[4] !== i ? (c = {
    items: n,
    getItemId: o,
    getItemLabel: r,
    onReorder: i,
    onDragEnd: s
  }, e[0] = o, e[1] = r, e[2] = n, e[3] = s, e[4] = i, e[5] = c) : c = e[5];
  const {
    draggingId: u,
    settling: d,
    committing: f,
    getRowRef: p,
    getHandleProps: g,
    getItemTransform: h,
    announcement: b,
    instructionsId: v
  } = tP(c);
  let C;
  if (e[6] !== a || e[7] !== f || e[8] !== u || e[9] !== g || e[10] !== o || e[11] !== r || e[12] !== h || e[13] !== p || e[14] !== n || e[15] !== d) {
    let S;
    e[17] !== a || e[18] !== f || e[19] !== u || e[20] !== g || e[21] !== o || e[22] !== r || e[23] !== h || e[24] !== p || e[25] !== d ? (S = (E, N) => {
      const T = o(E), P = r(E), I = u === T, k = g(T, P), M = /* @__PURE__ */ m(iP, { ...k });
      return /* @__PURE__ */ m("div", { ref: p(T), "data-slot": "sortable-item", "data-dragging": I ? "" : void 0, style: {
        transform: h(T, N)
      }, className: ne(nP(), f && "transition-none", I && "z-10", I && !d && "transition-none"), children: a(E, {
        handle: M,
        handleProps: k,
        isDragging: I
      }) }, T);
    }, e[17] = a, e[18] = f, e[19] = u, e[20] = g, e[21] = o, e[22] = r, e[23] = h, e[24] = p, e[25] = d, e[26] = S) : S = e[26], C = n.map(S), e[6] = a, e[7] = f, e[8] = u, e[9] = g, e[10] = o, e[11] = r, e[12] = h, e[13] = p, e[14] = n, e[15] = d, e[16] = C;
  } else
    C = e[16];
  let y;
  e[27] !== v ? (y = /* @__PURE__ */ m("span", { id: v, className: "sr-only", children: "Press Space or Enter to pick up, arrow keys to move, Space or Enter to drop, or Escape to cancel." }), e[27] = v, e[28] = y) : y = e[28];
  let w;
  e[29] !== b ? (w = /* @__PURE__ */ m("span", { "aria-live": "polite", "aria-atomic": "true", className: "sr-only", children: b }), e[29] = b, e[30] = w) : w = e[30];
  let R;
  return e[31] !== l || e[32] !== C || e[33] !== y || e[34] !== w ? (R = /* @__PURE__ */ F("div", { "data-slot": "sortable-list", className: l, children: [
    C,
    y,
    w
  ] }), e[31] = l, e[32] = C, e[33] = y, e[34] = w, e[35] = R) : R = e[35], R;
}
const $D = sP, u1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (u1.displayName = "SwitchRootContext");
function lP() {
  const t = x.useContext(u1);
  if (t === void 0)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: SwitchRootContext is missing. Switch parts must be placed within <Switch.Root>." : rt(63));
  return t;
}
let Jg = /* @__PURE__ */ (function(t) {
  return t.checked = "data-checked", t.unchecked = "data-unchecked", t.disabled = "data-disabled", t.readonly = "data-readonly", t.required = "data-required", t.valid = "data-valid", t.invalid = "data-invalid", t.touched = "data-touched", t.dirty = "data-dirty", t.filled = "data-filled", t.focused = "data-focused", t;
})({});
const s3 = {
  ...to,
  checked(t) {
    return t ? {
      [Jg.checked]: ""
    } : {
      [Jg.unchecked]: ""
    };
  }
}, l3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    checked: o,
    className: r,
    defaultChecked: i,
    "aria-labelledby": s,
    form: l,
    id: a,
    inputRef: c,
    name: u,
    nativeButton: d = !1,
    onCheckedChange: f,
    readOnly: p = !1,
    required: g = !1,
    disabled: h = !1,
    render: b,
    uncheckedValue: v,
    value: C,
    style: y,
    ...w
  } = e, {
    clearErrors: R
  } = Vo(), {
    state: S,
    setTouched: E,
    setDirty: N,
    validityData: T,
    setFilled: P,
    setFocused: I,
    shouldValidateOnChange: k,
    validationMode: M,
    disabled: D,
    name: O,
    validation: V
  } = tn(), {
    labelId: _
  } = mn(), A = D || h, L = O ?? u, B = Se(f), G = x.useRef(null), U = fn(G, c, V.inputRef), Y = x.useRef(null), K = Mt(), j = Mr({
    id: a,
    implicit: !1,
    controlRef: Y
  }), Z = d ? void 0 : j, [te, W] = dn({
    controlled: o,
    default: !!i,
    name: "Switch",
    state: "checked"
  });
  pi(Y, {
    id: K,
    value: te
  }), ke(() => {
    G.current && P(G.current.checked);
  }, [G, P]), wo(te, () => {
    R(L), N(te !== T.initialValue), P(te), k() ? V.commit(te) : V.commit(te, !0);
  });
  const {
    getButtonProps: X,
    buttonRef: ee
  } = Wt({
    disabled: A,
    native: d
  }), le = Yd(s, _, G, !d, Z), J = {
    id: d ? j : K,
    role: "switch",
    "aria-checked": te,
    "aria-readonly": p || void 0,
    "aria-required": g || void 0,
    "aria-labelledby": le,
    onFocus() {
      A || I(!0);
    },
    onBlur() {
      const re = G.current;
      !re || A || (E(!0), I(!1), M === "onBlur" && V.commit(re.checked));
    },
    onClick(re) {
      p || A || (re.preventDefault(), G.current?.dispatchEvent(new PointerEvent("click", {
        bubbles: !0,
        shiftKey: re.shiftKey,
        ctrlKey: re.ctrlKey,
        altKey: re.altKey,
        metaKey: re.metaKey
      })));
    }
  }, ie = x.useMemo(() => en(
    {
      checked: te,
      disabled: A,
      form: l,
      id: Z,
      name: L,
      required: g,
      style: L ? ti : Jo,
      tabIndex: -1,
      type: "checkbox",
      "aria-hidden": !0,
      ref: U,
      onChange(re) {
        if (re.nativeEvent.defaultPrevented)
          return;
        if (p) {
          re.preventDefault();
          return;
        }
        const de = re.currentTarget.checked, xe = Ve(Pt, re.nativeEvent);
        B?.(de, xe), !xe.isCanceled && W(de);
      },
      onFocus() {
        Y.current?.focus();
      }
    },
    V.getInputValidationProps,
    // React <19 sets an empty value if `undefined` is passed explicitly
    // To avoid this, we only set the value if it's defined
    C !== void 0 ? {
      value: C
    } : St
  ), [te, A, l, U, Z, L, B, p, g, W, V, C]), pe = x.useMemo(() => ({
    ...S,
    checked: te,
    disabled: A,
    readOnly: p,
    required: g
  }), [S, te, A, p, g]), oe = $e("span", e, {
    state: pe,
    ref: [n, Y, ee],
    props: [J, V.getValidationProps, w, X],
    stateAttributesMapping: s3
  });
  return /* @__PURE__ */ F(u1.Provider, {
    value: pe,
    children: [oe, !te && L && v !== void 0 && /* @__PURE__ */ m("input", {
      type: "hidden",
      form: l,
      name: L,
      value: v
    }), /* @__PURE__ */ m("input", {
      ...ie,
      suppressHydrationWarning: !0
    })]
  });
});
process.env.NODE_ENV !== "production" && (l3.displayName = "SwitchRoot");
const a3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    state: l
  } = tn(), a = lP(), c = {
    ...l,
    ...a
  };
  return $e("span", e, {
    state: c,
    ref: n,
    stateAttributesMapping: s3,
    props: s
  });
});
process.env.NODE_ENV !== "production" && (a3.displayName = "SwitchThumb");
const aP = ce(["inline-flex", "items-start", "gap-(--spacing-8)"], {
  variants: {
    disabled: {
      true: ["opacity-[0.54]", "cursor-not-allowed"],
      false: ["cursor-pointer"]
    }
  },
  defaultVariants: {
    disabled: !1
  }
}), cP = ce(["relative", "shrink-0", "w-[44px]", "h-(--spacing-24)", "rounded-full", "bg-surface-container-highest", "data-[checked]:bg-primary", "transition-colors", "duration-200", "ease-in-out", "motion-reduce:transition-none", "focus-visible:outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-2", "focus-visible:ring-tertiary-tertiary", "cursor-[inherit]", "[@media(pointer:coarse)]:before:content-['']", "[@media(pointer:coarse)]:before:absolute", "[@media(pointer:coarse)]:before:inset-x-0", "[@media(pointer:coarse)]:before:inset-y-[-12px]"]), uP = ce(["absolute", "top-(--spacing-2)", "w-(--spacing-20)", "h-(--spacing-20)", "rounded-full", "bg-surface-container-lowest", "shadow-elevation-1", "translate-x-(--spacing-2)", "data-[checked]:translate-x-[22px]", "transition-transform", "duration-150", "ease-in-out", "motion-reduce:transition-none"]), dP = ce(["text-text-default", "font-(family-name:--font-family-body)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)"]), fP = ce(["text-text-subtle", "font-(family-name:--font-family-body)", "font-(number:--font-weight-regular)", "text-(length:--font-size-body-small)", "leading-(--font-line-height-16)"]);
function HD(t) {
  const e = z.c(25);
  let n, o, r, i, s;
  e[0] !== t ? ({
    label: r,
    description: n,
    disabled: s,
    id: o,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = s === void 0 ? !1 : s, a = _t(), c = o ?? a;
  let u;
  e[6] !== l ? (u = ne(aP({
    disabled: l
  })), e[6] = l, e[7] = u) : u = e[7];
  const d = r ? `${c}-label` : void 0, f = n ? `${c}-description` : void 0;
  let p;
  e[8] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = cP(), e[8] = p) : p = e[8];
  let g;
  e[9] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = /* @__PURE__ */ m(a3, { className: uP() }), e[9] = g) : g = e[9];
  let h;
  e[10] !== l || e[11] !== i || e[12] !== c || e[13] !== d || e[14] !== f ? (h = /* @__PURE__ */ m(l3, { ...i, id: c, disabled: l, "aria-labelledby": d, "aria-describedby": f, className: p, children: g }), e[10] = l, e[11] = i, e[12] = c, e[13] = d, e[14] = f, e[15] = h) : h = e[15];
  let b;
  e[16] !== n || e[17] !== r || e[18] !== c ? (b = (r || n) && /* @__PURE__ */ F("div", { className: "flex flex-col gap-(--spacing-4)", children: [
    r && /* @__PURE__ */ m("span", { id: `${c}-label`, className: dP(), children: r }),
    n && /* @__PURE__ */ m("span", { id: `${c}-description`, className: fP(), children: n })
  ] }), e[16] = n, e[17] = r, e[18] = c, e[19] = b) : b = e[19];
  let v;
  return e[20] !== c || e[21] !== u || e[22] !== h || e[23] !== b ? (v = /* @__PURE__ */ F("label", { htmlFor: c, className: u, children: [
    h,
    b
  ] }), e[20] = c, e[21] = u, e[22] = h, e[23] = b, e[24] = v) : v = e[24], v;
}
/**
   * table-core
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function Bo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function En(t, e) {
  return (n) => {
    e.setState((o) => ({
      ...o,
      [t]: Bo(n, o[t])
    }));
  };
}
function Pa(t) {
  return t instanceof Function;
}
function pP(t) {
  return Array.isArray(t) && t.every((e) => typeof e == "number");
}
function gP(t, e) {
  const n = [], o = (r) => {
    r.forEach((i) => {
      n.push(i);
      const s = e(i);
      s != null && s.length && o(s);
    });
  };
  return o(t), n;
}
function lt(t, e, n) {
  let o = [], r;
  return (i) => {
    let s;
    n.key && n.debug && (s = Date.now());
    const l = t(i);
    if (!(l.length !== o.length || l.some((u, d) => o[d] !== u)))
      return r;
    o = l;
    let c;
    if (n.key && n.debug && (c = Date.now()), r = e(...l), n == null || n.onChange == null || n.onChange(r), n.key && n.debug && n != null && n.debug()) {
      const u = Math.round((Date.now() - s) * 100) / 100, d = Math.round((Date.now() - c) * 100) / 100, f = d / 16, p = (g, h) => {
        for (g = String(g); g.length < h; )
          g = " " + g;
        return g;
      };
      console.info(`%c⏱ ${p(d, 5)} /${p(u, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * f, 120))}deg 100% 31%);`, n?.key);
    }
    return r;
  };
}
function at(t, e, n, o) {
  return {
    debug: () => {
      var r;
      return (r = t?.debugAll) != null ? r : t[e];
    },
    key: process.env.NODE_ENV === "development" && n,
    onChange: o
  };
}
function mP(t, e, n, o) {
  const r = () => {
    var s;
    return (s = i.getValue()) != null ? s : t.options.renderFallbackValue;
  }, i = {
    id: `${e.id}_${n.id}`,
    row: e,
    column: n,
    getValue: () => e.getValue(o),
    renderValue: r,
    getContext: lt(() => [t, n, e, i], (s, l, a, c) => ({
      table: s,
      column: l,
      row: a,
      cell: c,
      getValue: c.getValue,
      renderValue: c.renderValue
    }), at(t.options, "debugCells", "cell.getContext"))
  };
  return t._features.forEach((s) => {
    s.createCell == null || s.createCell(i, n, e, t);
  }, {}), i;
}
function hP(t, e, n, o) {
  var r, i;
  const l = {
    ...t._getDefaultColumnDef(),
    ...e
  }, a = l.accessorKey;
  let c = (r = (i = l.id) != null ? i : a ? typeof String.prototype.replaceAll == "function" ? a.replaceAll(".", "_") : a.replace(/\./g, "_") : void 0) != null ? r : typeof l.header == "string" ? l.header : void 0, u;
  if (l.accessorFn ? u = l.accessorFn : a && (a.includes(".") ? u = (f) => {
    let p = f;
    for (const h of a.split(".")) {
      var g;
      p = (g = p) == null ? void 0 : g[h], process.env.NODE_ENV !== "production" && p === void 0 && console.warn(`"${h}" in deeply nested key "${a}" returned undefined.`);
    }
    return p;
  } : u = (f) => f[l.accessorKey]), !c)
    throw process.env.NODE_ENV !== "production" ? new Error(l.accessorFn ? "Columns require an id when using an accessorFn" : "Columns require an id when using a non-string header") : new Error();
  let d = {
    id: `${String(c)}`,
    accessorFn: u,
    parent: o,
    depth: n,
    columnDef: l,
    columns: [],
    getFlatColumns: lt(() => [!0], () => {
      var f;
      return [d, ...(f = d.columns) == null ? void 0 : f.flatMap((p) => p.getFlatColumns())];
    }, at(t.options, "debugColumns", "column.getFlatColumns")),
    getLeafColumns: lt(() => [t._getOrderColumnsFn()], (f) => {
      var p;
      if ((p = d.columns) != null && p.length) {
        let g = d.columns.flatMap((h) => h.getLeafColumns());
        return f(g);
      }
      return [d];
    }, at(t.options, "debugColumns", "column.getLeafColumns"))
  };
  for (const f of t._features)
    f.createColumn == null || f.createColumn(d, t);
  return d;
}
const on = "debugHeaders";
function em(t, e, n) {
  var o;
  let i = {
    id: (o = n.id) != null ? o : e.id,
    column: e,
    index: n.index,
    isPlaceholder: !!n.isPlaceholder,
    placeholderId: n.placeholderId,
    depth: n.depth,
    subHeaders: [],
    colSpan: 0,
    rowSpan: 0,
    headerGroup: null,
    getLeafHeaders: () => {
      const s = [], l = (a) => {
        a.subHeaders && a.subHeaders.length && a.subHeaders.map(l), s.push(a);
      };
      return l(i), s;
    },
    getContext: () => ({
      table: t,
      header: i,
      column: e
    })
  };
  return t._features.forEach((s) => {
    s.createHeader == null || s.createHeader(i, t);
  }), i;
}
const bP = {
  createTable: (t) => {
    t.getHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => {
      var i, s;
      const l = (i = o?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? i : [], a = (s = r?.map((d) => n.find((f) => f.id === d)).filter(Boolean)) != null ? s : [], c = n.filter((d) => !(o != null && o.includes(d.id)) && !(r != null && r.includes(d.id)));
      return fl(e, [...l, ...c, ...a], t);
    }, at(t.options, on, "getHeaderGroups")), t.getCenterHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o, r) => (n = n.filter((i) => !(o != null && o.includes(i.id)) && !(r != null && r.includes(i.id))), fl(e, n, t, "center")), at(t.options, on, "getCenterHeaderGroups")), t.getLeftHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.left], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return fl(e, i, t, "left");
    }, at(t.options, on, "getLeftHeaderGroups")), t.getRightHeaderGroups = lt(() => [t.getAllColumns(), t.getVisibleLeafColumns(), t.getState().columnPinning.right], (e, n, o) => {
      var r;
      const i = (r = o?.map((s) => n.find((l) => l.id === s)).filter(Boolean)) != null ? r : [];
      return fl(e, i, t, "right");
    }, at(t.options, on, "getRightHeaderGroups")), t.getFooterGroups = lt(() => [t.getHeaderGroups()], (e) => [...e].reverse(), at(t.options, on, "getFooterGroups")), t.getLeftFooterGroups = lt(() => [t.getLeftHeaderGroups()], (e) => [...e].reverse(), at(t.options, on, "getLeftFooterGroups")), t.getCenterFooterGroups = lt(() => [t.getCenterHeaderGroups()], (e) => [...e].reverse(), at(t.options, on, "getCenterFooterGroups")), t.getRightFooterGroups = lt(() => [t.getRightHeaderGroups()], (e) => [...e].reverse(), at(t.options, on, "getRightFooterGroups")), t.getFlatHeaders = lt(() => [t.getHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, on, "getFlatHeaders")), t.getLeftFlatHeaders = lt(() => [t.getLeftHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, on, "getLeftFlatHeaders")), t.getCenterFlatHeaders = lt(() => [t.getCenterHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, on, "getCenterFlatHeaders")), t.getRightFlatHeaders = lt(() => [t.getRightHeaderGroups()], (e) => e.map((n) => n.headers).flat(), at(t.options, on, "getRightFlatHeaders")), t.getCenterLeafHeaders = lt(() => [t.getCenterFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), at(t.options, on, "getCenterLeafHeaders")), t.getLeftLeafHeaders = lt(() => [t.getLeftFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), at(t.options, on, "getLeftLeafHeaders")), t.getRightLeafHeaders = lt(() => [t.getRightFlatHeaders()], (e) => e.filter((n) => {
      var o;
      return !((o = n.subHeaders) != null && o.length);
    }), at(t.options, on, "getRightLeafHeaders")), t.getLeafHeaders = lt(() => [t.getLeftHeaderGroups(), t.getCenterHeaderGroups(), t.getRightHeaderGroups()], (e, n, o) => {
      var r, i, s, l, a, c;
      return [...(r = (i = e[0]) == null ? void 0 : i.headers) != null ? r : [], ...(s = (l = n[0]) == null ? void 0 : l.headers) != null ? s : [], ...(a = (c = o[0]) == null ? void 0 : c.headers) != null ? a : []].map((u) => u.getLeafHeaders()).flat();
    }, at(t.options, on, "getLeafHeaders"));
  }
};
function fl(t, e, n, o) {
  var r, i;
  let s = 0;
  const l = function(f, p) {
    p === void 0 && (p = 1), s = Math.max(s, p), f.filter((g) => g.getIsVisible()).forEach((g) => {
      var h;
      (h = g.columns) != null && h.length && l(g.columns, p + 1);
    }, 0);
  };
  l(t);
  let a = [];
  const c = (f, p) => {
    const g = {
      depth: p,
      id: [o, `${p}`].filter(Boolean).join("_"),
      headers: []
    }, h = [];
    f.forEach((b) => {
      const v = [...h].reverse()[0], C = b.column.depth === g.depth;
      let y, w = !1;
      if (C && b.column.parent ? y = b.column.parent : (y = b.column, w = !0), v && v?.column === y)
        v.subHeaders.push(b);
      else {
        const R = em(n, y, {
          id: [o, p, y.id, b?.id].filter(Boolean).join("_"),
          isPlaceholder: w,
          placeholderId: w ? `${h.filter((S) => S.column === y).length}` : void 0,
          depth: p,
          index: h.length
        });
        R.subHeaders.push(b), h.push(R);
      }
      g.headers.push(b), b.headerGroup = g;
    }), a.push(g), p > 0 && c(h, p - 1);
  }, u = e.map((f, p) => em(n, f, {
    depth: s,
    index: p
  }));
  c(u, s - 1), a.reverse();
  const d = (f) => f.filter((g) => g.column.getIsVisible()).map((g) => {
    let h = 0, b = 0, v = [0];
    g.subHeaders && g.subHeaders.length ? (v = [], d(g.subHeaders).forEach((y) => {
      let {
        colSpan: w,
        rowSpan: R
      } = y;
      h += w, v.push(R);
    })) : h = 1;
    const C = Math.min(...v);
    return b = b + C, g.colSpan = h, g.rowSpan = b, {
      colSpan: h,
      rowSpan: b
    };
  });
  return d((r = (i = a[0]) == null ? void 0 : i.headers) != null ? r : []), a;
}
const vP = (t, e, n, o, r, i, s) => {
  let l = {
    id: e,
    index: o,
    original: n,
    depth: r,
    parentId: s,
    _valuesCache: {},
    _uniqueValuesCache: {},
    getValue: (a) => {
      if (l._valuesCache.hasOwnProperty(a))
        return l._valuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return l._valuesCache[a] = c.accessorFn(l.original, o), l._valuesCache[a];
    },
    getUniqueValues: (a) => {
      if (l._uniqueValuesCache.hasOwnProperty(a))
        return l._uniqueValuesCache[a];
      const c = t.getColumn(a);
      if (c != null && c.accessorFn)
        return c.columnDef.getUniqueValues ? (l._uniqueValuesCache[a] = c.columnDef.getUniqueValues(l.original, o), l._uniqueValuesCache[a]) : (l._uniqueValuesCache[a] = [l.getValue(a)], l._uniqueValuesCache[a]);
    },
    renderValue: (a) => {
      var c;
      return (c = l.getValue(a)) != null ? c : t.options.renderFallbackValue;
    },
    subRows: [],
    getLeafRows: () => gP(l.subRows, (a) => a.subRows),
    getParentRow: () => l.parentId ? t.getRow(l.parentId, !0) : void 0,
    getParentRows: () => {
      let a = [], c = l;
      for (; ; ) {
        const u = c.getParentRow();
        if (!u) break;
        a.push(u), c = u;
      }
      return a.reverse();
    },
    getAllCells: lt(() => [t.getAllLeafColumns()], (a) => a.map((c) => mP(t, l, c, c.id)), at(t.options, "debugRows", "getAllCells")),
    _getAllCellsByColumnId: lt(() => [l.getAllCells()], (a) => a.reduce((c, u) => (c[u.column.id] = u, c), {}), at(t.options, "debugRows", "getAllCellsByColumnId"))
  };
  for (let a = 0; a < t._features.length; a++) {
    const c = t._features[a];
    c == null || c.createRow == null || c.createRow(l, t);
  }
  return l;
}, yP = {
  createColumn: (t, e) => {
    t._getFacetedRowModel = e.options.getFacetedRowModel && e.options.getFacetedRowModel(e, t.id), t.getFacetedRowModel = () => t._getFacetedRowModel ? t._getFacetedRowModel() : e.getPreFilteredRowModel(), t._getFacetedUniqueValues = e.options.getFacetedUniqueValues && e.options.getFacetedUniqueValues(e, t.id), t.getFacetedUniqueValues = () => t._getFacetedUniqueValues ? t._getFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getFacetedMinMaxValues = e.options.getFacetedMinMaxValues && e.options.getFacetedMinMaxValues(e, t.id), t.getFacetedMinMaxValues = () => {
      if (t._getFacetedMinMaxValues)
        return t._getFacetedMinMaxValues();
    };
  }
}, c3 = (t, e, n) => {
  var o, r;
  const i = n == null || (o = n.toString()) == null ? void 0 : o.toLowerCase();
  return !!(!((r = t.getValue(e)) == null || (r = r.toString()) == null || (r = r.toLowerCase()) == null) && r.includes(i));
};
c3.autoRemove = (t) => jn(t);
const u3 = (t, e, n) => {
  var o;
  return !!(!((o = t.getValue(e)) == null || (o = o.toString()) == null) && o.includes(n));
};
u3.autoRemove = (t) => jn(t);
const d3 = (t, e, n) => {
  var o;
  return ((o = t.getValue(e)) == null || (o = o.toString()) == null ? void 0 : o.toLowerCase()) === n?.toLowerCase();
};
d3.autoRemove = (t) => jn(t);
const f3 = (t, e, n) => {
  var o;
  return (o = t.getValue(e)) == null ? void 0 : o.includes(n);
};
f3.autoRemove = (t) => jn(t);
const p3 = (t, e, n) => !n.some((o) => {
  var r;
  return !((r = t.getValue(e)) != null && r.includes(o));
});
p3.autoRemove = (t) => jn(t) || !(t != null && t.length);
const g3 = (t, e, n) => n.some((o) => {
  var r;
  return (r = t.getValue(e)) == null ? void 0 : r.includes(o);
});
g3.autoRemove = (t) => jn(t) || !(t != null && t.length);
const m3 = (t, e, n) => t.getValue(e) === n;
m3.autoRemove = (t) => jn(t);
const h3 = (t, e, n) => t.getValue(e) == n;
h3.autoRemove = (t) => jn(t);
const d1 = (t, e, n) => {
  let [o, r] = n;
  const i = t.getValue(e);
  return i >= o && i <= r;
};
d1.resolveFilterValue = (t) => {
  let [e, n] = t, o = typeof e != "number" ? parseFloat(e) : e, r = typeof n != "number" ? parseFloat(n) : n, i = e === null || Number.isNaN(o) ? -1 / 0 : o, s = n === null || Number.isNaN(r) ? 1 / 0 : r;
  if (i > s) {
    const l = i;
    i = s, s = l;
  }
  return [i, s];
};
d1.autoRemove = (t) => jn(t) || jn(t[0]) && jn(t[1]);
const Co = {
  includesString: c3,
  includesStringSensitive: u3,
  equalsString: d3,
  arrIncludes: f3,
  arrIncludesAll: p3,
  arrIncludesSome: g3,
  equals: m3,
  weakEquals: h3,
  inNumberRange: d1
};
function jn(t) {
  return t == null || t === "";
}
const xP = {
  getDefaultColumnDef: () => ({
    filterFn: "auto"
  }),
  getInitialState: (t) => ({
    columnFilters: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnFiltersChange: En("columnFilters", t),
    filterFromLeafRows: !1,
    maxLeafRowFilterDepth: 100
  }),
  createColumn: (t, e) => {
    t.getAutoFilterFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      return typeof o == "string" ? Co.includesString : typeof o == "number" ? Co.inNumberRange : typeof o == "boolean" || o !== null && typeof o == "object" ? Co.equals : Array.isArray(o) ? Co.arrIncludes : Co.weakEquals;
    }, t.getFilterFn = () => {
      var n, o;
      return Pa(t.columnDef.filterFn) ? t.columnDef.filterFn : t.columnDef.filterFn === "auto" ? t.getAutoFilterFn() : (
        // @ts-ignore
        (n = (o = e.options.filterFns) == null ? void 0 : o[t.columnDef.filterFn]) != null ? n : Co[t.columnDef.filterFn]
      );
    }, t.getCanFilter = () => {
      var n, o, r;
      return ((n = t.columnDef.enableColumnFilter) != null ? n : !0) && ((o = e.options.enableColumnFilters) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && !!t.accessorFn;
    }, t.getIsFiltered = () => t.getFilterIndex() > -1, t.getFilterValue = () => {
      var n;
      return (n = e.getState().columnFilters) == null || (n = n.find((o) => o.id === t.id)) == null ? void 0 : n.value;
    }, t.getFilterIndex = () => {
      var n, o;
      return (n = (o = e.getState().columnFilters) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.setFilterValue = (n) => {
      e.setColumnFilters((o) => {
        const r = t.getFilterFn(), i = o?.find((u) => u.id === t.id), s = Bo(n, i ? i.value : void 0);
        if (tm(r, s, t)) {
          var l;
          return (l = o?.filter((u) => u.id !== t.id)) != null ? l : [];
        }
        const a = {
          id: t.id,
          value: s
        };
        if (i) {
          var c;
          return (c = o?.map((u) => u.id === t.id ? a : u)) != null ? c : [];
        }
        return o != null && o.length ? [...o, a] : [a];
      });
    };
  },
  createRow: (t, e) => {
    t.columnFilters = {}, t.columnFiltersMeta = {};
  },
  createTable: (t) => {
    t.setColumnFilters = (e) => {
      const n = t.getAllLeafColumns(), o = (r) => {
        var i;
        return (i = Bo(e, r)) == null ? void 0 : i.filter((s) => {
          const l = n.find((a) => a.id === s.id);
          if (l) {
            const a = l.getFilterFn();
            if (tm(a, s.value, l))
              return !1;
          }
          return !0;
        });
      };
      t.options.onColumnFiltersChange == null || t.options.onColumnFiltersChange(o);
    }, t.resetColumnFilters = (e) => {
      var n, o;
      t.setColumnFilters(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.columnFilters) != null ? n : []);
    }, t.getPreFilteredRowModel = () => t.getCoreRowModel(), t.getFilteredRowModel = () => (!t._getFilteredRowModel && t.options.getFilteredRowModel && (t._getFilteredRowModel = t.options.getFilteredRowModel(t)), t.options.manualFiltering || !t._getFilteredRowModel ? t.getPreFilteredRowModel() : t._getFilteredRowModel());
  }
};
function tm(t, e, n) {
  return (t && t.autoRemove ? t.autoRemove(e, n) : !1) || typeof e > "u" || typeof e == "string" && !e;
}
const CP = (t, e, n) => n.reduce((o, r) => {
  const i = r.getValue(t);
  return o + (typeof i == "number" ? i : 0);
}, 0), wP = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o > i || o === void 0 && i >= i) && (o = i);
  }), o;
}, SP = (t, e, n) => {
  let o;
  return n.forEach((r) => {
    const i = r.getValue(t);
    i != null && (o < i || o === void 0 && i >= i) && (o = i);
  }), o;
}, RP = (t, e, n) => {
  let o, r;
  return n.forEach((i) => {
    const s = i.getValue(t);
    s != null && (o === void 0 ? s >= s && (o = r = s) : (o > s && (o = s), r < s && (r = s)));
  }), [o, r];
}, EP = (t, e) => {
  let n = 0, o = 0;
  if (e.forEach((r) => {
    let i = r.getValue(t);
    i != null && (i = +i) >= i && (++n, o += i);
  }), n) return o / n;
}, NP = (t, e) => {
  if (!e.length)
    return;
  const n = e.map((i) => i.getValue(t));
  if (!pP(n))
    return;
  if (n.length === 1)
    return n[0];
  const o = Math.floor(n.length / 2), r = n.sort((i, s) => i - s);
  return n.length % 2 !== 0 ? r[o] : (r[o - 1] + r[o]) / 2;
}, kP = (t, e) => Array.from(new Set(e.map((n) => n.getValue(t))).values()), MP = (t, e) => new Set(e.map((n) => n.getValue(t))).size, IP = (t, e) => e.length, Ic = {
  sum: CP,
  min: wP,
  max: SP,
  extent: RP,
  mean: EP,
  median: NP,
  unique: kP,
  uniqueCount: MP,
  count: IP
}, PP = {
  getDefaultColumnDef: () => ({
    aggregatedCell: (t) => {
      var e, n;
      return (e = (n = t.getValue()) == null || n.toString == null ? void 0 : n.toString()) != null ? e : null;
    },
    aggregationFn: "auto"
  }),
  getInitialState: (t) => ({
    grouping: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGroupingChange: En("grouping", t),
    groupedColumnMode: "reorder"
  }),
  createColumn: (t, e) => {
    t.toggleGrouping = () => {
      e.setGrouping((n) => n != null && n.includes(t.id) ? n.filter((o) => o !== t.id) : [...n ?? [], t.id]);
    }, t.getCanGroup = () => {
      var n, o;
      return ((n = t.columnDef.enableGrouping) != null ? n : !0) && ((o = e.options.enableGrouping) != null ? o : !0) && (!!t.accessorFn || !!t.columnDef.getGroupingValue);
    }, t.getIsGrouped = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.includes(t.id);
    }, t.getGroupedIndex = () => {
      var n;
      return (n = e.getState().grouping) == null ? void 0 : n.indexOf(t.id);
    }, t.getToggleGroupingHandler = () => {
      const n = t.getCanGroup();
      return () => {
        n && t.toggleGrouping();
      };
    }, t.getAutoAggregationFn = () => {
      const n = e.getCoreRowModel().flatRows[0], o = n?.getValue(t.id);
      if (typeof o == "number")
        return Ic.sum;
      if (Object.prototype.toString.call(o) === "[object Date]")
        return Ic.extent;
    }, t.getAggregationFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Pa(t.columnDef.aggregationFn) ? t.columnDef.aggregationFn : t.columnDef.aggregationFn === "auto" ? t.getAutoAggregationFn() : (n = (o = e.options.aggregationFns) == null ? void 0 : o[t.columnDef.aggregationFn]) != null ? n : Ic[t.columnDef.aggregationFn];
    };
  },
  createTable: (t) => {
    t.setGrouping = (e) => t.options.onGroupingChange == null ? void 0 : t.options.onGroupingChange(e), t.resetGrouping = (e) => {
      var n, o;
      t.setGrouping(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.grouping) != null ? n : []);
    }, t.getPreGroupedRowModel = () => t.getFilteredRowModel(), t.getGroupedRowModel = () => (!t._getGroupedRowModel && t.options.getGroupedRowModel && (t._getGroupedRowModel = t.options.getGroupedRowModel(t)), t.options.manualGrouping || !t._getGroupedRowModel ? t.getPreGroupedRowModel() : t._getGroupedRowModel());
  },
  createRow: (t, e) => {
    t.getIsGrouped = () => !!t.groupingColumnId, t.getGroupingValue = (n) => {
      if (t._groupingValuesCache.hasOwnProperty(n))
        return t._groupingValuesCache[n];
      const o = e.getColumn(n);
      return o != null && o.columnDef.getGroupingValue ? (t._groupingValuesCache[n] = o.columnDef.getGroupingValue(t.original), t._groupingValuesCache[n]) : t.getValue(n);
    }, t._groupingValuesCache = {};
  },
  createCell: (t, e, n, o) => {
    t.getIsGrouped = () => e.getIsGrouped() && e.id === n.groupingColumnId, t.getIsPlaceholder = () => !t.getIsGrouped() && e.getIsGrouped(), t.getIsAggregated = () => {
      var r;
      return !t.getIsGrouped() && !t.getIsPlaceholder() && !!((r = n.subRows) != null && r.length);
    };
  }
};
function TP(t, e, n) {
  if (!(e != null && e.length) || !n)
    return t;
  const o = t.filter((i) => !e.includes(i.id));
  return n === "remove" ? o : [...e.map((i) => t.find((s) => s.id === i)).filter(Boolean), ...o];
}
const OP = {
  getInitialState: (t) => ({
    columnOrder: [],
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnOrderChange: En("columnOrder", t)
  }),
  createColumn: (t, e) => {
    t.getIndex = lt((n) => [zi(e, n)], (n) => n.findIndex((o) => o.id === t.id), at(e.options, "debugColumns", "getIndex")), t.getIsFirstColumn = (n) => {
      var o;
      return ((o = zi(e, n)[0]) == null ? void 0 : o.id) === t.id;
    }, t.getIsLastColumn = (n) => {
      var o;
      const r = zi(e, n);
      return ((o = r[r.length - 1]) == null ? void 0 : o.id) === t.id;
    };
  },
  createTable: (t) => {
    t.setColumnOrder = (e) => t.options.onColumnOrderChange == null ? void 0 : t.options.onColumnOrderChange(e), t.resetColumnOrder = (e) => {
      var n;
      t.setColumnOrder(e ? [] : (n = t.initialState.columnOrder) != null ? n : []);
    }, t._getOrderColumnsFn = lt(() => [t.getState().columnOrder, t.getState().grouping, t.options.groupedColumnMode], (e, n, o) => (r) => {
      let i = [];
      if (!(e != null && e.length))
        i = r;
      else {
        const s = [...e], l = [...r];
        for (; l.length && s.length; ) {
          const a = s.shift(), c = l.findIndex((u) => u.id === a);
          c > -1 && i.push(l.splice(c, 1)[0]);
        }
        i = [...i, ...l];
      }
      return TP(i, n, o);
    }, at(t.options, "debugTable", "_getOrderColumnsFn"));
  }
}, Pc = () => ({
  left: [],
  right: []
}), DP = {
  getInitialState: (t) => ({
    columnPinning: Pc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnPinningChange: En("columnPinning", t)
  }),
  createColumn: (t, e) => {
    t.pin = (n) => {
      const o = t.getLeafColumns().map((r) => r.id).filter(Boolean);
      e.setColumnPinning((r) => {
        var i, s;
        if (n === "right") {
          var l, a;
          return {
            left: ((l = r?.left) != null ? l : []).filter((d) => !(o != null && o.includes(d))),
            right: [...((a = r?.right) != null ? a : []).filter((d) => !(o != null && o.includes(d))), ...o]
          };
        }
        if (n === "left") {
          var c, u;
          return {
            left: [...((c = r?.left) != null ? c : []).filter((d) => !(o != null && o.includes(d))), ...o],
            right: ((u = r?.right) != null ? u : []).filter((d) => !(o != null && o.includes(d)))
          };
        }
        return {
          left: ((i = r?.left) != null ? i : []).filter((d) => !(o != null && o.includes(d))),
          right: ((s = r?.right) != null ? s : []).filter((d) => !(o != null && o.includes(d)))
        };
      });
    }, t.getCanPin = () => t.getLeafColumns().some((o) => {
      var r, i, s;
      return ((r = o.columnDef.enablePinning) != null ? r : !0) && ((i = (s = e.options.enableColumnPinning) != null ? s : e.options.enablePinning) != null ? i : !0);
    }), t.getIsPinned = () => {
      const n = t.getLeafColumns().map((l) => l.id), {
        left: o,
        right: r
      } = e.getState().columnPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "left" : s ? "right" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      return r ? (n = (o = e.getState().columnPinning) == null || (o = o[r]) == null ? void 0 : o.indexOf(t.id)) != null ? n : -1 : 0;
    };
  },
  createRow: (t, e) => {
    t.getCenterVisibleCells = lt(() => [t._getAllVisibleCells(), e.getState().columnPinning.left, e.getState().columnPinning.right], (n, o, r) => {
      const i = [...o ?? [], ...r ?? []];
      return n.filter((s) => !i.includes(s.column.id));
    }, at(e.options, "debugRows", "getCenterVisibleCells")), t.getLeftVisibleCells = lt(() => [t._getAllVisibleCells(), e.getState().columnPinning.left], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "left"
    })), at(e.options, "debugRows", "getLeftVisibleCells")), t.getRightVisibleCells = lt(() => [t._getAllVisibleCells(), e.getState().columnPinning.right], (n, o) => (o ?? []).map((i) => n.find((s) => s.column.id === i)).filter(Boolean).map((i) => ({
      ...i,
      position: "right"
    })), at(e.options, "debugRows", "getRightVisibleCells"));
  },
  createTable: (t) => {
    t.setColumnPinning = (e) => t.options.onColumnPinningChange == null ? void 0 : t.options.onColumnPinningChange(e), t.resetColumnPinning = (e) => {
      var n, o;
      return t.setColumnPinning(e ? Pc() : (n = (o = t.initialState) == null ? void 0 : o.columnPinning) != null ? n : Pc());
    }, t.getIsSomeColumnsPinned = (e) => {
      var n;
      const o = t.getState().columnPinning;
      if (!e) {
        var r, i;
        return !!((r = o.left) != null && r.length || (i = o.right) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t.getLeftLeafColumns = lt(() => [t.getAllLeafColumns(), t.getState().columnPinning.left], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), at(t.options, "debugColumns", "getLeftLeafColumns")), t.getRightLeafColumns = lt(() => [t.getAllLeafColumns(), t.getState().columnPinning.right], (e, n) => (n ?? []).map((o) => e.find((r) => r.id === o)).filter(Boolean), at(t.options, "debugColumns", "getRightLeafColumns")), t.getCenterLeafColumns = lt(() => [t.getAllLeafColumns(), t.getState().columnPinning.left, t.getState().columnPinning.right], (e, n, o) => {
      const r = [...n ?? [], ...o ?? []];
      return e.filter((i) => !r.includes(i.id));
    }, at(t.options, "debugColumns", "getCenterLeafColumns"));
  }
};
function VP(t) {
  return t || (typeof document < "u" ? document : null);
}
const pl = {
  size: 150,
  minSize: 20,
  maxSize: Number.MAX_SAFE_INTEGER
}, Tc = () => ({
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  isResizingColumn: !1,
  columnSizingStart: []
}), _P = {
  getDefaultColumnDef: () => pl,
  getInitialState: (t) => ({
    columnSizing: {},
    columnSizingInfo: Tc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    columnResizeMode: "onEnd",
    columnResizeDirection: "ltr",
    onColumnSizingChange: En("columnSizing", t),
    onColumnSizingInfoChange: En("columnSizingInfo", t)
  }),
  createColumn: (t, e) => {
    t.getSize = () => {
      var n, o, r;
      const i = e.getState().columnSizing[t.id];
      return Math.min(Math.max((n = t.columnDef.minSize) != null ? n : pl.minSize, (o = i ?? t.columnDef.size) != null ? o : pl.size), (r = t.columnDef.maxSize) != null ? r : pl.maxSize);
    }, t.getStart = lt((n) => [n, zi(e, n), e.getState().columnSizing], (n, o) => o.slice(0, t.getIndex(n)).reduce((r, i) => r + i.getSize(), 0), at(e.options, "debugColumns", "getStart")), t.getAfter = lt((n) => [n, zi(e, n), e.getState().columnSizing], (n, o) => o.slice(t.getIndex(n) + 1).reduce((r, i) => r + i.getSize(), 0), at(e.options, "debugColumns", "getAfter")), t.resetSize = () => {
      e.setColumnSizing((n) => {
        let {
          [t.id]: o,
          ...r
        } = n;
        return r;
      });
    }, t.getCanResize = () => {
      var n, o;
      return ((n = t.columnDef.enableResizing) != null ? n : !0) && ((o = e.options.enableColumnResizing) != null ? o : !0);
    }, t.getIsResizing = () => e.getState().columnSizingInfo.isResizingColumn === t.id;
  },
  createHeader: (t, e) => {
    t.getSize = () => {
      let n = 0;
      const o = (r) => {
        if (r.subHeaders.length)
          r.subHeaders.forEach(o);
        else {
          var i;
          n += (i = r.column.getSize()) != null ? i : 0;
        }
      };
      return o(t), n;
    }, t.getStart = () => {
      if (t.index > 0) {
        const n = t.headerGroup.headers[t.index - 1];
        return n.getStart() + n.getSize();
      }
      return 0;
    }, t.getResizeHandler = (n) => {
      const o = e.getColumn(t.column.id), r = o?.getCanResize();
      return (i) => {
        if (!o || !r || (i.persist == null || i.persist(), Oc(i) && i.touches && i.touches.length > 1))
          return;
        const s = t.getSize(), l = t ? t.getLeafHeaders().map((v) => [v.column.id, v.column.getSize()]) : [[o.id, o.getSize()]], a = Oc(i) ? Math.round(i.touches[0].clientX) : i.clientX, c = {}, u = (v, C) => {
          typeof C == "number" && (e.setColumnSizingInfo((y) => {
            var w, R;
            const S = e.options.columnResizeDirection === "rtl" ? -1 : 1, E = (C - ((w = y?.startOffset) != null ? w : 0)) * S, N = Math.max(E / ((R = y?.startSize) != null ? R : 0), -0.999999);
            return y.columnSizingStart.forEach((T) => {
              let [P, I] = T;
              c[P] = Math.round(Math.max(I + I * N, 0) * 100) / 100;
            }), {
              ...y,
              deltaOffset: E,
              deltaPercentage: N
            };
          }), (e.options.columnResizeMode === "onChange" || v === "end") && e.setColumnSizing((y) => ({
            ...y,
            ...c
          })));
        }, d = (v) => u("move", v), f = (v) => {
          u("end", v), e.setColumnSizingInfo((C) => ({
            ...C,
            isResizingColumn: !1,
            startOffset: null,
            startSize: null,
            deltaOffset: null,
            deltaPercentage: null,
            columnSizingStart: []
          }));
        }, p = VP(n), g = {
          moveHandler: (v) => d(v.clientX),
          upHandler: (v) => {
            p?.removeEventListener("mousemove", g.moveHandler), p?.removeEventListener("mouseup", g.upHandler), f(v.clientX);
          }
        }, h = {
          moveHandler: (v) => (v.cancelable && (v.preventDefault(), v.stopPropagation()), d(v.touches[0].clientX), !1),
          upHandler: (v) => {
            var C;
            p?.removeEventListener("touchmove", h.moveHandler), p?.removeEventListener("touchend", h.upHandler), v.cancelable && (v.preventDefault(), v.stopPropagation()), f((C = v.touches[0]) == null ? void 0 : C.clientX);
          }
        }, b = AP() ? {
          passive: !1
        } : !1;
        Oc(i) ? (p?.addEventListener("touchmove", h.moveHandler, b), p?.addEventListener("touchend", h.upHandler, b)) : (p?.addEventListener("mousemove", g.moveHandler, b), p?.addEventListener("mouseup", g.upHandler, b)), e.setColumnSizingInfo((v) => ({
          ...v,
          startOffset: a,
          startSize: s,
          deltaOffset: 0,
          deltaPercentage: 0,
          columnSizingStart: l,
          isResizingColumn: o.id
        }));
      };
    };
  },
  createTable: (t) => {
    t.setColumnSizing = (e) => t.options.onColumnSizingChange == null ? void 0 : t.options.onColumnSizingChange(e), t.setColumnSizingInfo = (e) => t.options.onColumnSizingInfoChange == null ? void 0 : t.options.onColumnSizingInfoChange(e), t.resetColumnSizing = (e) => {
      var n;
      t.setColumnSizing(e ? {} : (n = t.initialState.columnSizing) != null ? n : {});
    }, t.resetHeaderSizeInfo = (e) => {
      var n;
      t.setColumnSizingInfo(e ? Tc() : (n = t.initialState.columnSizingInfo) != null ? n : Tc());
    }, t.getTotalSize = () => {
      var e, n;
      return (e = (n = t.getHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getLeftTotalSize = () => {
      var e, n;
      return (e = (n = t.getLeftHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getCenterTotalSize = () => {
      var e, n;
      return (e = (n = t.getCenterHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    }, t.getRightTotalSize = () => {
      var e, n;
      return (e = (n = t.getRightHeaderGroups()[0]) == null ? void 0 : n.headers.reduce((o, r) => o + r.getSize(), 0)) != null ? e : 0;
    };
  }
};
let gl = null;
function AP() {
  if (typeof gl == "boolean") return gl;
  let t = !1;
  try {
    const e = {
      get passive() {
        return t = !0, !1;
      }
    }, n = () => {
    };
    window.addEventListener("test", n, e), window.removeEventListener("test", n);
  } catch {
    t = !1;
  }
  return gl = t, gl;
}
function Oc(t) {
  return t.type === "touchstart";
}
const LP = {
  getInitialState: (t) => ({
    columnVisibility: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onColumnVisibilityChange: En("columnVisibility", t)
  }),
  createColumn: (t, e) => {
    t.toggleVisibility = (n) => {
      t.getCanHide() && e.setColumnVisibility((o) => ({
        ...o,
        [t.id]: n ?? !t.getIsVisible()
      }));
    }, t.getIsVisible = () => {
      var n, o;
      const r = t.columns;
      return (n = r.length ? r.some((i) => i.getIsVisible()) : (o = e.getState().columnVisibility) == null ? void 0 : o[t.id]) != null ? n : !0;
    }, t.getCanHide = () => {
      var n, o;
      return ((n = t.columnDef.enableHiding) != null ? n : !0) && ((o = e.options.enableHiding) != null ? o : !0);
    }, t.getToggleVisibilityHandler = () => (n) => {
      t.toggleVisibility == null || t.toggleVisibility(n.target.checked);
    };
  },
  createRow: (t, e) => {
    t._getAllVisibleCells = lt(() => [t.getAllCells(), e.getState().columnVisibility], (n) => n.filter((o) => o.column.getIsVisible()), at(e.options, "debugRows", "_getAllVisibleCells")), t.getVisibleCells = lt(() => [t.getLeftVisibleCells(), t.getCenterVisibleCells(), t.getRightVisibleCells()], (n, o, r) => [...n, ...o, ...r], at(e.options, "debugRows", "getVisibleCells"));
  },
  createTable: (t) => {
    const e = (n, o) => lt(() => [o(), o().filter((r) => r.getIsVisible()).map((r) => r.id).join("_")], (r) => r.filter((i) => i.getIsVisible == null ? void 0 : i.getIsVisible()), at(t.options, "debugColumns", n));
    t.getVisibleFlatColumns = e("getVisibleFlatColumns", () => t.getAllFlatColumns()), t.getVisibleLeafColumns = e("getVisibleLeafColumns", () => t.getAllLeafColumns()), t.getLeftVisibleLeafColumns = e("getLeftVisibleLeafColumns", () => t.getLeftLeafColumns()), t.getRightVisibleLeafColumns = e("getRightVisibleLeafColumns", () => t.getRightLeafColumns()), t.getCenterVisibleLeafColumns = e("getCenterVisibleLeafColumns", () => t.getCenterLeafColumns()), t.setColumnVisibility = (n) => t.options.onColumnVisibilityChange == null ? void 0 : t.options.onColumnVisibilityChange(n), t.resetColumnVisibility = (n) => {
      var o;
      t.setColumnVisibility(n ? {} : (o = t.initialState.columnVisibility) != null ? o : {});
    }, t.toggleAllColumnsVisible = (n) => {
      var o;
      n = (o = n) != null ? o : !t.getIsAllColumnsVisible(), t.setColumnVisibility(t.getAllLeafColumns().reduce((r, i) => ({
        ...r,
        [i.id]: n || !(i.getCanHide != null && i.getCanHide())
      }), {}));
    }, t.getIsAllColumnsVisible = () => !t.getAllLeafColumns().some((n) => !(n.getIsVisible != null && n.getIsVisible())), t.getIsSomeColumnsVisible = () => t.getAllLeafColumns().some((n) => n.getIsVisible == null ? void 0 : n.getIsVisible()), t.getToggleAllColumnsVisibilityHandler = () => (n) => {
      var o;
      t.toggleAllColumnsVisible((o = n.target) == null ? void 0 : o.checked);
    };
  }
};
function zi(t, e) {
  return e ? e === "center" ? t.getCenterVisibleLeafColumns() : e === "left" ? t.getLeftVisibleLeafColumns() : t.getRightVisibleLeafColumns() : t.getVisibleLeafColumns();
}
const FP = {
  createTable: (t) => {
    t._getGlobalFacetedRowModel = t.options.getFacetedRowModel && t.options.getFacetedRowModel(t, "__global__"), t.getGlobalFacetedRowModel = () => t.options.manualFiltering || !t._getGlobalFacetedRowModel ? t.getPreFilteredRowModel() : t._getGlobalFacetedRowModel(), t._getGlobalFacetedUniqueValues = t.options.getFacetedUniqueValues && t.options.getFacetedUniqueValues(t, "__global__"), t.getGlobalFacetedUniqueValues = () => t._getGlobalFacetedUniqueValues ? t._getGlobalFacetedUniqueValues() : /* @__PURE__ */ new Map(), t._getGlobalFacetedMinMaxValues = t.options.getFacetedMinMaxValues && t.options.getFacetedMinMaxValues(t, "__global__"), t.getGlobalFacetedMinMaxValues = () => {
      if (t._getGlobalFacetedMinMaxValues)
        return t._getGlobalFacetedMinMaxValues();
    };
  }
}, $P = {
  getInitialState: (t) => ({
    globalFilter: void 0,
    ...t
  }),
  getDefaultOptions: (t) => ({
    onGlobalFilterChange: En("globalFilter", t),
    globalFilterFn: "auto",
    getColumnCanGlobalFilter: (e) => {
      var n;
      const o = (n = t.getCoreRowModel().flatRows[0]) == null || (n = n._getAllCellsByColumnId()[e.id]) == null ? void 0 : n.getValue();
      return typeof o == "string" || typeof o == "number";
    }
  }),
  createColumn: (t, e) => {
    t.getCanGlobalFilter = () => {
      var n, o, r, i;
      return ((n = t.columnDef.enableGlobalFilter) != null ? n : !0) && ((o = e.options.enableGlobalFilter) != null ? o : !0) && ((r = e.options.enableFilters) != null ? r : !0) && ((i = e.options.getColumnCanGlobalFilter == null ? void 0 : e.options.getColumnCanGlobalFilter(t)) != null ? i : !0) && !!t.accessorFn;
    };
  },
  createTable: (t) => {
    t.getGlobalAutoFilterFn = () => Co.includesString, t.getGlobalFilterFn = () => {
      var e, n;
      const {
        globalFilterFn: o
      } = t.options;
      return Pa(o) ? o : o === "auto" ? t.getGlobalAutoFilterFn() : (e = (n = t.options.filterFns) == null ? void 0 : n[o]) != null ? e : Co[o];
    }, t.setGlobalFilter = (e) => {
      t.options.onGlobalFilterChange == null || t.options.onGlobalFilterChange(e);
    }, t.resetGlobalFilter = (e) => {
      t.setGlobalFilter(e ? void 0 : t.initialState.globalFilter);
    };
  }
}, HP = {
  getInitialState: (t) => ({
    expanded: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onExpandedChange: En("expanded", t),
    paginateExpandedRows: !0
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetExpanded = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetExpanded) != null ? o : !t.options.manualExpanding) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetExpanded(), n = !1;
        });
      }
    }, t.setExpanded = (o) => t.options.onExpandedChange == null ? void 0 : t.options.onExpandedChange(o), t.toggleAllRowsExpanded = (o) => {
      o ?? !t.getIsAllRowsExpanded() ? t.setExpanded(!0) : t.setExpanded({});
    }, t.resetExpanded = (o) => {
      var r, i;
      t.setExpanded(o ? {} : (r = (i = t.initialState) == null ? void 0 : i.expanded) != null ? r : {});
    }, t.getCanSomeRowsExpand = () => t.getPrePaginationRowModel().flatRows.some((o) => o.getCanExpand()), t.getToggleAllRowsExpandedHandler = () => (o) => {
      o.persist == null || o.persist(), t.toggleAllRowsExpanded();
    }, t.getIsSomeRowsExpanded = () => {
      const o = t.getState().expanded;
      return o === !0 || Object.values(o).some(Boolean);
    }, t.getIsAllRowsExpanded = () => {
      const o = t.getState().expanded;
      return typeof o == "boolean" ? o === !0 : !(!Object.keys(o).length || t.getRowModel().flatRows.some((r) => !r.getIsExpanded()));
    }, t.getExpandedDepth = () => {
      let o = 0;
      return (t.getState().expanded === !0 ? Object.keys(t.getRowModel().rowsById) : Object.keys(t.getState().expanded)).forEach((i) => {
        const s = i.split(".");
        o = Math.max(o, s.length);
      }), o;
    }, t.getPreExpandedRowModel = () => t.getSortedRowModel(), t.getExpandedRowModel = () => (!t._getExpandedRowModel && t.options.getExpandedRowModel && (t._getExpandedRowModel = t.options.getExpandedRowModel(t)), t.options.manualExpanding || !t._getExpandedRowModel ? t.getPreExpandedRowModel() : t._getExpandedRowModel());
  },
  createRow: (t, e) => {
    t.toggleExpanded = (n) => {
      e.setExpanded((o) => {
        var r;
        const i = o === !0 ? !0 : !!(o != null && o[t.id]);
        let s = {};
        if (o === !0 ? Object.keys(e.getRowModel().rowsById).forEach((l) => {
          s[l] = !0;
        }) : s = o, n = (r = n) != null ? r : !i, !i && n)
          return {
            ...s,
            [t.id]: !0
          };
        if (i && !n) {
          const {
            [t.id]: l,
            ...a
          } = s;
          return a;
        }
        return o;
      });
    }, t.getIsExpanded = () => {
      var n;
      const o = e.getState().expanded;
      return !!((n = e.options.getIsRowExpanded == null ? void 0 : e.options.getIsRowExpanded(t)) != null ? n : o === !0 || o?.[t.id]);
    }, t.getCanExpand = () => {
      var n, o, r;
      return (n = e.options.getRowCanExpand == null ? void 0 : e.options.getRowCanExpand(t)) != null ? n : ((o = e.options.enableExpanding) != null ? o : !0) && !!((r = t.subRows) != null && r.length);
    }, t.getIsAllParentsExpanded = () => {
      let n = !0, o = t;
      for (; n && o.parentId; )
        o = e.getRow(o.parentId, !0), n = o.getIsExpanded();
      return n;
    }, t.getToggleExpandedHandler = () => {
      const n = t.getCanExpand();
      return () => {
        n && t.toggleExpanded();
      };
    };
  }
}, mu = 0, hu = 10, Dc = () => ({
  pageIndex: mu,
  pageSize: hu
}), zP = {
  getInitialState: (t) => ({
    ...t,
    pagination: {
      ...Dc(),
      ...t?.pagination
    }
  }),
  getDefaultOptions: (t) => ({
    onPaginationChange: En("pagination", t)
  }),
  createTable: (t) => {
    let e = !1, n = !1;
    t._autoResetPageIndex = () => {
      var o, r;
      if (!e) {
        t._queue(() => {
          e = !0;
        });
        return;
      }
      if ((o = (r = t.options.autoResetAll) != null ? r : t.options.autoResetPageIndex) != null ? o : !t.options.manualPagination) {
        if (n) return;
        n = !0, t._queue(() => {
          t.resetPageIndex(), n = !1;
        });
      }
    }, t.setPagination = (o) => {
      const r = (i) => Bo(o, i);
      return t.options.onPaginationChange == null ? void 0 : t.options.onPaginationChange(r);
    }, t.resetPagination = (o) => {
      var r;
      t.setPagination(o ? Dc() : (r = t.initialState.pagination) != null ? r : Dc());
    }, t.setPageIndex = (o) => {
      t.setPagination((r) => {
        let i = Bo(o, r.pageIndex);
        const s = typeof t.options.pageCount > "u" || t.options.pageCount === -1 ? Number.MAX_SAFE_INTEGER : t.options.pageCount - 1;
        return i = Math.max(0, Math.min(i, s)), {
          ...r,
          pageIndex: i
        };
      });
    }, t.resetPageIndex = (o) => {
      var r, i;
      t.setPageIndex(o ? mu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageIndex) != null ? r : mu);
    }, t.resetPageSize = (o) => {
      var r, i;
      t.setPageSize(o ? hu : (r = (i = t.initialState) == null || (i = i.pagination) == null ? void 0 : i.pageSize) != null ? r : hu);
    }, t.setPageSize = (o) => {
      t.setPagination((r) => {
        const i = Math.max(1, Bo(o, r.pageSize)), s = r.pageSize * r.pageIndex, l = Math.floor(s / i);
        return {
          ...r,
          pageIndex: l,
          pageSize: i
        };
      });
    }, t.setPageCount = (o) => t.setPagination((r) => {
      var i;
      let s = Bo(o, (i = t.options.pageCount) != null ? i : -1);
      return typeof s == "number" && (s = Math.max(-1, s)), {
        ...r,
        pageCount: s
      };
    }), t.getPageOptions = lt(() => [t.getPageCount()], (o) => {
      let r = [];
      return o && o > 0 && (r = [...new Array(o)].fill(null).map((i, s) => s)), r;
    }, at(t.options, "debugTable", "getPageOptions")), t.getCanPreviousPage = () => t.getState().pagination.pageIndex > 0, t.getCanNextPage = () => {
      const {
        pageIndex: o
      } = t.getState().pagination, r = t.getPageCount();
      return r === -1 ? !0 : r === 0 ? !1 : o < r - 1;
    }, t.previousPage = () => t.setPageIndex((o) => o - 1), t.nextPage = () => t.setPageIndex((o) => o + 1), t.firstPage = () => t.setPageIndex(0), t.lastPage = () => t.setPageIndex(t.getPageCount() - 1), t.getPrePaginationRowModel = () => t.getExpandedRowModel(), t.getPaginationRowModel = () => (!t._getPaginationRowModel && t.options.getPaginationRowModel && (t._getPaginationRowModel = t.options.getPaginationRowModel(t)), t.options.manualPagination || !t._getPaginationRowModel ? t.getPrePaginationRowModel() : t._getPaginationRowModel()), t.getPageCount = () => {
      var o;
      return (o = t.options.pageCount) != null ? o : Math.ceil(t.getRowCount() / t.getState().pagination.pageSize);
    }, t.getRowCount = () => {
      var o;
      return (o = t.options.rowCount) != null ? o : t.getPrePaginationRowModel().rows.length;
    };
  }
}, Vc = () => ({
  top: [],
  bottom: []
}), BP = {
  getInitialState: (t) => ({
    rowPinning: Vc(),
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowPinningChange: En("rowPinning", t)
  }),
  createRow: (t, e) => {
    t.pin = (n, o, r) => {
      const i = o ? t.getLeafRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], s = r ? t.getParentRows().map((a) => {
        let {
          id: c
        } = a;
        return c;
      }) : [], l = /* @__PURE__ */ new Set([...s, t.id, ...i]);
      e.setRowPinning((a) => {
        var c, u;
        if (n === "bottom") {
          var d, f;
          return {
            top: ((d = a?.top) != null ? d : []).filter((h) => !(l != null && l.has(h))),
            bottom: [...((f = a?.bottom) != null ? f : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)]
          };
        }
        if (n === "top") {
          var p, g;
          return {
            top: [...((p = a?.top) != null ? p : []).filter((h) => !(l != null && l.has(h))), ...Array.from(l)],
            bottom: ((g = a?.bottom) != null ? g : []).filter((h) => !(l != null && l.has(h)))
          };
        }
        return {
          top: ((c = a?.top) != null ? c : []).filter((h) => !(l != null && l.has(h))),
          bottom: ((u = a?.bottom) != null ? u : []).filter((h) => !(l != null && l.has(h)))
        };
      });
    }, t.getCanPin = () => {
      var n;
      const {
        enableRowPinning: o,
        enablePinning: r
      } = e.options;
      return typeof o == "function" ? o(t) : (n = o ?? r) != null ? n : !0;
    }, t.getIsPinned = () => {
      const n = [t.id], {
        top: o,
        bottom: r
      } = e.getState().rowPinning, i = n.some((l) => o?.includes(l)), s = n.some((l) => r?.includes(l));
      return i ? "top" : s ? "bottom" : !1;
    }, t.getPinnedIndex = () => {
      var n, o;
      const r = t.getIsPinned();
      if (!r) return -1;
      const i = (n = r === "top" ? e.getTopRows() : e.getBottomRows()) == null ? void 0 : n.map((s) => {
        let {
          id: l
        } = s;
        return l;
      });
      return (o = i?.indexOf(t.id)) != null ? o : -1;
    };
  },
  createTable: (t) => {
    t.setRowPinning = (e) => t.options.onRowPinningChange == null ? void 0 : t.options.onRowPinningChange(e), t.resetRowPinning = (e) => {
      var n, o;
      return t.setRowPinning(e ? Vc() : (n = (o = t.initialState) == null ? void 0 : o.rowPinning) != null ? n : Vc());
    }, t.getIsSomeRowsPinned = (e) => {
      var n;
      const o = t.getState().rowPinning;
      if (!e) {
        var r, i;
        return !!((r = o.top) != null && r.length || (i = o.bottom) != null && i.length);
      }
      return !!((n = o[e]) != null && n.length);
    }, t._getPinnedRows = (e, n, o) => {
      var r;
      return ((r = t.options.keepPinnedRows) == null || r ? (
        //get all rows that are pinned even if they would not be otherwise visible
        //account for expanded parent rows, but not pagination or filtering
        (n ?? []).map((s) => {
          const l = t.getRow(s, !0);
          return l.getIsAllParentsExpanded() ? l : null;
        })
      ) : (
        //else get only visible rows that are pinned
        (n ?? []).map((s) => e.find((l) => l.id === s))
      )).filter(Boolean).map((s) => ({
        ...s,
        position: o
      }));
    }, t.getTopRows = lt(() => [t.getRowModel().rows, t.getState().rowPinning.top], (e, n) => t._getPinnedRows(e, n, "top"), at(t.options, "debugRows", "getTopRows")), t.getBottomRows = lt(() => [t.getRowModel().rows, t.getState().rowPinning.bottom], (e, n) => t._getPinnedRows(e, n, "bottom"), at(t.options, "debugRows", "getBottomRows")), t.getCenterRows = lt(() => [t.getRowModel().rows, t.getState().rowPinning.top, t.getState().rowPinning.bottom], (e, n, o) => {
      const r = /* @__PURE__ */ new Set([...n ?? [], ...o ?? []]);
      return e.filter((i) => !r.has(i.id));
    }, at(t.options, "debugRows", "getCenterRows"));
  }
}, WP = {
  getInitialState: (t) => ({
    rowSelection: {},
    ...t
  }),
  getDefaultOptions: (t) => ({
    onRowSelectionChange: En("rowSelection", t),
    enableRowSelection: !0,
    enableMultiRowSelection: !0,
    enableSubRowSelection: !0
    // enableGroupingRowSelection: false,
    // isAdditiveSelectEvent: (e: unknown) => !!e.metaKey,
    // isInclusiveSelectEvent: (e: unknown) => !!e.shiftKey,
  }),
  createTable: (t) => {
    t.setRowSelection = (e) => t.options.onRowSelectionChange == null ? void 0 : t.options.onRowSelectionChange(e), t.resetRowSelection = (e) => {
      var n;
      return t.setRowSelection(e ? {} : (n = t.initialState.rowSelection) != null ? n : {});
    }, t.toggleAllRowsSelected = (e) => {
      t.setRowSelection((n) => {
        e = typeof e < "u" ? e : !t.getIsAllRowsSelected();
        const o = {
          ...n
        }, r = t.getPreGroupedRowModel().flatRows;
        return e ? r.forEach((i) => {
          i.getCanSelect() && (o[i.id] = !0);
        }) : r.forEach((i) => {
          delete o[i.id];
        }), o;
      });
    }, t.toggleAllPageRowsSelected = (e) => t.setRowSelection((n) => {
      const o = typeof e < "u" ? e : !t.getIsAllPageRowsSelected(), r = {
        ...n
      };
      return t.getRowModel().rows.forEach((i) => {
        bu(r, i.id, o, !0, t);
      }), r;
    }), t.getPreSelectedRowModel = () => t.getCoreRowModel(), t.getSelectedRowModel = lt(() => [t.getState().rowSelection, t.getCoreRowModel()], (e, n) => Object.keys(e).length ? _c(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(t.options, "debugTable", "getSelectedRowModel")), t.getFilteredSelectedRowModel = lt(() => [t.getState().rowSelection, t.getFilteredRowModel()], (e, n) => Object.keys(e).length ? _c(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(t.options, "debugTable", "getFilteredSelectedRowModel")), t.getGroupedSelectedRowModel = lt(() => [t.getState().rowSelection, t.getSortedRowModel()], (e, n) => Object.keys(e).length ? _c(t, n) : {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, at(t.options, "debugTable", "getGroupedSelectedRowModel")), t.getIsAllRowsSelected = () => {
      const e = t.getFilteredRowModel().flatRows, {
        rowSelection: n
      } = t.getState();
      let o = !!(e.length && Object.keys(n).length);
      return o && e.some((r) => r.getCanSelect() && !n[r.id]) && (o = !1), o;
    }, t.getIsAllPageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows.filter((r) => r.getCanSelect()), {
        rowSelection: n
      } = t.getState();
      let o = !!e.length;
      return o && e.some((r) => !n[r.id]) && (o = !1), o;
    }, t.getIsSomeRowsSelected = () => {
      var e;
      const n = Object.keys((e = t.getState().rowSelection) != null ? e : {}).length;
      return n > 0 && n < t.getFilteredRowModel().flatRows.length;
    }, t.getIsSomePageRowsSelected = () => {
      const e = t.getPaginationRowModel().flatRows;
      return t.getIsAllPageRowsSelected() ? !1 : e.filter((n) => n.getCanSelect()).some((n) => n.getIsSelected() || n.getIsSomeSelected());
    }, t.getToggleAllRowsSelectedHandler = () => (e) => {
      t.toggleAllRowsSelected(e.target.checked);
    }, t.getToggleAllPageRowsSelectedHandler = () => (e) => {
      t.toggleAllPageRowsSelected(e.target.checked);
    };
  },
  createRow: (t, e) => {
    t.toggleSelected = (n, o) => {
      const r = t.getIsSelected();
      e.setRowSelection((i) => {
        var s;
        if (n = typeof n < "u" ? n : !r, t.getCanSelect() && r === n)
          return i;
        const l = {
          ...i
        };
        return bu(l, t.id, n, (s = o?.selectChildren) != null ? s : !0, e), l;
      });
    }, t.getIsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return f1(t, n);
    }, t.getIsSomeSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return vu(t, n) === "some";
    }, t.getIsAllSubRowsSelected = () => {
      const {
        rowSelection: n
      } = e.getState();
      return vu(t, n) === "all";
    }, t.getCanSelect = () => {
      var n;
      return typeof e.options.enableRowSelection == "function" ? e.options.enableRowSelection(t) : (n = e.options.enableRowSelection) != null ? n : !0;
    }, t.getCanSelectSubRows = () => {
      var n;
      return typeof e.options.enableSubRowSelection == "function" ? e.options.enableSubRowSelection(t) : (n = e.options.enableSubRowSelection) != null ? n : !0;
    }, t.getCanMultiSelect = () => {
      var n;
      return typeof e.options.enableMultiRowSelection == "function" ? e.options.enableMultiRowSelection(t) : (n = e.options.enableMultiRowSelection) != null ? n : !0;
    }, t.getToggleSelectedHandler = () => {
      const n = t.getCanSelect();
      return (o) => {
        var r;
        n && t.toggleSelected((r = o.target) == null ? void 0 : r.checked);
      };
    };
  }
}, bu = (t, e, n, o, r) => {
  var i;
  const s = r.getRow(e, !0);
  n ? (s.getCanMultiSelect() || Object.keys(t).forEach((l) => delete t[l]), s.getCanSelect() && (t[e] = !0)) : delete t[e], o && (i = s.subRows) != null && i.length && s.getCanSelectSubRows() && s.subRows.forEach((l) => bu(t, l.id, n, o, r));
};
function _c(t, e) {
  const n = t.getState().rowSelection, o = [], r = {}, i = function(s, l) {
    return s.map((a) => {
      var c;
      const u = f1(a, n);
      if (u && (o.push(a), r[a.id] = a), (c = a.subRows) != null && c.length && (a = {
        ...a,
        subRows: i(a.subRows)
      }), u)
        return a;
    }).filter(Boolean);
  };
  return {
    rows: i(e.rows),
    flatRows: o,
    rowsById: r
  };
}
function f1(t, e) {
  var n;
  return (n = e[t.id]) != null ? n : !1;
}
function vu(t, e, n) {
  var o;
  if (!((o = t.subRows) != null && o.length)) return !1;
  let r = !0, i = !1;
  return t.subRows.forEach((s) => {
    if (!(i && !r) && (s.getCanSelect() && (f1(s, e) ? i = !0 : r = !1), s.subRows && s.subRows.length)) {
      const l = vu(s, e);
      l === "all" ? i = !0 : (l === "some" && (i = !0), r = !1);
    }
  }), r ? "all" : i ? "some" : !1;
}
const yu = /([0-9]+)/gm, UP = (t, e, n) => b3(Xo(t.getValue(n)).toLowerCase(), Xo(e.getValue(n)).toLowerCase()), GP = (t, e, n) => b3(Xo(t.getValue(n)), Xo(e.getValue(n))), YP = (t, e, n) => p1(Xo(t.getValue(n)).toLowerCase(), Xo(e.getValue(n)).toLowerCase()), jP = (t, e, n) => p1(Xo(t.getValue(n)), Xo(e.getValue(n))), KP = (t, e, n) => {
  const o = t.getValue(n), r = e.getValue(n);
  return o > r ? 1 : o < r ? -1 : 0;
}, qP = (t, e, n) => p1(t.getValue(n), e.getValue(n));
function p1(t, e) {
  return t === e ? 0 : t > e ? 1 : -1;
}
function Xo(t) {
  return typeof t == "number" ? isNaN(t) || t === 1 / 0 || t === -1 / 0 ? "" : String(t) : typeof t == "string" ? t : "";
}
function b3(t, e) {
  const n = t.split(yu).filter(Boolean), o = e.split(yu).filter(Boolean);
  for (; n.length && o.length; ) {
    const r = n.shift(), i = o.shift(), s = parseInt(r, 10), l = parseInt(i, 10), a = [s, l].sort();
    if (isNaN(a[0])) {
      if (r > i)
        return 1;
      if (i > r)
        return -1;
      continue;
    }
    if (isNaN(a[1]))
      return isNaN(s) ? -1 : 1;
    if (s > l)
      return 1;
    if (l > s)
      return -1;
  }
  return n.length - o.length;
}
const Pi = {
  alphanumeric: UP,
  alphanumericCaseSensitive: GP,
  text: YP,
  textCaseSensitive: jP,
  datetime: KP,
  basic: qP
}, ZP = {
  getInitialState: (t) => ({
    sorting: [],
    ...t
  }),
  getDefaultColumnDef: () => ({
    sortingFn: "auto",
    sortUndefined: 1
  }),
  getDefaultOptions: (t) => ({
    onSortingChange: En("sorting", t),
    isMultiSortEvent: (e) => e.shiftKey
  }),
  createColumn: (t, e) => {
    t.getAutoSortingFn = () => {
      const n = e.getFilteredRowModel().flatRows.slice(10);
      let o = !1;
      for (const r of n) {
        const i = r?.getValue(t.id);
        if (Object.prototype.toString.call(i) === "[object Date]")
          return Pi.datetime;
        if (typeof i == "string" && (o = !0, i.split(yu).length > 1))
          return Pi.alphanumeric;
      }
      return o ? Pi.text : Pi.basic;
    }, t.getAutoSortDir = () => {
      const n = e.getFilteredRowModel().flatRows[0];
      return typeof n?.getValue(t.id) == "string" ? "asc" : "desc";
    }, t.getSortingFn = () => {
      var n, o;
      if (!t)
        throw new Error();
      return Pa(t.columnDef.sortingFn) ? t.columnDef.sortingFn : t.columnDef.sortingFn === "auto" ? t.getAutoSortingFn() : (n = (o = e.options.sortingFns) == null ? void 0 : o[t.columnDef.sortingFn]) != null ? n : Pi[t.columnDef.sortingFn];
    }, t.toggleSorting = (n, o) => {
      const r = t.getNextSortingOrder(), i = typeof n < "u" && n !== null;
      e.setSorting((s) => {
        const l = s?.find((p) => p.id === t.id), a = s?.findIndex((p) => p.id === t.id);
        let c = [], u, d = i ? n : r === "desc";
        if (s != null && s.length && t.getCanMultiSort() && o ? l ? u = "toggle" : u = "add" : s != null && s.length && a !== s.length - 1 ? u = "replace" : l ? u = "toggle" : u = "replace", u === "toggle" && (i || r || (u = "remove")), u === "add") {
          var f;
          c = [...s, {
            id: t.id,
            desc: d
          }], c.splice(0, c.length - ((f = e.options.maxMultiSortColCount) != null ? f : Number.MAX_SAFE_INTEGER));
        } else u === "toggle" ? c = s.map((p) => p.id === t.id ? {
          ...p,
          desc: d
        } : p) : u === "remove" ? c = s.filter((p) => p.id !== t.id) : c = [{
          id: t.id,
          desc: d
        }];
        return c;
      });
    }, t.getFirstSortDir = () => {
      var n, o;
      return ((n = (o = t.columnDef.sortDescFirst) != null ? o : e.options.sortDescFirst) != null ? n : t.getAutoSortDir() === "desc") ? "desc" : "asc";
    }, t.getNextSortingOrder = (n) => {
      var o, r;
      const i = t.getFirstSortDir(), s = t.getIsSorted();
      return s ? s !== i && ((o = e.options.enableSortingRemoval) == null || o) && // If enableSortRemove, enable in general
      (!(n && (r = e.options.enableMultiRemove) != null) || r) ? !1 : s === "desc" ? "asc" : "desc" : i;
    }, t.getCanSort = () => {
      var n, o;
      return ((n = t.columnDef.enableSorting) != null ? n : !0) && ((o = e.options.enableSorting) != null ? o : !0) && !!t.accessorFn;
    }, t.getCanMultiSort = () => {
      var n, o;
      return (n = (o = t.columnDef.enableMultiSort) != null ? o : e.options.enableMultiSort) != null ? n : !!t.accessorFn;
    }, t.getIsSorted = () => {
      var n;
      const o = (n = e.getState().sorting) == null ? void 0 : n.find((r) => r.id === t.id);
      return o ? o.desc ? "desc" : "asc" : !1;
    }, t.getSortIndex = () => {
      var n, o;
      return (n = (o = e.getState().sorting) == null ? void 0 : o.findIndex((r) => r.id === t.id)) != null ? n : -1;
    }, t.clearSorting = () => {
      e.setSorting((n) => n != null && n.length ? n.filter((o) => o.id !== t.id) : []);
    }, t.getToggleSortingHandler = () => {
      const n = t.getCanSort();
      return (o) => {
        n && (o.persist == null || o.persist(), t.toggleSorting == null || t.toggleSorting(void 0, t.getCanMultiSort() ? e.options.isMultiSortEvent == null ? void 0 : e.options.isMultiSortEvent(o) : !1));
      };
    };
  },
  createTable: (t) => {
    t.setSorting = (e) => t.options.onSortingChange == null ? void 0 : t.options.onSortingChange(e), t.resetSorting = (e) => {
      var n, o;
      t.setSorting(e ? [] : (n = (o = t.initialState) == null ? void 0 : o.sorting) != null ? n : []);
    }, t.getPreSortedRowModel = () => t.getGroupedRowModel(), t.getSortedRowModel = () => (!t._getSortedRowModel && t.options.getSortedRowModel && (t._getSortedRowModel = t.options.getSortedRowModel(t)), t.options.manualSorting || !t._getSortedRowModel ? t.getPreSortedRowModel() : t._getSortedRowModel());
  }
}, XP = [
  bP,
  LP,
  OP,
  DP,
  yP,
  xP,
  FP,
  //depends on ColumnFaceting
  $P,
  //depends on ColumnFiltering
  ZP,
  PP,
  //depends on RowSorting
  HP,
  zP,
  BP,
  WP,
  _P
];
function QP(t) {
  var e, n;
  process.env.NODE_ENV !== "production" && (t.debugAll || t.debugTable) && console.info("Creating Table Instance...");
  const o = [...XP, ...(e = t._features) != null ? e : []];
  let r = {
    _features: o
  };
  const i = r._features.reduce((f, p) => Object.assign(f, p.getDefaultOptions == null ? void 0 : p.getDefaultOptions(r)), {}), s = (f) => r.options.mergeOptions ? r.options.mergeOptions(i, f) : {
    ...i,
    ...f
  };
  let a = {
    ...{},
    ...(n = t.initialState) != null ? n : {}
  };
  r._features.forEach((f) => {
    var p;
    a = (p = f.getInitialState == null ? void 0 : f.getInitialState(a)) != null ? p : a;
  });
  const c = [];
  let u = !1;
  const d = {
    _features: o,
    options: {
      ...i,
      ...t
    },
    initialState: a,
    _queue: (f) => {
      c.push(f), u || (u = !0, Promise.resolve().then(() => {
        for (; c.length; )
          c.shift()();
        u = !1;
      }).catch((p) => setTimeout(() => {
        throw p;
      })));
    },
    reset: () => {
      r.setState(r.initialState);
    },
    setOptions: (f) => {
      const p = Bo(f, r.options);
      r.options = s(p);
    },
    getState: () => r.options.state,
    setState: (f) => {
      r.options.onStateChange == null || r.options.onStateChange(f);
    },
    _getRowId: (f, p, g) => {
      var h;
      return (h = r.options.getRowId == null ? void 0 : r.options.getRowId(f, p, g)) != null ? h : `${g ? [g.id, p].join(".") : p}`;
    },
    getCoreRowModel: () => (r._getCoreRowModel || (r._getCoreRowModel = r.options.getCoreRowModel(r)), r._getCoreRowModel()),
    // The final calls start at the bottom of the model,
    // expanded rows, which then work their way up
    getRowModel: () => r.getPaginationRowModel(),
    //in next version, we should just pass in the row model as the optional 2nd arg
    getRow: (f, p) => {
      let g = (p ? r.getPrePaginationRowModel() : r.getRowModel()).rowsById[f];
      if (!g && (g = r.getCoreRowModel().rowsById[f], !g))
        throw process.env.NODE_ENV !== "production" ? new Error(`getRow could not find row with ID: ${f}`) : new Error();
      return g;
    },
    _getDefaultColumnDef: lt(() => [r.options.defaultColumn], (f) => {
      var p;
      return f = (p = f) != null ? p : {}, {
        header: (g) => {
          const h = g.header.column.columnDef;
          return h.accessorKey ? h.accessorKey : h.accessorFn ? h.id : null;
        },
        // footer: props => props.header.column.id,
        cell: (g) => {
          var h, b;
          return (h = (b = g.renderValue()) == null || b.toString == null ? void 0 : b.toString()) != null ? h : null;
        },
        ...r._features.reduce((g, h) => Object.assign(g, h.getDefaultColumnDef == null ? void 0 : h.getDefaultColumnDef()), {}),
        ...f
      };
    }, at(t, "debugColumns", "_getDefaultColumnDef")),
    _getColumnDefs: () => r.options.columns,
    getAllColumns: lt(() => [r._getColumnDefs()], (f) => {
      const p = function(g, h, b) {
        return b === void 0 && (b = 0), g.map((v) => {
          const C = hP(r, v, b, h), y = v;
          return C.columns = y.columns ? p(y.columns, C, b + 1) : [], C;
        });
      };
      return p(f);
    }, at(t, "debugColumns", "getAllColumns")),
    getAllFlatColumns: lt(() => [r.getAllColumns()], (f) => f.flatMap((p) => p.getFlatColumns()), at(t, "debugColumns", "getAllFlatColumns")),
    _getAllFlatColumnsById: lt(() => [r.getAllFlatColumns()], (f) => f.reduce((p, g) => (p[g.id] = g, p), {}), at(t, "debugColumns", "getAllFlatColumnsById")),
    getAllLeafColumns: lt(() => [r.getAllColumns(), r._getOrderColumnsFn()], (f, p) => {
      let g = f.flatMap((h) => h.getLeafColumns());
      return p(g);
    }, at(t, "debugColumns", "getAllLeafColumns")),
    getColumn: (f) => {
      const p = r._getAllFlatColumnsById()[f];
      return process.env.NODE_ENV !== "production" && !p && console.error(`[Table] Column with id '${f}' does not exist.`), p;
    }
  };
  Object.assign(r, d);
  for (let f = 0; f < r._features.length; f++) {
    const p = r._features[f];
    p == null || p.createTable == null || p.createTable(r);
  }
  return r;
}
function JP() {
  return (t) => lt(() => [t.options.data], (e) => {
    const n = {
      rows: [],
      flatRows: [],
      rowsById: {}
    }, o = function(r, i, s) {
      i === void 0 && (i = 0);
      const l = [];
      for (let c = 0; c < r.length; c++) {
        const u = vP(t, t._getRowId(r[c], c, s), r[c], c, i, void 0, s?.id);
        if (n.flatRows.push(u), n.rowsById[u.id] = u, l.push(u), t.options.getSubRows) {
          var a;
          u.originalSubRows = t.options.getSubRows(r[c], c), (a = u.originalSubRows) != null && a.length && (u.subRows = o(u.originalSubRows, i + 1, u));
        }
      }
      return l;
    };
    return n.rows = o(e), n;
  }, at(t.options, "debugTable", "getRowModel", () => t._autoResetPageIndex()));
}
function eT(t) {
  const e = [], n = (o) => {
    var r;
    e.push(o), (r = o.subRows) != null && r.length && o.getIsExpanded() && o.subRows.forEach(n);
  };
  return t.rows.forEach(n), {
    rows: e,
    flatRows: t.flatRows,
    rowsById: t.rowsById
  };
}
function tT(t) {
  return (e) => lt(() => [e.getState().pagination, e.getPrePaginationRowModel(), e.options.paginateExpandedRows ? void 0 : e.getState().expanded], (n, o) => {
    if (!o.rows.length)
      return o;
    const {
      pageSize: r,
      pageIndex: i
    } = n;
    let {
      rows: s,
      flatRows: l,
      rowsById: a
    } = o;
    const c = r * i, u = c + r;
    s = s.slice(c, u);
    let d;
    e.options.paginateExpandedRows ? d = {
      rows: s,
      flatRows: l,
      rowsById: a
    } : d = eT({
      rows: s,
      flatRows: l,
      rowsById: a
    }), d.flatRows = [];
    const f = (p) => {
      d.flatRows.push(p), p.subRows.length && p.subRows.forEach(f);
    };
    return d.rows.forEach(f), d;
  }, at(e.options, "debugTable", "getPaginationRowModel"));
}
function nT() {
  return (t) => lt(() => [t.getState().sorting, t.getPreSortedRowModel()], (e, n) => {
    if (!n.rows.length || !(e != null && e.length))
      return n;
    const o = t.getState().sorting, r = [], i = o.filter((a) => {
      var c;
      return (c = t.getColumn(a.id)) == null ? void 0 : c.getCanSort();
    }), s = {};
    i.forEach((a) => {
      const c = t.getColumn(a.id);
      c && (s[a.id] = {
        sortUndefined: c.columnDef.sortUndefined,
        invertSorting: c.columnDef.invertSorting,
        sortingFn: c.getSortingFn()
      });
    });
    const l = (a) => {
      const c = a.map((u) => ({
        ...u
      }));
      return c.sort((u, d) => {
        for (let p = 0; p < i.length; p += 1) {
          var f;
          const g = i[p], h = s[g.id], b = h.sortUndefined, v = (f = g?.desc) != null ? f : !1;
          let C = 0;
          if (b) {
            const y = u.getValue(g.id), w = d.getValue(g.id), R = y === void 0, S = w === void 0;
            if (R || S) {
              if (b === "first") return R ? -1 : 1;
              if (b === "last") return R ? 1 : -1;
              C = R && S ? 0 : R ? b : -b;
            }
          }
          if (C === 0 && (C = h.sortingFn(u, d, g.id)), C !== 0)
            return v && (C *= -1), h.invertSorting && (C *= -1), C;
        }
        return u.index - d.index;
      }), c.forEach((u) => {
        var d;
        r.push(u), (d = u.subRows) != null && d.length && (u.subRows = l(u.subRows));
      }), c;
    };
    return {
      rows: l(n.rows),
      flatRows: r,
      rowsById: n.rowsById
    };
  }, at(t.options, "debugTable", "getSortedRowModel", () => t._autoResetPageIndex()));
}
/**
   * react-table
   *
   * Copyright (c) TanStack
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   */
function nm(t, e) {
  return t ? oT(t) ? /* @__PURE__ */ x.createElement(t, e) : t : null;
}
function oT(t) {
  return rT(t) || typeof t == "function" || iT(t);
}
function rT(t) {
  return typeof t == "function" && (() => {
    const e = Object.getPrototypeOf(t);
    return e.prototype && e.prototype.isReactComponent;
  })();
}
function iT(t) {
  return typeof t == "object" && typeof t.$$typeof == "symbol" && ["react.memo", "react.forward_ref"].includes(t.$$typeof.description);
}
function sT(t) {
  const e = {
    state: {},
    // Dummy state
    onStateChange: () => {
    },
    // noop
    renderFallbackValue: null,
    ...t
  }, [n] = x.useState(() => ({
    current: QP(e)
  })), [o, r] = x.useState(() => n.current.initialState);
  return n.current.setOptions((i) => ({
    ...i,
    ...t,
    state: {
      ...o,
      ...t.state
    },
    // Similarly, we'll maintain both our internal state and any user-provided
    // state.
    onStateChange: (s) => {
      r(s), t.onStateChange == null || t.onStateChange(s);
    }
  })), n.current;
}
const lT = {
  starting: "169px",
  text: "170px",
  doubleLine: "250px",
  chip: "90px",
  chipText: "250px",
  currency: "130px",
  icon: "52px",
  button: "191px",
  toggle: "207px",
  dropdown: "182px",
  input: "var(--table-input-cell-width)",
  calendar: "208px",
  expand: "80px",
  endingSpacer: "8px"
}, aT = ce(["w-full", "caption-bottom", "border-collapse", "bg-table-row-light-surface", "text-text-default", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "@max-[480px]/data-table:[--table-input-cell-width:167px]", "@max-[480px]/data-table:[--table-row-height:56px]"], {
  variants: {
    size: {
      sm: ["[--table-input-cell-width:167px]", "[--table-row-height:56px]"],
      md: ["[--table-input-cell-width:167px]", "[--table-row-height:68px]"],
      lg: ["[--table-input-cell-width:208px]", "[--table-row-height:84px]"]
    }
  },
  defaultVariants: {
    size: "md"
  }
}), cT = ce(["relative", "border-b", "border-table-outline", "transition-[box-shadow]", "duration-200", "ease-in-out", "data-[interactive]:cursor-pointer", "data-[selected]:bg-table-row-select"], {
  variants: {
    section: {
      header: ["h-(--spacing-40)"],
      body: ["h-(--table-row-height)", "hover:z-[1]", "hover:shadow-elevation-2"]
    }
  },
  defaultVariants: {
    section: "body"
  }
}), uT = ce(["[&>td:first-child]:relative", "[&>td:first-child]:before:pointer-events-none", "[&>td:first-child]:before:absolute", "[&>td:first-child]:before:inset-y-0", "[&>td:first-child]:before:left-0", "[&>td:first-child]:before:w-(--spacing-4)", "[&>td:first-child]:before:content-['']"], {
  variants: {
    tone: {
      brand: "[&>td:first-child]:before:bg-primary",
      positive: "[&>td:first-child]:before:bg-positive",
      warning: "[&>td:first-child]:before:bg-accessibility-warning",
      negative: "[&>td:first-child]:before:bg-negative",
      informative: "[&>td:first-child]:before:bg-informative"
    }
  }
}), v3 = ce([], {
  variants: {
    align: {
      left: "text-left",
      center: "text-center",
      right: "text-right"
    }
  },
  defaultVariants: {
    align: "left"
  }
}), dT = ce(["h-(--spacing-40)", "whitespace-nowrap", "border-b", "border-table-outline", "bg-table-header-surface", "py-0", "align-middle", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-small)", "font-(number:--font-weight-semibold)", "leading-(--font-line-height-16)", "text-table-header-text"], {
  variants: {
    variant: {
      default: ["px-(--spacing-16)"],
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      spacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), fT = ce(["h-(--table-row-height)", "min-w-0", "px-(--spacing-16)", "py-0", "align-middle", "text-text-default"], {
  variants: {
    variant: {
      starting: ["pl-(--spacing-24)", "pr-(--spacing-16)"],
      text: null,
      doubleLine: null,
      chip: null,
      chipText: null,
      currency: ["font-(family-name:--font-family-label)"],
      icon: ["px-(--spacing-16)", "text-center"],
      button: null,
      toggle: null,
      dropdown: null,
      input: null,
      calendar: null,
      expand: ["px-(--spacing-16)", "text-center"],
      endingSpacer: ["p-0"]
    }
  },
  defaultVariants: {
    variant: "text"
  }
});
function y3(t, e) {
  return t !== void 0 ? typeof t == "number" ? `${t}px` : t : e ? lT[e] : void 0;
}
function x3(t, e) {
  return e ? {
    ...t,
    width: e,
    minWidth: e
  } : t;
}
function C3(t) {
  if (t === "compact") return "@max-[480px]/data-table:hidden";
  if (t === "comfortable") return "@max-[768px]/data-table:hidden";
  if (t === "expanded") return "@max-[1024px]/data-table:hidden";
  if (t === "wide") return "@max-[1280px]/data-table:hidden";
}
function pT(t) {
  const e = z.c(11);
  let n, o, r;
  e[0] !== t ? ({
    size: r,
    style: o,
    ...n
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r) : (n = e[1], o = e[2], r = e[3]);
  const i = r === void 0 ? "md" : r;
  let s;
  e[4] !== i ? (s = aT({
    size: i
  }), e[4] = i, e[5] = s) : s = e[5];
  let l;
  return e[6] !== n || e[7] !== i || e[8] !== o || e[9] !== s ? (l = /* @__PURE__ */ m("table", { "data-slot": "table", "data-size": i, className: s, style: o, ...n }), e[6] = n, e[7] = i, e[8] = o, e[9] = s, e[10] = l) : l = e[10], l;
}
function gT(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m("thead", { "data-slot": "table-header", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function mT(t) {
  const e = z.c(2);
  let n;
  return e[0] !== t ? (n = /* @__PURE__ */ m("tbody", { "data-slot": "table-body", ...t }), e[0] = t, e[1] = n) : n = e[1], n;
}
function Ac(t) {
  const e = z.c(17);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    accentTone: n,
    selected: s,
    interactive: l,
    section: i,
    children: o,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = s === void 0 ? !1 : s, c = l === void 0 ? !1 : l, u = a ? "" : void 0, d = c ? "" : void 0, f = a || void 0;
  let p;
  e[7] !== n || e[8] !== i ? (p = ne(cT({
    section: i
  }), i !== "header" && n && uT({
    tone: n
  })), e[7] = n, e[8] = i, e[9] = p) : p = e[9];
  let g;
  return e[10] !== o || e[11] !== r || e[12] !== u || e[13] !== d || e[14] !== f || e[15] !== p ? (g = /* @__PURE__ */ m("tr", { "data-slot": "table-row", "data-selected": u, "data-interactive": d, "aria-selected": f, className: p, ...r, children: o }), e[10] = o, e[11] = r, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = g) : g = e[16], g;
}
function hT(t) {
  return t || "none";
}
function om(t, e) {
  return t ? t === e ? "text-primary" : "text-icon-disabled" : "text-icon-main";
}
function bT(t) {
  const e = z.c(13), {
    direction: n
  } = t;
  let o;
  e[0] !== n ? (o = ne("absolute left-(--spacing-2) top-[3px] inline-flex", om(n, "ascending")), e[0] = n, e[1] = o) : o = e[1];
  let r;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (r = /* @__PURE__ */ m(Ke, { name: "chevron-up", size: "xs", tone: "inherit" }), e[2] = r) : r = e[2];
  let i;
  e[3] !== o ? (i = /* @__PURE__ */ m("span", { className: o, children: r }), e[3] = o, e[4] = i) : i = e[4];
  let s;
  e[5] !== n ? (s = ne("absolute left-(--spacing-2) top-[9px] inline-flex", om(n, "descending")), e[5] = n, e[6] = s) : s = e[6];
  let l;
  e[7] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (l = /* @__PURE__ */ m(Ke, { name: "chevron-down", size: "xs", tone: "inherit" }), e[7] = l) : l = e[7];
  let a;
  e[8] !== s ? (a = /* @__PURE__ */ m("span", { className: s, children: l }), e[8] = s, e[9] = a) : a = e[9];
  let c;
  return e[10] !== i || e[11] !== a ? (c = /* @__PURE__ */ F("span", { "aria-hidden": "true", className: "relative block h-[28px] w-(--spacing-20) shrink-0", children: [
    i,
    a
  ] }), e[10] = i, e[11] = a, e[12] = c) : c = e[12], c;
}
function vT(t) {
  const e = z.c(72);
  let n, o, r, i, s, l, a, c, u, d, f, p;
  e[0] !== t ? ({
    align: n,
    children: o,
    leadingCheckbox: i,
    sortable: c,
    sortDirection: u,
    tooltip: d,
    hideBelow: r,
    variant: f,
    width: p,
    style: a,
    onSort: s,
    ...l
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f, e[12] = p) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11], p = e[12]);
  const g = c === void 0 ? !1 : c, h = u === void 0 ? !1 : u;
  let b, v, C, y, w;
  if (e[13] !== n || e[14] !== o || e[15] !== r || e[16] !== i || e[17] !== s || e[18] !== h || e[19] !== g || e[20] !== a || e[21] !== d || e[22] !== f || e[23] !== p) {
    const S = y3(p);
    let E;
    e[29] !== d ? (E = d ? /* @__PURE__ */ m(qo, { label: d, showArrow: !1, children: /* @__PURE__ */ m("button", { type: "button", className: "inline-flex shrink-0 items-center border-0 bg-transparent p-0 text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", "aria-label": d, children: /* @__PURE__ */ m(Ke, { name: "circle-info", size: "xs", tone: "inherit" }) }) }) : null, e[29] = d, e[30] = E) : E = e[30];
    const N = E, T = n === "right" && "justify-end", P = n === "center" && "justify-center";
    let I;
    e[31] !== T || e[32] !== P ? (I = ne("flex min-w-0 items-center gap-(--spacing-8)", T, P), e[31] = T, e[32] = P, e[33] = I) : I = e[33];
    let k;
    e[34] !== o ? (k = /* @__PURE__ */ m("span", { className: "min-w-0 truncate", children: o }), e[34] = o, e[35] = k) : k = e[35];
    let M;
    e[36] !== h || e[37] !== g ? (M = g && /* @__PURE__ */ m(bT, { direction: h }), e[36] = h, e[37] = g, e[38] = M) : M = e[38];
    let D;
    e[39] !== I || e[40] !== k || e[41] !== M ? (D = /* @__PURE__ */ F("span", { className: I, children: [
      k,
      M
    ] }), e[39] = I, e[40] = k, e[41] = M, e[42] = D) : D = e[42];
    const O = D, V = n === "right" && "justify-end", _ = n === "center" && "justify-center";
    let A;
    e[43] !== V || e[44] !== _ ? (A = ne("flex min-w-0 items-center gap-(--spacing-12)", V, _), e[43] = V, e[44] = _, e[45] = A) : A = e[45];
    let L;
    e[46] !== i ? (L = i && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0", children: i }), e[46] = i, e[47] = L) : L = e[47];
    let B;
    e[48] !== n || e[49] !== O || e[50] !== s || e[51] !== g ? (B = g ? /* @__PURE__ */ m("button", { type: "button", onClick: s, className: ne("flex h-full min-w-0 items-center bg-transparent p-0 text-inherit", "border-0 outline-none cursor-pointer", "focus-visible:ring-2 focus-visible:ring-button-focus-ring focus-visible:ring-offset-1 focus-visible:ring-offset-surface", n === "right" && "justify-end", n === "center" && "justify-center"), children: O }) : O, e[48] = n, e[49] = O, e[50] = s, e[51] = g, e[52] = B) : B = e[52];
    let G;
    e[53] !== A || e[54] !== L || e[55] !== B || e[56] !== N ? (G = /* @__PURE__ */ F("span", { className: A, children: [
      L,
      B,
      N
    ] }), e[53] = A, e[54] = L, e[55] = B, e[56] = N, e[57] = G) : G = e[57], b = G, v = "table-head", e[58] !== h || e[59] !== g ? (C = g ? hT(h) : void 0, e[58] = h, e[59] = g, e[60] = C) : C = e[60], e[61] !== n || e[62] !== r || e[63] !== f ? (y = ne(dT({
      variant: f
    }), v3({
      align: n
    }), C3(r)), e[61] = n, e[62] = r, e[63] = f, e[64] = y) : y = e[64], w = x3(a, S), e[13] = n, e[14] = o, e[15] = r, e[16] = i, e[17] = s, e[18] = h, e[19] = g, e[20] = a, e[21] = d, e[22] = f, e[23] = p, e[24] = b, e[25] = v, e[26] = C, e[27] = y, e[28] = w;
  } else
    b = e[24], v = e[25], C = e[26], y = e[27], w = e[28];
  let R;
  return e[65] !== b || e[66] !== l || e[67] !== v || e[68] !== C || e[69] !== y || e[70] !== w ? (R = /* @__PURE__ */ m("th", { "data-slot": v, "aria-sort": C, className: y, style: w, ...l, children: b }), e[65] = b, e[66] = l, e[67] = v, e[68] = C, e[69] = y, e[70] = w, e[71] = R) : R = e[71], R;
}
function yT(t) {
  const e = z.c(31);
  let n, o, r, i, s, l, a, c;
  e[0] !== t ? ({
    align: n,
    variant: a,
    hideBelow: r,
    width: c,
    style: s,
    children: o,
    emptyFallback: l,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8]);
  const u = l === void 0 ? "--" : l, d = a ?? "text";
  let f, p, g, h, b;
  if (e[9] !== n || e[10] !== o || e[11] !== r || e[12] !== d || e[13] !== s || e[14] !== c) {
    const y = y3(c, d);
    f = o == null || typeof o == "string" && o.trim() === "", p = "table-cell", g = d, e[20] !== n || e[21] !== r || e[22] !== d ? (h = ne(fT({
      variant: d
    }), v3({
      align: n
    }), C3(r)), e[20] = n, e[21] = r, e[22] = d, e[23] = h) : h = e[23], b = x3(s, y), e[9] = n, e[10] = o, e[11] = r, e[12] = d, e[13] = s, e[14] = c, e[15] = f, e[16] = p, e[17] = g, e[18] = h, e[19] = b;
  } else
    f = e[15], p = e[16], g = e[17], h = e[18], b = e[19];
  const v = d === "endingSpacer" ? null : f ? u : o;
  let C;
  return e[24] !== i || e[25] !== p || e[26] !== g || e[27] !== h || e[28] !== b || e[29] !== v ? (C = /* @__PURE__ */ m("td", { "data-slot": p, "data-variant": g, className: h, style: b, ...i, children: v }), e[24] = i, e[25] = p, e[26] = g, e[27] = h, e[28] = b, e[29] = v, e[30] = C) : C = e[30], C;
}
function w3(t) {
  const e = z.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m("div", { className: "flex min-w-0 flex-col gap-(--spacing-2)", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function g1(t) {
  const e = z.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-medium) font-(number:--font-weight-medium) leading-(--font-line-height-20) text-text-default", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function m1(t) {
  const e = z.c(2), {
    children: n
  } = t;
  let o;
  return e[0] !== n ? (o = /* @__PURE__ */ m("span", { className: "min-w-0 truncate font-(family-name:--font-family-body) text-(length:--font-size-body-small) font-(number:--font-weight-regular) leading-(--font-line-height-16) text-text-subtext", children: n }), e[0] = n, e[1] = o) : o = e[1], o;
}
function xT(t) {
  const e = z.c(15), {
    status: n,
    checkbox: o,
    thumbnail: r,
    avatar: i,
    icon: s,
    primary: l,
    secondary: a,
    chip: c
  } = t;
  let u;
  e[0] !== l ? (u = /* @__PURE__ */ m(g1, { children: l }), e[0] = l, e[1] = u) : u = e[1];
  let d;
  e[2] !== c || e[3] !== a ? (d = (a || c) && /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-wrap items-center gap-(--spacing-4) pt-(--spacing-4)", children: [
    a && /* @__PURE__ */ m(m1, { children: a }),
    c && /* @__PURE__ */ m("span", { className: "shrink-0", children: c })
  ] }), e[2] = c, e[3] = a, e[4] = d) : d = e[4];
  let f;
  e[5] !== u || e[6] !== d ? (f = /* @__PURE__ */ F("div", { className: "flex min-w-0 flex-col justify-center", children: [
    u,
    d
  ] }), e[5] = u, e[6] = d, e[7] = f) : f = e[7];
  let p;
  return e[8] !== i || e[9] !== o || e[10] !== s || e[11] !== n || e[12] !== f || e[13] !== r ? (p = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    n,
    o,
    r,
    i,
    s,
    f
  ] }), e[8] = i, e[9] = o, e[10] = s, e[11] = n, e[12] = f, e[13] = r, e[14] = p) : p = e[14], p;
}
function CT(t) {
  const e = z.c(15), {
    leadingIcon: n,
    main: o,
    supporting: r,
    trailingIcon: i
  } = t;
  let s;
  e[0] !== n ? (s = n && /* @__PURE__ */ m("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = s) : s = e[1];
  let l;
  e[2] !== o ? (l = /* @__PURE__ */ m(g1, { children: o }), e[2] = o, e[3] = l) : l = e[3];
  let a;
  e[4] !== r ? (a = r && /* @__PURE__ */ m(m1, { children: r }), e[4] = r, e[5] = a) : a = e[5];
  let c;
  e[6] !== l || e[7] !== a ? (c = /* @__PURE__ */ F(w3, { children: [
    l,
    a
  ] }), e[6] = l, e[7] = a, e[8] = c) : c = e[8];
  let u;
  e[9] !== i ? (u = i && /* @__PURE__ */ m("span", { className: "shrink-0", children: i }), e[9] = i, e[10] = u) : u = e[10];
  let d;
  return e[11] !== s || e[12] !== c || e[13] !== u ? (d = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    s,
    c,
    u
  ] }), e[11] = s, e[12] = c, e[13] = u, e[14] = d) : d = e[14], d;
}
function wT(t) {
  const e = z.c(7), {
    chip: n,
    secondary: o
  } = t;
  let r;
  e[0] !== n ? (r = /* @__PURE__ */ m("span", { className: "shrink-0", children: n }), e[0] = n, e[1] = r) : r = e[1];
  let i;
  e[2] !== o ? (i = o && /* @__PURE__ */ m("span", { className: "min-w-0 truncate text-text-subtext", children: o }), e[2] = o, e[3] = i) : i = e[3];
  let s;
  return e[4] !== r || e[5] !== i ? (s = /* @__PURE__ */ F("div", { className: "flex min-w-0 items-center gap-(--spacing-8)", children: [
    r,
    i
  ] }), e[4] = r, e[5] = i, e[6] = s) : s = e[6], s;
}
const rm = Object.assign(yT, {
  ChipText: wT,
  Primary: g1,
  Secondary: m1,
  Stack: w3,
  Starting: xT,
  Text: CT
});
function ST(t) {
  return t === "asc" ? "ascending" : t === "desc" ? "descending" : !1;
}
function RT() {
  return import.meta.env?.DEV ?? !1;
}
function zD({
  ariaLabel: t,
  columns: e,
  data: n,
  size: o = "md",
  getRowId: r,
  sorting: i,
  onSortingChange: s,
  manualSorting: l = !1,
  rowSelection: a,
  onRowSelectionChange: c,
  enableRowSelection: u,
  getRowAccentTone: d,
  pagination: f,
  manualPagination: p = !1,
  emptyMessage: g = "No results.",
  variant: h = "fullWidth"
}) {
  const b = u ?? !!(a || c), v = {
    ...i !== void 0 ? {
      sorting: i
    } : {},
    ...a !== void 0 ? {
      rowSelection: a
    } : {},
    ...f !== void 0 ? {
      pagination: {
        pageIndex: Math.max(0, f.currentPage - 1),
        pageSize: f.rowsPerPage
      }
    } : {}
  }, C = sT({
    data: n,
    columns: e,
    defaultColumn: {
      enableSorting: !1
    },
    getRowId: r,
    state: v,
    enableRowSelection: b,
    onSortingChange: s,
    onRowSelectionChange: c,
    manualSorting: l,
    manualPagination: p,
    getCoreRowModel: JP(),
    ...l ? {} : {
      getSortedRowModel: nT()
    },
    ...f !== void 0 && !p ? {
      getPaginationRowModel: tT()
    } : {},
    ...f !== void 0 ? {
      pageCount: f.totalPages
    } : {}
  }), y = C.getVisibleLeafColumns(), w = y[0], R = w?.columnDef.meta;
  return RT() && w && R?.cellVariant !== "starting" && console.warn("DataTable expects the first visible column to use meta.cellVariant = 'starting' to match the table design-system contract."), /* @__PURE__ */ F("div", { "data-slot": "data-table", "data-variant": h, className: ne("@container/data-table w-full", h === "card" && ["overflow-hidden", "rounded-(--radius-sm)", "border", "border-outline-subtle", "bg-surface", "shadow-elevation-1"]), children: [
    /* @__PURE__ */ m("div", { "data-slot": "data-table-scroll", className: "w-full overflow-x-auto bg-table-row-light-surface pb-(--spacing-8)", children: /* @__PURE__ */ F(pT, { size: o, "aria-label": t, children: [
      /* @__PURE__ */ m(gT, { children: C.getHeaderGroups().map((S) => /* @__PURE__ */ m(Ac, { section: "header", children: S.headers.map((E) => {
        const N = E.column.columnDef.meta, T = E.column.getCanSort(), P = E.column.getToggleSortingHandler(), I = N?.cellVariant === "starting", k = E.column.id === w?.id, M = b && I && k && !E.isPlaceholder, D = C.getIsAllPageRowsSelected(), O = C.getIsSomePageRowsSelected();
        return /* @__PURE__ */ m(vT, { colSpan: E.colSpan, scope: "col", align: N?.headerAlign ?? N?.align, variant: I ? "starting" : void 0, width: N?.width, tooltip: N?.tooltip, hideBelow: N?.hideBelow, leadingCheckbox: M ? /* @__PURE__ */ m(AR, { "aria-label": "Select all visible rows", checked: D, indeterminate: O && !D, onCheckedChange: (V) => C.toggleAllPageRowsSelected(!!V) }) : void 0, sortable: T, sortDirection: ST(E.column.getIsSorted()), onSort: T && P ? (V) => P(V) : void 0, children: E.isPlaceholder ? null : nm(E.column.columnDef.header, E.getContext()) }, E.id);
      }) }, S.id)) }),
      /* @__PURE__ */ m(mT, { children: C.getRowModel().rows.length > 0 ? C.getRowModel().rows.map((S) => /* @__PURE__ */ m(Ac, { accentTone: d?.(S.original), selected: S.getIsSelected(), children: S.getVisibleCells().map((E) => {
        const N = E.column.columnDef.meta;
        return /* @__PURE__ */ m(rm, { variant: N?.cellVariant, align: N?.align, width: N?.width, hideBelow: N?.hideBelow, "data-hide-below": N?.hideBelow, children: nm(E.column.columnDef.cell, E.getContext()) }, E.id);
      }) }, S.id)) : /* @__PURE__ */ m(Ac, { children: /* @__PURE__ */ m(rm, { colSpan: y.length, emptyFallback: null, children: /* @__PURE__ */ m("div", { className: "flex h-(--table-row-height) items-center justify-center text-text-subtext", children: g }) }) }) })
    ] }) }),
    f && /* @__PURE__ */ m("div", { "data-slot": "data-table-pagination", className: ne(h === "card" && "bg-table-row-light-surface"), children: /* @__PURE__ */ m(sI, { ...f }) })
  ] });
}
const ET = ["flex", "flex-row", "items-center", "border-b", "border-outline-variant"].join(" ");
function BD({
  children: t,
  inset: e = !1,
  ...n
}) {
  const {
    onScroll: o,
    ref: r,
    ...i
  } = n, s = ft(null), l = ft(() => {
  }), [a, c] = ot(!1), [u, d] = ot(!1);
  l.current = function() {
    const h = s.current;
    if (!h) {
      c(!1), d(!1);
      return;
    }
    const b = h.scrollWidth > h.clientWidth;
    c(b && h.scrollLeft > 0), d(b && h.scrollLeft + h.clientWidth < h.scrollWidth - 1);
  };
  function f(g) {
    s.current = g, typeof r == "function" ? r(g) : r && (r.current = g);
  }
  Io(() => {
    l.current();
  }), Io(() => {
    const g = s.current;
    if (!g || typeof ResizeObserver > "u")
      return;
    const h = new ResizeObserver(() => {
      l.current();
    });
    h.observe(g);
    for (const v of g.children)
      h.observe(v);
    const b = new MutationObserver(() => {
      for (const v of g.children)
        h.observe(v);
      l.current();
    });
    return b.observe(g, {
      childList: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, []);
  function p(g) {
    l.current(), o?.(g);
  }
  return /* @__PURE__ */ F("div", { className: "relative", children: [
    /* @__PURE__ */ m(r1, { ...i, ref: f, onScroll: p, className: ne(ET, "overflow-x-auto", "overflow-y-hidden", e && "px-(--spacing-24)"), children: t }),
    a && /* @__PURE__ */ m("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-left", className: "pointer-events-none absolute inset-y-0 left-0 z-10 w-[24px] bg-linear-to-r from-surface to-transparent" }),
    u && /* @__PURE__ */ m("div", { "aria-hidden": "true", "data-slot": "tabs-overflow-gradient-right", className: "pointer-events-none absolute inset-y-0 right-0 z-10 w-[24px] bg-linear-to-l from-surface to-transparent" })
  ] });
}
const NT = [
  // Layout
  "inline-flex",
  "flex-row",
  "items-center",
  "gap-(--spacing-8)",
  "px-(--spacing-12)",
  "py-(--spacing-6)",
  "rounded-tl-(--radius-sm)",
  "rounded-tr-(--radius-sm)",
  // Typography base
  "font-(family-name:--font-family-body)",
  "text-(length:--font-size-body-large)",
  "leading-(--font-line-height-24)",
  "tracking-(--font-letter-spacing-default)",
  "whitespace-nowrap",
  "outline-none",
  "cursor-pointer",
  "select-none",
  "relative",
  // Transitions
  "transition-colors",
  "duration-200",
  "ease-in-out",
  // Hover state (pointer devices only, not on disabled)
  "not-data-[disabled]:hover:bg-surface-hover",
  // Pressed state
  "not-data-[disabled]:active:bg-surface-pressed",
  // Focus ring
  "focus-visible:ring-2",
  "focus-visible:ring-inset",
  "focus-visible:ring-button-focus-ring",
  // Disabled state
  "data-[disabled]:opacity-50",
  "data-[disabled]:pointer-events-none",
  "data-[disabled]:cursor-default"
].join(" "), kT = ["text-text-subtext", "after:absolute", "after:bottom-0", "after:left-0", "after:right-0", "after:h-(--spacing-2)", "after:translate-y-px", "after:bg-transparent", "after:transition-colors", "after:duration-200", "after:ease-in-out", "group", "data-[active]:text-text-default", "data-[active]:after:bg-primary"].join(" ");
function WD(t) {
  const e = z.c(18);
  let n, o, r, i;
  e[0] !== t ? ({
    icon: r,
    chipLabel: o,
    children: n,
    ...i
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  let s;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (s = ne(NT, kT), e[5] = s) : s = e[5];
  let l;
  e[6] !== r ? (l = r && /* @__PURE__ */ m(Ke, { name: r, size: "sm", tone: "inherit" }), e[6] = r, e[7] = l) : l = e[7];
  const a = typeof n == "string" ? n : void 0;
  let c;
  e[8] !== n || e[9] !== a ? (c = /* @__PURE__ */ m("span", { "data-text": a, className: "relative flex flex-col items-center group-data-[active]:font-semibold before:content-[attr(data-text)] before:font-semibold before:invisible before:h-0 before:overflow-hidden before:pointer-events-none", children: n }), e[8] = n, e[9] = a, e[10] = c) : c = e[10];
  let u;
  e[11] !== o ? (u = o != null && /* @__PURE__ */ m(Kn, { tone: "neutral", label: o, "aria-hidden": !0 }), e[11] = o, e[12] = u) : u = e[12];
  let d;
  return e[13] !== i || e[14] !== l || e[15] !== c || e[16] !== u ? (d = /* @__PURE__ */ F(o1, { className: s, ...i, children: [
    l,
    c,
    u
  ] }), e[13] = i, e[14] = l, e[15] = c, e[16] = u, e[17] = d) : d = e[17], d;
}
function UD(t) {
  const e = z.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ m(Ub, { className: "outline-none", ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
function GD(t) {
  const e = z.c(6);
  let n, o;
  e[0] !== t ? ({
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o) : (n = e[1], o = e[2]);
  let r;
  return e[3] !== n || e[4] !== o ? (r = /* @__PURE__ */ m(e1, { ...o, children: n }), e[3] = n, e[4] = o, e[5] = r) : r = e[5], r;
}
const MT = ce("text-surface-on-surface", {
  variants: {
    tone: {
      base: ["bg-surface-container-lowest"],
      muted: ["bg-surface-container-low"],
      neutral: ["bg-surface-container"],
      positive: ["bg-positive-container", "text-positive-on-container"],
      warning: ["bg-accessibility-warning-container", "text-warning-on-container"],
      negative: ["bg-negative-container", "text-negative-on-container"],
      informative: ["bg-informative-container", "text-informative-on-container"]
    },
    padding: {
      none: "p-0",
      dense: "px-(--spacing-8) py-(--spacing-10)",
      compact: "p-(--spacing-12)",
      comfortable: "px-(--spacing-20) py-(--spacing-16)"
    },
    radius: {
      none: "rounded-(--radius-none)",
      sm: "rounded-(--radius-sm)",
      md: "rounded-(--radius-md)",
      lg: "rounded-(--radius-lg)",
      xl: "rounded-(--radius-xl)",
      full: "rounded-(--radius-full)"
    },
    aspect: {
      auto: null,
      square: "aspect-square"
    },
    centered: {
      true: "grid place-items-center",
      false: null
    },
    width: {
      auto: null,
      content: "w-fit",
      full: "w-full"
    }
  },
  defaultVariants: {
    tone: "base",
    padding: "comfortable",
    radius: "sm",
    aspect: "auto",
    centered: !1,
    width: "auto"
  }
});
function YD(t) {
  const e = z.c(28);
  let n, o, r, i, s, l, a, c, u;
  e[0] !== t ? ({
    tone: r,
    padding: i,
    radius: s,
    aspect: l,
    centered: a,
    width: c,
    hasBorder: u,
    children: n,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9]);
  const d = r === void 0 ? "base" : r, f = i === void 0 ? "comfortable" : i, p = s === void 0 ? "sm" : s, g = l === void 0 ? "auto" : l, h = a === void 0 ? !1 : a, b = c === void 0 ? "auto" : c, v = u === void 0 ? !1 : u, C = h || void 0;
  let y;
  e[10] !== g || e[11] !== h || e[12] !== v || e[13] !== f || e[14] !== p || e[15] !== d || e[16] !== b ? (y = ne(MT({
    tone: d,
    padding: f,
    radius: p,
    aspect: g,
    centered: h,
    width: b
  }), v && "border border-outline-subtle", "shadow-elevation-1"), e[10] = g, e[11] = h, e[12] = v, e[13] = f, e[14] = p, e[15] = d, e[16] = b, e[17] = y) : y = e[17];
  let w;
  return e[18] !== g || e[19] !== n || e[20] !== f || e[21] !== o || e[22] !== p || e[23] !== C || e[24] !== y || e[25] !== d || e[26] !== b ? (w = /* @__PURE__ */ m("div", { "data-slot": "tile", "data-tone": d, "data-padding": f, "data-radius": p, "data-aspect": g, "data-centered": C, "data-width": b, className: y, ...o, children: n }), e[18] = g, e[19] = n, e[20] = f, e[21] = o, e[22] = p, e[23] = C, e[24] = y, e[25] = d, e[26] = b, e[27] = w) : w = e[27], w;
}
function S3(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM";
  return `${e === 0 ? 12 : e > 12 ? e - 12 : e}:${String(n).padStart(2, "0")} ${o}`;
}
function _s(t) {
  const [e, n] = t.split(":").map(Number), o = e < 12 ? "AM" : "PM", r = e === 0 ? 12 : e > 12 ? e - 12 : e;
  return {
    hour: String(r).padStart(2, "0"),
    minute: String(n).padStart(2, "0"),
    period: o
  };
}
function IT(t) {
  const e = Number(t.hour);
  let n = t.period === "PM" ? e + 12 : e;
  return t.period === "AM" && e === 12 && (n = 0), t.period === "PM" && e === 12 && (n = 12), `${String(n).padStart(2, "0")}:${t.minute}`;
}
function im(t) {
  const e = t.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/i);
  if (!e) return null;
  let n = parseInt(e[1], 10);
  const o = parseInt(e[2], 10), r = e[3].toUpperCase();
  return n < 1 || n > 12 || o < 0 || o > 59 ? null : (r === "AM" ? n === 12 && (n = 0) : n !== 12 && (n += 12), `${String(n).padStart(2, "0")}:${String(o).padStart(2, "0")}`);
}
function PT(t, e, n) {
  const o = [];
  for (let r = 0; r < 1440; r += t) {
    const i = Math.floor(r / 60), s = r % 60, l = `${String(i).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
    e && l < e || n && l > n || o.push({
      value: l,
      label: S3(l)
    });
  }
  return o;
}
function TT(t, e) {
  const n = /* @__PURE__ */ new Set();
  return t.forEach((o) => {
    const r = _s(o.value);
    n.add(r[e]);
  }), [...n];
}
function OT(t, e) {
  const n = _s(t.value);
  return n.hour === e.hour && n.minute === e.minute && n.period === e.period;
}
function DT({
  options: t,
  currentParts: e,
  column: n,
  partValue: o
}) {
  const r = {
    ...e,
    [n]: o
  }, i = t.find((s) => OT(s, r));
  return i ? i.value : t.find((s) => _s(s.value)[n] === o)?.value ?? t[0]?.value ?? IT(r);
}
function VT(t, e) {
  return _s(t?.value ?? e[0]?.value ?? "00:00");
}
function Lc({
  options: t,
  currentParts: e,
  column: n
}) {
  return TT(t, n).map((o) => ({
    kind: n,
    value: `${n}-${o}`,
    label: o,
    partValue: o,
    nextValue: DT({
      options: t,
      currentParts: e,
      column: n,
      partValue: o
    })
  }));
}
const _T = ce(["flex", "items-center", "gap-(--spacing-4)", "w-[228px]", "rounded-(--radius-sm)", "border", "border-solid", "border-input-default-outline", "bg-input-default-background", "px-(--spacing-10)", "transition-colors", "duration-200", "ease-in-out", "cursor-text", "[&:not(:focus-within)]:hover:bg-input-hover-background", "[&:not(:focus-within)]:hover:border-input-hover-outline", "active:border-input-pressed-outline", "focus-within:border-input-active-outline"], {
  variants: {
    size: {
      sm: ["h-(--spacing-32)", "py-(--spacing-6)"],
      md: ["h-(--spacing-40)", "py-(--spacing-10)"]
    },
    hasError: {
      true: ["border-input-error-outline", "[&:not(:focus-within)]:hover:border-input-error-outline"],
      false: []
    }
  },
  defaultVariants: {
    size: "md",
    hasError: !1
  }
});
function R3(t, e) {
  return e[t.kind] === t.partValue;
}
function AT(t, e) {
  return t.kind === "time" && e.kind === "time" ? t.value === e.value : t.kind !== "time" && e.kind === "time" ? R3(t, _s(e.value)) : t.value === e.value;
}
function Fc(t) {
  const e = z.c(19), {
    option: n,
    selectedParts: o
  } = t;
  let r, i, s, l, a;
  e[0] !== n || e[1] !== o ? (i = R3(n, o), r = Ts, s = n, l = `${n.kind} ${n.label}`, a = ne(Ko({}), "justify-center px-(--spacing-8)", i && "bg-menu-item-selected"), e[0] = n, e[1] = o, e[2] = r, e[3] = i, e[4] = s, e[5] = l, e[6] = a) : (r = e[2], i = e[3], s = e[4], l = e[5], a = e[6]);
  let c;
  e[7] !== n.label ? (c = /* @__PURE__ */ m("span", { className: "min-w-0 flex-1 text-center", children: n.label }), e[7] = n.label, e[8] = c) : c = e[8];
  let u;
  e[9] !== n.kind || e[10] !== i ? (u = i && n.kind === "period" && /* @__PURE__ */ m("span", { className: "inline-flex shrink-0 text-menu-icon-secondary", children: /* @__PURE__ */ m(Ke, { name: "check-mark", size: "xs", tone: "inherit" }) }), e[9] = n.kind, e[10] = i, e[11] = u) : u = e[11];
  let d;
  return e[12] !== r || e[13] !== s || e[14] !== l || e[15] !== a || e[16] !== c || e[17] !== u ? (d = /* @__PURE__ */ F(r, { value: s, "aria-label": l, className: a, children: [
    c,
    u
  ] }), e[12] = r, e[13] = s, e[14] = l, e[15] = a, e[16] = c, e[17] = u, e[18] = d) : d = e[18], d;
}
function $c() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("div", { "aria-hidden": "true", className: "h-[36px]" }), t[0] = e) : e = t[0], e;
}
function jD(t) {
  const e = z.c(83), {
    value: n,
    onValueChange: o,
    id: r,
    label: i,
    placeholder: s,
    size: l,
    required: a,
    description: c,
    tooltip: u,
    error: d,
    disabled: f,
    minuteStep: p,
    minTime: g,
    maxTime: h,
    name: b,
    "data-testid": v
  } = t, C = s === void 0 ? "--:--" : s, y = l === void 0 ? "md" : l, w = f === void 0 ? !1 : f, R = p === void 0 ? 15 : p, S = qt(), [E, N] = ot(!1), T = _t(), P = r ?? T, I = _t(), k = !!d;
  let M, D, O, V;
  if (e[0] !== h || e[1] !== g || e[2] !== R || e[3] !== n) {
    M = PT(R, g, h), D = n ? {
      ...M.find((be) => be.value === n) ?? {
        value: n,
        label: S3(n)
      },
      kind: "time"
    } : null, O = VT(D, M);
    const ue = {
      hour: Lc({
        options: M,
        currentParts: O,
        column: "hour"
      }),
      minute: Lc({
        options: M,
        currentParts: O,
        column: "minute"
      }),
      period: Lc({
        options: M,
        currentParts: O,
        column: "period"
      })
    }, Re = Math.max(ue.hour.length, ue.minute.length, ue.period.length);
    V = Array.from({
      length: Re
    }, (be, ve) => ({
      hour: ue.hour[ve],
      minute: ue.minute[ve],
      period: ue.period[ve]
    })), e[0] = h, e[1] = g, e[2] = R, e[3] = n, e[4] = M, e[5] = D, e[6] = O, e[7] = V;
  } else
    M = e[4], D = e[5], O = e[6], V = e[7];
  const _ = V;
  let A;
  e[8] !== M || e[9] !== o || e[10] !== n ? (A = function(Re) {
    const be = im(Re.currentTarget.value);
    be !== null && be !== n && M.some((ve) => ve.value === be) && o(be);
  }, e[8] = M, e[9] = o, e[10] = n, e[11] = A) : A = e[11];
  const L = A;
  let B;
  e[12] !== M || e[13] !== o || e[14] !== n ? (B = function(Re) {
    const be = Re.currentTarget.value.trim();
    if (be === "") {
      n !== null && o(null);
      return;
    }
    const ve = im(be);
    ve !== null && ve !== n && M.some((me) => me.value === ve) && o(ve);
  }, e[12] = M, e[13] = o, e[14] = n, e[15] = B) : B = e[15];
  const G = B;
  let U;
  e[16] !== o ? (U = function(Re) {
    if (Re === null) {
      o(null);
      return;
    }
    o(Re.kind === "time" ? Re.value : Re.nextValue);
  }, e[16] = o, e[17] = U) : U = e[17];
  const Y = U, K = w && "pointer-events-none";
  let j;
  e[18] !== K ? (j = ne("flex flex-col w-fit", K), e[18] = K, e[19] = j) : j = e[19];
  let Z;
  e[20] !== P || e[21] !== i || e[22] !== a || e[23] !== u ? (Z = i && /* @__PURE__ */ m(gi, { htmlFor: P, label: i, required: a, tooltip: u }), e[20] = P, e[21] = i, e[22] = a, e[23] = u, e[24] = Z) : Z = e[24];
  let te;
  e[25] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (te = (ue, Re) => {
    N(!ue && Re.reason === "item-press" ? !0 : ue);
  }, e[25] = te) : te = e[25];
  let W;
  e[26] !== w || e[27] !== k || e[28] !== y ? (W = ne(_T({
    size: y,
    hasError: k
  }), w && "opacity-50"), e[26] = w, e[27] = k, e[28] = y, e[29] = W) : W = e[29];
  const X = i ? void 0 : "Choose time", ee = a || void 0, le = k || void 0, J = c || d ? I : void 0, ie = k && "text-input-error-text";
  let pe;
  e[30] !== ie ? (pe = ne("flex-1", "min-w-0", "outline-none", "bg-transparent", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-input-text-default", "placeholder:text-input-text-placeholder", ie), e[30] = ie, e[31] = pe) : pe = e[31];
  let oe;
  e[32] !== v || e[33] !== G || e[34] !== L || e[35] !== P || e[36] !== C || e[37] !== X || e[38] !== ee || e[39] !== le || e[40] !== J || e[41] !== pe ? (oe = /* @__PURE__ */ m(Is, { id: P, "data-testid": v, placeholder: C, "aria-autocomplete": "list", "aria-label": X, "aria-required": ee, "aria-invalid": le, "aria-describedby": J, onChange: L, onBlur: G, className: pe }), e[32] = v, e[33] = G, e[34] = L, e[35] = P, e[36] = C, e[37] = X, e[38] = ee, e[39] = le, e[40] = J, e[41] = pe, e[42] = oe) : oe = e[42];
  let re;
  e[43] !== w || e[44] !== D ? (re = D !== null && !w && /* @__PURE__ */ m(Of, { "aria-label": "Clear time", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) text-icon-secondary outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "xs", tone: "inherit" }) }), e[43] = w, e[44] = D, e[45] = re) : re = e[45];
  let de;
  e[46] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (de = /* @__PURE__ */ m(ya, { "aria-label": "Open time picker", className: "flex items-center justify-center size-(--spacing-16) rounded-(--radius-xs) disabled:opacity-50 outline-none focus-visible:ring-2 focus-visible:ring-button-focus-ring", children: /* @__PURE__ */ m(Ke, { name: "clock-seven", size: "xs", tone: "secondary" }) }), e[46] = de) : de = e[46];
  let xe;
  e[47] !== re ? (xe = /* @__PURE__ */ F("div", { className: "flex shrink-0 items-center gap-(--spacing-6)", children: [
    re,
    de
  ] }), e[47] = re, e[48] = xe) : xe = e[48];
  let se;
  e[49] !== W || e[50] !== oe || e[51] !== xe ? (se = /* @__PURE__ */ F(va, { className: W, children: [
    oe,
    xe
  ] }), e[49] = W, e[50] = oe, e[51] = xe, e[52] = se) : se = e[52];
  let fe;
  e[53] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (fe = ws({
    size: "auto",
    className: "w-[228px]"
  }), e[53] = fe) : fe = e[53];
  let $;
  e[54] !== _ || e[55] !== O ? ($ = /* @__PURE__ */ m(Ca, { sideOffset: 4, className: "w-(--anchor-width)", children: /* @__PURE__ */ m(wa, { className: fe, children: /* @__PURE__ */ m(Ps, { "aria-label": "Select a time", className: "flex flex-col gap-(--spacing-2) outline-none", children: _.map((ue) => /* @__PURE__ */ F(_0, { className: "grid grid-cols-3 gap-(--spacing-2)", children: [
    ue.hour ? /* @__PURE__ */ m(Fc, { option: ue.hour, selectedParts: O }) : /* @__PURE__ */ m($c, {}),
    ue.minute ? /* @__PURE__ */ m(Fc, { option: ue.minute, selectedParts: O }) : /* @__PURE__ */ m($c, {}),
    ue.period ? /* @__PURE__ */ m(Fc, { option: ue.period, selectedParts: O }) : /* @__PURE__ */ m($c, {})
  ] }, [ue.hour?.value ?? "empty-hour", ue.minute?.value ?? "empty-minute", ue.period?.value ?? "empty-period"].join("-"))) }) }) }), e[54] = _, e[55] = O, e[56] = $) : $ = e[56];
  let Q;
  e[57] !== S || e[58] !== $ ? (Q = /* @__PURE__ */ m(xa, { container: S, children: $ }), e[57] = S, e[58] = $, e[59] = Q) : Q = e[59];
  let H;
  e[60] !== w || e[61] !== Y || e[62] !== b || e[63] !== E || e[64] !== a || e[65] !== D || e[66] !== se || e[67] !== Q ? (H = /* @__PURE__ */ F(yf, { open: E, onOpenChange: te, value: D, onValueChange: Y, isItemEqualToValue: AT, itemToStringLabel: FT, itemToStringValue: LT, disabled: w, required: a, name: b, grid: !0, filter: null, autoComplete: "none", children: [
    se,
    Q
  ] }), e[60] = w, e[61] = Y, e[62] = b, e[63] = E, e[64] = a, e[65] = D, e[66] = se, e[67] = Q, e[68] = H) : H = e[68];
  let q;
  e[69] !== c || e[70] !== I || e[71] !== d || e[72] !== k ? (q = k ? /* @__PURE__ */ m(Pr, { match: !0, id: I, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-error-text", children: d }) : c ? /* @__PURE__ */ m(fi, { id: I, className: "text-(length:--font-size-body-small) leading-(--font-line-height-16) text-input-text-supporting", children: c }) : null, e[69] = c, e[70] = I, e[71] = d, e[72] = k, e[73] = q) : q = e[73];
  let ae;
  e[74] !== q ? (ae = /* @__PURE__ */ m("div", { "data-testid": "time-picker-subtext-row", className: "min-h-(--spacing-20) mt-(--spacing-4)", children: q }), e[74] = q, e[75] = ae) : ae = e[75];
  let ge;
  return e[76] !== w || e[77] !== k || e[78] !== j || e[79] !== Z || e[80] !== H || e[81] !== ae ? (ge = /* @__PURE__ */ F(Ir, { invalid: k, disabled: w, className: j, children: [
    Z,
    H,
    ae
  ] }), e[76] = w, e[77] = k, e[78] = j, e[79] = Z, e[80] = H, e[81] = ae, e[82] = ge) : ge = e[82], ge;
}
function LT(t) {
  return t.kind === "time" ? t.value : t.nextValue;
}
function FT(t) {
  return t.label;
}
const Ta = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (Ta.displayName = "ToastContext");
function h1() {
  const t = x.useContext(Ta);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : rt(73));
  return t;
}
let sm = 0;
function E3(t) {
  return sm += 1, `${t}-${Math.random().toString(36).slice(2, 6)}-${sm}`;
}
function Hc(t, e) {
  if (typeof t == "string")
    return {
      description: t
    };
  if (typeof t == "function") {
    const n = t(e);
    return typeof n == "string" ? {
      description: n
    } : n;
  }
  return t;
}
const ml = s9((t) => t.toasts, (t) => {
  const e = /* @__PURE__ */ new Map();
  let n = 0, o = 0;
  return t.forEach((r, i) => {
    const s = r.transitionStatus === "ending";
    e.set(r.id, {
      value: r,
      domIndex: i,
      visibleIndex: s ? -1 : n,
      offsetY: o
    }), o += r.height || 0, s || (n += 1);
  }), e;
}), io = {
  toasts: he((t) => t.toasts),
  isEmpty: he((t) => t.toasts.length === 0),
  toast: he(ml, (t, e) => t.get(e)?.value),
  toastIndex: he(ml, (t, e) => t.get(e)?.domIndex ?? -1),
  toastOffsetY: he(ml, (t, e) => t.get(e)?.offsetY ?? 0),
  toastVisibleIndex: he(ml, (t, e) => t.get(e)?.visibleIndex ?? -1),
  hovering: he((t) => t.hovering),
  focused: he((t) => t.focused),
  expanded: he((t) => t.hovering || t.focused),
  expandedOrOutOfFocus: he((t) => t.hovering || t.focused || !t.isWindowFocused),
  prevFocusElement: he((t) => t.prevFocusElement)
};
class $T extends wr {
  timers = /* @__PURE__ */ new Map();
  areTimersPaused = !1;
  constructor(e) {
    super(e, {}, io);
  }
  setFocused(e) {
    this.set("focused", e);
  }
  setHovering(e) {
    this.set("hovering", e);
  }
  setIsWindowFocused(e) {
    this.set("isWindowFocused", e);
  }
  setPrevFocusElement(e) {
    this.set("prevFocusElement", e);
  }
  setViewport = (e) => {
    this.set("viewport", e);
  };
  disposeEffect = () => () => {
    this.timers.forEach((e) => {
      e.timeout?.clear();
    }), this.timers.clear();
  };
  removeToast(e, n = {}) {
    const o = io.toastIndex(this.state, e);
    if (o === -1)
      return;
    const r = this.state.toasts[o];
    n.skipOnRemove || r?.onRemove?.();
    const i = [...this.state.toasts];
    i.splice(o, 1), this.setToasts(i);
  }
  addToast = (e) => {
    const {
      timeout: n,
      limit: o
    } = this.state, r = e.id || E3("toast");
    if (e.id) {
      const c = io.toast(this.state, e.id);
      if (c)
        if (c.transitionStatus === "ending")
          this.removeToast(e.id, {
            skipOnRemove: !0
          });
        else {
          const {
            id: u,
            transitionStatus: d,
            ...f
          } = e;
          return this.updateToastInternal(e.id, f, {
            resetTimer: !0,
            markUpdated: !0
          }), e.id;
        }
    }
    const i = {
      ...e,
      id: r,
      updateKey: 0,
      transitionStatus: "starting"
    }, s = [i, ...this.state.toasts], l = s.filter((c) => c.transitionStatus !== "ending");
    if (l.length > o) {
      const c = l.length - o, u = l.slice(-c), d = new Set(u.map((f) => f.id));
      this.setToasts(s.map((f) => {
        const p = d.has(f.id);
        return f.limited !== p ? {
          ...f,
          limited: p
        } : f;
      }));
    } else
      this.setToasts(s.map((c) => c.limited ? {
        ...c,
        limited: !1
      } : c));
    const a = i.timeout ?? n;
    return i.type !== "loading" && a > 0 && this.scheduleTimer(r, a, () => this.closeToast(r)), io.expandedOrOutOfFocus(this.state) && this.pauseTimers(), r;
  };
  updateToast = (e, n) => {
    this.updateToastInternal(e, n, {
      markUpdated: !0
    });
  };
  updateToastInternal = (e, n, o = {}) => {
    const {
      timeout: r,
      toasts: i
    } = this.state, s = io.toast(this.state, e) ?? null;
    if (!s || s.transitionStatus === "ending")
      return;
    const l = {
      ...s,
      ...n,
      ...o.markUpdated && {
        updateKey: (s.updateKey ?? 0) + 1
      }
    };
    this.setToasts(i.map((h) => h.id === e ? l : h));
    const a = l.timeout ?? r, c = s?.timeout ?? r, u = Object.hasOwn(n, "timeout"), d = l.transitionStatus !== "ending" && l.type !== "loading" && a > 0, f = this.timers.has(e), p = c !== a, g = s?.type === "loading";
    if (!d && f) {
      this.timers.get(e)?.timeout?.clear(), this.timers.delete(e);
      return;
    }
    if (d && (!f || p || u || g || o.resetTimer)) {
      const h = this.timers.get(e);
      h && (h.timeout?.clear(), this.timers.delete(e)), this.scheduleTimer(e, a, () => this.closeToast(e)), io.expandedOrOutOfFocus(this.state) && this.pauseTimers();
    }
  };
  closeToast = (e) => {
    const n = e === void 0, {
      limit: o,
      toasts: r
    } = this.state;
    let i;
    if (n)
      i = r, this.timers.forEach((c) => {
        c.timeout?.clear();
      }), this.timers.clear();
    else {
      const c = io.toast(this.state, e);
      if (!c)
        return;
      i = [c];
      const u = this.timers.get(e);
      u?.timeout && (u.timeout.clear(), this.timers.delete(e));
    }
    let s = 0;
    const a = {
      toasts: r.map((c) => {
        if (n || c.id === e)
          return {
            ...c,
            transitionStatus: "ending",
            height: 0
          };
        if (c.transitionStatus === "ending")
          return c;
        const u = s >= o;
        return s += 1, c.limited !== u ? {
          ...c,
          limited: u
        } : c;
      })
    };
    (n || r.length === 1) && (a.hovering = !1, a.focused = !1), this.update(a), i.forEach((c) => {
      c.transitionStatus !== "ending" && c.onClose?.();
    }), this.handleFocusManagement(e);
  };
  promiseToast = (e, n) => {
    const o = Hc(n.loading), r = this.addToast({
      ...o,
      type: "loading"
    }), i = e.then((s) => {
      const l = Hc(n.success, s);
      return this.updateToast(r, {
        ...l,
        type: "success",
        timeout: l.timeout
      }), s;
    }).catch((s) => {
      const l = Hc(n.error, s);
      return this.updateToast(r, {
        ...l,
        type: "error",
        timeout: l.timeout
      }), Promise.reject(s);
    });
    return {}.hasOwnProperty.call(n, "setPromise") && n.setPromise(i), i;
  };
  pauseTimers() {
    this.areTimersPaused || (this.areTimersPaused = !0, this.timers.forEach((e) => {
      if (e.timeout) {
        e.timeout.clear();
        const n = Date.now() - e.start, o = e.delay - n;
        e.remaining = o > 0 ? o : 0;
      }
    }));
  }
  resumeTimers() {
    this.areTimersPaused && (this.areTimersPaused = !1, this.timers.forEach((e, n) => {
      e.remaining = e.remaining > 0 ? e.remaining : e.delay, e.timeout ??= xn.create(), e.timeout.start(e.remaining, () => {
        this.timers.delete(n), e.callback();
      }), e.start = Date.now();
    }));
  }
  restoreFocusToPrevElement() {
    this.state.prevFocusElement?.focus({
      preventScroll: !0
    });
  }
  handleDocumentPointerDown = (e) => {
    if (e.pointerType !== "touch")
      return;
    const n = bt(e);
    ze(this.state.viewport, n) || (this.resumeTimers(), this.update({
      hovering: !1,
      focused: !1
    }));
  };
  scheduleTimer(e, n, o) {
    const r = Date.now(), i = !io.expandedOrOutOfFocus(this.state), s = i ? xn.create() : void 0;
    s?.start(n, () => {
      this.timers.delete(e), o();
    }), this.timers.set(e, {
      timeout: s,
      start: i ? r : 0,
      delay: n,
      remaining: n,
      callback: o
    });
  }
  setToasts(e) {
    const n = {
      toasts: e
    };
    e.length === 0 && (n.hovering = !1, n.focused = !1), this.update(n);
  }
  handleFocusManagement(e) {
    const n = Gt(et(this.state.viewport));
    if (!this.state.viewport || !ze(this.state.viewport, n) || !Vl(n))
      return;
    if (e === void 0) {
      this.restoreFocusToPrevElement();
      return;
    }
    const o = io.toasts(this.state), r = io.toastIndex(this.state, e);
    let i = null, s = r + 1;
    for (; s < o.length; ) {
      if (o[s].transitionStatus !== "ending") {
        i = o[s];
        break;
      }
      s += 1;
    }
    if (!i)
      for (s = r - 1; s >= 0; ) {
        if (o[s].transitionStatus !== "ending") {
          i = o[s];
          break;
        }
        s -= 1;
      }
    i ? i.ref?.current?.focus() : this.restoreFocusToPrevElement();
  }
}
const b1 = function(e) {
  const {
    children: n,
    timeout: o = 5e3,
    limit: r = 3,
    toastManager: i
  } = e, s = Tt(() => new $T({
    timeout: o,
    limit: r,
    viewport: null,
    toasts: [],
    hovering: !1,
    focused: !1,
    isWindowFocused: !0,
    prevFocusElement: null
  })).current;
  return Jr(s.disposeEffect), x.useEffect(function() {
    return i ? i[" subscribe"](({
      action: c,
      options: u
    }) => {
      const d = u.id;
      c === "promise" && u.promise ? s.promiseToast(u.promise, u) : c === "update" && d ? s.updateToast(d, u) : c === "close" ? s.closeToast(d) : s.addToast(u);
    }) : void 0;
  }, [s, o, i]), s.useSyncedValues({
    timeout: o,
    limit: r
  }), /* @__PURE__ */ m(Ta.Provider, {
    value: s,
    children: n
  });
};
process.env.NODE_ENV !== "production" && (b1.displayName = "ToastProvider");
let HT = /* @__PURE__ */ (function(t) {
  return t.frontmostHeight = "--toast-frontmost-height", t;
})({});
const N3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    children: s,
    ...l
  } = e, a = h1(), c = Vt(), u = x.useRef(!1), d = x.useRef(!1), f = x.useRef(!1), p = a.useState("isEmpty"), g = a.useState("toasts"), h = a.useState("focused"), b = a.useState("expanded"), v = a.useState("prevFocusElement"), C = g[0]?.height ?? 0, y = x.useMemo(() => g.some((_) => _.transitionStatus === "ending"), [g]);
  x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_)
      return;
    function A(B) {
      p || B.key === "F6" && bt(B) !== _ && (B.preventDefault(), a.setPrevFocusElement(Gt(et(_))), _?.focus({
        preventScroll: !0
      }), a.pauseTimers(), a.setFocused(!0));
    }
    const L = wt(_);
    return ut(L, "keydown", A);
  }, [a, p]), x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_ || p)
      return;
    const A = wt(_);
    function L(G) {
      bt(G) === A && (a.setIsWindowFocused(!1), a.pauseTimers());
    }
    function B(G) {
      if (G.relatedTarget)
        return;
      const U = bt(G), Y = Gt(et(_));
      (U === A || !ze(_, U) || !Vl(Y)) && a.resumeTimers(), c.start(0, () => a.setIsWindowFocused(!0));
    }
    return Yn(ut(A, "blur", L, !0), ut(A, "focus", B, !0));
  }, [
    a,
    c,
    // `store.state.viewport` isn't available on the first render,
    // since the portal node hasn't yet been created.
    // By adding this dependency, we ensure the window listeners
    // are added when toasts have been created, once the ref is available.
    p
  ]), x.useEffect(() => {
    const _ = a.state.viewport;
    if (!_ || p)
      return;
    const A = et(_);
    return ut(A, "pointerdown", a.handleDocumentPointerDown, !0);
  }, [p, a]);
  function w(_) {
    const A = a.state.viewport;
    A && (u.current = !0, _.relatedTarget === A ? g[0]?.ref?.current?.focus() : a.restoreFocusToPrevElement());
  }
  function R(_) {
    _.key === "Tab" && _.shiftKey && bt(_.nativeEvent) === a.state.viewport && (_.preventDefault(), a.restoreFocusToPrevElement(), a.resumeTimers());
  }
  function S() {
    const _ = a.state.toasts.some((A) => A.transitionStatus === "ending");
    !a.state.isWindowFocused || _ || f.current || !d.current || (a.resumeTimers(), a.setHovering(!1), d.current = !1);
  }
  x.useEffect(S, [y, a]);
  function E() {
    a.pauseTimers(), a.setHovering(!0), d.current = !1;
  }
  function N() {
    y || f.current ? d.current = !0 : (a.resumeTimers(), a.setHovering(!1));
  }
  function T(_) {
    _.pointerType === "touch" && (f.current = !0);
  }
  function P(_) {
    _.pointerType === "touch" && (f.current = !1, S());
  }
  function I() {
    if (u.current) {
      u.current = !1;
      return;
    }
    h || Vl(Gt(et(a.state.viewport))) && (a.setFocused(!0), a.pauseTimers());
  }
  function k(_) {
    !h || ze(a.state.viewport, _.relatedTarget) || (a.setFocused(!1), a.resumeTimers());
  }
  const M = {
    tabIndex: -1,
    role: "region",
    "aria-live": "polite",
    "aria-atomic": !1,
    "aria-relevant": "additions text",
    "aria-label": "Notifications",
    onMouseEnter: E,
    onMouseMove: E,
    onMouseLeave: N,
    onFocus: I,
    onBlur: k,
    onKeyDown: R,
    onClick: I,
    onPointerDown: T,
    onPointerUp: P,
    onPointerCancel: P
  }, D = {
    expanded: b
  }, O = $e("div", e, {
    ref: [n, a.setViewport],
    state: D,
    props: [M, {
      style: {
        [HT.frontmostHeight]: C ? `${C}px` : void 0
      }
    }, l, {
      children: /* @__PURE__ */ F(x.Fragment, {
        children: [!p && v && /* @__PURE__ */ m(Vn, {
          onFocus: w
        }), s, !p && v && /* @__PURE__ */ m(Vn, {
          onFocus: w
        })]
      })
    }]
  }), V = x.useMemo(() => g.filter((_) => _.priority === "high"), [g]);
  return /* @__PURE__ */ F(x.Fragment, {
    children: [!p && v && /* @__PURE__ */ m(Vn, {
      onFocus: w
    }), O, !h && V.length > 0 && /* @__PURE__ */ m("div", {
      style: Jo,
      children: V.map((_) => /* @__PURE__ */ F("div", {
        role: "alert",
        "aria-atomic": !0,
        children: [/* @__PURE__ */ m("div", {
          children: _.title
        }), /* @__PURE__ */ m("div", {
          children: _.description
        })]
      }, _.id))
    })]
  });
});
process.env.NODE_ENV !== "production" && (N3.displayName = "ToastViewport");
const v1 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (v1.displayName = "ToastRootContext");
function Oa() {
  const t = x.useContext(v1);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToastRootContext is missing. Toast parts must be used within <Toast.Root>." : rt(66));
  return t;
}
let sr = /* @__PURE__ */ (function(t) {
  return t.index = "--toast-index", t.offsetY = "--toast-offset-y", t.height = "--toast-height", t.swipeMovementX = "--toast-swipe-movement-x", t.swipeMovementY = "--toast-swipe-movement-y", t;
})({});
const zT = {
  ...Bt,
  swipeDirection(t) {
    return t ? {
      "data-swipe-direction": t
    } : null;
  }
}, Ti = 40, BT = 10, $o = 0.5, WT = 1, UT = `${Ch},${U8}`;
function lm(t, e, n) {
  switch (t) {
    case "up":
      return -n;
    case "down":
      return n;
    case "left":
      return -e;
    case "right":
      return e;
    default:
      return 0;
  }
}
function GT(t) {
  const n = wt(t).getComputedStyle(t).transform;
  let o = 0, r = 0, i = 1;
  if (n && n !== "none") {
    const s = n.match(/matrix(?:3d)?\(([^)]+)\)/);
    if (s) {
      const l = s[1].split(", ").map(parseFloat);
      l.length === 6 ? (o = l[4], r = l[5], i = Math.sqrt(l[0] * l[0] + l[1] * l[1])) : l.length === 16 && (o = l[12], r = l[13], i = l[0]);
    }
  }
  return {
    x: o,
    y: r,
    scale: i
  };
}
const k3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    toast: o,
    render: r,
    className: i,
    swipeDirection: s = ["down", "right"],
    style: l,
    ...a
  } = e, c = o.positionerProps?.anchor !== void 0;
  let u = [];
  c || (u = Array.isArray(s) ? s : [s]);
  const d = u.length > 0, f = h1(), [p, g] = x.useState(void 0), [h, b] = x.useState(!1), [v, C] = x.useState(!1), [y, w] = x.useState(!1), [R, S] = x.useState({
    x: 0,
    y: 0
  }), [E, N] = x.useState({
    x: 0,
    y: 0,
    scale: 1
  }), [T, P] = x.useState(), [I, k] = x.useState(), [M, D] = x.useState(null), O = x.useRef(null), V = x.useRef({
    x: 0,
    y: 0
  }), _ = x.useRef({
    x: 0,
    y: 0,
    scale: 1
  }), A = x.useRef(void 0), L = x.useRef(0), B = x.useRef(!1), G = x.useRef({
    x: 0,
    y: 0
  }), U = x.useRef(!1), Y = f.useState("toastIndex", o.id), K = f.useState("toastVisibleIndex", o.id), j = f.useState("toastOffsetY", o.id), Z = f.useState("focused"), te = f.useState("expanded");
  jt({
    open: o.transitionStatus !== "ending",
    ref: O,
    onComplete() {
      o.transitionStatus === "ending" && f.removeToast(o.id);
    }
  });
  const W = Se(($ = !1) => {
    const Q = O.current;
    if (!Q)
      return;
    const H = Q.style.height;
    Q.style.height = "auto";
    const q = Q.offsetHeight;
    Q.style.height = H;
    function ae() {
      f.updateToastInternal(o.id, {
        ref: O,
        height: q,
        ...o.transitionStatus === "starting" ? {
          transitionStatus: void 0
        } : {}
      });
    }
    $ ? an.flushSync(ae) : ae();
  });
  ke(W, [W]);
  function X($, Q) {
    let H = $, q = Q;
    return !u.includes("left") && !u.includes("right") ? H = $ > 0 ? $ ** $o : -(Math.abs($) ** $o) : (!u.includes("right") && $ > 0 && (H = $ ** $o), !u.includes("left") && $ < 0 && (H = -(Math.abs($) ** $o))), !u.includes("up") && !u.includes("down") ? q = Q > 0 ? Q ** $o : -(Math.abs(Q) ** $o) : (!u.includes("down") && Q > 0 && (q = Q ** $o), !u.includes("up") && Q < 0 && (q = -(Math.abs(Q) ** $o))), {
      x: H,
      y: q
    };
  }
  function ee($) {
    if ($.button !== 0)
      return;
    $.pointerType === "touch" && f.pauseTimers();
    const Q = bt($.nativeEvent);
    if (!(Q && Q.closest(`button,a,input,textarea,[role="button"],${UT}`))) {
      if (B.current = !1, A.current = void 0, L.current = 0, V.current = {
        x: $.clientX,
        y: $.clientY
      }, G.current = V.current, O.current) {
        const q = GT(O.current);
        _.current = q, N(q), S({
          x: q.x,
          y: q.y
        });
      }
      f.setHovering(!0), b(!0), C(!1), D(null), U.current = !0, O.current?.setPointerCapture($.pointerId);
    }
  }
  function le($) {
    if (!h)
      return;
    $.preventDefault(), U.current && (V.current = {
      x: $.clientX,
      y: $.clientY
    }, U.current = !1);
    const {
      clientY: Q,
      clientX: H,
      movementX: q,
      movementY: ae
    } = $;
    (ae < 0 && Q > G.current.y || ae > 0 && Q < G.current.y) && (G.current = {
      x: G.current.x,
      y: Q
    }), (q < 0 && H > G.current.x || q > 0 && H < G.current.x) && (G.current = {
      x: H,
      y: G.current.y
    });
    const ge = H - V.current.x, ue = Q - V.current.y, Re = Q - G.current.y, be = H - G.current.x;
    if (!v && Math.sqrt(ge * ge + ue * ue) >= WT && (C(!0), M === null)) {
      const _e = u.includes("left") || u.includes("right"), Ue = u.includes("up") || u.includes("down");
      if (_e && Ue) {
        const Ye = Math.abs(ge), He = Math.abs(ue);
        D(Ye > He ? "horizontal" : "vertical");
      }
    }
    let ve;
    if (!A.current)
      M === "vertical" ? ue > 0 ? ve = "down" : ue < 0 && (ve = "up") : M === "horizontal" ? ge > 0 ? ve = "right" : ge < 0 && (ve = "left") : Math.abs(ge) >= Math.abs(ue) ? ve = ge > 0 ? "right" : "left" : ve = ue > 0 ? "down" : "up", ve && u.includes(ve) && (A.current = ve, L.current = lm(ve, ge, ue), g(ve));
    else {
      const Me = A.current, _e = lm(Me, be, Re);
      _e > Ti ? (B.current = !1, g(Me)) : !(u.includes("left") && u.includes("right")) && !(u.includes("up") && u.includes("down")) && L.current - _e >= BT && (B.current = !0);
    }
    const me = X(ge, ue);
    let Ee = _.current.x, Pe = _.current.y;
    M === "horizontal" ? (u.includes("left") || u.includes("right")) && (Ee += me.x) : (M === "vertical" || (u.includes("left") || u.includes("right")) && (Ee += me.x), (u.includes("up") || u.includes("down")) && (Pe += me.y)), S({
      x: Ee,
      y: Pe
    });
  }
  function J($) {
    if (!h)
      return;
    if (b(!1), C(!1), D(null), O.current?.releasePointerCapture($.pointerId), B.current) {
      S({
        x: E.x,
        y: E.y
      }), g(void 0);
      return;
    }
    let Q = !1;
    const H = R.x - E.x, q = R.y - E.y;
    let ae;
    for (const ge of u) {
      switch (ge) {
        case "right":
          H > Ti && (Q = !0, ae = "right");
          break;
        case "left":
          H < -Ti && (Q = !0, ae = "left");
          break;
        case "down":
          q > Ti && (Q = !0, ae = "down");
          break;
        case "up":
          q < -Ti && (Q = !0, ae = "up");
          break;
      }
      if (Q)
        break;
    }
    Q ? (g(ae), w(!0), f.closeToast(o.id)) : (S({
      x: E.x,
      y: E.y
    }), g(void 0));
  }
  function ie() {
    h && (b(!1), C(!1), D(null), S({
      x: E.x,
      y: E.y
    }), g(void 0));
  }
  function pe($) {
    if ($.key === "Escape") {
      if (!O.current || !ze(O.current, Gt(et(O.current))))
        return;
      f.closeToast(o.id);
    }
  }
  x.useEffect(() => {
    if (!d)
      return;
    const $ = O.current;
    if (!$)
      return;
    function Q(H) {
      ze($, bt(H)) && H.preventDefault();
    }
    return ut($, "touchmove", Q, {
      passive: !1
    });
  }, [d]);
  function oe() {
    if (!h && R.x === E.x && R.y === E.y && !y)
      return {
        [sr.swipeMovementX]: "0px",
        [sr.swipeMovementY]: "0px"
      };
    const $ = R.x - E.x, Q = R.y - E.y;
    return {
      transition: h ? "none" : void 0,
      // While swiping, freeze the element at its current visual transform so it doesn't snap to the
      // end position.
      transform: h ? `translateX(${R.x}px) translateY(${R.y}px) scale(${E.scale})` : void 0,
      [sr.swipeMovementX]: `${$}px`,
      [sr.swipeMovementY]: `${Q}px`
    };
  }
  const re = o.priority === "high", de = {
    role: re ? "alertdialog" : "dialog",
    tabIndex: 0,
    "aria-modal": !1,
    "aria-labelledby": T,
    "aria-describedby": I,
    "aria-hidden": re && !Z ? !0 : void 0,
    onPointerDown: d ? ee : void 0,
    onPointerMove: d ? le : void 0,
    onPointerUp: d ? J : void 0,
    onPointerCancel: d ? ie : void 0,
    onKeyDown: pe,
    inert: Er(o.limited),
    style: {
      ...oe(),
      [sr.index]: o.transitionStatus === "ending" ? Y : K,
      [sr.offsetY]: `${j}px`,
      [sr.height]: o.height ? `${o.height}px` : void 0
    }
  }, xe = x.useMemo(() => ({
    rootRef: O,
    toast: o,
    titleId: T,
    setTitleId: P,
    descriptionId: I,
    setDescriptionId: k,
    swiping: h,
    swipeDirection: p,
    recalculateHeight: W,
    index: Y,
    visibleIndex: K,
    expanded: te
  }), [o, T, I, h, p, W, Y, K, te]), se = {
    transitionStatus: o.transitionStatus,
    expanded: te,
    limited: o.limited || !1,
    type: o.type,
    swiping: xe.swiping,
    swipeDirection: xe.swipeDirection
  }, fe = $e("div", e, {
    ref: [n, xe.rootRef],
    state: se,
    stateAttributesMapping: zT,
    props: [de, a]
  });
  return /* @__PURE__ */ m(v1.Provider, {
    value: xe,
    children: fe
  });
});
process.env.NODE_ENV !== "production" && (k3.displayName = "ToastRoot");
const M3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    ...s
  } = e, {
    visibleIndex: l,
    expanded: a,
    recalculateHeight: c
  } = Oa(), u = x.useRef(null);
  ke(() => {
    const g = u.current;
    if (!g || (c(), typeof ResizeObserver != "function" || typeof MutationObserver != "function"))
      return;
    const h = new ResizeObserver(() => c(!0)), b = new MutationObserver(() => c(!0));
    return h.observe(g), b.observe(g, {
      childList: !0,
      subtree: !0,
      characterData: !0
    }), () => {
      h.disconnect(), b.disconnect();
    };
  }, [c]);
  const d = l > 0;
  return $e("div", e, {
    ref: [n, u],
    state: {
      expanded: a,
      behind: d
    },
    props: s
  });
});
process.env.NODE_ENV !== "production" && (M3.displayName = "ToastContent");
const I3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    id: s,
    children: l,
    ...a
  } = e, {
    toast: c,
    setDescriptionId: u
  } = Oa(), d = l ?? c.description, f = !!d, p = Do(s);
  ke(() => {
    if (f)
      return u(p), () => {
        u(void 0);
      };
  }, [f, p, u]);
  const g = {
    type: c.type
  }, h = $e("p", e, {
    ref: n,
    state: g,
    props: {
      ...a,
      id: p,
      children: d
    }
  });
  return f ? h : null;
});
process.env.NODE_ENV !== "production" && (I3.displayName = "ToastDescription");
const xu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, c = h1(), {
    toast: u
  } = Oa(), d = c.useState("expanded"), [f, p] = x.useState(!1), {
    getButtonProps: g,
    buttonRef: h
  } = Wt({
    disabled: s,
    native: l
  }), b = {
    type: u.type
  };
  return $e("button", e, {
    ref: [n, h],
    state: b,
    props: [{
      "aria-hidden": !d && !f,
      onClick() {
        c.closeToast(u.id);
      },
      onFocus() {
        p(!0);
      },
      onBlur() {
        p(!1);
      }
    }, a, g]
  });
});
process.env.NODE_ENV !== "production" && (xu.displayName = "ToastClose");
const Cu = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    render: o,
    className: r,
    style: i,
    disabled: s,
    nativeButton: l = !0,
    ...a
  } = e, {
    toast: c
  } = Oa(), u = c.actionProps?.children ?? a.children, d = !!u, {
    getButtonProps: f,
    buttonRef: p
  } = Wt({
    disabled: s,
    native: l
  }), g = {
    type: c.type
  }, h = $e("button", e, {
    ref: [n, p],
    state: g,
    props: [a, c.actionProps, f, {
      children: u
    }]
  });
  return d ? h : null;
});
process.env.NODE_ENV !== "production" && (Cu.displayName = "ToastAction");
const YT = ga;
function jT() {
  const t = x.useContext(Ta);
  if (!t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: useToastManager must be used within <Toast.Provider>." : rt(73));
  const e = t.useState("toasts");
  return x.useMemo(() => ({
    toasts: e,
    add: t.addToast,
    close: t.closeToast,
    update: t.updateToast,
    promise: t.promiseToast
  }), [e, t]);
}
function KT() {
  const t = /* @__PURE__ */ new Set();
  function e(n) {
    t.forEach((o) => o(n));
  }
  return {
    // This should be private aside from ToastProvider needing to access it.
    // https://x.com/drosenwasser/status/1816947740032872664
    " subscribe": function(o) {
      return t.add(o), () => {
        t.delete(o);
      };
    },
    add(n) {
      const o = n.id || E3("toast"), r = {
        ...n,
        id: o,
        transitionStatus: "starting"
      };
      return e({
        action: "add",
        options: r
      }), o;
    },
    close(n) {
      e({
        action: "close",
        options: {
          id: n
        }
      });
    },
    update(n, o) {
      e({
        action: "update",
        options: {
          ...o,
          id: n
        }
      });
    },
    promise(n, o) {
      let r = n;
      return e({
        action: "promise",
        options: {
          ...o,
          promise: n,
          setPromise(i) {
            r = i;
          }
        }
      }), r;
    }
  };
}
const qT = ce(["rounded-(--radius-sm)", "outline-none", "transition-[opacity,transform,height]", "duration-200", "ease-in-out", "motion-reduce:transition-none", "shadow-elevation-3", "[&[data-starting-style]]:translate-y-2", "[&[data-starting-style]]:opacity-0", "[&[data-ending-style]]:translate-y-2", "[&[data-ending-style]]:opacity-0", "[&[data-limited]]:pointer-events-none", "[&[data-limited]]:opacity-0"], {
  variants: {
    variant: {
      default: ["bg-surface-inverse-surface", "text-surface-inverse-on-surface"],
      error: ["bg-error", "text-error-on-error"]
    },
    placement: {
      static: ["relative", "w-full", "max-w-[344px]"],
      viewport: ["w-full"]
    }
  },
  defaultVariants: {
    variant: "default",
    placement: "static"
  }
}), ZT = ce(["flex", "min-h-[48px]", "w-full", "items-center", "pl-(--spacing-10)"], {
  variants: {
    hasClose: {
      true: "pr-(--spacing-4)",
      false: "pr-(--spacing-8)"
    },
    layout: {
      inline: "gap-(--spacing-10)",
      "inline-action": "gap-(--spacing-4)",
      stacked: "items-start gap-(--spacing-10)"
    }
  },
  defaultVariants: {
    hasClose: !1,
    layout: "inline"
  }
}), XT = ce(["m-0", "min-w-0", "font-(family-name:--font-family-body)", "text-(length:--font-size-body-medium)", "font-(number:--font-weight-regular)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "text-current", "overflow-hidden", "[display:-webkit-box]", "[-webkit-box-orient:vertical]", "[-webkit-line-clamp:2]"]), QT = ce("min-w-0 flex-1 py-(--spacing-10)", {
  variants: {
    layout: {
      inline: "block",
      "inline-action": "block",
      stacked: "flex flex-col items-stretch gap-(--spacing-4)"
    }
  },
  defaultVariants: {
    layout: "inline"
  }
}), JT = ce("shrink-0 py-(--spacing-10)", {
  variants: {
    variant: {
      default: "text-primary-inverse-primary",
      error: "text-error-on-error"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), eO = ce(["inline-flex", "h-(--spacing-40)", "shrink-0", "items-center", "justify-center", "gap-(--spacing-8)", "whitespace-nowrap", "rounded-(--radius-sm)", "border-0", "bg-transparent", "px-(--spacing-12)", "py-0", "font-(family-name:--font-family-label)", "text-(length:--font-size-label-large)", "font-(number:--font-weight-medium)", "leading-(--font-line-height-20)", "tracking-(--font-letter-spacing-default)", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-primary-inverse-primary", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), tO = ce(["inline-flex", "size-[48px]", "shrink-0", "items-center", "justify-center", "rounded-(--radius-sm)", "border-0", "bg-transparent", "p-0", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-button-focus-ring", "disabled:pointer-events-none", "disabled:opacity-40", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0"], {
  variants: {
    variant: {
      default: ["text-surface-inverse-on-surface", "hover:bg-surface-inverse-surface-hover", "active:bg-surface-inverse-surface-pressed", "focus-visible:ring-offset-surface-inverse-surface"],
      error: ["text-error-on-error", "hover:bg-toast-error-button-hover-background", "active:bg-toast-error-button-pressed-background", "focus-visible:ring-offset-error"]
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), nO = ne("fixed", "[left:0]", "[right:0]", "mx-auto", "bottom-(--spacing-24)", "z-[var(--z-layer-notification)]", "h-(--toast-frontmost-height)", "w-[min(344px,calc(100vw_-_var(--spacing-32)))]"), oO = 10;
function am({
  children: t,
  variant: e,
  disabled: n = !1,
  ...o
}) {
  return /* @__PURE__ */ m(Qn, { className: ne(eO({
    variant: e
  })), disabled: n, "aria-disabled": n || void 0, tabIndex: n ? -1 : void 0, ...o, children: t });
}
function cm({
  variant: t,
  disabled: e = !1,
  "aria-label": n = "Dismiss notification",
  ...o
}) {
  return /* @__PURE__ */ m(Qn, { className: ne(tO({
    variant: t
  })), disabled: e, "aria-disabled": e || void 0, "aria-label": n, tabIndex: e ? -1 : void 0, ...o, children: /* @__PURE__ */ m(Ke, { name: "x-close", size: "sm", tone: "inherit" }) });
}
const P3 = KT();
function rO(t) {
  return t === "error" ? "error" : "default";
}
const iO = {
  add(t, e = {}) {
    const {
      variant: n = "default",
      action: o,
      icon: r = !1,
      onDismiss: i,
      timeout: s
    } = e;
    return P3.add({
      description: t,
      type: n,
      priority: n === "error" ? "high" : "low",
      ...s !== void 0 && {
        timeout: s
      },
      data: {
        action: o,
        icon: r,
        onDismiss: i
      }
    });
  },
  error(t, e = {}) {
    return iO.add(t, {
      ...e,
      variant: "error"
    });
  }
};
function T3(t) {
  const e = z.c(73);
  let n, o, r, i;
  e[0] !== t ? ({
    toast: i,
    onActionComplete: n,
    placement: r,
    ...o
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i) : (n = e[1], o = e[2], r = e[3], i = e[4]);
  const s = r === void 0 ? "static" : r;
  let l, a, c, u, d, f, p, g, h, b, v, C, y, w, R, S, E;
  if (e[5] !== n || e[6] !== s || e[7] !== o || e[8] !== i) {
    E = rO(i.type), c = i.data?.action;
    const V = i.data?.icon ?? !1, _ = !!i.data?.onDismiss;
    f = c && c.label.length >= oO ? "stacked" : c ? "inline-action" : "inline", p = f === "stacked" && _, g = _ && !p;
    let A;
    e[26] !== c || e[27] !== n ? (A = function() {
      c?.onClick(), n?.();
    }, e[26] = c, e[27] = n, e[28] = A) : A = e[28], u = A;
    let L;
    e[29] !== i.data ? (L = function() {
      i.data?.onDismiss?.();
    }, e[29] = i.data, e[30] = L) : L = e[30], d = L, a = k3, v = i, e[31] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (C = ["down", "right"], e[31] = C) : C = e[31], y = E === "error" ? "alert" : "status", w = E === "error" ? "assertive" : "polite", R = ne(qT({
      variant: E,
      placement: s
    })), S = o, l = M3, e[32] !== f || e[33] !== _ ? (h = ne(ZT({
      hasClose: _,
      layout: f
    })), e[32] = f, e[33] = _, e[34] = h) : h = e[34], b = V && /* @__PURE__ */ m("span", { "data-slot": "toast-leading-icon", className: ne(JT({
      variant: E
    })), children: /* @__PURE__ */ m(Ke, { name: E === "error" ? "circle-exclamation" : "circle-check-regular", size: "md", tone: "inherit" }) }), e[5] = n, e[6] = s, e[7] = o, e[8] = i, e[9] = l, e[10] = a, e[11] = c, e[12] = u, e[13] = d, e[14] = f, e[15] = p, e[16] = g, e[17] = h, e[18] = b, e[19] = v, e[20] = C, e[21] = y, e[22] = w, e[23] = R, e[24] = S, e[25] = E;
  } else
    l = e[9], a = e[10], c = e[11], u = e[12], d = e[13], f = e[14], p = e[15], g = e[16], h = e[17], b = e[18], v = e[19], C = e[20], y = e[21], w = e[22], R = e[23], S = e[24], E = e[25];
  let N;
  e[35] !== f ? (N = ne(QT({
    layout: f
  })), e[35] = f, e[36] = N) : N = e[36];
  let T;
  e[37] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = /* @__PURE__ */ m(I3, { className: ne(XT()) }), e[37] = T) : T = e[37];
  let P;
  e[38] !== c || e[39] !== u || e[40] !== d || e[41] !== f || e[42] !== p || e[43] !== E ? (P = c && f === "stacked" && /* @__PURE__ */ F("div", { className: "flex w-full items-center justify-end", children: [
    /* @__PURE__ */ m(Cu, { render: /* @__PURE__ */ m(am, { variant: E, onClick: u }), children: c.label }),
    p && /* @__PURE__ */ m(xu, { render: /* @__PURE__ */ m(cm, { variant: E, "aria-hidden": void 0, onClick: d }) })
  ] }), e[38] = c, e[39] = u, e[40] = d, e[41] = f, e[42] = p, e[43] = E, e[44] = P) : P = e[44];
  let I;
  e[45] !== N || e[46] !== P ? (I = /* @__PURE__ */ F("div", { className: N, children: [
    T,
    P
  ] }), e[45] = N, e[46] = P, e[47] = I) : I = e[47];
  let k;
  e[48] !== c || e[49] !== u || e[50] !== f || e[51] !== E ? (k = c && f === "inline-action" && /* @__PURE__ */ m(Cu, { render: /* @__PURE__ */ m(am, { variant: E, onClick: u }), children: c.label }), e[48] = c, e[49] = u, e[50] = f, e[51] = E, e[52] = k) : k = e[52];
  let M;
  e[53] !== d || e[54] !== g || e[55] !== E ? (M = g && /* @__PURE__ */ m(xu, { render: /* @__PURE__ */ m(cm, { variant: E, "aria-hidden": void 0, onClick: d }) }), e[53] = d, e[54] = g, e[55] = E, e[56] = M) : M = e[56];
  let D;
  e[57] !== l || e[58] !== I || e[59] !== k || e[60] !== M || e[61] !== h || e[62] !== b ? (D = /* @__PURE__ */ F(l, { className: h, children: [
    b,
    I,
    k,
    M
  ] }), e[57] = l, e[58] = I, e[59] = k, e[60] = M, e[61] = h, e[62] = b, e[63] = D) : D = e[63];
  let O;
  return e[64] !== a || e[65] !== D || e[66] !== v || e[67] !== C || e[68] !== y || e[69] !== w || e[70] !== R || e[71] !== S ? (O = /* @__PURE__ */ m(a, { toast: v, swipeDirection: C, role: y, "aria-live": w, className: R, ...S, children: D }), e[64] = a, e[65] = D, e[66] = v, e[67] = C, e[68] = y, e[69] = w, e[70] = R, e[71] = S, e[72] = O) : O = e[72], O;
}
function KD(t) {
  const e = z.c(20);
  let n, o, r, i, s, l;
  e[0] !== t ? ({
    variant: l,
    description: o,
    action: n,
    icon: r,
    onDismiss: i,
    ...s
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6]);
  const a = _t(), c = l ?? "default", u = l === "error" ? "high" : "low";
  let d;
  e[7] !== n || e[8] !== r || e[9] !== i ? (d = {
    action: n,
    icon: r,
    onDismiss: i
  }, e[7] = n, e[8] = r, e[9] = i, e[10] = d) : d = e[10];
  let f;
  e[11] !== o || e[12] !== a || e[13] !== c || e[14] !== u || e[15] !== d ? (f = {
    id: a,
    description: o,
    type: c,
    priority: u,
    data: d
  }, e[11] = o, e[12] = a, e[13] = c, e[14] = u, e[15] = d, e[16] = f) : f = e[16];
  let p;
  return e[17] !== s || e[18] !== f ? (p = /* @__PURE__ */ m(b1, { timeout: 0, limit: 1, children: /* @__PURE__ */ m(T3, { toast: f, ...s }) }), e[17] = s, e[18] = f, e[19] = p) : p = e[19], p;
}
function sO() {
  const t = z.c(7), e = jT(), n = qt();
  let o;
  t[0] !== e ? (o = e.toasts.map((s) => /* @__PURE__ */ m(T3, { onActionComplete: () => e.close(s.id), toast: s, placement: "viewport" }, s.id)), t[0] = e, t[1] = o) : o = t[1];
  let r;
  t[2] !== o ? (r = /* @__PURE__ */ m(N3, { className: nO, children: o }), t[2] = o, t[3] = r) : r = t[3];
  let i;
  return t[4] !== n || t[5] !== r ? (i = /* @__PURE__ */ m(YT, { container: n, children: r }), t[4] = n, t[5] = r, t[6] = i) : i = t[6], i;
}
const O3 = /* @__PURE__ */ x.createContext(void 0);
process.env.NODE_ENV !== "production" && (O3.displayName = "ToggleGroupContext");
function lO(t = !0) {
  const e = x.useContext(O3);
  if (e === void 0 && !t)
    throw new Error(process.env.NODE_ENV !== "production" ? "Base UI: ToggleGroupContext is missing. ToggleGroup parts must be placed within <ToggleGroup>." : rt(7));
  return e;
}
const D3 = /* @__PURE__ */ x.forwardRef(function(e, n) {
  const {
    className: o,
    defaultPressed: r = !1,
    disabled: i = !1,
    form: s,
    // never participates in form validation
    onPressedChange: l,
    pressed: a,
    render: c,
    type: u,
    // cannot change button type
    value: d,
    nativeButton: f = !0,
    style: p,
    ...g
  } = e, h = Mt(d || void 0), b = lO(), v = b?.value ?? [], C = b ? void 0 : r, y = (i || b?.disabled) ?? !1;
  process.env.NODE_ENV !== "production" && ke(() => {
    b && d === void 0 && b.isValueInitialized && jo("A `<Toggle>` component rendered in a `<ToggleGroup>` has no explicit `value` prop.", "This will cause issues between the Toggle Group and Toggle values.", "Provide the `<Toggle>` with a `value` prop matching the `<ToggleGroup>` values prop type.");
  }, [b, d, b?.isValueInitialized]);
  const [w, R] = dn({
    controlled: b ? h !== void 0 && v.indexOf(h) > -1 : a,
    default: C,
    name: "Toggle",
    state: "pressed"
  }), S = Se((M, D) => {
    h && b?.setGroupValue?.(h, M, D), l?.(M, D);
  }), {
    getButtonProps: E,
    buttonRef: N
  } = Wt({
    disabled: y,
    native: f
  }), T = {
    disabled: y,
    pressed: w
  }, P = [N, n], I = [{
    "aria-pressed": w,
    onClick(M) {
      const D = !w, O = Ve(Pt, M.nativeEvent);
      S(D, O), !O.isCanceled && R(D);
    }
  }, g, E], k = $e("button", e, {
    enabled: !b,
    state: T,
    ref: P,
    props: I
  });
  return b ? /* @__PURE__ */ m(kd, {
    tag: "button",
    render: c,
    className: o,
    style: p,
    state: T,
    refs: P,
    props: I
  }) : k;
});
process.env.NODE_ENV !== "production" && (D3.displayName = "Toggle");
const aO = ce(["inline-flex", "items-center", "justify-center", "overflow-hidden", "whitespace-nowrap", "shrink-0", "gap-(--spacing-8)", "rounded-(--radius-sm)", "border", "border-solid", "cursor-pointer", "select-none", "transition-colors", "duration-200", "ease-in-out", "outline-none", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "[&_svg]:pointer-events-none", "[&_svg]:shrink-0", "focus-visible:ring-2", "focus-visible:ring-offset-1", "focus-visible:ring-offset-surface", "focus-visible:ring-button-focus-ring"], {
  variants: {
    variant: {
      outline: ["bg-button-outline-default-background", "text-button-outline-default-text", "border-button-outline-default-border", "hover:bg-button-outline-hover-background", "hover:border-button-outline-hover-border", "active:bg-button-outline-pressed-background", "active:border-button-outline-pressed-border", "data-[pressed]:border-2", "data-[pressed]:border-primary", "data-[pressed]:text-primary"],
      ghost: ["bg-transparent", "text-button-ghost-default-text", "border-transparent", "hover:bg-button-ghost-hover-background", "active:bg-button-ghost-pressed-background", "data-[pressed]:text-primary"]
    }
  },
  defaultVariants: {
    variant: "outline"
  }
});
function qD(t) {
  const e = z.c(23);
  let n, o, r, i, s;
  e[0] !== t ? ({
    icon: n,
    label: o,
    variant: i,
    disabled: s,
    ...r
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5]);
  const l = i === void 0 ? "outline" : i, a = s === void 0 ? !1 : s;
  let c;
  e[6] !== a || e[7] !== o || e[8] !== l ? (c = ne(aO({
    variant: l
  }), o ? "h-(--spacing-32) px-(--spacing-12)" : "size-(--spacing-32)", a && "opacity-40 pointer-events-none cursor-not-allowed"), e[6] = a, e[7] = o, e[8] = l, e[9] = c) : c = e[9];
  const u = a || void 0, d = a ? -1 : void 0;
  let f;
  e[10] !== o ? (f = o && /* @__PURE__ */ m("span", { className: "min-w-0 overflow-hidden text-ellipsis whitespace-nowrap", children: o }), e[10] = o, e[11] = f) : f = e[11];
  let p;
  e[12] !== n ? (p = /* @__PURE__ */ m(Ke, { name: n, size: "xs", tone: "inherit" }), e[12] = n, e[13] = p) : p = e[13];
  let g;
  return e[14] !== a || e[15] !== r || e[16] !== c || e[17] !== u || e[18] !== d || e[19] !== f || e[20] !== p || e[21] !== l ? (g = /* @__PURE__ */ F(D3, { "data-slot": "toggle", "data-variant": l, className: c, disabled: a, "aria-disabled": u, tabIndex: d, ...r, children: [
    f,
    p
  ] }), e[14] = a, e[15] = r, e[16] = c, e[17] = u, e[18] = d, e[19] = f, e[20] = p, e[21] = l, e[22] = g) : g = e[22], g;
}
const cO = {
  photo: {
    icon: "image-regular",
    accept: "image/png,image/jpeg",
    acceptedFormatsLabel: "PNG, JPG",
    buttonLabel: "Select Image"
  },
  file: {
    icon: "upload",
    accept: "application/pdf,text/plain",
    acceptedFormatsLabel: "PDF, TXT",
    buttonLabel: "Select File"
  }
};
function ZD(t) {
  const e = z.c(45);
  let n, o, r, i, s, l, a, c, u, d, f;
  e[0] !== t ? ({
    variant: c,
    accept: n,
    acceptedFormatsLabel: o,
    maxSizeLabel: u,
    multiple: d,
    disabled: f,
    buttonLabel: r,
    guidanceLabel: s,
    onFilesSelected: l,
    className: i,
    ...a
  } = t, e[0] = t, e[1] = n, e[2] = o, e[3] = r, e[4] = i, e[5] = s, e[6] = l, e[7] = a, e[8] = c, e[9] = u, e[10] = d, e[11] = f) : (n = e[1], o = e[2], r = e[3], i = e[4], s = e[5], l = e[6], a = e[7], c = e[8], u = e[9], d = e[10], f = e[11]);
  const p = c === void 0 ? "photo" : c, g = u === void 0 ? "5 MB" : u, h = d === void 0 ? !1 : d, b = f === void 0 ? !1 : f, v = _t(), C = _t(), y = ft(null), w = cO[p], R = o ?? w.acceptedFormatsLabel, S = r ?? w.buttonLabel, E = n ?? w.accept, N = s ?? `Upload ${R} up to ${g}`;
  let T;
  e[12] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (T = function() {
    y.current?.click();
  }, e[12] = T) : T = e[12];
  const P = T;
  let I;
  e[13] !== l ? (I = function(K) {
    const j = Array.from(K.currentTarget.files ?? []);
    j.length > 0 && l?.(j), K.currentTarget.value = "";
  }, e[13] = l, e[14] = I) : I = e[14];
  const k = I, M = b || void 0, D = b && "opacity-50";
  let O;
  e[15] !== i || e[16] !== D ? (O = ne("flex", "w-[480px]", "max-w-full", "relative", "flex-col", "items-center", "justify-center", "gap-(--spacing-24)", "rounded-(--radius-sm)", "bg-surface-container-lowest", "px-(--spacing-16)", "py-(--spacing-24)", D, i), e[15] = i, e[16] = D, e[17] = O) : O = e[17];
  let V;
  e[18] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = /* @__PURE__ */ m(uO, {}), e[18] = V) : V = e[18];
  let _;
  e[19] !== w.icon ? (_ = /* @__PURE__ */ m("span", { "data-slot": "upload-icon", className: "text-text-subtext", children: /* @__PURE__ */ m(Ke, { name: w.icon, size: "lg", tone: "inherit", "aria-hidden": !0 }) }), e[19] = w.icon, e[20] = _) : _ = e[20];
  let A;
  e[21] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (A = ne("m-0", "text-center", "font-(family-name:--font-family-label)", "font-(number:--font-weight-medium)", "text-(length:--font-size-body-medium)", "leading-(--font-line-height-20)", "text-text-subtext"), e[21] = A) : A = e[21];
  let L;
  e[22] !== C || e[23] !== N ? (L = /* @__PURE__ */ m("p", { id: C, className: A, children: N }), e[22] = C, e[23] = N, e[24] = L) : L = e[24];
  let B;
  e[25] !== b || e[26] !== C || e[27] !== S ? (B = /* @__PURE__ */ m(_n, { variant: "outline", size: "md", disabled: b, onClick: P, type: "button", "aria-describedby": C, children: S }), e[25] = b, e[26] = C, e[27] = S, e[28] = B) : B = e[28];
  let G;
  e[29] !== b || e[30] !== k || e[31] !== v || e[32] !== h || e[33] !== E || e[34] !== S ? (G = /* @__PURE__ */ m("input", { ref: y, id: v, className: "sr-only", type: "file", accept: E, multiple: h, disabled: b, tabIndex: -1, "aria-label": S, onChange: k }), e[29] = b, e[30] = k, e[31] = v, e[32] = h, e[33] = E, e[34] = S, e[35] = G) : G = e[35];
  let U;
  return e[36] !== a || e[37] !== _ || e[38] !== L || e[39] !== B || e[40] !== G || e[41] !== M || e[42] !== O || e[43] !== p ? (U = /* @__PURE__ */ F("div", { "data-slot": "upload", "data-variant": p, "data-disabled": M, className: O, ...a, children: [
    V,
    _,
    L,
    B,
    G
  ] }), e[36] = a, e[37] = _, e[38] = L, e[39] = B, e[40] = G, e[41] = M, e[42] = O, e[43] = p, e[44] = U) : U = e[44], U;
}
function uO() {
  const t = z.c(1);
  let e;
  return t[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (e = /* @__PURE__ */ m("svg", { "aria-hidden": "true", className: "pointer-events-none absolute inset-0 size-full", fill: "none", preserveAspectRatio: "none", viewBox: "0 0 480 188", children: /* @__PURE__ */ m("rect", { className: "stroke-outline-subtle", x: "0.5", y: "0.5", width: "479", height: "187", rx: "4", strokeDasharray: "8 6", strokeLinecap: "butt", strokeWidth: "1", vectorEffect: "non-scaling-stroke" }) }), t[0] = e) : e = t[0], e;
}
function XD(t) {
  const e = z.c(13), {
    children: n,
    defaultTheme: o,
    storageKey: r
  } = t, [i, s] = ot(null), [l, a] = ot(null);
  let c;
  e[0] !== l || e[1] !== i ? (c = {
    blockingLayerHost: l,
    portalHost: i
  }, e[0] = l, e[1] = i, e[2] = c) : c = e[2];
  let u, d, f;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (u = /* @__PURE__ */ m("div", { "data-slot": "assetwatch-ui-portal-host", ref: s }), d = /* @__PURE__ */ m("div", { "data-slot": "assetwatch-ui-blocking-layer-host", ref: a }), f = /* @__PURE__ */ m(sO, {}), e[3] = u, e[4] = d, e[5] = f) : (u = e[3], d = e[4], f = e[5]);
  let p;
  e[6] !== n || e[7] !== o || e[8] !== r ? (p = /* @__PURE__ */ m(u2, { delay: 300, timeout: 400, children: /* @__PURE__ */ m(b1, { toastManager: P3, timeout: 5e3, limit: 1, children: /* @__PURE__ */ F(US, { defaultTheme: o, storageKey: r, children: [
    n,
    u,
    d,
    f
  ] }) }) }), e[6] = n, e[7] = o, e[8] = r, e[9] = p) : p = e[9];
  let g;
  return e[10] !== c || e[11] !== p ? (g = /* @__PURE__ */ m(Md, { value: c, children: p }), e[10] = c, e[11] = p, e[12] = g) : g = e[12], g;
}
export {
  oD as Accordion,
  GO as ActionItemCard,
  Ru as AiSparkles,
  ig as Alert,
  U5 as AnchorLink,
  G5 as AnchorNav,
  kO as AppShell,
  MO as AppShellContent,
  IO as AppShellMobileNavigationTrigger,
  yO as AssetAlertChat,
  qO as AssetStatusCard,
  ZO as AssetTimeline,
  Xv as AssetWatchLogo,
  XD as AssetWatchUiProvider,
  nx as AssistantChatComposer,
  UO as AssistantChatDialog,
  wO as AssistantChatFeedback,
  sc as AssistantChatHeader,
  WO as AssistantChatPanel,
  ZC as AssistantChatSidebar,
  BO as AssistantChatTemplatePicker,
  Gr as Avatar,
  au as Badge,
  rD as Banner,
  SO as BlockingActionOverlay,
  iD as Breadcrumb,
  lR as BreadcrumbItem,
  aR as BreadcrumbLink,
  sD as BreadcrumbList,
  lD as BreadcrumbPage,
  U0 as BreadcrumbSeparator,
  _n as Button,
  hO as Caption,
  Xr as Card,
  nw as CardBorderFill,
  aD as CardContainer,
  zO as CardGroup,
  HO as CardImageSlot,
  cD as Carousel,
  uD as ChatActionButton,
  Xc as ChatBubble,
  dD as ChatCopyButton,
  qc as ChatMessage,
  Om as ChatMessageAvatar,
  Zc as ChatMessageContent,
  T1 as ChatMessageFooter,
  $v as ChatMessageGroup,
  Dm as ChatMessageHeader,
  Np as ChatPanel,
  Ip as ChatPanelBody,
  wy as ChatPanelFooter,
  xO as ChatPanelHeader,
  Mp as ChatPanelMain,
  Cy as ChatPanelSidebar,
  kp as ChatPanelSidebarHeader,
  Vm as ChatScroller,
  Am as ChatScrollerContent,
  Fi as ChatScrollerItem,
  Lm as ChatScrollerJumpToLatest,
  _m as ChatScrollerViewport,
  Hv as ChatStatus,
  Fy as ChatTextarea,
  AR as Checkbox,
  Kn as Chip,
  TD as CircularProgress,
  JO as CompanyNavigation,
  EO as Container,
  tD as DEFAULT_PROFILE_MENU_LABELS,
  zD as DataTable,
  fD as DatePicker,
  bD as DateRangeFilter,
  pD as Dialog,
  bO as Display,
  gr as Divider,
  PC as Drawer,
  OO as DrawerBody,
  TC as DrawerClose,
  OC as DrawerContent,
  DO as DrawerFooter,
  TO as DrawerHeader,
  PO as DrawerTrigger,
  gD as EmptyState,
  eD as FacilityNavigation,
  mD as FilterPanel,
  CD as Form,
  SD as FormActionColumnHeader,
  FM as FormFooter,
  wD as FormSection,
  RO as FullPageLoading,
  hr as Group,
  vO as Headline,
  Gw as HoverCard,
  jw as HoverCardContent,
  Yw as HoverCardTrigger,
  Ke as Icon,
  mt as IconButton,
  hc as InlineLink,
  rx as Input,
  YO as InsightCard,
  B2 as Kbd,
  fo as Label,
  RD as Lightbox,
  ED as ListCard,
  Id as Menu,
  E7 as MenuButton,
  b7 as MenuCheckboxItem,
  fr as MenuItem,
  kr as MenuPopup,
  Pd as MenuRadioGroup,
  Td as MenuRadioItem,
  lu as MenuSubHeader,
  Yo as MenuTrigger,
  jO as MetricCard,
  ug as Modal,
  ND as MultiSelect,
  sI as Pagination,
  kD as Popover,
  ID as PopoverContent,
  MD as PopoverTrigger,
  nD as ProfileMenu,
  PD as Progress,
  Fr as RELEASE_STATUS,
  Vi as RELEASE_STATUS_LABEL,
  DD as Radio,
  OD as RadioGroup,
  QO as ReleaseInfoModal,
  XO as STATUS_DISPLAY,
  VD as SearchInput,
  _D as SearchSpotlight,
  xD as SegmentedFilter,
  A0 as Select,
  yD as SelectedFilters,
  KO as ServiceCard,
  VO as Sidebar,
  _O as SidebarFooter,
  ng as SidebarGroup,
  Rl as SidebarItem,
  uu as SidebarToggle,
  hD as SingleFilter,
  LD as Skeleton,
  vD as SortGroupFilter,
  $D as SortableList,
  iP as SortableListHandle,
  FD as SortableListItem,
  qr as Stack,
  HD as Switch,
  pT as Table,
  mT as TableBody,
  rm as TableCell,
  g1 as TableCellPrimary,
  m1 as TableCellSecondary,
  w3 as TableCellStack,
  wT as TableChipTextCellContent,
  vT as TableHead,
  gT as TableHeader,
  Ac as TableRow,
  xT as TableStartingCellContent,
  CT as TableTextCellContent,
  GD as Tabs,
  UD as TabsContent,
  BD as TabsList,
  WD as TabsTrigger,
  cu as Tag,
  ln as Text,
  CO as Textarea,
  v2 as Thumbnail,
  YD as Tile,
  jD as TimePicker,
  An as Title,
  KD as Toast,
  qD as Toggle,
  qo as Tooltip,
  Jy as TooltipIcon,
  AO as TopBar,
  $O as TopBarActions,
  FO as TopBarContent,
  LO as TopBarLeading,
  u0 as Trend,
  Sy as TypingIndicator,
  ZD as Upload,
  iO as toast,
  Y5 as useAnchorNav,
  NO as useAppShell,
  x2 as useOverflowItems,
  AD as useSearchHotkey,
  l0 as useSidebar,
  GS as useTheme
};
//# sourceMappingURL=index.js.map
